const _o1 = (_0: any,_1: any) => ({"kind":_0,"definitions":_1})
const _o2 = (_0: any,_1: any,_2: any,_3: any) => ({"kind":_0,"name":_1,"typeCondition":_2,"selectionSet":_3})
const _o3 = (_0: any,_1: any) => ({"kind":_0,"value":_1})
const _o4 = (_0: any,_1: any) => ({"kind":_0,"name":_1})
const _o5 = (_0: any,_1: any) => ({"kind":_0,"selections":_1})
const _o6 = (_0: any,_1: any,_2: any) => ({"kind":_0,"name":_1,"selectionSet":_2})
const _o7 = (_0: any,_1: any,_2: any,_3: any) => ({"kind":_0,"name":_1,"arguments":_2,"selectionSet":_3})
const _o8 = (_0: any,_1: any,_2: any) => ({"kind":_0,"name":_1,"value":_2})
const _o9 = (_0: any,_1: any,_2: any) => ({"kind":_0,"value":_1,"block":_2})
const _o10 = (_0: any,_1: any,_2: any) => ({"kind":_0,"name":_1,"arguments":_2})
const _o11 = (_0: any,_1: any,_2: any,_3: any,_4: any) => ({"kind":_0,"operation":_1,"name":_2,"variableDefinitions":_3,"selectionSet":_4})
const _o12 = (_0: any,_1: any,_2: any) => ({"kind":_0,"variable":_1,"type":_2})
const _o13 = (_0: any,_1: any) => ({"kind":_0,"type":_1})
const _o14 = (_0: any,_1: any) => ({"kind":_0,"fields":_1})
const _o15 = (_0: any,_1: any,_2: any,_3: any,_4: any) => ({"kind":_0,"alias":_1,"name":_2,"arguments":_3,"selectionSet":_4})
const _o16 = (_0: any,_1: any,_2: any,_3: any,_4: any,_5: any) => ({"kind":_0,"alias":_1,"name":_2,"arguments":_3,"directives":_4,"selectionSet":_5})
const _o17 = (_0: any,_1: any,_2: any,_3: any) => ({"kind":_0,"operation":_1,"name":_2,"selectionSet":_3})
const _o18 = (_0: any) => ({"kind":_0})
const _1="Document"
const _2="FragmentDefinition"
const _3="Name"
const _4=_o3(_3,"PostsMinimumInfo")
const _5="NamedType"
const _6=_o4(_5,_o3(_3,"Post"))
const _7="SelectionSet"
const _8="Field"
const _9=_o3(_3,"_id")
const _10=_o4(_8,_9)
const _11=_o3(_3,"slug")
const _12=_o4(_8,_11)
const _13=_o3(_3,"title")
const _14=_o4(_8,_13)
const _15=_o4(_8,_o3(_3,"draft"))
const _16=_o4(_8,_o3(_3,"shortform"))
const _17=_o3(_3,"af")
const _18=_o4(_8,_17)
const _19=_o3(_3,"userId")
const _20=_o4(_8,_19)
const _21=_o4(_8,_o3(_3,"coauthorUserIds"))
const _22=_o4(_8,_o3(_3,"rejected"))
const _23=_o2(_2,_4,_6,_o5(_7,[_10,_12,_14,_15,_16,_o4(_8,_o3(_3,"hideCommentKarma")),_18,_20,_21,_22,_o4(_8,_o3(_3,"collabEditorDialogue"))]))
const _24=_o3(_3,"UserProfilePost")
const _25="FragmentSpread"
const _26=_o4(_25,_4)
const _27=_o4(_8,_o3(_3,"baseScore"))
const _28=_o4(_8,_o3(_3,"postedAt"))
const _29=_o4(_8,_o3(_3,"hideAuthor"))
const _30=_o3(_3,"user")
const _31=_o4(_8,_o3(_3,"displayName"))
const _32=_o5(_7,[_10,_31])
const _33=_o6(_8,_30,_32)
const _34=_o3(_3,"coauthors")
const _35=_o6(_8,_34,_32)
const _36=_o3(_3,"contents")
const _37=_o4(_8,_o3(_3,"plaintextDescription"))
const _38=_o5(_7,[_37])
const _39=_o6(_8,_36,_38)
const _40=_o2(_2,_24,_6,_o5(_7,[_26,_27,_28,_29,_33,_35,_39]))
const _41=_o3(_3,"ProfileTopPost")
const _42=_o3(_3,"socialPreviewData")
const _43=_o4(_8,_o3(_3,"imageUrl"))
const _44=_o2(_2,_41,_6,_o5(_7,[_26,_27,_28,_o6(_8,_42,_o5(_7,[_43])),_39]))
const _45=_o3(_3,"UsersMinimumInfo")
const _46=_o4(_5,_o3(_3,"User"))
const _47=_o4(_8,_o3(_3,"createdAt"))
const _48=_o3(_3,"username")
const _49=_o4(_8,_48)
const _50=_o4(_8,_o3(_3,"profileImageId"))
const _51=_o4(_8,_o3(_3,"karma"))
const _52=_o4(_8,_o3(_3,"afKarma"))
const _53=_o3(_3,"deleted")
const _54=_o4(_8,_53)
const _55=_o4(_8,_o3(_3,"htmlBio"))
const _56=_o4(_8,_o3(_3,"postCount"))
const _57=_o4(_8,_o3(_3,"commentCount"))
const _58=_o4(_8,_o3(_3,"afPostCount"))
const _59=_o4(_8,_o3(_3,"afCommentCount"))
const _60=_o4(_8,_o3(_3,"reviewedByUserId"))
const _61=_o2(_2,_45,_46,_o5(_7,[_10,_12,_47,_49,_31,_50,_51,_52,_54,_o4(_8,_o3(_3,"isAdmin")),_55,_56,_57,_o4(_8,_o3(_3,"sequenceCount")),_58,_59,_o4(_8,_o3(_3,"tagRevisionCount")),_60]))
const _62=_o3(_3,"SequenceSummaryFragment")
const _63=_o4(_5,_o3(_3,"Sequence"))
const _64=_o4(_8,_o3(_3,"postsCount"))
const _65=_o4(_8,_o3(_3,"canonicalCollectionSlug"))
const _66=_o4(_25,_45)
const _67=_o5(_7,[_66])
const _68=_o6(_8,_30,_67)
const _69=_o4(_8,_o3(_3,"htmlHighlight"))
const _70=_o4(_8,_o3(_3,"wordCount"))
const _71=_o2(_2,_62,_63,_o5(_7,[_10,_14,_64,_65,_68,_o6(_8,_36,_o5(_7,[_69,_70]))]))
const _72=_o3(_3,"BookmarksMinimumInfoFragment")
const _73=_o4(_5,_o3(_3,"Bookmark"))
const _74=_o4(_8,_o3(_3,"active"))
const _75=_o2(_2,_72,_73,_o5(_7,[_10,_74]))
const _76=_o3(_3,"PostsBase")
const _77=_o3(_3,"url")
const _78=_o4(_8,_77)
const _79=_o4(_8,_o3(_3,"status"))
const _80=_o4(_8,_o3(_3,"frontpageDate"))
const _81=_o4(_8,_o3(_3,"deletedDraft"))
const _82=_o3(_3,"tagRelevance")
const _83=_o4(_8,_82)
const _84=_o3(_3,"linkSharingKey")
const _85=_o4(_8,_o3(_3,"voteCount"))
const _86=_o4(_8,_o3(_3,"extendedScore"))
const _87=_o4(_8,_o3(_3,"score"))
const _88=_o4(_8,_o3(_3,"lastVisitedAt"))
const _89=_o3(_3,"isRead")
const _90=_o4(_8,_89)
const _91=_o4(_8,_o3(_3,"lastCommentedAt"))
const _92=_o4(_8,_o3(_3,"location"))
const _93=_o4(_8,_o3(_3,"googleLocation"))
const _94=_o3(_3,"onlineEvent")
const _95=_o4(_8,_94)
const _96=_o3(_3,"globalEvent")
const _97=_o4(_8,_96)
const _98=_o4(_8,_o3(_3,"startTime"))
const _99=_o4(_8,_o3(_3,"endTime"))
const _100=_o4(_8,_o3(_3,"facebookLink"))
const _101=_o4(_8,_o3(_3,"meetupLink"))
const _102=_o4(_8,_o3(_3,"website"))
const _103=_o4(_8,_o3(_3,"contactInfo"))
const _104=_o4(_8,_o3(_3,"isEvent"))
const _105=_o4(_8,_o3(_3,"eventImageId"))
const _106=_o3(_3,"eventType")
const _107=_o4(_8,_o3(_3,"types"))
const _108=_o3(_3,"groupId")
const _109=_o4(_8,_108)
const _110=_o4(_8,_o3(_3,"suggestForCuratedUsernames"))
const _111=_o3(_3,"authorIsUnreviewed")
const _112=_o4(_8,_111)
const _113=_o4(_8,_o3(_3,"afDate"))
const _114=_o4(_8,_o3(_3,"suggestForAlignmentUserIds"))
const _115=_o4(_8,_o3(_3,"reviewForAlignmentUserId"))
const _116=_o4(_8,_o3(_3,"afBaseScore"))
const _117=_o4(_8,_o3(_3,"afExtendedScore"))
const _118=_o4(_8,_o3(_3,"moderationStyle"))
const _119=_o4(_8,_o3(_3,"reviewVoteCount"))
const _120=_o4(_8,_o3(_3,"annualReviewMarketProbability"))
const _121=_o4(_8,_o3(_3,"annualReviewMarketUrl"))
const _122=_o3(_3,"name")
const _123=_o4(_8,_122)
const _124=_o4(_8,_o3(_3,"organizerIds"))
const _125=_o4(_8,_o3(_3,"forceAllowType3Audio"))
const _126=_o4(_8,_o3(_3,"votingSystem"))
const _127=_o2(_2,_76,_6,_o5(_7,[_26,_78,_28,_o4(_8,_o3(_3,"sticky")),_o4(_8,_o3(_3,"metaSticky")),_o4(_8,_o3(_3,"stickyPriority")),_79,_80,_o4(_8,_o3(_3,"meta")),_81,_o4(_8,_o3(_3,"postCategory")),_83,_o4(_8,_o3(_3,"shareWithUsers")),_o4(_8,_o3(_3,"sharingSettings")),_o4(_8,_84),_o4(_8,_o3(_3,"contents_latest")),_57,_85,_27,_86,_o4(_8,_o3(_3,"unlisted")),_87,_88,_o4(_8,_o3(_3,"isFuture")),_90,_91,_o4(_8,_o3(_3,"lastCommentPromotedAt")),_65,_o4(_8,_o3(_3,"curatedDate")),_o4(_8,_o3(_3,"commentsLocked")),_o4(_8,_o3(_3,"commentsLockedToAccountsCreatedAfter")),_o4(_8,_o3(_3,"debate")),_o4(_8,_o3(_3,"question")),_o4(_8,_o3(_3,"hiddenRelatedQuestion")),_o4(_8,_o3(_3,"originalPostRelationSourceId")),_20,_92,_93,_95,_97,_98,_99,_o4(_8,_o3(_3,"localStartTime")),_o4(_8,_o3(_3,"localEndTime")),_o4(_8,_o3(_3,"eventRegistrationLink")),_o4(_8,_o3(_3,"joinEventLink")),_100,_101,_102,_103,_104,_105,_o4(_8,_106),_107,_109,_60,_o4(_8,_o3(_3,"suggestForCuratedUserIds")),_110,_o4(_8,_o3(_3,"reviewForCuratedUserId")),_112,_113,_114,_115,_116,_117,_59,_o4(_8,_o3(_3,"afLastCommentedAt")),_o4(_8,_o3(_3,"afSticky")),_29,_118,_o4(_8,_o3(_3,"ignoreRateLimits")),_o4(_8,_o3(_3,"submitToFrontpage")),_16,_o4(_8,_o3(_3,"onlyVisibleToLoggedIn")),_o4(_8,_o3(_3,"onlyVisibleToEstablishedAccounts")),_o4(_8,_o3(_3,"reviewCount")),_119,_o4(_8,_o3(_3,"positiveReviewVoteCount")),_o4(_8,_o3(_3,"manifoldReviewMarketId")),_120,_o4(_8,_o3(_3,"annualReviewMarketIsResolved")),_o4(_8,_o3(_3,"annualReviewMarketYear")),_121,_o6(_8,_o3(_3,"group"),_o5(_7,[_10,_123,_124])),_o4(_8,_o3(_3,"rsvpCounts")),_o4(_8,_o3(_3,"podcastEpisodeId")),_125,_o4(_8,_o3(_3,"nominationCount2019")),_o4(_8,_o3(_3,"reviewCount2019")),_126,_o4(_8,_o3(_3,"disableRecommendation"))]))
const _128=_o3(_3,"PostsAuthors")
const _129=_o4(_8,_o3(_3,"bannedUserIds"))
const _130=_o4(_8,_o3(_3,"bannedPersonalUserIds"))
const _131=_o4(_8,_o3(_3,"moderatorAssistance"))
const _132=_o4(_8,_o3(_3,"groups"))
const _133=_o4(_8,_o3(_3,"banned"))
const _134=_o4(_8,_o3(_3,"allCommentingDisabled"))
const _135=_o6(_8,_34,_67)
const _136=_o2(_2,_128,_6,_o5(_7,[_o6(_8,_30,_o5(_7,[_66,_50,_118,_129,_130,_131,_132,_133,_134])),_135]))
const _137=_o3(_3,"TagBasicInfo")
const _138=_o4(_5,_o3(_3,"Tag"))
const _139=_o4(_8,_o3(_3,"core"))
const _140=_o4(_8,_o3(_3,"needsReview"))
const _141=_o4(_8,_o3(_3,"wikiOnly"))
const _142=_o4(_8,_o3(_3,"noindex"))
const _143=_o4(_8,_o3(_3,"isArbitalImport"))
const _144=_o4(_8,_o3(_3,"currentUserVote"))
const _145=_o4(_8,_o3(_3,"currentUserExtendedVote"))
const _146=_o2(_2,_137,_138,_o5(_7,[_10,_20,_123,_o4(_8,_o3(_3,"shortName")),_12,_139,_56,_o4(_8,_o3(_3,"adminOnly")),_o4(_8,_o3(_3,"canEditUserIds")),_o4(_8,_o3(_3,"suggestedAsFilter")),_140,_o4(_8,_o3(_3,"descriptionTruncationCount")),_47,_141,_54,_o4(_8,_o3(_3,"isSubforum")),_142,_143,_o4(_8,_o3(_3,"isPlaceholderPage")),_27,_86,_87,_116,_117,_85,_144,_145]))
const _147=_o3(_3,"TagPreviewFragment")
const _148=_o4(_25,_137)
const _149=_o3(_3,"parentTag")
const _150=_o5(_7,[_148])
const _151=_o6(_8,_149,_150)
const _152=_o3(_3,"subTags")
const _153=_o6(_8,_152,_150)
const _154=_o3(_3,"description")
const _155=_o5(_7,[_10,_69])
const _156=_o4(_8,_o3(_3,"canVoteOnRels"))
const _157=_o4(_8,_o3(_3,"authorOnly"))
const _158=_o2(_2,_147,_138,_o5(_7,[_148,_90,_151,_153,_o6(_8,_154,_155),_156,_157,_143]))
const _159=_o3(_3,"CommentsList")
const _160=_o4(_5,_o3(_3,"Comment"))
const _161=_o3(_3,"postId")
const _162=_o4(_8,_161)
const _163=_o3(_3,"tagId")
const _164=_o4(_8,_163)
const _165=_o3(_3,"tag")
const _166=_o5(_7,[_10,_12])
const _167=_o6(_8,_165,_166)
const _168=_o4(_8,_o3(_3,"relevantTagIds"))
const _169=_o5(_7,[_o4(_25,_147)])
const _170=_o6(_8,_o3(_3,"relevantTags"),_169)
const _171=_o4(_8,_o3(_3,"tagCommentType"))
const _172=_o4(_8,_o3(_3,"parentCommentId"))
const _173=_o3(_3,"topLevelCommentId")
const _174=_o4(_8,_o3(_3,"html"))
const _175=_o4(_8,_o3(_3,"plaintextMainText"))
const _176=_o3(_3,"deletedPublic")
const _177=_o4(_8,_176)
const _178=_o3(_3,"deletedReason")
const _179=_o4(_8,_178)
const _180=_o4(_8,_o3(_3,"isBookmarked"))
const _181=_o4(_8,_o3(_3,"lastSubthreadActivity"))
const _182=_o3(_3,"rejectedReason")
const _183=_o4(_8,_182)
const _184=_o2(_2,_159,_160,_o5(_7,[_10,_162,_164,_167,_168,_170,_171,_172,_o4(_8,_173),_o4(_8,_o3(_3,"descendentCount")),_14,_o6(_8,_36,_o5(_7,[_10,_174,_175,_70])),_28,_o4(_8,_o3(_3,"lastEditedAt")),_o4(_8,_o3(_3,"repliesBlockedUntil")),_20,_15,_54,_177,_o4(_8,_o3(_3,"deletedByUserId")),_179,_29,_112,_68,_144,_145,_180,_27,_86,_87,_85,_18,_113,_o4(_8,_o3(_3,"moveToAlignmentUserId")),_116,_117,_114,_115,_140,_o4(_8,_o3(_3,"answer")),_o4(_8,_o3(_3,"parentAnswerId")),_o4(_8,_o3(_3,"retracted")),_o4(_8,_o3(_3,"postVersion")),_60,_16,_o4(_8,_o3(_3,"shortformFrontpage")),_181,_o4(_8,_o3(_3,"moderatorHat")),_o4(_8,_o3(_3,"hideModeratorHat")),_o4(_8,_o3(_3,"nominatedForReview")),_o4(_8,_o3(_3,"reviewingForReview")),_o4(_8,_o3(_3,"promoted")),_o6(_8,_o3(_3,"promotedByUser"),_67),_o4(_8,_o3(_3,"directChildrenCount")),_126,_o4(_8,_o3(_3,"isPinnedOnProfile")),_o4(_8,_o3(_3,"debateResponse")),_22,_183,_o4(_8,_o3(_3,"originalDialogueId"))]))
const _185=_o3(_3,"PostsListBase")
const _186=_o4(_25,_76)
const _187=_o3(_3,"customHighlight")
const _188=_o5(_7,[_10,_68])
const _189=_o4(_25,_159)
const _190=_o5(_7,[_189])
const _191=_o3(_3,"tags")
const _192=_o2(_2,_185,_6,_o5(_7,[_186,_o4(_25,_128),_o4(_8,_o3(_3,"readTimeMinutes")),_183,_o6(_8,_187,_o5(_7,[_10,_174,_37])),_o6(_8,_o3(_3,"lastPromotedComment"),_188),_o6(_8,_o3(_3,"bestAnswer"),_190),_o6(_8,_191,_150),_o6(_8,_42,_o5(_7,[_10,_43])),_o4(_8,_o3(_3,"feedId")),_o4(_8,_o3(_3,"totalDialogueResponseCount")),_o4(_8,_o3(_3,"unreadDebateResponseCount")),_o4(_8,_o3(_3,"dialogTooltipPreview")),_o4(_8,_o3(_3,"disableSidenotes"))]))
const _193=_o3(_3,"PostsList")
const _194=_o4(_25,_185)
const _195=_o3(_3,"version")
const _196=_o4(_8,_195)
const _197=_o6(_8,_o3(_3,"fmCrosspost"),_o5(_7,[_o4(_8,_o3(_3,"isCrosspost")),_o4(_8,_o3(_3,"hostedHere")),_o4(_8,_o3(_3,"foreignPostId"))]))
const _198=_o2(_2,_193,_6,_o5(_7,[_194,_81,_o6(_8,_36,_o5(_7,[_10,_69,_37,_70,_196])),_180,_197,_129]))
const _199=_o3(_3,"PostPodcastEpisode")
const _200=_o4(_8,_o3(_3,"episodeLink"))
const _201=_o4(_8,_o3(_3,"externalEpisodeId"))
const _202=_o6(_8,_o3(_3,"podcastEpisode"),_o5(_7,[_10,_14,_o6(_8,_o3(_3,"podcast"),_o5(_7,[_10,_14,_o4(_8,_o3(_3,"applePodcastLink")),_o4(_8,_o3(_3,"spotifyPodcastLink"))])),_200,_201]))
const _203=_o2(_2,_199,_6,_o5(_7,[_202]))
const _204=_o3(_3,"PostsListWithVotes")
const _205=_o4(_25,_193)
const _206=_o4(_25,_199)
const _207=_o2(_2,_204,_6,_o5(_7,[_205,_144,_145,_206]))
const _208=_o3(_3,"BookmarksWithDocumentFragment")
const _209=_o4(_25,_72)
const _210=_o3(_3,"post")
const _211=_o4(_25,_204)
const _212=_o5(_7,[_211])
const _213=_o6(_8,_210,_212)
const _214=_o2(_2,_208,_73,_o5(_7,[_209,_213]))
const _215=_o3(_3,"UltraFeedComment")
const _216=_o5(_7,[_189,_213])
const _217=_o2(_2,_215,_160,_216)
const _218=_o3(_3,"BookmarksFeedItemFragment")
const _219=_o3(_3,"collectionName")
const _220=_o4(_8,_219)
const _221=_o3(_3,"comment")
const _222=_o5(_7,[_o4(_25,_215)])
const _223=_o2(_2,_218,_73,_o5(_7,[_209,_220,_o4(_8,_o3(_3,"lastUpdated")),_213,_o6(_8,_221,_222)]))
const _224=_o3(_3,"RevisionDisplay")
const _225=_o4(_5,_o3(_3,"Revision"))
const _226=_o2(_2,_224,_225,_o5(_7,[_10,_196,_174,_70,_69,_37]))
const _227=_o3(_3,"SequencesPageTitleFragment")
const _228=_o5(_7,[_10,_14])
const _229=_o6(_8,_o3(_3,"canonicalCollection"),_228)
const _230=_o2(_2,_227,_63,_o5(_7,[_10,_14,_65,_229]))
const _231=_o3(_3,"SequencesPageFragment")
const _232=_o4(_25,_227)
const _233=_o4(_25,_224)
const _234=_o5(_7,[_233])
const _235=_o6(_8,_36,_234)
const _236=_o4(_8,_o3(_3,"gridImageId"))
const _237=_o4(_8,_o3(_3,"bannerImageId"))
const _238=_o4(_8,_o3(_3,"curatedOrder"))
const _239=_o2(_2,_231,_63,_o5(_7,[_232,_47,_20,_68,_235,_236,_237,_65,_15,_o4(_8,_o3(_3,"isDeleted")),_o4(_8,_o3(_3,"hidden")),_o4(_8,_o3(_3,"hideFromAuthorPage")),_142,_238,_o4(_8,_o3(_3,"userProfileOrder")),_18,_64,_o4(_8,_o3(_3,"readPostsCount"))]))
const _240=_o3(_3,"ChapterPostSlim")
const _241=_o2(_2,_240,_6,_o5(_7,[_10,_14,_12,_90]))
const _242=_o3(_3,"SlimChapter")
const _243=_o4(_5,_o3(_3,"Chapter"))
const _244=_o4(_8,_o3(_3,"subtitle"))
const _245=_o4(_8,_o3(_3,"number"))
const _246=_o3(_3,"sequenceId")
const _247=_o4(_8,_246)
const _248=_o3(_3,"postIds")
const _249=_o4(_8,_248)
const _250=_o3(_3,"posts")
const _251=_o2(_2,_242,_243,_o5(_7,[_10,_47,_14,_244,_235,_245,_247,_249,_o6(_8,_250,_o5(_7,[_o4(_25,_240)]))]))
const _252=_o3(_3,"SequencesPageWithChaptersFragment")
const _253=_o4(_25,_231)
const _254=_o3(_3,"chapters")
const _255=_o2(_2,_252,_63,_o5(_7,[_253,_o6(_8,_254,_o5(_7,[_o4(_25,_242)]))]))
const _256=_o3(_3,"BookPageFragment")
const _257=_o4(_5,_o3(_3,"Book"))
const _258=_o4(_8,_o3(_3,"sequenceIds"))
const _259=_o3(_3,"sequences")
const _260=_o6(_8,_250,_212)
const _261=_o2(_2,_256,_257,_o5(_7,[_10,_47,_14,_245,_244,_o4(_8,_o3(_3,"tocTitle")),_235,_258,_o6(_8,_259,_o5(_7,[_o4(_25,_252)])),_249,_260,_o4(_8,_o3(_3,"collectionId")),_o4(_8,_o3(_3,"displaySequencesAsGrid")),_o4(_8,_o3(_3,"hideProgressBar")),_o4(_8,_o3(_3,"showChapters"))]))
const _262=_o3(_3,"RevisionEdit")
const _263=_o4(_8,_o3(_3,"editedAt"))
const _264=_o4(_8,_o3(_3,"commitMessage"))
const _265=_o4(_8,_o3(_3,"type"))
const _266=_o3(_3,"data")
const _267=_o4(_8,_266)
const _268=_o6(_8,_o3(_3,"originalContents"),_o5(_7,[_265,_267]))
const _269=_o4(_8,_o3(_3,"markdown"))
const _270=_o2(_2,_262,_225,_o5(_7,[_233,_o4(_8,_o3(_3,"updateType")),_263,_20,_264,_268,_269,_o4(_8,_o3(_3,"ckEditorMarkup"))]))
const _271=_o3(_3,"BookEdit")
const _272=_o4(_25,_256)
const _273=_o5(_7,[_o4(_25,_262)])
const _274=_o6(_8,_36,_273)
const _275=_o2(_2,_271,_257,_o5(_7,[_272,_274]))
const _276=_o3(_3,"ChaptersFragment")
const _277=_o2(_2,_276,_243,_o5(_7,[_10,_47,_14,_244,_235,_245,_247,_249,_260]))
const _278=_o3(_3,"ChaptersEdit")
const _279=_o4(_25,_276)
const _280=_o2(_2,_278,_243,_o5(_7,[_279,_274]))
const _281=_o3(_3,"documentId")
const _282=_o4(_8,_281)
const _283=_o4(_8,_o3(_3,"endedAt"))
const _284=_o3(_3,"ModeratorClientIDInfo")
const _285=_o4(_8,_o3(_3,"clientId"))
const _286=_o4(_8,_o3(_3,"firstSeenReferrer"))
const _287=_o4(_8,_o3(_3,"firstSeenLandingPage"))
const _288=_o3(_3,"users")
const _289=_o6(_8,_288,_67)
const _290=_o2(_2,_284,_o4(_5,_o3(_3,"ClientId")),_o5(_7,[_10,_285,_47,_286,_287,_289]))
const _291=_o3(_3,"CollectionContinueReadingFragment")
const _292=_o4(_5,_o3(_3,"Collection"))
const _293=_o2(_2,_291,_292,_o5(_7,[_10,_14,_12,_236]))
const _294=_o3(_3,"CollectionsPageFragment")
const _295=_o4(_8,_o3(_3,"firstPageLink"))
const _296=_o3(_3,"books")
const _297=_o5(_7,[_272])
const _298=_o2(_2,_294,_292,_o5(_7,[_10,_47,_12,_20,_68,_14,_235,_295,_236,_o6(_8,_296,_297),_o4(_8,_o3(_3,"hideStartReadingButton")),_142]))
const _299=_o3(_3,"CollectionsEditFragment")
const _300=_o4(_25,_294)
const _301=_o2(_2,_299,_292,_o5(_7,[_300,_274]))
const _302=_o3(_3,"ShortformComments")
const _303=_o5(_7,[_26])
const _304=_o6(_8,_210,_303)
const _305=_o2(_2,_302,_160,_o5(_7,[_189,_304,_170]))
const _306=_o3(_3,"FrontpageShortformComments")
const _307=_o4(_25,_302)
const _308=_o3(_3,"latestChildren")
const _309=_o2(_2,_306,_160,_o5(_7,[_307,_o6(_8,_308,_o5(_7,[_10,_28,_33]))]))
const _310=_o3(_3,"DraftComments")
const _311=_o3(_3,"parentComment")
const _312=_o2(_2,_310,_160,_o5(_7,[_189,_304,_o6(_8,_311,_188)]))
const _313=_o3(_3,"CommentWithRepliesFragment")
const _314=_o6(_8,_165,_150)
const _315=_o5(_7,[_186])
const _316=_o2(_2,_313,_160,_o5(_7,[_189,_181,_o6(_8,_308,_190),_314,_o6(_8,_210,_315)]))
const _317=_o3(_3,"CommentEdit")
const _318=_o2(_2,_317,_160,_o5(_7,[_189,_168,_274]))
const _319=_o3(_3,"DeletedCommentsMetaData")
const _320=_o2(_2,_319,_160,_o5(_7,[_10,_54,_o4(_8,_o3(_3,"deletedDate")),_o6(_8,_o3(_3,"deletedByUser"),_32),_179,_177]))
const _321=_o3(_3,"CommentsListWithParentMetadata")
const _322=_o2(_2,_321,_160,_o5(_7,[_189,_o6(_8,_210,_o5(_7,[_26,_90])),_314]))
const _323=_o3(_3,"AutomatedContentEvaluationsFragment")
const _324=_o4(_8,_o3(_3,"pangramApiVersion"))
const _325=_o4(_8,_o3(_3,"pangramScore"))
const _326=_o4(_8,_o3(_3,"pangramMaxScore"))
const _327=_o4(_8,_o3(_3,"pangramPrediction"))
const _328=_o3(_3,"pangramWindowScores")
const _329=_o3(_3,"text")
const _330=_o4(_8,_329)
const _331=_o4(_8,_o3(_3,"startIndex"))
const _332=_o4(_8,_o3(_3,"endIndex"))
const _333=_o3(_3,"label")
const _334=_o4(_8,_333)
const _335=_o2(_2,_323,_o4(_5,_o3(_3,"AutomatedContentEvaluation")),_o5(_7,[_10,_87,_o6(_8,_o3(_3,"sentenceScores"),_o5(_7,[_o4(_8,_o3(_3,"sentence")),_87])),_o4(_8,_o3(_3,"aiChoice")),_o4(_8,_o3(_3,"aiReasoning")),_o4(_8,_o3(_3,"aiCoT")),_324,_325,_o4(_8,_o3(_3,"pangramFractionAi")),_o4(_8,_o3(_3,"pangramFractionAiAssisted")),_o4(_8,_o3(_3,"pangramFractionHuman")),_326,_327,_o6(_8,_328,_o5(_7,[_330,_87,_331,_332,_334,_o4(_8,_o3(_3,"confidence")),_70]))]))
const _336=_o3(_3,"SunshineCommentsList")
const _337=_o4(_25,_321)
const _338=_o5(_7,[_o4(_25,_323)])
const _339=_o6(_8,_o3(_3,"automatedContentEvaluations"),_338)
const _340=_o2(_2,_336,_160,_o5(_7,[_337,_339]))
const _341=_o3(_3,"WithVoteComment")
const _342=_o4(_8,_o3(_3,"__typename"))
const _343=_o5(_7,[_342,_10,_144,_145,_27,_86,_87,_116,_117,_85])
const _344=_o2(_2,_341,_160,_343)
const _345=_o3(_3,"PostsForAutocomplete")
const _346=_o6(_8,_36,_o5(_7,[_269]))
const _347=_o2(_2,_345,_6,_o5(_7,[_10,_14,_20,_27,_86,_68,_346]))
const _348=_o3(_3,"CommentsForAutocomplete")
const _349=_o5(_7,[_o4(_25,_345)])
const _350=_o2(_2,_348,_160,_o5(_7,[_10,_162,_27,_86,_47,_68,_346,_o6(_8,_210,_349)]))
const _351=_o3(_3,"CommentsForAutocompleteWithParents")
const _352=_o4(_25,_348)
const _353=_o5(_7,[_352])
const _354=_o2(_2,_351,_160,_o5(_7,[_352,_o6(_8,_311,_o5(_7,[_352,_o6(_8,_311,_o5(_7,[_352,_o6(_8,_311,_o5(_7,[_352,_o6(_8,_311,_o5(_7,[_352,_o6(_8,_311,_o5(_7,[_352,_o6(_8,_311,_o5(_7,[_352,_o6(_8,_311,_o5(_7,[_352,_o6(_8,_311,_o5(_7,[_352,_o6(_8,_311,_o5(_7,[_352,_o6(_8,_311,_353)]))]))]))]))]))]))]))]))]))]))
const _355=_o3(_3,"SuggestAlignmentComment")
const _356=_o6(_8,_o3(_3,"suggestForAlignmentUsers"),_32)
const _357=_o2(_2,_355,_160,_o5(_7,[_189,_304,_114,_356]))
const _358=_o3(_3,"CommentsMarkdownFragment")
const _359=_o4(_8,_o3(_3,"agentMarkdown"))
const _360=_o6(_8,_36,_o5(_7,[_359,_175]))
const _361=_o2(_2,_358,_160,_o5(_7,[_10,_162,_172,_28,_27,_85,_126,_86,_o6(_8,_30,_o5(_7,[_10,_12,_31])),_360]))
const _362=_o3(_3,"ConversationsMinimumInfo")
const _363=_o4(_5,_o3(_3,"Conversation"))
const _364=_o3(_3,"participantIds")
const _365=_o3(_3,"moderator")
const _366=_o2(_2,_362,_363,_o5(_7,[_10,_47,_o4(_8,_o3(_3,"latestActivity")),_14,_o4(_8,_364),_o4(_8,_o3(_3,"archivedByIds")),_o4(_8,_o3(_3,"messageCount")),_o4(_8,_365)]))
const _367=_o3(_3,"messageListFragment")
const _368=_o4(_5,_o3(_3,"Message"))
const _369=_o3(_3,"conversationId")
const _370=_o4(_8,_369)
const _371=_o2(_2,_367,_368,_o5(_7,[_10,_o6(_8,_30,_o5(_7,[_66,_50])),_o6(_8,_36,_o5(_7,[_174,_175])),_47,_370,_85,_27,_87,_86,_144,_145]))
const _372=_o3(_3,"ConversationsList")
const _373=_o4(_25,_362)
const _374=_o5(_7,[_o4(_25,_367)])
const _375=_o2(_2,_372,_363,_o5(_7,[_373,_o6(_8,_o3(_3,"participants"),_67),_o6(_8,_o3(_3,"latestMessage"),_374)]))
const _376=_o3(_3,"ConversationsListWithReadStatus")
const _377=_o4(_25,_372)
const _378=_o2(_2,_376,_363,_o5(_7,[_377,_o4(_8,_o3(_3,"hasUnreadMessages"))]))
const _379=_o3(_3,"ElicitQuestionFragment")
const _380=_o4(_8,_o3(_3,"notes"))
const _381=_o4(_8,_o3(_3,"resolution"))
const _382=_o4(_8,_o3(_3,"resolvesBy"))
const _383=_o2(_2,_379,_o4(_5,_o3(_3,"ElicitQuestion")),_o5(_7,[_10,_14,_380,_381,_382]))
const _384=_o3(_3,"FieldChangeFragment")
const _385=_o3(_3,"fieldName")
const _386=_o4(_8,_385)
const _387=_o2(_2,_384,_o4(_5,_o3(_3,"FieldChange")),_o5(_7,[_10,_47,_20,_o4(_8,_o3(_3,"changeGroup")),_282,_386,_o4(_8,_o3(_3,"oldValue")),_o4(_8,_o3(_3,"newValue"))]))
const _388=_o3(_3,"GoogleServiceAccountSessionAdminInfo")
const _389=_o3(_3,"email")
const _390=_o4(_8,_389)
const _391=_o2(_2,_388,_o4(_5,_o3(_3,"GoogleServiceAccountSession")),_o5(_7,[_10,_390,_o4(_8,_o3(_3,"estimatedExpiry"))]))
const _392=_o3(_3,"JargonTerms")
const _393=_o4(_5,_o3(_3,"JargonTerm"))
const _394=_o4(_8,_o3(_3,"term"))
const _395=_o4(_8,_o3(_3,"humansAndOrAIEdited"))
const _396=_o4(_8,_o3(_3,"approved"))
const _397=_o4(_8,_o3(_3,"altTerms"))
const _398=_o2(_2,_392,_393,_o5(_7,[_10,_162,_394,_274,_395,_396,_54,_397]))
const _399=_o3(_3,"LlmConversationsFragment")
const _400=_o4(_5,_o3(_3,"LlmConversation"))
const _401=_o2(_2,_399,_400,_o5(_7,[_10,_20,_14,_47,_o4(_8,_o3(_3,"lastUpdatedAt")),_54]))
const _402=_o3(_3,"LlmConversationsViewingPageFragment")
const _403=_o4(_25,_399)
const _404=_o2(_2,_402,_400,_o5(_7,[_403,_o4(_8,_o3(_3,"totalCharacterCount")),_68]))
const _405=_o3(_3,"LlmMessagesFragment")
const _406=_o4(_8,_o3(_3,"content"))
const _407=_o2(_2,_405,_o4(_5,_o3(_3,"LlmMessage")),_o5(_7,[_10,_20,_370,_o4(_8,_o3(_3,"role")),_406,_47]))
const _408=_o3(_3,"LlmConversationsWithMessagesFragment")
const _409=_o3(_3,"messages")
const _410=_o2(_2,_408,_400,_o5(_7,[_403,_o6(_8,_409,_o5(_7,[_o4(_25,_405)]))]))
const _411=_o3(_3,"localGroupsBase")
const _412=_o4(_5,_o3(_3,"Localgroup"))
const _413=_o4(_8,_o3(_3,"isOnline"))
const _414=_o4(_8,_o3(_3,"mongoLocation"))
const _415=_o2(_2,_411,_412,_o5(_7,[_10,_47,_124,_o6(_8,_o3(_3,"organizers"),_67),_o4(_8,_o3(_3,"lastActivity")),_123,_o4(_8,_o3(_3,"nameInAnotherLanguage")),_413,_92,_93,_414,_107,_o4(_8,_o3(_3,"categories")),_103,_100,_o4(_8,_o3(_3,"facebookPageLink")),_101,_o4(_8,_o3(_3,"slackLink")),_102,_237,_o4(_8,_o3(_3,"inactive")),_54]))
const _416=_o3(_3,"localGroupsHomeFragment")
const _417=_o4(_25,_411)
const _418=_o2(_2,_416,_412,_o5(_7,[_417,_235]))
const _419=_o3(_3,"localGroupsEdit")
const _420=_o2(_2,_419,_412,_o5(_7,[_417,_274]))
const _421=_o3(_3,"localGroupsIsOnline")
const _422=_o2(_2,_421,_412,_o5(_7,[_10,_123,_413]))
const _423=_o3(_3,"newEventFragment")
const _424=_o4(_5,_o3(_3,"LWEvent"))
const _425=_o4(_8,_o3(_3,"important"))
const _426=_o4(_8,_o3(_3,"properties"))
const _427=_o4(_8,_o3(_3,"intercom"))
const _428=_o2(_2,_423,_424,_o5(_7,[_10,_47,_20,_123,_425,_426,_427]))
const _429=_o3(_3,"lastEventFragment")
const _430=_o2(_2,_429,_424,_o5(_7,[_10,_47,_282,_20,_123,_425,_426,_427]))
const _431=_o3(_3,"emailHistoryFragment")
const _432=_o2(_2,_431,_424,_o5(_7,[_10,_47,_20,_123,_426]))
const _433=_o3(_3,"WithVoteMessage")
const _434=_o5(_7,[_342,_10,_87,_27,_86,_116,_85,_144,_145])
const _435=_o2(_2,_433,_368,_434)
const _436=_o3(_3,"ModerationTemplateFragment")
const _437=_o4(_8,_o3(_3,"order"))
const _438=_o2(_2,_436,_o4(_5,_o3(_3,"ModerationTemplate")),_o5(_7,[_10,_123,_220,_437,_o4(_8,_o3(_3,"groupLabel")),_54,_274]))
const _439=_o3(_3,"MultiDocumentMinimumInfo")
const _440=_o4(_5,_o3(_3,"MultiDocument"))
const _441=_o3(_3,"parentDocumentId")
const _442=_o4(_8,_o3(_3,"oldSlugs"))
const _443=_o4(_8,_o3(_3,"tabTitle"))
const _444=_o4(_8,_o3(_3,"tabSubtitle"))
const _445=_o4(_8,_o3(_3,"legacyData"))
const _446=_o2(_2,_439,_440,_o5(_7,[_10,_o4(_8,_441),_220,_386,_20,_12,_442,_14,_443,_444,_o4(_8,_o3(_3,"preview")),_o4(_8,_o3(_3,"index")),_54,_47,_445,_27,_86,_87,_116,_117,_85,_144,_145]))
const _447=_o3(_3,"WithVoteMultiDocument")
const _448=_o4(_25,_439)
const _449=_o5(_7,[_448])
const _450=_o2(_2,_447,_440,_449)
const _451=_o3(_3,"NotificationsList")
const _452=_o4(_8,_o3(_3,"documentType"))
const _453=_o4(_8,_o3(_3,"link"))
const _454=_o3(_3,"message")
const _455=_o4(_8,_454)
const _456=_o2(_2,_451,_o4(_5,_o3(_3,"Notification")),_o5(_7,[_10,_282,_452,_54,_20,_47,_453,_455,_265,_o4(_8,_o3(_3,"viewed")),_o4(_8,_o3(_3,"extraData"))]))
const _457=_o3(_3,"PetrovDayActionInfo")
const _458=_o2(_2,_457,_o4(_5,_o3(_3,"PetrovDayAction")),_o5(_7,[_10,_47,_20,_o4(_8,_o3(_3,"actionType")),_267]))
const _459=_o3(_3,"PodcastEpisodeCreateFragment")
const _460=_o4(_5,_o3(_3,"PodcastEpisode"))
const _461=_o4(_8,_o3(_3,"schemaVersion"))
const _462=_o4(_8,_o3(_3,"podcastId"))
const _463=_o2(_2,_459,_460,_o5(_7,[_10,_461,_47,_445,_462,_14,_200,_201]))
const _464=_o3(_3,"PodcastEpisodeFull")
const _465=_o2(_2,_464,_460,_o5(_7,[_10,_462,_14,_200,_201]))
const _466=_o3(_3,"PodcastSelect")
const _467=_o2(_2,_466,_o4(_5,_o3(_3,"Podcast")),_228)
const _468=_o3(_3,"SplashArtCoordinates")
const _469=_o4(_5,_o3(_3,"SplashArtCoordinate"))
const _470=_o3(_3,"reviewWinnerArtId")
const _471=_o2(_2,_468,_469,_o5(_7,[_10,_o4(_8,_470),_o4(_8,_o3(_3,"leftXPct")),_o4(_8,_o3(_3,"leftYPct")),_o4(_8,_o3(_3,"leftHeightPct")),_o4(_8,_o3(_3,"leftWidthPct")),_o4(_8,_o3(_3,"leftFlipped")),_o4(_8,_o3(_3,"middleXPct")),_o4(_8,_o3(_3,"middleYPct")),_o4(_8,_o3(_3,"middleHeightPct")),_o4(_8,_o3(_3,"middleWidthPct")),_o4(_8,_o3(_3,"middleFlipped")),_o4(_8,_o3(_3,"rightXPct")),_o4(_8,_o3(_3,"rightYPct")),_o4(_8,_o3(_3,"rightHeightPct")),_o4(_8,_o3(_3,"rightWidthPct")),_o4(_8,_o3(_3,"rightFlipped"))]))
const _472=_o3(_3,"SplashArtCoordinatesEdit")
const _473=_o4(_25,_468)
const _474=_o2(_2,_472,_469,_o5(_7,[_473,_47]))
const _475=_o3(_3,"ReviewWinnerTopPostsPage")
const _476=_o4(_5,_o3(_3,"ReviewWinner"))
const _477=_o4(_8,_o3(_3,"category"))
const _478=_o4(_8,_o3(_3,"reviewYear"))
const _479=_o4(_8,_o3(_3,"reviewRanking"))
const _480=_o3(_3,"reviewWinnerArt")
const _481=_o4(_8,_o3(_3,"splashArtImageUrl"))
const _482=_o5(_7,[_o4(_25,_472)])
const _483=_o6(_8,_o3(_3,"activeSplashArtCoordinates"),_482)
const _484=_o2(_2,_475,_476,_o5(_7,[_10,_477,_238,_478,_479,_o6(_8,_480,_o5(_7,[_481,_483]))]))
const _485=_o3(_3,"PostsTopItemInfo")
const _486=_o3(_3,"reviewWinner")
const _487=_o6(_8,_486,_o5(_7,[_o4(_25,_475)]))
const _488=_o2(_2,_485,_6,_o5(_7,[_26,_90,_33,_487]))
const _489=_o3(_3,"PostsListWithVotesAndSequence")
const _490=_o3(_3,"canonicalSequence")
const _491=_o5(_7,[_253])
const _492=_o2(_2,_489,_6,_o5(_7,[_211,_o6(_8,_490,_491)]))
const _493=_o3(_3,"RSSFeedMinimumInfo")
const _494=_o4(_5,_o3(_3,"RSSFeed"))
const _495=_o4(_8,_o3(_3,"ownedByUser"))
const _496=_o4(_8,_o3(_3,"displayFullContent"))
const _497=_o4(_8,_o3(_3,"nickname"))
const _498=_o4(_8,_o3(_3,"importAsDraft"))
const _499=_o2(_2,_493,_494,_o5(_7,[_10,_20,_68,_47,_495,_496,_497,_78,_498]))
const _500=_o3(_3,"PostsDetails")
const _501=_o4(_8,_o3(_3,"canonicalSource"))
const _502=_o4(_8,_o3(_3,"noIndex"))
const _503=_o6(_8,_42,_o5(_7,[_10,_330,_43]))
const _504=_o5(_7,[_o4(_25,_493)])
const _505=_o4(_8,_o3(_3,"sourcePostId"))
const _506=_o2(_2,_500,_6,_o5(_7,[_194,_501,_502,_o4(_8,_o3(_3,"viewCount")),_o6(_8,_191,_169),_503,_83,_o4(_8,_o3(_3,"commentSortOrder")),_o4(_8,_o3(_3,"sideCommentVisibility")),_o4(_8,_o3(_3,"collectionTitle")),_o4(_8,_o3(_3,"canonicalPrevPostSlug")),_o4(_8,_o3(_3,"canonicalNextPostSlug")),_o4(_8,_o3(_3,"canonicalSequenceId")),_o4(_8,_o3(_3,"canonicalBookId")),_o6(_8,_490,_228),_o6(_8,_o3(_3,"canonicalBook"),_228),_229,_129,_118,_144,_145,_180,_o4(_8,_o3(_3,"feedLink")),_o6(_8,_o3(_3,"feed"),_504),_o6(_8,_o3(_3,"sourcePostRelations"),_o5(_7,[_10,_505,_o6(_8,_o3(_3,"sourcePost"),_212),_437])),_o6(_8,_o3(_3,"targetPostRelations"),_o5(_7,[_10,_505,_o4(_8,_o3(_3,"targetPostId")),_o6(_8,_o3(_3,"targetPost"),_212),_437])),_o4(_8,_o3(_3,"rsvps")),_o4(_8,_o3(_3,"activateRSVPs")),_197]))
const _507=_o3(_3,"UltraFeedPostFragment")
const _508=_o4(_25,_500)
const _509=_o4(_8,_o3(_3,"autoFrontpage"))
const _510=_o2(_2,_507,_6,_o5(_7,[_508,_211,_o6(_8,_36,_o5(_7,[_10,_174,_69,_70,_37,_196])),_509,_126]))
const _511=_o3(_3,"PostsReviewVotingList")
const _512=_o3(_3,"qualitativeScore")
const _513=_o4(_8,_512)
const _514=_o4(_8,_o3(_3,"quadraticScore"))
const _515=_o5(_7,[_10,_513,_514])
const _516=_o2(_2,_511,_6,_o5(_7,[_211,_o4(_8,_o3(_3,"reviewVoteScoreAllKarma")),_o4(_8,_o3(_3,"reviewVotesAllKarma")),_o4(_8,_o3(_3,"reviewVoteScoreHighKarma")),_o4(_8,_o3(_3,"reviewVotesHighKarma")),_o4(_8,_o3(_3,"reviewVoteScoreAF")),_o4(_8,_o3(_3,"reviewVotesAF")),_o6(_8,_o3(_3,"currentUserReviewVote"),_515)]))
const _517=_o3(_3,"PostsModerationGuidelines")
const _518=_o3(_3,"moderationGuidelines")
const _519=_o2(_2,_517,_6,_o5(_7,[_26,_80,_o6(_8,_30,_o5(_7,[_10,_31,_118])),_118,_o6(_8,_518,_o5(_7,[_10,_174,_268]))]))
const _520=_o3(_3,"MarkdownPostsList")
const _521=_o2(_2,_520,_6,_o5(_7,[_194,_o6(_8,_36,_o5(_7,[_10,_o4(_8,_o3(_3,"agentMarkdownExcerpt"))])),_180,_197]))
const _522=_o3(_3,"CurationNoticesFragment")
const _523=_o3(_3,"commentId")
const _524=_o4(_8,_523)
const _525=_o2(_2,_522,_o4(_5,_o3(_3,"CurationNotice")),_o5(_7,[_10,_47,_20,_68,_524,_o6(_8,_221,_190),_162,_304,_54,_274]))
const _526=_o3(_3,"SunshineCurationPostsList")
const _527=_o3(_3,"curationNotices")
const _528=_o5(_7,[_o4(_25,_522)])
const _529=_o2(_2,_526,_6,_o5(_7,[_205,_o6(_8,_527,_528)]))
const _530=_o3(_3,"SunshineCurationPostsListItem")
const _531=_o2(_2,_530,_6,_o5(_7,[_10,_14,_28,_27,_110,_33,_o6(_8,_527,_o5(_7,[_10,_33]))]))
const _532=_o3(_3,"WithVoteTagRel")
const _533=_o4(_5,_o3(_3,"TagRel"))
const _534=_o2(_2,_532,_533,_434)
const _535=_o3(_3,"tagRel")
const _536="Argument"
const _537="Variable"
const _538=_o4(_537,_163)
const _539=_o8(_536,_163,_538)
const _540=_o5(_7,[_o4(_25,_532)])
const _541=_o7(_8,_535,[_539],_540)
const _542=_o3(_3,"PostsListTagWithVotes")
const _543=_o2(_2,_542,_6,_o5(_7,[_211,_541]))
const _544=_o3(_3,"PostsExpandedHighlight")
const _545=_o2(_2,_544,_6,_o5(_7,[_10,_o6(_8,_36,_o5(_7,[_10,_174,_70]))]))
const _546=_o3(_3,"PostsPlaintextDescription")
const _547=_o5(_7,[_10,_37])
const _548=_o2(_2,_546,_6,_o5(_7,[_10,_o6(_8,_36,_547)]))
const _549=_o3(_3,"RevisionMetadata")
const _550=_o2(_2,_549,_225,_o5(_7,[_10,_196,_263,_264,_20,_87,_27,_86,_85,_144,_145]))
const _551=_o3(_3,"PostsRevision")
const _552=_o4(_537,_195)
const _553=_o8(_536,_195,_552)
const _554=[_553]
const _555=_o3(_3,"revisions")
const _556=_o4(_25,_549)
const _557=_o6(_8,_555,_o5(_7,[_556]))
const _558=_o2(_2,_551,_6,_o5(_7,[_508,_196,_o7(_8,_36,_554,_234),_557]))
const _559=_o3(_3,"PostSequenceNavigation")
const _560=_o3(_3,"sequence")
const _561=_o4(_537,_246)
const _562=_o8(_536,_246,_561)
const _563=[_562]
const _564=_o3(_3,"prevOrNext")
const _565="StringValue"
const _566=_o5(_7,[_10])
const _567=_o3(_3,"nextPost")
const _568=_o2(_2,_559,_6,_o5(_7,[_o7(_8,_560,_563,_491),_o7(_8,_o3(_3,"prevPost"),_563,_o5(_7,[_211,_o7(_8,_560,[_562,_o8(_536,_564,_o9(_565,"prev",false))],_566)])),_o7(_8,_567,_563,_o5(_7,[_211,_o7(_8,_560,[_562,_o8(_536,_564,_o9(_565,"next",false))],_566)]))]))
const _569=_o3(_3,"ReviewWinnerArtImages")
const _570=_o2(_2,_569,_o4(_5,_o3(_3,"ReviewWinnerArt")),_o5(_7,[_10,_47,_162,_o4(_8,_o3(_3,"splashArtImagePrompt")),_481,_o4(_8,_o3(_3,"midjourneyJobId")),_o4(_8,_o3(_3,"midjourneyImageIndex")),_o4(_8,_o3(_3,"upscaledImageUrl")),_483]))
const _571=_o3(_3,"ReviewWinnerAll")
const _572=_o5(_7,[_o4(_25,_569)])
const _573=_o4(_8,_o3(_3,"competitorCount"))
const _574=_o2(_2,_571,_476,_o5(_7,[_10,_477,_238,_162,_478,_479,_o6(_8,_480,_572),_573]))
const _575=_o3(_3,"JargonTermsPost")
const _576=_o2(_2,_575,_393,_o5(_7,[_10,_394,_395,_396,_54,_397,_235]))
const _577=_o3(_3,"PostsWithNavigationAndRevision")
const _578=_o4(_25,_551)
const _579=_o4(_25,_559)
const _580=_o6(_8,_486,_o5(_7,[_o4(_25,_571)]))
const _581=_o6(_8,_o3(_3,"glossary"),_o5(_7,[_o4(_25,_575)]))
const _582=_o2(_2,_577,_6,_o5(_7,[_578,_579,_o6(_8,_187,_234),_o10(_8,_o3(_3,"tableOfContentsRevision"),_554),_580,_206,_581]))
const _583=_o3(_3,"PostsPage")
const _584=_o4(_8,_o3(_3,"sideComments"))
const _585=_o4(_8,_o3(_3,"myEditorAccess"))
const _586=_o2(_2,_583,_6,_o5(_7,[_508,_196,_235,_584,_585]))
const _587=_o3(_3,"PostsWithNavigation")
const _588=_o4(_25,_583)
const _589=_o3(_3,"tableOfContents")
const _590=_o4(_8,_589)
const _591=_o2(_2,_587,_6,_o5(_7,[_588,_579,_590,_580,_206,_581]))
const _592=_o3(_3,"PostsEdit")
const _593=_o6(_8,_518,_273)
const _594=_o4(_8,_o3(_3,"imageId"))
const _595=_o2(_2,_592,_6,_o5(_7,[_508,_584,_585,_196,_21,_o4(_8,_o3(_3,"readTimeMinutesOverride")),_197,_o4(_8,_o3(_3,"hideFromRecentDiscussions")),_o4(_8,_o3(_3,"hideFromPopularComments")),_593,_o6(_8,_187,_273),_590,_o4(_8,_o3(_3,"subforumTagId")),_o4(_8,_o3(_3,"socialPreviewImageId")),_o6(_8,_o3(_3,"socialPreview"),_o5(_7,[_594,_330])),_o6(_8,_42,_o5(_7,[_10,_594,_330])),_o6(_8,_30,_o5(_7,[_66,_118,_129,_131])),_o6(_8,_o3(_3,"usersSharedWith"),_67),_135,_o4(_8,_o3(_3,"generateDraftJargon"))]))
const _596=_o3(_3,"PostsEditQueryFragment")
const _597=_o4(_25,_592)
const _598=_o7(_8,_36,_554,_273)
const _599=_o2(_2,_596,_6,_o5(_7,[_597,_598]))
const _600=_o3(_3,"PostsEditMutationFragment")
const _601=_o2(_2,_600,_6,_o5(_7,[_597,_274]))
const _602=_o3(_3,"PostsRevisionsList")
const _603=_o2(_2,_602,_6,_o5(_7,[_10,_557]))
const _604=_o3(_3,"PostsRecentDiscussion")
const _605=_o3(_3,"recentComments")
const _606=_o3(_3,"commentsLimit")
const _607=_o4(_537,_606)
const _608=_o3(_3,"maxAgeHours")
const _609=_o4(_537,_608)
const _610=_o8(_536,_608,_609)
const _611=_o4(_537,_17)
const _612=_o8(_536,_17,_611)
const _613=[_o8(_536,_606,_607),_610,_612]
const _614=_o2(_2,_604,_6,_o5(_7,[_211,_o7(_8,_605,_613,_190)]))
const _615=_o3(_3,"CommentsListWithTopLevelComment")
const _616=_o3(_3,"topLevelComment")
const _617=_o2(_2,_615,_160,_o5(_7,[_189,_o6(_8,_616,_190)]))
const _618=_o3(_3,"ShortformRecentDiscussion")
const _619=_o5(_7,[_o4(_25,_615)])
const _620=_o2(_2,_618,_6,_o5(_7,[_211,_o7(_8,_605,_613,_619)]))
const _621=_o3(_3,"ModeratorActionDisplay")
const _622=_o2(_2,_621,_o4(_5,_o3(_3,"ModeratorAction")),_o5(_7,[_10,_68,_20,_265,_74,_47,_283]))
const _623=_o3(_3,"TagRelBasicInfo")
const _624=_o2(_2,_623,_533,_o5(_7,[_10,_87,_27,_86,_116,_85,_164,_162,_o4(_8,_o3(_3,"autoApplied"))]))
const _625=_o3(_3,"TagRelMinimumFragment")
const _626=_o4(_25,_623)
const _627=_o6(_8,_165,_169)
const _628=_o4(_8,_o3(_3,"currentUserCanVote"))
const _629=_o2(_2,_625,_533,_o5(_7,[_626,_627,_144,_145,_628]))
const _630=_o3(_3,"SunshinePostsList")
const _631=_o5(_7,[_10,_174])
const _632=_o6(_8,_518,_631)
const _633=_o3(_3,"biography")
const _634=_o6(_8,_633,_234)
const _635=_o5(_7,[_o4(_25,_621)])
const _636=_o6(_8,_o3(_3,"moderatorActions"),_635)
const _637=_o3(_3,"tagRels")
const _638=_o5(_7,[_o4(_25,_625)])
const _639=_o2(_2,_630,_6,_o5(_7,[_194,_144,_145,_180,_197,_183,_509,_o6(_8,_36,_o5(_7,[_10,_174,_69,_70,_196])),_339,_632,_o6(_8,_30,_o5(_7,[_66,_634,_50,_118,_129,_131,_632,_140,_636])),_o6(_8,_o3(_3,"frontpageClassification"),_o5(_7,[_o4(_8,_o3(_3,"isFrontpage")),_o4(_8,_o3(_3,"probability"))])),_o6(_8,_637,_638)]))
const _640=_o3(_3,"WithVotePost")
const _641=_o2(_2,_640,_6,_343)
const _642=_o3(_3,"HighlightWithHash")
const _643=_o3(_3,"hash")
const _644=_o4(_537,_643)
const _645=_o8(_536,_643,_644)
const _646=_o5(_7,[_10,_o10(_8,_o3(_3,"htmlHighlightStartingAtHash"),[_645])])
const _647=_o2(_2,_642,_6,_o5(_7,[_10,_o6(_8,_36,_646)]))
const _648=_o3(_3,"PostWithDialogueMessage")
const _649=_o3(_3,"dialogueMessageId")
const _650=_o4(_537,_649)
const _651=_o2(_2,_648,_6,_o5(_7,[_10,_o10(_8,_o3(_3,"dialogueMessageContents"),[_o8(_536,_649,_650)])]))
const _652=_o3(_3,"RevisionHTML")
const _653=_o2(_2,_652,_225,_631)
const _654=_o3(_3,"SuggestAlignmentPost")
const _655=_o2(_2,_654,_6,_o5(_7,[_205,_356]))
const _656=_o3(_3,"UserRateLimitDisplay")
const _657=_o4(_5,_o3(_3,"UserRateLimit"))
const _658=_o4(_8,_o3(_3,"actionsPerInterval"))
const _659=_o4(_8,_o3(_3,"intervalUnit"))
const _660=_o4(_8,_o3(_3,"intervalLength"))
const _661=_o2(_2,_656,_657,_o5(_7,[_10,_68,_20,_265,_658,_659,_660,_47,_283]))
const _662=_o3(_3,"SunshineUsersList")
const _663=_o4(_8,_o3(_3,"emails"))
const _664=_o4(_8,_o3(_3,"error"))
const _665=_o3(_3,"sourceUserId")
const _666=_o4(_8,_665)
const _667=_o4(_8,_o3(_3,"shortformFeedId"))
const _668=_o4(_8,_o3(_3,"mapLocation"))
const _669=_o4(_8,_o3(_3,"mapMarkerText"))
const _670=_o4(_8,_o3(_3,"htmlMapMarkerText"))
const _671=_o4(_8,_o3(_3,"postingDisabled"))
const _672=_o4(_8,_o3(_3,"commentingOnOtherUsersDisabled"))
const _673=_o4(_8,_o3(_3,"conversationsDisabled"))
const _674=_o4(_8,_o3(_3,"nullifyVotes"))
const _675=_o4(_8,_o3(_3,"deleteContent"))
const _676=_o4(_8,_o3(_3,"reviewGroup"))
const _677=_o4(_8,_o3(_3,"voteReceivedCount"))
const _678=_o4(_8,_o3(_3,"lastNotificationsCheck"))
const _679=_o3(_3,"userRateLimits")
const _680=_o5(_7,[_o4(_25,_656)])
const _681=_o2(_2,_662,_46,_o5(_7,[_66,_51,_55,_102,_47,_390,_663,_o6(_8,_o3(_3,"mailgunValidation"),_o5(_7,[_390,_79,_o4(_8,_o3(_3,"validatedAt")),_o4(_8,_o3(_3,"httpStatus")),_664,_o4(_8,_o3(_3,"isValid")),_o4(_8,_o3(_3,"risk")),_o4(_8,_o3(_3,"reason")),_o4(_8,_o3(_3,"didYouMean")),_o4(_8,_o3(_3,"isDisposableAddress")),_o4(_8,_o3(_3,"isRoleAddress")),_666])),_57,_o4(_8,_o3(_3,"maxCommentCount")),_56,_o4(_8,_o3(_3,"maxPostCount")),_667,_85,_o4(_8,_o3(_3,"smallUpvoteCount")),_o4(_8,_o3(_3,"bigUpvoteCount")),_o4(_8,_o3(_3,"smallDownvoteCount")),_o4(_8,_o3(_3,"bigDownvoteCount")),_133,_60,_o4(_8,_o3(_3,"reviewedAt")),_o4(_8,_o3(_3,"signUpReCaptchaRating")),_668,_669,_670,_140,_o4(_8,_o3(_3,"sunshineNotes")),_o4(_8,_o3(_3,"sunshineFlagged")),_671,_134,_672,_673,_o4(_8,_o3(_3,"votingDisabled")),_o4(_8,_o3(_3,"snoozedUntilContentCount")),_674,_675,_636,_676,_o4(_8,_o3(_3,"hasPendingComments")),_o4(_8,_o3(_3,"usersContactedBeforeReview")),_677,_o4(_8,_o3(_3,"smallUpvoteReceivedCount")),_o4(_8,_o3(_3,"bigUpvoteReceivedCount")),_o4(_8,_o3(_3,"smallDownvoteReceivedCount")),_o4(_8,_o3(_3,"bigDownvoteReceivedCount")),_o4(_8,_o3(_3,"recentKarmaInfo")),_678,_o4(_8,_o3(_3,"lastRemovedFromReviewQueueAt")),_o4(_8,_o3(_3,"rejectedContentCount")),_o6(_8,_679,_680)]))
const _682=_o3(_3,"UnclaimedReportsList")
const _683=_o5(_7,[_205])
const _684=_o6(_8,_210,_683)
const _685=_o4(_25,_662)
const _686=_o5(_7,[_685])
const _687=_o4(_8,_154)
const _688=_o2(_2,_682,_o4(_5,_o3(_3,"Report")),_o5(_7,[_10,_20,_68,_524,_o6(_8,_221,_o5(_7,[_189,_304,_314])),_162,_684,_o6(_8,_o3(_3,"reportedUser"),_686),_o4(_8,_o3(_3,"closedAt")),_47,_o4(_8,_o3(_3,"claimedUserId")),_o6(_8,_o3(_3,"claimedUser"),_o5(_7,[_10,_31,_49,_12])),_453,_687,_o4(_8,_o3(_3,"reportedAsSpam")),_o4(_8,_o3(_3,"markedAsSpam"))]))
const _689=_o3(_3,"reviewVoteFragment")
const _690=_o4(_5,_o3(_3,"ReviewVote"))
const _691=_o3(_3,"year")
const _692=_o4(_8,_691)
const _693=_o3(_3,"dummy")
const _694=_o2(_2,_689,_690,_o5(_7,[_10,_47,_20,_162,_513,_514,_o4(_8,_221),_692,_o4(_8,_693),_o4(_8,_o3(_3,"reactions"))]))
const _695=_o3(_3,"reviewAdminDashboard")
const _696=_o2(_2,_695,_690,_o5(_7,[_10,_47,_20,_o6(_8,_30,_o5(_7,[_10,_31,_51]))]))
const _697=_o3(_3,"ReviewWinnerAnnouncement")
const _698=_o2(_2,_697,_476,_o5(_7,[_10,_477,_238,_478,_479,_573,_162,_o6(_8,_210,_o5(_7,[_10,_14,_12]))]))
const _699=_o3(_3,"RevisionMetadataWithChangeMetrics")
const _700=_o4(_8,_o3(_3,"changeMetrics"))
const _701=_o2(_2,_699,_225,_o5(_7,[_556,_700,_68]))
const _702=_o3(_3,"RevisionHistoryEntry")
const _703=_o2(_2,_702,_225,_o5(_7,[_556,_282,_220,_700,_445,_o4(_8,_o3(_3,"skipAttributions")),_68]))
const _704=_o3(_3,"RevisionHistorySummaryEdit")
const _705=_o4(_25,_702)
const _706=_o2(_2,_704,_225,_o5(_7,[_705,_o6(_8,_o3(_3,"summary"),_o5(_7,[_448,_o6(_8,_149,_o5(_7,[_10,_123])),_o6(_8,_o3(_3,"parentLens"),_o5(_7,[_10,_14,_443,_444]))]))]))
const _707=_o3(_3,"TagDetailsFragment")
const _708=_o2(_2,_707,_138,_o5(_7,[_148,_244,_442,_90,_o4(_8,_o3(_3,"defaultOrder")),_60,_o4(_8,_o3(_3,"wikiGrade")),_o4(_8,_o3(_3,"subforumModeratorIds")),_o6(_8,_o3(_3,"subforumModerators"),_67),_632,_237,_o4(_8,_o3(_3,"squareImageId")),_o4(_8,_o3(_3,"lesswrongWikiImportSlug")),_o4(_8,_o3(_3,"lesswrongWikiImportRevision")),_o6(_8,_560,_491)]))
const _709=_o3(_3,"TagFragment")
const _710=_o4(_25,_707)
const _711=_o2(_2,_709,_138,_o5(_7,[_710,_151,_153,_o6(_8,_154,_o5(_7,[_10,_174,_69,_37,_196,_263])),_156,_157]))
const _712=_o3(_3,"MultiDocumentContentDisplay")
const _713=_o4(_8,_o3(_3,"textLastUpdatedAt"))
const _714=_o2(_2,_712,_440,_o5(_7,[_448,_590,_713,_274]))
const _715=_o3(_3,"TagHistoryFragment")
const _716=_o4(_25,_709)
const _717=_o4(_25,_712)
const _718=_o5(_7,[_717])
const _719=_o2(_2,_715,_138,_o5(_7,[_716,_713,_590,_68,_o6(_8,_o3(_3,"lensesIncludingDeleted"),_718)]))
const _720=_o3(_3,"ArbitalLinkedPagesFragment")
const _721=_o5(_7,[_10,_123,_12])
const _722=_o2(_2,_720,_o4(_5,_o3(_3,"ArbitalLinkedPages")),_o5(_7,[_o6(_8,_o3(_3,"faster"),_721),_o6(_8,_o3(_3,"slower"),_721),_o6(_8,_o3(_3,"moreTechnical"),_721),_o6(_8,_o3(_3,"lessTechnical"),_721),_o6(_8,_o3(_3,"requirements"),_721),_o6(_8,_o3(_3,"teaches"),_721),_o6(_8,_o3(_3,"parents"),_721),_o6(_8,_o3(_3,"children"),_721)]))
const _723=_o3(_3,"MultiDocumentEdit")
const _724=_o6(_8,_o3(_3,"arbitalLinkedPages"),_o5(_7,[_o4(_25,_720)]))
const _725=_o6(_8,_o3(_3,"summaries"),_718)
const _726=_o2(_2,_723,_440,_o5(_7,[_717,_724,_725,_713]))
const _727=_o3(_3,"MultiDocumentParentDocument")
const _728=_o4(_25,_723)
const _729=_o5(_7,[_o4(_25,_715)])
const _730=_o2(_2,_727,_440,_o5(_7,[_728,_o6(_8,_149,_729)]))
const _731=_o3(_3,"RevisionTagFragment")
const _732=_o6(_8,_165,_729)
const _733=_o3(_3,"lens")
const _734=_o5(_7,[_o4(_25,_727)])
const _735=_o2(_2,_731,_225,_o5(_7,[_705,_732,_o6(_8,_733,_734)]))
const _736=_o3(_3,"TagRecentDiscussion")
const _737=_o3(_3,"tagCommentsLimit")
const _738=_o4(_537,_737)
const _739=_o2(_2,_736,_138,_o5(_7,[_716,_88,_o7(_8,_605,[_o8(_536,_737,_738),_610,_612],_190)]))
const _740=_o3(_3,"RecentDiscussionRevisionTagFragment")
const _741=_o5(_7,[_o4(_25,_736)])
const _742=_o2(_2,_740,_225,_o5(_7,[_705,_o6(_8,_165,_741)]))
const _743=_o3(_3,"WithVoteRevision")
const _744=_o2(_2,_743,_225,_o5(_7,[_342,_10,_144,_145,_27,_86,_87,_85]))
const _745=_o3(_3,"newRSSFeedFragment")
const _746=_o2(_2,_745,_494,_o5(_7,[_10,_20,_47,_495,_496,_497,_78,_79,_498]))
const _747=_o3(_3,"SequenceContinueReadingFragment")
const _748=_o2(_2,_747,_63,_o5(_7,[_10,_14,_236,_65]))
const _749=_o3(_3,"SequencesEdit")
const _750=_o2(_2,_749,_63,_o5(_7,[_253,_274]))
const _751=_o3(_3,"SpotlightMinimumInfo")
const _752=_o4(_5,_o3(_3,"Spotlight"))
const _753=_o4(_8,_o3(_3,"customTitle"))
const _754=_o4(_8,_o3(_3,"customSubtitle"))
const _755=_o2(_2,_751,_752,_o5(_7,[_10,_282,_452,_o4(_8,_o3(_3,"spotlightImageId")),_o4(_8,_o3(_3,"spotlightDarkImageId")),_o4(_8,_o3(_3,"spotlightSplashImageUrl")),_15,_81,_o4(_8,_o3(_3,"position")),_o4(_8,_o3(_3,"lastPromotedAt")),_753,_754,_o4(_8,_o3(_3,"subtitleUrl")),_o4(_8,_o3(_3,"headerTitle")),_o4(_8,_o3(_3,"headerTitleLeftColor")),_o4(_8,_o3(_3,"headerTitleRightColor")),_o4(_8,_o3(_3,"duration")),_o4(_8,_o3(_3,"showAuthor")),_o4(_8,_o3(_3,"imageFade")),_o4(_8,_o3(_3,"imageFadeColor"))]))
const _756=_o4(_25,_751)
const _757=_o3(_3,"SpotlightEditQueryFragment")
const _758=_o6(_8,_154,_273)
const _759=_o2(_2,_757,_752,_o5(_7,[_756,_758]))
const _760=_o3(_3,"SubscriptionState")
const _761=_o4(_5,_o3(_3,"Subscription"))
const _762=_o2(_2,_760,_761,_o5(_7,[_10,_20,_47,_o4(_8,_o3(_3,"state")),_282,_220,_54,_265]))
const _763=_o3(_3,"MembersOfGroupFragment")
const _764=_o2(_2,_763,_761,_o5(_7,[_68]))
const _765=_o3(_3,"TagFlagFragment")
const _766=_o4(_5,_o3(_3,"TagFlag"))
const _767=_o2(_2,_765,_766,_o5(_7,[_10,_47,_123,_12,_437,_54,_o6(_8,_36,_o5(_7,[_174,_69,_37]))]))
const _768=_o3(_3,"TagFlagEditFragment")
const _769=_o4(_25,_765)
const _770=_o2(_2,_768,_766,_o5(_7,[_769,_274]))
const _771=_o3(_3,"TagRelHistoryFragment")
const _772=_o2(_2,_771,_533,_o5(_7,[_626,_47,_68,_684]))
const _773=_o3(_3,"TagRelCreationFragment")
const _774=_o2(_2,_773,_533,_o5(_7,[_626,_627,_o6(_8,_210,_o5(_7,[_205,_83,_541])),_144,_145]))
const _775=_o3(_3,"TagCreationHistoryFragment")
const _776=_o6(_8,_154,_o5(_7,[_174]))
const _777=_o2(_2,_775,_138,_o5(_7,[_716,_68,_776]))
const _778=_o3(_3,"TagSectionPreviewFragment")
const _779=_o2(_2,_778,_138,_o5(_7,[_148,_90,_151,_153,_o6(_8,_154,_646),_156,_157]))
const _780=_o3(_3,"TagWithFlagsFragment")
const _781=_o4(_8,_o3(_3,"tagFlagsIds"))
const _782=_o3(_3,"tagFlags")
const _783=_o5(_7,[_769])
const _784=_o6(_8,_782,_783)
const _785=_o2(_2,_780,_138,_o5(_7,[_716,_781,_784]))
const _786=_o3(_3,"TagPageFragment")
const _787=_o4(_25,_780)
const _788=_o4(_8,_o3(_3,"postsDefaultSortOrder"))
const _789=_o6(_8,_o3(_3,"subforumIntroPost"),_212)
const _790=_o3(_3,"subforumWelcomeText")
const _791=_o6(_8,_790,_631)
const _792=_o3(_3,"contributors")
const _793=_o3(_3,"limit")
const _794=_o4(_537,_o3(_3,"contributorsLimit"))
const _795=_o8(_536,_793,_794)
const _796=_o4(_8,_o3(_3,"totalCount"))
const _797=_o4(_8,_o3(_3,"contributionScore"))
const _798=_o4(_8,_o3(_3,"currentAttributionCharCount"))
const _799=_o5(_7,[_796,_o6(_8,_792,_o5(_7,[_68,_797,_798,_o4(_8,_o3(_3,"numCommits")),_85]))])
const _800=_o7(_8,_792,[_795],_799)
const _801=_o2(_2,_786,_138,_o5(_7,[_787,_590,_788,_789,_791,_800,_156,_157,_125,_713]))
const _802=_o3(_3,"MultiDocumentWithContributors")
const _803=_o2(_2,_802,_440,_o5(_7,[_728,_o6(_8,_792,_o5(_7,[_796,_o6(_8,_792,_o5(_7,[_68,_798]))]))]))
const _804=_o3(_3,"TagPageArbitalContentFragment")
const _805=_o3(_3,"lenses")
const _806=_o2(_2,_804,_138,_o5(_7,[_o6(_8,_805,_o5(_7,[_o4(_25,_802)])),_724]))
const _807=_o3(_3,"TagPageWithArbitalContentFragment")
const _808=_o4(_25,_786)
const _809=_o4(_25,_804)
const _810=_o2(_2,_807,_138,_o5(_7,[_808,_809]))
const _811=_o3(_3,"AllTagsPageFragment")
const _812=_o2(_2,_811,_138,_o5(_7,[_787,_590]))
const _813=_o3(_3,"TagRevisionFragment")
const _814=_o2(_2,_813,_138,_o5(_7,[_710,_151,_153,_90,_o7(_8,_154,_554,_o5(_7,[_10,_196,_174,_69,_37,_263,_68]))]))
const _815=_o3(_3,"TagWithFlagsAndRevisionFragment")
const _816=_o2(_2,_815,_138,_o5(_7,[_o4(_25,_813),_781,_784]))
const _817=_o3(_3,"TagPageWithRevisionFragment")
const _818=_o10(_8,_589,_554)
const _819=_o2(_2,_817,_138,_o5(_7,[_o4(_25,_815),_818,_713,_788,_789,_791,_o7(_8,_792,[_795,_553],_799),_156,_157,_125]))
const _820=_o3(_3,"TagPageRevisionWithArbitalContentFragment")
const _821=_o4(_25,_817)
const _822=_o2(_2,_820,_138,_o5(_7,[_821,_809]))
const _823=_o3(_3,"TagFullContributorsList")
const _824=_o2(_2,_823,_138,_o5(_7,[_o6(_8,_792,_799)]))
const _825=_o3(_3,"TagEditFragment")
const _826=_o2(_2,_825,_138,_o5(_7,[_710,_o4(_8,_o3(_3,"isPostType")),_o4(_8,_o3(_3,"parentTagId")),_151,_o4(_8,_o3(_3,"subforumIntroPostId")),_781,_788,_o4(_8,_o3(_3,"introSequenceId")),_156,_o4(_8,_o3(_3,"removalResistant")),_157,_o4(_8,_o3(_3,"autoTagModel")),_o4(_8,_o3(_3,"autoTagPrompt")),_758,_o6(_8,_790,_273),_593]))
const _827=_o3(_3,"SunshineTagFragment")
const _828=_o2(_2,_827,_138,_o5(_7,[_716,_68]))
const _829=_o3(_3,"ExplorePageTagFragment")
const _830=_o2(_2,_829,_138,_o5(_7,[_716,_800,_445]))
const _831=_o3(_3,"ConceptItemFragment")
const _832=_o3(_3,"coreTagId")
const _833=_o2(_2,_831,_138,_o5(_7,[_10,_139,_123,_12,_442,_56,_27,_o6(_8,_154,_o5(_7,[_10,_70])),_141,_143,_o4(_8,_832),_o4(_8,_o3(_3,"maxScore")),_o6(_8,_o3(_3,"usersWhoLiked"),_o5(_7,[_20,_31]))]))
const _834=_o3(_3,"MultiDocumentRevision")
const _835=_o2(_2,_834,_440,_o5(_7,[_448,_598,_818]))
const _836=_o3(_3,"MultiDocumentWithContributorsRevision")
const _837=_o2(_2,_836,_440,_o5(_7,[_o4(_25,_834),_o7(_8,_792,_554,_o5(_7,[_796,_o6(_8,_792,_o5(_7,[_68,_798,_797]))])),_724,_713]))
const _838=_o3(_3,"TagPageWithArbitalContentAndLensRevisionFragment")
const _839=_o3(_3,"lensSlug")
const _840=_o4(_537,_839)
const _841=_o2(_2,_838,_138,_o5(_7,[_808,_724,_o7(_8,_805,[_o8(_536,_839,_840),_553],_o5(_7,[_o4(_25,_836)]))]))
const _842=_o3(_3,"WithVoteTag")
const _843=_o2(_2,_842,_138,_150)
const _844=_o3(_3,"TypoSuggestionsDefaultFragment")
const _845=_o4(_8,_o3(_3,"quote"))
const _846=_o2(_2,_844,_o4(_5,_o3(_3,"TypoSuggestion")),_o5(_7,[_10,_47,_282,_220,_386,_o4(_8,_o3(_3,"voteId")),_o6(_8,_o3(_3,"reactor"),_67),_o4(_8,_o3(_3,"authorId")),_o6(_8,_o3(_3,"author"),_67),_845,_o4(_8,_o3(_3,"llmCanonicalQuote")),_o4(_8,_o3(_3,"proposedReplacement")),_o4(_8,_o3(_3,"narrowedQuote")),_o4(_8,_o3(_3,"narrowedReplacement")),_o4(_8,_o3(_3,"explanation")),_o4(_8,_o3(_3,"llmVerdict")),_79,_o4(_8,_o3(_3,"resolvedByUserId")),_o4(_8,_o3(_3,"appliedRevisionId")),_o4(_8,_o3(_3,"resolvedAt"))]))
const _847=_o3(_3,"UserMostValuablePostInfo")
const _848=_o2(_2,_847,_o4(_5,_o3(_3,"UserMostValuablePost")),_o5(_7,[_10,_20,_162,_54]))
const _849=_o3(_3,"UserRateLimitMutationFragment")
const _850=_o2(_2,_849,_657,_o5(_7,[_10,_461,_47,_445,_20,_265,_659,_660,_658,_283]))
const _851=_o3(_3,"UsersCurrentCommentRateLimit")
const _852=_o4(_537,_161)
const _853=_o8(_536,_161,_852)
const _854=[_853]
const _855=_o2(_2,_851,_46,_o5(_7,[_10,_o10(_8,_o3(_3,"rateLimitNextAbleToComment"),_854)]))
const _856=_o3(_3,"UsersCurrentPostRateLimit")
const _857=_o3(_3,"eventForm")
const _858=_o4(_537,_857)
const _859=_o2(_2,_856,_46,_o5(_7,[_10,_o10(_8,_o3(_3,"rateLimitNextAbleToPost"),[_o8(_536,_857,_858)])]))
const _860=_o3(_3,"UserKarmaChanges")
const _861=_o3(_3,"karmaChanges")
const _862=_o4(_8,_o3(_3,"totalChange"))
const _863=_o4(_8,_o3(_3,"updateFrequency"))
const _864=_o3(_3,"startDate")
const _865=_o4(_8,_864)
const _866=_o3(_3,"endDate")
const _867=_o4(_8,_866)
const _868=_o4(_8,_o3(_3,"nextBatchDate"))
const _869=_o4(_8,_o3(_3,"scoreChange"))
const _870=_o6(_8,_o3(_3,"addedReacts"),_o5(_7,[_o4(_8,_o3(_3,"reactionType")),_20,_845]))
const _871=_o3(_3,"comments")
const _872=_o4(_8,_o3(_3,"postTitle"))
const _873=_o4(_8,_o3(_3,"postSlug"))
const _874=_o3(_3,"tagSlug")
const _875=_o4(_8,_874)
const _876=_o4(_8,_o3(_3,"tagName"))
const _877=_o3(_3,"tagRevisions")
const _878=_o2(_2,_860,_46,_o5(_7,[_10,_o6(_8,_861,_o5(_7,[_862,_863,_865,_867,_868,_o6(_8,_250,_o5(_7,[_10,_869,_162,_14,_12,_870,_220])),_o6(_8,_871,_o5(_7,[_10,_869,_524,_687,_162,_872,_873,_875,_876,_171,_870,_220])),_o6(_8,_877,_o5(_7,[_10,_869,_164,_875,_876,_870,_220]))]))]))
const _879=_o3(_3,"UserAltAccountsFragment")
const _880=_o4(_8,_o3(_3,"userIds"))
const _881=_o6(_8,_o3(_3,"associatedClientIds"),_o5(_7,[_285,_286,_287,_880]))
const _882=_o2(_2,_879,_46,_o5(_7,[_685,_881,_o4(_8,_o3(_3,"IPs"))]))
const _883=_o3(_3,"UserClientIdsInfo")
const _884=_o2(_2,_883,_46,_o5(_7,[_10,_12,_881,_o4(_8,_o3(_3,"altAccountsDetected"))]))
const _885=_o3(_3,"UsersMapEntry")
const _886=_o4(_8,_o3(_3,"fullName"))
const _887=_o3(_3,"lat")
const _888=_o4(_8,_887)
const _889=_o3(_3,"lng")
const _890=_o4(_8,_889)
const _891=_o4(_8,_o3(_3,"mapLocationSet"))
const _892=_o2(_2,_885,_46,_o5(_7,[_10,_31,_49,_886,_12,_o6(_8,_o3(_3,"mapLocationLatLng"),_o5(_7,[_888,_890])),_891,_670]))
const _893=_o3(_3,"UsersProfile")
const _894=_o4(_8,_o3(_3,"organizerOfGroupIds"))
const _895=_o4(_8,_o3(_3,"linkedinProfileURL"))
const _896=_o4(_8,_o3(_3,"facebookProfileURL"))
const _897=_o4(_8,_o3(_3,"blueskyProfileURL"))
const _898=_o4(_8,_o3(_3,"twitterProfileURL"))
const _899=_o4(_8,_o3(_3,"githubProfileURL"))
const _900=_o6(_8,_518,_234)
const _901=_o4(_8,_o3(_3,"petrovPressedButtonDate"))
const _902=_o4(_8,_o3(_3,"petrovOptOut"))
const _903=_o4(_8,_o3(_3,"sortDraftsBy"))
const _904=_o4(_8,_o3(_3,"paymentEmail"))
const _905=_o4(_8,_o3(_3,"paymentInfo"))
const _906=_o2(_2,_893,_46,_o5(_7,[_66,_o4(_8,_o3(_3,"coauthoredPostCount")),_886,_o4(_8,_o3(_3,"previousDisplayName")),_442,_132,_634,_894,_102,_895,_896,_897,_898,_899,_o4(_8,_o3(_3,"afSequenceCount")),_o4(_8,_o3(_3,"afSequenceDraftCount")),_o4(_8,_o3(_3,"sequenceDraftCount")),_118,_900,_129,_92,_93,_668,_891,_669,_670,_414,_667,_901,_902,_903,_390,_663,_133,_675,_142,_904,_905,_671,_134,_672,_673,_o4(_8,_o3(_3,"pinnedPostIds")),_o4(_8,_o3(_3,"hideProfileTopPosts")),_677]))
const _907=_o3(_3,"UsersCurrent")
const _908=_o4(_8,_o3(_3,"beta"))
const _909=_o4(_8,_o3(_3,"hideIntercom"))
const _910=_o4(_8,_o3(_3,"hideCommunitySection"))
const _911=_o4(_8,_o3(_3,"currentFrontpageFilter"))
const _912=_o4(_8,_o3(_3,"noKibitz"))
const _913=_o4(_8,_o3(_3,"showHideKarmaOption"))
const _914=_o4(_8,_o3(_3,"markDownPostEditor"))
const _915=_o4(_8,_o3(_3,"hideElicitPredictions"))
const _916=_o4(_8,_o3(_3,"hideAFNonMemberInitialWarning"))
const _917=_o4(_8,_o3(_3,"commentSorting"))
const _918=_o4(_8,_o3(_3,"hideFrontpageMap"))
const _919=_o4(_8,_o3(_3,"emailSubscribedToCurated"))
const _920=_o4(_8,_o3(_3,"unsubscribeFromAll"))
const _921=_o4(_8,_o3(_3,"whenConfirmationEmailSent"))
const _922=_o4(_8,_o3(_3,"noCollapseCommentsFrontpage"))
const _923=_o4(_8,_o3(_3,"noCollapseCommentsPosts"))
const _924=_o4(_8,_o3(_3,"noSingleLineComments"))
const _925=_o4(_8,_o3(_3,"showCommunityInRecentDiscussion"))
const _926=_o4(_8,_o3(_3,"karmaChangeNotifierSettings"))
const _927=_o4(_8,_o3(_3,"karmaChangeLastOpened"))
const _928=_o4(_8,_o3(_3,"theme"))
const _929=_o4(_8,_o3(_3,"hideFrontpageBookAd"))
const _930=_o3(_3,"abTestKey")
const _931=_o4(_8,_o3(_3,"notificationSubforumUnread"))
const _932=_o4(_8,_o3(_3,"notificationRepliesToMyComments"))
const _933=_o4(_8,_o3(_3,"hideFrontpageBook2020Ad"))
const _934=_o2(_2,_907,_46,_o5(_7,[_66,_442,_132,_894,_118,_900,_129,_92,_93,_668,_891,_669,_414,_667,_903,_390,_663,_133,_675,_904,_905,_671,_134,_672,_673,_o4(_8,_o3(_3,"usernameUnset")),_o4(_8,_o3(_3,"taggingDashboardCollapsed")),_908,_o4(_8,_o3(_3,"acceptedTos")),_o4(_8,_o3(_3,"pageUrl")),_o4(_8,_o3(_3,"isReviewed")),_674,_909,_o4(_8,_o3(_3,"hideNavigationSidebar")),_910,_o4(_8,_o3(_3,"hasContinueReading")),_o6(_8,_o3(_3,"expandedFrontpageSections"),_o5(_7,[_o4(_8,_o3(_3,"community")),_o4(_8,_o3(_3,"recommendations")),_o4(_8,_o3(_3,"quickTakes")),_o4(_8,_o3(_3,"quickTakesCommunity")),_o4(_8,_o3(_3,"popularComments"))])),_911,_o4(_8,_o3(_3,"frontpageSelectedTab")),_o4(_8,_o3(_3,"frontpageFilterSettings")),_o4(_8,_o3(_3,"ultraFeedSettings")),_o4(_8,_o3(_3,"hideFrontpageFilterSettingsDesktop")),_o4(_8,_o3(_3,"allPostsTimeframe")),_o4(_8,_o3(_3,"allPostsSorting")),_o4(_8,_o3(_3,"allPostsFilter")),_o4(_8,_o3(_3,"allPostsShowLowKarma")),_o4(_8,_o3(_3,"allPostsIncludeEvents")),_o4(_8,_o3(_3,"allPostsOpenSettings")),_o4(_8,_o3(_3,"draftsListSorting")),_o4(_8,_o3(_3,"draftsListShowArchived")),_o4(_8,_o3(_3,"draftsListShowShared")),_678,_129,_130,_118,_912,_913,_914,_915,_916,_917,_92,_93,_414,_668,_891,_669,_670,_o4(_8,_o3(_3,"nearbyEventsNotifications")),_o4(_8,_o3(_3,"nearbyEventsNotificationsLocation")),_o4(_8,_o3(_3,"nearbyEventsNotificationsRadius")),_o4(_8,_o3(_3,"nearbyPeopleNotificationThreshold")),_918,_919,_920,_921,_o4(_8,_o3(_3,"hideSubscribePoke")),_o4(_8,_o3(_3,"hideMeetupsPoke")),_o4(_8,_o3(_3,"hideHomeRHS")),_922,_923,_924,_925,_926,_927,_667,_o4(_8,_o3(_3,"viewUnreviewedComments")),_o4(_8,_o3(_3,"recommendationSettings")),_928,_o4(_8,_o3(_3,"hasAnyBookmarks")),_o6(_8,_o3(_3,"hiddenPostsMetadata"),_o5(_7,[_162])),_o4(_8,_o3(_3,"auto_subscribe_to_my_posts")),_o4(_8,_o3(_3,"auto_subscribe_to_my_comments")),_o4(_8,_o3(_3,"autoSubscribeAsOrganizer")),_o4(_8,_o3(_3,"noExpandUnreadCommentsReview")),_929,_o4(_8,_930),_o4(_8,_o3(_3,"abTestOverrides")),_903,_o4(_8,_o3(_3,"reactPaletteStyle")),_901,_o4(_8,_o3(_3,"petrovLaunchCodeDate")),_902,_o4(_8,_o3(_3,"lastUsedTimezone")),_o4(_8,_o3(_3,"acknowledgedNewUserGuidelines")),_931,_932,_o4(_8,_o3(_3,"subforumPreferredLayout")),_933,_o4(_8,_o3(_3,"showDialoguesList")),_o4(_8,_o3(_3,"showMyDialogues")),_o4(_8,_o3(_3,"showMatches")),_o4(_8,_o3(_3,"showRecommendedPartners")),_o4(_8,_o3(_3,"hideActiveDialogueUsers")),_o4(_8,_o3(_3,"hideSunshineSidebar")),_o4(_8,_o3(_3,"postGlossariesPinned")),_o4(_8,_o3(_3,"generateJargonForDrafts")),_o4(_8,_o3(_3,"generateJargonForPublishedPosts")),_o4(_8,_o3(_3,"claudeLinkedAt"))]))
const _935=_o3(_3,"UsersEdit")
const _936=_o4(_25,_893)
const _937=_o4(_25,_907)
const _938=_o6(_8,_633,_273)
const _939=_o4(_8,_o3(_3,"associatedOAuthServices"))
const _940=_o4(_8,_o3(_3,"reviewForAlignmentForumUserId"))
const _941=_o4(_8,_o3(_3,"afApplicationText"))
const _942=_o4(_8,_o3(_3,"afSubmittedApplication"))
const _943=_o2(_2,_935,_46,_o5(_7,[_936,_937,_938,_593,_914,_915,_916,_909,_917,_911,_923,_922,_924,_910,_925,_908,_928,_390,_921,_919,_920,_131,_o4(_8,_o3(_3,"collapseModerationGuidelines")),_129,_130,_912,_913,_674,_675,_133,_939,_49,_31,_886,_414,_93,_92,_668,_o4(_8,_o3(_3,"hideFromPeopleDirectory")),_60,_940,_132,_941,_942,_927,_926,_o4(_8,_o3(_3,"notificationShortformContent")),_o4(_8,_o3(_3,"notificationCommentsOnSubscribedPost")),_932,_o4(_8,_o3(_3,"notificationRepliesToSubscribedComments")),_o4(_8,_o3(_3,"notificationSubscribedUserPost")),_o4(_8,_o3(_3,"notificationSubscribedUserComment")),_o4(_8,_o3(_3,"notificationSubscribedTagPost")),_o4(_8,_o3(_3,"notificationSubscribedSequencePost")),_o4(_8,_o3(_3,"notificationPostsInGroups")),_o4(_8,_o3(_3,"notificationPrivateMessage")),_o4(_8,_o3(_3,"notificationSharedWithMe")),_o4(_8,_o3(_3,"notificationAlignmentSubmissionApproved")),_o4(_8,_o3(_3,"notificationEventInRadius")),_o4(_8,_o3(_3,"notificationRSVPs")),_o4(_8,_o3(_3,"notificationCommentsOnDraft")),_o4(_8,_o3(_3,"notificationPostsNominatedReview")),_o4(_8,_o3(_3,"notificationGroupAdministration")),_931,_o4(_8,_o3(_3,"notificationNewMention")),_o4(_8,_o3(_3,"notificationTypoSuggestions")),_o4(_8,_o3(_3,"notificationNewDialogueChecks")),_o4(_8,_o3(_3,"notificationYourTurnMatchForm")),_o4(_8,_o3(_3,"notificationDialogueMessages")),_o4(_8,_o3(_3,"notificationPublishedDialogueMessages")),_918,_o4(_8,_o3(_3,"hideTaggingProgressBar")),_929,_933,_54,_o4(_8,_o3(_3,"permanentDeletionRequestedAt")),_o4(_8,_o3(_3,"twitterProfileURLAdmin"))]))
const _944=_o5(_7,[_417])
const _945=_o3(_3,"UsersCrosspostInfo")
const _946=_o2(_2,_945,_46,_o5(_7,[_10,_49,_12,_o4(_8,_o3(_3,"fmCrosspostUserId"))]))
const _947=_o3(_3,"SuggestAlignmentUser")
const _948=_o2(_2,_947,_46,_o5(_7,[_66,_52,_58,_59,_940,_132,_941,_942]))
const _949=_o3(_3,"UsersMergeSearchResult")
const _950=_o2(_2,_949,_46,_o5(_7,[_66,_390,_663,_939]))
const _951=_o3(_3,"TagRelVotes")
const _952=_o4(_5,_o3(_3,"Vote"))
const _953=_o3(_3,"voteType")
const _954=_o4(_8,_953)
const _955=_o4(_8,_o3(_3,"power"))
const _956=_o4(_8,_o3(_3,"votedAt"))
const _957=_o4(_8,_o3(_3,"isUnvote"))
const _958=_o2(_2,_951,_952,_o5(_7,[_10,_20,_954,_955,_282,_956,_957,_o6(_8,_535,_540)]))
const _959=_o3(_3,"TagRelFragment")
const _960=_o2(_2,_959,_533,_o5(_7,[_626,_627,_684,_144,_145,_628]))
const _961=_o3(_3,"TagVotingActivity")
const _962=_o5(_7,[_o4(_25,_959)])
const _963=_o2(_2,_961,_952,_o5(_7,[_o4(_25,_951),_o6(_8,_535,_962)]))
const _964=_o3(_3,"UserVotes")
const _965=_o2(_2,_964,_952,_o5(_7,[_10,_20,_954,_955,_o4(_8,_o3(_3,"cancelled")),_282,_956,_957,_220]))
const _966=_o3(_3,"UserVotesWithDocument")
const _967=_o4(_25,_964)
const _968=_o5(_7,[_337])
const _969=_o2(_2,_966,_952,_o5(_7,[_967,_o6(_8,_221,_968),_213]))
const _970=_o3(_3,"FeedPostFragment")
const _971=_o4(_8,_o3(_3,"postMetaInfo"))
const _972=_o2(_2,_970,_o4(_5,_o3(_3,"FeedPost")),_o5(_7,[_10,_971,_213]))
const _973=_o3(_3,"FeedCommentThreadFragment")
const _974=_o2(_2,_973,_o4(_5,_o3(_3,"FeedCommentThread")),_o5(_7,[_10,_o4(_8,_o3(_3,"commentMetaInfos")),_o4(_8,_o3(_3,"postSources")),_971,_213,_o6(_8,_871,_222)]))
const _975=_o3(_3,"SpotlightDisplay")
const _976=_o2(_2,_975,_752,_o5(_7,[_756,_o6(_8,_210,_o5(_7,[_10,_12,_14,_68,_o6(_8,_o3(_3,"reviews"),_566)])),_o6(_8,_560,_o5(_7,[_10,_14,_68])),_o6(_8,_165,_o5(_7,[_10,_123,_12,_68])),_776]))
const _977=_o3(_3,"FeedSpotlightFragment")
const _978=_o3(_3,"spotlight")
const _979=_o5(_7,[_o4(_25,_975)])
const _980=_o6(_8,_978,_979)
const _981=_o2(_2,_977,_o4(_5,_o3(_3,"FeedSpotlightItem")),_o5(_7,[_10,_980,_213,_o6(_8,_o3(_3,"spotlightMetaInfo"),_o5(_7,[_o4(_8,_o3(_3,"sources")),_o4(_8,_o3(_3,"servedEventId")),_o4(_8,_o3(_3,"rankingMetadata"))]))]))
const _982=_o3(_3,"FeedSubscriptionSuggestionsFragment")
const _983=_o2(_2,_982,_o4(_5,_o3(_3,"FeedSubscriptionSuggestions")),_o5(_7,[_10,_o6(_8,_o3(_3,"suggestedUsers"),_67)]))
const _984=_o3(_3,"FeedMarkerFragment")
const _985=_o2(_2,_984,_o4(_5,_o3(_3,"FeedMarker")),_o5(_7,[_10,_o4(_8,_o3(_3,"markerType")),_o4(_8,_o3(_3,"timestamp"))]))
const _986="OperationDefinition"
const _987="mutation"
const _988="VariableDefinition"
const _989=_o4(_537,_329)
const _990="NonNullType"
const _991=_o4(_5,_o3(_3,"String"))
const _992=_o13(_990,_991)
const _993=_o3(_3,"model")
const _994=_o4(_537,_993)
const _995="query"
const _996=_o4(_537,_281)
const _997=_o12(_988,_996,_992)
const _998=[_997]
const _999=_o3(_3,"collection")
const _1000=_o3(_3,"input")
const _1001="ObjectValue"
const _1002="ObjectField"
const _1003=_o3(_3,"selector")
const _1004=_o14(_1001,[_o8(_1002,_281,_996)])
const _1005=_o8(_1002,_1003,_1004)
const _1006=_o8(_536,_1000,_o14(_1001,[_1005]))
const _1007=[_1006]
const _1008=_o3(_3,"result")
const _1009=_o6(_8,_36,_o5(_7,[_359,_37]))
const _1010=_o6(_8,_250,_166)
const _1011=_o4(_537,_o3(_3,"defaultLimit"))
const _1012=_o4(_5,_o3(_3,"Int"))
const _1013=_o4(_537,_o3(_3,"nearbyLimit"))
const _1014=_o4(_537,_887)
const _1015=_o4(_5,_o3(_3,"Float"))
const _1016=_o4(_537,_889)
const _1017=_o4(_537,_o3(_3,"hasCoordinates"))
const _1018=_o4(_5,_o3(_3,"Boolean"))
const _1019=_o13(_990,_1018)
const _1020=_o3(_3,"events")
const _1021="BooleanValue"
const _1022=_o3(_1021,false)
const _1023=_o8(_1002,_94,_1022)
const _1024=_o8(_536,_793,_1011)
const _1025=_o3(_3,"results")
const _1026=_o6(_8,_30,_o5(_7,[_12,_31]))
const _1027=_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_12,_14,_92,_98,_99,_95,_97,_1026]))])
const _1028=_o3(_3,"globalEvents")
const _1029=_o14(_1001,[])
const _1030=_o4(_537,_o3(_3,"recentLimit"))
const _1031=_o4(_537,_o3(_3,"latestLimit"))
const _1032=_o3(_3,"currentSpotlight")
const _1033=_o6(_8,_210,_o5(_7,[_10,_12,_14]))
const _1034=_o3(_3,"curated")
const _1035="IntValue"
const _1036=_o8(_536,_793,_o3(_1035,"3"))
const _1037=_o5(_7,[_o4(_25,_520)])
const _1038=_o5(_7,[_o6(_8,_1025,_1037)])
const _1039="new"
const _1040=_o4(_537,_523)
const _1041=_o12(_988,_1040,_992)
const _1042=[_1041]
const _1043=_o14(_1001,[_o8(_1002,_9,_1040)])
const _1044=[_o8(_536,_1003,_1043)]
const _1045=_o5(_7,[_o4(_25,_358)])
const _1046=_o4(_537,_9)
const _1047=_o12(_988,_1046,_992)
const _1048=[_1047]
const _1049=[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_9,_1046)]))]
const _1050=_o4(_537,_793)
const _1051=_o12(_988,_1050,_1012)
const _1052=[_1047,_1051]
const _1053=_o14(_1001,[_o8(_1002,_161,_1046)])
const _1054=_o8(_536,_793,_1050)
const _1055=_o5(_7,[_o6(_8,_1025,_1045)])
const _1056=_o4(_537,_1003)
const _1057=_o4(_5,_o3(_3,"PostSelector"))
const _1058=_o12(_988,_1056,_1057)
const _1059=[_1058,_1051]
const _1060=_o8(_536,_1003,_1056)
const _1061=[_1060,_1054]
const _1062=_o3(_3,"id")
const _1063=_o4(_537,_1062)
const _1064=_o12(_988,_1063,_992)
const _1065=_o4(_537,_o3(_3,"chapterLimit"))
const _1066=_o8(_536,_1003,_o14(_1001,[_o8(_1002,_9,_1063)]))
const _1067=_o4(_537,_11)
const _1068=_o12(_988,_1067,_992)
const _1069=[_1068]
const _1070=_o3(_3,"tagBySlug")
const _1071=_o14(_1001,[_o8(_1002,_11,_1067)])
const _1072=_o8(_536,_793,_o3(_1035,"1"))
const _1073=_o12(_988,_538,_992)
const _1074=_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"usersProfile"),_1071)]))
const _1075=_o4(_537,_19)
const _1076=_o12(_988,_1075,_992)
const _1077=_o4(_537,_o3(_3,"postsLimit"))
const _1078=_o3(_3,"userPosts")
const _1079=_o8(_1002,_19,_1075)
const _1080=_o3(_3,"sortedBy")
const _1081=_o3(_1021,true)
const _1082=_o8(_1002,_o3(_3,"excludeEvents"),_1081)
const _1083=_o9(_565,_1039,false)
const _1084=_o12(_988,_607,_1012)
const _1085=_o3(_3,"profileComments")
const _1086=_o3(_3,"sortBy")
const _1087=_o4(_537,_219)
const _1088=_o12(_988,_996,_991)
const _1089=_o4(_537,_84)
const _1090=[_o12(_988,_1087,_991),_1088,_o12(_988,_1089,_991)]
const _1091=_o8(_536,_219,_1087)
const _1092=_o8(_536,_281,_996)
const _1093=_o8(_536,_84,_1089)
const _1094=_o3(_3,"token")
const _1095=_o5(_7,[_o4(_8,_1094)])
const _1096=_o5(_7,[_o7(_8,_o3(_3,"HocuspocusAuth"),[_1091,_1092,_1093],_1095)])
const _1097=_o4(_537,_108)
const _1098=_o3(_3,"localgroup")
const _1099=_o3(_3,"commentIds")
const _1100=_o4(_537,_1099)
const _1101="ListType"
const _1102=_o13(_1101,_992)
const _1103=_o13(_990,_1102)
const _1104=_o3(_3,"default")
const _1105=_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1104,_o14(_1001,[_o8(_1002,_1099,_1100)]))]))
const _1106=_o6(_8,_1025,_o5(_7,[_307]))
const _1107=_o13(_990,_1012)
const _1108=_o12(_988,_1050,_1107)
const _1109=[_1076,_1108]
const _1110=_o8(_536,_19,_1075)
const _1111=[_1110,_1054]
const _1112=_o4(_8,_o3(_3,"date"))
const _1113=_o4(_5,_o3(_3,"UserSelector"))
const _1114=_o3(_3,"enableTotal")
const _1115=_o4(_537,_1114)
const _1116=_o12(_988,_1115,_1018)
const _1117=[_o12(_988,_1056,_1113),_1051,_1116]
const _1118=[_1060,_1054,_o8(_536,_1114,_1115)]
const _1119=_o5(_7,[_936])
const _1120=_o5(_7,[_o7(_8,_288,_1118,_o5(_7,[_o6(_8,_1025,_1119),_796]))])
const _1121=[_1058,_1051,_1116]
const _1122=_o12(_988,_1056,_o4(_5,_o3(_3,"CommentSelector")))
const _1123=[_1122,_1051,_1116]
const _1124=_o6(_8,_1025,_968)
const _1125=_o5(_7,[_o7(_8,_871,_1118,_o5(_7,[_1124,_796]))])
const _1126=_o5(_7,[_o7(_8,_871,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_306)])),_796]))])
const _1127=[_o12(_988,_1056,_o4(_5,_o3(_3,"SequenceSelector"))),_1051,_1116]
const _1128=_o5(_7,[_o4(_25,_747)])
const _1129=[_o12(_988,_1056,_o4(_5,_o3(_3,"RevisionSelector"))),_1051,_1116]
const _1130=_o5(_7,[_o4(_25,_731)])
const _1131=_o5(_7,[_o6(_8,_1025,_1130),_796])
const _1132=_o5(_7,[_o7(_8,_555,_1118,_1131)])
const _1133=_o3(_3,"SearchSynonyms")
const _1134=_o3(_3,"UpdateSearchSynonyms")
const _1135=_o3(_3,"synonyms")
const _1136=_o4(_537,_1135)
const _1137=_o4(_5,_o3(_3,"SelectorInput"))
const _1138=_o12(_988,_1056,_o13(_990,_1137))
const _1139=_o4(_537,_266)
const _1140=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateCurationNoticeDataInput"))))]
const _1141=_o8(_536,_266,_1139)
const _1142=[_1060,_1141]
const _1143=_o5(_7,[_o6(_8,_266,_528)])
const _1144=_o5(_7,[_o7(_8,_o3(_3,"updateCurationNotice"),_1142,_1143)])
const _1145=[_1141]
const _1146=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdatePostDataInput"))))]
const _1147=_o3(_3,"updatePost")
const _1148=_o5(_7,[_o7(_8,_1147,_1142,_o5(_7,[_o6(_8,_266,_683)]))])
const _1149=[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateCommentDataInput"))))]
const _1150=_o3(_3,"createComment")
const _1151=_o5(_7,[_o6(_8,_266,_190)])
const _1152=_o5(_7,[_o7(_8,_1150,_1145,_1151)])
const _1153=_o6(_8,_1025,_528)
const _1154=_o4(_537,_1000)
const _1155=[_o8(_536,_1000,_1154)]
const _1156=_o4(_8,_o3(_3,"ok"))
const _1157=_o3(_3,"userIsAuthor")
const _1158=_o4(_537,_1157)
const _1159=_o3(_3,"publicId")
const _1160=_o4(_8,_1159)
const _1161=_o3(_3,"verified")
const _1162=_o4(_8,_1161)
const _1163=_o3(_3,"autoReviewPassed")
const _1164=_o4(_8,_1163)
const _1165=_o4(_8,_o3(_3,"autoReviewMessage"))
const _1166=_o4(_8,_o3(_3,"source"))
const _1167=_o3(_3,"designId")
const _1168=_o4(_537,_1167)
const _1169=_o4(_537,_1161)
const _1170=_o4(_537,_1163)
const _1171=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateCommentDataInput"))))]
const _1172=_o3(_3,"updateComment")
const _1173=_o5(_7,[_o4(_25,_355)])
const _1174=_o5(_7,[_o7(_8,_871,_1118,_o5(_7,[_o6(_8,_1025,_1173),_796]))])
const _1175=_o3(_3,"alignmentPost")
const _1176=_o12(_988,_852,_991)
const _1177=_o12(_988,_611,_1018)
const _1178=_o6(_8,_1025,_67)
const _1179=_o5(_7,[_o7(_8,_288,_1118,_o5(_7,[_1178,_796]))])
const _1180=[_1088]
const _1181=_o5(_7,[_588])
const _1182=_o5(_7,[_o6(_8,_1008,_1181)])
const _1183=_o5(_7,[_o7(_8,_210,_1007,_1182)])
const _1184=[_o12(_988,_1056,_o4(_5,_o3(_3,"BookmarkSelector"))),_1051,_1116]
const _1185=_o3(_3,"bookmarks")
const _1186=_o3(_3,"filter")
const _1187=_o4(_537,_1186)
const _1188=_o3(_3,"sort")
const _1189=_o4(_537,_1188)
const _1190=[_1051,_o12(_988,_1187,_o4(_5,_o3(_3,"PostReviewFilter"))),_o12(_988,_1189,_o4(_5,_o3(_3,"PostReviewSort")))]
const _1191=_o8(_536,_1186,_1187)
const _1192=[_1054,_1191,_o8(_536,_1188,_1189)]
const _1193=[_o12(_988,_1056,_o4(_5,_o3(_3,"VoteSelector"))),_1051,_1116]
const _1194=_o3(_3,"votes")
const _1195=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateUserDataInput"))))]
const _1196=_o3(_3,"updateUser")
const _1197=_o5(_7,[_937])
const _1198=_o5(_7,[_o7(_8,_1196,_1142,_o5(_7,[_o6(_8,_266,_1197)]))])
const _1199=_o3(_3,_995)
const _1200=_o4(_537,_1199)
const _1201=_o12(_988,_1200,_992)
const _1202=_o3(_3,"scoreBias")
const _1203=_o4(_537,_1202)
const _1204=_o12(_988,_1203,_1015)
const _1205=_o8(_536,_1199,_1200)
const _1206=_o8(_536,_1202,_1203)
const _1207=_o8(_536,_523,_1040)
const _1208=_o5(_7,[_o6(_8,_1008,_190)])
const _1209=_o5(_7,[_o7(_8,_221,_1007,_1208)])
const _1210=_o5(_7,[_o7(_8,_1172,_1142,_1151)])
const _1211=_o5(_7,[_o4(_25,_313)])
const _1212=_o5(_7,[_o6(_8,_1008,_1211)])
const _1213=_o5(_7,[_o7(_8,_221,_1007,_1212)])
const _1214=_o14(_1001,[_o8(_1002,_9,_996)])
const _1215=[_o8(_536,_1003,_1214)]
const _1216=_o5(_7,[_o4(_25,_310)])
const _1217=_o5(_7,[_o4(_25,_317)])
const _1218=[_o12(_988,_1056,_o4(_5,_o3(_3,"LWEventSelector"))),_1051,_1116]
const _1219=_o3(_3,"lWEvents")
const _1220=[_o8(_536,_1003,_1004)]
const _1221=_o3(_3,"TagModerationGuidelines")
const _1222=_o5(_7,[_716])
const _1223=_o6(_8,_1008,_1222)
const _1224=_o5(_7,[_o7(_8,_1147,_1142,_o5(_7,[_o6(_8,_266,_1181)]))])
const _1225=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateTagDataInput"))))]
const _1226=_o3(_3,"updateTag")
const _1227=_o5(_7,[_787])
const _1228=_o5(_7,[_o6(_8,_266,_1227)])
const _1229=_o5(_7,[_o7(_8,_1226,_1142,_1228)])
const _1230=_o12(_988,_552,_991)
const _1231=_o5(_7,[_o4(_25,_596)])
const _1232=_o5(_7,[_o6(_8,_1008,_1231)])
const _1233=_o5(_7,[_o4(_25,_825)])
const _1234=_o5(_7,[_o6(_8,_1008,_1233)])
const _1235=_o5(_7,[_o6(_8,_1008,_968)])
const _1236=_o5(_7,[_o7(_8,_221,_1007,_1235)])
const _1237=_o3(_3,"PopularComments")
const _1238=[_1051]
const _1239=[_1054]
const _1240=_o5(_7,[_1124])
const _1241=_o5(_7,[_o7(_8,_871,_1118,_o5(_7,[_o6(_8,_1025,_190),_796]))])
const _1242=_o5(_7,[_o7(_8,_871,_1118,_o5(_7,[_1106,_796]))])
const _1243=_o4(_537,_1159)
const _1244=[_o12(_988,_1243,_992)]
const _1245=_o3(_3,"homePageDesignByPublicId")
const _1246=[_o8(_536,_1159,_1243)]
const _1247=_o5(_7,[_10,_1160,_174,_14])
const _1248=_o4(_537,_248)
const _1249=[_o12(_988,_1248,_1102)]
const _1250=_o8(_536,_793,_o3(_1035,"50"))
const _1251=[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1104,_o14(_1001,[_o8(_1002,_o3(_3,"exactPostIds"),_1248)]))])),_1250]
const _1252=_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_144]))])
const _1253=_o4(_537,_953)
const _1254=_o12(_988,_1253,_991)
const _1255=[_1088,_1254]
const _1256=_o3(_3,"performVotePost")
const _1257=_o8(_536,_953,_1253)
const _1258=[_1092,_1257]
const _1259="document"
const _1260=_o3(_3,_1259)
const _1261=_o4(_8,_o3(_3,"showVotingPatternWarning"))
const _1262=_o5(_7,[_o6(_8,_1260,_o5(_7,[_o4(_25,_640)])),_1261])
const _1263=_o3(_3,"performVoteComment")
const _1264=_o5(_7,[_o6(_8,_1260,_o5(_7,[_o4(_25,_341)])),_1261])
const _1265=_o12(_988,_644,_991)
const _1266=[_1088,_1265]
const _1267=_o5(_7,[_o7(_8,_210,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_642)]))]))])
const _1268=_o3(_3,"AllTagsActivityFeed")
const _1269=_o3(_3,"cutoff")
const _1270=_o4(_537,_1269)
const _1271=_o4(_5,_o3(_3,"Date"))
const _1272=_o12(_988,_1270,_1271)
const _1273=_o3(_3,"offset")
const _1274=_o4(_537,_1273)
const _1275=_o12(_988,_1274,_1012)
const _1276=_o8(_536,_1269,_1270)
const _1277=_o8(_536,_1273,_1274)
const _1278=_o4(_8,_1269)
const _1279=_o4(_8,_o3(_3,"endOffset"))
const _1280=_o3(_3,"tagCreated")
const _1281=_o3(_3,"tagRevision")
const _1282=_o3(_3,"tagDiscussionComment")
const _1283=_o3(_3,"TagHistoryFeed")
const _1284=_o3(_3,"options")
const _1285=_o4(_537,_1284)
const _1286=_o4(_5,_o3(_3,"JSON"))
const _1287=_o5(_7,[_705])
const _1288=_o5(_7,[_o4(_25,_384)])
const _1289=_o3(_3,"RecentDiscussionFeed")
const _1290=_o12(_988,_609,_1012)
const _1291=_o5(_7,[_o4(_25,_604)])
const _1292=_o3(_3,"UltraFeed")
const _1293=_o3(_3,"sessionId")
const _1294=_o4(_537,_1293)
const _1295=_o3(_3,"settings")
const _1296=_o4(_537,_1295)
const _1297=_o12(_988,_1296,_1286)
const _1298=_o8(_536,_1295,_1296)
const _1299=_o6(_8,_o3(_3,"feedCommentThread"),_o5(_7,[_o4(_25,_973)]))
const _1300=_o6(_8,_o3(_3,"feedPost"),_o5(_7,[_o4(_25,_970)]))
const _1301=_o6(_8,_o3(_3,"feedSubscriptionSuggestions"),_o5(_7,[_o4(_25,_982)]))
const _1302=_o6(_8,_o3(_3,"feedMarker"),_o5(_7,[_o4(_25,_984)]))
const _1303=_o3(_3,"UltraFeedSubscriptions")
const _1304=_o3(_3,"UserContentFeed")
const _1305=_o4(_537,_1086)
const _1306=_o12(_988,_1305,_991)
const _1307=_o8(_536,_1086,_1305)
const _1308=_o3(_3,"ElicitBlockData")
const _1309=_o3(_3,"questionId")
const _1310=_o4(_537,_1309)
const _1311=_o12(_988,_1310,_991)
const _1312=_o8(_536,_1309,_1310)
const _1313=_o3(_3,"prediction")
const _1314=_o5(_7,[_10,_14,_380,_382,_381,_o6(_8,_o3(_3,"predictions"),_o5(_7,[_10,_o4(_8,_o3(_3,"predictionId")),_o4(_8,_1313),_47,_380,_o4(_8,_o3(_3,"sourceUrl")),_o4(_8,_o3(_3,"sourceId")),_o4(_8,_o3(_3,"binaryQuestionId")),_o6(_8,_o3(_3,"creator"),_o5(_7,[_10,_31,_666,_o6(_8,_o3(_3,"lwUser"),_67)]))]))])
const _1315=_o4(_537,_1313)
const _1316=_o4(_537,_o3(_3,"widgetId"))
const _1317=_o3(_3,"RecentlyActiveDialogues")
const _1318=_o6(_8,_1025,_212)
const _1319=_o5(_7,[_1318])
const _1320=_o3(_3,"MyDialogues")
const _1321=_o5(_7,[_o6(_8,_1008,_212)])
const _1322=_o5(_7,[_o7(_8,_210,_1007,_1321)])
const _1323=_o5(_7,[_508])
const _1324=_o5(_7,[_o7(_8,_210,_1007,_o5(_7,[_o6(_8,_1008,_1323)]))])
const _1325=_o3(_3,"lockThread")
const _1326=_o3(_3,"until")
const _1327=_o4(_537,_1326)
const _1328=_o3(_3,"unlockThread")
const _1329=_o5(_7,[_o7(_8,_1172,_1142,_o5(_7,[_o6(_8,_266,_1173)]))])
const _1330=_o3(_3,"moderateComment")
const _1331=_o12(_988,_1040,_991)
const _1332=_o4(_537,_53)
const _1333=_o4(_537,_178)
const _1334=_o4(_537,_176)
const _1335=_o12(_988,_852,_992)
const _1336=[_1335]
const _1337=[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_9,_852)]))]
const _1338=_o6(_8,_36,_631)
const _1339=_o3(_3,"moderationTemplate")
const _1340=[_1060]
const _1341=_o5(_7,[_o4(_25,_436)])
const _1342=_o5(_7,[_o6(_8,_1008,_1341)])
const _1343=_o3(_3,"unlistLlmPost")
const _1344=_o3(_3,"modCommentHtml")
const _1345=_o4(_537,_1344)
const _1346=_o3(_3,"markAsReadOrUnread")
const _1347=_o4(_537,_89)
const _1348=_o5(_7,[_597])
const _1349=_o5(_7,[_o6(_8,_266,_1348)])
const _1350=_o5(_7,[_o7(_8,_1147,_1142,_1349)])
const _1351=_o3(_3,"setIsHidden")
const _1352=_o3(_3,"isHidden")
const _1353=_o4(_537,_1352)
const _1354=_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_o6(_8,_1025,_303),_796]))])
const _1355=_o3(_3,"sendNewDialogueMessageNotification")
const _1356=_o3(_3,"dialogueHtml")
const _1357=_o4(_537,_1356)
const _1358=_o5(_7,[_o7(_8,_555,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_699)])),_796]))])
const _1359=_o3(_3,"revision")
const _1360=_o3(_3,"revertPostToRevision")
const _1361=_o3(_3,"revisionId")
const _1362=_o4(_537,_1361)
const _1363=_o5(_7,[_o6(_8,_1008,_67)])
const _1364=_o5(_7,[_o7(_8,_30,_1007,_1363)])
const _1365=_o3(_3,"revertToRevisionId")
const _1366=_o4(_537,_1365)
const _1367=_o12(_988,_794,_1012)
const _1368=_o5(_7,[_808])
const _1369=_o3(_3,"LlmModelOptions")
const _1370=_o4(_537,_1260)
const _1371=_o3(_3,"targetFormat")
const _1372=_o4(_537,_1371)
const _1373=_o8(_536,_1260,_1370)
const _1374=_o8(_536,_1371,_1372)
const _1375=_o3(_3,"unlinkCrossposter")
const _1376=[_o12(_988,_1056,_o4(_5,_o3(_3,"LocalgroupSelector"))),_1051,_1116]
const _1377=_o3(_3,"localgroups")
const _1378=_o5(_7,[_o6(_8,_1008,_491)])
const _1379=_o5(_7,[_o7(_8,_165,_1007,_o5(_7,[_o6(_8,_1008,_150)]))])
const _1380=_o5(_7,[_o7(_8,_30,_1007,_o5(_7,[_o6(_8,_1008,_1119)]))])
const _1381=_o12(_988,_1075,_991)
const _1382=_o13(_1101,_991)
const _1383=_o12(_988,_1248,_1382)
const _1384=_o3(_3,"desc")
const _1385=_o4(_537,_1384)
const _1386=_o8(_536,_248,_1248)
const _1387=_o4(_8,_o3(_3,"views"))
const _1388=_o4(_8,_o3(_3,"reads"))
const _1389=_o4(_8,_871)
const _1390=_o4(_537,_864)
const _1391=_o12(_988,_1390,_1271)
const _1392=_o4(_537,_866)
const _1393=_o12(_988,_1392,_1271)
const _1394=_o8(_536,_864,_1390)
const _1395=_o8(_536,_866,_1392)
const _1396=_o5(_7,[_209])
const _1397=_o3(_3,"reviewVotesForPostAndUser")
const _1398=_o3(_3,"reviewVotes")
const _1399=_o8(_1002,_161,_852)
const _1400=_o3(_3,"UserExpandFrontpageSection")
const _1401=_o3(_3,"section")
const _1402=_o4(_537,_1401)
const _1403=_o3(_3,"expanded")
const _1404=_o4(_537,_1403)
const _1405=_o12(_988,_1056,_o4(_5,_o3(_3,"TagSelector")))
const _1406=[_1405,_1051,_1116]
const _1407=_o6(_8,_1025,_150)
const _1408=_o5(_7,[_o7(_8,_191,_1118,_o5(_7,[_1407,_796]))])
const _1409=_o3(_3,"initiateConversation")
const _1410=_o4(_537,_364)
const _1411=_o4(_537,_365)
const _1412=_o5(_7,[_373])
const _1413=_o3(_3,"markConversationRead")
const _1414=_o4(_537,_369)
const _1415=_o12(_988,_1414,_992)
const _1416=[_1415]
const _1417=_o8(_536,_369,_1414)
const _1418=[_1417]
const _1419=[_o12(_988,_1056,_o4(_5,_o3(_3,"SubscriptionSelector"))),_1051,_1116]
const _1420=_o3(_3,"subscriptions")
const _1421=_o5(_7,[_o4(_25,_760)])
const _1422=_o5(_7,[_o7(_8,_1420,_1118,_o5(_7,[_o6(_8,_1025,_1421),_796]))])
const _1423=[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateSubscriptionDataInput"))))]
const _1424=_o5(_7,[_o7(_8,_o3(_3,"createSubscription"),_1145,_o5(_7,[_o6(_8,_266,_1421)]))])
const _1425=_o4(_8,_o3(_3,"uniqueClientViews"))
const _1426=_o5(_7,[_o6(_8,_1008,_683)])
const _1427=_o5(_7,[_o7(_8,_210,_1007,_1426)])
const _1428=_o5(_7,[_o4(_25,_630)])
const _1429=_o5(_7,[_o6(_8,_1025,_1428),_796])
const _1430=_o5(_7,[_o7(_8,_250,_1118,_1429)])
const _1431=[_1176]
const _1432=_o3(_3,"markPostCommentsRead")
const _1433=_o3(_3,"RefreshDbSettings")
const _1434=[_o12(_988,_1056,_o4(_5,_o3(_3,"ModerationTemplateSelector"))),_1051,_1116]
const _1435=_o5(_7,[_o7(_8,_o3(_3,"moderationTemplates"),_1118,_o5(_7,[_o6(_8,_1025,_1341),_796]))])
const _1436=_o5(_7,[_o7(_8,_1172,_1142,_o5(_7,[_o6(_8,_266,_968)]))])
const _1437=[_o12(_988,_1056,_o4(_5,_o3(_3,"MultiDocumentSelector"))),_1051,_1116]
const _1438=_o3(_3,"multiDocuments")
const _1439=[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_9,_1075)]))]
const _1440=_o3(_3,"jargonTerms")
const _1441=_o5(_7,[_o4(_25,_392)])
const _1442=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateJargonTermDataInput"))))]
const _1443=_o5(_7,[_o6(_8,_266,_1441)])
const _1444=_o5(_7,[_o7(_8,_o3(_3,"updateJargonTerm"),_1142,_1443)])
const _1445=_o3(_3,"getNewJargonTerms")
const _1446=_o3(_3,"glossaryPrompt")
const _1447=_o4(_537,_1446)
const _1448=_o3(_3,"examplePost")
const _1449=_o4(_537,_1448)
const _1450=_o3(_3,"exampleTerm")
const _1451=_o4(_537,_1450)
const _1452=_o3(_3,"exampleAltTerm")
const _1453=_o4(_537,_1452)
const _1454=_o3(_3,"exampleDefinition")
const _1455=_o4(_537,_1454)
const _1456=[_1058,_1051,_1116,_1230]
const _1457=_o5(_7,[_1318,_796])
const _1458=_o5(_7,[_o7(_8,_250,_1118,_1457)])
const _1459=[_o12(_988,_1056,_o4(_5,_o3(_3,"LlmConversationSelector"))),_1051,_1116]
const _1460=_o3(_3,"llmConversations")
const _1461=_o5(_7,[_403])
const _1462=_o5(_7,[_o7(_8,_o3(_3,"llmConversation"),_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_408)]))]))])
const _1463=_o4(_537,_691)
const _1464=_o12(_988,_1463,_1107)
const _1465=_o8(_536,_691,_1463)
const _1466=_o4(_537,_77)
const _1467=_o12(_988,_1466,_992)
const _1468=_o3(_3,"forceRefetch")
const _1469=_o4(_537,_1468)
const _1470=[_1467,_o12(_988,_1469,_1018)]
const _1471=_o3(_3,"crossSiteLinkPreview")
const _1472=_o8(_536,_77,_1466)
const _1473=_o8(_536,_1468,_1469)
const _1474=_o3(_3,"includeDebug")
const _1475=_o4(_8,_o3(_3,"imageWidth"))
const _1476=_o4(_8,_o3(_3,"imageHeight"))
const _1477=_o4(_8,_o3(_3,"fetchedAt"))
const _1478=_o4(_8,_o3(_3,"nextRefreshAt"))
const _1479=_o3(_3,"allowNull")
const _1480=_o4(_537,_1479)
const _1481=[_1088,_o12(_988,_1480,_1018)]
const _1482=[_o8(_536,_1000,_o14(_1001,[_1005,_o8(_1002,_1479,_1480)]))]
const _1483=_o4(_537,_o3(_3,"arbitalSlug"))
const _1484=_o5(_7,[_o4(_25,_416)])
const _1485=_o5(_7,[_o7(_8,_1377,_1118,_o5(_7,[_o6(_8,_1025,_1484),_796]))])
const _1486=_o6(_8,_1025,_683)
const _1487=_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_1486,_796]))])
const _1488=_o5(_7,[_o6(_8,_266,_1484)])
const _1489=[_1006,_o8(_536,_1479,_1081)]
const _1490=_o5(_7,[_o6(_8,_1008,_1484)])
const _1491=_o5(_7,[_o4(_25,_935)])
const _1492=_o5(_7,[_o7(_8,_30,_1007,_o5(_7,[_o6(_8,_1008,_1491)]))])
const _1493=[_o12(_988,_1056,_o4(_5,_o3(_3,"MessageSelector"))),_1051,_1116]
const _1494=_o5(_7,[_o7(_8,_409,_1118,_o5(_7,[_o6(_8,_1025,_374),_796]))])
const _1495=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateConversationDataInput"))))]
const _1496=_o5(_7,[_377])
const _1497=_o5(_7,[_o7(_8,_o3(_3,"updateConversation"),_1142,_o5(_7,[_o6(_8,_266,_1496)]))])
const _1498=_o3(_3,"conversation")
const _1499=[_o12(_988,_1056,_o4(_5,_o3(_3,"ConversationSelector"))),_1051,_1116]
const _1500=_o3(_3,"conversations")
const _1501=_o5(_7,[_o4(_25,_376)])
const _1502=_o3(_3,"GetUserBySlug")
const _1503=_o8(_536,_11,_1067)
const _1504=[_1503]
const _1505=_o5(_7,[_o7(_8,_1502,_1504,_67)])
const _1506=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateModerationTemplateDataInput"))))]
const _1507=_o5(_7,[_o6(_8,_266,_1341)])
const _1508=_o5(_7,[_o7(_8,_o3(_3,"updateModerationTemplate"),_1142,_1507)])
const _1509=_o3(_3,"notificationIds")
const _1510=_o4(_537,_1509)
const _1511=_o5(_7,[_o7(_8,_30,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_860)]))]))])
const _1512=_o5(_7,[_o7(_8,_535,_1007,_o5(_7,[_o6(_8,_1008,_962)]))])
const _1513=_o3(_3,"suggestionId")
const _1514=_o4(_537,_1513)
const _1515=_o5(_7,[_o4(_25,_844)])
const _1516=_o12(_988,_1514,_992)
const _1517=_o3(_3,"mode")
const _1518=_o4(_537,_1517)
const _1519=_o8(_536,_1513,_1514)
const _1520=_o5(_7,[_o7(_8,_1196,_1142,_o5(_7,[_o6(_8,_266,_1491)]))])
const _1521=_o3(_3,"getClaudeAccessLink")
const _1522=_o3(_3,"fileUrl")
const _1523=_o4(_537,_1522)
const _1524=_o4(_537,_385)
const _1525=_o12(_988,_1524,_992)
const _1526=_o8(_536,_385,_1524)
const _1527=_o3(_3,"importUrlAsDraftPost")
const _1528=_o5(_7,[_o7(_8,_210,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_544)]))]))])
const _1529=[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreatePostDataInput"))))]
const _1530=_o3(_3,"createPost")
const _1531=_o5(_7,[_o7(_8,_1530,_1145,_1349)])
const _1532=_o5(_7,[_o4(_25,_600)])
const _1533=_o5(_7,[_o6(_8,_266,_1532)])
const _1534=_o5(_7,[_o4(_25,_847)])
const _1535=_o5(_7,[_o6(_8,_266,_1534)])
const _1536=_o5(_7,[_o7(_8,_555,_1118,_o5(_7,[_o6(_8,_1025,_1287),_796]))])
const _1537=_o12(_988,_561,_991)
const _1538=[_1088,_1537]
const _1539=_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_587)]))])
const _1540=_o3(_3,"dialogueId")
const _1541=_o4(_537,_1540)
const _1542=_o4(_537,_o3(_3,"unreadCount"))
const _1543=[_1088,_1230]
const _1544=_o5(_7,[_o7(_8,_210,_1007,_1232)])
const _1545=[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateSplashArtCoordinateDataInput"))))]
const _1546=_o3(_3,"createSplashArtCoordinate")
const _1547=_o5(_7,[_o7(_8,_1546,_1145,_o5(_7,[_o6(_8,_266,_482)]))])
const _1548=_o4(_537,_470)
const _1549=[_o12(_988,_1548,_992)]
const _1550=[_o8(_536,_470,_1548)]
const _1551=_o5(_7,[_o7(_8,_871,_1118,_o5(_7,[_o6(_8,_1025,_1211),_796]))])
const _1552=_o3(_3,"flipSplashArtImage")
const _1553=[_o12(_988,_1056,_o4(_5,_o3(_3,"ReviewWinnerArtSelector"))),_1051,_1116]
const _1554=_o5(_7,[_o7(_8,_o3(_3,"reviewWinnerArts"),_1118,_o5(_7,[_o6(_8,_1025,_572),_796]))])
const _1555=_o4(_537,_122)
const _1556=_o12(_988,_1555,_991)
const _1557=_o4(_537,_389)
const _1558=_o12(_988,_1557,_991)
const _1559=_o3(_3,"private")
const _1560=_o4(_537,_1559)
const _1561=_o3(_3,"response")
const _1562=_o4(_537,_1561)
const _1563=_o8(_536,_122,_1555)
const _1564=_o8(_536,_389,_1557)
const _1565=_o3(_3,"CancelRSVPToEvent")
const _1566=[_1051,_1297]
const _1567=[_1054,_1298]
const _1568=_o5(_7,[_o6(_8,_1025,_o5(_7,[_213,_o4(_8,_o3(_3,"scenario")),_o4(_8,_o3(_3,"recommId")),_o4(_8,_o3(_3,"generatedAt")),_o4(_8,_1034),_o4(_8,_o3(_3,"stickied"))]))])
const _1569=_o12(_988,_538,_991)
const _1570=_o3(_3,"CuratedAndPopularThisWeek")
const _1571=_o3(_3,"observeRecommendation")
const _1572=_o3(_3,"clickRecommendation")
const _1573=_o3(_3,"dismissRecommendation")
const _1574=_o3(_3,"count")
const _1575=_o4(_537,_1574)
const _1576=_o3(_3,"algorithm")
const _1577=_o4(_537,_1576)
const _1578=[_o12(_988,_1575,_1012),_o12(_988,_1577,_1286)]
const _1579=_o5(_7,[_o7(_8,_o3(_3,"Recommendations"),[_o8(_536,_1574,_1575),_o8(_536,_1576,_1577)],_o5(_7,[_o4(_25,_489)]))])
const _1580=_o3(_3,"withConversation")
const _1581=_o4(_537,_1580)
const _1582=_o5(_7,[_10,_334,_o4(_8,_o3(_3,"sourceEventId")),_47])
const _1583=_o3(_3,"researchConversation")
const _1584=[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_9,_1414)]))]
const _1585=_o5(_7,[_o6(_8,_1008,_228)])
const _1586=_o3(_3,"promptHtml")
const _1587=_o4(_537,_1586)
const _1588=_o12(_988,_1587,_992)
const _1589=_o3(_3,"activeDocumentId")
const _1590=_o4(_537,_1589)
const _1591=_o12(_988,_1590,_992)
const _1592=[_1415,_1588,_1591]
const _1593=_o5(_7,[_370])
const _1594=_o5(_7,[_o7(_8,_o3(_3,"continueResearchConversation"),[_1417,_o8(_536,_1586,_1587),_o8(_536,_1589,_1590)],_1593)])
const _1595=_o5(_7,[_o7(_8,_o3(_3,"cancelResearchConversation"),_1418,_1593)])
const _1596=_o3(_3,"projectId")
const _1597=_o4(_537,_1596)
const _1598=_o12(_988,_1597,_992)
const _1599=_o3(_3,"baseEnvironmentId")
const _1600=_o4(_537,_1599)
const _1601=_o3(_3,"runtime")
const _1602=_o4(_537,_1601)
const _1603=_o8(_1002,_1596,_1597)
const _1604=_o3(_3,"kind")
const _1605=[_1598]
const _1606=_o3(_3,"researchDocuments")
const _1607=_o14(_1001,[_1603])
const _1608=_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"byProject"),_1607)]))
const _1609=_o8(_536,_793,_o3(_1035,"200"))
const _1610=[_1608,_1609]
const _1611=_o4(_537,_13)
const _1612=_o12(_988,_1611,_991)
const _1613=_o8(_1002,_13,_1611)
const _1614=_o5(_7,[_10,_14,_47])
const _1615=[_1064,_1612]
const _1616=_o3(_3,"updateResearchDocument")
const _1617=[_1066,_o8(_536,_266,_o14(_1001,[_1613]))]
const _1618=_o5(_7,[_o6(_8,_266,_228)])
const _1619=_o3(_3,"updateResearchConversation")
const _1620=_o3(_3,"icon")
const _1621=_o4(_537,_1620)
const _1622=[_1064,_o12(_988,_1621,_991)]
const _1623=[_1066,_o8(_536,_266,_o14(_1001,[_o8(_1002,_1620,_1621)]))]
const _1624=_o4(_8,_1620)
const _1625=_o5(_7,[_o6(_8,_266,_o5(_7,[_10,_1624]))])
const _1626=_o3(_3,"orderedIds")
const _1627=_o4(_537,_1626)
const _1628=_o8(_536,_1596,_1597)
const _1629=_o4(_8,_o3(_3,"success"))
const _1630=_o5(_7,[_1629])
const _1631=_o4(_537,_333)
const _1632=_o3(_3,"updateResearchEnvironment")
const _1633=_o3(_3,"archived")
const _1634=_o4(_537,_1633)
const _1635=[_1064,_o12(_988,_1634,_1019)]
const _1636=[_1066,_o8(_536,_266,_o14(_1001,[_o8(_1002,_1633,_1634)]))]
const _1637=_o5(_7,[_o6(_8,_266,_o5(_7,[_10,_o4(_8,_1633)]))])
const _1638=[_1628]
const _1639=_o4(_8,_o3(_3,"lastActivityAt"))
const _1640=_o5(_7,[_10,_14,_687,_47])
const _1641=[_1076]
const _1642=_o4(_537,_154)
const _1643=_o4(_537,_1094)
const _1644=_o8(_536,_1094,_1643)
const _1645=[_1644]
const _1646=_o3(_3,"toolUseId")
const _1647=_o4(_537,_1646)
const _1648=_o3(_3,"answersJson")
const _1649=_o4(_537,_1648)
const _1650=_o3(_3,"path")
const _1651=_o4(_537,_1650)
const _1652=[_1417,_o8(_536,_1650,_1651)]
const _1653=_o4(_8,_1650)
const _1654=_o4(_8,_o3(_3,"running"))
const _1655=_o4(_8,_1604)
const _1656=_o4(_8,_o3(_3,"size"))
const _1657=_o3(_3,"before")
const _1658=_o4(_537,_1657)
const _1659=_o8(_536,_1657,_1658)
const _1660=_o3(_3,"researchConversations")
const _1661=[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"byProjectArchived"),_1607)])),_1609]
const _1662=_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_14,_1624,_1639,_o4(_8,_o3(_3,"entrypointKind")),_o4(_8,_o3(_3,"entrypointDocumentId"))]))])
const _1663=_o3(_3,"researchEnvironments")
const _1664=_o5(_7,[_o6(_8,_1025,_1582)])
const _1665=_o3(_3,"GetAllReviewWinners")
const _1666=_o5(_7,[_o6(_8,_1665,_o5(_7,[_o4(_25,_485)]))])
const _1667=_o3(_3,"prompt")
const _1668=_o4(_537,_1667)
const _1669=_o5(_7,[_o4(_25,_511)])
const _1670=_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_o6(_8,_1025,_1669),_796]))])
const _1671=[_o12(_988,_1056,_o4(_5,_o3(_3,"ReviewVoteSelector"))),_1051,_1116]
const _1672=_o5(_7,[_o7(_8,_1398,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_689)])),_796]))])
const _1673=_o3(_3,"electionName")
const _1674=_o4(_537,_1673)
const _1675=_o12(_988,_1674,_992)
const _1676=[_1675]
const _1677=_o8(_536,_1673,_1674)
const _1678=[_1677]
const _1679=_o3(_3,"x")
const _1680=_o3(_3,"y")
const _1681=_o3(_3,"theta")
const _1682=_o5(_7,[_20,_31,_o4(_8,_1679),_o4(_8,_1680),_o4(_8,_1681)])
const _1683=_o3(_3,"AddGivingSeasonHeart")
const _1684=_o4(_537,_1679)
const _1685=_o13(_990,_1015)
const _1686=_o4(_537,_1680)
const _1687=_o4(_537,_1681)
const _1688=_o3(_3,"RemoveGivingSeasonHeart")
const _1689=_o3(_3,"submitReviewVote")
const _1690=_o4(_537,_512)
const _1691=_o3(_3,"quadraticChange")
const _1692=_o4(_537,_1691)
const _1693=_o3(_3,"newQuadraticScore")
const _1694=_o4(_537,_1693)
const _1695=_o4(_537,_221)
const _1696=_o4(_537,_693)
const _1697=_o5(_7,[_o6(_8,_1008,_979)])
const _1698=_o3(_3,"RevisionsDiff")
const _1699=_o3(_3,"beforeRev")
const _1700=_o4(_537,_1699)
const _1701=_o3(_3,"afterRev")
const _1702=_o4(_537,_1701)
const _1703=_o3(_3,"trim")
const _1704=_o4(_537,_1703)
const _1705=_o3(_3,"launchCode")
const _1706=_o4(_537,_1705)
const _1707=[_o12(_988,_1056,_o4(_5,_o3(_3,"PetrovDayActionSelector"))),_1051,_1116]
const _1708=_o5(_7,[_o4(_25,_457)])
const _1709=_o5(_7,[_o7(_8,_o3(_3,"petrovDayActions"),_1118,_o5(_7,[_o6(_8,_1025,_1708),_796]))])
const _1710=[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreatePetrovDayActionDataInput"))))]
const _1711=_o5(_7,[_o7(_8,_o3(_3,"createPetrovDayAction"),_1145,_o5(_7,[_o6(_8,_266,_1708)]))])
const _1712=_o3(_3,"petrov2024checkIfNuked")
const _1713=_o4(_537,_106)
const _1714=[_o12(_988,_1713,_992)]
const _1715=[_o8(_536,_106,_1713)]
const _1716=_o6(_8,_250,_683)
const _1717=_o4(_537,_o3(_3,"draftsSelector"))
const _1718=_o4(_537,_o3(_3,"publishedSelector"))
const _1719=_o8(_536,_1114,_1022)
const _1720=_o5(_7,[_1486])
const _1721=_o12(_988,_1056,_o4(_5,_o3(_3,"ChapterSelector")))
const _1722=[_1060,_1054,_1719]
const _1723=_o5(_7,[_o4(_25,_278)])
const _1724=_o5(_7,[_o4(_25,_749)])
const _1725=_o5(_7,[_o6(_8,_266,_1723)])
const _1726=_o3(_3,"chapterId")
const _1727=_o4(_537,_1726)
const _1728=_o3(_3,"fromChapterId")
const _1729=_o4(_537,_1728)
const _1730=_o3(_3,"toChapterId")
const _1731=_o4(_537,_1730)
const _1732=_o3(_3,"toIndex")
const _1733=_o4(_537,_1732)
const _1734=_o5(_7,[_o6(_8,_266,_297)])
const _1735=_o3(_3,"bookId")
const _1736=_o4(_537,_1735)
const _1737=[_1721,_1051,_1116]
const _1738=_o5(_7,[_o7(_8,_254,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_279])),_796]))])
const _1739=_o5(_7,[_300])
const _1740=_o12(_988,_561,_992)
const _1741=_o5(_7,[_o6(_8,_266,_566)])
const _1742=_o3(_3,"updateContinueReading")
const _1743=_o3(_3,"spotlightId")
const _1744=_o4(_537,_1743)
const _1745=[_o12(_988,_1744,_991)]
const _1746=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateSpotlightDataInput"))))]
const _1747=_o3(_3,"updateSpotlight")
const _1748=_o5(_7,[_o4(_25,_757)])
const _1749=_o5(_7,[_o6(_8,_266,_1748)])
const _1750=[_o12(_988,_1056,_o4(_5,_o3(_3,"SpotlightSelector"))),_1051,_1116]
const _1751=_o5(_7,[_o7(_8,_o3(_3,"spotlights"),_1118,_o5(_7,[_o6(_8,_1025,_979),_796]))])
const _1752=_o3(_3,"publishAndDeDuplicateSpotlight")
const _1753=_o3(_3,"SuggestedFeedSubscriptionUsers")
const _1754=_o5(_7,[_o4(_25,_654)])
const _1755=_o5(_7,[_o7(_8,_1147,_1142,_o5(_7,[_o6(_8,_266,_1754)]))])
const _1756=_o5(_7,[_o7(_8,_1196,_1142,_o5(_7,[_o6(_8,_266,_686)]))])
const _1757=_o12(_988,_1087,_o13(_990,_o4(_5,_o3(_3,"ContentCollectionName"))))
const _1758=[_997,_1757]
const _1759=[_1092,_1091]
const _1760=_o5(_7,[_o4(_25,_879)])
const _1761=_o3(_3,"ipAddress")
const _1762=_o4(_537,_1761)
const _1763=_o3(_3,"createModeratorAction")
const _1764=[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateModeratorActionDataInput"))))]
const _1765=_o5(_7,[_o6(_8,_266,_635)])
const _1766=_o5(_7,[_o7(_8,_1763,_1145,_1765)])
const _1767=_o6(_8,_1025,_686)
const _1768=_o5(_7,[_o7(_8,_288,_1118,_o5(_7,[_1767,_796]))])
const _1769=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateModeratorActionDataInput"))))]
const _1770=_o3(_3,"updateModeratorAction")
const _1771=_o5(_7,[_o7(_8,_1770,_1142,_1765)])
const _1772=_o5(_7,[_o4(_25,_682)])
const _1773=_o5(_7,[_o6(_8,_266,_1772)])
const _1774=_o5(_7,[_o4(_25,_526)])
const _1775=[_1122,_1051]
const _1776=_o5(_7,[_o7(_8,_1763,_1145,_1741)])
const _1777=[_o12(_988,_1056,_o4(_5,_o3(_3,"TagRelSelector"))),_1051,_1116]
const _1778=_o5(_7,[_o7(_8,_637,_1118,_o5(_7,[_o6(_8,_1025,_962),_796]))])
const _1779=_o5(_7,[_o4(_25,_827)])
const _1780=_o5(_7,[_o7(_8,_191,_1118,_o5(_7,[_o6(_8,_1025,_1779),_796]))])
const _1781=_o5(_7,[_o6(_8,_1008,_686)])
const _1782=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateUserRateLimitDataInput"))))]
const _1783=_o3(_3,"updateUserRateLimit")
const _1784=_o5(_7,[_o6(_8,_266,_o5(_7,[_o4(_25,_849)]))])
const _1785=_o5(_7,[_o6(_8,_266,_680)])
const _1786=[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateUserRateLimitDataInput"))))]
const _1787=_o3(_3,"createUserRateLimit")
const _1788=_o4(_537,_o3(_3,"userSelector"))
const _1789=_o4(_537,_o3(_3,"postSelector"))
const _1790=_o4(_537,_o3(_3,"classifiedPostSelector"))
const _1791=_o4(_537,_o3(_3,"userLimit"))
const _1792=_o4(_537,_o3(_3,"reviewQueueLimit"))
const _1793=_o4(_537,_o3(_3,"postLimit"))
const _1794=_o4(_537,_o3(_3,"curationLimit"))
const _1795=_o8(_536,_1003,_1788)
const _1796=_o8(_536,_793,_1793)
const _1797=_o8(_536,_1114,_1081)
const _1798=[_1569,_1176]
const _1799=_o3(_3,"addOrUpvoteTag")
const _1800=[_539,_853]
const _1801=_o5(_7,[_o7(_8,_1799,_1800,_638)])
const _1802=_o3(_3,"extendedVote")
const _1803=_o4(_537,_1802)
const _1804=[_1088,_1254,_o12(_988,_1803,_1286)]
const _1805=_o3(_3,"performVoteTagRel")
const _1806=[_1092,_1257,_o8(_536,_1802,_1803)]
const _1807=_o6(_8,_1260,_540)
const _1808=_o4(_537,_182)
const _1809=_o12(_988,_1808,_992)
const _1810=_o3(_3,"messageContent")
const _1811=_o4(_537,_1810)
const _1812=_o3(_3,"rejectContentAndRemoveUserFromQueue")
const _1813=_o8(_536,_182,_1808)
const _1814=[_1110]
const _1815=_o5(_7,[_o6(_8,_266,_o5(_7,[_10,_265,_20,_283]))])
const _1816=_o6(_8,_1025,_169)
const _1817=_o3(_3,"slugs")
const _1818=_o4(_537,_1817)
const _1819=_o5(_7,[_o4(_25,_831)])
const _1820=_o5(_7,[_o6(_8,_1008,_169)])
const _1821=_o5(_7,[_o7(_8,_165,_1007,_1820)])
const _1822=_o5(_7,[_o7(_8,_191,_1118,_o5(_7,[_o6(_8,_1025,_1227),_796]))])
const _1823=_o5(_7,[_o7(_8,_165,_1007,_1234)])
const _1824=_o3(_3,"reorderSummaries")
const _1825=_o4(_537,_441)
const _1826=_o3(_3,"parentDocumentCollectionName")
const _1827=_o4(_537,_1826)
const _1828=_o3(_3,"summaryIds")
const _1829=_o4(_537,_1828)
const _1830=[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateMultiDocumentDataInput"))))]
const _1831=_o3(_3,"updateMultiDocument")
const _1832=_o5(_7,[_o6(_8,_266,_718)])
const _1833=[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateMultiDocumentDataInput"))))]
const _1834=_o3(_3,"createMultiDocument")
const _1835=_o13(_990,_1271)
const _1836=_o3(_3,"after")
const _1837=_o4(_537,_1836)
const _1838=_o5(_7,[_o6(_8,_266,_783)])
const _1839=_o3(_3,"tagFlag")
const _1840=_o3(_3,"mergeTags")
const _1841=_o3(_3,"sourceTagId")
const _1842=_o4(_537,_1841)
const _1843=_o3(_3,"targetTagId")
const _1844=_o4(_537,_1843)
const _1845=_o3(_3,"transferSubtags")
const _1846=_o4(_537,_1845)
const _1847=_o3(_3,"redirectSource")
const _1848=_o4(_537,_1847)
const _1849=_o3(_3,"promoteLensToMain")
const _1850=_o3(_3,"lensId")
const _1851=_o4(_537,_1850)
const _1852=_o4(_537,_832)
const _1853=_o3(_3,"searchTagIds")
const _1854=_o4(_537,_1853)
const _1855=_o5(_7,[_o6(_8,_266,_o5(_7,[_728]))])
const _1856=[_1405,_1051]
const _1857=_o6(_8,_1025,_1222)
const _1858=[_1405,_1051,_1367]
const _1859=[_1405,_1051,_1230,_1367]
const _1860=[_1068,_1265]
const _1861=_o3(_3,"TagPreview")
const _1862=[_1503,_645]
const _1863=_o6(_8,_733,_718)
const _1864=_o5(_7,[_o4(_25,_778)])
const _1865=_o5(_7,[_o6(_8,_1008,_o5(_7,[_232]))])
const _1866=[_o8(_536,_1000,_o14(_1001,[_o8(_1002,_1003,_1214)]))]
const _1867=_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_507)]))])
const _1868=_o3(_3,"createUltraFeedEvent")
const _1869=_o3(_3,"updateUltraFeedEvent")
const _1870=_o3(_3,"connectCrossposter")
const _1871=_o12(_988,_1643,_991)
const _1872=[_1871]
const _1873=_o3(_3,"useEmailToken")
const _1874=_o3(_3,"sendEventTriggeredDM")
const _1875=_o3(_3,"AirtableLeaderboards")
const _1876=_o3(_3,"days")
const _1877=_o4(_537,_1876)
const _1878=_o3(_3,"login")
const _1879=_o4(_537,_48)
const _1880=_o12(_988,_1879,_991)
const _1881=_o3(_3,"password")
const _1882=_o4(_537,_1881)
const _1883=_o12(_988,_1882,_991)
const _1884=_o8(_536,_48,_1879)
const _1885=_o8(_536,_1881,_1882)
const _1886=_o3(_3,"signup")
const _1887=_o3(_3,"subscribeToCurated")
const _1888=_o4(_537,_1887)
const _1889=_o3(_3,"reCaptchaToken")
const _1890=_o4(_537,_1889)
const _1891=_o4(_537,_930)
const _1892=_o3(_3,"resetPassword")
const _1893=_o3(_3,"args")
const _1894=_o4(_537,_1893)
const _1895=_o4(_537,_1080)
const _1896=_o4(_537,_173)
const _1897=_o3(_3,"UsersSearchForMerge")
const _1898=_o3(_3,"MergeAccounts")
const _1899=_o4(_537,_665)
const _1900=_o3(_3,"targetUserId")
const _1901=_o4(_537,_1900)
const _1902=_o3(_3,"dryRun")
const _1903=_o4(_537,_1902)
const _1904=_o3(_3,"SoftDeleteUser")
const _1905=_o5(_7,[_o7(_8,_1502,_1504,_1491)])
const _1906=_o3(_3,"performVoteRevision")
const _1907=_o3(_3,"performVoteTag")
const _1908=_o3(_3,"performVoteMultiDocument")
const _1909=_o3(_3,"performVoteMessage")
const _1910=_o5(_7,[_o7(_8,_210,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_578]))]))])
const _1911=_o3(_3,"Lightcone2024FundraiserStripeAmounts")
const _1912=_o3(_3,"Lightcone2025FundraiserAirtableAmounts")
const _1913=[_o12(_988,_1154,_o4(_5,_o3(_3,"MultiPostInput")))]
const _1914=[_o12(_988,_1154,_o4(_5,_o3(_3,"MultiCommentInput")))]
const _1915=_o4(_537,_874)
const _1916=_o12(_988,_1154,_o4(_5,_o3(_3,"SinglePostInput")))
const _1917=[_1916]
const _1918=_o5(_7,[_10,_14,_346])
/* eslint-disable */
// @ts-nocheck
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ContentTypeData: { input: any; output: any; }
  Date: { input: Date; output: string; }
  JSON: { input: any; output: any; }
};

export type AdminEmailAudienceFilterInput = {
  excludeDeleted: Scalars['Boolean']['input'];
  excludeUnsubscribed: Scalars['Boolean']['input'];
  includeUnknownRisk: Scalars['Boolean']['input'];
  maxMailgunRisk?: InputMaybe<MailgunRiskLevel>;
  onlyAdmins: Scalars['Boolean']['input'];
  requireMailgunValid: Scalars['Boolean']['input'];
  verifiedEmailOnly: Scalars['Boolean']['input'];
};

export type AdminEmailAudiencePreview = {
  __typename?: 'AdminEmailAudiencePreview';
  sample: Array<AdminEmailAudienceRow>;
  totalCount: Scalars['Int']['output'];
};

export type AdminEmailAudienceRow = {
  __typename?: 'AdminEmailAudienceRow';
  email: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AdminEmailPreviewAudienceInput = {
  filter: AdminEmailAudienceFilterInput;
};

export type AdminHomePageDesign = {
  __typename?: 'AdminHomePageDesign';
  _id: Scalars['String']['output'];
  autoReviewMessage: Maybe<Scalars['String']['output']>;
  autoReviewPassed: Maybe<Scalars['Boolean']['output']>;
  commentId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  html: Scalars['String']['output'];
  modelName: Maybe<Scalars['String']['output']>;
  ownerDisplayName: Scalars['String']['output'];
  ownerSlug: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type AdminSendBulkEmailError = {
  __typename?: 'AdminSendBulkEmailError';
  batch: Scalars['Int']['output'];
  status: Maybe<Scalars['Int']['output']>;
};

export type AdminSendBulkEmailInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  filter: AdminEmailAudienceFilterInput;
  from?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  maxRecipients?: InputMaybe<Scalars['Int']['input']>;
  runId?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type AdminSendBulkEmailResult = {
  __typename?: 'AdminSendBulkEmailResult';
  batches: Scalars['Int']['output'];
  errors: Array<AdminSendBulkEmailError>;
  lastAfterUserId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  processed: Scalars['Int']['output'];
  runId: Scalars['String']['output'];
};

export type AdminSendTestEmailInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AdminSendTestEmailResult = {
  __typename?: 'AdminSendTestEmailResult';
  email: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  status: Maybe<Scalars['Int']['output']>;
  unsubscribeUrl: Scalars['String']['output'];
};

export type AirtableLeaderboardResult = {
  __typename?: 'AirtableLeaderboardResult';
  leaderboardAmount: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type AllTagsActivityFeedEntry = {
  __typename?: 'AllTagsActivityFeedEntry';
  tagCreated: Maybe<Tag>;
  tagDiscussionComment: Maybe<Comment>;
  tagRevision: Maybe<Revision>;
  type: AllTagsActivityFeedEntryType;
};

export type AllTagsActivityFeedEntryType =
  | 'tagCreated'
  | 'tagDiscussionComment'
  | 'tagRevision';

export type AllTagsActivityFeedQueryResults = {
  __typename?: 'AllTagsActivityFeedQueryResults';
  cutoff: Maybe<Scalars['Date']['output']>;
  endOffset: Scalars['Int']['output'];
  results: Maybe<Array<AllTagsActivityFeedEntry>>;
};

export type AnalyticsSeriesValue = {
  __typename?: 'AnalyticsSeriesValue';
  comments: Maybe<Scalars['Int']['output']>;
  date: Maybe<Scalars['Date']['output']>;
  karma: Maybe<Scalars['Int']['output']>;
  reads: Maybe<Scalars['Int']['output']>;
  views: Maybe<Scalars['Int']['output']>;
};

export type AnswerResearchQuestionOutput = {
  __typename?: 'AnswerResearchQuestionOutput';
  expired: Scalars['Boolean']['output'];
  ok: Scalars['Boolean']['output'];
};

export type ArbitalCaches = {
  __typename?: 'ArbitalCaches';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
};

export type ArbitalLinkedPage = {
  __typename?: 'ArbitalLinkedPage';
  _id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ArbitalLinkedPages = {
  __typename?: 'ArbitalLinkedPages';
  children: Array<ArbitalLinkedPage>;
  faster: Array<ArbitalLinkedPage>;
  lessTechnical: Array<ArbitalLinkedPage>;
  moreTechnical: Array<ArbitalLinkedPage>;
  parents: Array<ArbitalLinkedPage>;
  requirements: Array<ArbitalLinkedPage>;
  slower: Array<ArbitalLinkedPage>;
  teaches: Array<ArbitalLinkedPage>;
};

export type ArbitalPageData = {
  __typename?: 'ArbitalPageData';
  html: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type ArbitalTagContentRel = {
  __typename?: 'ArbitalTagContentRel';
  _id: Scalars['String']['output'];
  childCollectionName: Scalars['String']['output'];
  childDocumentId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  isStrong: Scalars['Boolean']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  level: Scalars['Float']['output'];
  parentCollectionName: Scalars['String']['output'];
  parentDocumentId: Scalars['String']['output'];
  schemaVersion: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type ArbitalTagContentRelSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type AutomatedContentEvaluation = {
  __typename?: 'AutomatedContentEvaluation';
  _id: Scalars['String']['output'];
  aiChoice: Maybe<Scalars['String']['output']>;
  aiCoT: Maybe<Scalars['String']['output']>;
  aiReasoning: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  pangramApiVersion: Maybe<Scalars['String']['output']>;
  pangramFractionAi: Maybe<Scalars['Float']['output']>;
  pangramFractionAiAssisted: Maybe<Scalars['Float']['output']>;
  pangramFractionHuman: Maybe<Scalars['Float']['output']>;
  pangramMaxScore: Maybe<Scalars['Float']['output']>;
  pangramPrediction: Maybe<Scalars['String']['output']>;
  pangramScore: Maybe<Scalars['Float']['output']>;
  pangramWindowScores: Maybe<Array<PangramWindowScore>>;
  revisionId: Scalars['String']['output'];
  score: Maybe<Scalars['Float']['output']>;
  sentenceScores: Maybe<Array<SentenceScore>>;
};

export type Ban = {
  __typename?: 'Ban';
  _id: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  expirationDate: Maybe<Scalars['Date']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  properties: Maybe<Scalars['JSON']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type BanSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type Book = {
  __typename?: 'Book';
  _id: Scalars['String']['output'];
  collectionId: Scalars['String']['output'];
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  displaySequencesAsGrid: Maybe<Scalars['Boolean']['output']>;
  hideProgressBar: Maybe<Scalars['Boolean']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  number: Maybe<Scalars['Float']['output']>;
  postIds: Array<Scalars['String']['output']>;
  postedAt: Maybe<Scalars['Date']['output']>;
  posts: Array<Post>;
  schemaVersion: Scalars['Float']['output'];
  sequenceIds: Array<Scalars['String']['output']>;
  sequences: Array<Sequence>;
  showChapters: Maybe<Scalars['Boolean']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  tocTitle: Maybe<Scalars['String']['output']>;
};


export type BookcontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type BookOutput = {
  __typename?: 'BookOutput';
  data: Maybe<Book>;
};

export type BookSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type Bookmark = {
  __typename?: 'Bookmark';
  _id: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  collectionName: Scalars['String']['output'];
  comment: Maybe<Comment>;
  createdAt: Scalars['Date']['output'];
  documentId: Scalars['String']['output'];
  lastUpdated: Scalars['Date']['output'];
  post: Maybe<Post>;
  userId: Scalars['String']['output'];
};

export type BookmarkSelector = {
  myBookmarkedPosts?: InputMaybe<EmptyViewInput>;
  myBookmarks?: InputMaybe<EmptyViewInput>;
  userDocumentBookmark?: InputMaybe<BookmarksUserDocumentBookmarkInput>;
};

export type BookmarksUserDocumentBookmarkInput = {
  collectionName?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Chapter = {
  __typename?: 'Chapter';
  _id: Scalars['String']['output'];
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  number: Maybe<Scalars['Float']['output']>;
  postIds: Array<Scalars['String']['output']>;
  posts: Array<Post>;
  schemaVersion: Scalars['Float']['output'];
  sequence: Maybe<Sequence>;
  sequenceId: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};


export type ChaptercontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type ChapterOutput = {
  __typename?: 'ChapterOutput';
  data: Maybe<Chapter>;
};

export type ChapterSelector = {
  SequenceChapters?: InputMaybe<ChaptersSequenceChaptersInput>;
  default?: InputMaybe<EmptyViewInput>;
};

export type ChaptersSequenceChaptersInput = {
  limit?: InputMaybe<Scalars['String']['input']>;
  sequenceId?: InputMaybe<Scalars['String']['input']>;
};

export type CkEditorUserSession = {
  __typename?: 'CkEditorUserSession';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  documentId: Maybe<Scalars['String']['output']>;
  endedAt: Maybe<Scalars['Date']['output']>;
  endedBy: Maybe<Scalars['String']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  userId: Maybe<Scalars['String']['output']>;
};

export type CkEditorUserSessionSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type ClientId = {
  __typename?: 'ClientId';
  _id: Scalars['String']['output'];
  clientId: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  firstSeenLandingPage: Maybe<Scalars['String']['output']>;
  firstSeenReferrer: Maybe<Scalars['String']['output']>;
  invalidated: Maybe<Scalars['Boolean']['output']>;
  lastSeenAt: Maybe<Scalars['Date']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  timesSeen: Maybe<Scalars['Float']['output']>;
  userIds: Maybe<Array<Scalars['String']['output']>>;
  users: Maybe<Array<User>>;
};

export type ClientIdSelector = {
  default?: InputMaybe<EmptyViewInput>;
  getClientId?: InputMaybe<ClientIdsGetClientIdInput>;
};

export type ClientIdsGetClientIdInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};

export type CoauthorStatusInput = {
  confirmed: Scalars['Boolean']['input'];
  requested: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type CoauthorStatusOutput = {
  __typename?: 'CoauthorStatusOutput';
  confirmed: Scalars['Boolean']['output'];
  requested: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type Collection = {
  __typename?: 'Collection';
  _id: Scalars['String']['output'];
  books: Array<Book>;
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  firstPageLink: Scalars['String']['output'];
  gridImageId: Maybe<Scalars['String']['output']>;
  hideStartReadingButton: Maybe<Scalars['Boolean']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  noindex: Scalars['Boolean']['output'];
  postsCount: Scalars['Int']['output'];
  readPostsCount: Scalars['Int']['output'];
  schemaVersion: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
};


export type CollectioncontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionDefaultViewInput = {
  collectionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CollectionOutput = {
  __typename?: 'CollectionOutput';
  data: Maybe<Collection>;
};

export type CollectionSelector = {
  default?: InputMaybe<CollectionDefaultViewInput>;
};

export type Comment = {
  __typename?: 'Comment';
  _id: Scalars['String']['output'];
  af: Scalars['Boolean']['output'];
  afBaseScore: Maybe<Scalars['Float']['output']>;
  afDate: Maybe<Scalars['Date']['output']>;
  afExtendedScore: Maybe<Scalars['JSON']['output']>;
  afVoteCount: Maybe<Scalars['Float']['output']>;
  agentFoundationsId: Maybe<Scalars['String']['output']>;
  allVotes: Maybe<Array<Vote>>;
  answer: Scalars['Boolean']['output'];
  author: Maybe<Scalars['String']['output']>;
  authorIsUnreviewed: Scalars['Boolean']['output'];
  automatedContentEvaluations: Maybe<AutomatedContentEvaluation>;
  baseScore: Maybe<Scalars['Float']['output']>;
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  currentUserExtendedVote: Maybe<Scalars['JSON']['output']>;
  currentUserVote: Maybe<Scalars['String']['output']>;
  debateResponse: Maybe<Scalars['Boolean']['output']>;
  deleted: Scalars['Boolean']['output'];
  deletedByUser: Maybe<User>;
  deletedByUserId: Maybe<Scalars['String']['output']>;
  deletedDate: Maybe<Scalars['Date']['output']>;
  deletedPublic: Scalars['Boolean']['output'];
  deletedReason: Maybe<Scalars['String']['output']>;
  descendentCount: Scalars['Float']['output'];
  directChildrenCount: Scalars['Float']['output'];
  draft: Scalars['Boolean']['output'];
  extendedScore: Maybe<Scalars['JSON']['output']>;
  hideAuthor: Scalars['Boolean']['output'];
  hideKarma: Maybe<Scalars['Boolean']['output']>;
  hideModeratorHat: Maybe<Scalars['Boolean']['output']>;
  htmlBody: Maybe<Scalars['String']['output']>;
  isBookmarked: Scalars['Boolean']['output'];
  isPinnedOnProfile: Scalars['Boolean']['output'];
  lastEditedAt: Maybe<Scalars['Date']['output']>;
  lastSubthreadActivity: Maybe<Scalars['Date']['output']>;
  latestChildren: Array<Comment>;
  legacy: Scalars['Boolean']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  legacyId: Maybe<Scalars['String']['output']>;
  legacyParentId: Maybe<Scalars['String']['output']>;
  legacyPoll: Scalars['Boolean']['output'];
  moderatorHat: Scalars['Boolean']['output'];
  moveToAlignmentUser: Maybe<User>;
  moveToAlignmentUserId: Maybe<Scalars['String']['output']>;
  needsReview: Maybe<Scalars['Boolean']['output']>;
  nominatedForReview: Maybe<Scalars['String']['output']>;
  originalDialogue: Maybe<Post>;
  originalDialogueId: Maybe<Scalars['String']['output']>;
  pageUrl: Maybe<Scalars['String']['output']>;
  pageUrlRelative: Maybe<Scalars['String']['output']>;
  parentAnswer: Maybe<Comment>;
  parentAnswerId: Maybe<Scalars['String']['output']>;
  parentComment: Maybe<Comment>;
  parentCommentId: Maybe<Scalars['String']['output']>;
  pingbacks: Maybe<Scalars['JSON']['output']>;
  post: Maybe<Post>;
  postId: Maybe<Scalars['String']['output']>;
  postVersion: Maybe<Scalars['String']['output']>;
  postedAt: Scalars['Date']['output'];
  promoted: Maybe<Scalars['Boolean']['output']>;
  promotedAt: Maybe<Scalars['Date']['output']>;
  promotedByUser: Maybe<User>;
  promotedByUserId: Maybe<Scalars['String']['output']>;
  referrer: Maybe<Scalars['String']['output']>;
  rejected: Scalars['Boolean']['output'];
  rejectedByUser: Maybe<User>;
  rejectedByUserId: Maybe<Scalars['String']['output']>;
  rejectedReason: Maybe<Scalars['String']['output']>;
  relevantTagIds: Array<Scalars['String']['output']>;
  relevantTags: Array<Tag>;
  repliesBlockedUntil: Maybe<Scalars['Date']['output']>;
  retracted: Scalars['Boolean']['output'];
  reviewForAlignmentUserId: Maybe<Scalars['String']['output']>;
  reviewedByUser: Maybe<User>;
  reviewedByUserId: Maybe<Scalars['String']['output']>;
  reviewingForReview: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  shortform: Maybe<Scalars['Boolean']['output']>;
  shortformFrontpage: Scalars['Boolean']['output'];
  spam: Scalars['Boolean']['output'];
  suggestForAlignmentUserIds: Array<Scalars['String']['output']>;
  suggestForAlignmentUsers: Array<User>;
  tag: Maybe<Tag>;
  tagCommentType: TagCommentType;
  tagId: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  topLevelComment: Maybe<Comment>;
  topLevelCommentId: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
  userAgent: Maybe<Scalars['String']['output']>;
  userIP: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  voteCount: Scalars['Float']['output'];
  votingSystem: Scalars['String']['output'];
  wordCount: Maybe<Scalars['Int']['output']>;
};


export type CommentcontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CommentCountTag = {
  __typename?: 'CommentCountTag';
  comment_count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CommentDefaultViewInput = {
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentEmbedding = {
  __typename?: 'CommentEmbedding';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
};

export type CommentKarmaChange = {
  __typename?: 'CommentKarmaChange';
  _id: Scalars['String']['output'];
  addedReacts: Maybe<Array<ReactionChange>>;
  collectionName: Scalars['String']['output'];
  commentId: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  postId: Maybe<Scalars['String']['output']>;
  postSlug: Maybe<Scalars['String']['output']>;
  postTitle: Maybe<Scalars['String']['output']>;
  scoreChange: Scalars['Int']['output'];
  tagCommentType: Maybe<TagCommentType>;
  tagId: Maybe<Scalars['String']['output']>;
  tagName: Maybe<Scalars['String']['output']>;
  tagSlug: Maybe<Scalars['String']['output']>;
};

export type CommentModeratorAction = {
  __typename?: 'CommentModeratorAction';
  _id: Scalars['String']['output'];
  active: Maybe<Scalars['Boolean']['output']>;
  comment: Maybe<Comment>;
  commentId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  endedAt: Maybe<Scalars['Date']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  type: Maybe<Scalars['String']['output']>;
};

export type CommentModeratorActionOutput = {
  __typename?: 'CommentModeratorActionOutput';
  data: Maybe<CommentModeratorAction>;
};

export type CommentModeratorActionSelector = {
  activeCommentModeratorActions?: InputMaybe<CommentModeratorActionsActiveCommentModeratorActionsInput>;
  default?: InputMaybe<EmptyViewInput>;
};

export type CommentModeratorActionsActiveCommentModeratorActionsInput = {
  limit?: InputMaybe<Scalars['String']['input']>;
};

export type CommentOutput = {
  __typename?: 'CommentOutput';
  data: Maybe<Comment>;
};

export type CommentSelector = {
  afPostCommentsTop?: InputMaybe<CommentsAfPostCommentsTopInput>;
  afRecentDiscussionThread?: InputMaybe<CommentsAfRecentDiscussionThreadInput>;
  afSubmissions?: InputMaybe<CommentsAfSubmissionsInput>;
  alignmentSuggestedComments?: InputMaybe<CommentsAlignmentSuggestedCommentsInput>;
  allCommentsDeleted?: InputMaybe<CommentsAllCommentsDeletedInput>;
  allRecentComments?: InputMaybe<CommentsAllRecentCommentsInput>;
  answersAndReplies?: InputMaybe<CommentsAnswersAndRepliesInput>;
  commentReplies?: InputMaybe<CommentsCommentRepliesInput>;
  debateResponses?: InputMaybe<CommentsDebateResponsesInput>;
  default?: InputMaybe<CommentDefaultViewInput>;
  defaultModeratorResponses?: InputMaybe<CommentsDefaultModeratorResponsesInput>;
  draftComments?: InputMaybe<CommentsDraftCommentsInput>;
  latestSubforumDiscussion?: InputMaybe<CommentsLatestSubforumDiscussionInput>;
  legacyIdComment?: InputMaybe<CommentsLegacyIdCommentInput>;
  moderatorComments?: InputMaybe<CommentsModeratorCommentsInput>;
  nominations2018?: InputMaybe<CommentsNominations2018Input>;
  nominations2019?: InputMaybe<CommentsNominations2019Input>;
  postCommentsBest?: InputMaybe<CommentsPostCommentsBestInput>;
  postCommentsDeleted?: InputMaybe<CommentsPostCommentsDeletedInput>;
  postCommentsMagic?: InputMaybe<CommentsPostCommentsMagicInput>;
  postCommentsNew?: InputMaybe<CommentsPostCommentsNewInput>;
  postCommentsOld?: InputMaybe<CommentsPostCommentsOldInput>;
  postCommentsRecentReplies?: InputMaybe<CommentsPostCommentsRecentRepliesInput>;
  postCommentsTop?: InputMaybe<CommentsPostCommentsTopInput>;
  postLWComments?: InputMaybe<CommentsPostLWCommentsInput>;
  postsItemComments?: InputMaybe<CommentsPostsItemCommentsInput>;
  profileComments?: InputMaybe<CommentsProfileCommentsInput>;
  profileRecentComments?: InputMaybe<CommentsProfileRecentCommentsInput>;
  questionAnswers?: InputMaybe<CommentsQuestionAnswersInput>;
  recentComments?: InputMaybe<CommentsRecentCommentsInput>;
  recentDebateResponses?: InputMaybe<CommentsRecentDebateResponsesInput>;
  recentDiscussionThread?: InputMaybe<CommentsRecentDiscussionThreadInput>;
  rejected?: InputMaybe<CommentsRejectedInput>;
  repliesToAnswer?: InputMaybe<CommentsRepliesToAnswerInput>;
  repliesToCommentThread?: InputMaybe<CommentsRepliesToCommentThreadInput>;
  repliesToCommentThreadIncludingRoot?: InputMaybe<CommentsRepliesToCommentThreadIncludingRootInput>;
  reviews?: InputMaybe<CommentsReviewsInput>;
  reviews2018?: InputMaybe<CommentsReviews2018Input>;
  reviews2019?: InputMaybe<CommentsReviews2019Input>;
  rss?: InputMaybe<CommentsRssInput>;
  shortform?: InputMaybe<CommentsShortformInput>;
  shortformFrontpage?: InputMaybe<CommentsShortformFrontpageInput>;
  shortformLatestChildren?: InputMaybe<CommentsShortformLatestChildrenInput>;
  sunshineNewCommentsList?: InputMaybe<CommentsSunshineNewCommentsListInput>;
  sunshineNewUsersComments?: InputMaybe<CommentsSunshineNewUsersCommentsInput>;
  tagDiscussionComments?: InputMaybe<CommentsTagDiscussionCommentsInput>;
  tagSubforumComments?: InputMaybe<CommentsTagSubforumCommentsInput>;
  topShortform?: InputMaybe<CommentsTopShortformInput>;
};

export type CommentSortingMode =
  | 'groupByPost'
  | 'magic'
  | 'new'
  | 'newest'
  | 'old'
  | 'oldest'
  | 'recentComments'
  | 'recentDiscussion'
  | 'top';

export type CommentsAfPostCommentsTopInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsAfRecentDiscussionThreadInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsAfSubmissionsInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsAlignmentSuggestedCommentsInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsAllCommentsDeletedInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsAllRecentCommentsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsAnswersAndRepliesInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsCommentRepliesInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsDebateResponsesInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsDefaultModeratorResponsesInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsDraftCommentsInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  drafts?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  shortform?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsLatestSubforumDiscussionInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  profileTagIds?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsLegacyIdCommentInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  legacyId?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsModeratorCommentsInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsNominations2018Input = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CommentSortingMode>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsNominations2019Input = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CommentSortingMode>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsPostCommentsBestInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsPostCommentsDeletedInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsPostCommentsMagicInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsPostCommentsNewInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsPostCommentsOldInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsPostCommentsRecentRepliesInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsPostCommentsTopInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsPostLWCommentsInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsPostsItemCommentsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsProfileCommentsInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  drafts?: InputMaybe<Scalars['String']['input']>;
  includeRejected?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  shortform?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsProfileRecentCommentsInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsQuestionAnswersInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsRecentCommentsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsRecentDebateResponsesInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsRecentDiscussionThreadInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsRejectedInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsRepliesToAnswerInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  parentAnswerId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsRepliesToCommentThreadIncludingRootInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  topLevelCommentId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsRepliesToCommentThreadInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  topLevelCommentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsReviews2018Input = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CommentSortingMode>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsReviews2019Input = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CommentSortingMode>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsReviewsInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  reviewYear?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsRssInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsShortformFrontpageInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxAgeDays?: InputMaybe<Scalars['Int']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  relevantTagId?: InputMaybe<Scalars['String']['input']>;
  showCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsShortformInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsShortformLatestChildrenInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  topLevelCommentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsSunshineNewCommentsListInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['String']['input']>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsSunshineNewUsersCommentsInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsTagDiscussionCommentsInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsTagSubforumCommentsInput = {
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsTopShortformInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  commentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumKarma?: InputMaybe<Scalars['Int']['input']>;
  shortformFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<CommentSortingMode>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsWithReactsResult = {
  __typename?: 'CommentsWithReactsResult';
  results: Array<Comment>;
};

export type ContentCollectionName =
  | 'Comments'
  | 'Posts';

export type ContentType = {
  __typename?: 'ContentType';
  data: Scalars['ContentTypeData']['output'];
  type: Scalars['String']['output'];
  yjsState: Maybe<Scalars['String']['output']>;
};

export type ContentTypeInput = {
  data: Scalars['ContentTypeData']['input'];
  type: Scalars['String']['input'];
  yjsState?: InputMaybe<Scalars['String']['input']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  _id: Scalars['String']['output'];
  af: Maybe<Scalars['Boolean']['output']>;
  archivedBy: Array<User>;
  archivedByIds: Array<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  hasUnreadMessages: Maybe<Scalars['Boolean']['output']>;
  latestActivity: Maybe<Scalars['Date']['output']>;
  latestMessage: Maybe<Message>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  messageCount: Scalars['Float']['output'];
  moderator: Maybe<Scalars['Boolean']['output']>;
  participantIds: Maybe<Array<Scalars['String']['output']>>;
  participants: Maybe<Array<User>>;
  schemaVersion: Scalars['Float']['output'];
  title: Maybe<Scalars['String']['output']>;
};

export type ConversationOutput = {
  __typename?: 'ConversationOutput';
  data: Maybe<Conversation>;
};

export type ConversationSelector = {
  default?: InputMaybe<EmptyViewInput>;
  moderatorConversations?: InputMaybe<ConversationsModeratorConversationsInput>;
  userConversations?: InputMaybe<ConversationsUserConversationsInput>;
  userConversationsAll?: InputMaybe<ConversationsUserConversationsAllInput>;
  userGroupUntitledConversations?: InputMaybe<ConversationsUserGroupUntitledConversationsInput>;
};

export type ConversationsModeratorConversationsInput = {
  showArchive?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsUserConversationsAllInput = {
  showArchive?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsUserConversationsInput = {
  showArchive?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsUserGroupUntitledConversationsInput = {
  moderator?: InputMaybe<Scalars['String']['input']>;
  participantIds?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ConvertibleCollectionName =
  | 'Comments'
  | 'Posts'
  | 'Tags';

export type CreateBookDataInput = {
  collectionId: Scalars['String']['input'];
  contents?: InputMaybe<CreateRevisionDataInput>;
  displaySequencesAsGrid?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sequenceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  showChapters?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tocTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBookInput = {
  data: CreateBookDataInput;
};

export type CreateChapterDataInput = {
  contents?: InputMaybe<CreateRevisionDataInput>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  postIds: Array<Scalars['String']['input']>;
  sequenceId?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChapterInput = {
  data: CreateChapterDataInput;
};

export type CreateCollectionDataInput = {
  contents?: InputMaybe<CreateRevisionDataInput>;
  createdAt: Scalars['Date']['input'];
  firstPageLink?: InputMaybe<Scalars['String']['input']>;
  gridImageId?: InputMaybe<Scalars['String']['input']>;
  hideStartReadingButton?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  noindex?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateCollectionInput = {
  data: CreateCollectionDataInput;
};

export type CreateCommentDataInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  afDate?: InputMaybe<Scalars['Date']['input']>;
  agentFoundationsId?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['Boolean']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  debateResponse?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByUserId?: InputMaybe<Scalars['String']['input']>;
  deletedDate?: InputMaybe<Scalars['Date']['input']>;
  deletedPublic?: InputMaybe<Scalars['Boolean']['input']>;
  deletedReason?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  hideKarma?: InputMaybe<Scalars['Boolean']['input']>;
  hideModeratorHat?: InputMaybe<Scalars['Boolean']['input']>;
  isPinnedOnProfile?: InputMaybe<Scalars['Boolean']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  legacyId?: InputMaybe<Scalars['String']['input']>;
  legacyParentId?: InputMaybe<Scalars['String']['input']>;
  legacyPoll?: InputMaybe<Scalars['Boolean']['input']>;
  moderatorHat?: InputMaybe<Scalars['Boolean']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  nominatedForReview?: InputMaybe<Scalars['String']['input']>;
  originalDialogueId?: InputMaybe<Scalars['String']['input']>;
  parentAnswerId?: InputMaybe<Scalars['String']['input']>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  promotedByUserId?: InputMaybe<Scalars['String']['input']>;
  rejected?: InputMaybe<Scalars['Boolean']['input']>;
  rejectedByUserId?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  relevantTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retracted?: InputMaybe<Scalars['Boolean']['input']>;
  reviewedByUserId?: InputMaybe<Scalars['String']['input']>;
  reviewingForReview?: InputMaybe<Scalars['String']['input']>;
  shortform?: InputMaybe<Scalars['Boolean']['input']>;
  shortformFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
  spam?: InputMaybe<Scalars['Boolean']['input']>;
  tagCommentType?: InputMaybe<TagCommentType>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topLevelCommentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommentInput = {
  data: CreateCommentDataInput;
};

export type CreateCommentModeratorActionDataInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Date']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['String']['input'];
};

export type CreateCommentModeratorActionInput = {
  data: CreateCommentModeratorActionDataInput;
};

export type CreateConversationDataInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  archivedByIds?: InputMaybe<Array<Scalars['String']['input']>>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  moderator?: InputMaybe<Scalars['Boolean']['input']>;
  participantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConversationInput = {
  data: CreateConversationDataInput;
};

export type CreateCurationNoticeDataInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  postId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateCurationNoticeInput = {
  data: CreateCurationNoticeDataInput;
};

export type CreateElicitQuestionDataInput = {
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  resolvesBy?: InputMaybe<Scalars['Date']['input']>;
  title: Scalars['String']['input'];
};

export type CreateElicitQuestionInput = {
  data: CreateElicitQuestionDataInput;
};

export type CreateJargonTermDataInput = {
  altTerms: Array<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  postId: Scalars['String']['input'];
  term: Scalars['String']['input'];
};

export type CreateJargonTermInput = {
  data: CreateJargonTermDataInput;
};

export type CreateLWEventDataInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  intercom?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateLWEventInput = {
  data: CreateLWEventDataInput;
};

export type CreateLocalgroupDataInput = {
  bannerImageId?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  facebookPageLink?: InputMaybe<Scalars['String']['input']>;
  googleLocation?: InputMaybe<Scalars['JSON']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivity?: InputMaybe<Scalars['Date']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  meetupLink?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nameInAnotherLanguage?: InputMaybe<Scalars['String']['input']>;
  organizerIds: Array<Scalars['String']['input']>;
  slackLink?: InputMaybe<Scalars['String']['input']>;
  types: Array<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLocalgroupInput = {
  data: CreateLocalgroupDataInput;
};

export type CreateMessageDataInput = {
  contents?: InputMaybe<CreateRevisionDataInput>;
  conversationId: Scalars['String']['input'];
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  noEmail?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMessageInput = {
  data: CreateMessageDataInput;
};

export type CreateModerationTemplateDataInput = {
  collectionName: ModerationTemplateType;
  contents?: InputMaybe<CreateRevisionDataInput>;
  groupLabel?: InputMaybe<Scalars['String']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateModerationTemplateInput = {
  data: CreateModerationTemplateDataInput;
};

export type CreateModeratorActionDataInput = {
  endedAt?: InputMaybe<Scalars['Date']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  type: ModeratorActionType;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateModeratorActionInput = {
  data: CreateModeratorActionDataInput;
};

export type CreateMultiDocumentDataInput = {
  collectionName: MultiDocumentCollectionName;
  contents?: InputMaybe<CreateRevisionDataInput>;
  fieldName: MultiDocumentFieldName;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  parentDocumentId: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  tabSubtitle?: InputMaybe<Scalars['String']['input']>;
  tabTitle: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMultiDocumentInput = {
  data: CreateMultiDocumentDataInput;
};

export type CreatePetrovDayActionDataInput = {
  actionType: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreatePetrovDayActionInput = {
  data: CreatePetrovDayActionDataInput;
};

export type CreatePodcastEpisodeDataInput = {
  episodeLink: Scalars['String']['input'];
  externalEpisodeId: Scalars['String']['input'];
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  podcastId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreatePodcastEpisodeInput = {
  data: CreatePodcastEpisodeDataInput;
};

export type CreatePostDataInput = {
  activateRSVPs?: InputMaybe<Scalars['Boolean']['input']>;
  af?: InputMaybe<Scalars['Boolean']['input']>;
  afDate?: InputMaybe<Scalars['Date']['input']>;
  afSticky?: InputMaybe<Scalars['Boolean']['input']>;
  agentFoundationsId?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  autoFrontpage?: InputMaybe<Scalars['String']['input']>;
  bannedUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  canonicalBookId?: InputMaybe<Scalars['String']['input']>;
  canonicalCollectionSlug?: InputMaybe<Scalars['String']['input']>;
  canonicalNextPostSlug?: InputMaybe<Scalars['String']['input']>;
  canonicalPrevPostSlug?: InputMaybe<Scalars['String']['input']>;
  canonicalSequenceId?: InputMaybe<Scalars['String']['input']>;
  canonicalSource?: InputMaybe<Scalars['String']['input']>;
  coauthorStatuses?: InputMaybe<Array<CoauthorStatusInput>>;
  coauthorUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  collabEditorDialogue?: InputMaybe<Scalars['Boolean']['input']>;
  collectionTitle?: InputMaybe<Scalars['String']['input']>;
  commentSortOrder?: InputMaybe<Scalars['String']['input']>;
  commentsLocked?: InputMaybe<Scalars['Boolean']['input']>;
  commentsLockedToAccountsCreatedAfter?: InputMaybe<Scalars['Date']['input']>;
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  curatedDate?: InputMaybe<Scalars['Date']['input']>;
  customHighlight?: InputMaybe<CreateRevisionDataInput>;
  defaultRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  disableRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  disableSidenotes?: InputMaybe<Scalars['Boolean']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  eventImageId?: InputMaybe<Scalars['String']['input']>;
  eventRegistrationLink?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  feedId?: InputMaybe<Scalars['String']['input']>;
  feedLink?: InputMaybe<Scalars['String']['input']>;
  fmCrosspost?: InputMaybe<CrosspostInput>;
  forceAllowType3Audio?: InputMaybe<Scalars['Boolean']['input']>;
  frontpageDate?: InputMaybe<Scalars['Date']['input']>;
  generateDraftJargon?: InputMaybe<Scalars['Boolean']['input']>;
  globalEvent?: InputMaybe<Scalars['Boolean']['input']>;
  googleLocation?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hasCoauthorPermission?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenRelatedQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  hideAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  hideCommentKarma?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromPopularComments?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromRecentDiscussions?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageComments?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreRateLimits?: InputMaybe<Scalars['Boolean']['input']>;
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  joinEventLink?: InputMaybe<Scalars['String']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  legacyId?: InputMaybe<Scalars['String']['input']>;
  legacySpam?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manifoldReviewMarketId?: InputMaybe<Scalars['String']['input']>;
  meetupLink?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['Boolean']['input']>;
  metaDate?: InputMaybe<Scalars['Date']['input']>;
  metaSticky?: InputMaybe<Scalars['Boolean']['input']>;
  moderationGuidelines?: InputMaybe<CreateRevisionDataInput>;
  moderationStyle?: InputMaybe<Scalars['String']['input']>;
  nextDayReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  onlineEvent?: InputMaybe<Scalars['Boolean']['input']>;
  onlyVisibleToEstablishedAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyVisibleToLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  organizerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  originalPostRelationSourceId?: InputMaybe<Scalars['String']['input']>;
  podcastEpisodeId?: InputMaybe<Scalars['String']['input']>;
  postCategory?: InputMaybe<PostCategory>;
  postedAt?: InputMaybe<Scalars['Date']['input']>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  readTimeMinutesOverride?: InputMaybe<Scalars['Float']['input']>;
  rejected?: InputMaybe<Scalars['Boolean']['input']>;
  rejectedByUserId?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  reviewForAlignmentUserId?: InputMaybe<Scalars['String']['input']>;
  reviewForCuratedUserId?: InputMaybe<Scalars['String']['input']>;
  reviewedByUserId?: InputMaybe<Scalars['String']['input']>;
  shareWithUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  sharingSettings?: InputMaybe<Scalars['JSON']['input']>;
  shortform?: InputMaybe<Scalars['Boolean']['input']>;
  sideCommentVisibility?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  socialPreview?: InputMaybe<SocialPreviewInput>;
  socialPreviewImageAutoUrl?: InputMaybe<Scalars['String']['input']>;
  socialPreviewImageId?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['Float']['input']>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  stickyPriority?: InputMaybe<Scalars['Int']['input']>;
  subforumTagId?: InputMaybe<Scalars['String']['input']>;
  submitToFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
  suggestForAlignmentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  suggestForCuratedUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  swrCachingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tagRelevance?: InputMaybe<Scalars['JSON']['input']>;
  title: Scalars['String']['input'];
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  unlisted?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  wasEverUndrafted?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePostInput = {
  data: CreatePostDataInput;
};

export type CreateRSSFeedDataInput = {
  displayFullContent?: InputMaybe<Scalars['Boolean']['input']>;
  importAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  nickname: Scalars['String']['input'];
  ownedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  rawFeed?: InputMaybe<Scalars['JSON']['input']>;
  setCanonicalUrl?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRSSFeedInput = {
  data: CreateRSSFeedDataInput;
};

export type CreateReportDataInput = {
  claimedUserId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  link: Scalars['String']['input'];
  postId?: InputMaybe<Scalars['String']['input']>;
  reportedAsSpam?: InputMaybe<Scalars['Boolean']['input']>;
  reportedUserId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReportInput = {
  data: CreateReportDataInput;
};

export type CreateResearchDocumentDataInput = {
  contents?: InputMaybe<CreateRevisionDataInput>;
  projectId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateResearchDocumentInput = {
  data: CreateResearchDocumentDataInput;
};

export type CreateResearchProjectDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  title: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateResearchProjectInput = {
  data: CreateResearchProjectDataInput;
};

export type CreateRevisionDataInput = {
  commitMessage?: InputMaybe<Scalars['String']['input']>;
  dataWithDiscardedSuggestions?: InputMaybe<Scalars['JSON']['input']>;
  googleDocMetadata?: InputMaybe<Scalars['JSON']['input']>;
  originalContents: ContentTypeInput;
  updateType?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSequenceDataInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  bannerImageId?: InputMaybe<Scalars['String']['input']>;
  canonicalCollectionSlug?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  curatedOrder?: InputMaybe<Scalars['Float']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  gridImageId?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromAuthorPage?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated?: InputMaybe<Scalars['Date']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  noindex?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateSequenceInput = {
  data: CreateSequenceDataInput;
};

export type CreateSplashArtCoordinateDataInput = {
  leftFlipped?: InputMaybe<Scalars['Boolean']['input']>;
  leftHeightPct: Scalars['Float']['input'];
  leftWidthPct: Scalars['Float']['input'];
  leftXPct: Scalars['Float']['input'];
  leftYPct: Scalars['Float']['input'];
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  middleFlipped?: InputMaybe<Scalars['Boolean']['input']>;
  middleHeightPct: Scalars['Float']['input'];
  middleWidthPct: Scalars['Float']['input'];
  middleXPct: Scalars['Float']['input'];
  middleYPct: Scalars['Float']['input'];
  reviewWinnerArtId: Scalars['String']['input'];
  rightFlipped: Scalars['Boolean']['input'];
  rightHeightPct: Scalars['Float']['input'];
  rightWidthPct: Scalars['Float']['input'];
  rightXPct: Scalars['Float']['input'];
  rightYPct: Scalars['Float']['input'];
};

export type CreateSplashArtCoordinateInput = {
  data: CreateSplashArtCoordinateDataInput;
};

export type CreateSpotlightDataInput = {
  customSubtitle?: InputMaybe<Scalars['String']['input']>;
  customTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<CreateRevisionDataInput>;
  documentId: Scalars['String']['input'];
  documentType: SpotlightDocumentType;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  duration: Scalars['Float']['input'];
  headerTitle?: InputMaybe<Scalars['String']['input']>;
  headerTitleLeftColor?: InputMaybe<Scalars['String']['input']>;
  headerTitleRightColor?: InputMaybe<Scalars['String']['input']>;
  imageFade?: InputMaybe<Scalars['Boolean']['input']>;
  imageFadeColor?: InputMaybe<Scalars['String']['input']>;
  lastPromotedAt: Scalars['Date']['input'];
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  showAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  spotlightDarkImageId?: InputMaybe<Scalars['String']['input']>;
  spotlightImageId?: InputMaybe<Scalars['String']['input']>;
  spotlightSplashImageUrl?: InputMaybe<Scalars['String']['input']>;
  subtitleUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSpotlightInput = {
  data: CreateSpotlightDataInput;
};

export type CreateSubscriptionDataInput = {
  collectionName: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  state: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateSubscriptionInput = {
  data: CreateSubscriptionDataInput;
};

export type CreateTagDataInput = {
  adminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  authorOnly?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagModel?: InputMaybe<Scalars['String']['input']>;
  autoTagPrompt?: InputMaybe<Scalars['String']['input']>;
  bannerImageId?: InputMaybe<Scalars['String']['input']>;
  canEditUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  canVoteOnRels?: InputMaybe<Array<TagRelVoteGroup>>;
  core?: InputMaybe<Scalars['Boolean']['input']>;
  coreTagId?: InputMaybe<Scalars['String']['input']>;
  defaultOrder?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<CreateRevisionDataInput>;
  descriptionTruncationCount?: InputMaybe<Scalars['Float']['input']>;
  forceAllowType3Audio?: InputMaybe<Scalars['Boolean']['input']>;
  introSequenceId?: InputMaybe<Scalars['String']['input']>;
  isPostType?: InputMaybe<Scalars['Boolean']['input']>;
  isSubforum?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  moderationGuidelines?: InputMaybe<CreateRevisionDataInput>;
  name: Scalars['String']['input'];
  parentTagId?: InputMaybe<Scalars['String']['input']>;
  postsDefaultSortOrder?: InputMaybe<Scalars['String']['input']>;
  removalResistant?: InputMaybe<Scalars['Boolean']['input']>;
  reviewedByUserId?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  squareImageId?: InputMaybe<Scalars['String']['input']>;
  subTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subforumIntroPostId?: InputMaybe<Scalars['String']['input']>;
  subforumModeratorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subforumWelcomeText?: InputMaybe<CreateRevisionDataInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  suggestedAsFilter?: InputMaybe<Scalars['Boolean']['input']>;
  tagFlagsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  wikiGrade?: InputMaybe<Scalars['Int']['input']>;
  wikiOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTagFlagDataInput = {
  contents?: InputMaybe<CreateRevisionDataInput>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTagFlagInput = {
  data: CreateTagFlagDataInput;
};

export type CreateTagInput = {
  data: CreateTagDataInput;
};

export type CreateUltraFeedEventDataInput = {
  collectionName: UltraFeedEventCollectionName;
  documentId: Scalars['String']['input'];
  event: Scalars['JSON']['input'];
  eventType: UltraFeedEventEventType;
  feedItemId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUltraFeedEventInput = {
  data: CreateUltraFeedEventDataInput;
};

export type CreateUserDataInput = {
  acceptedTos?: InputMaybe<Scalars['Boolean']['input']>;
  acknowledgedNewUserGuidelines?: InputMaybe<Scalars['Boolean']['input']>;
  afSubmittedApplication?: InputMaybe<Scalars['Boolean']['input']>;
  allCommentingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  allPostsFilter?: InputMaybe<Scalars['String']['input']>;
  allPostsHideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  allPostsIncludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  allPostsOpenSettings?: InputMaybe<Scalars['Boolean']['input']>;
  allPostsShowLowKarma?: InputMaybe<Scalars['Boolean']['input']>;
  allPostsSorting?: InputMaybe<Scalars['String']['input']>;
  allPostsTimeframe?: InputMaybe<Scalars['String']['input']>;
  autoSubscribeAsOrganizer?: InputMaybe<Scalars['Boolean']['input']>;
  auto_subscribe_to_my_comments?: InputMaybe<Scalars['Boolean']['input']>;
  auto_subscribe_to_my_posts?: InputMaybe<Scalars['Boolean']['input']>;
  banned?: InputMaybe<Scalars['Date']['input']>;
  bannedPersonalUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  bannedUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  biography?: InputMaybe<CreateRevisionDataInput>;
  blueskyProfileURL?: InputMaybe<Scalars['String']['input']>;
  careerStage?: InputMaybe<Array<Scalars['String']['input']>>;
  collapseModerationGuidelines?: InputMaybe<Scalars['Boolean']['input']>;
  commentSorting?: InputMaybe<Scalars['String']['input']>;
  commentingOnOtherUsersDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  conversationsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  criticismTipsDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  currentFrontpageFilter?: InputMaybe<Scalars['String']['input']>;
  deleteContent?: InputMaybe<Scalars['Boolean']['input']>;
  displayName: Scalars['String']['input'];
  draftsListShowArchived?: InputMaybe<Scalars['Boolean']['input']>;
  draftsListShowShared?: InputMaybe<Scalars['Boolean']['input']>;
  draftsListSorting?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSubscribedToCurated?: InputMaybe<Scalars['Boolean']['input']>;
  expandedFrontpageSections?: InputMaybe<ExpandedFrontpageSectionsSettingsInput>;
  facebookProfileURL?: InputMaybe<Scalars['String']['input']>;
  fmCrosspostUserId?: InputMaybe<Scalars['String']['input']>;
  frontpageFilterSettings?: InputMaybe<Scalars['JSON']['input']>;
  frontpageSelectedTab?: InputMaybe<Scalars['String']['input']>;
  githubProfileURL?: InputMaybe<Scalars['String']['input']>;
  googleLocation?: InputMaybe<Scalars['JSON']['input']>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  hideActiveDialogueUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hideCommunitySection?: InputMaybe<Scalars['Boolean']['input']>;
  hideDialogueFacilitation?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromPeopleDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageBook2019Ad?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageBook2020Ad?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageBookAd?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageFilterSettingsDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageMap?: InputMaybe<Scalars['Boolean']['input']>;
  hideHomeRHS?: InputMaybe<Scalars['Boolean']['input']>;
  hideIntercom?: InputMaybe<Scalars['Boolean']['input']>;
  hideMeetupsPoke?: InputMaybe<Scalars['Boolean']['input']>;
  hideNavigationSidebar?: InputMaybe<Scalars['Boolean']['input']>;
  hidePostsRecommendations?: InputMaybe<Scalars['Boolean']['input']>;
  hideProfileTopPosts?: InputMaybe<Scalars['Boolean']['input']>;
  hideSubscribePoke?: InputMaybe<Scalars['Boolean']['input']>;
  hideSunshineSidebar?: InputMaybe<Scalars['Boolean']['input']>;
  hideTaggingProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  howICanHelpOthers?: InputMaybe<CreateRevisionDataInput>;
  howOthersCanHelpMe?: InputMaybe<CreateRevisionDataInput>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  karmaChangeBatchStart?: InputMaybe<Scalars['Date']['input']>;
  karmaChangeLastOpened?: InputMaybe<Scalars['Date']['input']>;
  karmaChangeNotifierSettings?: InputMaybe<Scalars['JSON']['input']>;
  lastNotificationsCheck?: InputMaybe<Scalars['Date']['input']>;
  lastUsedTimezone?: InputMaybe<Scalars['String']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  legacyId?: InputMaybe<Scalars['String']['input']>;
  linkedinProfileURL?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mapLocation?: InputMaybe<Scalars['JSON']['input']>;
  mapMarkerText?: InputMaybe<Scalars['String']['input']>;
  moderationGuidelines?: InputMaybe<CreateRevisionDataInput>;
  moderationStyle?: InputMaybe<Scalars['String']['input']>;
  moderatorAssistance?: InputMaybe<Scalars['Boolean']['input']>;
  nearbyEventsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  nearbyEventsNotificationsLocation?: InputMaybe<Scalars['JSON']['input']>;
  nearbyEventsNotificationsRadius?: InputMaybe<Scalars['Float']['input']>;
  nearbyPeopleNotificationThreshold?: InputMaybe<Scalars['Float']['input']>;
  noCollapseCommentsFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
  noCollapseCommentsPosts?: InputMaybe<Scalars['Boolean']['input']>;
  noExpandUnreadCommentsReview?: InputMaybe<Scalars['Boolean']['input']>;
  noKibitz?: InputMaybe<Scalars['Boolean']['input']>;
  noSingleLineComments?: InputMaybe<Scalars['Boolean']['input']>;
  notificationAddedAsCoauthor?: InputMaybe<Scalars['JSON']['input']>;
  notificationAlignmentSubmissionApproved?: InputMaybe<Scalars['JSON']['input']>;
  notificationCommentsOnDraft?: InputMaybe<Scalars['JSON']['input']>;
  notificationCommentsOnSubscribedPost?: InputMaybe<Scalars['JSON']['input']>;
  notificationDebateCommentsOnSubscribedPost?: InputMaybe<Scalars['JSON']['input']>;
  notificationDebateReplies?: InputMaybe<Scalars['JSON']['input']>;
  notificationDialogueMatch?: InputMaybe<Scalars['JSON']['input']>;
  notificationDialogueMessages?: InputMaybe<Scalars['JSON']['input']>;
  notificationEventInRadius?: InputMaybe<Scalars['JSON']['input']>;
  notificationGroupAdministration?: InputMaybe<Scalars['JSON']['input']>;
  notificationKarmaPowersGained?: InputMaybe<Scalars['JSON']['input']>;
  notificationNewDialogueChecks?: InputMaybe<Scalars['JSON']['input']>;
  notificationNewMention?: InputMaybe<Scalars['JSON']['input']>;
  notificationPostsInGroups?: InputMaybe<Scalars['JSON']['input']>;
  notificationPostsNominatedReview?: InputMaybe<Scalars['JSON']['input']>;
  notificationPrivateMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationPublishedDialogueMessages?: InputMaybe<Scalars['JSON']['input']>;
  notificationRSVPs?: InputMaybe<Scalars['JSON']['input']>;
  notificationRepliesToMyComments?: InputMaybe<Scalars['JSON']['input']>;
  notificationRepliesToSubscribedComments?: InputMaybe<Scalars['JSON']['input']>;
  notificationSharedWithMe?: InputMaybe<Scalars['JSON']['input']>;
  notificationShortformContent?: InputMaybe<Scalars['JSON']['input']>;
  notificationSubforumUnread?: InputMaybe<Scalars['JSON']['input']>;
  notificationSubscribedSequencePost?: InputMaybe<Scalars['JSON']['input']>;
  notificationSubscribedTagPost?: InputMaybe<Scalars['JSON']['input']>;
  notificationSubscribedUserComment?: InputMaybe<Scalars['JSON']['input']>;
  notificationSubscribedUserPost?: InputMaybe<Scalars['JSON']['input']>;
  notificationTypoSuggestions?: InputMaybe<Scalars['JSON']['input']>;
  notificationYourTurnMatchForm?: InputMaybe<Scalars['JSON']['input']>;
  nullifyVotes?: InputMaybe<Scalars['Boolean']['input']>;
  optedInToDialogueFacilitation?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  organizerOfGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  petrovOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  pinnedPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postGlossariesPinned?: InputMaybe<Scalars['Boolean']['input']>;
  postingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  previousDisplayName?: InputMaybe<Scalars['String']['input']>;
  profileTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  programParticipation?: InputMaybe<Array<Scalars['String']['input']>>;
  revealChecksToAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  reviewForAlignmentForumUserId?: InputMaybe<Scalars['String']['input']>;
  reviewedAt?: InputMaybe<Scalars['Date']['input']>;
  reviewedByUserId?: InputMaybe<Scalars['String']['input']>;
  shortformFeedId?: InputMaybe<Scalars['String']['input']>;
  showCommunityInRecentDiscussion?: InputMaybe<Scalars['Boolean']['input']>;
  showDialoguesList?: InputMaybe<Scalars['Boolean']['input']>;
  showHideKarmaOption?: InputMaybe<Scalars['Boolean']['input']>;
  showMatches?: InputMaybe<Scalars['Boolean']['input']>;
  showMyDialogues?: InputMaybe<Scalars['Boolean']['input']>;
  showPostAuthorCard?: InputMaybe<Scalars['Boolean']['input']>;
  showRecommendedPartners?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subforumPreferredLayout?: InputMaybe<SubforumPreferredLayout>;
  theme?: InputMaybe<Scalars['JSON']['input']>;
  twitterProfileURL?: InputMaybe<Scalars['String']['input']>;
  twitterProfileURLAdmin?: InputMaybe<Scalars['String']['input']>;
  ultraFeedSettings?: InputMaybe<Scalars['JSON']['input']>;
  unsubscribeFromAll?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  viewUnreviewedComments?: InputMaybe<Scalars['Boolean']['input']>;
  voteBanned?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whenConfirmationEmailSent?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateUserInput = {
  data: CreateUserDataInput;
};

export type CreateUserMostValuablePostDataInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  postId: Scalars['String']['input'];
};

export type CreateUserMostValuablePostInput = {
  data: CreateUserMostValuablePostDataInput;
};

export type CreateUserRateLimitDataInput = {
  actionsPerInterval: Scalars['Float']['input'];
  endedAt: Scalars['Date']['input'];
  intervalLength: Scalars['Float']['input'];
  intervalUnit: UserRateLimitIntervalUnit;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  type: UserRateLimitType;
  userId: Scalars['String']['input'];
};

export type CreateUserRateLimitInput = {
  data: CreateUserRateLimitDataInput;
};

export type CreateUserTagRelDataInput = {
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  subforumEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  subforumHideIntroPost?: InputMaybe<Scalars['Boolean']['input']>;
  subforumShowUnreadInSidebar?: InputMaybe<Scalars['Boolean']['input']>;
  tagId: Scalars['String']['input'];
};

export type CreateUserTagRelInput = {
  data: CreateUserTagRelDataInput;
};

export type CronHistory = {
  __typename?: 'CronHistory';
  _id: Maybe<Scalars['String']['output']>;
  finishedAt: Maybe<Scalars['Date']['output']>;
  intendedAt: Maybe<Scalars['Date']['output']>;
  name: Maybe<Scalars['String']['output']>;
  result: Maybe<Scalars['JSON']['output']>;
  startedAt: Maybe<Scalars['Date']['output']>;
};

export type CrossSiteLinkPreviewData = {
  __typename?: 'CrossSiteLinkPreviewData';
  cacheVersion: Maybe<Scalars['Int']['output']>;
  debugHtmlSource: Maybe<Scalars['String']['output']>;
  debugImageSource: Maybe<Scalars['String']['output']>;
  debugTitleSource: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  fetchedAt: Maybe<Scalars['Date']['output']>;
  html: Maybe<Scalars['String']['output']>;
  imageHeight: Maybe<Scalars['Int']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  imageWidth: Maybe<Scalars['Int']['output']>;
  mirroredImageUrl: Maybe<Scalars['String']['output']>;
  nextRefreshAt: Maybe<Scalars['Date']['output']>;
  originalImageUrl: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type CrossedKarmaThresholdResult = {
  __typename?: 'CrossedKarmaThresholdResult';
  results: Array<Post>;
};

export type CrosspostInput = {
  foreignPostId?: InputMaybe<Scalars['String']['input']>;
  hostedHere?: InputMaybe<Scalars['Boolean']['input']>;
  isCrosspost: Scalars['Boolean']['input'];
};

export type CrosspostOutput = {
  __typename?: 'CrosspostOutput';
  foreignPostId: Maybe<Scalars['String']['output']>;
  hostedHere: Maybe<Scalars['Boolean']['output']>;
  isCrosspost: Scalars['Boolean']['output'];
};

export type CuratedAndPopularThisWeekResult = {
  __typename?: 'CuratedAndPopularThisWeekResult';
  results: Array<Post>;
};

export type CurationCandidatePostsResult = {
  __typename?: 'CurationCandidatePostsResult';
  results: Array<Post>;
};

export type CurationEmail = {
  __typename?: 'CurationEmail';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  postId: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  userId: Maybe<Scalars['String']['output']>;
};

export type CurationNotice = {
  __typename?: 'CurationNotice';
  _id: Scalars['String']['output'];
  comment: Maybe<Comment>;
  commentId: Maybe<Scalars['String']['output']>;
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deleted: Scalars['Boolean']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  post: Maybe<Post>;
  postId: Scalars['String']['output'];
  schemaVersion: Scalars['Float']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
};


export type CurationNoticecontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CurationNoticeOutput = {
  __typename?: 'CurationNoticeOutput';
  data: Maybe<CurationNotice>;
};

export type CurationNoticeSelector = {
  curationNoticesPage?: InputMaybe<EmptyViewInput>;
  curationNoticesPostView?: InputMaybe<CurationNoticesPostViewInput>;
  default?: InputMaybe<EmptyViewInput>;
};

export type CurationNoticesPostViewInput = {
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type DatabaseMetadata = {
  __typename?: 'DatabaseMetadata';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
};

export type DebouncerEvents = {
  __typename?: 'DebouncerEvents';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
};

export type DevPreviewUrlOutput = {
  __typename?: 'DevPreviewUrlOutput';
  url: Scalars['String']['output'];
};

export type DialogueCheck = {
  __typename?: 'DialogueCheck';
  _id: Scalars['String']['output'];
  checked: Maybe<Scalars['Boolean']['output']>;
  checkedAt: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  hideInRecommendations: Maybe<Scalars['Boolean']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  matchPreference: Maybe<DialogueMatchPreference>;
  reciprocalMatchPreference: Maybe<DialogueMatchPreference>;
  schemaVersion: Scalars['Float']['output'];
  targetUserId: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type DialogueCheckSelector = {
  default?: InputMaybe<EmptyViewInput>;
  userDialogueChecks?: InputMaybe<DialogueChecksUserDialogueChecksInput>;
  userTargetDialogueChecks?: InputMaybe<DialogueChecksUserTargetDialogueChecksInput>;
};

export type DialogueChecksUserDialogueChecksInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DialogueChecksUserTargetDialogueChecksInput = {
  targetUserIds?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DialogueMatchPreference = {
  __typename?: 'DialogueMatchPreference';
  _id: Scalars['String']['output'];
  asyncPreference: Maybe<Scalars['String']['output']>;
  calendlyLink: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deleted: Scalars['Boolean']['output'];
  dialogueCheck: Maybe<DialogueCheck>;
  dialogueCheckId: Maybe<Scalars['String']['output']>;
  formatNotes: Maybe<Scalars['String']['output']>;
  generatedDialogueId: Maybe<Scalars['String']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  syncPreference: Maybe<Scalars['String']['output']>;
  topicNotes: Maybe<Scalars['String']['output']>;
  topicPreferences: Maybe<Array<Scalars['JSON']['output']>>;
};

export type DialogueMatchPreferenceSelector = {
  default?: InputMaybe<EmptyViewInput>;
  dialogueMatchPreferences?: InputMaybe<DialogueMatchPreferencesDialogueMatchPreferencesInput>;
};

export type DialogueMatchPreferencesDialogueMatchPreferencesInput = {
  dialogueCheckId?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentDeletion = {
  __typename?: 'DocumentDeletion';
  createdAt: Scalars['Date']['output'];
  docFields: Maybe<MultiDocument>;
  documentId: Scalars['String']['output'];
  netChange: DocumentDeletionNetChange;
  type: Maybe<MultiDocumentType>;
  userId: Maybe<Scalars['String']['output']>;
};

export type DocumentDeletionNetChange =
  | 'deleted'
  | 'restored';

export type ElicitBlockData = {
  __typename?: 'ElicitBlockData';
  _id: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  predictions: Maybe<Array<ElicitPrediction>>;
  resolution: Maybe<Scalars['Boolean']['output']>;
  resolvesBy: Maybe<Scalars['Date']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type ElicitPrediction = {
  __typename?: 'ElicitPrediction';
  _id: Maybe<Scalars['String']['output']>;
  binaryQuestionId: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  creator: Maybe<ElicitUser>;
  notes: Maybe<Scalars['String']['output']>;
  prediction: Maybe<Scalars['Float']['output']>;
  predictionId: Maybe<Scalars['String']['output']>;
  sourceId: Maybe<Scalars['String']['output']>;
  sourceUrl: Maybe<Scalars['String']['output']>;
};

export type ElicitQuestion = {
  __typename?: 'ElicitQuestion';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  resolution: Maybe<Scalars['String']['output']>;
  resolvesBy: Maybe<Scalars['Date']['output']>;
  schemaVersion: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type ElicitQuestionOutput = {
  __typename?: 'ElicitQuestionOutput';
  data: Maybe<ElicitQuestion>;
};

export type ElicitQuestionPrediction = {
  __typename?: 'ElicitQuestionPrediction';
  _id: Scalars['String']['output'];
  binaryQuestionId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  creator: ElicitQuestionPredictionCreator;
  isDeleted: Scalars['Boolean']['output'];
  notes: Maybe<Scalars['String']['output']>;
  prediction: Maybe<Scalars['Float']['output']>;
  predictionId: Maybe<Scalars['String']['output']>;
  question: ElicitQuestion;
  sourceId: Maybe<Scalars['String']['output']>;
  sourceUrl: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['String']['output']>;
};

export type ElicitQuestionPredictionCreator = {
  __typename?: 'ElicitQuestionPredictionCreator';
  _id: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  isQuestionCreator: Scalars['Boolean']['output'];
  sourceUserId: Maybe<Scalars['String']['output']>;
};

export type ElicitQuestionPredictionSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type ElicitQuestionSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type ElicitUser = {
  __typename?: 'ElicitUser';
  _id: Maybe<Scalars['String']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  isQuestionCreator: Maybe<Scalars['Boolean']['output']>;
  lwUser: Maybe<User>;
  sourceUserId: Maybe<Scalars['String']['output']>;
};

export type EmailPreview = {
  __typename?: 'EmailPreview';
  html: Maybe<Scalars['String']['output']>;
  subject: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  to: Maybe<Scalars['String']['output']>;
};

export type EmailTokens = {
  __typename?: 'EmailTokens';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
};

export type EmptyViewInput = {
  /** @deprecated GraphQL doesn't support empty input types, so we need to provide a field.  Don't pass anything in, it doesn't do anything. */
  _?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnsureResearchScratchDocumentOutput = {
  __typename?: 'EnsureResearchScratchDocumentOutput';
  documentId: Scalars['String']['output'];
};

export type ExpandedFrontpageSectionsSettingsInput = {
  community?: InputMaybe<Scalars['Boolean']['input']>;
  popularComments?: InputMaybe<Scalars['Boolean']['input']>;
  quickTakes?: InputMaybe<Scalars['Boolean']['input']>;
  quickTakesCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  recommendations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpandedFrontpageSectionsSettingsOutput = {
  __typename?: 'ExpandedFrontpageSectionsSettingsOutput';
  community: Maybe<Scalars['Boolean']['output']>;
  popularComments: Maybe<Scalars['Boolean']['output']>;
  quickTakes: Maybe<Scalars['Boolean']['output']>;
  quickTakesCommunity: Maybe<Scalars['Boolean']['output']>;
  recommendations: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalPost = {
  __typename?: 'ExternalPost';
  _id: Scalars['String']['output'];
  coauthorUserIds: Maybe<Array<Scalars['String']['output']>>;
  content: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  draft: Maybe<Scalars['Boolean']['output']>;
  modifiedAt: Maybe<Scalars['Date']['output']>;
  postedAt: Maybe<Scalars['Date']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type ExternalPostImportData = {
  __typename?: 'ExternalPostImportData';
  alreadyExists: Maybe<Scalars['Boolean']['output']>;
  post: Maybe<ExternalPost>;
};

export type FeedCommentThread = {
  __typename?: 'FeedCommentThread';
  _id: Scalars['String']['output'];
  commentMetaInfos: Maybe<Scalars['JSON']['output']>;
  comments: Array<Comment>;
  post: Maybe<Post>;
  postMetaInfo: Maybe<Scalars['JSON']['output']>;
  postSources: Maybe<Array<Scalars['String']['output']>>;
};

export type FeedMarker = {
  __typename?: 'FeedMarker';
  _id: Scalars['String']['output'];
  markerType: Scalars['String']['output'];
  timestamp: Scalars['Date']['output'];
};

export type FeedPost = {
  __typename?: 'FeedPost';
  _id: Scalars['String']['output'];
  post: Post;
  postMetaInfo: Maybe<Scalars['JSON']['output']>;
};

export type FeedSpotlightItem = {
  __typename?: 'FeedSpotlightItem';
  _id: Scalars['String']['output'];
  post: Maybe<Post>;
  spotlight: Maybe<Spotlight>;
  spotlightMetaInfo: Maybe<FeedSpotlightMetaInfo>;
};

export type FeedSpotlightMetaInfo = {
  __typename?: 'FeedSpotlightMetaInfo';
  rankingMetadata: Maybe<Scalars['JSON']['output']>;
  servedEventId: Scalars['String']['output'];
  sources: Array<Scalars['String']['output']>;
};

export type FeedSubscriptionSuggestions = {
  __typename?: 'FeedSubscriptionSuggestions';
  _id: Scalars['String']['output'];
  suggestedUsers: Array<User>;
};

export type FieldChange = {
  __typename?: 'FieldChange';
  _id: Scalars['String']['output'];
  changeGroup: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  documentId: Maybe<Scalars['String']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  newValue: Maybe<Scalars['JSON']['output']>;
  oldValue: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  user: Maybe<User>;
  userId: Maybe<Scalars['String']['output']>;
};

export type FieldChangeSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type FireResearchConversationInput = {
  activeDocumentId: Scalars['String']['input'];
  baseEnvironmentId?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
  kind: ResearchEntrypointKind;
  projectId: Scalars['String']['input'];
  promptHtml: Scalars['String']['input'];
  runtime?: InputMaybe<Scalars['String']['input']>;
};

export type FrontpageClassification = {
  __typename?: 'FrontpageClassification';
  isFrontpage: Scalars['Boolean']['output'];
  probability: Scalars['Float']['output'];
};

export type GivingSeasonHeart = {
  __typename?: 'GivingSeasonHeart';
  displayName: Scalars['String']['output'];
  theta: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type GoogleServiceAccountSession = {
  __typename?: 'GoogleServiceAccountSession';
  _id: Scalars['String']['output'];
  active: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Date']['output'];
  email: Maybe<Scalars['String']['output']>;
  estimatedExpiry: Maybe<Scalars['Date']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  refreshToken: Maybe<Scalars['String']['output']>;
  revoked: Maybe<Scalars['Boolean']['output']>;
  schemaVersion: Scalars['Float']['output'];
};

export type GoogleServiceAccountSessionSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type HocuspocusAuth = {
  __typename?: 'HocuspocusAuth';
  token: Scalars['String']['output'];
};

export type HomePageDesign = {
  __typename?: 'HomePageDesign';
  _id: Scalars['String']['output'];
  autoReviewMessage: Maybe<Scalars['String']['output']>;
  autoReviewPassed: Maybe<Scalars['Boolean']['output']>;
  commentId: Maybe<Scalars['String']['output']>;
  conversationHistory: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['Date']['output'];
  html: Scalars['String']['output'];
  modelName: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type HomePageDesignMutationOutput = {
  __typename?: 'HomePageDesignMutationOutput';
  data: Maybe<HomePageDesign>;
};

export type HomePageDesignSummary = {
  __typename?: 'HomePageDesignSummary';
  createdAt: Scalars['Date']['output'];
  publicId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type HomepageCommunityEventMarker = {
  __typename?: 'HomepageCommunityEventMarker';
  _id: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  types: Maybe<Array<Scalars['String']['output']>>;
};

export type HomepageCommunityEventMarkersResult = {
  __typename?: 'HomepageCommunityEventMarkersResult';
  events: Array<HomepageCommunityEventMarker>;
};

export type HomepageCommunityEventPostsResult = {
  __typename?: 'HomepageCommunityEventPostsResult';
  posts: Array<Post>;
};

export type IframeWidgetSrcdoc = {
  __typename?: 'IframeWidgetSrcdoc';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  html: Scalars['String']['output'];
  revisionId: Scalars['String']['output'];
};

export type IframeWidgetSrcdocSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type Images = {
  __typename?: 'Images';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
};

export type JargonTerm = {
  __typename?: 'JargonTerm';
  _id: Scalars['String']['output'];
  altTerms: Array<Scalars['String']['output']>;
  approved: Scalars['Boolean']['output'];
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deleted: Scalars['Boolean']['output'];
  humansAndOrAIEdited: Maybe<Scalars['String']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  post: Maybe<Post>;
  postId: Scalars['String']['output'];
  schemaVersion: Scalars['Float']['output'];
  term: Scalars['String']['output'];
};


export type JargonTermcontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type JargonTermOutput = {
  __typename?: 'JargonTermOutput';
  data: Maybe<JargonTerm>;
};

export type JargonTermSelector = {
  default?: InputMaybe<EmptyViewInput>;
  glossaryEditAll?: InputMaybe<EmptyViewInput>;
  postEditorJargonTerms?: InputMaybe<JargonTermsPostEditorJargonTermsInput>;
  postsApprovedJargon?: InputMaybe<JargonTermsPostsApprovedJargonInput>;
};

export type JargonTermsPostEditorJargonTermsInput = {
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type JargonTermsPostsApprovedJargonInput = {
  postIds?: InputMaybe<Scalars['String']['input']>;
};

export type KarmaChanges = {
  __typename?: 'KarmaChanges';
  comments: Array<CommentKarmaChange>;
  endDate: Maybe<Scalars['Date']['output']>;
  nextBatchDate: Maybe<Scalars['Date']['output']>;
  posts: Array<PostKarmaChange>;
  startDate: Maybe<Scalars['Date']['output']>;
  tagRevisions: Array<RevisionsKarmaChange>;
  thisWeeksKarmaChanges: Maybe<KarmaChangesSimple>;
  todaysKarmaChanges: Maybe<KarmaChangesSimple>;
  totalChange: Scalars['Int']['output'];
  updateFrequency: Scalars['String']['output'];
};

export type KarmaChangesSimple = {
  __typename?: 'KarmaChangesSimple';
  comments: Array<CommentKarmaChange>;
  posts: Array<PostKarmaChange>;
  tagRevisions: Array<RevisionsKarmaChange>;
};

export type LWEvent = {
  __typename?: 'LWEvent';
  _id: Scalars['String']['output'];
  createdAt: Maybe<Scalars['Date']['output']>;
  documentId: Maybe<Scalars['String']['output']>;
  important: Maybe<Scalars['Boolean']['output']>;
  intercom: Maybe<Scalars['Boolean']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  name: Maybe<Scalars['String']['output']>;
  properties: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  user: Maybe<User>;
  userId: Maybe<Scalars['String']['output']>;
};

export type LWEventOutput = {
  __typename?: 'LWEventOutput';
  data: Maybe<LWEvent>;
};

export type LWEventSelector = {
  adminView?: InputMaybe<LWEventsAdminViewInput>;
  default?: InputMaybe<EmptyViewInput>;
  emailHistory?: InputMaybe<LWEventsEmailHistoryInput>;
  postVisits?: InputMaybe<LWEventsPostVisitsInput>;
};

export type LWEventsAdminViewInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LWEventsEmailHistoryInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type LWEventsPostVisitsInput = {
  limit?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type LastCuratedDateResult = {
  __typename?: 'LastCuratedDateResult';
  lastCuratedDate: Maybe<Scalars['Date']['output']>;
};

export type LatLng = {
  __typename?: 'LatLng';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LegacyData = {
  __typename?: 'LegacyData';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
};

export type LlmConversation = {
  __typename?: 'LlmConversation';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deleted: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedAt: Maybe<Scalars['Date']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  messages: Maybe<Array<LlmMessage>>;
  model: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  systemPrompt: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  totalCharacterCount: Maybe<Scalars['Int']['output']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['String']['output']>;
};

export type LlmConversationOutput = {
  __typename?: 'LlmConversationOutput';
  data: Maybe<LlmConversation>;
};

export type LlmConversationSelector = {
  default?: InputMaybe<EmptyViewInput>;
  llmConversationsAll?: InputMaybe<LlmConversationsLlmConversationsAllInput>;
  llmConversationsWithUser?: InputMaybe<LlmConversationsLlmConversationsWithUserInput>;
};

export type LlmConversationsLlmConversationsAllInput = {
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LlmConversationsLlmConversationsWithUserInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type LlmMessage = {
  __typename?: 'LlmMessage';
  _id: Scalars['String']['output'];
  content: Maybe<Scalars['String']['output']>;
  conversationId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  role: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  userId: Maybe<Scalars['String']['output']>;
};

export type Localgroup = {
  __typename?: 'Localgroup';
  _id: Scalars['String']['output'];
  bannerImageId: Maybe<Scalars['String']['output']>;
  categories: Maybe<Array<Scalars['String']['output']>>;
  contactInfo: Maybe<Scalars['String']['output']>;
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deleted: Scalars['Boolean']['output'];
  facebookLink: Maybe<Scalars['String']['output']>;
  facebookPageLink: Maybe<Scalars['String']['output']>;
  googleLocation: Maybe<Scalars['JSON']['output']>;
  inactive: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  lastActivity: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  location: Maybe<Scalars['String']['output']>;
  meetupLink: Maybe<Scalars['String']['output']>;
  mongoLocation: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  nameInAnotherLanguage: Maybe<Scalars['String']['output']>;
  organizerIds: Array<Scalars['String']['output']>;
  organizers: Array<User>;
  schemaVersion: Scalars['Float']['output'];
  slackLink: Maybe<Scalars['String']['output']>;
  types: Array<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
};


export type LocalgroupcontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type LocalgroupDefaultViewInput = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalgroupOutput = {
  __typename?: 'LocalgroupOutput';
  data: Maybe<Localgroup>;
};

export type LocalgroupSelector = {
  all?: InputMaybe<LocalgroupsAllInput>;
  default?: InputMaybe<LocalgroupDefaultViewInput>;
  local?: InputMaybe<LocalgroupsLocalInput>;
  nearby?: InputMaybe<LocalgroupsNearbyInput>;
  online?: InputMaybe<LocalgroupsOnlineInput>;
  single?: InputMaybe<LocalgroupsSingleInput>;
  userActiveGroups?: InputMaybe<LocalgroupsUserActiveGroupsInput>;
  userInactiveGroups?: InputMaybe<LocalgroupsUserInactiveGroupsInput>;
  userOrganizesGroups?: InputMaybe<LocalgroupsUserOrganizesGroupsInput>;
};

export type LocalgroupsAllInput = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalgroupsLocalInput = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalgroupsNearbyInput = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type LocalgroupsOnlineInput = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalgroupsSingleInput = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalgroupsUserActiveGroupsInput = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type LocalgroupsUserInactiveGroupsInput = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type LocalgroupsUserOrganizesGroupsInput = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type LoginReturnData = {
  __typename?: 'LoginReturnData';
  token: Maybe<Scalars['String']['output']>;
};

export type MailgunRiskLevel =
  | 'high'
  | 'low'
  | 'medium';

export type MailgunValidationResult = {
  __typename?: 'MailgunValidationResult';
  didYouMean: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  httpStatus: Maybe<Scalars['Int']['output']>;
  isDisposableAddress: Maybe<Scalars['Boolean']['output']>;
  isRoleAddress: Maybe<Scalars['Boolean']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  risk: Maybe<Scalars['String']['output']>;
  sourceUserId: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  validatedAt: Maybe<Scalars['Date']['output']>;
};

export type ManifoldProbabilitiesCache = {
  __typename?: 'ManifoldProbabilitiesCache';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  isResolved: Scalars['Boolean']['output'];
  lastUpdated: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  marketId: Scalars['String']['output'];
  probability: Scalars['Float']['output'];
  schemaVersion: Scalars['Float']['output'];
  url: Maybe<Scalars['String']['output']>;
  year: Scalars['Float']['output'];
};

export type MarkResearchConversationReadOutput = {
  __typename?: 'MarkResearchConversationReadOutput';
  ok: Scalars['Boolean']['output'];
};

export type MarketplaceHomePageDesign = {
  __typename?: 'MarketplaceHomePageDesign';
  commentBaseScore: Scalars['Int']['output'];
  commentId: Maybe<Scalars['String']['output']>;
  html: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type MergeAccountsFailure = {
  __typename?: 'MergeAccountsFailure';
  collectionName: Maybe<Scalars['String']['output']>;
  documentId: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  stage: Scalars['String']['output'];
};

export type MergeAccountsResult = {
  __typename?: 'MergeAccountsResult';
  completed: Scalars['Boolean']['output'];
  failures: Array<MergeAccountsFailure>;
  success: Scalars['Boolean']['output'];
};

export type Message = {
  __typename?: 'Message';
  _id: Scalars['String']['output'];
  afBaseScore: Maybe<Scalars['Float']['output']>;
  afExtendedScore: Maybe<Scalars['JSON']['output']>;
  afVoteCount: Maybe<Scalars['Float']['output']>;
  baseScore: Scalars['Float']['output'];
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  conversation: Maybe<Conversation>;
  conversationId: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  currentUserExtendedVote: Maybe<Scalars['JSON']['output']>;
  currentUserVote: Maybe<Scalars['String']['output']>;
  extendedScore: Maybe<Scalars['JSON']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  noEmail: Maybe<Scalars['Boolean']['output']>;
  schemaVersion: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  user: Maybe<User>;
  userId: Maybe<Scalars['String']['output']>;
  voteCount: Scalars['Float']['output'];
};


export type MessagecontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type MessageOutput = {
  __typename?: 'MessageOutput';
  data: Maybe<Message>;
};

export type MessageSelector = {
  conversationPreview?: InputMaybe<MessagesConversationPreviewInput>;
  default?: InputMaybe<EmptyViewInput>;
  messagesConversation?: InputMaybe<MessagesMessagesConversationInput>;
};

export type MessagesConversationPreviewInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
};

export type MessagesMessagesConversationInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
};

export type Migration = {
  __typename?: 'Migration';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
};

export type MigrationRun = {
  __typename?: 'MigrationRun';
  finished: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  started: Scalars['Date']['output'];
  succeeded: Maybe<Scalars['Boolean']['output']>;
};

export type MigrationStatus = {
  __typename?: 'MigrationStatus';
  dateWritten: Maybe<Scalars['String']['output']>;
  lastRun: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  runs: Maybe<Array<MigrationRun>>;
};

export type MigrationsDashboardData = {
  __typename?: 'MigrationsDashboardData';
  migrations: Maybe<Array<MigrationStatus>>;
};

export type ModerationTemplate = {
  __typename?: 'ModerationTemplate';
  _id: Scalars['String']['output'];
  collectionName: ModerationTemplateType;
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deleted: Scalars['Boolean']['output'];
  groupLabel: Maybe<Scalars['String']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  schemaVersion: Scalars['Float']['output'];
};


export type ModerationTemplatecontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type ModerationTemplateOutput = {
  __typename?: 'ModerationTemplateOutput';
  data: Maybe<ModerationTemplate>;
};

export type ModerationTemplateSelector = {
  default?: InputMaybe<EmptyViewInput>;
  moderationTemplatesList?: InputMaybe<ModerationTemplatesModerationTemplatesListInput>;
  moderationTemplatesPage?: InputMaybe<EmptyViewInput>;
};

export type ModerationTemplateType =
  | 'Comments'
  | 'Messages'
  | 'Rejections';

export type ModerationTemplatesModerationTemplatesListInput = {
  collectionName?: InputMaybe<Scalars['String']['input']>;
};

export type ModeratorAction = {
  __typename?: 'ModeratorAction';
  _id: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  endedAt: Maybe<Scalars['Date']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  type: ModeratorActionType;
  user: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type ModeratorActionOutput = {
  __typename?: 'ModeratorActionOutput';
  data: Maybe<ModeratorAction>;
};

export type ModeratorActionSelector = {
  default?: InputMaybe<EmptyViewInput>;
  restrictionModerationActions?: InputMaybe<EmptyViewInput>;
  userModeratorActions?: InputMaybe<ModeratorActionsUserModeratorActionsInput>;
};

export type ModeratorActionType =
  | 'autoBlockedFromSendingDMs'
  | 'autoPurgedProfileSpam'
  | 'exemptFromRateLimits'
  | 'flaggedForNDMs'
  | 'lowAverageKarmaCommentAlert'
  | 'lowAverageKarmaPostAlert'
  | 'manualFlag'
  | 'manualNeedsReview'
  | 'manualRateLimitExpired'
  | 'movedPostToDraft'
  | 'negativeUserKarmaAlert'
  | 'potentialTargetedDownvoting'
  | 'rateLimitOnePerDay'
  | 'rateLimitOnePerFortnight'
  | 'rateLimitOnePerMonth'
  | 'rateLimitOnePerThreeDays'
  | 'rateLimitOnePerWeek'
  | 'rateLimitThreeCommentsPerPost'
  | 'receivedSeniorDownvotesAlert'
  | 'recentlyDownvotedContentAlert'
  | 'rejectedComment'
  | 'rejectedPost'
  | 'sentModeratorMessage'
  | 'snoozeExpired'
  | 'stricterCommentAutomodRateLimit'
  | 'stricterPostAutomodRateLimit'
  | 'unreviewedBioUpdate'
  | 'unreviewedComment'
  | 'unreviewedFirstComment'
  | 'unreviewedFirstPost'
  | 'unreviewedMapLocationUpdate'
  | 'unreviewedPost'
  | 'unreviewedProfileImageUpdate'
  | 'votingDisabled'
  | 'votingPatternWarningDelivered';

export type ModeratorActionsUserModeratorActionsInput = {
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ModeratorIPAddressInfo = {
  __typename?: 'ModeratorIPAddressInfo';
  ip: Scalars['String']['output'];
  userIds: Array<Scalars['String']['output']>;
};

export type MultiArbitalTagContentRelInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiArbitalTagContentRelOutput = {
  __typename?: 'MultiArbitalTagContentRelOutput';
  results: Array<ArbitalTagContentRel>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiBanInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiBanOutput = {
  __typename?: 'MultiBanOutput';
  results: Array<Ban>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiBookInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiBookOutput = {
  __typename?: 'MultiBookOutput';
  results: Array<Book>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiBookmarkInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiBookmarkOutput = {
  __typename?: 'MultiBookmarkOutput';
  results: Array<Bookmark>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiChapterInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiChapterOutput = {
  __typename?: 'MultiChapterOutput';
  results: Array<Chapter>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiCkEditorUserSessionInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiCkEditorUserSessionOutput = {
  __typename?: 'MultiCkEditorUserSessionOutput';
  results: Array<CkEditorUserSession>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiClientIdInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiClientIdOutput = {
  __typename?: 'MultiClientIdOutput';
  results: Array<ClientId>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiCollectionInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiCollectionOutput = {
  __typename?: 'MultiCollectionOutput';
  results: Array<Collection>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiCommentInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiCommentModeratorActionInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiCommentModeratorActionOutput = {
  __typename?: 'MultiCommentModeratorActionOutput';
  results: Array<CommentModeratorAction>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiCommentOutput = {
  __typename?: 'MultiCommentOutput';
  results: Array<Comment>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiConversationInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiConversationOutput = {
  __typename?: 'MultiConversationOutput';
  results: Array<Conversation>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiCurationNoticeInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiCurationNoticeOutput = {
  __typename?: 'MultiCurationNoticeOutput';
  results: Array<CurationNotice>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiDialogueCheckInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiDialogueCheckOutput = {
  __typename?: 'MultiDialogueCheckOutput';
  results: Array<DialogueCheck>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiDialogueMatchPreferenceInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiDialogueMatchPreferenceOutput = {
  __typename?: 'MultiDialogueMatchPreferenceOutput';
  results: Array<DialogueMatchPreference>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiDocument = {
  __typename?: 'MultiDocument';
  _id: Scalars['String']['output'];
  afBaseScore: Maybe<Scalars['Float']['output']>;
  afExtendedScore: Maybe<Scalars['JSON']['output']>;
  afVoteCount: Maybe<Scalars['Float']['output']>;
  arbitalLinkedPages: Maybe<ArbitalLinkedPages>;
  baseScore: Scalars['Float']['output'];
  collectionName: MultiDocumentCollectionName;
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  contributionStats: Maybe<Scalars['JSON']['output']>;
  contributors: Maybe<TagContributorsList>;
  createdAt: Scalars['Date']['output'];
  currentUserExtendedVote: Maybe<Scalars['JSON']['output']>;
  currentUserVote: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  extendedScore: Maybe<Scalars['JSON']['output']>;
  fieldName: MultiDocumentFieldName;
  htmlWithContributorAnnotations: Maybe<Scalars['String']['output']>;
  index: Scalars['Float']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  oldSlugs: Array<Scalars['String']['output']>;
  parentDocumentId: Scalars['String']['output'];
  parentLens: Maybe<MultiDocument>;
  parentTag: Maybe<Tag>;
  pingbacks: Maybe<Scalars['JSON']['output']>;
  preview: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  summaries: Array<MultiDocument>;
  tabSubtitle: Maybe<Scalars['String']['output']>;
  tabTitle: Scalars['String']['output'];
  tableOfContents: Maybe<Scalars['JSON']['output']>;
  textLastUpdatedAt: Maybe<Scalars['Date']['output']>;
  title: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
  userId: Scalars['String']['output'];
  voteCount: Scalars['Float']['output'];
};


export type MultiDocumentcontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MultiDocumentcontributorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MultiDocumenttableOfContentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type MultiDocumentCollectionName =
  | 'MultiDocuments'
  | 'Tags';

export type MultiDocumentDefaultViewInput = {
  excludedDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MultiDocumentFieldName =
  | 'description'
  | 'summary';

export type MultiDocumentOutput = {
  __typename?: 'MultiDocumentOutput';
  data: Maybe<MultiDocument>;
};

export type MultiDocumentSelector = {
  default?: InputMaybe<MultiDocumentDefaultViewInput>;
  lensBySlug?: InputMaybe<MultiDocumentsLensBySlugInput>;
  pingbackLensPages?: InputMaybe<MultiDocumentsPingbackLensPagesInput>;
  summariesByParentId?: InputMaybe<MultiDocumentsSummariesByParentIdInput>;
};

export type MultiDocumentType =
  | 'lens'
  | 'summary';

export type MultiDocumentsLensBySlugInput = {
  excludedDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type MultiDocumentsPingbackLensPagesInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  excludedDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MultiDocumentsSummariesByParentIdInput = {
  excludedDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  parentDocumentId?: InputMaybe<Scalars['String']['input']>;
};

export type MultiElicitQuestionInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiElicitQuestionOutput = {
  __typename?: 'MultiElicitQuestionOutput';
  results: Array<ElicitQuestion>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiElicitQuestionPredictionInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiElicitQuestionPredictionOutput = {
  __typename?: 'MultiElicitQuestionPredictionOutput';
  results: Array<ElicitQuestionPrediction>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiFieldChangeInput = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiFieldChangeOutput = {
  __typename?: 'MultiFieldChangeOutput';
  results: Array<FieldChange>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiGoogleServiceAccountSessionInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiGoogleServiceAccountSessionOutput = {
  __typename?: 'MultiGoogleServiceAccountSessionOutput';
  results: Array<GoogleServiceAccountSession>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiIframeWidgetSrcdocOutput = {
  __typename?: 'MultiIframeWidgetSrcdocOutput';
  results: Array<IframeWidgetSrcdoc>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiJargonTermInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiJargonTermOutput = {
  __typename?: 'MultiJargonTermOutput';
  results: Array<JargonTerm>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiLWEventInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiLWEventOutput = {
  __typename?: 'MultiLWEventOutput';
  results: Array<LWEvent>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiLlmConversationInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiLlmConversationOutput = {
  __typename?: 'MultiLlmConversationOutput';
  results: Array<LlmConversation>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiLocalgroupInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiLocalgroupOutput = {
  __typename?: 'MultiLocalgroupOutput';
  results: Array<Localgroup>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiMessageInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiMessageOutput = {
  __typename?: 'MultiMessageOutput';
  results: Array<Message>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiModerationTemplateInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiModerationTemplateOutput = {
  __typename?: 'MultiModerationTemplateOutput';
  results: Array<ModerationTemplate>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiModeratorActionInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiModeratorActionOutput = {
  __typename?: 'MultiModeratorActionOutput';
  results: Array<ModeratorAction>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiMultiDocumentInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiMultiDocumentOutput = {
  __typename?: 'MultiMultiDocumentOutput';
  results: Array<MultiDocument>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiNotificationInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiNotificationOutput = {
  __typename?: 'MultiNotificationOutput';
  results: Array<Notification>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiPetrovDayActionInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiPetrovDayActionOutput = {
  __typename?: 'MultiPetrovDayActionOutput';
  results: Array<PetrovDayAction>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiPodcastEpisodeInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiPodcastEpisodeOutput = {
  __typename?: 'MultiPodcastEpisodeOutput';
  results: Array<PodcastEpisode>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiPodcastInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiPodcastOutput = {
  __typename?: 'MultiPodcastOutput';
  results: Array<Podcast>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiPostAnalyticsResult = {
  __typename?: 'MultiPostAnalyticsResult';
  posts: Maybe<Array<Maybe<PostAnalytics2Result>>>;
  totalCount: Scalars['Int']['output'];
};

export type MultiPostInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiPostOutput = {
  __typename?: 'MultiPostOutput';
  results: Array<Post>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiPostRelationInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiPostRelationOutput = {
  __typename?: 'MultiPostRelationOutput';
  results: Array<PostRelation>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiRSSFeedInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiRSSFeedOutput = {
  __typename?: 'MultiRSSFeedOutput';
  results: Array<RSSFeed>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiReportInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiReportOutput = {
  __typename?: 'MultiReportOutput';
  results: Array<Report>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiResearchConversationEventInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiResearchConversationEventOutput = {
  __typename?: 'MultiResearchConversationEventOutput';
  results: Array<ResearchConversationEvent>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiResearchConversationInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiResearchConversationOutput = {
  __typename?: 'MultiResearchConversationOutput';
  results: Array<ResearchConversation>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiResearchDocumentInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiResearchDocumentOutput = {
  __typename?: 'MultiResearchDocumentOutput';
  results: Array<ResearchDocument>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiResearchEnvironmentInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiResearchEnvironmentOutput = {
  __typename?: 'MultiResearchEnvironmentOutput';
  results: Array<ResearchEnvironment>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiResearchProjectInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiResearchProjectOutput = {
  __typename?: 'MultiResearchProjectOutput';
  results: Array<ResearchProject>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiReviewVoteInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiReviewVoteOutput = {
  __typename?: 'MultiReviewVoteOutput';
  results: Array<ReviewVote>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiReviewWinnerArtInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiReviewWinnerArtOutput = {
  __typename?: 'MultiReviewWinnerArtOutput';
  results: Array<ReviewWinnerArt>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiReviewWinnerInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiReviewWinnerOutput = {
  __typename?: 'MultiReviewWinnerOutput';
  results: Array<ReviewWinner>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiRevisionInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiRevisionOutput = {
  __typename?: 'MultiRevisionOutput';
  results: Array<Revision>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiSequenceInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiSequenceOutput = {
  __typename?: 'MultiSequenceOutput';
  results: Array<Sequence>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiSplashArtCoordinateInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiSplashArtCoordinateOutput = {
  __typename?: 'MultiSplashArtCoordinateOutput';
  results: Array<SplashArtCoordinate>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiSpotlightInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiSpotlightOutput = {
  __typename?: 'MultiSpotlightOutput';
  results: Array<Spotlight>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiSubscriptionInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiSubscriptionOutput = {
  __typename?: 'MultiSubscriptionOutput';
  results: Array<Subscription>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiTagFlagInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiTagFlagOutput = {
  __typename?: 'MultiTagFlagOutput';
  results: Array<TagFlag>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiTagInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiTagOutput = {
  __typename?: 'MultiTagOutput';
  results: Array<Tag>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiTagRelInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiTagRelOutput = {
  __typename?: 'MultiTagRelOutput';
  results: Array<TagRel>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiTypingIndicatorInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiTypingIndicatorOutput = {
  __typename?: 'MultiTypingIndicatorOutput';
  results: Array<TypingIndicator>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiTypoSuggestionInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiTypoSuggestionOutput = {
  __typename?: 'MultiTypoSuggestionOutput';
  results: Array<TypoSuggestion>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiUltraFeedEventInput = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiUltraFeedEventOutput = {
  __typename?: 'MultiUltraFeedEventOutput';
  results: Array<UltraFeedEvent>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiUserInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiUserMostValuablePostInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiUserMostValuablePostOutput = {
  __typename?: 'MultiUserMostValuablePostOutput';
  results: Array<UserMostValuablePost>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiUserOutput = {
  __typename?: 'MultiUserOutput';
  results: Array<User>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiUserRateLimitInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiUserRateLimitOutput = {
  __typename?: 'MultiUserRateLimitOutput';
  results: Array<UserRateLimit>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiUserTagRelInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiUserTagRelOutput = {
  __typename?: 'MultiUserTagRelOutput';
  results: Array<UserTagRel>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MultiVoteInput = {
  enableCache?: InputMaybe<Scalars['Boolean']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  terms?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultiVoteOutput = {
  __typename?: 'MultiVoteOutput';
  results: Array<Vote>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  AddGivingSeasonHeart: Array<GivingSeasonHeart>;
  CancelRSVPToEvent: Maybe<Post>;
  ImportGoogleDoc: Maybe<Post>;
  MakeElicitPrediction: Maybe<ElicitBlockData>;
  MarkAllNotificationsAsRead: Maybe<Scalars['Boolean']['output']>;
  MergeAccounts: MergeAccountsResult;
  NewUserCompleteProfile: Maybe<NewUserCompletedProfile>;
  PetrovDayLaunchMissile: Maybe<PetrovDayLaunchMissileData>;
  RSVPToEvent: Maybe<Post>;
  RefreshDbSettings: Maybe<Scalars['Boolean']['output']>;
  RemoveGivingSeasonHeart: Array<GivingSeasonHeart>;
  SoftDeleteUser: Scalars['Boolean']['output'];
  UpdateSearchSynonyms: Array<Scalars['String']['output']>;
  UserExpandFrontpageSection: Maybe<Scalars['Boolean']['output']>;
  UserUpdateSubforumMembership: Maybe<User>;
  acceptTypoSuggestion: TypoSuggestion;
  addOrUpvoteTag: Maybe<TagRel>;
  addTags: Maybe<Scalars['Boolean']['output']>;
  adminSendBulkEmail: AdminSendBulkEmailResult;
  adminSendTestEmail: AdminSendTestEmailResult;
  alignmentComment: Maybe<Comment>;
  alignmentPost: Maybe<Post>;
  analyticsEvent: Maybe<Scalars['Boolean']['output']>;
  answerResearchConversationQuestion: Maybe<AnswerResearchQuestionOutput>;
  approveUserCurrentContentOnly: Scalars['Boolean']['output'];
  cancelResearchConversation: Maybe<ResearchConversationOutput>;
  clickRecommendation: Maybe<Scalars['Boolean']['output']>;
  connectCrossposter: Maybe<Scalars['String']['output']>;
  continueResearchConversation: Maybe<ResearchConversationOutput>;
  convertDocumentEditorType: Maybe<Scalars['JSON']['output']>;
  createBook: Maybe<BookOutput>;
  createChapter: Maybe<ChapterOutput>;
  createCollection: Maybe<CollectionOutput>;
  createComment: Maybe<CommentOutput>;
  createCommentModeratorAction: Maybe<CommentModeratorActionOutput>;
  createConversation: Maybe<ConversationOutput>;
  createCurationNotice: Maybe<CurationNoticeOutput>;
  createElicitQuestion: Maybe<ElicitQuestionOutput>;
  createJargonTerm: Maybe<JargonTermOutput>;
  createLWEvent: Maybe<LWEventOutput>;
  createLocalgroup: Maybe<LocalgroupOutput>;
  createMessage: Maybe<MessageOutput>;
  createModerationTemplate: Maybe<ModerationTemplateOutput>;
  createModeratorAction: Maybe<ModeratorActionOutput>;
  createMultiDocument: Maybe<MultiDocumentOutput>;
  createPetrovDayAction: Maybe<PetrovDayActionOutput>;
  createPodcastEpisode: Maybe<PodcastEpisodeOutput>;
  createPost: Maybe<PostOutput>;
  createRSSFeed: Maybe<RSSFeedOutput>;
  createReport: Maybe<ReportOutput>;
  createResearchDocument: Maybe<ResearchDocumentOutput>;
  createResearchProject: Maybe<ResearchProjectOutput>;
  createSequence: Maybe<SequenceOutput>;
  createSplashArtCoordinate: Maybe<SplashArtCoordinateOutput>;
  createSpotlight: Maybe<SpotlightOutput>;
  createSubscription: Maybe<SubscriptionOutput>;
  createTag: Maybe<TagOutput>;
  createTagFlag: Maybe<TagFlagOutput>;
  createUltraFeedEvent: Maybe<UltraFeedEventOutput>;
  createUser: Maybe<UserOutput>;
  createUserMostValuablePost: Maybe<UserMostValuablePostOutput>;
  createUserRateLimit: Maybe<UserRateLimitOutput>;
  createUserTagRel: Maybe<UserTagRelOutput>;
  deleteChapter: Scalars['Boolean']['output'];
  dismissRecommendation: Maybe<Scalars['Boolean']['output']>;
  ensureResearchScratchDocument: Maybe<EnsureResearchScratchDocumentOutput>;
  fireResearchConversation: Maybe<ResearchConversationOutput>;
  flipSplashArtImage: Maybe<Scalars['Boolean']['output']>;
  generateCoverImagesForPost: Maybe<Array<Maybe<ReviewWinnerArt>>>;
  getClaudeAccessLink: Maybe<Scalars['String']['output']>;
  getNewJargonTerms: Maybe<Array<Maybe<JargonTerm>>>;
  importUrlAsDraftPost: ExternalPostImportData;
  increasePostViewCount: Maybe<Scalars['Float']['output']>;
  initiateConversation: Maybe<Conversation>;
  karmaChangesChecked: Scalars['Boolean']['output'];
  lockThread: Scalars['Boolean']['output'];
  login: Maybe<LoginReturnData>;
  logout: Maybe<LoginReturnData>;
  markAsReadOrUnread: Maybe<Scalars['Boolean']['output']>;
  markConversationRead: Scalars['Boolean']['output'];
  markPostCommentsRead: Maybe<Scalars['Boolean']['output']>;
  markResearchConversationRead: Maybe<MarkResearchConversationReadOutput>;
  mergeTags: Maybe<Scalars['Boolean']['output']>;
  mintDevPreviewUrl: Maybe<DevPreviewUrlOutput>;
  moderateComment: Maybe<Comment>;
  moveSequencePost: Scalars['Boolean']['output'];
  observeRecommendation: Maybe<Scalars['Boolean']['output']>;
  performVoteComment: Maybe<VoteResultComment>;
  performVoteMessage: Maybe<VoteResultMessage>;
  performVoteMultiDocument: Maybe<VoteResultMultiDocument>;
  performVotePost: Maybe<VoteResultPost>;
  performVoteRevision: Maybe<VoteResultRevision>;
  performVoteTag: Maybe<VoteResultTag>;
  performVoteTagRel: Maybe<VoteResultTagRel>;
  promoteLensToMain: Maybe<Scalars['Boolean']['output']>;
  publishAndDeDuplicateSpotlight: Maybe<Spotlight>;
  publishHomePageDesign: Maybe<HomePageDesignMutationOutput>;
  rejectContentAndRemoveUserFromQueue: Scalars['Boolean']['output'];
  rejectTypoSuggestion: TypoSuggestion;
  reorderResearchDocuments: Maybe<ReorderResearchDocumentsOutput>;
  reorderSummaries: Maybe<Scalars['Boolean']['output']>;
  rerunLlmCheck: AutomatedContentEvaluation;
  resetPassword: Maybe<Scalars['String']['output']>;
  restartResearchSandbox: Maybe<RestartResearchSandboxOutput>;
  resyncRssFeed: Scalars['Boolean']['output'];
  revertPostToRevision: Maybe<Post>;
  revertTagToRevision: Maybe<Tag>;
  runLlmCheckForDocument: AutomatedContentEvaluation;
  runPangramOnText: PangramTextEvaluationResult;
  saveResearchEnvironment: Maybe<SaveResearchEnvironmentOutput>;
  sendEventTriggeredDM: Scalars['Boolean']['output'];
  sendNewDialogueMessageNotification: Scalars['Boolean']['output'];
  setClaudeCodeOAuthToken: Maybe<SetClaudeCodeOAuthTokenOutput>;
  setHomePageDesignVerified: Maybe<HomePageDesign>;
  setIsBookmarked: Maybe<SetIsBookmarkedOutput>;
  setIsHidden: User;
  setVoteComment: Maybe<Comment>;
  setVoteMessage: Maybe<Message>;
  setVoteMultiDocument: Maybe<MultiDocument>;
  setVotePost: Maybe<Post>;
  setVoteRevision: Maybe<Revision>;
  setVoteTag: Maybe<Tag>;
  setVoteTagRel: Maybe<TagRel>;
  signup: Maybe<LoginReturnData>;
  submitReviewVote: Maybe<Post>;
  toggleBookmark: Maybe<ToggleBookmarkOutput>;
  unlinkCrossposter: Maybe<Scalars['String']['output']>;
  unlistLlmPost: Scalars['Boolean']['output'];
  unlockPost: Maybe<Post>;
  unlockThread: Scalars['Boolean']['output'];
  updateBook: Maybe<BookOutput>;
  updateChapter: Maybe<ChapterOutput>;
  updateCollection: Maybe<CollectionOutput>;
  updateComment: Maybe<CommentOutput>;
  updateCommentModeratorAction: Maybe<CommentModeratorActionOutput>;
  updateContinueReading: Maybe<Scalars['Boolean']['output']>;
  updateConversation: Maybe<ConversationOutput>;
  updateCurationNotice: Maybe<CurationNoticeOutput>;
  updateElicitQuestion: Maybe<ElicitQuestionOutput>;
  updateJargonTerm: Maybe<JargonTermOutput>;
  updateLlmConversation: Maybe<LlmConversationOutput>;
  updateLocalgroup: Maybe<LocalgroupOutput>;
  updateMessage: Maybe<MessageOutput>;
  updateModerationTemplate: Maybe<ModerationTemplateOutput>;
  updateModeratorAction: Maybe<ModeratorActionOutput>;
  updateMultiDocument: Maybe<MultiDocumentOutput>;
  updateNotification: Maybe<NotificationOutput>;
  updatePost: Maybe<PostOutput>;
  updateRSSFeed: Maybe<RSSFeedOutput>;
  updateReport: Maybe<ReportOutput>;
  updateResearchConversation: Maybe<ResearchConversationOutput>;
  updateResearchDocument: Maybe<ResearchDocumentOutput>;
  updateResearchEnvironment: Maybe<ResearchEnvironmentOutput>;
  updateResearchProject: Maybe<ResearchProjectOutput>;
  updateRevision: Maybe<RevisionOutput>;
  updateSequence: Maybe<SequenceOutput>;
  updateSpotlight: Maybe<SpotlightOutput>;
  updateTag: Maybe<TagOutput>;
  updateTagFlag: Maybe<TagFlagOutput>;
  updateUltraFeedEvent: Maybe<UltraFeedEventOutput>;
  updateUser: Maybe<UserOutput>;
  updateUserMostValuablePost: Maybe<UserMostValuablePostOutput>;
  updateUserRateLimit: Maybe<UserRateLimitOutput>;
  updateUserTagRel: Maybe<UserTagRelOutput>;
  upscaleReviewWinnerArt: Maybe<ReviewWinnerArt>;
  useEmailToken: Maybe<Scalars['JSON']['output']>;
};


export type MutationAddGivingSeasonHeartArgs = {
  electionName: Scalars['String']['input'];
  theta: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};


export type MutationCancelRSVPToEventArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportGoogleDocArgs = {
  fileUrl: Scalars['String']['input'];
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMakeElicitPredictionArgs = {
  prediction?: InputMaybe<Scalars['Int']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMergeAccountsArgs = {
  dryRun: Scalars['Boolean']['input'];
  sourceUserId: Scalars['String']['input'];
  targetUserId: Scalars['String']['input'];
};


export type MutationNewUserCompleteProfileArgs = {
  acceptedTos?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  subscribeToDigest: Scalars['Boolean']['input'];
  username: Scalars['String']['input'];
};


export type MutationPetrovDayLaunchMissileArgs = {
  launchCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRSVPToEventArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveGivingSeasonHeartArgs = {
  electionName: Scalars['String']['input'];
};


export type MutationSoftDeleteUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationUpdateSearchSynonymsArgs = {
  synonyms: Array<Scalars['String']['input']>;
};


export type MutationUserExpandFrontpageSectionArgs = {
  expanded: Scalars['Boolean']['input'];
  section: Scalars['String']['input'];
};


export type MutationUserUpdateSubforumMembershipArgs = {
  member: Scalars['Boolean']['input'];
  tagId: Scalars['String']['input'];
};


export type MutationacceptTypoSuggestionArgs = {
  mode: TypoAcceptMode;
  suggestionId: Scalars['String']['input'];
};


export type MutationaddOrUpvoteTagArgs = {
  postId?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationaddTagsArgs = {
  postId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationadminSendBulkEmailArgs = {
  input: AdminSendBulkEmailInput;
};


export type MutationadminSendTestEmailArgs = {
  input: AdminSendTestEmailInput;
};


export type MutationalignmentCommentArgs = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationalignmentPostArgs = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationanalyticsEventArgs = {
  events?: InputMaybe<Array<Scalars['JSON']['input']>>;
  now?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationanswerResearchConversationQuestionArgs = {
  answersJson: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
  toolUseId: Scalars['String']['input'];
};


export type MutationapproveUserCurrentContentOnlyArgs = {
  userId: Scalars['String']['input'];
};


export type MutationcancelResearchConversationArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationclickRecommendationArgs = {
  postId: Scalars['String']['input'];
};


export type MutationconnectCrossposterArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcontinueResearchConversationArgs = {
  activeDocumentId: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
  promptHtml: Scalars['String']['input'];
};


export type MutationconvertDocumentEditorTypeArgs = {
  collectionName: ConvertibleCollectionName;
  document: Scalars['JSON']['input'];
  documentId: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  targetFormat: Scalars['String']['input'];
};


export type MutationcreateBookArgs = {
  data: CreateBookDataInput;
};


export type MutationcreateChapterArgs = {
  data: CreateChapterDataInput;
};


export type MutationcreateCollectionArgs = {
  data: CreateCollectionDataInput;
};


export type MutationcreateCommentArgs = {
  data: CreateCommentDataInput;
};


export type MutationcreateCommentModeratorActionArgs = {
  data: CreateCommentModeratorActionDataInput;
};


export type MutationcreateConversationArgs = {
  data: CreateConversationDataInput;
};


export type MutationcreateCurationNoticeArgs = {
  data: CreateCurationNoticeDataInput;
};


export type MutationcreateElicitQuestionArgs = {
  data: CreateElicitQuestionDataInput;
};


export type MutationcreateJargonTermArgs = {
  data: CreateJargonTermDataInput;
};


export type MutationcreateLWEventArgs = {
  data: CreateLWEventDataInput;
};


export type MutationcreateLocalgroupArgs = {
  data: CreateLocalgroupDataInput;
};


export type MutationcreateMessageArgs = {
  data: CreateMessageDataInput;
};


export type MutationcreateModerationTemplateArgs = {
  data: CreateModerationTemplateDataInput;
};


export type MutationcreateModeratorActionArgs = {
  data: CreateModeratorActionDataInput;
};


export type MutationcreateMultiDocumentArgs = {
  data: CreateMultiDocumentDataInput;
};


export type MutationcreatePetrovDayActionArgs = {
  data: CreatePetrovDayActionDataInput;
};


export type MutationcreatePodcastEpisodeArgs = {
  data: CreatePodcastEpisodeDataInput;
};


export type MutationcreatePostArgs = {
  data: CreatePostDataInput;
};


export type MutationcreateRSSFeedArgs = {
  data: CreateRSSFeedDataInput;
};


export type MutationcreateReportArgs = {
  data: CreateReportDataInput;
};


export type MutationcreateResearchDocumentArgs = {
  data: CreateResearchDocumentDataInput;
};


export type MutationcreateResearchProjectArgs = {
  data: CreateResearchProjectDataInput;
};


export type MutationcreateSequenceArgs = {
  data: CreateSequenceDataInput;
};


export type MutationcreateSplashArtCoordinateArgs = {
  data: CreateSplashArtCoordinateDataInput;
};


export type MutationcreateSpotlightArgs = {
  data: CreateSpotlightDataInput;
};


export type MutationcreateSubscriptionArgs = {
  data: CreateSubscriptionDataInput;
};


export type MutationcreateTagArgs = {
  data: CreateTagDataInput;
};


export type MutationcreateTagFlagArgs = {
  data: CreateTagFlagDataInput;
};


export type MutationcreateUltraFeedEventArgs = {
  data: CreateUltraFeedEventDataInput;
};


export type MutationcreateUserArgs = {
  data: CreateUserDataInput;
};


export type MutationcreateUserMostValuablePostArgs = {
  data: CreateUserMostValuablePostDataInput;
};


export type MutationcreateUserRateLimitArgs = {
  data: CreateUserRateLimitDataInput;
};


export type MutationcreateUserTagRelArgs = {
  data: CreateUserTagRelDataInput;
};


export type MutationdeleteChapterArgs = {
  chapterId: Scalars['String']['input'];
};


export type MutationdismissRecommendationArgs = {
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationensureResearchScratchDocumentArgs = {
  projectId: Scalars['String']['input'];
};


export type MutationfireResearchConversationArgs = {
  input: FireResearchConversationInput;
};


export type MutationflipSplashArtImageArgs = {
  reviewWinnerArtId: Scalars['String']['input'];
};


export type MutationgenerateCoverImagesForPostArgs = {
  postId: Scalars['String']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationgetNewJargonTermsArgs = {
  exampleAltTerm?: InputMaybe<Scalars['String']['input']>;
  exampleDefinition?: InputMaybe<Scalars['String']['input']>;
  examplePost?: InputMaybe<Scalars['String']['input']>;
  exampleTerm?: InputMaybe<Scalars['String']['input']>;
  glossaryPrompt?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
};


export type MutationimportUrlAsDraftPostArgs = {
  url: Scalars['String']['input'];
};


export type MutationincreasePostViewCountArgs = {
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationinitiateConversationArgs = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  moderator?: InputMaybe<Scalars['Boolean']['input']>;
  participantIds: Array<Scalars['String']['input']>;
};


export type MutationkarmaChangesCheckedArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationlockThreadArgs = {
  commentId: Scalars['String']['input'];
  until?: InputMaybe<Scalars['String']['input']>;
};


export type MutationloginArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationmarkAsReadOrUnreadArgs = {
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationmarkConversationReadArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationmarkPostCommentsReadArgs = {
  postId: Scalars['String']['input'];
};


export type MutationmarkResearchConversationReadArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationmergeTagsArgs = {
  redirectSource: Scalars['Boolean']['input'];
  sourceTagId: Scalars['String']['input'];
  targetTagId: Scalars['String']['input'];
  transferSubtags: Scalars['Boolean']['input'];
};


export type MutationmintDevPreviewUrlArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationmoderateCommentArgs = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedPublic?: InputMaybe<Scalars['Boolean']['input']>;
  deletedReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationmoveSequencePostArgs = {
  fromChapterId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  toChapterId: Scalars['String']['input'];
  toIndex: Scalars['Int']['input'];
};


export type MutationobserveRecommendationArgs = {
  postId: Scalars['String']['input'];
};


export type MutationperformVoteCommentArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationperformVoteMessageArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationperformVoteMultiDocumentArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationperformVotePostArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationperformVoteRevisionArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationperformVoteTagArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationperformVoteTagRelArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationpromoteLensToMainArgs = {
  lensId: Scalars['String']['input'];
};


export type MutationpublishAndDeDuplicateSpotlightArgs = {
  spotlightId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationpublishHomePageDesignArgs = {
  input: PublishHomePageDesignInput;
};


export type MutationrejectContentAndRemoveUserFromQueueArgs = {
  collectionName: ContentCollectionName;
  documentId: Scalars['String']['input'];
  messageContent?: InputMaybe<Scalars['String']['input']>;
  rejectedReason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationrejectTypoSuggestionArgs = {
  suggestionId: Scalars['String']['input'];
};


export type MutationreorderResearchDocumentsArgs = {
  orderedIds: Array<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
};


export type MutationreorderSummariesArgs = {
  parentDocumentCollectionName: Scalars['String']['input'];
  parentDocumentId: Scalars['String']['input'];
  summaryIds: Array<Scalars['String']['input']>;
};


export type MutationrerunLlmCheckArgs = {
  collectionName: ContentCollectionName;
  documentId: Scalars['String']['input'];
};


export type MutationresetPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationrestartResearchSandboxArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationresyncRssFeedArgs = {
  feedId: Scalars['String']['input'];
};


export type MutationrevertPostToRevisionArgs = {
  postId: Scalars['String']['input'];
  revisionId: Scalars['String']['input'];
};


export type MutationrevertTagToRevisionArgs = {
  revertToRevisionId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};


export type MutationrunLlmCheckForDocumentArgs = {
  collectionName: ContentCollectionName;
  documentId: Scalars['String']['input'];
};


export type MutationrunPangramOnTextArgs = {
  model?: InputMaybe<PangramModel>;
  text: Scalars['String']['input'];
};


export type MutationsaveResearchEnvironmentArgs = {
  conversationId: Scalars['String']['input'];
  withConversation: Scalars['Boolean']['input'];
};


export type MutationsendEventTriggeredDMArgs = {
  eventType: Scalars['String']['input'];
};


export type MutationsendNewDialogueMessageNotificationArgs = {
  dialogueHtml: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};


export type MutationsetClaudeCodeOAuthTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationsetHomePageDesignVerifiedArgs = {
  autoReviewPassed?: InputMaybe<Scalars['Boolean']['input']>;
  designId: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsetIsBookmarkedArgs = {
  input: SetIsBookmarkedInput;
};


export type MutationsetIsHiddenArgs = {
  isHidden: Scalars['Boolean']['input'];
  postId: Scalars['String']['input'];
};


export type MutationsetVoteCommentArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsetVoteMessageArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsetVoteMultiDocumentArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsetVotePostArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsetVoteRevisionArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsetVoteTagArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsetVoteTagRelArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsignupArgs = {
  abTestKey?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  reCaptchaToken?: InputMaybe<Scalars['String']['input']>;
  subscribeToCurated?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsubmitReviewVoteArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dummy?: InputMaybe<Scalars['Boolean']['input']>;
  newQuadraticScore?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  quadraticChange?: InputMaybe<Scalars['Int']['input']>;
  qualitativeScore?: InputMaybe<Scalars['Int']['input']>;
  reactions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type MutationtoggleBookmarkArgs = {
  input: ToggleBookmarkInput;
};


export type MutationunlistLlmPostArgs = {
  modCommentHtml: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};


export type MutationunlockPostArgs = {
  linkSharingKey: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};


export type MutationunlockThreadArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationupdateBookArgs = {
  data: UpdateBookDataInput;
  selector: SelectorInput;
};


export type MutationupdateChapterArgs = {
  data: UpdateChapterDataInput;
  selector: SelectorInput;
};


export type MutationupdateCollectionArgs = {
  data: UpdateCollectionDataInput;
  selector: SelectorInput;
};


export type MutationupdateCommentArgs = {
  data: UpdateCommentDataInput;
  selector: SelectorInput;
};


export type MutationupdateCommentModeratorActionArgs = {
  data: UpdateCommentModeratorActionDataInput;
  selector: SelectorInput;
};


export type MutationupdateContinueReadingArgs = {
  postId: Scalars['String']['input'];
  sequenceId: Scalars['String']['input'];
};


export type MutationupdateConversationArgs = {
  data: UpdateConversationDataInput;
  selector: SelectorInput;
};


export type MutationupdateCurationNoticeArgs = {
  data: UpdateCurationNoticeDataInput;
  selector: SelectorInput;
};


export type MutationupdateElicitQuestionArgs = {
  data: UpdateElicitQuestionDataInput;
  selector: SelectorInput;
};


export type MutationupdateJargonTermArgs = {
  data: UpdateJargonTermDataInput;
  selector: SelectorInput;
};


export type MutationupdateLlmConversationArgs = {
  data: UpdateLlmConversationDataInput;
  selector: SelectorInput;
};


export type MutationupdateLocalgroupArgs = {
  data: UpdateLocalgroupDataInput;
  selector: SelectorInput;
};


export type MutationupdateMessageArgs = {
  data: UpdateMessageDataInput;
  selector: SelectorInput;
};


export type MutationupdateModerationTemplateArgs = {
  data: UpdateModerationTemplateDataInput;
  selector: SelectorInput;
};


export type MutationupdateModeratorActionArgs = {
  data: UpdateModeratorActionDataInput;
  selector: SelectorInput;
};


export type MutationupdateMultiDocumentArgs = {
  data: UpdateMultiDocumentDataInput;
  selector: SelectorInput;
};


export type MutationupdateNotificationArgs = {
  data: UpdateNotificationDataInput;
  selector: SelectorInput;
};


export type MutationupdatePostArgs = {
  data: UpdatePostDataInput;
  selector: SelectorInput;
};


export type MutationupdateRSSFeedArgs = {
  data: UpdateRSSFeedDataInput;
  selector: SelectorInput;
};


export type MutationupdateReportArgs = {
  data: UpdateReportDataInput;
  selector: SelectorInput;
};


export type MutationupdateResearchConversationArgs = {
  data: UpdateResearchConversationDataInput;
  selector: SelectorInput;
};


export type MutationupdateResearchDocumentArgs = {
  data: UpdateResearchDocumentDataInput;
  selector: SelectorInput;
};


export type MutationupdateResearchEnvironmentArgs = {
  data: UpdateResearchEnvironmentDataInput;
  selector: SelectorInput;
};


export type MutationupdateResearchProjectArgs = {
  data: UpdateResearchProjectDataInput;
  selector: SelectorInput;
};


export type MutationupdateRevisionArgs = {
  data: UpdateRevisionDataInput;
  selector: SelectorInput;
};


export type MutationupdateSequenceArgs = {
  data: UpdateSequenceDataInput;
  selector: SelectorInput;
};


export type MutationupdateSpotlightArgs = {
  data: UpdateSpotlightDataInput;
  selector: SelectorInput;
};


export type MutationupdateTagArgs = {
  data: UpdateTagDataInput;
  selector: SelectorInput;
};


export type MutationupdateTagFlagArgs = {
  data: UpdateTagFlagDataInput;
  selector: SelectorInput;
};


export type MutationupdateUltraFeedEventArgs = {
  data: UpdateUltraFeedEventDataInput;
  selector: Scalars['String']['input'];
};


export type MutationupdateUserArgs = {
  data: UpdateUserDataInput;
  selector: SelectorInput;
};


export type MutationupdateUserMostValuablePostArgs = {
  data: UpdateUserMostValuablePostDataInput;
  selector: SelectorInput;
};


export type MutationupdateUserRateLimitArgs = {
  data: UpdateUserRateLimitDataInput;
  selector: SelectorInput;
};


export type MutationupdateUserTagRelArgs = {
  data: UpdateUserTagRelDataInput;
  selector: SelectorInput;
};


export type MutationupscaleReviewWinnerArtArgs = {
  reviewWinnerArtId: Scalars['String']['input'];
};


export type MutationuseEmailTokenArgs = {
  args?: InputMaybe<Scalars['JSON']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MyDialoguesResult = {
  __typename?: 'MyDialoguesResult';
  results: Array<Post>;
};

export type NetKarmaChangesForAuthorsOverPeriod = {
  __typename?: 'NetKarmaChangesForAuthorsOverPeriod';
  netKarma: Maybe<Scalars['Int']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type NewUserCompletedProfile = {
  __typename?: 'NewUserCompletedProfile';
  displayName: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
  usernameUnset: Maybe<Scalars['Boolean']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  _id: Scalars['String']['output'];
  createdAt: Maybe<Scalars['Date']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  documentId: Maybe<Scalars['String']['output']>;
  documentType: Maybe<Scalars['String']['output']>;
  emailed: Maybe<Scalars['Boolean']['output']>;
  extraData: Maybe<Scalars['JSON']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  link: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
  viewed: Maybe<Scalars['Boolean']['output']>;
  waitingForBatch: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationCounts = {
  __typename?: 'NotificationCounts';
  checkedAt: Scalars['Date']['output'];
  faviconBadgeNumber: Scalars['Int']['output'];
  unreadNotifications: Scalars['Int']['output'];
  unreadPrivateMessages: Scalars['Int']['output'];
};

export type NotificationDisplaysResult = {
  __typename?: 'NotificationDisplaysResult';
  results: Array<Scalars['JSON']['output']>;
};

export type NotificationOutput = {
  __typename?: 'NotificationOutput';
  data: Maybe<Notification>;
};

export type NotificationSelector = {
  adminAlertNotifications?: InputMaybe<NotificationsAdminAlertNotificationsInput>;
  default?: InputMaybe<EmptyViewInput>;
  unreadUserNotifications?: InputMaybe<NotificationsUnreadUserNotificationsInput>;
  userNotifications?: InputMaybe<NotificationsUserNotificationsInput>;
};

export type NotificationsAdminAlertNotificationsInput = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationsUnreadUserNotificationsInput = {
  lastViewedDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationsUserNotificationsInput = {
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  viewed?: InputMaybe<Scalars['String']['input']>;
};

export type OAuthAccessToken = {
  __typename?: 'OAuthAccessToken';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
};

export type OAuthAuthorizationCode = {
  __typename?: 'OAuthAuthorizationCode';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
};

export type OAuthClient = {
  __typename?: 'OAuthClient';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
};

export type PangramModel =
  | 'pangram3'
  | 'pangram4';

export type PangramTextEvaluationResult = {
  __typename?: 'PangramTextEvaluationResult';
  analyzedText: Scalars['String']['output'];
  pangramApiVersion: Scalars['String']['output'];
  pangramMaxScore: Maybe<Scalars['Float']['output']>;
  pangramPrediction: Maybe<Scalars['String']['output']>;
  pangramScore: Scalars['Float']['output'];
  pangramWindowScores: Maybe<Array<PangramWindowScore>>;
};

export type PangramWindowScore = {
  __typename?: 'PangramWindowScore';
  confidence: Maybe<Scalars['String']['output']>;
  endIndex: Scalars['Int']['output'];
  label: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  startIndex: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  wordCount: Maybe<Scalars['Int']['output']>;
};

export type PartiallyReadSequenceItemInput = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  lastReadPostId: Scalars['String']['input'];
  lastReadTime?: InputMaybe<Scalars['Date']['input']>;
  nextPostId: Scalars['String']['input'];
  numRead: Scalars['Int']['input'];
  numTotal: Scalars['Int']['input'];
  sequenceId?: InputMaybe<Scalars['String']['input']>;
};

export type PartiallyReadSequenceItemOutput = {
  __typename?: 'PartiallyReadSequenceItemOutput';
  collectionId: Maybe<Scalars['String']['output']>;
  lastReadPostId: Maybe<Scalars['String']['output']>;
  lastReadTime: Maybe<Scalars['Date']['output']>;
  nextPostId: Maybe<Scalars['String']['output']>;
  numRead: Maybe<Scalars['Int']['output']>;
  numTotal: Maybe<Scalars['Int']['output']>;
  sequenceId: Maybe<Scalars['String']['output']>;
};

export type PetrovDay2024CheckNumberOfIncomingData = {
  __typename?: 'PetrovDay2024CheckNumberOfIncomingData';
  count: Maybe<Scalars['Int']['output']>;
};

export type PetrovDayAction = {
  __typename?: 'PetrovDayAction';
  _id: Scalars['String']['output'];
  actionType: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  data: Maybe<Scalars['JSON']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  userId: Maybe<Scalars['String']['output']>;
};

export type PetrovDayActionOutput = {
  __typename?: 'PetrovDayActionOutput';
  data: Maybe<PetrovDayAction>;
};

export type PetrovDayActionSelector = {
  adminConsole?: InputMaybe<EmptyViewInput>;
  default?: InputMaybe<EmptyViewInput>;
  getAction?: InputMaybe<PetrovDayActionsGetActionInput>;
  launchDashboard?: InputMaybe<PetrovDayActionsLaunchDashboardInput>;
  warningConsole?: InputMaybe<PetrovDayActionsWarningConsoleInput>;
};

export type PetrovDayActionsGetActionInput = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PetrovDayActionsLaunchDashboardInput = {
  side?: InputMaybe<Scalars['String']['input']>;
};

export type PetrovDayActionsWarningConsoleInput = {
  side?: InputMaybe<Scalars['String']['input']>;
};

export type PetrovDayCheckIfIncomingData = {
  __typename?: 'PetrovDayCheckIfIncomingData';
  createdAt: Maybe<Scalars['Date']['output']>;
  launched: Maybe<Scalars['Boolean']['output']>;
};

export type PetrovDayLaunch = {
  __typename?: 'PetrovDayLaunch';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  hashedLaunchCode: Maybe<Scalars['String']['output']>;
  launchCode: Scalars['String']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  userId: Maybe<Scalars['String']['output']>;
};

export type PetrovDayLaunchMissileData = {
  __typename?: 'PetrovDayLaunchMissileData';
  createdAt: Maybe<Scalars['Date']['output']>;
  launchCode: Maybe<Scalars['String']['output']>;
};

export type Podcast = {
  __typename?: 'Podcast';
  _id: Scalars['String']['output'];
  applePodcastLink: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  spotifyPodcastLink: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PodcastEpisode = {
  __typename?: 'PodcastEpisode';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  episodeLink: Scalars['String']['output'];
  externalEpisodeId: Scalars['String']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  podcast: Podcast;
  podcastId: Scalars['String']['output'];
  schemaVersion: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type PodcastEpisodeByExternalIdInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  externalEpisodeId?: InputMaybe<Scalars['String']['input']>;
};

export type PodcastEpisodeOutput = {
  __typename?: 'PodcastEpisodeOutput';
  data: Maybe<PodcastEpisode>;
};

export type PodcastEpisodeSelector = {
  default?: InputMaybe<EmptyViewInput>;
  episodeByExternalId?: InputMaybe<PodcastEpisodeByExternalIdInput>;
};

export type PodcastSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type PopularCommentsResult = {
  __typename?: 'PopularCommentsResult';
  results: Array<Comment>;
};

export type Post = {
  __typename?: 'Post';
  _id: Scalars['String']['output'];
  activateRSVPs: Maybe<Scalars['Boolean']['output']>;
  af: Scalars['Boolean']['output'];
  afBaseScore: Maybe<Scalars['Float']['output']>;
  afCommentCount: Scalars['Float']['output'];
  afDate: Maybe<Scalars['Date']['output']>;
  afExtendedScore: Maybe<Scalars['JSON']['output']>;
  afLastCommentedAt: Maybe<Scalars['Date']['output']>;
  afSticky: Scalars['Boolean']['output'];
  afVoteCount: Maybe<Scalars['Float']['output']>;
  agentFoundationsId: Maybe<Scalars['String']['output']>;
  annualReviewMarketIsResolved: Maybe<Scalars['Boolean']['output']>;
  annualReviewMarketProbability: Maybe<Scalars['Float']['output']>;
  annualReviewMarketUrl: Maybe<Scalars['String']['output']>;
  annualReviewMarketYear: Maybe<Scalars['Int']['output']>;
  author: Maybe<Scalars['String']['output']>;
  authorIsUnreviewed: Scalars['Boolean']['output'];
  autoFrontpage: Maybe<Scalars['String']['output']>;
  automatedContentEvaluations: Maybe<AutomatedContentEvaluation>;
  bannedUserIds: Maybe<Array<Scalars['String']['output']>>;
  baseScore: Scalars['Float']['output'];
  bestAnswer: Maybe<Comment>;
  canonicalBook: Maybe<Book>;
  canonicalBookId: Maybe<Scalars['String']['output']>;
  canonicalCollection: Maybe<Collection>;
  canonicalCollectionSlug: Maybe<Scalars['String']['output']>;
  canonicalNextPostSlug: Maybe<Scalars['String']['output']>;
  canonicalPrevPostSlug: Maybe<Scalars['String']['output']>;
  canonicalSequence: Maybe<Sequence>;
  canonicalSequenceId: Maybe<Scalars['String']['output']>;
  canonicalSource: Maybe<Scalars['String']['output']>;
  clickCount: Maybe<Scalars['Float']['output']>;
  coauthorStatuses: Maybe<Array<CoauthorStatusOutput>>;
  coauthorUserIds: Array<Scalars['String']['output']>;
  coauthors: Maybe<Array<User>>;
  collabEditorDialogue: Scalars['Boolean']['output'];
  collectionTitle: Maybe<Scalars['String']['output']>;
  commentCount: Scalars['Float']['output'];
  commentSortOrder: Maybe<Scalars['String']['output']>;
  commentsLocked: Maybe<Scalars['Boolean']['output']>;
  commentsLockedToAccountsCreatedAfter: Maybe<Scalars['Date']['output']>;
  contactInfo: Maybe<Scalars['String']['output']>;
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  curatedDate: Maybe<Scalars['Date']['output']>;
  curationNotices: Maybe<Array<CurationNotice>>;
  currentUserExtendedVote: Maybe<Scalars['JSON']['output']>;
  currentUserReviewVote: Maybe<ReviewVote>;
  currentUserVote: Maybe<Scalars['String']['output']>;
  customHighlight: Maybe<Revision>;
  customHighlight_latest: Maybe<Scalars['String']['output']>;
  debate: Scalars['Boolean']['output'];
  defaultRecommendation: Scalars['Boolean']['output'];
  deletedDraft: Scalars['Boolean']['output'];
  dialogTooltipPreview: Maybe<Scalars['String']['output']>;
  dialogueMessageContents: Maybe<Scalars['String']['output']>;
  disableRecommendation: Scalars['Boolean']['output'];
  disableSidenotes: Scalars['Boolean']['output'];
  domain: Maybe<Scalars['String']['output']>;
  draft: Maybe<Scalars['Boolean']['output']>;
  emailShareUrl: Maybe<Scalars['String']['output']>;
  endTime: Maybe<Scalars['Date']['output']>;
  eventImageId: Maybe<Scalars['String']['output']>;
  eventRegistrationLink: Maybe<Scalars['String']['output']>;
  eventType: Maybe<Scalars['String']['output']>;
  extendedScore: Maybe<Scalars['JSON']['output']>;
  facebookLink: Maybe<Scalars['String']['output']>;
  facebookShareUrl: Maybe<Scalars['String']['output']>;
  feed: Maybe<RSSFeed>;
  feedId: Maybe<Scalars['String']['output']>;
  feedLink: Maybe<Scalars['String']['output']>;
  finalReviewVoteScoreAF: Scalars['Float']['output'];
  finalReviewVoteScoreAllKarma: Scalars['Float']['output'];
  finalReviewVoteScoreHighKarma: Scalars['Float']['output'];
  finalReviewVotesAF: Array<Scalars['Float']['output']>;
  finalReviewVotesAllKarma: Array<Scalars['Float']['output']>;
  finalReviewVotesHighKarma: Array<Scalars['Float']['output']>;
  firstVideoAttribsForPreview: Maybe<Scalars['JSON']['output']>;
  fmCrosspost: Maybe<CrosspostOutput>;
  forceAllowType3Audio: Scalars['Boolean']['output'];
  frontpageClassification: Maybe<FrontpageClassification>;
  frontpageDate: Maybe<Scalars['Date']['output']>;
  generateDraftJargon: Maybe<Scalars['Boolean']['output']>;
  globalEvent: Scalars['Boolean']['output'];
  glossary: Array<JargonTerm>;
  googleLocation: Maybe<Scalars['JSON']['output']>;
  group: Maybe<Localgroup>;
  groupId: Maybe<Scalars['String']['output']>;
  hasCoauthorPermission: Scalars['Boolean']['output'];
  hiddenRelatedQuestion: Scalars['Boolean']['output'];
  hideAuthor: Scalars['Boolean']['output'];
  hideCommentKarma: Scalars['Boolean']['output'];
  hideFromPopularComments: Maybe<Scalars['Boolean']['output']>;
  hideFromRecentDiscussions: Scalars['Boolean']['output'];
  hideFrontpageComments: Scalars['Boolean']['output'];
  htmlBody: Maybe<Scalars['String']['output']>;
  ignoreRateLimits: Maybe<Scalars['Boolean']['output']>;
  isBookmarked: Scalars['Boolean']['output'];
  isEvent: Scalars['Boolean']['output'];
  isFuture: Scalars['Boolean']['output'];
  isRead: Maybe<Scalars['Boolean']['output']>;
  joinEventLink: Maybe<Scalars['String']['output']>;
  lastCommentPromotedAt: Maybe<Scalars['Date']['output']>;
  lastCommentedAt: Scalars['Date']['output'];
  lastPromotedComment: Maybe<Comment>;
  lastVisitedAt: Maybe<Scalars['Date']['output']>;
  legacy: Scalars['Boolean']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  legacyId: Maybe<Scalars['String']['output']>;
  legacySpam: Scalars['Boolean']['output'];
  linkSharingKey: Maybe<Scalars['String']['output']>;
  linkSharingKeyUsedBy: Maybe<Array<Scalars['String']['output']>>;
  linkUrl: Maybe<Scalars['String']['output']>;
  localEndTime: Maybe<Scalars['Date']['output']>;
  localStartTime: Maybe<Scalars['Date']['output']>;
  location: Maybe<Scalars['String']['output']>;
  manifoldReviewMarketId: Maybe<Scalars['String']['output']>;
  maxBaseScore: Scalars['Float']['output'];
  meetupLink: Maybe<Scalars['String']['output']>;
  meta: Scalars['Boolean']['output'];
  metaDate: Maybe<Scalars['Date']['output']>;
  metaSticky: Scalars['Boolean']['output'];
  moderationGuidelines: Maybe<Revision>;
  moderationGuidelines_latest: Maybe<Scalars['String']['output']>;
  moderationStyle: Maybe<Scalars['String']['output']>;
  modifiedAt: Maybe<Scalars['Date']['output']>;
  mongoLocation: Maybe<Scalars['JSON']['output']>;
  mostRecentPublishedDialogueResponseDate: Maybe<Scalars['Date']['output']>;
  myEditorAccess: Scalars['String']['output'];
  nextDayReminderSent: Scalars['Boolean']['output'];
  nextPost: Maybe<Post>;
  noIndex: Scalars['Boolean']['output'];
  nominationCount2018: Scalars['Float']['output'];
  nominationCount2019: Scalars['Float']['output'];
  onlineEvent: Scalars['Boolean']['output'];
  onlyVisibleToEstablishedAccounts: Scalars['Boolean']['output'];
  onlyVisibleToLoggedIn: Scalars['Boolean']['output'];
  organizerIds: Maybe<Array<Scalars['String']['output']>>;
  organizers: Maybe<Array<User>>;
  originalPostRelationSourceId: Maybe<Scalars['String']['output']>;
  pageUrl: Scalars['String']['output'];
  pageUrlRelative: Maybe<Scalars['String']['output']>;
  pingbacks: Maybe<Scalars['JSON']['output']>;
  podcastEpisode: Maybe<PodcastEpisode>;
  podcastEpisodeId: Maybe<Scalars['String']['output']>;
  positiveReviewVoteCount: Scalars['Float']['output'];
  postCategory: PostCategory;
  postedAt: Scalars['Date']['output'];
  postedAtFormatted: Maybe<Scalars['String']['output']>;
  prevPost: Maybe<Post>;
  question: Scalars['Boolean']['output'];
  readTimeMinutes: Scalars['Int']['output'];
  readTimeMinutesOverride: Maybe<Scalars['Float']['output']>;
  recentComments: Maybe<Array<Comment>>;
  referrer: Maybe<Scalars['String']['output']>;
  rejected: Scalars['Boolean']['output'];
  rejectedByUser: Maybe<User>;
  rejectedByUserId: Maybe<Scalars['String']['output']>;
  rejectedReason: Maybe<Scalars['String']['output']>;
  reviewCount: Scalars['Float']['output'];
  reviewCount2018: Scalars['Float']['output'];
  reviewCount2019: Scalars['Float']['output'];
  reviewForAlignmentUserId: Maybe<Scalars['String']['output']>;
  reviewForCuratedUserId: Maybe<Scalars['String']['output']>;
  reviewVoteCount: Scalars['Float']['output'];
  reviewVoteScoreAF: Scalars['Float']['output'];
  reviewVoteScoreAllKarma: Scalars['Float']['output'];
  reviewVoteScoreHighKarma: Scalars['Float']['output'];
  reviewVotesAF: Array<Scalars['Float']['output']>;
  reviewVotesAllKarma: Array<Scalars['Float']['output']>;
  reviewVotesHighKarma: Array<Scalars['Float']['output']>;
  reviewWinner: Maybe<ReviewWinner>;
  reviewedByUser: Maybe<User>;
  reviewedByUserId: Maybe<Scalars['String']['output']>;
  reviews: Maybe<Array<Comment>>;
  revisions: Maybe<Array<Revision>>;
  rsvpCounts: Scalars['JSON']['output'];
  rsvps: Maybe<Array<Scalars['JSON']['output']>>;
  schemaVersion: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  scoreExceeded2Date: Maybe<Scalars['Date']['output']>;
  scoreExceeded30Date: Maybe<Scalars['Date']['output']>;
  scoreExceeded45Date: Maybe<Scalars['Date']['output']>;
  scoreExceeded75Date: Maybe<Scalars['Date']['output']>;
  scoreExceeded125Date: Maybe<Scalars['Date']['output']>;
  scoreExceeded200Date: Maybe<Scalars['Date']['output']>;
  sequence: Maybe<Sequence>;
  shareWithUsers: Maybe<Array<Scalars['String']['output']>>;
  sharingSettings: Maybe<Scalars['JSON']['output']>;
  shortform: Scalars['Boolean']['output'];
  sideCommentVisibility: Maybe<Scalars['String']['output']>;
  sideComments: Maybe<Scalars['JSON']['output']>;
  sideCommentsCache: Maybe<SideCommentCache>;
  slug: Scalars['String']['output'];
  socialPreview: Maybe<SocialPreviewOutput>;
  socialPreviewData: SocialPreviewType;
  socialPreviewImageAutoUrl: Maybe<Scalars['String']['output']>;
  socialPreviewImageId: Maybe<Scalars['String']['output']>;
  socialPreviewImageUrl: Maybe<Scalars['String']['output']>;
  sourcePostRelations: Array<PostRelation>;
  spotlight: Maybe<Spotlight>;
  startTime: Maybe<Scalars['Date']['output']>;
  status: Scalars['Float']['output'];
  sticky: Scalars['Boolean']['output'];
  stickyPriority: Scalars['Int']['output'];
  subforumTag: Maybe<Tag>;
  subforumTagId: Maybe<Scalars['String']['output']>;
  submitToFrontpage: Scalars['Boolean']['output'];
  suggestForAlignmentUserIds: Array<Scalars['String']['output']>;
  suggestForAlignmentUsers: Array<User>;
  suggestForCuratedUserIds: Maybe<Array<Scalars['String']['output']>>;
  suggestForCuratedUsernames: Maybe<Scalars['String']['output']>;
  swrCachingEnabled: Maybe<Scalars['Boolean']['output']>;
  tableOfContents: Maybe<Scalars['JSON']['output']>;
  tableOfContentsRevision: Maybe<Scalars['JSON']['output']>;
  tagRel: Maybe<TagRel>;
  tagRelevance: Maybe<Scalars['JSON']['output']>;
  tagRels: Array<TagRel>;
  tags: Array<Tag>;
  targetPostRelations: Array<PostRelation>;
  title: Scalars['String']['output'];
  topLevelCommentCount: Scalars['Float']['output'];
  totalDialogueResponseCount: Scalars['Int']['output'];
  twitterShareUrl: Maybe<Scalars['String']['output']>;
  types: Maybe<Array<Scalars['String']['output']>>;
  unlisted: Scalars['Boolean']['output'];
  unreadDebateResponseCount: Scalars['Int']['output'];
  url: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
  userAgent: Maybe<Scalars['String']['output']>;
  userIP: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
  usersSharedWith: Maybe<Array<User>>;
  version: Maybe<Scalars['String']['output']>;
  viewCount: Maybe<Scalars['Float']['output']>;
  voteCount: Scalars['Float']['output'];
  votingSystem: Maybe<Scalars['String']['output']>;
  wasEverUndrafted: Maybe<Scalars['Boolean']['output']>;
  website: Maybe<Scalars['String']['output']>;
  wordCount: Maybe<Scalars['Int']['output']>;
};


export type PostcontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type PostcustomHighlightArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type PostdialogueMessageContentsArgs = {
  dialogueMessageId?: InputMaybe<Scalars['String']['input']>;
};


export type PostmoderationGuidelinesArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type PostnextPostArgs = {
  sequenceId?: InputMaybe<Scalars['String']['input']>;
};


export type PostprevPostArgs = {
  sequenceId?: InputMaybe<Scalars['String']['input']>;
};


export type PostrecentCommentsArgs = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  commentsLimit?: InputMaybe<Scalars['Int']['input']>;
  maxAgeHours?: InputMaybe<Scalars['Int']['input']>;
};


export type PostrevisionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type PostsequenceArgs = {
  prevOrNext?: InputMaybe<Scalars['String']['input']>;
  sequenceId?: InputMaybe<Scalars['String']['input']>;
};


export type PosttableOfContentsRevisionArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type PosttagRelArgs = {
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export type PostAnalytics2Result = {
  __typename?: 'PostAnalytics2Result';
  _id: Maybe<Scalars['String']['output']>;
  comments: Maybe<Scalars['Int']['output']>;
  karma: Maybe<Scalars['Int']['output']>;
  meanReadingTime: Maybe<Scalars['Float']['output']>;
  postedAt: Maybe<Scalars['Date']['output']>;
  reads: Maybe<Scalars['Int']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  uniqueViews: Maybe<Scalars['Int']['output']>;
  views: Maybe<Scalars['Int']['output']>;
};

export type PostAnalyticsResult = {
  __typename?: 'PostAnalyticsResult';
  allViews: Maybe<Scalars['Int']['output']>;
  medianReadingTime: Maybe<Scalars['Int']['output']>;
  uniqueClientViews: Maybe<Scalars['Int']['output']>;
  uniqueClientViews5Min: Maybe<Scalars['Int']['output']>;
  uniqueClientViews10Sec: Maybe<Scalars['Int']['output']>;
  uniqueClientViewsSeries: Maybe<Array<Maybe<UniqueClientViewsSeries>>>;
};

export type PostCategory =
  | 'linkpost'
  | 'post'
  | 'question';

export type PostDefaultViewInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  requiredFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
  requiredUnnominated?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostKarmaChange = {
  __typename?: 'PostKarmaChange';
  _id: Scalars['String']['output'];
  addedReacts: Maybe<Array<ReactionChange>>;
  collectionName: Scalars['String']['output'];
  postId: Scalars['String']['output'];
  scoreChange: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
};

export type PostMetadataInput = {
  postId: Scalars['String']['input'];
};

export type PostMetadataOutput = {
  __typename?: 'PostMetadataOutput';
  postId: Scalars['String']['output'];
};

export type PostOutput = {
  __typename?: 'PostOutput';
  data: Maybe<Post>;
};

export type PostRecommendation = {
  __typename?: 'PostRecommendation';
  _id: Scalars['String']['output'];
  clickedAt: Maybe<Scalars['Date']['output']>;
  clientId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  lastRecommendedAt: Maybe<Scalars['Date']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  post: Maybe<Post>;
  postId: Maybe<Scalars['String']['output']>;
  recommendationCount: Maybe<Scalars['Int']['output']>;
  schemaVersion: Scalars['Float']['output'];
  strategyName: Maybe<Scalars['String']['output']>;
  strategySettings: Maybe<Scalars['JSON']['output']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['String']['output']>;
};

export type PostRelation = {
  __typename?: 'PostRelation';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  order: Maybe<Scalars['Float']['output']>;
  schemaVersion: Scalars['Float']['output'];
  sourcePost: Maybe<Post>;
  sourcePostId: Scalars['String']['output'];
  targetPost: Maybe<Post>;
  targetPostId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PostRelationSelector = {
  allPostRelations?: InputMaybe<PostRelationsAllPostRelationsInput>;
  default?: InputMaybe<EmptyViewInput>;
};

export type PostRelationsAllPostRelationsInput = {
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type PostReviewFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  minKarma?: InputMaybe<Scalars['Int']['input']>;
  showEvents?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type PostReviewSort = {
  karma?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostSelector = {
  afRecentDiscussionThreadsList?: InputMaybe<PostsAfRecentDiscussionThreadsListInput>;
  alignmentSuggestedPosts?: InputMaybe<PostsAlignmentSuggestedPostsInput>;
  all_drafts?: InputMaybe<PostsAll_draftsInput>;
  community?: InputMaybe<PostsCommunityInput>;
  communityResourcePosts?: InputMaybe<PostsCommunityResourcePostsInput>;
  communityRss?: InputMaybe<PostsCommunityRssInput>;
  curated?: InputMaybe<PostsCuratedInput>;
  curatedRss?: InputMaybe<PostsCuratedRssInput>;
  currentOpenThread?: InputMaybe<PostsCurrentOpenThreadInput>;
  daily?: InputMaybe<PostsDailyInput>;
  default?: InputMaybe<PostDefaultViewInput>;
  drafts?: InputMaybe<PostsDraftsInput>;
  events?: InputMaybe<PostsEventsInput>;
  eventsInTimeRange?: InputMaybe<PostsEventsInTimeRangeInput>;
  frontpage?: InputMaybe<PostsFrontpageInput>;
  frontpageReviewWidget?: InputMaybe<PostsFrontpageReviewWidgetInput>;
  frontpageRss?: InputMaybe<PostsFrontpageRssInput>;
  globalEvents?: InputMaybe<PostsGlobalEventsInput>;
  hasEverDialogued?: InputMaybe<PostsHasEverDialoguedInput>;
  legacyIdPost?: InputMaybe<PostsLegacyIdPostInput>;
  magic?: InputMaybe<PostsMagicInput>;
  metaRss?: InputMaybe<PostsMetaRssInput>;
  myBookmarkedPosts?: InputMaybe<PostsMyBookmarkedPostsInput>;
  nearbyEvents?: InputMaybe<PostsNearbyEventsInput>;
  new?: InputMaybe<PostsNewInput>;
  nominatablePostsByVote?: InputMaybe<PostsNominatablePostsByVoteInput>;
  nominations2018?: InputMaybe<PostsNominations2018Input>;
  nominations2019?: InputMaybe<PostsNominations2019Input>;
  nonEventGroupPosts?: InputMaybe<PostsNonEventGroupPostsInput>;
  old?: InputMaybe<PostsOldInput>;
  pastEvents?: InputMaybe<PostsPastEventsInput>;
  pingbackPosts?: InputMaybe<PostsPingbackPostsInput>;
  postsWithBannedUsers?: InputMaybe<PostsPostsWithBannedUsersInput>;
  recentComments?: InputMaybe<PostsRecentCommentsInput>;
  recentDiscussionThreadsList?: InputMaybe<PostsRecentDiscussionThreadsListInput>;
  recentQuestionActivity?: InputMaybe<PostsRecentQuestionActivityInput>;
  rejected?: InputMaybe<PostsRejectedInput>;
  reviewFinalVoting?: InputMaybe<PostsReviewFinalVotingInput>;
  reviewQuickPage?: InputMaybe<PostsReviewQuickPageInput>;
  reviewRecentDiscussionThreadsList2018?: InputMaybe<PostsReviewRecentDiscussionThreadsList2018Input>;
  reviewRecentDiscussionThreadsList2019?: InputMaybe<PostsReviewRecentDiscussionThreadsList2019Input>;
  reviewVoting?: InputMaybe<PostsReviewVotingInput>;
  reviews2018?: InputMaybe<PostsReviews2018Input>;
  reviews2019?: InputMaybe<PostsReviews2019Input>;
  rss?: InputMaybe<PostsRssInput>;
  scheduled?: InputMaybe<PostsScheduledInput>;
  slugPost?: InputMaybe<PostsSlugPostInput>;
  stickied?: InputMaybe<PostsStickiedInput>;
  sunshineAutoClassifiedPosts?: InputMaybe<PostsSunshineAutoClassifiedPostsInput>;
  sunshineCuratedSuggestions?: InputMaybe<PostsSunshineCuratedSuggestionsInput>;
  sunshineNewPosts?: InputMaybe<PostsSunshineNewPostsInput>;
  sunshineNewUsersPosts?: InputMaybe<PostsSunshineNewUsersPostsInput>;
  tagRelevance?: InputMaybe<PostsTagRelevanceInput>;
  tbdEvents?: InputMaybe<PostsTbdEventsInput>;
  timeframe?: InputMaybe<PostsTimeframeInput>;
  top?: InputMaybe<PostsTopInput>;
  topQuestions?: InputMaybe<PostsTopQuestionsInput>;
  unlisted?: InputMaybe<PostsUnlistedInput>;
  upcomingEvents?: InputMaybe<PostsUpcomingEventsInput>;
  userAFSubmissions?: InputMaybe<PostsUserAFSubmissionsInput>;
  userPosts?: InputMaybe<PostsUserPostsInput>;
  voting2019?: InputMaybe<PostsVoting2019Input>;
};

export type PostWithApprovedJargon = {
  __typename?: 'PostWithApprovedJargon';
  jargonTerms: Array<JargonTerm>;
  post: Post;
};

export type PostsAfRecentDiscussionThreadsListInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsAlignmentSuggestedPostsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsAll_draftsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsBySubscribedAuthorsResult = {
  __typename?: 'PostsBySubscribedAuthorsResult';
  results: Array<Post>;
};

export type PostsCommunityInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsCommunityResourcePostsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsCommunityRssInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsCuratedInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsCuratedRssInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsCurrentOpenThreadInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsDailyInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsDraftsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  includeDraftEvents?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  includeShared?: InputMaybe<Scalars['Boolean']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortDraftsBy?: InputMaybe<Scalars['String']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsEventsInTimeRangeInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsEventsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  globalEvent?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  onlineEvent?: InputMaybe<Scalars['Boolean']['input']>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsFrontpageInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsFrontpageReviewWidgetInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  reviewPhase?: InputMaybe<Scalars['String']['input']>;
  reviewYear?: InputMaybe<Scalars['Int']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsFrontpageRssInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsGlobalEventsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Array<Scalars['String']['input']>>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  onlineEvent?: InputMaybe<Scalars['Boolean']['input']>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsHasEverDialoguedInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsLegacyIdPostInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  legacyId?: InputMaybe<Scalars['String']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsMagicInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  forum?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['Boolean']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsMetaRssInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsMyBookmarkedPostsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsNearbyEventsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  eventType?: InputMaybe<Array<Scalars['String']['input']>>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  onlineEvent?: InputMaybe<Scalars['Boolean']['input']>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsNewInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  forum?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['Boolean']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsNominatablePostsByVoteInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  requiredFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
  requiredUnnominated?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsNominations2018Input = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortByMost?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsNominations2019Input = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortByMost?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsNonEventGroupPostsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsOldInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsPastEventsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsPingbackPostsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postId?: InputMaybe<Scalars['String']['input']>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsPostsWithBannedUsersInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsRecentCommentsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsRecentDiscussionThreadsListInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsRecentQuestionActivityInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsRejectedInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsReviewFinalVotingInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsReviewQuickPageInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsReviewRecentDiscussionThreadsList2018Input = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsReviewRecentDiscussionThreadsList2019Input = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsReviewVotingInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  reviewPhase?: InputMaybe<Scalars['String']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsReviews2018Input = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsReviews2019Input = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsRssInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  forum?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['Boolean']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsScheduledInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsSlugPostInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsStickiedInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  forum?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsSunshineAutoClassifiedPostsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsSunshineCuratedSuggestionsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  audioOnly?: InputMaybe<Scalars['Boolean']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsSunshineNewPostsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsSunshineNewUsersPostsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsTagRelevanceInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsTbdEventsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsTimeframeInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  requiredFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
  requiredUnnominated?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsTopInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  forum?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['Boolean']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsTopQuestionsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsUnlistedInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsUpcomingEventsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsUserAFSubmissionsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsUserCommentedOnResult = {
  __typename?: 'PostsUserCommentedOnResult';
  posts: Maybe<Array<Post>>;
};

export type PostsUserPostsInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsVoting2019Input = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curatedAfter?: InputMaybe<Scalars['String']['input']>;
  exactPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterSettings?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedQuestions?: InputMaybe<Scalars['String']['input']>;
  karmaThreshold?: InputMaybe<Scalars['Int']['input']>;
  notPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type PostsWithActiveDiscussionResult = {
  __typename?: 'PostsWithActiveDiscussionResult';
  results: Array<Post>;
};

export type PostsWithApprovedJargonResult = {
  __typename?: 'PostsWithApprovedJargonResult';
  results: Array<PostWithApprovedJargon>;
};

export type ProfileCommentDiamond = {
  __typename?: 'ProfileCommentDiamond';
  date: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  karma: Scalars['Int']['output'];
  postId: Scalars['String']['output'];
};

export type ProfileDiamondCommentsResult = {
  __typename?: 'ProfileDiamondCommentsResult';
  results: Array<ProfileCommentDiamond>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type ProfileDiamondPostsResult = {
  __typename?: 'ProfileDiamondPostsResult';
  results: Array<ProfilePostDiamond>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type ProfilePostDiamond = {
  __typename?: 'ProfilePostDiamond';
  _id: Scalars['String']['output'];
  date: Scalars['Date']['output'];
  isCurated: Scalars['Boolean']['output'];
  isReviewWinner: Scalars['Boolean']['output'];
  karma: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

export type PublishHomePageDesignInput = {
  descriptionHtml: Scalars['String']['input'];
  publicId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  ActiveTagCount: Scalars['Int']['output'];
  AdminMetadata: Maybe<Scalars['String']['output']>;
  AirtableLeaderboards: Array<AirtableLeaderboardResult>;
  AllTagsActivityFeed: AllTagsActivityFeedQueryResults;
  AnalyticsSeries: Maybe<Array<Maybe<AnalyticsSeriesValue>>>;
  ArbitalPageData: Maybe<ArbitalPageData>;
  CommentEmbeddingSearch: Array<Comment>;
  CommentEmbeddingSimilaritySearch: Array<Comment>;
  CommentsWithReacts: Maybe<CommentsWithReactsResult>;
  ContinueReading: Maybe<Array<RecommendResumeSequence>>;
  CrossedKarmaThreshold: Maybe<CrossedKarmaThresholdResult>;
  CuratedAndPopularThisWeek: Maybe<CuratedAndPopularThisWeekResult>;
  CurationCandidatePosts: Maybe<CurationCandidatePostsResult>;
  ElicitBlockData: Maybe<ElicitBlockData>;
  EmailPreview: Maybe<Array<Maybe<EmailPreview>>>;
  GetAllReviewWinners: Array<Post>;
  GetRandomUser: Maybe<User>;
  GetUserBySlug: Maybe<User>;
  GivingSeasonHearts: Array<GivingSeasonHeart>;
  HocuspocusAuth: Maybe<HocuspocusAuth>;
  HomepageCommunityEventPosts: HomepageCommunityEventPostsResult;
  HomepageCommunityEvents: HomepageCommunityEventMarkersResult;
  IsDisplayNameTaken: Scalars['Boolean']['output'];
  LastCuratedDate: LastCuratedDateResult;
  Lightcone2024FundraiserStripeAmounts: Maybe<Array<Scalars['Int']['output']>>;
  Lightcone2025FundraiserAirtableAmounts: Scalars['Int']['output'];
  LlmModelOptions: Array<Scalars['String']['output']>;
  MigrationsDashboard: Maybe<MigrationsDashboardData>;
  MultiPostAnalytics: MultiPostAnalyticsResult;
  MyDialogues: Maybe<MyDialoguesResult>;
  NetKarmaChangesForAuthorsOverPeriod: Array<NetKarmaChangesForAuthorsOverPeriod>;
  NotificationDisplays: Maybe<NotificationDisplaysResult>;
  PetrovDay2024CheckNumberOfIncoming: Maybe<PetrovDay2024CheckNumberOfIncomingData>;
  PetrovDayCheckIfIncoming: Maybe<PetrovDayCheckIfIncomingData>;
  PopularComments: Maybe<PopularCommentsResult>;
  PostAnalytics: PostAnalyticsResult;
  PostsBySubscribedAuthors: Maybe<PostsBySubscribedAuthorsResult>;
  PostsUserCommentedOn: Maybe<UserReadHistoryResult>;
  PostsWithActiveDiscussion: Maybe<PostsWithActiveDiscussionResult>;
  PostsWithApprovedJargon: Maybe<PostsWithApprovedJargonResult>;
  ProfileDiamondComments: ProfileDiamondCommentsResult;
  ProfileDiamondPosts: ProfileDiamondPostsResult;
  RandomTag: Tag;
  RecentDiscussionFeed: RecentDiscussionFeedQueryResults;
  RecentlyActiveDialogues: Maybe<RecentlyActiveDialoguesResult>;
  RecombeeHybridPosts: Maybe<RecombeeHybridPostsResult>;
  RecombeeLatestPosts: Maybe<RecombeeLatestPostsResult>;
  Recommendations: Maybe<Array<Post>>;
  ReviewResultsTableData: Maybe<ReviewResultsTableData>;
  RevisionsDiff: Maybe<Scalars['String']['output']>;
  RssPostChanges: RssPostChangeInfo;
  SearchSynonyms: Array<Scalars['String']['output']>;
  SiteData: Maybe<Site>;
  SuggestedFeedSubscriptionUsers: Maybe<SuggestedFeedSubscriptionUsersResult>;
  SuggestedTopActiveUsers: Maybe<SuggestedTopActiveUsersResult>;
  TagHistoryFeed: TagHistoryFeedQueryResults;
  TagPreview: Maybe<TagPreviewWithSummaries>;
  TagUpdatesByUser: Maybe<Array<TagUpdates>>;
  TagUpdatesInTimeBlock: Array<TagUpdates>;
  TagsByCoreTagId: TagWithTotalCount;
  UltraFeed: UltraFeedQueryResults;
  UltraFeedSubscriptions: UltraFeedQueryResults;
  UserContentFeed: UserContentFeedQueryResults;
  UserReadHistory: Maybe<UserReadHistoryResult>;
  UserReadsPerCoreTag: Array<UserCoreTagReads>;
  UsersReadPostsOfTargetUser: Maybe<Array<Post>>;
  UsersSearchForMerge: Array<User>;
  adminEmailPreviewAudience: AdminEmailAudiencePreview;
  adminHomePageDesigns: Array<AdminHomePageDesign>;
  arbitalTagContentRel: Maybe<SingleArbitalTagContentRelOutput>;
  arbitalTagContentRels: Maybe<MultiArbitalTagContentRelOutput>;
  ban: Maybe<SingleBanOutput>;
  bans: Maybe<MultiBanOutput>;
  book: Maybe<SingleBookOutput>;
  bookmark: Maybe<SingleBookmarkOutput>;
  bookmarks: Maybe<MultiBookmarkOutput>;
  books: Maybe<MultiBookOutput>;
  chapter: Maybe<SingleChapterOutput>;
  chapters: Maybe<MultiChapterOutput>;
  ckEditorUserSession: Maybe<SingleCkEditorUserSessionOutput>;
  ckEditorUserSessions: Maybe<MultiCkEditorUserSessionOutput>;
  clientId: Maybe<SingleClientIdOutput>;
  clientIds: Maybe<MultiClientIdOutput>;
  collection: Maybe<SingleCollectionOutput>;
  collections: Maybe<MultiCollectionOutput>;
  comment: Maybe<SingleCommentOutput>;
  commentModeratorAction: Maybe<SingleCommentModeratorActionOutput>;
  commentModeratorActions: Maybe<MultiCommentModeratorActionOutput>;
  comments: Maybe<MultiCommentOutput>;
  conversation: Maybe<SingleConversationOutput>;
  conversations: Maybe<MultiConversationOutput>;
  convertDocument: Maybe<Scalars['JSON']['output']>;
  crossSiteLinkPreview: Maybe<CrossSiteLinkPreviewData>;
  curationNotice: Maybe<SingleCurationNoticeOutput>;
  curationNotices: Maybe<MultiCurationNoticeOutput>;
  currentSpotlight: Maybe<Spotlight>;
  currentUser: Maybe<User>;
  dialogueCheck: Maybe<SingleDialogueCheckOutput>;
  dialogueChecks: Maybe<MultiDialogueCheckOutput>;
  dialogueMatchPreference: Maybe<SingleDialogueMatchPreferenceOutput>;
  dialogueMatchPreferences: Maybe<MultiDialogueMatchPreferenceOutput>;
  elicitQuestion: Maybe<SingleElicitQuestionOutput>;
  elicitQuestionPrediction: Maybe<SingleElicitQuestionPredictionOutput>;
  elicitQuestionPredictions: Maybe<MultiElicitQuestionPredictionOutput>;
  elicitQuestions: Maybe<MultiElicitQuestionOutput>;
  fieldChange: Maybe<SingleFieldChangeOutput>;
  fieldChanges: Maybe<MultiFieldChangeOutput>;
  getBookWordCount: Maybe<Scalars['Float']['output']>;
  getCrosspost: Maybe<Scalars['JSON']['output']>;
  getLinkSharedPost: Maybe<Post>;
  getSequenceStats: Maybe<SequenceStats>;
  googleServiceAccountSession: Maybe<SingleGoogleServiceAccountSessionOutput>;
  googleServiceAccountSessions: Maybe<MultiGoogleServiceAccountSessionOutput>;
  homePageDesignByPublicId: Maybe<HomePageDesign>;
  iframeWidgetSrcdoc: Maybe<SingleIframeWidgetSrcdocOutput>;
  iframeWidgetSrcdocs: Maybe<MultiIframeWidgetSrcdocOutput>;
  jargonTerm: Maybe<SingleJargonTermOutput>;
  jargonTerms: Maybe<MultiJargonTermOutput>;
  lWEvent: Maybe<SingleLWEventOutput>;
  lWEvents: Maybe<MultiLWEventOutput>;
  latestDialogueMessages: Maybe<Array<Scalars['String']['output']>>;
  latestGoogleDocMetadata: Maybe<Scalars['JSON']['output']>;
  llmConversation: Maybe<SingleLlmConversationOutput>;
  llmConversations: Maybe<MultiLlmConversationOutput>;
  localgroup: Maybe<SingleLocalgroupOutput>;
  localgroups: Maybe<MultiLocalgroupOutput>;
  marketplaceHomePageDesigns: Array<MarketplaceHomePageDesign>;
  message: Maybe<SingleMessageOutput>;
  messages: Maybe<MultiMessageOutput>;
  moderationTemplate: Maybe<SingleModerationTemplateOutput>;
  moderationTemplates: Maybe<MultiModerationTemplateOutput>;
  moderatorAction: Maybe<SingleModeratorActionOutput>;
  moderatorActions: Maybe<MultiModeratorActionOutput>;
  moderatorViewIPAddress: Maybe<ModeratorIPAddressInfo>;
  multiDocument: Maybe<SingleMultiDocumentOutput>;
  multiDocuments: Maybe<MultiMultiDocumentOutput>;
  myHomePageDesignSummaries: Array<HomePageDesignSummary>;
  myHomePageDesigns: Array<HomePageDesign>;
  notification: Maybe<SingleNotificationOutput>;
  notifications: Maybe<MultiNotificationOutput>;
  petrov2024checkIfNuked: Maybe<Scalars['Boolean']['output']>;
  petrovDayAction: Maybe<SinglePetrovDayActionOutput>;
  petrovDayActions: Maybe<MultiPetrovDayActionOutput>;
  podcast: Maybe<SinglePodcastOutput>;
  podcastEpisode: Maybe<SinglePodcastEpisodeOutput>;
  podcastEpisodes: Maybe<MultiPodcastEpisodeOutput>;
  podcasts: Maybe<MultiPodcastOutput>;
  post: Maybe<SinglePostOutput>;
  postRelation: Maybe<SinglePostRelationOutput>;
  postRelations: Maybe<MultiPostRelationOutput>;
  posts: Maybe<MultiPostOutput>;
  rSSFeed: Maybe<SingleRSSFeedOutput>;
  rSSFeeds: Maybe<MultiRSSFeedOutput>;
  report: Maybe<SingleReportOutput>;
  reports: Maybe<MultiReportOutput>;
  researchConversation: Maybe<SingleResearchConversationOutput>;
  researchConversationEvent: Maybe<SingleResearchConversationEventOutput>;
  researchConversationEvents: Maybe<MultiResearchConversationEventOutput>;
  researchConversationSidebarStatuses: Array<ResearchConversationSidebarStatus>;
  researchConversationTranscript: Array<ResearchConversationEvent>;
  researchConversations: Maybe<MultiResearchConversationOutput>;
  researchDocument: Maybe<SingleResearchDocumentOutput>;
  researchDocuments: Maybe<MultiResearchDocumentOutput>;
  researchEnvironment: Maybe<SingleResearchEnvironmentOutput>;
  researchEnvironments: Maybe<MultiResearchEnvironmentOutput>;
  researchProject: Maybe<SingleResearchProjectOutput>;
  researchProjects: Maybe<MultiResearchProjectOutput>;
  researchSandboxDirectory: ResearchSandboxDirListing;
  researchSandboxFile: ResearchSandboxFileContents;
  researchSandboxRunning: Scalars['Boolean']['output'];
  researchSandboxStats: ResearchSandboxStats;
  reviewPredictionPosts: Array<Post>;
  reviewVote: Maybe<SingleReviewVoteOutput>;
  reviewVotes: Maybe<MultiReviewVoteOutput>;
  reviewWinner: Maybe<SingleReviewWinnerOutput>;
  reviewWinnerArt: Maybe<SingleReviewWinnerArtOutput>;
  reviewWinnerArts: Maybe<MultiReviewWinnerArtOutput>;
  reviewWinners: Maybe<MultiReviewWinnerOutput>;
  revision: Maybe<SingleRevisionOutput>;
  revisions: Maybe<MultiRevisionOutput>;
  sequence: Maybe<SingleSequenceOutput>;
  sequences: Maybe<MultiSequenceOutput>;
  splashArtCoordinate: Maybe<SingleSplashArtCoordinateOutput>;
  splashArtCoordinates: Maybe<MultiSplashArtCoordinateOutput>;
  spotlight: Maybe<SingleSpotlightOutput>;
  spotlights: Maybe<MultiSpotlightOutput>;
  subscription: Maybe<SingleSubscriptionOutput>;
  subscriptions: Maybe<MultiSubscriptionOutput>;
  tag: Maybe<SingleTagOutput>;
  tagFlag: Maybe<SingleTagFlagOutput>;
  tagFlags: Maybe<MultiTagFlagOutput>;
  tagRel: Maybe<SingleTagRelOutput>;
  tagRels: Maybe<MultiTagRelOutput>;
  tags: Maybe<MultiTagOutput>;
  typingIndicator: Maybe<SingleTypingIndicatorOutput>;
  typingIndicators: Maybe<MultiTypingIndicatorOutput>;
  typoSuggestion: Maybe<SingleTypoSuggestionOutput>;
  typoSuggestions: Maybe<MultiTypoSuggestionOutput>;
  ultraFeedEvent: Maybe<SingleUltraFeedEventOutput>;
  ultraFeedEvents: Maybe<MultiUltraFeedEventOutput>;
  unreadNotificationCounts: NotificationCounts;
  user: Maybe<SingleUserOutput>;
  userMostValuablePost: Maybe<SingleUserMostValuablePostOutput>;
  userMostValuablePosts: Maybe<MultiUserMostValuablePostOutput>;
  userRateLimit: Maybe<SingleUserRateLimitOutput>;
  userRateLimits: Maybe<MultiUserRateLimitOutput>;
  userTagRel: Maybe<SingleUserTagRelOutput>;
  userTagRels: Maybe<MultiUserTagRelOutput>;
  users: Maybe<MultiUserOutput>;
  vote: Maybe<SingleVoteOutput>;
  votes: Maybe<MultiVoteOutput>;
};


export type QueryAllTagsActivityFeedArgs = {
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAnalyticsSeriesArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  postIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArbitalPageDataArgs = {
  pageAlias?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommentEmbeddingSearchArgs = {
  query: Scalars['String']['input'];
  scoreBias?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryCommentEmbeddingSimilaritySearchArgs = {
  commentId: Scalars['String']['input'];
  scoreBias?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryCommentsWithReactsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCrossedKarmaThresholdArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCuratedAndPopularThisWeekArgs = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCurationCandidatePostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryElicitBlockDataArgs = {
  questionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmailPreviewArgs = {
  notificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRandomUserArgs = {
  userIsAuthor: Scalars['String']['input'];
};


export type QueryGetUserBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGivingSeasonHeartsArgs = {
  electionName: Scalars['String']['input'];
};


export type QueryHocuspocusAuthArgs = {
  collectionName?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  linkSharingKey?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHomepageCommunityEventPostsArgs = {
  eventType: Scalars['String']['input'];
};


export type QueryHomepageCommunityEventsArgs = {
  limit: Scalars['Int']['input'];
};


export type QueryIsDisplayNameTakenArgs = {
  displayName: Scalars['String']['input'];
};


export type QueryMultiPostAnalyticsArgs = {
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyDialoguesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNetKarmaChangesForAuthorsOverPeriodArgs = {
  days: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
};


export type QueryNotificationDisplaysArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPopularCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPostAnalyticsArgs = {
  postId: Scalars['String']['input'];
};


export type QueryPostsBySubscribedAuthorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPostsUserCommentedOnArgs = {
  filter?: InputMaybe<PostReviewFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PostReviewSort>;
};


export type QueryPostsWithActiveDiscussionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPostsWithApprovedJargonArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProfileDiamondCommentsArgs = {
  limit: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryProfileDiamondPostsArgs = {
  limit: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryRecentDiscussionFeedArgs = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecentlyActiveDialoguesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecombeeHybridPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryRecombeeLatestPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryRecommendationsArgs = {
  algorithm?: InputMaybe<Scalars['JSON']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReviewResultsTableDataArgs = {
  year: Scalars['Int']['input'];
};


export type QueryRevisionsDiffArgs = {
  afterRev: Scalars['String']['input'];
  beforeRev?: InputMaybe<Scalars['String']['input']>;
  collectionName: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  trim?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRssPostChangesArgs = {
  postId: Scalars['String']['input'];
};


export type QuerySuggestedFeedSubscriptionUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuggestedTopActiveUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagHistoryFeedArgs = {
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  tagId: Scalars['String']['input'];
};


export type QueryTagPreviewArgs = {
  hash?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryTagUpdatesByUserArgs = {
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryTagUpdatesInTimeBlockArgs = {
  after: Scalars['Date']['input'];
  before: Scalars['Date']['input'];
};


export type QueryTagsByCoreTagIdArgs = {
  coreTagId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUltraFeedArgs = {
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryUltraFeedSubscriptionsArgs = {
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryUserContentFeedArgs = {
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryUserReadHistoryArgs = {
  filter?: InputMaybe<PostReviewFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PostReviewSort>;
};


export type QueryUserReadsPerCoreTagArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUsersReadPostsOfTargetUserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  targetUserId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryUsersSearchForMergeArgs = {
  query: Scalars['String']['input'];
};


export type QueryadminEmailPreviewAudienceArgs = {
  input: AdminEmailPreviewAudienceInput;
};


export type QueryarbitalTagContentRelArgs = {
  input?: InputMaybe<SingleArbitalTagContentRelInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryarbitalTagContentRelsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiArbitalTagContentRelInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ArbitalTagContentRelSelector>;
};


export type QuerybanArgs = {
  input?: InputMaybe<SingleBanInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerybansArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiBanInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<BanSelector>;
};


export type QuerybookArgs = {
  input?: InputMaybe<SingleBookInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerybookmarkArgs = {
  input?: InputMaybe<SingleBookmarkInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerybookmarksArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiBookmarkInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<BookmarkSelector>;
};


export type QuerybooksArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiBookInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<BookSelector>;
};


export type QuerychapterArgs = {
  input?: InputMaybe<SingleChapterInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerychaptersArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiChapterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ChapterSelector>;
};


export type QueryckEditorUserSessionArgs = {
  input?: InputMaybe<SingleCkEditorUserSessionInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryckEditorUserSessionsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiCkEditorUserSessionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<CkEditorUserSessionSelector>;
};


export type QueryclientIdArgs = {
  input?: InputMaybe<SingleClientIdInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryclientIdsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiClientIdInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ClientIdSelector>;
};


export type QuerycollectionArgs = {
  input?: InputMaybe<SingleCollectionInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerycollectionsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiCollectionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<CollectionSelector>;
};


export type QuerycommentArgs = {
  allowNull?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<SingleCommentInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerycommentModeratorActionArgs = {
  input?: InputMaybe<SingleCommentModeratorActionInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerycommentModeratorActionsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiCommentModeratorActionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<CommentModeratorActionSelector>;
};


export type QuerycommentsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiCommentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<CommentSelector>;
};


export type QueryconversationArgs = {
  input?: InputMaybe<SingleConversationInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryconversationsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiConversationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ConversationSelector>;
};


export type QueryconvertDocumentArgs = {
  document?: InputMaybe<Scalars['JSON']['input']>;
  targetFormat?: InputMaybe<Scalars['String']['input']>;
};


export type QuerycrossSiteLinkPreviewArgs = {
  forceRefetch?: InputMaybe<Scalars['Boolean']['input']>;
  includeDebug?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
};


export type QuerycurationNoticeArgs = {
  input?: InputMaybe<SingleCurationNoticeInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerycurationNoticesArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiCurationNoticeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<CurationNoticeSelector>;
};


export type QuerydialogueCheckArgs = {
  input?: InputMaybe<SingleDialogueCheckInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerydialogueChecksArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiDialogueCheckInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<DialogueCheckSelector>;
};


export type QuerydialogueMatchPreferenceArgs = {
  input?: InputMaybe<SingleDialogueMatchPreferenceInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerydialogueMatchPreferencesArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiDialogueMatchPreferenceInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<DialogueMatchPreferenceSelector>;
};


export type QueryelicitQuestionArgs = {
  input?: InputMaybe<SingleElicitQuestionInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryelicitQuestionPredictionArgs = {
  input?: InputMaybe<SingleElicitQuestionPredictionInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryelicitQuestionPredictionsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiElicitQuestionPredictionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ElicitQuestionPredictionSelector>;
};


export type QueryelicitQuestionsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiElicitQuestionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ElicitQuestionSelector>;
};


export type QueryfieldChangeArgs = {
  input?: InputMaybe<SingleFieldChangeInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryfieldChangesArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiFieldChangeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<FieldChangeSelector>;
};


export type QuerygetBookWordCountArgs = {
  bookId: Scalars['String']['input'];
};


export type QuerygetCrosspostArgs = {
  args?: InputMaybe<Scalars['JSON']['input']>;
};


export type QuerygetLinkSharedPostArgs = {
  linkSharingKey: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};


export type QuerygetSequenceStatsArgs = {
  sequenceId: Scalars['String']['input'];
};


export type QuerygoogleServiceAccountSessionArgs = {
  input?: InputMaybe<SingleGoogleServiceAccountSessionInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerygoogleServiceAccountSessionsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiGoogleServiceAccountSessionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<GoogleServiceAccountSessionSelector>;
};


export type QueryhomePageDesignByPublicIdArgs = {
  publicId: Scalars['String']['input'];
};


export type QueryiframeWidgetSrcdocArgs = {
  selector?: InputMaybe<SelectorInput>;
};


export type QueryiframeWidgetSrcdocsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<IframeWidgetSrcdocSelector>;
};


export type QueryjargonTermArgs = {
  input?: InputMaybe<SingleJargonTermInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryjargonTermsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiJargonTermInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<JargonTermSelector>;
};


export type QuerylWEventArgs = {
  input?: InputMaybe<SingleLWEventInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerylWEventsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiLWEventInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<LWEventSelector>;
};


export type QuerylatestDialogueMessagesArgs = {
  dialogueId: Scalars['String']['input'];
  numMessages: Scalars['Int']['input'];
};


export type QuerylatestGoogleDocMetadataArgs = {
  postId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryllmConversationArgs = {
  input?: InputMaybe<SingleLlmConversationInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryllmConversationsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiLlmConversationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<LlmConversationSelector>;
};


export type QuerylocalgroupArgs = {
  allowNull?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<SingleLocalgroupInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerylocalgroupsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiLocalgroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<LocalgroupSelector>;
};


export type QuerymessageArgs = {
  input?: InputMaybe<SingleMessageInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerymessagesArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiMessageInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<MessageSelector>;
};


export type QuerymoderationTemplateArgs = {
  input?: InputMaybe<SingleModerationTemplateInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerymoderationTemplatesArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiModerationTemplateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ModerationTemplateSelector>;
};


export type QuerymoderatorActionArgs = {
  input?: InputMaybe<SingleModeratorActionInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerymoderatorActionsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiModeratorActionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ModeratorActionSelector>;
};


export type QuerymoderatorViewIPAddressArgs = {
  ipAddress: Scalars['String']['input'];
};


export type QuerymultiDocumentArgs = {
  input?: InputMaybe<SingleMultiDocumentInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerymultiDocumentsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiMultiDocumentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<MultiDocumentSelector>;
};


export type QuerymyHomePageDesignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerynotificationArgs = {
  input?: InputMaybe<SingleNotificationInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerynotificationsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<NotificationSelector>;
};


export type QuerypetrovDayActionArgs = {
  input?: InputMaybe<SinglePetrovDayActionInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerypetrovDayActionsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiPetrovDayActionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<PetrovDayActionSelector>;
};


export type QuerypodcastArgs = {
  input?: InputMaybe<SinglePodcastInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerypodcastEpisodeArgs = {
  input?: InputMaybe<SinglePodcastEpisodeInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerypodcastEpisodesArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiPodcastEpisodeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<PodcastEpisodeSelector>;
};


export type QuerypodcastsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiPodcastInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<PodcastSelector>;
};


export type QuerypostArgs = {
  allowNull?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<SinglePostInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerypostRelationArgs = {
  input?: InputMaybe<SinglePostRelationInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerypostRelationsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiPostRelationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<PostRelationSelector>;
};


export type QuerypostsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiPostInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<PostSelector>;
};


export type QueryrSSFeedArgs = {
  input?: InputMaybe<SingleRSSFeedInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryrSSFeedsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiRSSFeedInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<RSSFeedSelector>;
};


export type QueryreportArgs = {
  input?: InputMaybe<SingleReportInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryreportsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiReportInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ReportSelector>;
};


export type QueryresearchConversationArgs = {
  selector?: InputMaybe<SelectorInput>;
};


export type QueryresearchConversationEventArgs = {
  selector?: InputMaybe<SelectorInput>;
};


export type QueryresearchConversationEventsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ResearchConversationEventSelector>;
};


export type QueryresearchConversationSidebarStatusesArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryresearchConversationTranscriptArgs = {
  before?: InputMaybe<Scalars['Int']['input']>;
  conversationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryresearchConversationsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ResearchConversationSelector>;
};


export type QueryresearchDocumentArgs = {
  selector?: InputMaybe<SelectorInput>;
};


export type QueryresearchDocumentsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ResearchDocumentSelector>;
};


export type QueryresearchEnvironmentArgs = {
  selector?: InputMaybe<SelectorInput>;
};


export type QueryresearchEnvironmentsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ResearchEnvironmentSelector>;
};


export type QueryresearchProjectArgs = {
  selector?: InputMaybe<SelectorInput>;
};


export type QueryresearchProjectsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ResearchProjectSelector>;
};


export type QueryresearchSandboxDirectoryArgs = {
  conversationId: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryresearchSandboxFileArgs = {
  conversationId: Scalars['String']['input'];
  path: Scalars['String']['input'];
};


export type QueryresearchSandboxRunningArgs = {
  conversationId: Scalars['String']['input'];
};


export type QueryresearchSandboxStatsArgs = {
  conversationId: Scalars['String']['input'];
};


export type QueryreviewPredictionPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryreviewVoteArgs = {
  input?: InputMaybe<SingleReviewVoteInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryreviewVotesArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiReviewVoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ReviewVoteSelector>;
};


export type QueryreviewWinnerArgs = {
  input?: InputMaybe<SingleReviewWinnerInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryreviewWinnerArtArgs = {
  input?: InputMaybe<SingleReviewWinnerArtInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryreviewWinnerArtsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiReviewWinnerArtInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ReviewWinnerArtSelector>;
};


export type QueryreviewWinnersArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiReviewWinnerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<ReviewWinnerSelector>;
};


export type QueryrevisionArgs = {
  input?: InputMaybe<SingleRevisionInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryrevisionsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiRevisionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<RevisionSelector>;
};


export type QuerysequenceArgs = {
  allowNull?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<SingleSequenceInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerysequencesArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiSequenceInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<SequenceSelector>;
};


export type QuerysplashArtCoordinateArgs = {
  input?: InputMaybe<SingleSplashArtCoordinateInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerysplashArtCoordinatesArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiSplashArtCoordinateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<SplashArtCoordinateSelector>;
};


export type QueryspotlightArgs = {
  input?: InputMaybe<SingleSpotlightInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryspotlightsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiSpotlightInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<SpotlightSelector>;
};


export type QuerysubscriptionArgs = {
  input?: InputMaybe<SingleSubscriptionInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerysubscriptionsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiSubscriptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<SubscriptionSelector>;
};


export type QuerytagArgs = {
  input?: InputMaybe<SingleTagInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerytagFlagArgs = {
  input?: InputMaybe<SingleTagFlagInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerytagFlagsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiTagFlagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<TagFlagSelector>;
};


export type QuerytagRelArgs = {
  input?: InputMaybe<SingleTagRelInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerytagRelsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiTagRelInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<TagRelSelector>;
};


export type QuerytagsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiTagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<TagSelector>;
};


export type QuerytypingIndicatorArgs = {
  input?: InputMaybe<SingleTypingIndicatorInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerytypingIndicatorsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiTypingIndicatorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<TypingIndicatorSelector>;
};


export type QuerytypoSuggestionArgs = {
  input?: InputMaybe<SingleTypoSuggestionInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QuerytypoSuggestionsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiTypoSuggestionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<TypoSuggestionSelector>;
};


export type QueryultraFeedEventArgs = {
  input?: InputMaybe<SingleUltraFeedEventInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryultraFeedEventsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiUltraFeedEventInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<UltraFeedEventSelector>;
};


export type QueryuserArgs = {
  input?: InputMaybe<SingleUserInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryuserMostValuablePostArgs = {
  input?: InputMaybe<SingleUserMostValuablePostInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryuserMostValuablePostsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiUserMostValuablePostInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<UserMostValuablePostSelector>;
};


export type QueryuserRateLimitArgs = {
  input?: InputMaybe<SingleUserRateLimitInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryuserRateLimitsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiUserRateLimitInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<UserRateLimitSelector>;
};


export type QueryuserTagRelArgs = {
  input?: InputMaybe<SingleUserTagRelInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryuserTagRelsArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiUserTagRelInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<UserTagRelSelector>;
};


export type QueryusersArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<UserSelector>;
};


export type QueryvoteArgs = {
  input?: InputMaybe<SingleVoteInput>;
  selector?: InputMaybe<SelectorInput>;
};


export type QueryvotesArgs = {
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<MultiVoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<VoteSelector>;
};

export type RSSFeed = {
  __typename?: 'RSSFeed';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  displayFullContent: Scalars['Boolean']['output'];
  importAsDraft: Scalars['Boolean']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  nickname: Scalars['String']['output'];
  ownedByUser: Scalars['Boolean']['output'];
  rawFeed: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  setCanonicalUrl: Scalars['Boolean']['output'];
  status: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type RSSFeedOutput = {
  __typename?: 'RSSFeedOutput';
  data: Maybe<RSSFeed>;
};

export type RSSFeedSelector = {
  default?: InputMaybe<EmptyViewInput>;
  usersFeed?: InputMaybe<RSSFeedsUsersFeedInput>;
};

export type RSSFeedsUsersFeedInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ReactPaletteStyle =
  | 'gridView'
  | 'listView';

export type ReactionChange = {
  __typename?: 'ReactionChange';
  quote: Maybe<Scalars['String']['output']>;
  reactionType: Scalars['String']['output'];
  userId: Maybe<Scalars['String']['output']>;
};

export type ReadStatus = {
  __typename?: 'ReadStatus';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
};

export type RecentDiscussionFeedEntry = {
  __typename?: 'RecentDiscussionFeedEntry';
  postCommented: Maybe<Post>;
  shortformCommented: Maybe<Post>;
  tagDiscussed: Maybe<Tag>;
  tagRevised: Maybe<Revision>;
  type: RecentDiscussionFeedEntryType;
};

export type RecentDiscussionFeedEntryType =
  | 'meetupsPoke'
  | 'postCommented'
  | 'shortformCommented'
  | 'subscribeReminder'
  | 'tagDiscussed'
  | 'tagRevised';

export type RecentDiscussionFeedQueryResults = {
  __typename?: 'RecentDiscussionFeedQueryResults';
  cutoff: Maybe<Scalars['Date']['output']>;
  endOffset: Scalars['Int']['output'];
  results: Maybe<Array<RecentDiscussionFeedEntry>>;
  sessionId: Maybe<Scalars['String']['output']>;
};

export type RecentlyActiveDialoguesResult = {
  __typename?: 'RecentlyActiveDialoguesResult';
  results: Array<Post>;
};

export type RecombeeHybridPostsResult = {
  __typename?: 'RecombeeHybridPostsResult';
  results: Array<RecombeeRecommendedPost>;
};

export type RecombeeLatestPostsResult = {
  __typename?: 'RecombeeLatestPostsResult';
  results: Array<RecombeeRecommendedPost>;
};

export type RecombeeRecommendedPost = {
  __typename?: 'RecombeeRecommendedPost';
  curated: Maybe<Scalars['Boolean']['output']>;
  generatedAt: Maybe<Scalars['Date']['output']>;
  post: Post;
  recommId: Maybe<Scalars['String']['output']>;
  scenario: Maybe<Scalars['String']['output']>;
  stickied: Maybe<Scalars['Boolean']['output']>;
};

export type RecommendResumeSequence = {
  __typename?: 'RecommendResumeSequence';
  collection: Maybe<Collection>;
  lastReadTime: Maybe<Scalars['Date']['output']>;
  nextPost: Post;
  numRead: Maybe<Scalars['Int']['output']>;
  numTotal: Maybe<Scalars['Int']['output']>;
  sequence: Maybe<Sequence>;
};

export type RecommendationAlgorithmSettingsInput = {
  count: Scalars['Int']['input'];
  curatedModifier: Scalars['Float']['input'];
  frontpageModifier: Scalars['Float']['input'];
  method: Scalars['String']['input'];
  onlyUnread: Scalars['Boolean']['input'];
  personalBlogpostModifier: Scalars['Float']['input'];
  scoreExponent: Scalars['Float']['input'];
  scoreOffset: Scalars['Float']['input'];
};

export type RecommendationSettingsInput = {
  frontpage: RecommendationAlgorithmSettingsInput;
  frontpageEA: RecommendationAlgorithmSettingsInput;
  recommendationspage: RecommendationAlgorithmSettingsInput;
};

export type RecommendationsCache = {
  __typename?: 'RecommendationsCache';
  _id: Scalars['String']['output'];
  attributionId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  postId: Maybe<Scalars['String']['output']>;
  scenario: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  source: Maybe<Scalars['String']['output']>;
  ttlMs: Maybe<Scalars['Float']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type ReorderResearchDocumentsOutput = {
  __typename?: 'ReorderResearchDocumentsOutput';
  success: Scalars['Boolean']['output'];
};

export type Report = {
  __typename?: 'Report';
  _id: Scalars['String']['output'];
  claimedUser: Maybe<User>;
  claimedUserId: Maybe<Scalars['String']['output']>;
  closedAt: Maybe<Scalars['Date']['output']>;
  comment: Maybe<Comment>;
  commentId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description: Maybe<Scalars['String']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  link: Scalars['String']['output'];
  markedAsSpam: Maybe<Scalars['Boolean']['output']>;
  post: Maybe<Post>;
  postId: Maybe<Scalars['String']['output']>;
  reportedAsSpam: Maybe<Scalars['Boolean']['output']>;
  reportedUser: Maybe<User>;
  reportedUserId: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type ReportOutput = {
  __typename?: 'ReportOutput';
  data: Maybe<Report>;
};

export type ReportSelector = {
  adminClaimedReports?: InputMaybe<ReportsAdminClaimedReportsInput>;
  allReports?: InputMaybe<EmptyViewInput>;
  claimedReports?: InputMaybe<EmptyViewInput>;
  closedReports?: InputMaybe<EmptyViewInput>;
  default?: InputMaybe<EmptyViewInput>;
  sunshineSidebarReports?: InputMaybe<EmptyViewInput>;
  unclaimedReports?: InputMaybe<EmptyViewInput>;
};

export type ReportsAdminClaimedReportsInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ResearchConversation = {
  __typename?: 'ResearchConversation';
  _id: Scalars['String']['output'];
  archived: Maybe<Scalars['Boolean']['output']>;
  baseEnvironmentId: Maybe<Scalars['String']['output']>;
  claudeSessionId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  entrypointDocumentId: Maybe<Scalars['String']['output']>;
  entrypointKind: Maybe<ResearchEntrypointKind>;
  icon: Maybe<Scalars['String']['output']>;
  lastActivityAt: Maybe<Scalars['Date']['output']>;
  lastReadAt: Maybe<Scalars['Date']['output']>;
  presentationHtml: Maybe<Scalars['String']['output']>;
  projectId: Maybe<Scalars['String']['output']>;
  runtime: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
  userTurnCount: Maybe<Scalars['Int']['output']>;
};

export type ResearchConversationEvent = {
  __typename?: 'ResearchConversationEvent';
  _id: Scalars['String']['output'];
  claudeMessageUuid: Maybe<Scalars['String']['output']>;
  conversationId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  kind: Maybe<Scalars['String']['output']>;
  payload: Maybe<Scalars['JSON']['output']>;
  projectId: Maybe<Scalars['String']['output']>;
  seq: Maybe<Scalars['Int']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type ResearchConversationEventSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type ResearchConversationOutput = {
  __typename?: 'ResearchConversationOutput';
  conversationId: Scalars['String']['output'];
  data: Maybe<ResearchConversation>;
};

export type ResearchConversationSelector = {
  byProject?: InputMaybe<ResearchConversationsByProjectInput>;
  byProjectArchived?: InputMaybe<ResearchConversationsByProjectArchivedInput>;
  default?: InputMaybe<EmptyViewInput>;
};

export type ResearchConversationSidebarStatus = {
  __typename?: 'ResearchConversationSidebarStatus';
  conversationId: Scalars['String']['output'];
  lastActivityAt: Maybe<Scalars['Date']['output']>;
  lastReadAt: Maybe<Scalars['Date']['output']>;
  turnActive: Scalars['Boolean']['output'];
};

export type ResearchConversationsByProjectArchivedInput = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type ResearchConversationsByProjectInput = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type ResearchDocument = {
  __typename?: 'ResearchDocument';
  _id: Scalars['String']['output'];
  archived: Maybe<Scalars['Boolean']['output']>;
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  icon: Maybe<Scalars['String']['output']>;
  projectId: Maybe<Scalars['String']['output']>;
  revisions: Maybe<Array<Revision>>;
  sortOrder: Maybe<Scalars['Float']['output']>;
  title: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['String']['output']>;
};


export type ResearchDocumentcontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type ResearchDocumentrevisionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ResearchDocumentOutput = {
  __typename?: 'ResearchDocumentOutput';
  data: Maybe<ResearchDocument>;
};

export type ResearchDocumentSelector = {
  byProject?: InputMaybe<ResearchDocumentsByProjectInput>;
  byProjectArchived?: InputMaybe<ResearchDocumentsByProjectArchivedInput>;
  default?: InputMaybe<EmptyViewInput>;
};

export type ResearchDocumentsByProjectArchivedInput = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type ResearchDocumentsByProjectInput = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type ResearchEntrypointKind =
  | 'chat'
  | 'document';

export type ResearchEnvironment = {
  __typename?: 'ResearchEnvironment';
  _id: Scalars['String']['output'];
  archived: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Date']['output'];
  label: Maybe<Scalars['String']['output']>;
  projectId: Maybe<Scalars['String']['output']>;
  sourceEventId: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
  vercelSnapshotId: Maybe<Scalars['String']['output']>;
};

export type ResearchEnvironmentOutput = {
  __typename?: 'ResearchEnvironmentOutput';
  data: Maybe<ResearchEnvironment>;
};

export type ResearchEnvironmentSelector = {
  byProject?: InputMaybe<ResearchEnvironmentsByProjectInput>;
  byProjectArchived?: InputMaybe<ResearchEnvironmentsByProjectArchivedInput>;
  default?: InputMaybe<EmptyViewInput>;
};

export type ResearchEnvironmentsByProjectArchivedInput = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type ResearchEnvironmentsByProjectInput = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type ResearchProject = {
  __typename?: 'ResearchProject';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  description: Maybe<Scalars['String']['output']>;
  settings: Maybe<Scalars['JSON']['output']>;
  title: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type ResearchProjectOutput = {
  __typename?: 'ResearchProjectOutput';
  data: Maybe<ResearchProject>;
};

export type ResearchProjectSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type ResearchSandboxDirEntry = {
  __typename?: 'ResearchSandboxDirEntry';
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Maybe<Scalars['Float']['output']>;
};

export type ResearchSandboxDirListing = {
  __typename?: 'ResearchSandboxDirListing';
  entries: Array<ResearchSandboxDirEntry>;
  path: Scalars['String']['output'];
  running: Scalars['Boolean']['output'];
};

export type ResearchSandboxFileContents = {
  __typename?: 'ResearchSandboxFileContents';
  binary: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  path: Scalars['String']['output'];
  running: Scalars['Boolean']['output'];
  size: Scalars['Float']['output'];
  truncated: Scalars['Boolean']['output'];
};

export type ResearchSandboxStats = {
  __typename?: 'ResearchSandboxStats';
  cpuPct: Maybe<Scalars['Float']['output']>;
  diskTotal: Maybe<Scalars['Float']['output']>;
  diskUsed: Maybe<Scalars['Float']['output']>;
  hibernatingSince: Maybe<Scalars['Date']['output']>;
  memTotal: Maybe<Scalars['Float']['output']>;
  memUsed: Maybe<Scalars['Float']['output']>;
  running: Scalars['Boolean']['output'];
};

export type RestartResearchSandboxOutput = {
  __typename?: 'RestartResearchSandboxOutput';
  running: Scalars['Boolean']['output'];
};

export type ReviewGroup =
  | 'automod'
  | 'highContext'
  | 'maybeSpam'
  | 'newContent'
  | 'offboard'
  | 'snoozeExpired'
  | 'unknown';

export type ReviewResultsPostEntry = {
  __typename?: 'ReviewResultsPostEntry';
  authorName: Scalars['String']['output'];
  coauthorNames: Array<Scalars['String']['output']>;
  postUrl: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  votes: Array<Scalars['Float']['output']>;
};

export type ReviewResultsTableData = {
  __typename?: 'ReviewResultsTableData';
  results: Array<ReviewResultsPostEntry>;
  year: Scalars['Int']['output'];
};

export type ReviewVote = {
  __typename?: 'ReviewVote';
  _id: Scalars['String']['output'];
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  dummy: Scalars['Boolean']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  post: Maybe<Post>;
  postId: Scalars['String']['output'];
  quadraticScore: Scalars['Int']['output'];
  qualitativeScore: Scalars['Int']['output'];
  reactions: Maybe<Array<Scalars['String']['output']>>;
  schemaVersion: Scalars['Float']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type ReviewVoteSelector = {
  default?: InputMaybe<EmptyViewInput>;
  reviewVotesAdminDashboard?: InputMaybe<ReviewVotesReviewVotesAdminDashboardInput>;
  reviewVotesForPost?: InputMaybe<EmptyViewInput>;
  reviewVotesForPostAndUser?: InputMaybe<ReviewVotesReviewVotesForPostAndUserInput>;
  reviewVotesFromUser?: InputMaybe<ReviewVotesReviewVotesFromUserInput>;
};

export type ReviewVotesReviewVotesAdminDashboardInput = {
  year?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewVotesReviewVotesForPostAndUserInput = {
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewVotesReviewVotesFromUserInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewWinner = {
  __typename?: 'ReviewWinner';
  _id: Scalars['String']['output'];
  category: Scalars['String']['output'];
  competitorCount: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  curatedOrder: Maybe<Scalars['Float']['output']>;
  isAI: Maybe<Scalars['Boolean']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  post: Maybe<Post>;
  postId: Scalars['String']['output'];
  reviewRanking: Scalars['Float']['output'];
  reviewWinnerArt: Maybe<ReviewWinnerArt>;
  reviewYear: Scalars['Float']['output'];
  schemaVersion: Scalars['Float']['output'];
};

export type ReviewWinnerArt = {
  __typename?: 'ReviewWinnerArt';
  _id: Scalars['String']['output'];
  activeSplashArtCoordinates: Maybe<SplashArtCoordinate>;
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  midjourneyImageIndex: Maybe<Scalars['Int']['output']>;
  midjourneyJobId: Maybe<Scalars['String']['output']>;
  postId: Scalars['String']['output'];
  schemaVersion: Scalars['Float']['output'];
  splashArtImagePrompt: Scalars['String']['output'];
  splashArtImageUrl: Scalars['String']['output'];
  upscaledImageUrl: Maybe<Scalars['String']['output']>;
};

export type ReviewWinnerArtSelector = {
  allForYear?: InputMaybe<ReviewWinnerArtsAllForYearInput>;
  default?: InputMaybe<EmptyViewInput>;
  postArt?: InputMaybe<ReviewWinnerArtsPostArtInput>;
};

export type ReviewWinnerArtsAllForYearInput = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewWinnerArtsPostArtInput = {
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewWinnerSelector = {
  bestOfLessWrongAnnouncement?: InputMaybe<EmptyViewInput>;
  default?: InputMaybe<EmptyViewInput>;
  reviewWinnerSingle?: InputMaybe<ReviewWinnersReviewWinnerSingleInput>;
};

export type ReviewWinnersReviewWinnerSingleInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  reviewRanking?: InputMaybe<Scalars['String']['input']>;
  reviewYear?: InputMaybe<Scalars['String']['input']>;
};

export type Revision = {
  __typename?: 'Revision';
  _id: Scalars['String']['output'];
  afBaseScore: Maybe<Scalars['Float']['output']>;
  afExtendedScore: Maybe<Scalars['JSON']['output']>;
  afVoteCount: Maybe<Scalars['Float']['output']>;
  agentMarkdown: Maybe<Scalars['String']['output']>;
  agentMarkdownExcerpt: Maybe<Scalars['String']['output']>;
  baseScore: Scalars['Float']['output'];
  changeMetrics: Scalars['JSON']['output'];
  ckEditorMarkup: Maybe<Scalars['String']['output']>;
  collectionName: Maybe<Scalars['String']['output']>;
  commitMessage: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  currentUserExtendedVote: Maybe<Scalars['JSON']['output']>;
  currentUserVote: Maybe<Scalars['String']['output']>;
  documentId: Maybe<Scalars['String']['output']>;
  draft: Maybe<Scalars['Boolean']['output']>;
  editedAt: Scalars['Date']['output'];
  extendedScore: Maybe<Scalars['JSON']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  googleDocMetadata: Maybe<Scalars['JSON']['output']>;
  hasFootnotes: Maybe<Scalars['Boolean']['output']>;
  html: Maybe<Scalars['String']['output']>;
  htmlHighlight: Scalars['String']['output'];
  htmlHighlightStartingAtHash: Scalars['String']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  lens: Maybe<MultiDocument>;
  markdown: Maybe<Scalars['String']['output']>;
  originalContents: ContentType;
  plaintextDescription: Scalars['String']['output'];
  plaintextMainText: Scalars['String']['output'];
  post: Maybe<Post>;
  schemaVersion: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  skipAttributions: Scalars['Boolean']['output'];
  summary: Maybe<MultiDocument>;
  tag: Maybe<Tag>;
  updateType: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
  voteCount: Scalars['Float']['output'];
  wordCount: Scalars['Float']['output'];
};


export type RevisionhtmlHighlightStartingAtHashArgs = {
  hash?: InputMaybe<Scalars['String']['input']>;
};

export type RevisionOutput = {
  __typename?: 'RevisionOutput';
  data: Maybe<Revision>;
};

export type RevisionSelector = {
  default?: InputMaybe<EmptyViewInput>;
  revisionByVersionNumber?: InputMaybe<RevisionsRevisionByVersionNumberInput>;
  revisionsByUser?: InputMaybe<RevisionsRevisionsByUserInput>;
  revisionsOnDocument?: InputMaybe<RevisionsRevisionsOnDocumentInput>;
};

export type RevisionsKarmaChange = {
  __typename?: 'RevisionsKarmaChange';
  _id: Scalars['String']['output'];
  addedReacts: Maybe<Array<ReactionChange>>;
  collectionName: Scalars['String']['output'];
  scoreChange: Scalars['Int']['output'];
  tagId: Maybe<Scalars['String']['output']>;
  tagName: Maybe<Scalars['String']['output']>;
  tagSlug: Maybe<Scalars['String']['output']>;
};

export type RevisionsRevisionByVersionNumberInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type RevisionsRevisionsByUserInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type RevisionsRevisionsOnDocumentInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
};

export type RssPostChangeInfo = {
  __typename?: 'RssPostChangeInfo';
  htmlDiff: Scalars['String']['output'];
  isChanged: Scalars['Boolean']['output'];
  newHtml: Scalars['String']['output'];
};

export type SaveResearchEnvironmentOutput = {
  __typename?: 'SaveResearchEnvironmentOutput';
  data: Maybe<ResearchEnvironment>;
};

export type SelectorInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
};

export type SentenceScore = {
  __typename?: 'SentenceScore';
  score: Scalars['Float']['output'];
  sentence: Scalars['String']['output'];
};

export type Sequence = {
  __typename?: 'Sequence';
  _id: Scalars['String']['output'];
  af: Scalars['Boolean']['output'];
  bannerImageId: Maybe<Scalars['String']['output']>;
  canonicalCollection: Maybe<Collection>;
  canonicalCollectionSlug: Maybe<Scalars['String']['output']>;
  chapters: Array<Chapter>;
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  curatedOrder: Maybe<Scalars['Float']['output']>;
  draft: Scalars['Boolean']['output'];
  gridImageId: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  hideFromAuthorPage: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastUpdated: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  noindex: Scalars['Boolean']['output'];
  postsCount: Scalars['Int']['output'];
  readPostsCount: Scalars['Int']['output'];
  schemaVersion: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
  userProfileOrder: Maybe<Scalars['Float']['output']>;
};


export type SequencecontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type SequenceDefaultViewInput = {
  sequenceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SequenceOutput = {
  __typename?: 'SequenceOutput';
  data: Maybe<Sequence>;
};

export type SequenceSelector = {
  communitySequences?: InputMaybe<SequencesCommunitySequencesInput>;
  curatedSequences?: InputMaybe<SequencesCuratedSequencesInput>;
  default?: InputMaybe<SequenceDefaultViewInput>;
  userProfile?: InputMaybe<SequencesUserProfileInput>;
  userProfileAll?: InputMaybe<SequencesUserProfileAllInput>;
  userProfilePrivate?: InputMaybe<SequencesUserProfilePrivateInput>;
};

export type SequenceStats = {
  __typename?: 'SequenceStats';
  totalReadTime: Maybe<Scalars['Float']['output']>;
  totalWordCount: Maybe<Scalars['Float']['output']>;
};

export type SequencesCommunitySequencesInput = {
  sequenceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SequencesCuratedSequencesInput = {
  sequenceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SequencesUserProfileAllInput = {
  sequenceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SequencesUserProfileInput = {
  sequenceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SequencesUserProfilePrivateInput = {
  sequenceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Session = {
  __typename?: 'Session';
  _id: Maybe<Scalars['String']['output']>;
  expires: Maybe<Scalars['Date']['output']>;
  lastModified: Maybe<Scalars['Date']['output']>;
  session: Maybe<Scalars['JSON']['output']>;
};

export type SetClaudeCodeOAuthTokenOutput = {
  __typename?: 'SetClaudeCodeOAuthTokenOutput';
  success: Scalars['Boolean']['output'];
};

export type SetIsBookmarkedInput = {
  collectionName: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  isBookmarked: Scalars['Boolean']['input'];
};

export type SetIsBookmarkedOutput = {
  __typename?: 'SetIsBookmarkedOutput';
  data: Maybe<Bookmark>;
};

export type SideCommentCache = {
  __typename?: 'SideCommentCache';
  _id: Scalars['String']['output'];
  annotatedHtml: Maybe<Scalars['String']['output']>;
  commentsByBlock: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  postId: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  version: Maybe<Scalars['Float']['output']>;
};

export type SingleArbitalTagContentRelInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleArbitalTagContentRelOutput = {
  __typename?: 'SingleArbitalTagContentRelOutput';
  result: Maybe<ArbitalTagContentRel>;
};

export type SingleBanInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleBanOutput = {
  __typename?: 'SingleBanOutput';
  result: Maybe<Ban>;
};

export type SingleBookInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleBookOutput = {
  __typename?: 'SingleBookOutput';
  result: Maybe<Book>;
};

export type SingleBookmarkInput = {
  allowNull?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleBookmarkOutput = {
  __typename?: 'SingleBookmarkOutput';
  result: Maybe<Bookmark>;
};

export type SingleChapterInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleChapterOutput = {
  __typename?: 'SingleChapterOutput';
  result: Maybe<Chapter>;
};

export type SingleCkEditorUserSessionInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleCkEditorUserSessionOutput = {
  __typename?: 'SingleCkEditorUserSessionOutput';
  result: Maybe<CkEditorUserSession>;
};

export type SingleClientIdInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleClientIdOutput = {
  __typename?: 'SingleClientIdOutput';
  result: Maybe<ClientId>;
};

export type SingleCollectionInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleCollectionOutput = {
  __typename?: 'SingleCollectionOutput';
  result: Maybe<Collection>;
};

export type SingleCommentInput = {
  allowNull?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleCommentModeratorActionInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleCommentModeratorActionOutput = {
  __typename?: 'SingleCommentModeratorActionOutput';
  result: Maybe<CommentModeratorAction>;
};

export type SingleCommentOutput = {
  __typename?: 'SingleCommentOutput';
  result: Maybe<Comment>;
};

export type SingleConversationInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleConversationOutput = {
  __typename?: 'SingleConversationOutput';
  result: Maybe<Conversation>;
};

export type SingleCurationNoticeInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleCurationNoticeOutput = {
  __typename?: 'SingleCurationNoticeOutput';
  result: Maybe<CurationNotice>;
};

export type SingleDialogueCheckInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleDialogueCheckOutput = {
  __typename?: 'SingleDialogueCheckOutput';
  result: Maybe<DialogueCheck>;
};

export type SingleDialogueMatchPreferenceInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleDialogueMatchPreferenceOutput = {
  __typename?: 'SingleDialogueMatchPreferenceOutput';
  result: Maybe<DialogueMatchPreference>;
};

export type SingleElicitQuestionInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleElicitQuestionOutput = {
  __typename?: 'SingleElicitQuestionOutput';
  result: Maybe<ElicitQuestion>;
};

export type SingleElicitQuestionPredictionInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleElicitQuestionPredictionOutput = {
  __typename?: 'SingleElicitQuestionPredictionOutput';
  result: Maybe<ElicitQuestionPrediction>;
};

export type SingleFieldChangeInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleFieldChangeOutput = {
  __typename?: 'SingleFieldChangeOutput';
  result: Maybe<FieldChange>;
};

export type SingleGoogleServiceAccountSessionInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleGoogleServiceAccountSessionOutput = {
  __typename?: 'SingleGoogleServiceAccountSessionOutput';
  result: Maybe<GoogleServiceAccountSession>;
};

export type SingleIframeWidgetSrcdocOutput = {
  __typename?: 'SingleIframeWidgetSrcdocOutput';
  result: Maybe<IframeWidgetSrcdoc>;
};

export type SingleJargonTermInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleJargonTermOutput = {
  __typename?: 'SingleJargonTermOutput';
  result: Maybe<JargonTerm>;
};

export type SingleLWEventInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleLWEventOutput = {
  __typename?: 'SingleLWEventOutput';
  result: Maybe<LWEvent>;
};

export type SingleLlmConversationInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleLlmConversationOutput = {
  __typename?: 'SingleLlmConversationOutput';
  result: Maybe<LlmConversation>;
};

export type SingleLocalgroupInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleLocalgroupOutput = {
  __typename?: 'SingleLocalgroupOutput';
  result: Maybe<Localgroup>;
};

export type SingleMessageInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleMessageOutput = {
  __typename?: 'SingleMessageOutput';
  result: Maybe<Message>;
};

export type SingleModerationTemplateInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleModerationTemplateOutput = {
  __typename?: 'SingleModerationTemplateOutput';
  result: Maybe<ModerationTemplate>;
};

export type SingleModeratorActionInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleModeratorActionOutput = {
  __typename?: 'SingleModeratorActionOutput';
  result: Maybe<ModeratorAction>;
};

export type SingleMultiDocumentInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleMultiDocumentOutput = {
  __typename?: 'SingleMultiDocumentOutput';
  result: Maybe<MultiDocument>;
};

export type SingleNotificationInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleNotificationOutput = {
  __typename?: 'SingleNotificationOutput';
  result: Maybe<Notification>;
};

export type SinglePetrovDayActionInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SinglePetrovDayActionOutput = {
  __typename?: 'SinglePetrovDayActionOutput';
  result: Maybe<PetrovDayAction>;
};

export type SinglePodcastEpisodeInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SinglePodcastEpisodeOutput = {
  __typename?: 'SinglePodcastEpisodeOutput';
  result: Maybe<PodcastEpisode>;
};

export type SinglePodcastInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SinglePodcastOutput = {
  __typename?: 'SinglePodcastOutput';
  result: Maybe<Podcast>;
};

export type SinglePostInput = {
  allowNull?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SinglePostOutput = {
  __typename?: 'SinglePostOutput';
  result: Maybe<Post>;
};

export type SinglePostRelationInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SinglePostRelationOutput = {
  __typename?: 'SinglePostRelationOutput';
  result: Maybe<PostRelation>;
};

export type SingleRSSFeedInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleRSSFeedOutput = {
  __typename?: 'SingleRSSFeedOutput';
  result: Maybe<RSSFeed>;
};

export type SingleReportInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleReportOutput = {
  __typename?: 'SingleReportOutput';
  result: Maybe<Report>;
};

export type SingleResearchConversationEventInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleResearchConversationEventOutput = {
  __typename?: 'SingleResearchConversationEventOutput';
  result: Maybe<ResearchConversationEvent>;
};

export type SingleResearchConversationInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleResearchConversationOutput = {
  __typename?: 'SingleResearchConversationOutput';
  result: Maybe<ResearchConversation>;
};

export type SingleResearchDocumentInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleResearchDocumentOutput = {
  __typename?: 'SingleResearchDocumentOutput';
  result: Maybe<ResearchDocument>;
};

export type SingleResearchEnvironmentInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleResearchEnvironmentOutput = {
  __typename?: 'SingleResearchEnvironmentOutput';
  result: Maybe<ResearchEnvironment>;
};

export type SingleResearchProjectInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleResearchProjectOutput = {
  __typename?: 'SingleResearchProjectOutput';
  result: Maybe<ResearchProject>;
};

export type SingleReviewVoteInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleReviewVoteOutput = {
  __typename?: 'SingleReviewVoteOutput';
  result: Maybe<ReviewVote>;
};

export type SingleReviewWinnerArtInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleReviewWinnerArtOutput = {
  __typename?: 'SingleReviewWinnerArtOutput';
  result: Maybe<ReviewWinnerArt>;
};

export type SingleReviewWinnerInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleReviewWinnerOutput = {
  __typename?: 'SingleReviewWinnerOutput';
  result: Maybe<ReviewWinner>;
};

export type SingleRevisionInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleRevisionOutput = {
  __typename?: 'SingleRevisionOutput';
  result: Maybe<Revision>;
};

export type SingleSequenceInput = {
  allowNull?: InputMaybe<Scalars['Boolean']['input']>;
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleSequenceOutput = {
  __typename?: 'SingleSequenceOutput';
  result: Maybe<Sequence>;
};

export type SingleSplashArtCoordinateInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleSplashArtCoordinateOutput = {
  __typename?: 'SingleSplashArtCoordinateOutput';
  result: Maybe<SplashArtCoordinate>;
};

export type SingleSpotlightInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleSpotlightOutput = {
  __typename?: 'SingleSpotlightOutput';
  result: Maybe<Spotlight>;
};

export type SingleSubscriptionInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleSubscriptionOutput = {
  __typename?: 'SingleSubscriptionOutput';
  result: Maybe<Subscription>;
};

export type SingleTagFlagInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleTagFlagOutput = {
  __typename?: 'SingleTagFlagOutput';
  result: Maybe<TagFlag>;
};

export type SingleTagInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleTagOutput = {
  __typename?: 'SingleTagOutput';
  result: Maybe<Tag>;
};

export type SingleTagRelInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleTagRelOutput = {
  __typename?: 'SingleTagRelOutput';
  result: Maybe<TagRel>;
};

export type SingleTypingIndicatorInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleTypingIndicatorOutput = {
  __typename?: 'SingleTypingIndicatorOutput';
  result: Maybe<TypingIndicator>;
};

export type SingleTypoSuggestionInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleTypoSuggestionOutput = {
  __typename?: 'SingleTypoSuggestionOutput';
  result: Maybe<TypoSuggestion>;
};

export type SingleUltraFeedEventInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleUltraFeedEventOutput = {
  __typename?: 'SingleUltraFeedEventOutput';
  result: Maybe<UltraFeedEvent>;
};

export type SingleUserInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<UserSelectorUniqueInput>;
};

export type SingleUserMostValuablePostInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleUserMostValuablePostOutput = {
  __typename?: 'SingleUserMostValuablePostOutput';
  result: Maybe<UserMostValuablePost>;
};

export type SingleUserOutput = {
  __typename?: 'SingleUserOutput';
  result: Maybe<User>;
};

export type SingleUserRateLimitInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleUserRateLimitOutput = {
  __typename?: 'SingleUserRateLimitOutput';
  result: Maybe<UserRateLimit>;
};

export type SingleUserTagRelInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleUserTagRelOutput = {
  __typename?: 'SingleUserTagRelOutput';
  result: Maybe<UserTagRel>;
};

export type SingleVoteInput = {
  resolverArgs?: InputMaybe<Scalars['JSON']['input']>;
  selector?: InputMaybe<SelectorInput>;
};

export type SingleVoteOutput = {
  __typename?: 'SingleVoteOutput';
  result: Maybe<Vote>;
};

export type Site = {
  __typename?: 'Site';
  logoUrl: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type SocialPreviewInput = {
  imageId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SocialPreviewOutput = {
  __typename?: 'SocialPreviewOutput';
  imageId: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type SocialPreviewType = {
  __typename?: 'SocialPreviewType';
  _id: Scalars['String']['output'];
  imageId: Maybe<Scalars['String']['output']>;
  imageUrl: Scalars['String']['output'];
  text: Maybe<Scalars['String']['output']>;
};

export type SplashArtCoordinate = {
  __typename?: 'SplashArtCoordinate';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  leftFlipped: Scalars['Boolean']['output'];
  leftHeightPct: Scalars['Float']['output'];
  leftWidthPct: Scalars['Float']['output'];
  leftXPct: Scalars['Float']['output'];
  leftYPct: Scalars['Float']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  middleFlipped: Scalars['Boolean']['output'];
  middleHeightPct: Scalars['Float']['output'];
  middleWidthPct: Scalars['Float']['output'];
  middleXPct: Scalars['Float']['output'];
  middleYPct: Scalars['Float']['output'];
  reviewWinnerArt: Maybe<ReviewWinnerArt>;
  reviewWinnerArtId: Maybe<Scalars['String']['output']>;
  rightFlipped: Scalars['Boolean']['output'];
  rightHeightPct: Scalars['Float']['output'];
  rightWidthPct: Scalars['Float']['output'];
  rightXPct: Scalars['Float']['output'];
  rightYPct: Scalars['Float']['output'];
  schemaVersion: Scalars['Float']['output'];
};

export type SplashArtCoordinateOutput = {
  __typename?: 'SplashArtCoordinateOutput';
  data: Maybe<SplashArtCoordinate>;
};

export type SplashArtCoordinateSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type Spotlight = {
  __typename?: 'Spotlight';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  customSubtitle: Maybe<Scalars['String']['output']>;
  customTitle: Maybe<Scalars['String']['output']>;
  deletedDraft: Scalars['Boolean']['output'];
  description: Maybe<Revision>;
  description_latest: Maybe<Scalars['String']['output']>;
  document: Maybe<Post>;
  documentId: Scalars['String']['output'];
  documentType: SpotlightDocumentType;
  draft: Scalars['Boolean']['output'];
  duration: Scalars['Float']['output'];
  headerTitle: Maybe<Scalars['String']['output']>;
  headerTitleLeftColor: Maybe<Scalars['String']['output']>;
  headerTitleRightColor: Maybe<Scalars['String']['output']>;
  imageFade: Scalars['Boolean']['output'];
  imageFadeColor: Maybe<Scalars['String']['output']>;
  lastPromotedAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  position: Scalars['Float']['output'];
  post: Maybe<Post>;
  schemaVersion: Scalars['Float']['output'];
  sequence: Maybe<Sequence>;
  sequenceChapters: Maybe<Array<Chapter>>;
  showAuthor: Scalars['Boolean']['output'];
  spotlightDarkImageId: Maybe<Scalars['String']['output']>;
  spotlightImageId: Maybe<Scalars['String']['output']>;
  spotlightSplashImageUrl: Maybe<Scalars['String']['output']>;
  subtitleUrl: Maybe<Scalars['String']['output']>;
  tag: Maybe<Tag>;
};


export type SpotlightdescriptionArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type SpotlightDocumentType =
  | 'Post'
  | 'Sequence'
  | 'Tag';

export type SpotlightOutput = {
  __typename?: 'SpotlightOutput';
  data: Maybe<Spotlight>;
};

export type SpotlightSelector = {
  default?: InputMaybe<EmptyViewInput>;
  mostRecentlyPromotedSpotlights?: InputMaybe<SpotlightsMostRecentlyPromotedSpotlightsInput>;
  spotlightsByDocumentIds?: InputMaybe<SpotlightsSpotlightsByDocumentIdsInput>;
  spotlightsById?: InputMaybe<SpotlightsSpotlightsByIdInput>;
  spotlightsPage?: InputMaybe<SpotlightsSpotlightsPageInput>;
  spotlightsPageDraft?: InputMaybe<SpotlightsSpotlightsPageDraftInput>;
};

export type SpotlightsMostRecentlyPromotedSpotlightsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SpotlightsSpotlightsByDocumentIdsInput = {
  documentIds?: InputMaybe<Scalars['String']['input']>;
};

export type SpotlightsSpotlightsByIdInput = {
  spotlightIds?: InputMaybe<Scalars['String']['input']>;
};

export type SpotlightsSpotlightsPageDraftInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SpotlightsSpotlightsPageInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SubforumPreferredLayout =
  | 'card'
  | 'list';

export type Subscription = {
  __typename?: 'Subscription';
  _id: Scalars['String']['output'];
  collectionName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deleted: Maybe<Scalars['Boolean']['output']>;
  documentId: Maybe<Scalars['String']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  state: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['String']['output']>;
};

export type SubscriptionOutput = {
  __typename?: 'SubscriptionOutput';
  data: Maybe<Subscription>;
};

export type SubscriptionSelector = {
  default?: InputMaybe<EmptyViewInput>;
  membersOfGroup?: InputMaybe<SubscriptionsMembersOfGroupInput>;
  subscriptionState?: InputMaybe<SubscriptionsSubscriptionStateInput>;
  subscriptionsOfType?: InputMaybe<SubscriptionsSubscriptionsOfTypeInput>;
};

export type SubscriptionsMembersOfGroupInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionsSubscriptionStateInput = {
  collectionName?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionsSubscriptionsOfTypeInput = {
  collectionName?: InputMaybe<Scalars['String']['input']>;
  subscriptionType?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestedFeedSubscriptionUsersResult = {
  __typename?: 'SuggestedFeedSubscriptionUsersResult';
  results: Array<User>;
};

export type SuggestedTopActiveUsersResult = {
  __typename?: 'SuggestedTopActiveUsersResult';
  results: Array<User>;
};

export type Tag = {
  __typename?: 'Tag';
  _id: Scalars['String']['output'];
  adminOnly: Scalars['Boolean']['output'];
  afBaseScore: Maybe<Scalars['Float']['output']>;
  afExtendedScore: Maybe<Scalars['JSON']['output']>;
  afVoteCount: Maybe<Scalars['Float']['output']>;
  arbitalLinkedPages: Maybe<ArbitalLinkedPages>;
  authorOnly: Scalars['Boolean']['output'];
  autoTagModel: Maybe<Scalars['String']['output']>;
  autoTagPrompt: Maybe<Scalars['String']['output']>;
  bannerImageId: Maybe<Scalars['String']['output']>;
  baseScore: Scalars['Float']['output'];
  canEditUserIds: Maybe<Array<Scalars['String']['output']>>;
  canVoteOnRels: Maybe<Array<TagRelVoteGroup>>;
  charsAdded: Maybe<Scalars['Float']['output']>;
  charsRemoved: Maybe<Scalars['Float']['output']>;
  contributionStats: Maybe<Scalars['JSON']['output']>;
  contributors: TagContributorsList;
  core: Scalars['Boolean']['output'];
  coreTagId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  currentUserExtendedVote: Maybe<Scalars['JSON']['output']>;
  currentUserVote: Maybe<Scalars['String']['output']>;
  defaultOrder: Scalars['Float']['output'];
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Revision>;
  descriptionTruncationCount: Scalars['Float']['output'];
  description_latest: Maybe<Scalars['String']['output']>;
  extendedScore: Maybe<Scalars['JSON']['output']>;
  forceAllowType3Audio: Scalars['Boolean']['output'];
  htmlWithContributorAnnotations: Maybe<Scalars['String']['output']>;
  introSequenceId: Maybe<Scalars['String']['output']>;
  isArbitalImport: Maybe<Scalars['Boolean']['output']>;
  isPlaceholderPage: Scalars['Boolean']['output'];
  isPostType: Scalars['Boolean']['output'];
  isRead: Maybe<Scalars['Boolean']['output']>;
  isSubforum: Scalars['Boolean']['output'];
  lastCommentedAt: Maybe<Scalars['Date']['output']>;
  lastSubforumCommentAt: Maybe<Scalars['Date']['output']>;
  lastVisitedAt: Maybe<Scalars['Date']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  lenses: Array<MultiDocument>;
  lensesIncludingDeleted: Array<MultiDocument>;
  lesswrongWikiImportCompleted: Maybe<Scalars['Boolean']['output']>;
  lesswrongWikiImportRevision: Maybe<Scalars['String']['output']>;
  lesswrongWikiImportSlug: Maybe<Scalars['String']['output']>;
  maxScore: Maybe<Scalars['Int']['output']>;
  moderationGuidelines: Maybe<Revision>;
  moderationGuidelines_latest: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  needsReview: Scalars['Boolean']['output'];
  noindex: Scalars['Boolean']['output'];
  oldSlugs: Array<Scalars['String']['output']>;
  parentTag: Maybe<Tag>;
  parentTagId: Maybe<Scalars['String']['output']>;
  pingbacks: Maybe<Scalars['JSON']['output']>;
  postCount: Scalars['Float']['output'];
  postsDefaultSortOrder: Maybe<Scalars['String']['output']>;
  recentComments: Array<Comment>;
  removalResistant: Scalars['Boolean']['output'];
  reviewedByUser: Maybe<User>;
  reviewedByUserId: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  sequence: Maybe<Sequence>;
  shortName: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  squareImageId: Maybe<Scalars['String']['output']>;
  subTagIds: Array<Scalars['String']['output']>;
  subTags: Array<Tag>;
  subforumIntroPost: Maybe<Post>;
  subforumIntroPostId: Maybe<Scalars['String']['output']>;
  subforumModeratorIds: Array<Scalars['String']['output']>;
  subforumModerators: Array<User>;
  subforumUnreadMessagesCount: Maybe<Scalars['Int']['output']>;
  subforumWelcomeText: Maybe<Revision>;
  subforumWelcomeText_latest: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  suggestedAsFilter: Scalars['Boolean']['output'];
  summaries: Array<MultiDocument>;
  tableOfContents: Maybe<Scalars['JSON']['output']>;
  tagFlags: Array<TagFlag>;
  tagFlagsIds: Array<Scalars['String']['output']>;
  textLastUpdatedAt: Maybe<Scalars['Date']['output']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['String']['output']>;
  usersWhoLiked: Array<UserLikingTag>;
  voteCount: Scalars['Float']['output'];
  wikiGrade: Scalars['Int']['output'];
  wikiOnly: Scalars['Boolean']['output'];
};


export type TagcontributorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type TagdescriptionArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type TaglensesArgs = {
  lensSlug?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type TaglensesIncludingDeletedArgs = {
  lensSlug?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type TagmoderationGuidelinesArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type TagrecentCommentsArgs = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  maxAgeHours?: InputMaybe<Scalars['Int']['input']>;
  tagCommentType?: InputMaybe<Scalars['String']['input']>;
  tagCommentsLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type TagsubforumWelcomeTextArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type TagtableOfContentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type TagCommentType =
  | 'DISCUSSION'
  | 'SUBFORUM';

export type TagContributor = {
  __typename?: 'TagContributor';
  contributionScore: Scalars['Int']['output'];
  currentAttributionCharCount: Maybe<Scalars['Int']['output']>;
  numCommits: Scalars['Int']['output'];
  user: Maybe<User>;
  voteCount: Scalars['Int']['output'];
};

export type TagContributorsList = {
  __typename?: 'TagContributorsList';
  contributors: Array<TagContributor>;
  totalCount: Scalars['Int']['output'];
};

export type TagDefaultViewInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagFlag = {
  __typename?: 'TagFlag';
  _id: Scalars['String']['output'];
  contents: Maybe<Revision>;
  contents_latest: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deleted: Scalars['Boolean']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  order: Maybe<Scalars['Float']['output']>;
  schemaVersion: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
};


export type TagFlagcontentsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};

export type TagFlagOutput = {
  __typename?: 'TagFlagOutput';
  data: Maybe<TagFlag>;
};

export type TagFlagSelector = {
  allTagFlags?: InputMaybe<EmptyViewInput>;
  default?: InputMaybe<EmptyViewInput>;
};

export type TagHistoryFeedEntry = {
  __typename?: 'TagHistoryFeedEntry';
  lensOrSummaryMetadataChanged: Maybe<FieldChange>;
  lensRevision: Maybe<Revision>;
  summaryRevision: Maybe<Revision>;
  tagApplied: Maybe<TagRel>;
  tagCreated: Maybe<Tag>;
  tagDiscussionComment: Maybe<Comment>;
  tagRevision: Maybe<Revision>;
  type: TagHistoryFeedEntryType;
  wikiMetadataChanged: Maybe<FieldChange>;
};

export type TagHistoryFeedEntryType =
  | 'lensOrSummaryMetadataChanged'
  | 'lensRevision'
  | 'summaryRevision'
  | 'tagApplied'
  | 'tagCreated'
  | 'tagDiscussionComment'
  | 'tagRevision'
  | 'wikiMetadataChanged';

export type TagHistoryFeedQueryResults = {
  __typename?: 'TagHistoryFeedQueryResults';
  cutoff: Maybe<Scalars['Date']['output']>;
  endOffset: Scalars['Int']['output'];
  results: Maybe<Array<TagHistoryFeedEntry>>;
};

export type TagOutput = {
  __typename?: 'TagOutput';
  data: Maybe<Tag>;
};

export type TagPreviewWithSummaries = {
  __typename?: 'TagPreviewWithSummaries';
  lens: Maybe<MultiDocument>;
  summaries: Array<MultiDocument>;
  tag: Tag;
};

export type TagRel = {
  __typename?: 'TagRel';
  _id: Scalars['String']['output'];
  afBaseScore: Maybe<Scalars['Float']['output']>;
  afExtendedScore: Maybe<Scalars['JSON']['output']>;
  afVoteCount: Maybe<Scalars['Float']['output']>;
  autoApplied: Scalars['Boolean']['output'];
  backfilled: Scalars['Boolean']['output'];
  baseScore: Scalars['Float']['output'];
  createdAt: Scalars['Date']['output'];
  currentUserCanVote: Scalars['Boolean']['output'];
  currentUserExtendedVote: Maybe<Scalars['JSON']['output']>;
  currentUserVote: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  extendedScore: Maybe<Scalars['JSON']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  post: Maybe<Post>;
  postId: Scalars['String']['output'];
  schemaVersion: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  tag: Maybe<Tag>;
  tagId: Scalars['String']['output'];
  user: Maybe<User>;
  userId: Maybe<Scalars['String']['output']>;
  voteCount: Scalars['Float']['output'];
};

export type TagRelSelector = {
  default?: InputMaybe<EmptyViewInput>;
  postsWithTag?: InputMaybe<TagRelsPostsWithTagInput>;
  tagsOnPost?: InputMaybe<TagRelsTagsOnPostInput>;
};

export type TagRelVoteGroup =
  | 'admins'
  | 'alignmentForum'
  | 'alignmentForumAdmins'
  | 'alignmentVoters'
  | 'canBypassPostRateLimit'
  | 'canModeratePersonal'
  | 'canSuggestCuration'
  | 'debaters'
  | 'guests'
  | 'members'
  | 'podcasters'
  | 'realAdmins'
  | 'sunshineRegiment'
  | 'trustLevel1'
  | 'userOwns'
  | 'userOwnsOnlyUpvote';

export type TagRelsPostsWithTagInput = {
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export type TagRelsTagsOnPostInput = {
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type TagSelector = {
  allArbitalTags?: InputMaybe<TagsAllArbitalTagsInput>;
  allLWWikiTags?: InputMaybe<TagsAllLWWikiTagsInput>;
  allPagesByNewest?: InputMaybe<TagsAllPagesByNewestInput>;
  allPublicTags?: InputMaybe<TagsAllPublicTagsInput>;
  allTagsAlphabetical?: InputMaybe<TagsAllTagsAlphabeticalInput>;
  allTagsHierarchical?: InputMaybe<TagsAllTagsHierarchicalInput>;
  coreAndSubforumTags?: InputMaybe<TagsCoreAndSubforumTagsInput>;
  coreTags?: InputMaybe<TagsCoreTagsInput>;
  currentUserSubforums?: InputMaybe<TagsCurrentUserSubforumsInput>;
  default?: InputMaybe<TagDefaultViewInput>;
  newTags?: InputMaybe<TagsNewTagsInput>;
  pingbackWikiPages?: InputMaybe<TagsPingbackWikiPagesInput>;
  postTypeTags?: InputMaybe<TagsPostTypeTagsInput>;
  suggestedFilterTags?: InputMaybe<TagsSuggestedFilterTagsInput>;
  tagBySlug?: InputMaybe<TagsTagBySlugInput>;
  tagsBySlugs?: InputMaybe<TagsTagsBySlugsInput>;
  tagsByTagFlag?: InputMaybe<TagsTagsByTagFlagInput>;
  tagsByTagIds?: InputMaybe<TagsTagsByTagIdsInput>;
  unprocessedLWWikiTags?: InputMaybe<TagsUnprocessedLWWikiTagsInput>;
  unreviewedTags?: InputMaybe<TagsUnreviewedTagsInput>;
  userTags?: InputMaybe<TagsUserTagsInput>;
};

export type TagUpdates = {
  __typename?: 'TagUpdates';
  added: Scalars['Int']['output'];
  commentCount: Scalars['Int']['output'];
  commentIds: Array<Scalars['String']['output']>;
  documentDeletions: Array<DocumentDeletion>;
  lastCommentedAt: Maybe<Scalars['Date']['output']>;
  lastRevisedAt: Maybe<Scalars['Date']['output']>;
  removed: Scalars['Int']['output'];
  revisionIds: Array<Scalars['String']['output']>;
  tag: Tag;
  users: Array<User>;
};

export type TagWithTotalCount = {
  __typename?: 'TagWithTotalCount';
  tags: Array<Tag>;
  totalCount: Scalars['Int']['output'];
};

export type TagsAllArbitalTagsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsAllLWWikiTagsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsAllPagesByNewestInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsAllPublicTagsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsAllTagsAlphabeticalInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsAllTagsHierarchicalInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  wikiGrade?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCoreAndSubforumTagsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsCoreTagsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsCurrentUserSubforumsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsNewTagsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsPingbackWikiPagesInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export type TagsPostTypeTagsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsSuggestedFilterTagsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsTagBySlugInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type TagsTagsBySlugsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs: Array<Scalars['String']['input']>;
};

export type TagsTagsByTagFlagInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagFlagId?: InputMaybe<Scalars['String']['input']>;
};

export type TagsTagsByTagIdsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagIds: Array<Scalars['String']['input']>;
};

export type TagsUnprocessedLWWikiTagsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsUnreviewedTagsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TagsUserTagsInput = {
  excludedTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleBookmarkInput = {
  collectionName: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};

export type ToggleBookmarkOutput = {
  __typename?: 'ToggleBookmarkOutput';
  data: Maybe<Bookmark>;
};

export type TopCommentedTagUser = {
  __typename?: 'TopCommentedTagUser';
  _id: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  tag_comment_counts: Array<CommentCountTag>;
  total_power: Scalars['Float']['output'];
  username: Scalars['String']['output'];
};

export type Tweet = {
  __typename?: 'Tweet';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
};

export type TypingIndicator = {
  __typename?: 'TypingIndicator';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  documentId: Maybe<Scalars['String']['output']>;
  lastUpdated: Maybe<Scalars['Date']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  userId: Maybe<Scalars['String']['output']>;
};

export type TypingIndicatorSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type TypoAcceptMode =
  | 'APPLY'
  | 'SUGGEST';

export type TypoSuggestion = {
  __typename?: 'TypoSuggestion';
  _id: Scalars['String']['output'];
  appliedRevisionId: Maybe<Scalars['String']['output']>;
  author: Maybe<User>;
  authorId: Maybe<Scalars['String']['output']>;
  collectionName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  documentId: Maybe<Scalars['String']['output']>;
  explanation: Maybe<Scalars['String']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  llmCanonicalQuote: Maybe<Scalars['String']['output']>;
  llmVerdict: Maybe<Scalars['String']['output']>;
  narrowedQuote: Maybe<Scalars['String']['output']>;
  narrowedReplacement: Maybe<Scalars['String']['output']>;
  proposedReplacement: Maybe<Scalars['String']['output']>;
  quote: Maybe<Scalars['String']['output']>;
  reactor: Maybe<User>;
  resolvedAt: Maybe<Scalars['Date']['output']>;
  resolvedByUserId: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  voteId: Maybe<Scalars['String']['output']>;
};

export type TypoSuggestionSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type UltraFeedEntry = {
  __typename?: 'UltraFeedEntry';
  feedCommentThread: Maybe<FeedCommentThread>;
  feedMarker: Maybe<FeedMarker>;
  feedPost: Maybe<FeedPost>;
  feedSpotlight: Maybe<FeedSpotlightItem>;
  feedSubscriptionSuggestions: Maybe<FeedSubscriptionSuggestions>;
  type: UltraFeedEntryType;
};

export type UltraFeedEntryType =
  | 'feedCommentThread'
  | 'feedMarker'
  | 'feedPost'
  | 'feedSpotlight'
  | 'feedSubscriptionSuggestions';

export type UltraFeedEvent = {
  __typename?: 'UltraFeedEvent';
  _id: Scalars['String']['output'];
  collectionName: Maybe<UltraFeedEventCollectionName>;
  createdAt: Scalars['Date']['output'];
  documentId: Maybe<Scalars['String']['output']>;
  event: Maybe<Scalars['JSON']['output']>;
  eventType: Maybe<UltraFeedEventEventType>;
  feedItemId: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type UltraFeedEventCollectionName =
  | 'Comments'
  | 'Posts'
  | 'Spotlights';

export type UltraFeedEventEventType =
  | 'expanded'
  | 'interacted'
  | 'seeLess'
  | 'served'
  | 'viewed';

export type UltraFeedEventOutput = {
  __typename?: 'UltraFeedEventOutput';
  data: Maybe<UltraFeedEvent>;
};

export type UltraFeedEventSelector = {
  default?: InputMaybe<EmptyViewInput>;
};

export type UltraFeedQueryResults = {
  __typename?: 'UltraFeedQueryResults';
  cutoff: Maybe<Scalars['Date']['output']>;
  endOffset: Scalars['Int']['output'];
  results: Maybe<Array<UltraFeedEntry>>;
  sessionId: Maybe<Scalars['String']['output']>;
};

export type UniqueClientViewsSeries = {
  __typename?: 'UniqueClientViewsSeries';
  date: Maybe<Scalars['Date']['output']>;
  uniqueClientViews: Maybe<Scalars['Int']['output']>;
};

export type UpdateBookDataInput = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  displaySequencesAsGrid?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sequenceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  showChapters?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tocTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBookInput = {
  data: UpdateBookDataInput;
  selector: SelectorInput;
};

export type UpdateChapterDataInput = {
  contents?: InputMaybe<CreateRevisionDataInput>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  postIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sequenceId?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChapterInput = {
  data: UpdateChapterDataInput;
  selector: SelectorInput;
};

export type UpdateCollectionDataInput = {
  contents?: InputMaybe<CreateRevisionDataInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  firstPageLink?: InputMaybe<Scalars['String']['input']>;
  gridImageId?: InputMaybe<Scalars['String']['input']>;
  hideStartReadingButton?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  noindex?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCollectionInput = {
  data: UpdateCollectionDataInput;
  selector: SelectorInput;
};

export type UpdateCommentDataInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  afDate?: InputMaybe<Scalars['Date']['input']>;
  agentFoundationsId?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['Boolean']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  debateResponse?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByUserId?: InputMaybe<Scalars['String']['input']>;
  deletedDate?: InputMaybe<Scalars['Date']['input']>;
  deletedPublic?: InputMaybe<Scalars['Boolean']['input']>;
  deletedReason?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  hideAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  hideKarma?: InputMaybe<Scalars['Boolean']['input']>;
  hideModeratorHat?: InputMaybe<Scalars['Boolean']['input']>;
  isPinnedOnProfile?: InputMaybe<Scalars['Boolean']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  legacyId?: InputMaybe<Scalars['String']['input']>;
  legacyParentId?: InputMaybe<Scalars['String']['input']>;
  legacyPoll?: InputMaybe<Scalars['Boolean']['input']>;
  moderatorHat?: InputMaybe<Scalars['Boolean']['input']>;
  moveToAlignmentUserId?: InputMaybe<Scalars['String']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  nominatedForReview?: InputMaybe<Scalars['String']['input']>;
  originalDialogueId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  postedAt?: InputMaybe<Scalars['Date']['input']>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  promotedByUserId?: InputMaybe<Scalars['String']['input']>;
  rejected?: InputMaybe<Scalars['Boolean']['input']>;
  rejectedByUserId?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  relevantTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  repliesBlockedUntil?: InputMaybe<Scalars['Date']['input']>;
  retracted?: InputMaybe<Scalars['Boolean']['input']>;
  reviewForAlignmentUserId?: InputMaybe<Scalars['String']['input']>;
  reviewedByUserId?: InputMaybe<Scalars['String']['input']>;
  reviewingForReview?: InputMaybe<Scalars['String']['input']>;
  shortform?: InputMaybe<Scalars['Boolean']['input']>;
  shortformFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
  spam?: InputMaybe<Scalars['Boolean']['input']>;
  suggestForAlignmentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommentInput = {
  data: UpdateCommentDataInput;
  selector: SelectorInput;
};

export type UpdateCommentModeratorActionDataInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Date']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommentModeratorActionInput = {
  data: UpdateCommentModeratorActionDataInput;
  selector: SelectorInput;
};

export type UpdateConversationDataInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  archivedByIds?: InputMaybe<Array<Scalars['String']['input']>>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  moderator?: InputMaybe<Scalars['Boolean']['input']>;
  participantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConversationInput = {
  data: UpdateConversationDataInput;
  selector: SelectorInput;
};

export type UpdateCurationNoticeDataInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateCurationNoticeInput = {
  data: UpdateCurationNoticeDataInput;
  selector: SelectorInput;
};

export type UpdateElicitQuestionDataInput = {
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  resolvesBy?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateElicitQuestionInput = {
  data: UpdateElicitQuestionDataInput;
  selector: SelectorInput;
};

export type UpdateJargonTermDataInput = {
  altTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateJargonTermInput = {
  data: UpdateJargonTermDataInput;
  selector: SelectorInput;
};

export type UpdateLlmConversationDataInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLlmConversationInput = {
  data: UpdateLlmConversationDataInput;
  selector: SelectorInput;
};

export type UpdateLocalgroupDataInput = {
  bannerImageId?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  facebookPageLink?: InputMaybe<Scalars['String']['input']>;
  googleLocation?: InputMaybe<Scalars['JSON']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivity?: InputMaybe<Scalars['Date']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  meetupLink?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameInAnotherLanguage?: InputMaybe<Scalars['String']['input']>;
  organizerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  slackLink?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLocalgroupInput = {
  data: UpdateLocalgroupDataInput;
  selector: SelectorInput;
};

export type UpdateMessageDataInput = {
  contents?: InputMaybe<CreateRevisionDataInput>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateMessageInput = {
  data: UpdateMessageDataInput;
  selector: SelectorInput;
};

export type UpdateModerationTemplateDataInput = {
  collectionName?: InputMaybe<ModerationTemplateType>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  groupLabel?: InputMaybe<Scalars['String']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateModerationTemplateInput = {
  data: UpdateModerationTemplateDataInput;
  selector: SelectorInput;
};

export type UpdateModeratorActionDataInput = {
  endedAt?: InputMaybe<Scalars['Date']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<ModeratorActionType>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateModeratorActionInput = {
  data: UpdateModeratorActionDataInput;
  selector: SelectorInput;
};

export type UpdateMultiDocumentDataInput = {
  contents?: InputMaybe<CreateRevisionDataInput>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tabSubtitle?: InputMaybe<Scalars['String']['input']>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMultiDocumentInput = {
  data: UpdateMultiDocumentDataInput;
  selector: SelectorInput;
};

export type UpdateNotificationDataInput = {
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNotificationInput = {
  data: UpdateNotificationDataInput;
  selector: SelectorInput;
};

export type UpdatePostDataInput = {
  activateRSVPs?: InputMaybe<Scalars['Boolean']['input']>;
  af?: InputMaybe<Scalars['Boolean']['input']>;
  afDate?: InputMaybe<Scalars['Date']['input']>;
  afSticky?: InputMaybe<Scalars['Boolean']['input']>;
  agentFoundationsId?: InputMaybe<Scalars['String']['input']>;
  authorIsUnreviewed?: InputMaybe<Scalars['Boolean']['input']>;
  autoFrontpage?: InputMaybe<Scalars['String']['input']>;
  bannedUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  canonicalBookId?: InputMaybe<Scalars['String']['input']>;
  canonicalCollectionSlug?: InputMaybe<Scalars['String']['input']>;
  canonicalNextPostSlug?: InputMaybe<Scalars['String']['input']>;
  canonicalPrevPostSlug?: InputMaybe<Scalars['String']['input']>;
  canonicalSequenceId?: InputMaybe<Scalars['String']['input']>;
  canonicalSource?: InputMaybe<Scalars['String']['input']>;
  coauthorStatuses?: InputMaybe<Array<CoauthorStatusInput>>;
  coauthorUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  collabEditorDialogue?: InputMaybe<Scalars['Boolean']['input']>;
  collectionTitle?: InputMaybe<Scalars['String']['input']>;
  commentSortOrder?: InputMaybe<Scalars['String']['input']>;
  commentsLocked?: InputMaybe<Scalars['Boolean']['input']>;
  commentsLockedToAccountsCreatedAfter?: InputMaybe<Scalars['Date']['input']>;
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  curatedDate?: InputMaybe<Scalars['Date']['input']>;
  customHighlight?: InputMaybe<CreateRevisionDataInput>;
  defaultRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  deletedDraft?: InputMaybe<Scalars['Boolean']['input']>;
  disableRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  disableSidenotes?: InputMaybe<Scalars['Boolean']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  eventImageId?: InputMaybe<Scalars['String']['input']>;
  eventRegistrationLink?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  feedId?: InputMaybe<Scalars['String']['input']>;
  feedLink?: InputMaybe<Scalars['String']['input']>;
  fmCrosspost?: InputMaybe<CrosspostInput>;
  forceAllowType3Audio?: InputMaybe<Scalars['Boolean']['input']>;
  frontpageDate?: InputMaybe<Scalars['Date']['input']>;
  generateDraftJargon?: InputMaybe<Scalars['Boolean']['input']>;
  globalEvent?: InputMaybe<Scalars['Boolean']['input']>;
  googleLocation?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hasCoauthorPermission?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenRelatedQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  hideAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  hideCommentKarma?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromPopularComments?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromRecentDiscussions?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageComments?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreRateLimits?: InputMaybe<Scalars['Boolean']['input']>;
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  joinEventLink?: InputMaybe<Scalars['String']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  legacyId?: InputMaybe<Scalars['String']['input']>;
  legacySpam?: InputMaybe<Scalars['Boolean']['input']>;
  linkSharingKey?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manifoldReviewMarketId?: InputMaybe<Scalars['String']['input']>;
  meetupLink?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['Boolean']['input']>;
  metaDate?: InputMaybe<Scalars['Date']['input']>;
  metaSticky?: InputMaybe<Scalars['Boolean']['input']>;
  moderationGuidelines?: InputMaybe<CreateRevisionDataInput>;
  moderationStyle?: InputMaybe<Scalars['String']['input']>;
  nextDayReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  onlineEvent?: InputMaybe<Scalars['Boolean']['input']>;
  onlyVisibleToEstablishedAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyVisibleToLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  organizerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  podcastEpisodeId?: InputMaybe<Scalars['String']['input']>;
  postCategory?: InputMaybe<PostCategory>;
  postedAt?: InputMaybe<Scalars['Date']['input']>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  readTimeMinutesOverride?: InputMaybe<Scalars['Float']['input']>;
  rejected?: InputMaybe<Scalars['Boolean']['input']>;
  rejectedByUserId?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  reviewForAlignmentUserId?: InputMaybe<Scalars['String']['input']>;
  reviewForCuratedUserId?: InputMaybe<Scalars['String']['input']>;
  reviewedByUserId?: InputMaybe<Scalars['String']['input']>;
  shareWithUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  sharingSettings?: InputMaybe<Scalars['JSON']['input']>;
  shortform?: InputMaybe<Scalars['Boolean']['input']>;
  sideCommentVisibility?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  socialPreview?: InputMaybe<SocialPreviewInput>;
  socialPreviewImageAutoUrl?: InputMaybe<Scalars['String']['input']>;
  socialPreviewImageId?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['Float']['input']>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  stickyPriority?: InputMaybe<Scalars['Int']['input']>;
  subforumTagId?: InputMaybe<Scalars['String']['input']>;
  submitToFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
  suggestForAlignmentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  suggestForCuratedUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  swrCachingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tagRelevance?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  unlisted?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  votingSystem?: InputMaybe<Scalars['String']['input']>;
  wasEverUndrafted?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePostInput = {
  data: UpdatePostDataInput;
  selector: SelectorInput;
};

export type UpdateRSSFeedDataInput = {
  displayFullContent?: InputMaybe<Scalars['Boolean']['input']>;
  importAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  ownedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  rawFeed?: InputMaybe<Scalars['JSON']['input']>;
  setCanonicalUrl?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRSSFeedInput = {
  data: UpdateRSSFeedDataInput;
  selector: SelectorInput;
};

export type UpdateReportDataInput = {
  claimedUserId?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  markedAsSpam?: InputMaybe<Scalars['Boolean']['input']>;
  reportedAsSpam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateReportInput = {
  data: UpdateReportDataInput;
  selector: SelectorInput;
};

export type UpdateResearchConversationDataInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  baseEnvironmentId?: InputMaybe<Scalars['String']['input']>;
  claudeSessionId?: InputMaybe<Scalars['String']['input']>;
  entrypointDocumentId?: InputMaybe<Scalars['String']['input']>;
  entrypointKind?: InputMaybe<ResearchEntrypointKind>;
  icon?: InputMaybe<Scalars['String']['input']>;
  lastActivityAt?: InputMaybe<Scalars['Date']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResearchConversationInput = {
  data: UpdateResearchConversationDataInput;
  selector: SelectorInput;
};

export type UpdateResearchDocumentDataInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResearchDocumentInput = {
  data: UpdateResearchDocumentDataInput;
  selector: SelectorInput;
};

export type UpdateResearchEnvironmentDataInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  sourceEventId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  vercelSnapshotId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResearchEnvironmentInput = {
  data: UpdateResearchEnvironmentDataInput;
  selector: SelectorInput;
};

export type UpdateResearchProjectDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResearchProjectInput = {
  data: UpdateResearchProjectDataInput;
  selector: SelectorInput;
};

export type UpdateRevisionDataInput = {
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  skipAttributions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRevisionInput = {
  data: UpdateRevisionDataInput;
  selector: SelectorInput;
};

export type UpdateSequenceDataInput = {
  af?: InputMaybe<Scalars['Boolean']['input']>;
  bannerImageId?: InputMaybe<Scalars['String']['input']>;
  canonicalCollectionSlug?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<CreateRevisionDataInput>;
  curatedOrder?: InputMaybe<Scalars['Float']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  gridImageId?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromAuthorPage?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated?: InputMaybe<Scalars['Date']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  noindex?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSequenceInput = {
  data: UpdateSequenceDataInput;
  selector: SelectorInput;
};

export type UpdateSpotlightDataInput = {
  customSubtitle?: InputMaybe<Scalars['String']['input']>;
  customTitle?: InputMaybe<Scalars['String']['input']>;
  deletedDraft?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<CreateRevisionDataInput>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<SpotlightDocumentType>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  headerTitle?: InputMaybe<Scalars['String']['input']>;
  headerTitleLeftColor?: InputMaybe<Scalars['String']['input']>;
  headerTitleRightColor?: InputMaybe<Scalars['String']['input']>;
  imageFade?: InputMaybe<Scalars['Boolean']['input']>;
  imageFadeColor?: InputMaybe<Scalars['String']['input']>;
  lastPromotedAt?: InputMaybe<Scalars['Date']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  showAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  spotlightDarkImageId?: InputMaybe<Scalars['String']['input']>;
  spotlightImageId?: InputMaybe<Scalars['String']['input']>;
  spotlightSplashImageUrl?: InputMaybe<Scalars['String']['input']>;
  subtitleUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSpotlightInput = {
  data: UpdateSpotlightDataInput;
  selector: SelectorInput;
};

export type UpdateTagDataInput = {
  adminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  authorOnly?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagModel?: InputMaybe<Scalars['String']['input']>;
  autoTagPrompt?: InputMaybe<Scalars['String']['input']>;
  bannerImageId?: InputMaybe<Scalars['String']['input']>;
  canEditUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  canVoteOnRels?: InputMaybe<Array<TagRelVoteGroup>>;
  core?: InputMaybe<Scalars['Boolean']['input']>;
  coreTagId?: InputMaybe<Scalars['String']['input']>;
  defaultOrder?: InputMaybe<Scalars['Float']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<CreateRevisionDataInput>;
  descriptionTruncationCount?: InputMaybe<Scalars['Float']['input']>;
  forceAllowType3Audio?: InputMaybe<Scalars['Boolean']['input']>;
  introSequenceId?: InputMaybe<Scalars['String']['input']>;
  isPlaceholderPage?: InputMaybe<Scalars['Boolean']['input']>;
  isPostType?: InputMaybe<Scalars['Boolean']['input']>;
  isSubforum?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  moderationGuidelines?: InputMaybe<CreateRevisionDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  noindex?: InputMaybe<Scalars['Boolean']['input']>;
  parentTagId?: InputMaybe<Scalars['String']['input']>;
  postsDefaultSortOrder?: InputMaybe<Scalars['String']['input']>;
  removalResistant?: InputMaybe<Scalars['Boolean']['input']>;
  reviewedByUserId?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  squareImageId?: InputMaybe<Scalars['String']['input']>;
  subTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subforumIntroPostId?: InputMaybe<Scalars['String']['input']>;
  subforumModeratorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subforumWelcomeText?: InputMaybe<CreateRevisionDataInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  suggestedAsFilter?: InputMaybe<Scalars['Boolean']['input']>;
  tagFlagsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  wikiGrade?: InputMaybe<Scalars['Int']['input']>;
  wikiOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTagFlagDataInput = {
  contents?: InputMaybe<CreateRevisionDataInput>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTagFlagInput = {
  data: UpdateTagFlagDataInput;
  selector: SelectorInput;
};

export type UpdateTagInput = {
  data: UpdateTagDataInput;
  selector: SelectorInput;
};

export type UpdateUltraFeedEventDataInput = {
  event?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateUserDataInput = {
  abTestKey?: InputMaybe<Scalars['String']['input']>;
  abTestOverrides?: InputMaybe<Scalars['JSON']['input']>;
  acceptedTos?: InputMaybe<Scalars['Boolean']['input']>;
  acknowledgedNewUserGuidelines?: InputMaybe<Scalars['Boolean']['input']>;
  afApplicationText?: InputMaybe<Scalars['String']['input']>;
  afSubmittedApplication?: InputMaybe<Scalars['Boolean']['input']>;
  allCommentingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  allPostsFilter?: InputMaybe<Scalars['String']['input']>;
  allPostsHideCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  allPostsIncludeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  allPostsOpenSettings?: InputMaybe<Scalars['Boolean']['input']>;
  allPostsShowLowKarma?: InputMaybe<Scalars['Boolean']['input']>;
  allPostsSorting?: InputMaybe<Scalars['String']['input']>;
  allPostsTimeframe?: InputMaybe<Scalars['String']['input']>;
  autoSubscribeAsOrganizer?: InputMaybe<Scalars['Boolean']['input']>;
  auto_subscribe_to_my_comments?: InputMaybe<Scalars['Boolean']['input']>;
  auto_subscribe_to_my_posts?: InputMaybe<Scalars['Boolean']['input']>;
  banned?: InputMaybe<Scalars['Date']['input']>;
  bannedPersonalUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  bannedUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  beta?: InputMaybe<Scalars['Boolean']['input']>;
  biography?: InputMaybe<CreateRevisionDataInput>;
  blueskyProfileURL?: InputMaybe<Scalars['String']['input']>;
  careerStage?: InputMaybe<Array<Scalars['String']['input']>>;
  collapseModerationGuidelines?: InputMaybe<Scalars['Boolean']['input']>;
  commentSorting?: InputMaybe<Scalars['String']['input']>;
  commentingOnOtherUsersDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  conversationsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  criticismTipsDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  currentFrontpageFilter?: InputMaybe<Scalars['String']['input']>;
  defaultToCKEditor?: InputMaybe<Scalars['Boolean']['input']>;
  deleteContent?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  draftsListShowArchived?: InputMaybe<Scalars['Boolean']['input']>;
  draftsListShowShared?: InputMaybe<Scalars['Boolean']['input']>;
  draftsListSorting?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSubscribedToCurated?: InputMaybe<Scalars['Boolean']['input']>;
  expandedFrontpageSections?: InputMaybe<ExpandedFrontpageSectionsSettingsInput>;
  facebookProfileURL?: InputMaybe<Scalars['String']['input']>;
  fmCrosspostUserId?: InputMaybe<Scalars['String']['input']>;
  frontpageFilterSettings?: InputMaybe<Scalars['JSON']['input']>;
  frontpageSelectedTab?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  generateJargonForDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  generateJargonForPublishedPosts?: InputMaybe<Scalars['Boolean']['input']>;
  githubProfileURL?: InputMaybe<Scalars['String']['input']>;
  googleLocation?: InputMaybe<Scalars['JSON']['input']>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  hiddenPostsMetadata?: InputMaybe<Array<PostMetadataInput>>;
  hideAFNonMemberInitialWarning?: InputMaybe<Scalars['Boolean']['input']>;
  hideActiveDialogueUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hideCommunitySection?: InputMaybe<Scalars['Boolean']['input']>;
  hideDialogueFacilitation?: InputMaybe<Scalars['Boolean']['input']>;
  hideElicitPredictions?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromPeopleDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageBook2019Ad?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageBook2020Ad?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageBookAd?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageFilterSettingsDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  hideFrontpageMap?: InputMaybe<Scalars['Boolean']['input']>;
  hideHomeRHS?: InputMaybe<Scalars['Boolean']['input']>;
  hideIntercom?: InputMaybe<Scalars['Boolean']['input']>;
  hideMeetupsPoke?: InputMaybe<Scalars['Boolean']['input']>;
  hideNavigationSidebar?: InputMaybe<Scalars['Boolean']['input']>;
  hidePostsRecommendations?: InputMaybe<Scalars['Boolean']['input']>;
  hideProfileTopPosts?: InputMaybe<Scalars['Boolean']['input']>;
  hideSubscribePoke?: InputMaybe<Scalars['Boolean']['input']>;
  hideSunshineSidebar?: InputMaybe<Scalars['Boolean']['input']>;
  hideTaggingProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  howICanHelpOthers?: InputMaybe<CreateRevisionDataInput>;
  howOthersCanHelpMe?: InputMaybe<CreateRevisionDataInput>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  karmaChangeBatchStart?: InputMaybe<Scalars['Date']['input']>;
  karmaChangeLastOpened?: InputMaybe<Scalars['Date']['input']>;
  karmaChangeNotifierSettings?: InputMaybe<Scalars['JSON']['input']>;
  lastNotificationsCheck?: InputMaybe<Scalars['Date']['input']>;
  lastUsedTimezone?: InputMaybe<Scalars['String']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  legacyId?: InputMaybe<Scalars['String']['input']>;
  linkedinProfileURL?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mapLocation?: InputMaybe<Scalars['JSON']['input']>;
  mapMarkerText?: InputMaybe<Scalars['String']['input']>;
  markDownPostEditor?: InputMaybe<Scalars['Boolean']['input']>;
  moderationGuidelines?: InputMaybe<CreateRevisionDataInput>;
  moderationStyle?: InputMaybe<Scalars['String']['input']>;
  moderatorAssistance?: InputMaybe<Scalars['Boolean']['input']>;
  nearbyEventsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  nearbyEventsNotificationsLocation?: InputMaybe<Scalars['JSON']['input']>;
  nearbyEventsNotificationsRadius?: InputMaybe<Scalars['Float']['input']>;
  nearbyPeopleNotificationThreshold?: InputMaybe<Scalars['Float']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  noCollapseCommentsFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
  noCollapseCommentsPosts?: InputMaybe<Scalars['Boolean']['input']>;
  noExpandUnreadCommentsReview?: InputMaybe<Scalars['Boolean']['input']>;
  noKibitz?: InputMaybe<Scalars['Boolean']['input']>;
  noSingleLineComments?: InputMaybe<Scalars['Boolean']['input']>;
  noindex?: InputMaybe<Scalars['Boolean']['input']>;
  notificationAddedAsCoauthor?: InputMaybe<Scalars['JSON']['input']>;
  notificationAlignmentSubmissionApproved?: InputMaybe<Scalars['JSON']['input']>;
  notificationCommentsOnDraft?: InputMaybe<Scalars['JSON']['input']>;
  notificationCommentsOnSubscribedPost?: InputMaybe<Scalars['JSON']['input']>;
  notificationDebateCommentsOnSubscribedPost?: InputMaybe<Scalars['JSON']['input']>;
  notificationDebateReplies?: InputMaybe<Scalars['JSON']['input']>;
  notificationDialogueMatch?: InputMaybe<Scalars['JSON']['input']>;
  notificationDialogueMessages?: InputMaybe<Scalars['JSON']['input']>;
  notificationEventInRadius?: InputMaybe<Scalars['JSON']['input']>;
  notificationGroupAdministration?: InputMaybe<Scalars['JSON']['input']>;
  notificationKarmaPowersGained?: InputMaybe<Scalars['JSON']['input']>;
  notificationNewDialogueChecks?: InputMaybe<Scalars['JSON']['input']>;
  notificationNewMention?: InputMaybe<Scalars['JSON']['input']>;
  notificationPostsInGroups?: InputMaybe<Scalars['JSON']['input']>;
  notificationPostsNominatedReview?: InputMaybe<Scalars['JSON']['input']>;
  notificationPrivateMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationPublishedDialogueMessages?: InputMaybe<Scalars['JSON']['input']>;
  notificationRSVPs?: InputMaybe<Scalars['JSON']['input']>;
  notificationRepliesToMyComments?: InputMaybe<Scalars['JSON']['input']>;
  notificationRepliesToSubscribedComments?: InputMaybe<Scalars['JSON']['input']>;
  notificationSharedWithMe?: InputMaybe<Scalars['JSON']['input']>;
  notificationShortformContent?: InputMaybe<Scalars['JSON']['input']>;
  notificationSubforumUnread?: InputMaybe<Scalars['JSON']['input']>;
  notificationSubscribedSequencePost?: InputMaybe<Scalars['JSON']['input']>;
  notificationSubscribedTagPost?: InputMaybe<Scalars['JSON']['input']>;
  notificationSubscribedUserComment?: InputMaybe<Scalars['JSON']['input']>;
  notificationSubscribedUserPost?: InputMaybe<Scalars['JSON']['input']>;
  notificationTypoSuggestions?: InputMaybe<Scalars['JSON']['input']>;
  notificationYourTurnMatchForm?: InputMaybe<Scalars['JSON']['input']>;
  nullifyVotes?: InputMaybe<Scalars['Boolean']['input']>;
  optedInToDialogueFacilitation?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  organizerOfGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partiallyReadSequences?: InputMaybe<Array<PartiallyReadSequenceItemInput>>;
  paymentEmail?: InputMaybe<Scalars['String']['input']>;
  paymentInfo?: InputMaybe<Scalars['String']['input']>;
  permanentDeletionRequestedAt?: InputMaybe<Scalars['Date']['input']>;
  petrovLaunchCodeDate?: InputMaybe<Scalars['Date']['input']>;
  petrovOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  petrovPressedButtonDate?: InputMaybe<Scalars['Date']['input']>;
  pinnedPostIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postGlossariesPinned?: InputMaybe<Scalars['Boolean']['input']>;
  postingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  previousDisplayName?: InputMaybe<Scalars['String']['input']>;
  profileImageId?: InputMaybe<Scalars['String']['input']>;
  profileTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  programParticipation?: InputMaybe<Array<Scalars['String']['input']>>;
  reactPaletteStyle?: InputMaybe<ReactPaletteStyle>;
  recommendationSettings?: InputMaybe<RecommendationSettingsInput>;
  revealChecksToAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  reviewForAlignmentForumUserId?: InputMaybe<Scalars['String']['input']>;
  reviewVotesQuadratic?: InputMaybe<Scalars['Boolean']['input']>;
  reviewVotesQuadratic2019?: InputMaybe<Scalars['Boolean']['input']>;
  reviewVotesQuadratic2020?: InputMaybe<Scalars['Boolean']['input']>;
  reviewedAt?: InputMaybe<Scalars['Date']['input']>;
  reviewedByUserId?: InputMaybe<Scalars['String']['input']>;
  shortformFeedId?: InputMaybe<Scalars['String']['input']>;
  showCommunityInRecentDiscussion?: InputMaybe<Scalars['Boolean']['input']>;
  showDialoguesList?: InputMaybe<Scalars['Boolean']['input']>;
  showHideKarmaOption?: InputMaybe<Scalars['Boolean']['input']>;
  showMatches?: InputMaybe<Scalars['Boolean']['input']>;
  showMyDialogues?: InputMaybe<Scalars['Boolean']['input']>;
  showPostAuthorCard?: InputMaybe<Scalars['Boolean']['input']>;
  showRecommendedPartners?: InputMaybe<Scalars['Boolean']['input']>;
  signUpReCaptchaRating?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  snoozedUntilContentCount?: InputMaybe<Scalars['Float']['input']>;
  sortDraftsBy?: InputMaybe<Scalars['String']['input']>;
  subforumPreferredLayout?: InputMaybe<SubforumPreferredLayout>;
  sunshineFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  sunshineNotes?: InputMaybe<Scalars['String']['input']>;
  sunshineSnoozed?: InputMaybe<Scalars['Boolean']['input']>;
  taggingDashboardCollapsed?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['JSON']['input']>;
  twitterProfileURL?: InputMaybe<Scalars['String']['input']>;
  twitterProfileURLAdmin?: InputMaybe<Scalars['String']['input']>;
  ultraFeedSettings?: InputMaybe<Scalars['JSON']['input']>;
  unsubscribeFromAll?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameUnset?: InputMaybe<Scalars['Boolean']['input']>;
  viewUnreviewedComments?: InputMaybe<Scalars['Boolean']['input']>;
  voteBanned?: InputMaybe<Scalars['Boolean']['input']>;
  walledGardenInvite?: InputMaybe<Scalars['Boolean']['input']>;
  walledGardenPortalOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whenConfirmationEmailSent?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateUserInput = {
  data: UpdateUserDataInput;
  selector: SelectorInput;
};

export type UpdateUserMostValuablePostDataInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserMostValuablePostInput = {
  data: UpdateUserMostValuablePostDataInput;
  selector: SelectorInput;
};

export type UpdateUserRateLimitDataInput = {
  actionsPerInterval?: InputMaybe<Scalars['Float']['input']>;
  endedAt?: InputMaybe<Scalars['Date']['input']>;
  intervalLength?: InputMaybe<Scalars['Float']['input']>;
  intervalUnit?: InputMaybe<UserRateLimitIntervalUnit>;
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<UserRateLimitType>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserRateLimitInput = {
  data: UpdateUserRateLimitDataInput;
  selector: SelectorInput;
};

export type UpdateUserTagRelDataInput = {
  legacyData?: InputMaybe<Scalars['JSON']['input']>;
  subforumEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  subforumHideIntroPost?: InputMaybe<Scalars['Boolean']['input']>;
  subforumShowUnreadInSidebar?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserTagRelInput = {
  data: UpdateUserTagRelDataInput;
  selector: SelectorInput;
};

export type UpvotedUser = {
  __typename?: 'UpvotedUser';
  _id: Scalars['ID']['output'];
  agreement_values: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  power_values: Scalars['String']['output'];
  recently_active_matchmaking: Scalars['Boolean']['output'];
  total_agreement: Scalars['Float']['output'];
  total_power: Scalars['Float']['output'];
  username: Scalars['String']['output'];
  vote_counts: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  IPs: Maybe<Array<Scalars['String']['output']>>;
  _id: Scalars['String']['output'];
  abTestKey: Maybe<Scalars['String']['output']>;
  abTestOverrides: Maybe<Scalars['JSON']['output']>;
  acceptedTos: Maybe<Scalars['Boolean']['output']>;
  acknowledgedNewUserGuidelines: Maybe<Scalars['Boolean']['output']>;
  afApplicationText: Maybe<Scalars['String']['output']>;
  afCommentCount: Scalars['Float']['output'];
  afKarma: Scalars['Float']['output'];
  afPostCount: Scalars['Float']['output'];
  afSequenceCount: Scalars['Float']['output'];
  afSequenceDraftCount: Scalars['Float']['output'];
  afSubmittedApplication: Maybe<Scalars['Boolean']['output']>;
  allCommentingDisabled: Maybe<Scalars['Boolean']['output']>;
  allPostsFilter: Maybe<Scalars['String']['output']>;
  allPostsHideCommunity: Maybe<Scalars['Boolean']['output']>;
  allPostsIncludeEvents: Maybe<Scalars['Boolean']['output']>;
  allPostsOpenSettings: Maybe<Scalars['Boolean']['output']>;
  allPostsShowLowKarma: Maybe<Scalars['Boolean']['output']>;
  allPostsSorting: Maybe<Scalars['String']['output']>;
  allPostsTimeframe: Maybe<Scalars['String']['output']>;
  altAccountsDetected: Maybe<Scalars['Boolean']['output']>;
  associatedClientId: Maybe<ClientId>;
  associatedClientIds: Maybe<Array<ClientId>>;
  associatedOAuthServices: Maybe<Array<Scalars['String']['output']>>;
  autoSubscribeAsOrganizer: Scalars['Boolean']['output'];
  auto_subscribe_to_my_comments: Scalars['Boolean']['output'];
  auto_subscribe_to_my_posts: Scalars['Boolean']['output'];
  banned: Maybe<Scalars['Date']['output']>;
  bannedPersonalUserIds: Maybe<Array<Scalars['String']['output']>>;
  bannedUserIds: Maybe<Array<Scalars['String']['output']>>;
  beta: Maybe<Scalars['Boolean']['output']>;
  bigDownvoteCount: Maybe<Scalars['Float']['output']>;
  bigDownvoteReceivedCount: Maybe<Scalars['Float']['output']>;
  bigUpvoteCount: Maybe<Scalars['Float']['output']>;
  bigUpvoteReceivedCount: Maybe<Scalars['Float']['output']>;
  bio: Maybe<Scalars['String']['output']>;
  biography: Maybe<Revision>;
  biography_latest: Maybe<Scalars['String']['output']>;
  blueskyProfileURL: Maybe<Scalars['String']['output']>;
  bookmarkedPosts: Maybe<Array<Post>>;
  bookmarkedPostsMetadata: Maybe<Array<PostMetadataOutput>>;
  bookmarksCount: Maybe<Scalars['Int']['output']>;
  careerStage: Maybe<Array<Scalars['String']['output']>>;
  claudeLinkedAt: Maybe<Scalars['Date']['output']>;
  coauthoredPostCount: Scalars['Float']['output'];
  collapseModerationGuidelines: Maybe<Scalars['Boolean']['output']>;
  commentCount: Scalars['Float']['output'];
  commentSorting: Maybe<Scalars['String']['output']>;
  commentingOnOtherUsersDisabled: Maybe<Scalars['Boolean']['output']>;
  conversationsDisabled: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Date']['output'];
  criticismTipsDismissed: Maybe<Scalars['Boolean']['output']>;
  currentFrontpageFilter: Maybe<Scalars['String']['output']>;
  defaultToCKEditor: Maybe<Scalars['Boolean']['output']>;
  deleteContent: Maybe<Scalars['Boolean']['output']>;
  deleted: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  draftsListShowArchived: Maybe<Scalars['Boolean']['output']>;
  draftsListShowShared: Maybe<Scalars['Boolean']['output']>;
  draftsListSorting: Maybe<Scalars['String']['output']>;
  editUrl: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailSubscribedToCurated: Maybe<Scalars['Boolean']['output']>;
  emails: Maybe<Array<Scalars['JSON']['output']>>;
  expandedFrontpageSections: Maybe<ExpandedFrontpageSectionsSettingsOutput>;
  facebookProfileURL: Maybe<Scalars['String']['output']>;
  fmCrosspostUserId: Maybe<Scalars['String']['output']>;
  frontpageFilterSettings: Maybe<Scalars['JSON']['output']>;
  frontpagePostCount: Scalars['Float']['output'];
  frontpageSelectedTab: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  generateJargonForDrafts: Maybe<Scalars['Boolean']['output']>;
  generateJargonForPublishedPosts: Maybe<Scalars['Boolean']['output']>;
  githubProfileURL: Maybe<Scalars['String']['output']>;
  goodHeartTokens: Maybe<Scalars['Float']['output']>;
  googleLocation: Maybe<Scalars['JSON']['output']>;
  groups: Maybe<Array<Scalars['String']['output']>>;
  hasAnyBookmarks: Maybe<Scalars['Boolean']['output']>;
  hasAuth0Id: Maybe<Scalars['Boolean']['output']>;
  hasClaudeCodeOAuthToken: Maybe<Scalars['Boolean']['output']>;
  hasContinueReading: Maybe<Scalars['Boolean']['output']>;
  hasPendingComments: Maybe<Scalars['Boolean']['output']>;
  hiddenPosts: Maybe<Array<Post>>;
  hiddenPostsMetadata: Maybe<Array<PostMetadataOutput>>;
  hideAFNonMemberInitialWarning: Maybe<Scalars['Boolean']['output']>;
  hideActiveDialogueUsers: Maybe<Scalars['Boolean']['output']>;
  hideCommunitySection: Scalars['Boolean']['output'];
  hideDialogueFacilitation: Maybe<Scalars['Boolean']['output']>;
  hideElicitPredictions: Maybe<Scalars['Boolean']['output']>;
  hideFromPeopleDirectory: Scalars['Boolean']['output'];
  hideFrontpageBook2019Ad: Maybe<Scalars['Boolean']['output']>;
  hideFrontpageBook2020Ad: Maybe<Scalars['Boolean']['output']>;
  hideFrontpageBookAd: Maybe<Scalars['Boolean']['output']>;
  hideFrontpageFilterSettingsDesktop: Maybe<Scalars['Boolean']['output']>;
  hideFrontpageMap: Maybe<Scalars['Boolean']['output']>;
  hideHomeRHS: Maybe<Scalars['Boolean']['output']>;
  hideIntercom: Scalars['Boolean']['output'];
  hideMeetupsPoke: Maybe<Scalars['Boolean']['output']>;
  hideNavigationSidebar: Maybe<Scalars['Boolean']['output']>;
  hidePostsRecommendations: Scalars['Boolean']['output'];
  hideProfileTopPosts: Scalars['Boolean']['output'];
  hideSubscribePoke: Maybe<Scalars['Boolean']['output']>;
  hideSunshineSidebar: Maybe<Scalars['Boolean']['output']>;
  hideTaggingProgressBar: Maybe<Scalars['Boolean']['output']>;
  hideWalledGardenUI: Maybe<Scalars['Boolean']['output']>;
  howICanHelpOthers: Maybe<Revision>;
  howICanHelpOthers_latest: Maybe<Scalars['String']['output']>;
  howOthersCanHelpMe: Maybe<Revision>;
  howOthersCanHelpMe_latest: Maybe<Scalars['String']['output']>;
  htmlBio: Scalars['String']['output'];
  htmlMapMarkerText: Maybe<Scalars['String']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isReviewed: Maybe<Scalars['Boolean']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  karma: Scalars['Float']['output'];
  karmaChangeBatchStart: Maybe<Scalars['Date']['output']>;
  karmaChangeLastOpened: Maybe<Scalars['Date']['output']>;
  karmaChangeNotifierSettings: Maybe<Scalars['JSON']['output']>;
  karmaChanges: Maybe<KarmaChanges>;
  lastNotificationsCheck: Maybe<Scalars['Date']['output']>;
  lastRemovedFromReviewQueueAt: Maybe<Scalars['Date']['output']>;
  lastUsedTimezone: Maybe<Scalars['String']['output']>;
  legacy: Maybe<Scalars['Boolean']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  legacyId: Maybe<Scalars['String']['output']>;
  linkedinProfileURL: Maybe<Scalars['String']['output']>;
  location: Maybe<Scalars['String']['output']>;
  lwWikiImport: Maybe<Scalars['Boolean']['output']>;
  mailgunValidation: Maybe<MailgunValidationResult>;
  mapLocation: Maybe<Scalars['JSON']['output']>;
  mapLocationLatLng: Maybe<LatLng>;
  mapLocationSet: Maybe<Scalars['Boolean']['output']>;
  mapMarkerText: Maybe<Scalars['String']['output']>;
  markDownPostEditor: Scalars['Boolean']['output'];
  maxCommentCount: Scalars['Float']['output'];
  maxPostCount: Scalars['Float']['output'];
  moderationGuidelines: Maybe<Revision>;
  moderationGuidelines_latest: Maybe<Scalars['String']['output']>;
  moderationStyle: Maybe<Scalars['String']['output']>;
  moderatorActions: Maybe<Array<ModeratorAction>>;
  moderatorAssistance: Maybe<Scalars['Boolean']['output']>;
  mongoLocation: Maybe<Scalars['JSON']['output']>;
  nearbyEventsNotifications: Scalars['Boolean']['output'];
  nearbyEventsNotificationsLocation: Maybe<Scalars['JSON']['output']>;
  nearbyEventsNotificationsMongoLocation: Maybe<Scalars['JSON']['output']>;
  nearbyEventsNotificationsRadius: Maybe<Scalars['Float']['output']>;
  nearbyPeopleNotificationThreshold: Maybe<Scalars['Float']['output']>;
  needsReview: Maybe<Scalars['Boolean']['output']>;
  noCollapseCommentsFrontpage: Scalars['Boolean']['output'];
  noCollapseCommentsPosts: Scalars['Boolean']['output'];
  noExpandUnreadCommentsReview: Scalars['Boolean']['output'];
  noKibitz: Maybe<Scalars['Boolean']['output']>;
  noSingleLineComments: Scalars['Boolean']['output'];
  noindex: Scalars['Boolean']['output'];
  notificationAddedAsCoauthor: Maybe<Scalars['JSON']['output']>;
  notificationAlignmentSubmissionApproved: Maybe<Scalars['JSON']['output']>;
  notificationCommentsOnDraft: Maybe<Scalars['JSON']['output']>;
  notificationCommentsOnSubscribedPost: Maybe<Scalars['JSON']['output']>;
  notificationDebateCommentsOnSubscribedPost: Maybe<Scalars['JSON']['output']>;
  notificationDebateReplies: Maybe<Scalars['JSON']['output']>;
  notificationDialogueMatch: Maybe<Scalars['JSON']['output']>;
  notificationDialogueMessages: Maybe<Scalars['JSON']['output']>;
  notificationEventInRadius: Maybe<Scalars['JSON']['output']>;
  notificationGroupAdministration: Maybe<Scalars['JSON']['output']>;
  notificationKarmaPowersGained: Maybe<Scalars['JSON']['output']>;
  notificationNewDialogueChecks: Maybe<Scalars['JSON']['output']>;
  notificationNewMention: Maybe<Scalars['JSON']['output']>;
  notificationPostsInGroups: Maybe<Scalars['JSON']['output']>;
  notificationPostsNominatedReview: Maybe<Scalars['JSON']['output']>;
  notificationPrivateMessage: Maybe<Scalars['JSON']['output']>;
  notificationPublishedDialogueMessages: Maybe<Scalars['JSON']['output']>;
  notificationRSVPs: Maybe<Scalars['JSON']['output']>;
  notificationRepliesToMyComments: Maybe<Scalars['JSON']['output']>;
  notificationRepliesToSubscribedComments: Maybe<Scalars['JSON']['output']>;
  notificationSharedWithMe: Maybe<Scalars['JSON']['output']>;
  notificationShortformContent: Maybe<Scalars['JSON']['output']>;
  notificationSubforumUnread: Maybe<Scalars['JSON']['output']>;
  notificationSubscribedSequencePost: Maybe<Scalars['JSON']['output']>;
  notificationSubscribedTagPost: Maybe<Scalars['JSON']['output']>;
  notificationSubscribedUserComment: Maybe<Scalars['JSON']['output']>;
  notificationSubscribedUserPost: Maybe<Scalars['JSON']['output']>;
  notificationTypoSuggestions: Maybe<Scalars['JSON']['output']>;
  notificationYourTurnMatchForm: Maybe<Scalars['JSON']['output']>;
  nullifyVotes: Maybe<Scalars['Boolean']['output']>;
  oldSlugs: Array<Scalars['String']['output']>;
  optedInToDialogueFacilitation: Maybe<Scalars['Boolean']['output']>;
  organization: Maybe<Scalars['String']['output']>;
  organizerOfGroupIds: Array<Scalars['String']['output']>;
  organizerOfGroups: Array<Localgroup>;
  pagePath: Maybe<Scalars['String']['output']>;
  pageUrl: Maybe<Scalars['String']['output']>;
  partiallyReadSequences: Maybe<Array<PartiallyReadSequenceItemOutput>>;
  paymentEmail: Maybe<Scalars['String']['output']>;
  paymentInfo: Maybe<Scalars['String']['output']>;
  permanentDeletionRequestedAt: Maybe<Scalars['Date']['output']>;
  petrovLaunchCodeDate: Maybe<Scalars['Date']['output']>;
  petrovOptOut: Scalars['Boolean']['output'];
  petrovPressedButtonDate: Maybe<Scalars['Date']['output']>;
  pinnedPostIds: Array<Scalars['String']['output']>;
  postCount: Scalars['Float']['output'];
  postGlossariesPinned: Maybe<Scalars['Boolean']['output']>;
  postingDisabled: Maybe<Scalars['Boolean']['output']>;
  posts: Maybe<Array<Post>>;
  previousDisplayName: Maybe<Scalars['String']['output']>;
  profile: Maybe<Scalars['JSON']['output']>;
  profileImageId: Maybe<Scalars['String']['output']>;
  profileTagIds: Array<Scalars['String']['output']>;
  profileTags: Array<Tag>;
  profileUpdatedAt: Scalars['Date']['output'];
  programParticipation: Maybe<Array<Scalars['String']['output']>>;
  rateLimitNextAbleToComment: Maybe<Scalars['JSON']['output']>;
  rateLimitNextAbleToPost: Maybe<Scalars['JSON']['output']>;
  reactPaletteStyle: Maybe<ReactPaletteStyle>;
  recentKarmaInfo: Maybe<Scalars['JSON']['output']>;
  recommendationSettings: Maybe<Scalars['JSON']['output']>;
  rejectedContentCount: Maybe<Scalars['Int']['output']>;
  revealChecksToAdmins: Maybe<Scalars['Boolean']['output']>;
  reviewForAlignmentForumUserId: Maybe<Scalars['String']['output']>;
  reviewGroup: Maybe<ReviewGroup>;
  reviewVoteCount: Maybe<Scalars['Int']['output']>;
  reviewVotesQuadratic: Maybe<Scalars['Boolean']['output']>;
  reviewVotesQuadratic2019: Maybe<Scalars['Boolean']['output']>;
  reviewVotesQuadratic2020: Maybe<Scalars['Boolean']['output']>;
  reviewedAt: Maybe<Scalars['Date']['output']>;
  reviewedByUser: Maybe<User>;
  reviewedByUserId: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  sequenceCount: Scalars['Float']['output'];
  sequenceDraftCount: Scalars['Float']['output'];
  services: Maybe<Scalars['JSON']['output']>;
  shortformFeed: Maybe<Post>;
  shortformFeedId: Maybe<Scalars['String']['output']>;
  showCommunityInRecentDiscussion: Scalars['Boolean']['output'];
  showDialoguesList: Maybe<Scalars['Boolean']['output']>;
  showHideKarmaOption: Maybe<Scalars['Boolean']['output']>;
  showMatches: Maybe<Scalars['Boolean']['output']>;
  showMyDialogues: Maybe<Scalars['Boolean']['output']>;
  showPostAuthorCard: Maybe<Scalars['Boolean']['output']>;
  showRecommendedPartners: Maybe<Scalars['Boolean']['output']>;
  signUpReCaptchaRating: Maybe<Scalars['Float']['output']>;
  slug: Scalars['String']['output'];
  smallDownvoteCount: Maybe<Scalars['Float']['output']>;
  smallDownvoteReceivedCount: Maybe<Scalars['Float']['output']>;
  smallUpvoteCount: Maybe<Scalars['Float']['output']>;
  smallUpvoteReceivedCount: Maybe<Scalars['Float']['output']>;
  snoozedUntilContentCount: Maybe<Scalars['Float']['output']>;
  sortDraftsBy: Maybe<Scalars['String']['output']>;
  subforumPreferredLayout: Maybe<SubforumPreferredLayout>;
  sunshineFlagged: Maybe<Scalars['Boolean']['output']>;
  sunshineNotes: Maybe<Scalars['String']['output']>;
  sunshineSnoozed: Maybe<Scalars['Boolean']['output']>;
  tagRevisionCount: Scalars['Float']['output'];
  taggingDashboardCollapsed: Maybe<Scalars['Boolean']['output']>;
  theme: Maybe<Scalars['JSON']['output']>;
  twitterProfileURL: Maybe<Scalars['String']['output']>;
  twitterProfileURLAdmin: Maybe<Scalars['String']['output']>;
  ultraFeedSettings: Maybe<Scalars['JSON']['output']>;
  unsubscribeFromAll: Maybe<Scalars['Boolean']['output']>;
  userRateLimits: Maybe<Array<UserRateLimit>>;
  username: Maybe<Scalars['String']['output']>;
  usernameUnset: Maybe<Scalars['Boolean']['output']>;
  usersContactedBeforeReview: Maybe<Array<Scalars['String']['output']>>;
  viewUnreviewedComments: Maybe<Scalars['Boolean']['output']>;
  voteBanned: Maybe<Scalars['Boolean']['output']>;
  voteCount: Maybe<Scalars['Float']['output']>;
  voteReceivedCount: Maybe<Scalars['Float']['output']>;
  votingDisabled: Scalars['Boolean']['output'];
  walledGardenInvite: Maybe<Scalars['Boolean']['output']>;
  walledGardenPortalOnboarded: Maybe<Scalars['Boolean']['output']>;
  website: Maybe<Scalars['String']['output']>;
  whenConfirmationEmailSent: Maybe<Scalars['Date']['output']>;
};


export type UserbiographyArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type UserhowICanHelpOthersArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type UserhowOthersCanHelpMeArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type UserkarmaChangesArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type UsermoderationGuidelinesArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type UserpostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type UserrateLimitNextAbleToCommentArgs = {
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type UserrateLimitNextAbleToPostArgs = {
  eventForm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserActivity = {
  __typename?: 'UserActivity';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
};

export type UserContentFeedEntry = {
  __typename?: 'UserContentFeedEntry';
  profileComment: Maybe<Comment>;
  shortformComment: Maybe<Comment>;
  type: UserContentFeedEntryType;
  userPost: Maybe<Post>;
  wikiEdit: Maybe<Revision>;
};

export type UserContentFeedEntryType =
  | 'profileComment'
  | 'shortformComment'
  | 'userPost'
  | 'wikiEdit';

export type UserContentFeedQueryResults = {
  __typename?: 'UserContentFeedQueryResults';
  cutoff: Maybe<Scalars['Date']['output']>;
  endOffset: Scalars['Int']['output'];
  results: Maybe<Array<UserContentFeedEntry>>;
};

export type UserCoreTagReads = {
  __typename?: 'UserCoreTagReads';
  tagId: Scalars['String']['output'];
  userReadCount: Scalars['Int']['output'];
};

export type UserDialogueUsefulData = {
  __typename?: 'UserDialogueUsefulData';
  activeDialogueMatchSeekers: Maybe<Array<Maybe<User>>>;
  dialogueUsers: Maybe<Array<Maybe<User>>>;
  topUsers: Maybe<Array<Maybe<UpvotedUser>>>;
};

export type UserGroup =
  | 'admins'
  | 'alignmentForum'
  | 'alignmentForumAdmins'
  | 'alignmentVoters'
  | 'canBypassPostRateLimit'
  | 'canModeratePersonal'
  | 'canSuggestCuration'
  | 'debaters'
  | 'guests'
  | 'members'
  | 'podcasters'
  | 'realAdmins'
  | 'sunshineRegiment'
  | 'trustLevel1';

export type UserLikingTag = {
  __typename?: 'UserLikingTag';
  displayName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserMostValuablePost = {
  __typename?: 'UserMostValuablePost';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deleted: Maybe<Scalars['Boolean']['output']>;
  legacyData: Maybe<Scalars['JSON']['output']>;
  post: Maybe<Post>;
  postId: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Float']['output'];
  user: Maybe<User>;
  userId: Maybe<Scalars['String']['output']>;
};

export type UserMostValuablePostOutput = {
  __typename?: 'UserMostValuablePostOutput';
  data: Maybe<UserMostValuablePost>;
};

export type UserMostValuablePostSelector = {
  currentUserMostValuablePosts?: InputMaybe<EmptyViewInput>;
  currentUserPost?: InputMaybe<UserMostValuablePostsCurrentUserPostInput>;
  default?: InputMaybe<EmptyViewInput>;
};

export type UserMostValuablePostsCurrentUserPostInput = {
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type UserOutput = {
  __typename?: 'UserOutput';
  data: Maybe<User>;
};

export type UserRateLimit = {
  __typename?: 'UserRateLimit';
  _id: Scalars['String']['output'];
  actionsPerInterval: Scalars['Float']['output'];
  createdAt: Scalars['Date']['output'];
  endedAt: Scalars['Date']['output'];
  intervalLength: Scalars['Float']['output'];
  intervalUnit: UserRateLimitIntervalUnit;
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  type: UserRateLimitType;
  user: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type UserRateLimitIntervalUnit =
  | 'days'
  | 'hours'
  | 'minutes'
  | 'weeks';

export type UserRateLimitOutput = {
  __typename?: 'UserRateLimitOutput';
  data: Maybe<UserRateLimit>;
};

export type UserRateLimitSelector = {
  activeUserRateLimits?: InputMaybe<EmptyViewInput>;
  default?: InputMaybe<EmptyViewInput>;
  userRateLimits?: InputMaybe<UserRateLimitsUserRateLimitsInput>;
};

export type UserRateLimitType =
  | 'allComments'
  | 'allPosts';

export type UserRateLimitsUserRateLimitsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserReadHistoryResult = {
  __typename?: 'UserReadHistoryResult';
  posts: Maybe<Array<Post>>;
};

export type UserSelector = {
  LWSunshinesList?: InputMaybe<EmptyViewInput>;
  LWTrustLevel1List?: InputMaybe<EmptyViewInput>;
  LWUsersAdmin?: InputMaybe<EmptyViewInput>;
  alignmentSuggestedUsers?: InputMaybe<EmptyViewInput>;
  allUsers?: InputMaybe<EmptyViewInput>;
  default?: InputMaybe<EmptyViewInput>;
  recentlyActive?: InputMaybe<EmptyViewInput>;
  reviewAdminUsers?: InputMaybe<EmptyViewInput>;
  sunshineNewUsers?: InputMaybe<EmptyViewInput>;
  usersByUserIds?: InputMaybe<UsersUsersByUserIdsInput>;
  usersMapLocations?: InputMaybe<EmptyViewInput>;
  usersProfile?: InputMaybe<UsersUsersProfileInput>;
  usersTopKarma?: InputMaybe<EmptyViewInput>;
  usersWithBannedUsers?: InputMaybe<EmptyViewInput>;
  usersWithOptedInToDialogueFacilitation?: InputMaybe<EmptyViewInput>;
  usersWithPaymentInfo?: InputMaybe<EmptyViewInput>;
};

export type UserSelectorUniqueInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UserTagRel = {
  __typename?: 'UserTagRel';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Float']['output'];
  subforumEmailNotifications: Maybe<Scalars['Boolean']['output']>;
  subforumHideIntroPost: Maybe<Scalars['Boolean']['output']>;
  subforumShowUnreadInSidebar: Maybe<Scalars['Boolean']['output']>;
  tag: Maybe<Tag>;
  tagId: Scalars['String']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type UserTagRelOutput = {
  __typename?: 'UserTagRelOutput';
  data: Maybe<UserTagRel>;
};

export type UserTagRelSelector = {
  default?: InputMaybe<EmptyViewInput>;
  single?: InputMaybe<UserTagRelsSingleInput>;
};

export type UserTagRelsSingleInput = {
  tagId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UsersUsersByUserIdsInput = {
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UsersUsersProfileInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type VertexRecommendedPost = {
  __typename?: 'VertexRecommendedPost';
  attributionId: Maybe<Scalars['String']['output']>;
  post: Post;
};

export type Vote = {
  __typename?: 'Vote';
  _id: Scalars['String']['output'];
  afPower: Maybe<Scalars['Float']['output']>;
  authorId: Maybe<Scalars['String']['output']>;
  authorIds: Maybe<Array<Scalars['String']['output']>>;
  cancelled: Scalars['Boolean']['output'];
  collectionName: Scalars['String']['output'];
  comment: Maybe<Comment>;
  createdAt: Scalars['Date']['output'];
  documentId: Scalars['String']['output'];
  documentIsAf: Scalars['Boolean']['output'];
  extendedVoteType: Maybe<Scalars['JSON']['output']>;
  isUnvote: Scalars['Boolean']['output'];
  legacyData: Maybe<Scalars['JSON']['output']>;
  post: Maybe<Post>;
  power: Maybe<Scalars['Float']['output']>;
  schemaVersion: Scalars['Float']['output'];
  silenceNotification: Scalars['Boolean']['output'];
  tagRel: Maybe<TagRel>;
  userId: Maybe<Scalars['String']['output']>;
  voteType: VoteType;
  votedAt: Maybe<Scalars['Date']['output']>;
};

export type VoteResultComment = {
  __typename?: 'VoteResultComment';
  document: Comment;
  showVotingPatternWarning: Scalars['Boolean']['output'];
};

export type VoteResultMessage = {
  __typename?: 'VoteResultMessage';
  document: Message;
  showVotingPatternWarning: Scalars['Boolean']['output'];
};

export type VoteResultMultiDocument = {
  __typename?: 'VoteResultMultiDocument';
  document: MultiDocument;
  showVotingPatternWarning: Scalars['Boolean']['output'];
};

export type VoteResultPost = {
  __typename?: 'VoteResultPost';
  document: Post;
  showVotingPatternWarning: Scalars['Boolean']['output'];
};

export type VoteResultRevision = {
  __typename?: 'VoteResultRevision';
  document: Revision;
  showVotingPatternWarning: Scalars['Boolean']['output'];
};

export type VoteResultTag = {
  __typename?: 'VoteResultTag';
  document: Tag;
  showVotingPatternWarning: Scalars['Boolean']['output'];
};

export type VoteResultTagRel = {
  __typename?: 'VoteResultTagRel';
  document: TagRel;
  showVotingPatternWarning: Scalars['Boolean']['output'];
};

export type VoteSelector = {
  default?: InputMaybe<EmptyViewInput>;
  tagVotes?: InputMaybe<EmptyViewInput>;
  userPostVotes?: InputMaybe<VotesUserPostVotesInput>;
  userVotes?: InputMaybe<VotesUserVotesInput>;
};

export type VoteType =
  | 'bigDownvote'
  | 'bigUpvote'
  | 'neutral'
  | 'smallDownvote'
  | 'smallUpvote';

export type VotesUserPostVotesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionName?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<VoteType>;
};

export type VotesUserVotesInput = {
  collectionNames: Array<Scalars['String']['input']>;
};

export type YjsDocument = {
  __typename?: 'YjsDocument';
  _id: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
};

export type RunPangramOnTextMutationVariables = Exact<{
  text: Scalars['String']['input'];
  model?: InputMaybe<PangramModel>;
}>;


export type RunPangramOnTextMutation = { __typename?: 'Mutation', runPangramOnText: { __typename?: 'PangramTextEvaluationResult', analyzedText: string, pangramApiVersion: string, pangramScore: number, pangramMaxScore: number | null, pangramPrediction: string | null, pangramWindowScores: Array<{ __typename?: 'PangramWindowScore', text: string, score: number, startIndex: number, endIndex: number }> | null } };

export type MarkdownCollectionByDocumentIdQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type MarkdownCollectionByDocumentIdQuery = { __typename?: 'Query', collection: { __typename?: 'SingleCollectionOutput', result: { __typename?: 'Collection', _id: string, slug: string, title: string, firstPageLink: string, contents: { __typename?: 'Revision', agentMarkdown: string | null, plaintextDescription: string } | null, books: Array<{ __typename?: 'Book', _id: string, title: string | null, number: number | null, postIds: Array<string>, sequenceIds: Array<string>, sequences: Array<{ __typename?: 'Sequence', _id: string, title: string }> }> } | null } | null };

export type MarkdownCollectionPostsByDocumentIdQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type MarkdownCollectionPostsByDocumentIdQuery = { __typename?: 'Query', collection: { __typename?: 'SingleCollectionOutput', result: { __typename?: 'Collection', _id: string, books: Array<{ __typename?: 'Book', _id: string, posts: Array<{ __typename?: 'Post', _id: string, slug: string }>, sequences: Array<{ __typename?: 'Sequence', _id: string, chapters: Array<{ __typename?: 'Chapter', _id: string, posts: Array<{ __typename?: 'Post', _id: string, slug: string }> }> }> }> } | null } | null };

export type MarkdownCommunityPageQueryVariables = Exact<{
  defaultLimit?: InputMaybe<Scalars['Int']['input']>;
  nearbyLimit?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  hasCoordinates: Scalars['Boolean']['input'];
}>;


export type MarkdownCommunityPageQuery = { __typename?: 'Query', upcomingInPerson: { __typename?: 'MultiPostOutput', results: Array<{ __typename?: 'Post', _id: string, slug: string, title: string, location: string | null, startTime: string | null, endTime: string | null, onlineEvent: boolean, globalEvent: boolean, user: { __typename?: 'User', slug: string, displayName: string } | null }> } | null, globalEvents: { __typename?: 'MultiPostOutput', results: Array<{ __typename?: 'Post', _id: string, slug: string, title: string, location: string | null, startTime: string | null, endTime: string | null, onlineEvent: boolean, globalEvent: boolean, user: { __typename?: 'User', slug: string, displayName: string } | null }> } | null, nearbyInPerson?: { __typename?: 'MultiPostOutput', results: Array<{ __typename?: 'Post', _id: string, slug: string, title: string, location: string | null, startTime: string | null, endTime: string | null, onlineEvent: boolean, globalEvent: boolean, user: { __typename?: 'User', slug: string, displayName: string } | null }> } | null };

export type MarkdownFrontPageQueryVariables = Exact<{
  recentLimit?: InputMaybe<Scalars['Int']['input']>;
  latestLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarkdownFrontPageQuery = { __typename?: 'Query', currentSpotlight: { __typename?: 'Spotlight', _id: string, customTitle: string | null, customSubtitle: string | null, post: { __typename?: 'Post', _id: string, slug: string, title: string } | null, sequence: { __typename?: 'Sequence', _id: string, title: string } | null, tag: { __typename?: 'Tag', _id: string, name: string, slug: string } | null } | null, curated: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & MarkdownPostsList
    )> } | null, recent: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & MarkdownPostsList
    )> } | null, latest: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & MarkdownPostsList
    )> } | null };

export type PostMarkdownCommentByIdQueryVariables = Exact<{
  commentId: Scalars['String']['input'];
}>;


export type PostMarkdownCommentByIdQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentsMarkdownFragment
    ) | null } | null };

export type PostMarkdownCommentsPostQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type PostMarkdownCommentsPostQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: { __typename?: 'Post', _id: string, slug: string, title: string, commentCount: number } | null } | null };

export type PostMarkdownCommentsTopQueryVariables = Exact<{
  _id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PostMarkdownCommentsTopQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<(
      { __typename?: 'Comment' }
      & CommentsMarkdownFragment
    )> } | null };

export type PostMarkdownCommentsNewQueryVariables = Exact<{
  _id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PostMarkdownCommentsNewQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<(
      { __typename?: 'Comment' }
      & CommentsMarkdownFragment
    )> } | null };

export type PostMarkdownCommentsOldQueryVariables = Exact<{
  _id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PostMarkdownCommentsOldQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<(
      { __typename?: 'Comment' }
      & CommentsMarkdownFragment
    )> } | null };

export type MarkdownLatestPostsQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarkdownLatestPostsQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & MarkdownPostsList
    )> } | null };

export type MarkdownSequenceByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  chapterLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarkdownSequenceByIdQuery = { __typename?: 'Query', sequence: { __typename?: 'SingleSequenceOutput', result: { __typename?: 'Sequence', _id: string, title: string, createdAt: string, postsCount: number, user: { __typename?: 'User', slug: string, displayName: string } | null, contents: { __typename?: 'Revision', agentMarkdown: string | null, plaintextDescription: string } | null } | null } | null, chapters: { __typename?: 'MultiChapterOutput', results: Array<{ __typename?: 'Chapter', _id: string, title: string | null, number: number | null, posts: Array<(
        { __typename?: 'Post' }
        & MarkdownPostsList
      )> }> } | null };

export type MarkdownTagBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type MarkdownTagBySlugQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<{ __typename?: 'Tag', _id: string, name: string, slug: string, subtitle: string | null, wikiOnly: boolean, parentTag: { __typename?: 'Tag', _id: string, name: string, slug: string } | null, subTags: Array<{ __typename?: 'Tag', _id: string, name: string, slug: string }>, description: { __typename?: 'Revision', _id: string, agentMarkdown: string | null } | null }> } | null };

export type MarkdownTagPostsQueryVariables = Exact<{
  tagId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarkdownTagPostsQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & MarkdownPostsList
    )> } | null };

export type MarkdownUserProfileQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type MarkdownUserProfileQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', results: Array<{ __typename?: 'User', _id: string, slug: string, displayName: string, username: string | null, bio: string | null, karma: number, afKarma: number, postCount: number, commentCount: number, createdAt: string }> } | null };

export type MarkdownUserProfilePostsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  postsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarkdownUserProfilePostsQuery = { __typename?: 'Query', topPosts: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & MarkdownPostsList
    )> } | null, recentPosts: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & MarkdownPostsList
    )> } | null };

export type MarkdownUserProfileRecentCommentsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  commentsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarkdownUserProfileRecentCommentsQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<{ __typename?: 'Comment', _id: string, postedAt: string, baseScore: number | null, voteCount: number, parentCommentId: string | null, user: { __typename?: 'User', slug: string, displayName: string } | null, post: { __typename?: 'Post', _id: string, slug: string, title: string } | null, contents: { __typename?: 'Revision', agentMarkdown: string | null, plaintextMainText: string } | null }> } | null };

export type HocuspocusAuthQueryServerQueryVariables = Exact<{
  collectionName?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  linkSharingKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type HocuspocusAuthQueryServerQuery = { __typename?: 'Query', HocuspocusAuth: { __typename?: 'HocuspocusAuth', token: string } | null };

export type McpPostMetadataQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type McpPostMetadataQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: { __typename?: 'Post', _id: string, title: string, draft: boolean | null } | null } | null };

export type LocalgroupMetadataQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LocalgroupMetadataQuery = { __typename?: 'Query', localgroup: { __typename?: 'SingleLocalgroupOutput', result: { __typename?: 'Localgroup', _id: string, name: string, bannerImageId: string | null, contents: { __typename?: 'Revision', plaintextDescription: string } | null } | null } | null };

export type multiModeratorCommentsQueryQueryVariables = Exact<{
  commentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type multiModeratorCommentsQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<(
      { __typename?: 'Comment' }
      & ShortformComments
    )> } | null };

export type ProfilePostDiamondDataQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ProfilePostDiamondDataQueryQuery = { __typename?: 'Query', ProfileDiamondPosts: { __typename?: 'ProfileDiamondPostsResult', totalCount: number | null, results: Array<{ __typename?: 'ProfilePostDiamond', _id: string, slug: string, date: string, karma: number, isReviewWinner: boolean, isCurated: boolean }> } };

export type ProfileCommentDiamondDataQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ProfileCommentDiamondDataQueryQuery = { __typename?: 'Query', ProfileDiamondComments: { __typename?: 'ProfileDiamondCommentsResult', totalCount: number | null, results: Array<{ __typename?: 'ProfileCommentDiamond', id: string, date: string, karma: number, postId: string }> } };

export type ProfileUserQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfileUserQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & UsersProfile
    )> } | null };

export type ProfilePostsQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfilePostsQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & UserProfilePost
    )> } | null };

export type UserProfilePost = (
  { __typename?: 'Post', baseScore: number, postedAt: string, hideAuthor: boolean, user: { __typename?: 'User', _id: string, displayName: string } | null, coauthors: Array<{ __typename?: 'User', _id: string, displayName: string }> | null, contents: { __typename?: 'Revision', plaintextDescription: string } | null }
  & PostsMinimumInfo
);

export type ProfilePageCommentsQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfilePageCommentsQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type ProfilePageQuickTakesTabQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfilePageQuickTakesTabQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & FrontpageShortformComments
    )> } | null };

export type ProfileSequencesQueryQueryVariables = Exact<{
  selector?: InputMaybe<SequenceSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfileSequencesQueryQuery = { __typename?: 'Query', sequences: { __typename?: 'MultiSequenceOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Sequence' }
      & SequenceContinueReadingFragment
    )> } | null };

export type ProfilePageWikiEditsQueryQueryVariables = Exact<{
  selector?: InputMaybe<RevisionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfilePageWikiEditsQueryQuery = { __typename?: 'Query', revisions: { __typename?: 'MultiRevisionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Revision' }
      & RevisionTagFragment
    )> } | null };

export type ProfileTopPostsQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfileTopPostsQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & ProfileTopPost
    )> } | null };

export type ProfileTopPost = (
  { __typename?: 'Post', baseScore: number, postedAt: string, socialPreviewData: { __typename?: 'SocialPreviewType', imageUrl: string }, contents: { __typename?: 'Revision', plaintextDescription: string } | null }
  & PostsMinimumInfo
);

export type AdminMetadataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminMetadataQueryQuery = { __typename?: 'Query', AdminMetadata: string | null };

export type SearchSynonymsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchSynonymsQuery = { __typename?: 'Query', SearchSynonyms: Array<string> };

export type UpdateSearchSynonymsMutationVariables = Exact<{
  synonyms: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateSearchSynonymsMutation = { __typename?: 'Mutation', UpdateSearchSynonyms: Array<string> };

export type updateCurationNoticeCurationNoticesFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCurationNoticeDataInput;
}>;


export type updateCurationNoticeCurationNoticesFormMutation = { __typename?: 'Mutation', updateCurationNotice: { __typename?: 'CurationNoticeOutput', data: (
      { __typename?: 'CurationNotice' }
      & CurationNoticesFragment
    ) | null } | null };

export type createCurationNoticeCurationNoticesFormMutationVariables = Exact<{
  data: CreateCurationNoticeDataInput;
}>;


export type createCurationNoticeCurationNoticesFormMutation = { __typename?: 'Mutation', createCurationNotice: { __typename?: 'CurationNoticeOutput', data: (
      { __typename?: 'CurationNotice' }
      & CurationNoticesFragment
    ) | null } | null };

export type updatePostCurationNoticesItem1MutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostCurationNoticesItem1Mutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type updateCurationNoticeCurationNoticesItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCurationNoticeDataInput;
}>;


export type updateCurationNoticeCurationNoticesItemMutation = { __typename?: 'Mutation', updateCurationNotice: { __typename?: 'CurationNoticeOutput', data: (
      { __typename?: 'CurationNotice' }
      & CurationNoticesFragment
    ) | null } | null };

export type createCommentCurationNoticesItemMutationVariables = Exact<{
  data: CreateCommentDataInput;
}>;


export type createCommentCurationNoticesItemMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type multiCurationNoticeCurationPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<CurationNoticeSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCurationNoticeCurationPageQueryQuery = { __typename?: 'Query', curationNotices: { __typename?: 'MultiCurationNoticeOutput', totalCount: number | null, results: Array<(
      { __typename?: 'CurationNotice' }
      & CurationNoticesFragment
    )> } | null };

export type AdminEmailPreviewAudienceQueryVariables = Exact<{
  input: AdminEmailPreviewAudienceInput;
}>;


export type AdminEmailPreviewAudienceQuery = { __typename?: 'Query', adminEmailPreviewAudience: { __typename?: 'AdminEmailAudiencePreview', totalCount: number, sample: Array<{ __typename?: 'AdminEmailAudienceRow', userId: string, email: string }> } };

export type AdminSendTestEmailMutationVariables = Exact<{
  input: AdminSendTestEmailInput;
}>;


export type AdminSendTestEmailMutation = { __typename?: 'Mutation', adminSendTestEmail: { __typename?: 'AdminSendTestEmailResult', ok: boolean, status: number | null, email: string, unsubscribeUrl: string } };

export type AdminSendBulkEmailMutationVariables = Exact<{
  input: AdminSendBulkEmailInput;
}>;


export type AdminSendBulkEmailMutation = { __typename?: 'Mutation', adminSendBulkEmail: { __typename?: 'AdminSendBulkEmailResult', ok: boolean, runId: string, processed: number, batches: number, lastAfterUserId: string | null, errors: Array<{ __typename?: 'AdminSendBulkEmailError', batch: number, status: number | null }> } };

export type randomUserQueryVariables = Exact<{
  userIsAuthor: Scalars['String']['input'];
}>;


export type randomUserQuery = { __typename?: 'Query', GetRandomUser: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null };

export type AdminHomePageDesignsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminHomePageDesignsQuery = { __typename?: 'Query', adminHomePageDesigns: Array<{ __typename?: 'AdminHomePageDesign', _id: string, publicId: string, title: string, html: string, verified: boolean, autoReviewPassed: boolean | null, autoReviewMessage: string | null, createdAt: string, source: string, modelName: string | null, commentId: string | null, ownerDisplayName: string, ownerSlug: string }> };

export type SetHomePageDesignVerifiedMutationVariables = Exact<{
  designId: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  autoReviewPassed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetHomePageDesignVerifiedMutation = { __typename?: 'Mutation', setHomePageDesignVerified: { __typename?: 'HomePageDesign', _id: string, verified: boolean, autoReviewPassed: boolean | null, autoReviewMessage: string | null } | null };

export type UpdateCommentDeletedMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type UpdateCommentDeletedMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: { __typename?: 'Comment', _id: string, deleted: boolean } | null } | null };

export type MigrationsDashboardQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MigrationsDashboardQueryQuery = { __typename?: 'Query', MigrationsDashboard: { __typename?: 'MigrationsDashboardData', migrations: Array<{ __typename?: 'MigrationStatus', name: string, dateWritten: string | null, lastRun: string | null, runs: Array<{ __typename?: 'MigrationRun', name: string, started: string, finished: string | null, succeeded: boolean | null }> | null }> | null } | null };

export type multiCommentAFUnreviewedCommentCountQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentAFUnreviewedCommentCountQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & SuggestAlignmentComment
    )> } | null };

export type alignmentPostMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  af?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type alignmentPostMutation = { __typename?: 'Mutation', alignmentPost: (
    { __typename?: 'Post' }
    & PostsList
  ) | null };

export type multiUserAuthorAnalyticsPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserAuthorAnalyticsPageQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & UsersMinimumInfo
    )> } | null };

export type PostsAnalyticsPageQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsAnalyticsPageQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsPage
    ) | null } | null };

export type multiBookmarkBookmarksFeedQueryQueryVariables = Exact<{
  selector?: InputMaybe<BookmarkSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiBookmarkBookmarksFeedQueryQuery = { __typename?: 'Query', bookmarks: { __typename?: 'MultiBookmarkOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Bookmark' }
      & BookmarksFeedItemFragment
    )> } | null };

export type multiBookmarkBookmarksListQueryQueryVariables = Exact<{
  selector?: InputMaybe<BookmarkSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiBookmarkBookmarksListQueryQuery = { __typename?: 'Query', bookmarks: { __typename?: 'MultiBookmarkOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Bookmark' }
      & BookmarksWithDocumentFragment
    )> } | null };

export type getReadHistoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PostReviewFilter>;
  sort?: InputMaybe<PostReviewSort>;
}>;


export type getReadHistoryQuery = { __typename?: 'Query', UserReadHistory: { __typename?: 'UserReadHistoryResult', posts: Array<(
      { __typename?: 'Post', lastVisitedAt: string | null }
      & PostsListWithVotes
    )> | null } | null };

export type multiVoteVoteHistoryTabQueryQueryVariables = Exact<{
  selector?: InputMaybe<VoteSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiVoteVoteHistoryTabQueryQuery = { __typename?: 'Query', votes: { __typename?: 'MultiVoteOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Vote' }
      & UserVotesWithDocument
    )> } | null };

export type updateUserBook2020FrontpageWidgetMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserBook2020FrontpageWidgetMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersCurrent
    ) | null } | null };

export type updateUserBookFrontpageWidgetMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserBookFrontpageWidgetMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersCurrent
    ) | null } | null };

export type CommentEmbeddingsSearchQueryQueryVariables = Exact<{
  query: Scalars['String']['input'];
  scoreBias?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CommentEmbeddingsSearchQueryQuery = { __typename?: 'Query', CommentEmbeddingSearch: Array<(
    { __typename?: 'Comment' }
    & CommentsListWithParentMetadata
  )> };

export type CommentEmbeddingsSimilaritySearchQueryQueryVariables = Exact<{
  commentId: Scalars['String']['input'];
  scoreBias?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CommentEmbeddingsSimilaritySearchQueryQuery = { __typename?: 'Query', CommentEmbeddingSimilaritySearch: Array<(
    { __typename?: 'Comment' }
    & CommentsListWithParentMetadata
  )> };

export type CommentByIdQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentByIdQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type updateCommentCommentFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentCommentFormMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type createCommentCommentFormMutationVariables = Exact<{
  data: CreateCommentDataInput;
}>;


export type createCommentCommentFormMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type CommentPermalinkQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentPermalinkQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentWithRepliesFragment
    ) | null } | null };

export type LinkedDraftCommentQueryQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type LinkedDraftCommentQueryQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & DraftComments
    ) | null } | null };

export type CommentEditQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentEditQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentEdit
    ) | null } | null };

export type CommentDeletedMetadataQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentDeletedMetadataQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & DeletedCommentsMetaData
    ) | null } | null };

export type CommentsNewFormQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentsNewFormQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersCurrentCommentRateLimit
    ) | null } | null };

export type multiLWEventLastVisitListQueryQueryVariables = Exact<{
  selector?: InputMaybe<LWEventSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiLWEventLastVisitListQueryQuery = { __typename?: 'Query', lWEvents: { __typename?: 'MultiLWEventOutput', totalCount: number | null, results: Array<(
      { __typename?: 'LWEvent' }
      & lastEventFragment
    )> } | null };

export type PostsModerationGuidelinesQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsModerationGuidelinesQuery = { __typename?: 'Query', PostsModerationGuidelines: { __typename: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsModerationGuidelines
    ) | null } | null };

export type TagModerationGuidelinesQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagModerationGuidelinesQuery = { __typename?: 'Query', TagModerationGuidelines: { __typename: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagFragment
    ) | null } | null };

export type updatePostModerationGuidelinesEditFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostModerationGuidelinesEditFormMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsPage
    ) | null } | null };

export type updateTagModerationGuidelinesEditFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateTagDataInput;
}>;


export type updateTagModerationGuidelinesEditFormMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'TagOutput', data: (
      { __typename?: 'Tag' }
      & TagWithFlagsFragment
    ) | null } | null };

export type PostsEditQueryQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsEditQueryQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsEditQueryFragment
    ) | null } | null };

export type TagEditQueryQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type TagEditQueryQuery = { __typename?: 'Query', tag: { __typename?: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagEditFragment
    ) | null } | null };

export type multiCommentModeratorCommentsQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentModeratorCommentsQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type NewUserGuidelinesDialogQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewUserGuidelinesDialogQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type ParentCommentSingleQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ParentCommentSingleQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    ) | null } | null };

export type PopularCommentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PopularCommentsQuery = { __typename?: 'Query', PopularComments: { __typename?: 'PopularCommentsResult', results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type SideCommentSingleQueryVariables = Exact<{
  commentId: Scalars['String']['input'];
}>;


export type SideCommentSingleQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentWithRepliesFragment
    ) | null } | null };

export type multiCommentUserCommentsRepliesQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentUserCommentsRepliesQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type multiUserUserCommentsRepliesQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserUserCommentsRepliesQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & UsersProfile
    )> } | null };

export type DraftCommentsQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DraftCommentsQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & DraftComments
    )> } | null };

export type multiCommentRecentCommentsQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentRecentCommentsQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type multiCommentuseCommentQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentuseCommentQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsList
    )> } | null };

export type multiCommentCommentsListCondensedQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentCommentsListCondensedQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & ShortformComments
    )> } | null };

export type MyHomePageDesignSummariesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyHomePageDesignSummariesQuery = { __typename?: 'Query', myHomePageDesignSummaries: Array<{ __typename?: 'HomePageDesignSummary', publicId: string, title: string, createdAt: string }> };

export type HomePageDesignByPublicIdFullQueryVariables = Exact<{
  publicId: Scalars['String']['input'];
}>;


export type HomePageDesignByPublicIdFullQuery = { __typename?: 'Query', homePageDesignByPublicId: { __typename?: 'HomePageDesign', _id: string, publicId: string, html: string, title: string, source: string, conversationHistory: any | null } | null };

export type MarketplaceHomePageDesignsQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplaceHomePageDesignsQuery = { __typename?: 'Query', marketplaceHomePageDesigns: Array<{ __typename?: 'MarketplaceHomePageDesign', publicId: string, title: string, html: string, verified: boolean, commentId: string | null, commentBaseScore: number }> };

export type PublishHomePageDesignMutationVariables = Exact<{
  input: PublishHomePageDesignInput;
}>;


export type PublishHomePageDesignMutation = { __typename?: 'Mutation', publishHomePageDesign: { __typename?: 'HomePageDesignMutationOutput', data: { __typename?: 'HomePageDesign', _id: string, publicId: string, commentId: string | null } | null } | null };

export type HomePageDesignByPublicIdQueryVariables = Exact<{
  publicId: Scalars['String']['input'];
}>;


export type HomePageDesignByPublicIdQuery = { __typename?: 'Query', homePageDesignByPublicId: { __typename?: 'HomePageDesign', _id: string, publicId: string, html: string, title: string } | null };

export type MyHomePageDesignsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyHomePageDesignsQuery = { __typename?: 'Query', myHomePageDesigns: Array<{ __typename?: 'HomePageDesign', _id: string, publicId: string, html: string, title: string }> };

export type HomeDesignKarmaChangesQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomeDesignKarmaChangesQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: { __typename?: 'User', _id: string, karmaChanges: { __typename?: 'KarmaChanges', totalChange: number, updateFrequency: string, startDate: string | null, endDate: string | null, nextBatchDate: string | null, posts: Array<{ __typename?: 'PostKarmaChange', _id: string, scoreChange: number, postId: string, title: string | null, slug: string, collectionName: string }>, comments: Array<{ __typename?: 'CommentKarmaChange', _id: string, scoreChange: number, commentId: string | null, description: string | null, postId: string | null, postTitle: string | null, postSlug: string | null, tagSlug: string | null, tagName: string | null, tagCommentType: TagCommentType | null, collectionName: string }>, tagRevisions: Array<{ __typename?: 'RevisionsKarmaChange', _id: string, scoreChange: number, tagId: string | null, tagSlug: string | null, tagName: string | null, collectionName: string }> } | null } | null } | null };

export type HomeDesignReadStatusesQueryVariables = Exact<{
  postIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type HomeDesignReadStatusesQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<{ __typename?: 'Post', _id: string, isRead: boolean | null }> } | null };

export type HomeDesignPostVoteStatusesQueryVariables = Exact<{
  postIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type HomeDesignPostVoteStatusesQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<{ __typename?: 'Post', _id: string, currentUserVote: string | null }> } | null };

export type HomeDesignCommentVoteStatusesQueryVariables = Exact<{
  commentIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type HomeDesignCommentVoteStatusesQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<{ __typename?: 'Comment', _id: string, currentUserVote: string | null }> } | null };

export type HomeDesignPerformVotePostMutationVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomeDesignPerformVotePostMutation = { __typename?: 'Mutation', performVotePost: { __typename?: 'VoteResultPost', showVotingPatternWarning: boolean, document: (
      { __typename?: 'Post' }
      & WithVotePost
    ) } | null };

export type HomeDesignPerformVoteCommentMutationVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomeDesignPerformVoteCommentMutation = { __typename?: 'Mutation', performVoteComment: { __typename?: 'VoteResultComment', showVotingPatternWarning: boolean, document: (
      { __typename?: 'Comment' }
      & WithVoteComment
    ) } | null };

export type PostExcerptQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostExcerptQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & HighlightWithHash
    ) | null } | null };

export type AllTagsActivityFeedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllTagsActivityFeedQuery = { __typename?: 'Query', AllTagsActivityFeed: { __typename: 'AllTagsActivityFeedQueryResults', cutoff: string | null, endOffset: number, results: Array<{ __typename?: 'AllTagsActivityFeedEntry', type: AllTagsActivityFeedEntryType, tagCreated: (
        { __typename?: 'Tag' }
        & TagCreationHistoryFragment
      ) | null, tagRevision: (
        { __typename?: 'Revision' }
        & RevisionTagFragment
      ) | null, tagDiscussionComment: (
        { __typename?: 'Comment' }
        & CommentsListWithParentMetadata
      ) | null }> | null } };

export type TagHistoryFeedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tagId: Scalars['String']['input'];
  options?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type TagHistoryFeedQuery = { __typename?: 'Query', TagHistoryFeed: { __typename: 'TagHistoryFeedQueryResults', cutoff: string | null, endOffset: number, results: Array<{ __typename?: 'TagHistoryFeedEntry', type: TagHistoryFeedEntryType, tagCreated: (
        { __typename?: 'Tag' }
        & TagHistoryFragment
      ) | null, tagRevision: (
        { __typename?: 'Revision' }
        & RevisionHistoryEntry
      ) | null, lensRevision: (
        { __typename?: 'Revision' }
        & RevisionHistoryEntry
      ) | null, summaryRevision: (
        { __typename?: 'Revision' }
        & RevisionHistorySummaryEdit
      ) | null, tagApplied: (
        { __typename?: 'TagRel' }
        & TagRelHistoryFragment
      ) | null, tagDiscussionComment: (
        { __typename?: 'Comment' }
        & CommentsList
      ) | null, wikiMetadataChanged: (
        { __typename?: 'FieldChange' }
        & FieldChangeFragment
      ) | null, lensOrSummaryMetadataChanged: (
        { __typename?: 'FieldChange' }
        & FieldChangeFragment
      ) | null }> | null } };

export type RecentDiscussionFeedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  af?: InputMaybe<Scalars['Boolean']['input']>;
  commentsLimit?: InputMaybe<Scalars['Int']['input']>;
  maxAgeHours?: InputMaybe<Scalars['Int']['input']>;
  tagCommentsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentDiscussionFeedQuery = { __typename?: 'Query', RecentDiscussionFeed: { __typename: 'RecentDiscussionFeedQueryResults', cutoff: string | null, endOffset: number, results: Array<{ __typename?: 'RecentDiscussionFeedEntry', type: RecentDiscussionFeedEntryType, postCommented: (
        { __typename?: 'Post' }
        & PostsRecentDiscussion
      ) | null, shortformCommented: (
        { __typename?: 'Post' }
        & ShortformRecentDiscussion
      ) | null, tagDiscussed: (
        { __typename?: 'Tag' }
        & TagRecentDiscussion
      ) | null, tagRevised: (
        { __typename?: 'Revision' }
        & RecentDiscussionRevisionTagFragment
      ) | null }> | null } };

export type UltraFeedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UltraFeedQuery = { __typename?: 'Query', UltraFeed: { __typename: 'UltraFeedQueryResults', cutoff: string | null, endOffset: number, results: Array<{ __typename?: 'UltraFeedEntry', type: UltraFeedEntryType, feedCommentThread: (
        { __typename?: 'FeedCommentThread' }
        & FeedCommentThreadFragment
      ) | null, feedPost: (
        { __typename?: 'FeedPost' }
        & FeedPostFragment
      ) | null, feedSpotlight: (
        { __typename?: 'FeedSpotlightItem' }
        & FeedSpotlightFragment
      ) | null, feedSubscriptionSuggestions: (
        { __typename?: 'FeedSubscriptionSuggestions' }
        & FeedSubscriptionSuggestionsFragment
      ) | null, feedMarker: (
        { __typename?: 'FeedMarker' }
        & FeedMarkerFragment
      ) | null }> | null } };

export type UltraFeedSubscriptionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UltraFeedSubscriptionsQuery = { __typename?: 'Query', UltraFeedSubscriptions: { __typename: 'UltraFeedQueryResults', cutoff: string | null, endOffset: number, results: Array<{ __typename?: 'UltraFeedEntry', type: UltraFeedEntryType, feedCommentThread: (
        { __typename?: 'FeedCommentThread' }
        & FeedCommentThreadFragment
      ) | null, feedPost: (
        { __typename?: 'FeedPost' }
        & FeedPostFragment
      ) | null, feedSubscriptionSuggestions: (
        { __typename?: 'FeedSubscriptionSuggestions' }
        & FeedSubscriptionSuggestionsFragment
      ) | null, feedMarker: (
        { __typename?: 'FeedMarker' }
        & FeedMarkerFragment
      ) | null }> | null } };

export type UserContentFeedQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cutoff?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserContentFeedQuery = { __typename?: 'Query', UserContentFeed: { __typename: 'UserContentFeedQueryResults', cutoff: string | null, endOffset: number, results: Array<{ __typename?: 'UserContentFeedEntry', type: UserContentFeedEntryType, userPost: (
        { __typename?: 'Post' }
        & PostsListWithVotes
      ) | null, profileComment: (
        { __typename?: 'Comment', post: (
          { __typename?: 'Post' }
          & PostsListWithVotes
        ) | null }
        & CommentsList
      ) | null, shortformComment: (
        { __typename?: 'Comment', post: (
          { __typename?: 'Post' }
          & PostsListWithVotes
        ) | null }
        & CommentsList
      ) | null, wikiEdit: (
        { __typename?: 'Revision' }
        & RevisionTagFragment
      ) | null }> | null } };

export type ElicitBlockDataQueryVariables = Exact<{
  questionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ElicitBlockDataQuery = { __typename?: 'Query', ElicitBlockData: { __typename?: 'ElicitBlockData', _id: string | null, title: string | null, notes: string | null, resolvesBy: string | null, resolution: boolean | null, predictions: Array<{ __typename?: 'ElicitPrediction', _id: string | null, predictionId: string | null, prediction: number | null, createdAt: string | null, notes: string | null, sourceUrl: string | null, sourceId: string | null, binaryQuestionId: string | null, creator: { __typename?: 'ElicitUser', _id: string | null, displayName: string | null, sourceUserId: string | null, lwUser: (
          { __typename?: 'User' }
          & UsersMinimumInfo
        ) | null } | null }> | null } | null };

export type ElicitPredictionMutationVariables = Exact<{
  questionId?: InputMaybe<Scalars['String']['input']>;
  prediction?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ElicitPredictionMutation = { __typename?: 'Mutation', MakeElicitPrediction: { __typename?: 'ElicitBlockData', _id: string | null, title: string | null, notes: string | null, resolvesBy: string | null, resolution: boolean | null, predictions: Array<{ __typename?: 'ElicitPrediction', _id: string | null, predictionId: string | null, prediction: number | null, createdAt: string | null, notes: string | null, sourceUrl: string | null, sourceId: string | null, binaryQuestionId: string | null, creator: { __typename?: 'ElicitUser', _id: string | null, displayName: string | null, sourceUserId: string | null, lwUser: (
          { __typename?: 'User' }
          & UsersMinimumInfo
        ) | null } | null }> | null } | null };

export type IframeWidgetSrcdocQueryQueryVariables = Exact<{
  widgetId: Scalars['String']['input'];
}>;


export type IframeWidgetSrcdocQueryQuery = { __typename?: 'Query', iframeWidgetSrcdoc: { __typename?: 'SingleIframeWidgetSrcdocOutput', result: { __typename?: 'IframeWidgetSrcdoc', _id: string, html: string } | null } | null };

export type RecentlyActiveDialoguesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentlyActiveDialoguesQuery = { __typename?: 'Query', RecentlyActiveDialogues: { __typename?: 'RecentlyActiveDialoguesResult', results: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> } | null };

export type MyDialoguesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyDialoguesQuery = { __typename?: 'Query', MyDialogues: { __typename?: 'MyDialoguesResult', results: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> } | null };

export type DialoguesPageQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DialoguesPageQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsListWithVotes
    ) | null } | null };

export type updatePostBanUserFromPostDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostBanUserFromPostDropdownItemMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsPage
    ) | null } | null };

export type CommentActionsQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentActionsQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsDetails
    ) | null } | null };

export type lockThreadMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
  until?: InputMaybe<Scalars['String']['input']>;
}>;


export type lockThreadMutation = { __typename?: 'Mutation', lockThread: boolean };

export type unlockThreadMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
}>;


export type unlockThreadMutation = { __typename?: 'Mutation', unlockThread: boolean };

export type updateCommentMoveToAlignmentCommentDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentMoveToAlignmentCommentDropdownItemMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type updateCommentMoveToAnswersDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentMoveToAnswersDropdownItemMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type updateCommentPinToProfileDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentPinToProfileDropdownItemMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type updateCommentRetractCommentDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentRetractCommentDropdownItemMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type updateCommentShortformFrontpageDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentShortformFrontpageDropdownItemMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type updateCommentSuggestAlignmentCommentDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentSuggestAlignmentCommentDropdownItemMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & SuggestAlignmentComment
    ) | null } | null };

export type updateCommentToggleIsModeratorCommentDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentToggleIsModeratorCommentDropdownItemMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type moderateCommentMutationVariables = Exact<{
  commentId?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedReason?: InputMaybe<Scalars['String']['input']>;
  deletedPublic?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type moderateCommentMutation = { __typename?: 'Mutation', moderateComment: (
    { __typename?: 'Comment' }
    & CommentsList
  ) | null };

export type updateUserApproveNewUserDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserApproveNewUserDropdownItemMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersCurrent
    ) | null } | null };

export type updatePostDeleteDraftDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostDeleteDraftDropdownItemMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type updatePostExcludeFromRecommendationsDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostExcludeFromRecommendationsDropdownItemMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type PostLLMScoreQueryQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type PostLLMScoreQueryQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: { __typename?: 'Post', _id: string, contents: { __typename?: 'Revision', _id: string, html: string | null } | null, automatedContentEvaluations: (
        { __typename?: 'AutomatedContentEvaluation' }
        & AutomatedContentEvaluationsFragment
      ) | null } | null } | null };

export type llmPolicyViolationTemplateQueryQueryVariables = Exact<{
  selector?: InputMaybe<SelectorInput>;
}>;


export type llmPolicyViolationTemplateQueryQuery = { __typename?: 'Query', moderationTemplate: { __typename?: 'SingleModerationTemplateOutput', result: (
      { __typename?: 'ModerationTemplate' }
      & ModerationTemplateFragment
    ) | null } | null };

export type unlistLlmPostMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  modCommentHtml: Scalars['String']['input'];
}>;


export type unlistLlmPostMutation = { __typename?: 'Mutation', unlistLlmPost: boolean };

export type unapproveUserLlmPolicyViolationMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type unapproveUserLlmPolicyViolationMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null };

export type markAsReadOrUnreadMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type markAsReadOrUnreadMutation = { __typename?: 'Mutation', markAsReadOrUnread: boolean | null };

export type updatePostMoveToDraftDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostMoveToDraftDropdownItemMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type updatePostMoveToFrontpageDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostMoveToFrontpageDropdownItemMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type updatePostResyncRssDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostResyncRssDropdownItemMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsEdit
    ) | null } | null };

export type getRssPostChangesQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type getRssPostChangesQuery = { __typename?: 'Query', RssPostChanges: { __typename?: 'RssPostChangeInfo', isChanged: boolean, newHtml: string, htmlDiff: string } };

export type updateUserShortformDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserShortformDropdownItemMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersCurrent
    ) | null } | null };

export type updatePostSuggestAlignmentPostDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostSuggestAlignmentPostDropdownItemMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type updatePostSuggestCuratedDropdownItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostSuggestCuratedDropdownItemMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type setIsHiddenMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  isHidden: Scalars['Boolean']['input'];
}>;


export type setIsHiddenMutation = { __typename?: 'Mutation', setIsHidden: (
    { __typename?: 'User' }
    & UsersCurrent
  ) };

export type multiPostCKPostEditorQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostCKPostEditorQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsMinimumInfo
    )> } | null };

export type sendNewDialogueMessageNotificationMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  dialogueHtml: Scalars['String']['input'];
}>;


export type sendNewDialogueMessageNotificationMutation = { __typename?: 'Mutation', sendNewDialogueMessageNotification: boolean };

export type updatePostEditTitleMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostEditTitleMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsMinimumInfo
    ) | null } | null };

export type multiRevisionPostVersionHistoryQueryQueryVariables = Exact<{
  selector?: InputMaybe<RevisionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiRevisionPostVersionHistoryQueryQuery = { __typename?: 'Query', revisions: { __typename?: 'MultiRevisionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Revision' }
      & RevisionMetadataWithChangeMetrics
    )> } | null };

export type PostVersionHistoryQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostVersionHistoryQuery = { __typename?: 'Query', revision: { __typename?: 'SingleRevisionOutput', result: (
      { __typename?: 'Revision' }
      & RevisionDisplay
      & RevisionMetadata
    ) | null } | null };

export type revertPostToRevisionMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  revisionId: Scalars['String']['input'];
}>;


export type revertPostToRevisionMutation = { __typename?: 'Mutation', revertPostToRevision: (
    { __typename?: 'Post' }
    & PostsEdit
  ) | null };

export type PresenceListQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PresenceListQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null };

export type multiRevisionTagVersionHistoryQueryQueryVariables = Exact<{
  selector?: InputMaybe<RevisionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiRevisionTagVersionHistoryQueryQuery = { __typename?: 'Query', revisions: { __typename?: 'MultiRevisionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Revision' }
      & RevisionMetadataWithChangeMetrics
    )> } | null };

export type TagVersionHistoryQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagVersionHistoryQuery = { __typename?: 'Query', revision: { __typename?: 'SingleRevisionOutput', result: (
      { __typename?: 'Revision' }
      & RevisionDisplay
    ) | null } | null };

export type revertToRevisionMutationVariables = Exact<{
  tagId: Scalars['String']['input'];
  revertToRevisionId: Scalars['String']['input'];
  contributorsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type revertToRevisionMutation = { __typename?: 'Mutation', revertTagToRevision: (
    { __typename?: 'Tag' }
    & TagPageFragment
  ) | null };

export type createElicitQuestionCreateClaimDialogMutationVariables = Exact<{
  data: CreateElicitQuestionDataInput;
}>;


export type createElicitQuestionCreateClaimDialogMutation = { __typename?: 'Mutation', createElicitQuestion: { __typename?: 'ElicitQuestionOutput', data: (
      { __typename?: 'ElicitQuestion' }
      & ElicitQuestionFragment
    ) | null } | null };

export type LlmModelOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LlmModelOptionsQuery = { __typename?: 'Query', LlmModelOptions: Array<string> };

export type ConvertDocumentQueryVariables = Exact<{
  document?: InputMaybe<Scalars['JSON']['input']>;
  targetFormat?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConvertDocumentQuery = { __typename?: 'Query', convertDocument: any | null };

export type FMCrosspostControlQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FMCrosspostControlQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersCrosspostInfo
    ) | null } | null };

export type unlinkCrossposterMutationVariables = Exact<{ [key: string]: never; }>;


export type unlinkCrossposterMutation = { __typename?: 'Mutation', unlinkCrossposter: string | null };

export type ImageUploadQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImageUploadQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null };

export type multiPodcastEpisodePodcastEpisodeInputQueryQueryVariables = Exact<{
  selector?: InputMaybe<PodcastEpisodeSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPodcastEpisodePodcastEpisodeInputQueryQuery = { __typename?: 'Query', podcastEpisodes: { __typename?: 'MultiPodcastEpisodeOutput', totalCount: number | null, results: Array<(
      { __typename?: 'PodcastEpisode' }
      & PodcastEpisodeFull
    )> } | null };

export type multiPodcastPodcastEpisodeInputQueryQueryVariables = Exact<{
  selector?: InputMaybe<PodcastSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPodcastPodcastEpisodeInputQueryQuery = { __typename?: 'Query', podcasts: { __typename?: 'MultiPodcastOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Podcast' }
      & PodcastSelect
    )> } | null };

export type createPodcastEpisodePodcastEpisodeInputMutationVariables = Exact<{
  data: CreatePodcastEpisodeDataInput;
}>;


export type createPodcastEpisodePodcastEpisodeInputMutation = { __typename?: 'Mutation', createPodcastEpisode: { __typename?: 'PodcastEpisodeOutput', data: (
      { __typename?: 'PodcastEpisode' }
      & PodcastEpisodeCreateFragment
    ) | null } | null };

export type multiLocalgroupSelectLocalgroupQueryQueryVariables = Exact<{
  selector?: InputMaybe<LocalgroupSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiLocalgroupSelectLocalgroupQueryQuery = { __typename?: 'Query', localgroups: { __typename?: 'MultiLocalgroupOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Localgroup' }
      & localGroupsBase
    )> } | null };

export type SequencesListEditorItemQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SequencesListEditorItemQuery = { __typename?: 'Query', sequence: { __typename?: 'SingleSequenceOutput', result: (
      { __typename?: 'Sequence' }
      & SequencesPageFragment
    ) | null } | null };

export type SingleTagItemQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SingleTagItemQuery = { __typename?: 'Query', tag: { __typename?: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagBasicInfo
    ) | null } | null };

export type SingleUsersItemQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SingleUsersItemQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersProfile
    ) | null } | null };

export type TagSelectQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagSelectQuery = { __typename?: 'Query', tag: { __typename?: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagBasicInfo
    ) | null } | null };

export type MultiPostAnalyticsQueryQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  postIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MultiPostAnalyticsQueryQuery = { __typename?: 'Query', MultiPostAnalytics: { __typename?: 'MultiPostAnalyticsResult', totalCount: number, posts: Array<{ __typename?: 'PostAnalytics2Result', _id: string | null, title: string | null, slug: string | null, postedAt: string | null, views: number | null, uniqueViews: number | null, reads: number | null, meanReadingTime: number | null, karma: number | null, comments: number | null } | null> | null } };

export type AnalyticsSeriesQueryQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  postIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AnalyticsSeriesQueryQuery = { __typename?: 'Query', AnalyticsSeries: Array<{ __typename?: 'AnalyticsSeriesValue', date: string | null, views: number | null, reads: number | null, karma: number | null, comments: number | null } | null> | null };

export type multiBookmarkuseBookmarkQueryQueryVariables = Exact<{
  selector?: InputMaybe<BookmarkSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiBookmarkuseBookmarkQueryQuery = { __typename?: 'Query', bookmarks: { __typename?: 'MultiBookmarkOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Bookmark' }
      & BookmarksMinimumInfoFragment
    )> } | null };

export type SetIsBookmarkedMutationMutationVariables = Exact<{
  input: SetIsBookmarkedInput;
}>;


export type SetIsBookmarkedMutationMutation = { __typename?: 'Mutation', setIsBookmarked: { __typename?: 'SetIsBookmarkedOutput', data: (
      { __typename?: 'Bookmark' }
      & BookmarksMinimumInfoFragment
    ) | null } | null };

export type reviewVotesForPostAndUserQueryVariables = Exact<{
  postId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type reviewVotesForPostAndUserQuery = { __typename?: 'Query', reviewVotes: { __typename?: 'MultiReviewVoteOutput', results: Array<{ __typename?: 'ReviewVote', _id: string, qualitativeScore: number, quadraticScore: number }> } | null };

export type UserExpandFrontpageSectionMutationVariables = Exact<{
  section: Scalars['String']['input'];
  expanded: Scalars['Boolean']['input'];
}>;


export type UserExpandFrontpageSectionMutation = { __typename?: 'Mutation', UserExpandFrontpageSection: boolean | null };

export type multiTagfilterSettingsQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagfilterSettingsQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Tag' }
      & TagBasicInfo
    )> } | null };

export type initiateConversationMutationVariables = Exact<{
  participantIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  af?: InputMaybe<Scalars['Boolean']['input']>;
  moderator?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type initiateConversationMutation = { __typename?: 'Mutation', initiateConversation: (
    { __typename?: 'Conversation' }
    & ConversationsMinimumInfo
  ) | null };

export type markConversationReadMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type markConversationReadMutation = { __typename?: 'Mutation', markConversationRead: boolean };

export type multiCommentModerationSidebarQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentModerationSidebarQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & SunshineCommentsList
    )> } | null };

export type multiSubscriptionuseNotifyMeQueryQueryVariables = Exact<{
  selector?: InputMaybe<SubscriptionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiSubscriptionuseNotifyMeQueryQuery = { __typename?: 'Query', subscriptions: { __typename?: 'MultiSubscriptionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Subscription' }
      & SubscriptionState
    )> } | null };

export type createSubscriptionuseNotifyMeMutationVariables = Exact<{
  data: CreateSubscriptionDataInput;
}>;


export type createSubscriptionuseNotifyMeMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'SubscriptionOutput', data: (
      { __typename?: 'Subscription' }
      & SubscriptionState
    ) | null } | null };

export type PostAnalyticsQueryQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type PostAnalyticsQueryQuery = { __typename?: 'Query', PostAnalytics: { __typename?: 'PostAnalyticsResult', allViews: number | null, uniqueClientViews: number | null, uniqueClientViews10Sec: number | null, medianReadingTime: number | null, uniqueClientViews5Min: number | null, uniqueClientViewsSeries: Array<{ __typename?: 'UniqueClientViewsSeries', date: string | null, uniqueClientViews: number | null } | null> | null } };

export type PostsPreviewTooltipSingleQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsPreviewTooltipSingleQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type multiPostusePublishedPostsQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostusePublishedPostsQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & SunshinePostsList
    )> } | null };

export type increasePostViewCountMutationMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type increasePostViewCountMutationMutation = { __typename?: 'Mutation', increasePostViewCount: number | null };

export type markPostCommentsReadMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type markPostCommentsReadMutation = { __typename?: 'Mutation', markPostCommentsRead: boolean | null };

export type RefreshDbSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshDbSettingsMutation = { __typename?: 'Mutation', RefreshDbSettings: boolean | null };

export type multiModerationTemplateRejectContentDialogQueryQueryVariables = Exact<{
  selector?: InputMaybe<ModerationTemplateSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiModerationTemplateRejectContentDialogQueryQuery = { __typename?: 'Query', moderationTemplates: { __typename?: 'MultiModerationTemplateOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ModerationTemplate' }
      & ModerationTemplateFragment
    )> } | null };

export type rejectPostMutationMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type rejectPostMutationMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & SunshinePostsList
    ) | null } | null };

export type rejectCommentMutationMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type rejectCommentMutationMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    ) | null } | null };

export type multiMultiDocumentuseTagOrLensQueryQueryVariables = Exact<{
  selector?: InputMaybe<MultiDocumentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiMultiDocumentuseTagOrLensQueryQuery = { __typename?: 'Query', multiDocuments: { __typename?: 'MultiMultiDocumentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'MultiDocument' }
      & MultiDocumentParentDocument
    )> } | null };

export type UnreadNotificationCountQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationCountQueryQuery = { __typename?: 'Query', unreadNotificationCounts: { __typename?: 'NotificationCounts', unreadNotifications: number, unreadPrivateMessages: number, faviconBadgeNumber: number, checkedAt: string } };

export type updateUseruseUpdateCurrentUserMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUseruseUpdateCurrentUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersCurrent
    ) | null } | null };

export type updateUseruseUpdateGlossaryPinnedStateMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUseruseUpdateGlossaryPinnedStateMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersCurrent
    ) | null } | null };

export type UserClientIdsInfoQueryQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserClientIdsInfoQueryQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UserClientIdsInfo
    ) | null } | null };

export type multiJargonTermGlossaryEditFormQueryQueryVariables = Exact<{
  selector?: InputMaybe<JargonTermSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiJargonTermGlossaryEditFormQueryQuery = { __typename?: 'Query', jargonTerms: { __typename?: 'MultiJargonTermOutput', totalCount: number | null, results: Array<(
      { __typename?: 'JargonTerm' }
      & JargonTerms
    )> } | null };

export type updateJargonTermGlossaryEditForm1MutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateJargonTermDataInput;
}>;


export type updateJargonTermGlossaryEditForm1Mutation = { __typename?: 'Mutation', updateJargonTerm: { __typename?: 'JargonTermOutput', data: (
      { __typename?: 'JargonTerm' }
      & JargonTerms
    ) | null } | null };

export type updatePostGlossaryEditFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostGlossaryEditFormMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsEdit
    ) | null } | null };

export type getNewJargonTermsMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  glossaryPrompt?: InputMaybe<Scalars['String']['input']>;
  examplePost?: InputMaybe<Scalars['String']['input']>;
  exampleTerm?: InputMaybe<Scalars['String']['input']>;
  exampleAltTerm?: InputMaybe<Scalars['String']['input']>;
  exampleDefinition?: InputMaybe<Scalars['String']['input']>;
}>;


export type getNewJargonTermsMutation = { __typename?: 'Mutation', getNewJargonTerms: Array<(
    { __typename?: 'JargonTerm' }
    & JargonTerms
  ) | null> | null };

export type multiPostGlossaryEditorPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type multiPostGlossaryEditorPageQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsEditQueryFragment
    )> } | null };

export type updateJargonTermJargonEditorRowMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateJargonTermDataInput;
}>;


export type updateJargonTermJargonEditorRowMutation = { __typename?: 'Mutation', updateJargonTerm: { __typename?: 'JargonTermOutput', data: (
      { __typename?: 'JargonTerm' }
      & JargonTerms
    ) | null } | null };

export type updateJargonTermJargonTermFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateJargonTermDataInput;
}>;


export type updateJargonTermJargonTermFormMutation = { __typename?: 'Mutation', updateJargonTerm: { __typename?: 'JargonTermOutput', data: (
      { __typename?: 'JargonTerm' }
      & JargonTerms
    ) | null } | null };

export type createJargonTermJargonTermFormMutationVariables = Exact<{
  data: CreateJargonTermDataInput;
}>;


export type createJargonTermJargonTermFormMutation = { __typename?: 'Mutation', createJargonTerm: { __typename?: 'JargonTermOutput', data: (
      { __typename?: 'JargonTerm' }
      & JargonTerms
    ) | null } | null };

export type getPostsWithApprovedJargonQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type getPostsWithApprovedJargonQuery = { __typename?: 'Query', PostsWithApprovedJargon: { __typename?: 'PostsWithApprovedJargonResult', results: Array<{ __typename?: 'PostWithApprovedJargon', post: (
        { __typename?: 'Post' }
        & PostsListWithVotes
      ), jargonTerms: Array<(
        { __typename?: 'JargonTerm' }
        & JargonTerms
      )> }> } | null };

export type multiCommentAutocompleteModelSettingsQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentAutocompleteModelSettingsQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsList
    )> } | null };

export type multiPostAutocompleteModelSettingsQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostAutocompleteModelSettingsQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> } | null };

export type multiLlmConversationLlmChatWrapperQueryQueryVariables = Exact<{
  selector?: InputMaybe<LlmConversationSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiLlmConversationLlmChatWrapperQueryQuery = { __typename?: 'Query', llmConversations: { __typename?: 'MultiLlmConversationOutput', totalCount: number | null, results: Array<(
      { __typename?: 'LlmConversation' }
      & LlmConversationsFragment
    )> } | null };

export type updateLlmConversationLlmChatWrapperMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateLlmConversationDataInput;
}>;


export type updateLlmConversationLlmChatWrapperMutation = { __typename?: 'Mutation', updateLlmConversation: { __typename?: 'LlmConversationOutput', data: (
      { __typename?: 'LlmConversation' }
      & LlmConversationsFragment
    ) | null } | null };

export type LlmChatWrapperQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LlmChatWrapperQuery = { __typename?: 'Query', llmConversation: { __typename?: 'SingleLlmConversationOutput', result: (
      { __typename?: 'LlmConversation' }
      & LlmConversationsWithMessagesFragment
    ) | null } | null };

export type multiLlmConversationLlmConversationsViewingPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<LlmConversationSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiLlmConversationLlmConversationsViewingPageQueryQuery = { __typename?: 'Query', llmConversations: { __typename?: 'MultiLlmConversationOutput', totalCount: number | null, results: Array<(
      { __typename?: 'LlmConversation' }
      & LlmConversationsViewingPageFragment
    )> } | null };

export type LlmConversationsViewingPageQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LlmConversationsViewingPageQuery = { __typename?: 'Query', llmConversation: { __typename?: 'SingleLlmConversationOutput', result: (
      { __typename?: 'LlmConversation' }
      & LlmConversationsWithMessagesFragment
    ) | null } | null };

export type updateUserLayoutMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserLayoutMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersCurrent
    ) | null } | null };

export type HocuspocusAuthQueryQueryVariables = Exact<{
  collectionName?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  linkSharingKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type HocuspocusAuthQueryQuery = { __typename?: 'Query', HocuspocusAuth: { __typename?: 'HocuspocusAuth', token: string } | null };

export type GetReviewResultsTableDataQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type GetReviewResultsTableDataQuery = { __typename?: 'Query', ReviewResultsTableData: { __typename?: 'ReviewResultsTableData', year: number, results: Array<{ __typename?: 'ReviewResultsPostEntry', rank: number, title: string, postUrl: string, authorName: string, coauthorNames: Array<string>, votes: Array<number> }> } | null };

export type CrossSiteLinkPreviewWithImageDimensionsQueryQueryVariables = Exact<{
  url: Scalars['String']['input'];
  forceRefetch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CrossSiteLinkPreviewWithImageDimensionsQueryQuery = { __typename?: 'Query', crossSiteLinkPreview: { __typename?: 'CrossSiteLinkPreviewData', title: string | null, imageUrl: string | null, imageWidth: number | null, imageHeight: number | null, html: string | null, error: string | null, status: string | null, fetchedAt: string | null, nextRefreshAt: string | null } | null };

export type CrossSiteLinkPreviewDebugQueryQueryVariables = Exact<{
  url: Scalars['String']['input'];
  forceRefetch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CrossSiteLinkPreviewDebugQueryQuery = { __typename?: 'Query', crossSiteLinkPreview: { __typename?: 'CrossSiteLinkPreviewData', title: string | null, imageUrl: string | null, imageWidth: number | null, imageHeight: number | null, html: string | null, error: string | null, status: string | null, fetchedAt: string | null, nextRefreshAt: string | null, debugTitleSource: string | null, debugImageSource: string | null, debugHtmlSource: string | null } | null };

export type SequencePreviewQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  allowNull?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SequencePreviewQuery = { __typename?: 'Query', sequence: { __typename?: 'SingleSequenceOutput', result: (
      { __typename?: 'Sequence' }
      & SequenceSummaryFragment
    ) | null } | null };

export type PostLinkPreviewCommentQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  allowNull?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PostLinkPreviewCommentQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type PostLinkPreviewPostQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  allowNull?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PostLinkPreviewPostQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type ArbitalPageRequestQueryVariables = Exact<{
  arbitalSlug: Scalars['String']['input'];
}>;


export type ArbitalPageRequestQuery = { __typename?: 'Query', ArbitalPageData: { __typename?: 'ArbitalPageData', title: string | null, html: string | null } | null };

export type multiUserCommunityMapQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserCommunityMapQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & UsersMapEntry
    )> } | null };

export type multiLocalgroupCommunityMapQueryQueryVariables = Exact<{
  selector?: InputMaybe<LocalgroupSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiLocalgroupCommunityMapQueryQuery = { __typename?: 'Query', localgroups: { __typename?: 'MultiLocalgroupOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Localgroup' }
      & localGroupsHomeFragment
    )> } | null };

export type multiPostCommunityMapQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostCommunityMapQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type updateLocalgroupGroupFormDialogMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateLocalgroupDataInput;
}>;


export type updateLocalgroupGroupFormDialogMutation = { __typename?: 'Mutation', updateLocalgroup: { __typename?: 'LocalgroupOutput', data: (
      { __typename?: 'Localgroup' }
      & localGroupsHomeFragment
    ) | null } | null };

export type createLocalgroupGroupFormDialogMutationVariables = Exact<{
  data: CreateLocalgroupDataInput;
}>;


export type createLocalgroupGroupFormDialogMutation = { __typename?: 'Mutation', createLocalgroup: { __typename?: 'LocalgroupOutput', data: (
      { __typename?: 'Localgroup' }
      & localGroupsHomeFragment
    ) | null } | null };

export type GroupFormDialogQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GroupFormDialogQuery = { __typename?: 'Query', localgroup: { __typename?: 'SingleLocalgroupOutput', result: (
      { __typename?: 'Localgroup' }
      & localGroupsEdit
    ) | null } | null };

export type multiPostLocalGroupPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostLocalGroupPageQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type LocalGroupPageQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LocalGroupPageQuery = { __typename?: 'Query', localgroup: { __typename?: 'SingleLocalgroupOutput', result: (
      { __typename?: 'Localgroup' }
      & localGroupsHomeFragment
    ) | null } | null };

export type multiSubscriptionLocalGroupSubscribersQueryQueryVariables = Exact<{
  selector?: InputMaybe<SubscriptionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiSubscriptionLocalGroupSubscribersQueryQuery = { __typename?: 'Query', subscriptions: { __typename?: 'MultiSubscriptionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Subscription' }
      & MembersOfGroupFragment
    )> } | null };

export type multiLocalgroupLocalGroupsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<LocalgroupSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiLocalgroupLocalGroupsListQueryQuery = { __typename?: 'Query', localgroups: { __typename?: 'MultiLocalgroupOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Localgroup' }
      & localGroupsHomeFragment
    )> } | null };

export type SetPersonalMapLocationDialogQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetPersonalMapLocationDialogQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersEdit
    ) | null } | null };

export type multiPostTabNavigationEventsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostTabNavigationEventsListQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type multiMessageConversationContentsQueryQueryVariables = Exact<{
  selector?: InputMaybe<MessageSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiMessageConversationContentsQueryQuery = { __typename?: 'Query', messages: { __typename?: 'MultiMessageOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Message' }
      & messageListFragment
    )> } | null };

export type updateConversationInboxNavigationMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateConversationDataInput;
}>;


export type updateConversationInboxNavigationMutation = { __typename?: 'Mutation', updateConversation: { __typename?: 'ConversationOutput', data: (
      { __typename?: 'Conversation' }
      & ConversationsList
    ) | null } | null };

export type multiMessageConversationPreviewQueryQueryVariables = Exact<{
  selector?: InputMaybe<MessageSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiMessageConversationPreviewQueryQuery = { __typename?: 'Query', messages: { __typename?: 'MultiMessageOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Message' }
      & messageListFragment
    )> } | null };

export type singleMessageConversationPreviewQueryQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type singleMessageConversationPreviewQueryQuery = { __typename?: 'Query', message: { __typename?: 'SingleMessageOutput', result: (
      { __typename?: 'Message' }
      & messageListFragment
    ) | null } | null };

export type ConversationPreviewQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConversationPreviewQuery = { __typename?: 'Query', conversation: { __typename?: 'SingleConversationOutput', result: (
      { __typename?: 'Conversation' }
      & ConversationsList
    ) | null } | null };

export type updateConversationConversationTitleEditFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateConversationDataInput;
}>;


export type updateConversationConversationTitleEditFormMutation = { __typename?: 'Mutation', updateConversation: { __typename?: 'ConversationOutput', data: (
      { __typename?: 'Conversation' }
      & ConversationsList
    ) | null } | null };

export type multiConversationFriendlyInboxQueryQueryVariables = Exact<{
  selector?: InputMaybe<ConversationSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiConversationFriendlyInboxQueryQuery = { __typename?: 'Query', conversations: { __typename?: 'MultiConversationOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Conversation' }
      & ConversationsListWithReadStatus
    )> } | null };

export type FriendlyInboxQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FriendlyInboxQuery = { __typename?: 'Query', conversation: { __typename?: 'SingleConversationOutput', result: (
      { __typename?: 'Conversation' }
      & ConversationsListWithReadStatus
    ) | null } | null };

export type MessageUserGetUserBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type MessageUserGetUserBySlugQuery = { __typename?: 'Query', GetUserBySlug: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null };

export type createMessageMessagesNewFormMutationVariables = Exact<{
  data: CreateMessageDataInput;
}>;


export type createMessageMessagesNewFormMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'MessageOutput', data: (
      { __typename?: 'Message' }
      & messageListFragment
    ) | null } | null };

export type MessagesNewFormQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MessagesNewFormQuery = { __typename?: 'Query', moderationTemplate: { __typename?: 'SingleModerationTemplateOutput', result: (
      { __typename?: 'ModerationTemplate' }
      & ModerationTemplateFragment
    ) | null } | null };

export type updateModerationTemplateModerationTemplateFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateModerationTemplateDataInput;
}>;


export type updateModerationTemplateModerationTemplateFormMutation = { __typename?: 'Mutation', updateModerationTemplate: { __typename?: 'ModerationTemplateOutput', data: (
      { __typename?: 'ModerationTemplate' }
      & ModerationTemplateFragment
    ) | null } | null };

export type createModerationTemplateModerationTemplateFormMutationVariables = Exact<{
  data: CreateModerationTemplateDataInput;
}>;


export type createModerationTemplateModerationTemplateFormMutation = { __typename?: 'Mutation', createModerationTemplate: { __typename?: 'ModerationTemplateOutput', data: (
      { __typename?: 'ModerationTemplate' }
      & ModerationTemplateFragment
    ) | null } | null };

export type multiModerationTemplateModerationTemplatesPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<ModerationTemplateSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiModerationTemplateModerationTemplatesPageQueryQuery = { __typename?: 'Query', moderationTemplates: { __typename?: 'MultiModerationTemplateOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ModerationTemplate' }
      & ModerationTemplateFragment
    )> } | null };

export type CommentOnYourDraftNotificationHoverQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentOnYourDraftNotificationHoverQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsMinimumInfo
    ) | null } | null };

export type EmailPreviewQueryQueryVariables = Exact<{
  notificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailPreviewQueryQuery = { __typename?: 'Query', EmailPreview: Array<{ __typename?: 'EmailPreview', to: string | null, subject: string | null, html: string | null, text: string | null } | null> | null };

export type multiNotificationNotificationsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<NotificationSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiNotificationNotificationsListQueryQuery = { __typename?: 'Query', notifications: { __typename?: 'MultiNotificationOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Notification' }
      & NotificationsList
    )> } | null };

export type NotificationsMenuButtonQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotificationsMenuButtonQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UserKarmaChanges
    ) | null } | null };

export type TagRelNotificationItemQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagRelNotificationItemQuery = { __typename?: 'Query', tagRel: { __typename?: 'SingleTagRelOutput', result: (
      { __typename?: 'TagRel' }
      & TagRelFragment
    ) | null } | null };

export type TypoSuggestionHoverQueryQueryVariables = Exact<{
  suggestionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TypoSuggestionHoverQueryQuery = { __typename?: 'Query', typoSuggestion: { __typename?: 'SingleTypoSuggestionOutput', result: (
      { __typename?: 'TypoSuggestion' }
      & TypoSuggestionsDefaultFragment
    ) | null } | null };

export type acceptTypoSuggestionFromHoverMutationVariables = Exact<{
  suggestionId: Scalars['String']['input'];
  mode: TypoAcceptMode;
}>;


export type acceptTypoSuggestionFromHoverMutation = { __typename?: 'Mutation', acceptTypoSuggestion: (
    { __typename?: 'TypoSuggestion' }
    & TypoSuggestionsDefaultFragment
  ) };

export type rejectTypoSuggestionFromHoverMutationVariables = Exact<{
  suggestionId: Scalars['String']['input'];
}>;


export type rejectTypoSuggestionFromHoverMutation = { __typename?: 'Mutation', rejectTypoSuggestion: (
    { __typename?: 'TypoSuggestion' }
    & TypoSuggestionsDefaultFragment
  ) };

export type multiUserAdminPaymentsPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserAdminPaymentsPageQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & UsersProfile
    )> } | null };

export type updateUserEditPaymentInfoPageMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserEditPaymentInfoPageMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersEdit
    ) | null } | null };

export type AddToCalendarButtonQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddToCalendarButtonQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsPlaintextDescription
    ) | null } | null };

export type getClaudeAccessLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type getClaudeAccessLinkMutation = { __typename?: 'Mutation', getClaudeAccessLink: string | null };

export type multiPostCurrentOpenThreadPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostCurrentOpenThreadPageQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsMinimumInfo
    )> } | null };

export type multiPostDraftsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostDraftsListQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> } | null };

export type updatePostDraftsListMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostDraftsListMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type latestGoogleDocMetadataSidebarQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type latestGoogleDocMetadataSidebarQuery = { __typename?: 'Query', latestGoogleDocMetadata: any | null };

export type ImportGoogleDocSidebarMutationVariables = Exact<{
  fileUrl: Scalars['String']['input'];
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImportGoogleDocSidebarMutation = { __typename?: 'Mutation', ImportGoogleDoc: (
    { __typename?: 'Post' }
    & PostsBase
  ) | null };

export type ConvertDocumentEditorTypeMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  collectionName: ConvertibleCollectionName;
  fieldName: Scalars['String']['input'];
  document: Scalars['JSON']['input'];
  targetFormat: Scalars['String']['input'];
}>;


export type ConvertDocumentEditorTypeMutation = { __typename?: 'Mutation', convertDocumentEditorType: any | null };

export type updatePostExternalPostImporterMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostExternalPostImporterMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type createCommentExternalPostImporterMutationVariables = Exact<{
  data: CreateCommentDataInput;
}>;


export type createCommentExternalPostImporterMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type importUrlAsDraftPostMutationVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type importUrlAsDraftPostMutation = { __typename?: 'Mutation', importUrlAsDraftPost: { __typename?: 'ExternalPostImportData', alreadyExists: boolean | null, post: { __typename?: 'ExternalPost', _id: string, slug: string | null, title: string | null, content: string | null, url: string | null, postedAt: string | null, createdAt: string | null, modifiedAt: string | null, userId: string | null, draft: boolean | null, coauthorUserIds: Array<string> | null } | null } };

export type FeedPostsHighlightQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FeedPostsHighlightQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsExpandedHighlight
    ) | null } | null };

export type multiPostLWPostsByVoteQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostLWPostsByVoteQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> } | null };

export type createPostNewDialogueDialogMutationVariables = Exact<{
  data: CreatePostDataInput;
}>;


export type createPostNewDialogueDialogMutation = { __typename?: 'Mutation', createPost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsEdit
    ) | null } | null };

export type multiPostPingbacksListQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostPingbacksListQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type updatePostPostFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostPostFormMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsEditMutationFragment
    ) | null } | null };

export type createPostPostFormMutationVariables = Exact<{
  data: CreatePostDataInput;
}>;


export type createPostPostFormMutation = { __typename?: 'Mutation', createPost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsEditMutationFragment
    ) | null } | null };

export type multiUserMostValuablePostPostMostValuableCheckboxQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserMostValuablePostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserMostValuablePostPostMostValuableCheckboxQueryQuery = { __typename?: 'Query', userMostValuablePosts: { __typename?: 'MultiUserMostValuablePostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'UserMostValuablePost' }
      & UserMostValuablePostInfo
    )> } | null };

export type updateUserMostValuablePostPostMostValuableCheckboxMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserMostValuablePostDataInput;
}>;


export type updateUserMostValuablePostPostMostValuableCheckboxMutation = { __typename?: 'Mutation', updateUserMostValuablePost: { __typename?: 'UserMostValuablePostOutput', data: (
      { __typename?: 'UserMostValuablePost' }
      & UserMostValuablePostInfo
    ) | null } | null };

export type createUserMostValuablePostPostMostValuableCheckboxMutationVariables = Exact<{
  data: CreateUserMostValuablePostDataInput;
}>;


export type createUserMostValuablePostPostMostValuableCheckboxMutation = { __typename?: 'Mutation', createUserMostValuablePost: { __typename?: 'UserMostValuablePostOutput', data: (
      { __typename?: 'UserMostValuablePost' }
      & UserMostValuablePostInfo
    ) | null } | null };

export type multiPostPostsByVoteQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostPostsByVoteQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> } | null };

export type multiVotePostsByVoteWrapperQueryQueryVariables = Exact<{
  selector?: InputMaybe<VoteSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiVotePostsByVoteWrapperQueryQuery = { __typename?: 'Query', votes: { __typename?: 'MultiVoteOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Vote' }
      & UserVotes
    )> } | null };

export type multiRevisionPostsCompareRevisionsQueryQueryVariables = Exact<{
  selector?: InputMaybe<RevisionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiRevisionPostsCompareRevisionsQueryQuery = { __typename?: 'Query', revisions: { __typename?: 'MultiRevisionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Revision' }
      & RevisionHistoryEntry
    )> } | null };

export type PostsCompareRevisionsQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  sequenceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsCompareRevisionsQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsWithNavigation
    ) | null } | null };

export type multiCommentPostsDialogItemNewCommentsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentPostsDialogItemNewCommentsListQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsList
    )> } | null };

export type PostsEditFormUserQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  eventForm?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PostsEditFormUserQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersCurrentPostRateLimit
    ) | null } | null };

export type LinkSharingEditQueryQueryVariables = Exact<{
  postId: Scalars['String']['input'];
  linkSharingKey: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type LinkSharingEditQueryQuery = { __typename?: 'Query', getLinkSharedPost: (
    { __typename?: 'Post' }
    & PostsEditQueryFragment
  ) | null };

export type PostsGroupDetailsQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsGroupDetailsQuery = { __typename?: 'Query', localgroup: { __typename?: 'SingleLocalgroupOutput', result: (
      { __typename?: 'Localgroup' }
      & localGroupsHomeFragment
    ) | null } | null };

export type PostsHighlightQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsHighlightQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsExpandedHighlight
    ) | null } | null };

export type multiCommentPostsItemNewCommentsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentPostsItemNewCommentsListQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsList
    )> } | null };

export type LatestDialogueMessagesQueryVariables = Exact<{
  dialogueId: Scalars['String']['input'];
  unreadCount: Scalars['Int']['input'];
}>;


export type LatestDialogueMessagesQuery = { __typename?: 'Query', latestDialogueMessages: Array<string> | null };

export type PostsItemWrapperQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsItemWrapperQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type createPostPostsNewFormMutationVariables = Exact<{
  data: CreatePostDataInput;
}>;


export type createPostPostsNewFormMutation = { __typename?: 'Mutation', createPost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsEdit
    ) | null } | null };

export type PostsNewForm4QueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsNewForm4Query = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersEdit
    ) | null } | null };

export type PostsNewForm3QueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsNewForm3Query = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsEditMutationFragment
    ) | null } | null };

export type PostsNewForm2QueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsNewForm2Query = { __typename?: 'Query', localgroup: { __typename?: 'SingleLocalgroupOutput', result: (
      { __typename?: 'Localgroup' }
      & localGroupsIsOnline
    ) | null } | null };

export type PostsNewForm1QueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsNewForm1Query = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsEditQueryFragment
    ) | null } | null };

export type PostsNewFormQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsNewFormQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsPage
    ) | null } | null };

export type multiReviewWinnerBestOfLessWrongAnnouncementQueryQueryVariables = Exact<{
  selector?: InputMaybe<ReviewWinnerSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiReviewWinnerBestOfLessWrongAnnouncementQueryQuery = { __typename?: 'Query', reviewWinners: { __typename?: 'MultiReviewWinnerOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ReviewWinner' }
      & ReviewWinnerAnnouncement
    )> } | null };

export type createSplashArtCoordinateImageCropPreviewMutationVariables = Exact<{
  data: CreateSplashArtCoordinateDataInput;
}>;


export type createSplashArtCoordinateImageCropPreviewMutation = { __typename?: 'Mutation', createSplashArtCoordinate: { __typename?: 'SplashArtCoordinateOutput', data: (
      { __typename?: 'SplashArtCoordinate' }
      & SplashArtCoordinates
    ) | null } | null };

export type createSplashArtCoordinatePostWithArtGridMutationVariables = Exact<{
  data: CreateSplashArtCoordinateDataInput;
}>;


export type createSplashArtCoordinatePostWithArtGridMutation = { __typename?: 'Mutation', createSplashArtCoordinate: { __typename?: 'SplashArtCoordinateOutput', data: (
      { __typename?: 'SplashArtCoordinate' }
      & SplashArtCoordinatesEdit
    ) | null } | null };

export type upscaleReviewWinnerArtPostWithArtGridMutationVariables = Exact<{
  reviewWinnerArtId: Scalars['String']['input'];
}>;


export type upscaleReviewWinnerArtPostWithArtGridMutation = { __typename?: 'Mutation', upscaleReviewWinnerArt: (
    { __typename?: 'ReviewWinnerArt' }
    & ReviewWinnerArtImages
  ) | null };

export type multiCommentReviewPillContainerQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentReviewPillContainerQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentWithRepliesFragment
    )> } | null };

export type flipSplashArtImageMutationVariables = Exact<{
  reviewWinnerArtId: Scalars['String']['input'];
}>;


export type flipSplashArtImageMutation = { __typename?: 'Mutation', flipSplashArtImage: boolean | null };

export type multiReviewWinnerArtSplashImageEditingOptionsQueryQueryVariables = Exact<{
  selector?: InputMaybe<ReviewWinnerArtSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiReviewWinnerArtSplashImageEditingOptionsQueryQuery = { __typename?: 'Query', reviewWinnerArts: { __typename?: 'MultiReviewWinnerArtOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ReviewWinnerArt' }
      & ReviewWinnerArtImages
    )> } | null };

export type PostsPageWrapper1QueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  sequenceId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsPageWrapper1Query = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsWithNavigationAndRevision
    ) | null } | null };

export type PostsPageWrapperQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  sequenceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsPageWrapperQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsWithNavigation
    ) | null } | null };

export type PostsRevisionsListQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsRevisionsListQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsRevisionsList
    ) | null } | null };

export type RegisterRSVPMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterRSVPMutation = { __typename?: 'Mutation', RSVPToEvent: (
    { __typename?: 'Post' }
    & PostsDetails
  ) | null };

export type CancelRSVPToEventMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelRSVPToEventMutation = { __typename?: 'Mutation', CancelRSVPToEvent: (
    { __typename?: 'Post' }
    & PostsDetails
  ) | null };

export type LWPostsPreviewTooltip1QueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  dialogueMessageId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LWPostsPreviewTooltip1Query = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostWithDialogueMessage
    ) | null } | null };

export type LWPostsPreviewTooltipQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
}>;


export type LWPostsPreviewTooltipQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & HighlightWithHash
    ) | null } | null };

export type PostsPreviewTooltipSingle4QueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsPreviewTooltipSingle4Query = { __typename?: 'Query', tagRel: { __typename?: 'SingleTagRelOutput', result: (
      { __typename?: 'TagRel' }
      & TagRelFragment
    ) | null } | null };

export type PostsPreviewTooltipSingle3QueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsPreviewTooltipSingle3Query = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type multiPostPostsTimeBlockQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostPostsTimeBlockQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> } | null };

export type getRecombeeLatestPostsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type getRecombeeLatestPostsQuery = { __typename?: 'Query', RecombeeLatestPosts: { __typename?: 'RecombeeLatestPostsResult', results: Array<{ __typename?: 'RecombeeRecommendedPost', scenario: string | null, recommId: string | null, generatedAt: string | null, curated: boolean | null, stickied: boolean | null, post: (
        { __typename?: 'Post' }
        & PostsListWithVotes
      ) }> } | null };

export type getRecombeeHybridPostsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type getRecombeeHybridPostsQuery = { __typename?: 'Query', RecombeeHybridPosts: { __typename?: 'RecombeeHybridPostsResult', results: Array<{ __typename?: 'RecombeeRecommendedPost', scenario: string | null, recommId: string | null, generatedAt: string | null, curated: boolean | null, stickied: boolean | null, post: (
        { __typename?: 'Post' }
        & PostsListWithVotes
      ) }> } | null };

export type createCommentDialogueSubmitMutationVariables = Exact<{
  data: CreateCommentDataInput;
}>;


export type createCommentDialogueSubmitMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentEdit
    ) | null } | null };

export type PostsEditFormPostQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsEditFormPostQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsEditQueryFragment
    ) | null } | null };

export type multiCommentPostsPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentPostsPageQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsList
    )> } | null };

export type postCommentsThreadQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type postCommentsThreadQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsList
    )> } | null };

export type multiPostusePostQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostusePostQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type postsListWithVotesQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type postsListWithVotesQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> } | null };

export type postsListTagWithVotesQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
}>;


export type postsListTagWithVotesQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsListTagWithVotes
    )> } | null };

export type multiCommentQuickTakesSectionQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentQuickTakesSectionQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & FrontpageShortformComments
    )> } | null };

export type multiPostRecentDiscussionThreadsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  commentsLimit?: InputMaybe<Scalars['Int']['input']>;
  maxAgeHours?: InputMaybe<Scalars['Int']['input']>;
  af?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostRecentDiscussionThreadsListQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsRecentDiscussion
    )> } | null };

export type CuratedAndPopularThisWeekQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  af?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CuratedAndPopularThisWeekQuery = { __typename?: 'Query', CuratedAndPopularThisWeek: { __typename?: 'CuratedAndPopularThisWeekResult', results: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> } | null };

export type multiPostRecommendationsSamplePageQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostRecommendationsSamplePageQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> } | null };

export type WelcomePostItemQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type WelcomePostItemQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsListWithVotes
    ) | null } | null };

export type observeRecommendationMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type observeRecommendationMutation = { __typename?: 'Mutation', observeRecommendation: boolean | null };

export type clickRecommendationMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type clickRecommendationMutation = { __typename?: 'Mutation', clickRecommendation: boolean | null };

export type ContinueReadingQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ContinueReadingQueryQuery = { __typename?: 'Query', ContinueReading: Array<{ __typename?: 'RecommendResumeSequence', numRead: number | null, numTotal: number | null, lastReadTime: string | null, sequence: (
      { __typename?: 'Sequence' }
      & SequenceContinueReadingFragment
    ) | null, collection: (
      { __typename?: 'Collection' }
      & CollectionContinueReadingFragment
    ) | null, nextPost: (
      { __typename?: 'Post' }
      & PostsListWithVotes
    ) }> | null };

export type dismissRecommendationMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type dismissRecommendationMutation = { __typename?: 'Mutation', dismissRecommendation: boolean | null };

export type RecommendationsQueryQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']['input']>;
  algorithm?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type RecommendationsQueryQuery = { __typename?: 'Query', Recommendations: Array<(
    { __typename?: 'Post' }
    & PostsListWithVotesAndSequence
  )> | null };

export type SaveResearchEnvironmentMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
  withConversation: Scalars['Boolean']['input'];
}>;


export type SaveResearchEnvironmentMutation = { __typename?: 'Mutation', saveResearchEnvironment: { __typename?: 'SaveResearchEnvironmentOutput', data: { __typename?: 'ResearchEnvironment', _id: string, label: string | null, sourceEventId: string | null, createdAt: string } | null } | null };

export type MintDevPreviewUrlMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type MintDevPreviewUrlMutation = { __typename?: 'Mutation', mintDevPreviewUrl: { __typename?: 'DevPreviewUrlOutput', url: string } | null };

export type ResearchSandboxRunningQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type ResearchSandboxRunningQuery = { __typename?: 'Query', researchSandboxRunning: boolean };

export type ConversationChatViewInfoQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type ConversationChatViewInfoQuery = { __typename?: 'Query', researchConversation: { __typename?: 'SingleResearchConversationOutput', result: { __typename?: 'ResearchConversation', _id: string, title: string | null } | null } | null };

export type ContinueResearchConversationFromChatViewMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
  promptHtml: Scalars['String']['input'];
  activeDocumentId: Scalars['String']['input'];
}>;


export type ContinueResearchConversationFromChatViewMutation = { __typename?: 'Mutation', continueResearchConversation: { __typename?: 'ResearchConversationOutput', conversationId: string } | null };

export type CancelResearchConversationFromChatViewMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type CancelResearchConversationFromChatViewMutation = { __typename?: 'Mutation', cancelResearchConversation: { __typename?: 'ResearchConversationOutput', conversationId: string } | null };

export type ResearchDocumentQueryQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type ResearchDocumentQueryQuery = { __typename?: 'Query', researchDocument: { __typename?: 'SingleResearchDocumentOutput', result: { __typename?: 'ResearchDocument', _id: string, title: string | null, contents: { __typename?: 'Revision', html: string | null, originalContents: { __typename?: 'ContentType', type: string, data: any } } | null } | null } | null };

export type FireDocumentConversationMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  activeDocumentId: Scalars['String']['input'];
  promptHtml: Scalars['String']['input'];
  baseEnvironmentId?: InputMaybe<Scalars['String']['input']>;
  runtime?: InputMaybe<Scalars['String']['input']>;
}>;


export type FireDocumentConversationMutation = { __typename?: 'Mutation', fireResearchConversation: { __typename?: 'ResearchConversationOutput', conversationId: string } | null };

export type ProjectCommentsDocumentsQueryQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type ProjectCommentsDocumentsQueryQuery = { __typename?: 'Query', researchDocuments: { __typename?: 'MultiResearchDocumentOutput', results: Array<{ __typename?: 'ResearchDocument', _id: string, title: string | null }> } | null };

export type CreateResearchDocumentSidebarMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateResearchDocumentSidebarMutation = { __typename?: 'Mutation', createResearchDocument: { __typename?: 'ResearchDocumentOutput', data: { __typename?: 'ResearchDocument', _id: string, title: string | null, createdAt: string } | null } | null };

export type RenameResearchDocumentSidebarMutationVariables = Exact<{
  id: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenameResearchDocumentSidebarMutation = { __typename?: 'Mutation', updateResearchDocument: { __typename?: 'ResearchDocumentOutput', data: { __typename?: 'ResearchDocument', _id: string, title: string | null } | null } | null };

export type RenameResearchConversationSidebarMutationVariables = Exact<{
  id: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenameResearchConversationSidebarMutation = { __typename?: 'Mutation', updateResearchConversation: { __typename?: 'ResearchConversationOutput', data: { __typename?: 'ResearchConversation', _id: string, title: string | null } | null } | null };

export type SetResearchDocumentIconMutationVariables = Exact<{
  id: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetResearchDocumentIconMutation = { __typename?: 'Mutation', updateResearchDocument: { __typename?: 'ResearchDocumentOutput', data: { __typename?: 'ResearchDocument', _id: string, icon: string | null } | null } | null };

export type SetResearchConversationIconMutationVariables = Exact<{
  id: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetResearchConversationIconMutation = { __typename?: 'Mutation', updateResearchConversation: { __typename?: 'ResearchConversationOutput', data: { __typename?: 'ResearchConversation', _id: string, icon: string | null } | null } | null };

export type ReorderResearchDocumentsMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  orderedIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReorderResearchDocumentsMutation = { __typename?: 'Mutation', reorderResearchDocuments: { __typename?: 'ReorderResearchDocumentsOutput', success: boolean } | null };

export type RenameResearchEnvironmentSidebarMutationVariables = Exact<{
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
}>;


export type RenameResearchEnvironmentSidebarMutation = { __typename?: 'Mutation', updateResearchEnvironment: { __typename?: 'ResearchEnvironmentOutput', data: { __typename?: 'ResearchEnvironment', _id: string, label: string | null } | null } | null };

export type ArchiveResearchDocumentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type ArchiveResearchDocumentMutation = { __typename?: 'Mutation', updateResearchDocument: { __typename?: 'ResearchDocumentOutput', data: { __typename?: 'ResearchDocument', _id: string, archived: boolean | null } | null } | null };

export type ArchiveResearchConversationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type ArchiveResearchConversationMutation = { __typename?: 'Mutation', updateResearchConversation: { __typename?: 'ResearchConversationOutput', data: { __typename?: 'ResearchConversation', _id: string, archived: boolean | null } | null } | null };

export type ArchiveResearchEnvironmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type ArchiveResearchEnvironmentMutation = { __typename?: 'Mutation', updateResearchEnvironment: { __typename?: 'ResearchEnvironmentOutput', data: { __typename?: 'ResearchEnvironment', _id: string, archived: boolean | null } | null } | null };

export type ResearchConversationSidebarStatusesQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type ResearchConversationSidebarStatusesQuery = { __typename?: 'Query', researchConversationSidebarStatuses: Array<{ __typename?: 'ResearchConversationSidebarStatus', conversationId: string, turnActive: boolean, lastActivityAt: string | null, lastReadAt: string | null }> };

export type ResearchProjectListQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ResearchProjectListQueryQuery = { __typename?: 'Query', researchProjects: { __typename?: 'MultiResearchProjectOutput', results: Array<{ __typename?: 'ResearchProject', _id: string, title: string | null, description: string | null, createdAt: string }> } | null };

export type ResearchClaudeTokenStatusQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ResearchClaudeTokenStatusQueryQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: { __typename?: 'User', _id: string, hasClaudeCodeOAuthToken: boolean | null } | null } | null };

export type CreateResearchProjectMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateResearchProjectMutation = { __typename?: 'Mutation', createResearchProject: { __typename?: 'ResearchProjectOutput', data: { __typename?: 'ResearchProject', _id: string, title: string | null, description: string | null, createdAt: string } | null } | null };

export type ResearchSetClaudeCodeOAuthTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ResearchSetClaudeCodeOAuthTokenMutation = { __typename?: 'Mutation', setClaudeCodeOAuthToken: { __typename?: 'SetClaudeCodeOAuthTokenOutput', success: boolean } | null };

export type AnswerResearchConversationQuestionMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
  toolUseId: Scalars['String']['input'];
  answersJson: Scalars['String']['input'];
}>;


export type AnswerResearchConversationQuestionMutation = { __typename?: 'Mutation', answerResearchConversationQuestion: { __typename?: 'AnswerResearchQuestionOutput', ok: boolean, expired: boolean } | null };

export type ResearchWorkspaceFirstDocumentQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type ResearchWorkspaceFirstDocumentQuery = { __typename?: 'Query', researchDocuments: { __typename?: 'MultiResearchDocumentOutput', results: Array<{ __typename?: 'ResearchDocument', _id: string }> } | null };

export type EnsureResearchScratchDocumentMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type EnsureResearchScratchDocumentMutation = { __typename?: 'Mutation', ensureResearchScratchDocument: { __typename?: 'EnsureResearchScratchDocumentOutput', documentId: string } | null };

export type ResearchSandboxDirectoryQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResearchSandboxDirectoryQuery = { __typename?: 'Query', researchSandboxDirectory: { __typename?: 'ResearchSandboxDirListing', path: string, running: boolean, entries: Array<{ __typename?: 'ResearchSandboxDirEntry', name: string, kind: string, size: number | null }> } };

export type ResearchSandboxFileQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
  path: Scalars['String']['input'];
}>;


export type ResearchSandboxFileQuery = { __typename?: 'Query', researchSandboxFile: { __typename?: 'ResearchSandboxFileContents', path: string, running: boolean, content: string, truncated: boolean, binary: boolean, size: number } };

export type ResearchSandboxStatsQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type ResearchSandboxStatsQuery = { __typename?: 'Query', researchSandboxStats: { __typename?: 'ResearchSandboxStats', running: boolean, cpuPct: number | null, memUsed: number | null, memTotal: number | null, diskUsed: number | null, diskTotal: number | null, hibernatingSince: string | null } };

export type RestartResearchSandboxMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type RestartResearchSandboxMutation = { __typename?: 'Mutation', restartResearchSandbox: { __typename?: 'RestartResearchSandboxOutput', running: boolean } | null };

export type ResearchConversationTranscriptQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
  before?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ResearchConversationTranscriptQuery = { __typename?: 'Query', researchConversationTranscript: Array<{ __typename?: 'ResearchConversationEvent', _id: string, conversationId: string | null, seq: number | null, claudeMessageUuid: string | null, kind: string | null, payload: any | null, createdAt: string }> };

export type MarkResearchConversationReadMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type MarkResearchConversationReadMutation = { __typename?: 'Mutation', markResearchConversationRead: { __typename?: 'MarkResearchConversationReadOutput', ok: boolean } | null };

export type ResearchConversationBlockInfoQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type ResearchConversationBlockInfoQuery = { __typename?: 'Query', researchConversation: { __typename?: 'SingleResearchConversationOutput', result: { __typename?: 'ResearchConversation', _id: string, title: string | null, presentationHtml: string | null, userTurnCount: number | null } | null } | null };

export type ContinueResearchConversationFromBlockMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
  promptHtml: Scalars['String']['input'];
  activeDocumentId: Scalars['String']['input'];
}>;


export type ContinueResearchConversationFromBlockMutation = { __typename?: 'Mutation', continueResearchConversation: { __typename?: 'ResearchConversationOutput', conversationId: string } | null };

export type CancelResearchConversationFromBlockMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type CancelResearchConversationFromBlockMutation = { __typename?: 'Mutation', cancelResearchConversation: { __typename?: 'ResearchConversationOutput', conversationId: string } | null };

export type MentionTypeaheadProjectResourcesQueryQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type MentionTypeaheadProjectResourcesQueryQuery = { __typename?: 'Query', researchDocuments: { __typename?: 'MultiResearchDocumentOutput', results: Array<{ __typename?: 'ResearchDocument', _id: string, title: string | null, createdAt: string }> } | null, researchConversations: { __typename?: 'MultiResearchConversationOutput', results: Array<{ __typename?: 'ResearchConversation', _id: string, title: string | null, lastActivityAt: string | null }> } | null };

export type ProjectSidebarQueryQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type ProjectSidebarQueryQuery = { __typename?: 'Query', researchProject: { __typename?: 'SingleResearchProjectOutput', result: { __typename?: 'ResearchProject', _id: string, title: string | null } | null } | null, researchDocuments: { __typename?: 'MultiResearchDocumentOutput', results: Array<{ __typename?: 'ResearchDocument', _id: string, title: string | null, icon: string | null, sortOrder: number | null, createdAt: string }> } | null, archivedDocuments: { __typename?: 'MultiResearchDocumentOutput', results: Array<{ __typename?: 'ResearchDocument', _id: string, title: string | null, icon: string | null, createdAt: string }> } | null, researchConversations: { __typename?: 'MultiResearchConversationOutput', results: Array<{ __typename?: 'ResearchConversation', _id: string, title: string | null, icon: string | null, lastActivityAt: string | null, entrypointKind: ResearchEntrypointKind | null, entrypointDocumentId: string | null }> } | null, archivedConversations: { __typename?: 'MultiResearchConversationOutput', results: Array<{ __typename?: 'ResearchConversation', _id: string, title: string | null, icon: string | null, lastActivityAt: string | null, entrypointKind: ResearchEntrypointKind | null, entrypointDocumentId: string | null }> } | null };

export type ResearchEnvironmentsByProjectQueryQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type ResearchEnvironmentsByProjectQueryQuery = { __typename?: 'Query', researchEnvironments: { __typename?: 'MultiResearchEnvironmentOutput', results: Array<{ __typename?: 'ResearchEnvironment', _id: string, label: string | null, sourceEventId: string | null, createdAt: string }> } | null, archivedEnvironments: { __typename?: 'MultiResearchEnvironmentOutput', results: Array<{ __typename?: 'ResearchEnvironment', _id: string, label: string | null, sourceEventId: string | null, createdAt: string }> } | null };

export type multiReviewWinnerArtBestOfLessWrongAdminQueryQueryVariables = Exact<{
  selector?: InputMaybe<ReviewWinnerArtSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiReviewWinnerArtBestOfLessWrongAdminQueryQuery = { __typename?: 'Query', reviewWinnerArts: { __typename?: 'MultiReviewWinnerArtOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ReviewWinnerArt' }
      & ReviewWinnerArtImages
    )> } | null };

export type BestOfLessWrongAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type BestOfLessWrongAdminQuery = { __typename?: 'Query', GetAllReviewWinners: Array<(
    { __typename?: 'Post' }
    & PostsTopItemInfo
  )> };

export type FrontpageBestOfLWWidgetQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FrontpageBestOfLWWidgetQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsListWithVotes
    ) | null } | null };

export type GenerateCoverImagesForPostMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateCoverImagesForPostMutation = { __typename?: 'Mutation', generateCoverImagesForPost: Array<{ __typename?: 'ReviewWinnerArt', _id: string } | null> | null };

export type multiCommentLatestReviewQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentLatestReviewQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type PostNominatedNotificationQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostNominatedNotificationQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type getPostsUserCommentedOnQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PostReviewFilter>;
  sort?: InputMaybe<PostReviewSort>;
}>;


export type getPostsUserCommentedOnQuery = { __typename?: 'Query', PostsUserCommentedOn: { __typename?: 'UserReadHistoryResult', posts: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> | null } | null };

export type ReviewPredictionPostsQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReviewPredictionPostsQuery = { __typename?: 'Query', reviewPredictionPosts: Array<(
    { __typename?: 'Post', annualReviewMarketProbability: number | null, annualReviewMarketUrl: string | null }
    & PostsListWithVotes
  )> };

export type multiPostQuickReviewPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostQuickReviewPageQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsReviewVotingList
    )> } | null };

export type multiPostQuickReviewPage2022QueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostQuickReviewPage2022QueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsReviewVotingList
    )> } | null };

export type multiReviewVoteReviewAdminDashboardQueryQueryVariables = Exact<{
  selector?: InputMaybe<ReviewVoteSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiReviewVoteReviewAdminDashboardQueryQuery = { __typename?: 'Query', reviewVotes: { __typename?: 'MultiReviewVoteOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ReviewVote' }
      & reviewAdminDashboard
    )> } | null };

export type multiCommentReviewPostCommentsQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentReviewPostCommentsQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentWithRepliesFragment
    )> } | null };

export type multiCommentReviewProgressNominationsQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentReviewProgressNominationsQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type multiCommentReviewProgressReviewsQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentReviewProgressReviewsQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type multiReviewVoteReviewProgressVotingQueryQueryVariables = Exact<{
  selector?: InputMaybe<ReviewVoteSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiReviewVoteReviewProgressVotingQueryQuery = { __typename?: 'Query', reviewVotes: { __typename?: 'MultiReviewVoteOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ReviewVote' }
      & reviewVoteFragment
    )> } | null };

export type multiReviewVoteReviewVotingCanvasQueryQueryVariables = Exact<{
  selector?: InputMaybe<ReviewVoteSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiReviewVoteReviewVotingCanvasQueryQuery = { __typename?: 'Query', reviewVotes: { __typename?: 'MultiReviewVoteOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ReviewVote' }
      & reviewVoteFragment
    )> } | null };

export type GivingSeasonHeartsQueryQueryVariables = Exact<{
  electionName: Scalars['String']['input'];
}>;


export type GivingSeasonHeartsQueryQuery = { __typename?: 'Query', GivingSeasonHearts: Array<{ __typename?: 'GivingSeasonHeart', userId: string, displayName: string, x: number, y: number, theta: number }> };

export type AddGivingSeasonHeartMutationVariables = Exact<{
  electionName: Scalars['String']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  theta: Scalars['Float']['input'];
}>;


export type AddGivingSeasonHeartMutation = { __typename?: 'Mutation', AddGivingSeasonHeart: Array<{ __typename?: 'GivingSeasonHeart', userId: string, displayName: string, x: number, y: number, theta: number }> };

export type RemoveGivingSeasonHeartMutationVariables = Exact<{
  electionName: Scalars['String']['input'];
}>;


export type RemoveGivingSeasonHeartMutation = { __typename?: 'Mutation', RemoveGivingSeasonHeart: Array<{ __typename?: 'GivingSeasonHeart', userId: string, displayName: string, x: number, y: number, theta: number }> };

export type ReviewVotingExpandedPostQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReviewVotingExpandedPostQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type multiPostReviewVotingPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostReviewVotingPageQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsReviewVotingList
    )> } | null };

export type submitReviewVoteMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  qualitativeScore?: InputMaybe<Scalars['Int']['input']>;
  quadraticChange?: InputMaybe<Scalars['Int']['input']>;
  newQuadraticScore?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
  dummy?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type submitReviewVoteMutation = { __typename?: 'Mutation', submitReviewVote: (
    { __typename?: 'Post' }
    & PostsReviewVotingList
  ) | null };

export type updateUserReviews2019MutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserReviews2019Mutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersCurrent
    ) | null } | null };

export type multiCommentReviewsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentReviewsListQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type RotatingReviewWinnerSpotlightDisplayQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RotatingReviewWinnerSpotlightDisplayQuery = { __typename?: 'Query', spotlight: { __typename?: 'SingleSpotlightOutput', result: (
      { __typename?: 'Spotlight' }
      & SpotlightDisplay
    ) | null } | null };

export type RotatingReviewWinnerSpotlightQueryVariables = Exact<{ [key: string]: never; }>;


export type RotatingReviewWinnerSpotlightQuery = { __typename?: 'Query', GetAllReviewWinners: Array<{ __typename?: 'Post', reviewWinner: { __typename?: 'ReviewWinner', _id: string, category: string } | null, spotlight: { __typename?: 'Spotlight', _id: string } | null }> };

export type multiCommentSingleLineReviewsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentSingleLineReviewsListQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type multiUserUserReviewsQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserUserReviewsQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & UsersProfile
    )> } | null };

export type createSplashArtCoordinateCoordinateEditorMutationVariables = Exact<{
  data: CreateSplashArtCoordinateDataInput;
}>;


export type createSplashArtCoordinateCoordinateEditorMutation = { __typename?: 'Mutation', createSplashArtCoordinate: { __typename?: 'SplashArtCoordinateOutput', data: (
      { __typename?: 'SplashArtCoordinate' }
      & SplashArtCoordinatesEdit
    ) | null } | null };

export type updateRevisionCompareRevisionsMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateRevisionDataInput;
}>;


export type updateRevisionCompareRevisionsMutation = { __typename?: 'Mutation', updateRevision: { __typename?: 'RevisionOutput', data: (
      { __typename?: 'Revision' }
      & RevisionEdit
    ) | null } | null };

export type RevisionsDiffQueryVariables = Exact<{
  collectionName: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  beforeRev?: InputMaybe<Scalars['String']['input']>;
  afterRev: Scalars['String']['input'];
  trim?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RevisionsDiffQuery = { __typename?: 'Query', RevisionsDiff: string | null };

export type multiRevisionPostsRevisionSelectQueryQueryVariables = Exact<{
  selector?: InputMaybe<RevisionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiRevisionPostsRevisionSelectQueryQuery = { __typename?: 'Query', revisions: { __typename?: 'MultiRevisionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Revision' }
      & RevisionMetadataWithChangeMetrics
    )> } | null };

export type PostsRevisionSelectQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsRevisionSelectQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsDetails
    ) | null } | null };

export type multiRevisionTagPageRevisionSelectQueryQueryVariables = Exact<{
  selector?: InputMaybe<RevisionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiRevisionTagPageRevisionSelectQueryQuery = { __typename?: 'Query', revisions: { __typename?: 'MultiRevisionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Revision' }
      & RevisionHistoryEntry
    )> } | null };

export type multiRSSFeedNewFeedButtonQueryQueryVariables = Exact<{
  selector?: InputMaybe<RSSFeedSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiRSSFeedNewFeedButtonQueryQuery = { __typename?: 'Query', rSSFeeds: { __typename?: 'MultiRSSFeedOutput', totalCount: number | null, results: Array<(
      { __typename?: 'RSSFeed' }
      & RSSFeedMinimumInfo
    )> } | null };

export type createRSSFeedNewFeedButtonMutationVariables = Exact<{
  data: CreateRSSFeedDataInput;
}>;


export type createRSSFeedNewFeedButtonMutation = { __typename?: 'Mutation', createRSSFeed: { __typename?: 'RSSFeedOutput', data: (
      { __typename?: 'RSSFeed' }
      & newRSSFeedFragment
    ) | null } | null };

export type HomepageCommunityMapQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomepageCommunityMapQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type launchPetrovMissileMutationVariables = Exact<{
  launchCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type launchPetrovMissileMutation = { __typename?: 'Mutation', PetrovDayLaunchMissile: { __typename?: 'PetrovDayLaunchMissileData', launchCode: string | null } | null };

export type petrovDayLaunchResolversQueryVariables = Exact<{ [key: string]: never; }>;


export type petrovDayLaunchResolversQuery = { __typename?: 'Query', PetrovDayCheckIfIncoming: { __typename?: 'PetrovDayCheckIfIncomingData', launched: boolean | null, createdAt: string | null } | null };

export type meetupMonthQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type meetupMonthQueryQuery = { __typename?: 'Query', HomepageCommunityEvents: { __typename?: 'HomepageCommunityEventMarkersResult', events: Array<{ __typename?: 'HomepageCommunityEventMarker', _id: string, lat: number, lng: number, types: Array<string> | null }> } };

export type multiPetrovDayActionOptIntoPetrovButtonQueryQueryVariables = Exact<{
  selector?: InputMaybe<PetrovDayActionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPetrovDayActionOptIntoPetrovButtonQueryQuery = { __typename?: 'Query', petrovDayActions: { __typename?: 'MultiPetrovDayActionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'PetrovDayAction' }
      & PetrovDayActionInfo
    )> } | null };

export type createPetrovDayActionOptIntoPetrovButtonMutationVariables = Exact<{
  data: CreatePetrovDayActionDataInput;
}>;


export type createPetrovDayActionOptIntoPetrovButtonMutation = { __typename?: 'Mutation', createPetrovDayAction: { __typename?: 'PetrovDayActionOutput', data: (
      { __typename?: 'PetrovDayAction' }
      & PetrovDayActionInfo
    ) | null } | null };

export type multiPetrovDayActionPetrovAdminConsoleQueryQueryVariables = Exact<{
  selector?: InputMaybe<PetrovDayActionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPetrovDayActionPetrovAdminConsoleQueryQuery = { __typename?: 'Query', petrovDayActions: { __typename?: 'MultiPetrovDayActionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'PetrovDayAction' }
      & PetrovDayActionInfo
    )> } | null };

export type multiPetrovDayActionPetrovGameWrapperQueryQueryVariables = Exact<{
  selector?: InputMaybe<PetrovDayActionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPetrovDayActionPetrovGameWrapperQueryQuery = { __typename?: 'Query', petrovDayActions: { __typename?: 'MultiPetrovDayActionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'PetrovDayAction' }
      & PetrovDayActionInfo
    )> } | null };

export type petrov2024checkIfNukedQueryVariables = Exact<{ [key: string]: never; }>;


export type petrov2024checkIfNukedQuery = { __typename?: 'Query', petrov2024checkIfNuked: boolean | null };

export type multiPetrovDayActionPetrovLaunchConsoleQueryQueryVariables = Exact<{
  selector?: InputMaybe<PetrovDayActionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPetrovDayActionPetrovLaunchConsoleQueryQuery = { __typename?: 'Query', petrovDayActions: { __typename?: 'MultiPetrovDayActionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'PetrovDayAction' }
      & PetrovDayActionInfo
    )> } | null };

export type createPetrovDayActionPetrovLaunchConsoleMutationVariables = Exact<{
  data: CreatePetrovDayActionDataInput;
}>;


export type createPetrovDayActionPetrovLaunchConsoleMutation = { __typename?: 'Mutation', createPetrovDayAction: { __typename?: 'PetrovDayActionOutput', data: (
      { __typename?: 'PetrovDayAction' }
      & PetrovDayActionInfo
    ) | null } | null };

export type multiPetrovDayActionPetrovWarningConsoleQueryQueryVariables = Exact<{
  selector?: InputMaybe<PetrovDayActionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPetrovDayActionPetrovWarningConsoleQueryQuery = { __typename?: 'Query', petrovDayActions: { __typename?: 'MultiPetrovDayActionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'PetrovDayAction' }
      & PetrovDayActionInfo
    )> } | null };

export type createPetrovDayActionPetrovWarningConsoleMutationVariables = Exact<{
  data: CreatePetrovDayActionDataInput;
}>;


export type createPetrovDayActionPetrovWarningConsoleMutation = { __typename?: 'Mutation', createPetrovDayAction: { __typename?: 'PetrovDayActionOutput', data: (
      { __typename?: 'PetrovDayAction' }
      & PetrovDayActionInfo
    ) | null } | null };

export type petrovDay2024ResolversQueryVariables = Exact<{ [key: string]: never; }>;


export type petrovDay2024ResolversQuery = { __typename?: 'Query', PetrovDay2024CheckNumberOfIncoming: { __typename?: 'PetrovDay2024CheckNumberOfIncomingData', count: number | null } | null };

export type HomepageCommunityEventPostsQueryQueryVariables = Exact<{
  eventType: Scalars['String']['input'];
}>;


export type HomepageCommunityEventPostsQueryQuery = { __typename?: 'Query', HomepageCommunityEventPosts: { __typename?: 'HomepageCommunityEventPostsResult', posts: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } };

export type SequenceAddPostRecentPostsQueryVariables = Exact<{
  draftsSelector?: InputMaybe<PostSelector>;
  publishedSelector?: InputMaybe<PostSelector>;
}>;


export type SequenceAddPostRecentPostsQuery = { __typename?: 'Query', drafts: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null, published: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type SequenceEditChaptersQueryVariables = Exact<{
  selector?: InputMaybe<ChapterSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SequenceEditChaptersQuery = { __typename?: 'Query', chapters: { __typename?: 'MultiChapterOutput', results: Array<(
      { __typename?: 'Chapter' }
      & ChaptersEdit
    )> } | null };

export type SequenceEditPostRowQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SequenceEditPostRowQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type updateSequenceSequenceEditorMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateSequenceDataInput;
}>;


export type updateSequenceSequenceEditorMutation = { __typename?: 'Mutation', updateSequence: { __typename?: 'SequenceOutput', data: (
      { __typename?: 'Sequence' }
      & SequencesEdit
    ) | null } | null };

export type updateChapterSequenceEditorMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateChapterDataInput;
}>;


export type updateChapterSequenceEditorMutation = { __typename?: 'Mutation', updateChapter: { __typename?: 'ChapterOutput', data: (
      { __typename?: 'Chapter' }
      & ChaptersEdit
    ) | null } | null };

export type createChapterSequenceEditorMutationVariables = Exact<{
  data: CreateChapterDataInput;
}>;


export type createChapterSequenceEditorMutation = { __typename?: 'Mutation', createChapter: { __typename?: 'ChapterOutput', data: (
      { __typename?: 'Chapter' }
      & ChaptersEdit
    ) | null } | null };

export type deleteChapterSequenceEditorMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
}>;


export type deleteChapterSequenceEditorMutation = { __typename?: 'Mutation', deleteChapter: boolean };

export type moveSequencePostSequenceEditorMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  fromChapterId: Scalars['String']['input'];
  toChapterId: Scalars['String']['input'];
  toIndex: Scalars['Int']['input'];
}>;


export type moveSequencePostSequenceEditorMutation = { __typename?: 'Mutation', moveSequencePost: boolean };

export type updateBookBooksFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateBookDataInput;
}>;


export type updateBookBooksFormMutation = { __typename?: 'Mutation', updateBook: { __typename?: 'BookOutput', data: (
      { __typename?: 'Book' }
      & BookPageFragment
    ) | null } | null };

export type createBookBooksFormMutationVariables = Exact<{
  data: CreateBookDataInput;
}>;


export type createBookBooksFormMutation = { __typename?: 'Mutation', createBook: { __typename?: 'BookOutput', data: (
      { __typename?: 'Book' }
      & BookPageFragment
    ) | null } | null };

export type BooksItemQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type BooksItemQuery = { __typename?: 'Query', book: { __typename?: 'SingleBookOutput', result: (
      { __typename?: 'Book' }
      & BookEdit
    ) | null } | null };

export type GetBookWordCountQueryVariables = Exact<{
  bookId: Scalars['String']['input'];
}>;


export type GetBookWordCountQuery = { __typename?: 'Query', getBookWordCount: number | null };

export type multiChapterChaptersListQueryQueryVariables = Exact<{
  selector?: InputMaybe<ChapterSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiChapterChaptersListQueryQuery = { __typename?: 'Query', chapters: { __typename?: 'MultiChapterOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Chapter' }
      & ChaptersFragment
    )> } | null };

export type updateCollectionCollectionsEditFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCollectionDataInput;
}>;


export type updateCollectionCollectionsEditFormMutation = { __typename?: 'Mutation', updateCollection: { __typename?: 'CollectionOutput', data: (
      { __typename?: 'Collection' }
      & CollectionsPageFragment
    ) | null } | null };

export type CollectionsEditQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CollectionsEditQuery = { __typename?: 'Query', collection: { __typename?: 'SingleCollectionOutput', result: (
      { __typename?: 'Collection' }
      & CollectionsEditFragment
    ) | null } | null };

export type GetSequenceStatsQueryVariables = Exact<{
  sequenceId: Scalars['String']['input'];
}>;


export type GetSequenceStatsQuery = { __typename?: 'Query', getSequenceStats: { __typename?: 'SequenceStats', totalWordCount: number | null, totalReadTime: number | null } | null };

export type multiSequenceSequencesGridWrapperQueryQueryVariables = Exact<{
  selector?: InputMaybe<SequenceSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiSequenceSequencesGridWrapperQueryQuery = { __typename?: 'Query', sequences: { __typename?: 'MultiSequenceOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Sequence' }
      & SequencesPageFragment
    )> } | null };

export type createSequenceSequencesNewFormMutationVariables = Exact<{
  data: CreateSequenceDataInput;
}>;


export type createSequenceSequencesNewFormMutation = { __typename?: 'Mutation', createSequence: { __typename?: 'SequenceOutput', data: { __typename?: 'Sequence', _id: string } | null } | null };

export type SequencesPageQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SequencesPageQuery = { __typename?: 'Query', sequence: { __typename?: 'SingleSequenceOutput', result: (
      { __typename?: 'Sequence' }
      & SequencesPageFragment
    ) | null } | null };

export type SequencesEditQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SequencesEditQuery = { __typename?: 'Query', sequence: { __typename?: 'SingleSequenceOutput', result: (
      { __typename?: 'Sequence' }
      & SequencesEdit
    ) | null } | null };

export type multiChapterSequencesSummaryQueryQueryVariables = Exact<{
  selector?: InputMaybe<ChapterSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiChapterSequencesSummaryQueryQuery = { __typename?: 'Query', chapters: { __typename?: 'MultiChapterOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Chapter' }
      & ChaptersFragment
    )> } | null };

export type SequenceSummaryFragment = { __typename?: 'Sequence', _id: string, title: string, postsCount: number, canonicalCollectionSlug: string | null, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, contents: { __typename?: 'Revision', htmlHighlight: string, wordCount: number } | null };

export type GetAllReviewWinnersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllReviewWinnersQuery = { __typename?: 'Query', GetAllReviewWinners: Array<(
    { __typename?: 'Post' }
    & PostsTopItemInfo
  )> };

export type GetReviewWinnerSpotlightsQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetReviewWinnerSpotlightsQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post', reviewWinner: (
        { __typename?: 'ReviewWinner' }
        & ReviewWinnerTopPostsPage
      ) | null, spotlight: (
        { __typename?: 'Spotlight' }
        & SpotlightDisplay
      ) | null }
      & PostsBase
    )> } | null };

export type CollectionsPageQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CollectionsPageQuery = { __typename?: 'Query', collection: { __typename?: 'SingleCollectionOutput', result: (
      { __typename?: 'Collection' }
      & CollectionsPageFragment
    ) | null } | null };

export type PostsSequenceMetadataQueryQueryVariables = Exact<{
  selector: PostSelector;
}>;


export type PostsSequenceMetadataQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type updateContinueReadingMutationVariables = Exact<{
  sequenceId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;


export type updateContinueReadingMutation = { __typename?: 'Mutation', updateContinueReading: boolean | null };

export type ProfileShortformQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileShortformQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsListWithVotes
    ) | null } | null };

export type multiCommentRepliesToCommentListQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentRepliesToCommentListQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsList
    )> } | null };

export type multiCommentShortformThreadListQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentShortformThreadListQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentWithRepliesFragment
    )> } | null };

export type multiCommentShortformTimeBlockQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentShortformTimeBlockQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & ShortformComments
    )> } | null };

export type DisplaySpotlightQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DisplaySpotlightQueryQuery = { __typename?: 'Query', currentSpotlight: (
    { __typename?: 'Spotlight' }
    & SpotlightDisplay
  ) | null };

export type DisplaySpotlightByIdQueryQueryVariables = Exact<{
  spotlightId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DisplaySpotlightByIdQueryQuery = { __typename?: 'Query', spotlight: { __typename?: 'SingleSpotlightOutput', result: (
      { __typename?: 'Spotlight' }
      & SpotlightDisplay
    ) | null } | null };

export type updateSpotlightSpotlightFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateSpotlightDataInput;
}>;


export type updateSpotlightSpotlightFormMutation = { __typename?: 'Mutation', updateSpotlight: { __typename?: 'SpotlightOutput', data: (
      { __typename?: 'Spotlight' }
      & SpotlightEditQueryFragment
    ) | null } | null };

export type createSpotlightSpotlightFormMutationVariables = Exact<{
  data: CreateSpotlightDataInput;
}>;


export type createSpotlightSpotlightFormMutation = { __typename?: 'Mutation', createSpotlight: { __typename?: 'SpotlightOutput', data: (
      { __typename?: 'Spotlight' }
      & SpotlightEditQueryFragment
    ) | null } | null };

export type multiSpotlightSpotlightHistoryQueryQueryVariables = Exact<{
  selector?: InputMaybe<SpotlightSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiSpotlightSpotlightHistoryQueryQuery = { __typename?: 'Query', spotlights: { __typename?: 'MultiSpotlightOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Spotlight' }
      & SpotlightDisplay
    )> } | null };

export type updateSpotlightSpotlightItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateSpotlightDataInput;
}>;


export type updateSpotlightSpotlightItemMutation = { __typename?: 'Mutation', updateSpotlight: { __typename?: 'SpotlightOutput', data: (
      { __typename?: 'Spotlight' }
      & SpotlightDisplay
    ) | null } | null };

export type SpotlightItemQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SpotlightItemQuery = { __typename?: 'Query', spotlight: { __typename?: 'SingleSpotlightOutput', result: (
      { __typename?: 'Spotlight' }
      & SpotlightEditQueryFragment
    ) | null } | null };

export type SpotlightStartOrContinueReadingQueryQueryVariables = Exact<{
  spotlightId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SpotlightStartOrContinueReadingQueryQuery = { __typename?: 'Query', spotlight: { __typename?: 'SingleSpotlightOutput', result: { __typename?: 'Spotlight', _id: string, sequenceChapters: Array<{ __typename?: 'Chapter', _id: string, posts: Array<(
          { __typename?: 'Post' }
          & PostsList
        )> }> | null } | null } | null };

export type multiSpotlightSpotlightsPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<SpotlightSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiSpotlightSpotlightsPageQueryQuery = { __typename?: 'Query', spotlights: { __typename?: 'MultiSpotlightOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Spotlight' }
      & SpotlightDisplay
    )> } | null };

export type publishAndDeDuplicateSpotlightMutationVariables = Exact<{
  spotlightId?: InputMaybe<Scalars['String']['input']>;
}>;


export type publishAndDeDuplicateSpotlightMutation = { __typename?: 'Mutation', publishAndDeDuplicateSpotlight: (
    { __typename?: 'Spotlight' }
    & SpotlightDisplay
  ) | null };

export type multiSubscriptionFollowUserSearchQueryQueryVariables = Exact<{
  selector?: InputMaybe<SubscriptionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiSubscriptionFollowUserSearchQueryQuery = { __typename?: 'Query', subscriptions: { __typename?: 'MultiSubscriptionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Subscription' }
      & SubscriptionState
    )> } | null };

export type UserFollowingCountQueryVariables = Exact<{
  selector?: InputMaybe<SubscriptionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UserFollowingCountQuery = { __typename?: 'Query', subscriptions: { __typename?: 'MultiSubscriptionOutput', totalCount: number | null } | null };

export type SuggestedFeedSubscriptionUsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuggestedFeedSubscriptionUsersQuery = { __typename?: 'Query', SuggestedFeedSubscriptionUsers: { __typename?: 'SuggestedFeedSubscriptionUsersResult', results: Array<(
      { __typename?: 'User' }
      & UsersMinimumInfo
    )> } | null };

export type updateCommentAFSuggestCommentsItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentAFSuggestCommentsItemMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & SuggestAlignmentComment
    ) | null } | null };

export type multiCommentAFSuggestCommentsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentAFSuggestCommentsListQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & SuggestAlignmentComment
    )> } | null };

export type updatePostAFSuggestPostsItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostAFSuggestPostsItemMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & SuggestAlignmentPost
    ) | null } | null };

export type multiPostAFSuggestPostsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostAFSuggestPostsListQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & SuggestAlignmentPost
    )> } | null };

export type updateUserAFSuggestUsersItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserAFSuggestUsersItemMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & SunshineUsersList
    ) | null } | null };

export type multiUserAFSuggestUsersListQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserAFSuggestUsersListQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & SuggestAlignmentUser
    )> } | null };

export type AllReactedCommentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllReactedCommentsQuery = { __typename?: 'Query', CommentsWithReacts: { __typename?: 'CommentsWithReactsResult', results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type multiLWEventEmailHistoryQueryQueryVariables = Exact<{
  selector?: InputMaybe<LWEventSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiLWEventEmailHistoryQueryQuery = { __typename?: 'Query', lWEvents: { __typename?: 'MultiLWEventOutput', totalCount: number | null, results: Array<(
      { __typename?: 'LWEvent' }
      & emailHistoryFragment
    )> } | null };

export type multiModerationTemplateGroupedTemplateListQueryQueryVariables = Exact<{
  selector?: InputMaybe<ModerationTemplateSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiModerationTemplateGroupedTemplateListQueryQuery = { __typename?: 'Query', moderationTemplates: { __typename?: 'MultiModerationTemplateOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ModerationTemplate' }
      & ModerationTemplateFragment
    )> } | null };

export type updateModerationTemplateGroupedTemplateListMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateModerationTemplateDataInput;
}>;


export type updateModerationTemplateGroupedTemplateListMutation = { __typename?: 'Mutation', updateModerationTemplate: { __typename?: 'ModerationTemplateOutput', data: (
      { __typename?: 'ModerationTemplate' }
      & ModerationTemplateFragment
    ) | null } | null };

export type RunLlmCheckForDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  collectionName: ContentCollectionName;
}>;


export type RunLlmCheckForDocumentMutation = { __typename?: 'Mutation', runLlmCheckForDocument: (
    { __typename?: 'AutomatedContentEvaluation' }
    & AutomatedContentEvaluationsFragment
  ) };

export type multiClientIdModerationAltAccountsQueryQueryVariables = Exact<{
  selector?: InputMaybe<ClientIdSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiClientIdModerationAltAccountsQueryQuery = { __typename?: 'Query', clientIds: { __typename?: 'MultiClientIdOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ClientId' }
      & ModeratorClientIDInfo
    )> } | null };

export type multiUserModerationAltAccountsQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserModerationAltAccountsQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & UserAltAccountsFragment
    )> } | null };

export type ModerationAltAccountsQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ModerationAltAccountsQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UserAltAccountsFragment
    ) | null } | null };

export type ModeratorIPAddressInfoQueryVariables = Exact<{
  ipAddress: Scalars['String']['input'];
}>;


export type ModeratorIPAddressInfoQuery = { __typename?: 'Query', moderatorViewIPAddress: { __typename?: 'ModeratorIPAddressInfo', ip: string, userIds: Array<string> } | null };

export type updateUserModeratorActionsMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserModeratorActionsMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & SunshineUsersList
    ) | null } | null };

export type createModeratorActionMutationVariables = Exact<{
  data: CreateModeratorActionDataInput;
}>;


export type createModeratorActionMutation = { __typename?: 'Mutation', createModeratorAction: { __typename?: 'ModeratorActionOutput', data: (
      { __typename?: 'ModeratorAction' }
      & ModeratorActionDisplay
    ) | null } | null };

export type multiConversationModeratorMessageCountQueryQueryVariables = Exact<{
  selector?: InputMaybe<ConversationSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiConversationModeratorMessageCountQueryQuery = { __typename?: 'Query', conversations: { __typename?: 'MultiConversationOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Conversation' }
      & ConversationsMinimumInfo
    )> } | null };

export type multiUserAltAccountInfoQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserAltAccountInfoQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & SunshineUsersList
    )> } | null };

export type updateModeratorActionModeratorActionItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateModeratorActionDataInput;
}>;


export type updateModeratorActionModeratorActionItemMutation = { __typename?: 'Mutation', updateModeratorAction: { __typename?: 'ModeratorActionOutput', data: (
      { __typename?: 'ModeratorAction' }
      & ModeratorActionDisplay
    ) | null } | null };

export type NewCommentModerationWarningQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewCommentModerationWarningQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type createModeratorActionNewModeratorActionDialogMutationVariables = Exact<{
  data: CreateModeratorActionDataInput;
}>;


export type createModeratorActionNewModeratorActionDialogMutation = { __typename?: 'Mutation', createModeratorAction: { __typename?: 'ModeratorActionOutput', data: (
      { __typename?: 'ModeratorAction' }
      & ModeratorActionDisplay
    ) | null } | null };

export type NewPostModerationWarningQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewPostModerationWarningQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentsList
    ) | null } | null };

export type createReportReportFormMutationVariables = Exact<{
  data: CreateReportDataInput;
}>;


export type createReportReportFormMutation = { __typename?: 'Mutation', createReport: { __typename?: 'ReportOutput', data: (
      { __typename?: 'Report' }
      & UnclaimedReportsList
    ) | null } | null };

export type updatePostSunshineCuratedSuggestionsItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostSunshineCuratedSuggestionsItemMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & SunshineCurationPostsList
    ) | null } | null };

export type multiPostsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostsListQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type multiSunshineCurationPostsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiSunshineCurationPostsListQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & SunshineCurationPostsList
    )> } | null };

export type multiGoogleServiceAccountSessionSunshineGoogleServiceAccountQueryQueryVariables = Exact<{
  selector?: InputMaybe<GoogleServiceAccountSessionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiGoogleServiceAccountSessionSunshineGoogleServiceAccountQueryQuery = { __typename?: 'Query', googleServiceAccountSessions: { __typename?: 'MultiGoogleServiceAccountSessionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'GoogleServiceAccountSession' }
      & GoogleServiceAccountSessionAdminInfo
    )> } | null };

export type updateCommentSunshineNewCommentsItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentSunshineNewCommentsItemMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    ) | null } | null };

export type multiCommentSunshineNewCommentsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type multiCommentSunshineNewCommentsListQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type updatePostSunshineNewPostsItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostSunshineNewPostsItemMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type createModeratorActionSunshineNewPostsItemMutationVariables = Exact<{
  data: CreateModeratorActionDataInput;
}>;


export type createModeratorActionSunshineNewPostsItemMutation = { __typename?: 'Mutation', createModeratorAction: { __typename?: 'ModeratorActionOutput', data: { __typename?: 'ModeratorAction', _id: string } | null } | null };

export type multiPostSunshineNewPostsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostSunshineNewPostsListQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & SunshinePostsList
    )> } | null };

export type multiTagRelSunshineNewTagsItemQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagRelSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagRelSunshineNewTagsItemQueryQuery = { __typename?: 'Query', tagRels: { __typename?: 'MultiTagRelOutput', totalCount: number | null, results: Array<(
      { __typename?: 'TagRel' }
      & TagRelFragment
    )> } | null };

export type updateTagSunshineNewTagsItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateTagDataInput;
}>;


export type updateTagSunshineNewTagsItemMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'TagOutput', data: (
      { __typename?: 'Tag' }
      & SunshineTagFragment
    ) | null } | null };

export type multiTagSunshineNewTagsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagSunshineNewTagsListQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Tag' }
      & SunshineTagFragment
    )> } | null };

export type multiCommentSunshineNewUsersInfoQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentSunshineNewUsersInfoQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    )> } | null };

export type multiUserSunshineNewUsersListQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserSunshineNewUsersListQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & SunshineUsersList
    )> } | null };

export type SunshineNewUsersProfileInfoQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SunshineNewUsersProfileInfoQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & SunshineUsersList
    ) | null } | null };

export type multiReportSunshineReportedContentListQueryQueryVariables = Exact<{
  selector?: InputMaybe<ReportSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiReportSunshineReportedContentListQueryQuery = { __typename?: 'Query', reports: { __typename?: 'MultiReportOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Report' }
      & UnclaimedReportsList
    )> } | null };

export type updatePostSunshineReportedItem1MutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostSunshineReportedItem1Mutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type updateCommentSunshineReportedItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentSunshineReportedItemMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    ) | null } | null };

export type updateReportSunshineReportedContentListMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateReportDataInput;
}>;


export type updateReportSunshineReportedContentListMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'ReportOutput', data: (
      { __typename?: 'Report' }
      & UnclaimedReportsList
    ) | null } | null };

export type multiModerationTemplateSunshineSendMessageWithDefaultsQueryQueryVariables = Exact<{
  selector?: InputMaybe<ModerationTemplateSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiModerationTemplateSunshineSendMessageWithDefaultsQueryQuery = { __typename?: 'Query', moderationTemplates: { __typename?: 'MultiModerationTemplateOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ModerationTemplate' }
      & ModerationTemplateFragment
    )> } | null };

export type multiConversationSunshineUserMessagesQueryQueryVariables = Exact<{
  selector?: InputMaybe<ConversationSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiConversationSunshineUserMessagesQueryQuery = { __typename?: 'Query', conversations: { __typename?: 'MultiConversationOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Conversation' }
      & ConversationsList
    )> } | null };

export type multiUserRateLimitUserRateLimitItemQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserRateLimitSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserRateLimitUserRateLimitItemQueryQuery = { __typename?: 'Query', userRateLimits: { __typename?: 'MultiUserRateLimitOutput', totalCount: number | null, results: Array<(
      { __typename?: 'UserRateLimit' }
      & UserRateLimitDisplay
    )> } | null };

export type updateUserRateLimitUserRateLimitItem1MutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserRateLimitDataInput;
}>;


export type updateUserRateLimitUserRateLimitItem1Mutation = { __typename?: 'Mutation', updateUserRateLimit: { __typename?: 'UserRateLimitOutput', data: (
      { __typename?: 'UserRateLimit' }
      & UserRateLimitMutationFragment
    ) | null } | null };

export type updateUserRateLimitUserRateLimitItemMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserRateLimitDataInput;
}>;


export type updateUserRateLimitUserRateLimitItemMutation = { __typename?: 'Mutation', updateUserRateLimit: { __typename?: 'UserRateLimitOutput', data: (
      { __typename?: 'UserRateLimit' }
      & UserRateLimitDisplay
    ) | null } | null };

export type createUserRateLimitUserRateLimitItem1MutationVariables = Exact<{
  data: CreateUserRateLimitDataInput;
}>;


export type createUserRateLimitUserRateLimitItem1Mutation = { __typename?: 'Mutation', createUserRateLimit: { __typename?: 'UserRateLimitOutput', data: (
      { __typename?: 'UserRateLimit' }
      & UserRateLimitMutationFragment
    ) | null } | null };

export type createUserRateLimitUserRateLimitItemMutationVariables = Exact<{
  data: CreateUserRateLimitDataInput;
}>;


export type createUserRateLimitUserRateLimitItemMutation = { __typename?: 'Mutation', createUserRateLimit: { __typename?: 'UserRateLimitOutput', data: (
      { __typename?: 'UserRateLimit' }
      & UserRateLimitDisplay
    ) | null } | null };

export type CurationPostViewQueryQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type CurationPostViewQueryQuery = { __typename?: 'Query', curationNotices: { __typename?: 'MultiCurationNoticeOutput', results: Array<(
      { __typename?: 'CurationNotice' }
      & CurationNoticesFragment
    )> } | null };

export type ModerationInboxDataQueryQueryVariables = Exact<{
  userSelector?: InputMaybe<UserSelector>;
  postSelector?: InputMaybe<PostSelector>;
  classifiedPostSelector?: InputMaybe<PostSelector>;
  userLimit?: InputMaybe<Scalars['Int']['input']>;
  reviewQueueLimit?: InputMaybe<Scalars['Int']['input']>;
  postLimit?: InputMaybe<Scalars['Int']['input']>;
  curationLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ModerationInboxDataQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', results: Array<(
      { __typename?: 'User' }
      & SunshineUsersList
    )> } | null, reviewQueueUsers: { __typename?: 'MultiUserOutput', results: Array<{ __typename?: 'User', _id: string, reviewGroup: ReviewGroup | null }> } | null, posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & SunshinePostsList
    )> } | null, classifiedPosts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & SunshinePostsList
    )> } | null, CurationCandidatePosts: { __typename?: 'CurationCandidatePostsResult', results: Array<(
      { __typename?: 'Post' }
      & SunshineCurationPostsListItem
    )> } | null, LastCuratedDate: { __typename?: 'LastCuratedDateResult', lastCuratedDate: string | null } };

export type singleUserSupermodQueryQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type singleUserSupermodQueryQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & SunshineUsersList
    ) | null } | null };

export type addOrUpvoteTagModeratorCoreTagsChecklistMutationVariables = Exact<{
  tagId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type addOrUpvoteTagModeratorCoreTagsChecklistMutation = { __typename?: 'Mutation', addOrUpvoteTag: (
    { __typename?: 'TagRel' }
    & TagRelMinimumFragment
  ) | null };

export type performVoteTagRelModeratorCoreTagsChecklistMutationVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type performVoteTagRelModeratorCoreTagsChecklistMutation = { __typename?: 'Mutation', performVoteTagRel: { __typename?: 'VoteResultTagRel', document: (
      { __typename?: 'TagRel' }
      & WithVoteTagRel
    ) } | null };

export type updateUserModeratorNotesMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserModeratorNotesMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & SunshineUsersList
    ) | null } | null };

export type multiModerationTemplateRestrictAndNotifyModalQueryQueryVariables = Exact<{
  selector?: InputMaybe<ModerationTemplateSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiModerationTemplateRestrictAndNotifyModalQueryQuery = { __typename?: 'Query', moderationTemplates: { __typename?: 'MultiModerationTemplateOutput', totalCount: number | null, results: Array<(
      { __typename?: 'ModerationTemplate' }
      & ModerationTemplateFragment
    )> } | null };

export type rejectContentAndRemoveFromQueueRestrictAndNotifyMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  collectionName: ContentCollectionName;
  rejectedReason: Scalars['String']['input'];
  messageContent?: InputMaybe<Scalars['String']['input']>;
}>;


export type rejectContentAndRemoveFromQueueRestrictAndNotifyMutation = { __typename?: 'Mutation', rejectContentAndRemoveUserFromQueue: boolean };

export type updateModeratorActionSupermodMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateModeratorActionDataInput;
}>;


export type updateModeratorActionSupermodMutation = { __typename?: 'Mutation', updateModeratorAction: { __typename?: 'ModeratorActionOutput', data: (
      { __typename?: 'ModeratorAction' }
      & ModeratorActionDisplay
    ) | null } | null };

export type updateUserModerationKeyboardMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserModerationKeyboardMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & SunshineUsersList
    ) | null } | null };

export type rejectContentAndRemoveFromQueueModerationKeyboardMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  collectionName: ContentCollectionName;
  rejectedReason: Scalars['String']['input'];
}>;


export type rejectContentAndRemoveFromQueueModerationKeyboardMutation = { __typename?: 'Mutation', rejectContentAndRemoveUserFromQueue: boolean };

export type approveCurrentContentOnlyModerationKeyboardMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type approveCurrentContentOnlyModerationKeyboardMutation = { __typename?: 'Mutation', approveUserCurrentContentOnly: boolean };

export type updatePostPostReviewActionsMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostPostReviewActionsMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type createModeratorActionPostReviewActionsMutationVariables = Exact<{
  data: CreateModeratorActionDataInput;
}>;


export type createModeratorActionPostReviewActionsMutation = { __typename?: 'Mutation', createModeratorAction: { __typename?: 'ModeratorActionOutput', data: { __typename?: 'ModeratorAction', _id: string } | null } | null };

export type RerunLlmCheckHookMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  collectionName: ContentCollectionName;
}>;


export type RerunLlmCheckHookMutation = { __typename?: 'Mutation', rerunLlmCheck: (
    { __typename?: 'AutomatedContentEvaluation' }
    & AutomatedContentEvaluationsFragment
  ) };

export type updateUserContentPermissionsMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserContentPermissionsMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & SunshineUsersList
    ) | null } | null };

export type createModeratorActionContentPermissionsMutationVariables = Exact<{
  data: CreateModeratorActionDataInput;
}>;


export type createModeratorActionContentPermissionsMutation = { __typename?: 'Mutation', createModeratorAction: { __typename?: 'ModeratorActionOutput', data: { __typename?: 'ModeratorAction', _id: string, type: ModeratorActionType, userId: string, endedAt: string | null } | null } | null };

export type updateModeratorActionContentPermissionsMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateModeratorActionDataInput;
}>;


export type updateModeratorActionContentPermissionsMutation = { __typename?: 'Mutation', updateModeratorAction: { __typename?: 'ModeratorActionOutput', data: { __typename?: 'ModeratorAction', _id: string, type: ModeratorActionType, userId: string, endedAt: string | null } | null } | null };

export type addPostsToTagMutationVariables = Exact<{
  tagId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type addPostsToTagMutation = { __typename?: 'Mutation', addOrUpvoteTag: (
    { __typename?: 'TagRel' }
    & TagRelCreationFragment
  ) | null };

export type AllPostsPageTagRevisionItemQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllPostsPageTagRevisionItemQuery = { __typename?: 'Query', revision: { __typename?: 'SingleRevisionOutput', result: (
      { __typename?: 'Revision' }
      & RevisionHistoryEntry
    ) | null } | null };

export type multiTagAllTagsAlphabeticalQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagAllTagsAlphabeticalQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Tag' }
      & TagPreviewFragment
    )> } | null };

export type AllWikiTagsPageQueryQueryVariables = Exact<{
  slugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AllWikiTagsPageQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & ConceptItemFragment
    )> } | null };

export type multiTagArbitalExplorePageQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  contributorsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type multiTagArbitalExplorePageQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Tag' }
      & ExplorePageTagFragment
    )> } | null };

export type multiTagCoreTagsSectionQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagCoreTagsSectionQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Tag' }
      & TagDetailsFragment
    )> } | null };

export type FilterModeQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FilterModeQuery = { __typename?: 'Query', tag: { __typename?: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagPreviewFragment
    ) | null } | null };

export type multiTagRelFooterTagListQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagRelSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagRelFooterTagListQueryQuery = { __typename?: 'Query', tagRels: { __typename?: 'MultiTagRelOutput', totalCount: number | null, results: Array<(
      { __typename?: 'TagRel' }
      & TagRelMinimumFragment
    )> } | null };

export type addOrUpvoteTagMutationVariables = Exact<{
  tagId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type addOrUpvoteTagMutation = { __typename?: 'Mutation', addOrUpvoteTag: (
    { __typename?: 'TagRel' }
    & TagRelMinimumFragment
  ) | null };

export type multiTagLWTagPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagLWTagPageQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Tag' }
      & TagWithFlagsFragment
    )> } | null };

export type LWTagPageQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LWTagPageQuery = { __typename?: 'Query', tag: { __typename?: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagEditFragment
    ) | null } | null };

export type updateTagNewTagPageMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateTagDataInput;
}>;


export type updateTagNewTagPageMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'TagOutput', data: (
      { __typename?: 'Tag' }
      & TagEditFragment
    ) | null } | null };

export type multiTagNewTagsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagNewTagsListQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Tag' }
      & SunshineTagFragment
    )> } | null };

export type getRandomTagQueryVariables = Exact<{ [key: string]: never; }>;


export type getRandomTagQuery = { __typename?: 'Query', RandomTag: { __typename?: 'Tag', slug: string } };

export type multiMultiDocumentRedlinkTagPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<MultiDocumentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiMultiDocumentRedlinkTagPageQueryQuery = { __typename?: 'Query', multiDocuments: { __typename?: 'MultiMultiDocumentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'MultiDocument' }
      & MultiDocumentMinimumInfo
    )> } | null };

export type multiTagRedlinkTagPageQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagRedlinkTagPageQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Tag' }
      & TagBasicInfo
    )> } | null };

export type multiSubscriptionSubscribeButtonQueryQueryVariables = Exact<{
  selector?: InputMaybe<SubscriptionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiSubscriptionSubscribeButtonQueryQuery = { __typename?: 'Query', subscriptions: { __typename?: 'MultiSubscriptionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Subscription' }
      & SubscriptionState
    )> } | null };

export type createSubscriptionSubscribeButtonMutationVariables = Exact<{
  data: CreateSubscriptionDataInput;
}>;


export type createSubscriptionSubscribeButtonMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'SubscriptionOutput', data: (
      { __typename?: 'Subscription' }
      & SubscriptionState
    ) | null } | null };

export type multiMultiDocumentSummariesEditFormQueryQueryVariables = Exact<{
  selector?: InputMaybe<MultiDocumentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiMultiDocumentSummariesEditFormQueryQuery = { __typename?: 'Query', multiDocuments: { __typename?: 'MultiMultiDocumentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'MultiDocument' }
      & MultiDocumentContentDisplay
    )> } | null };

export type reorderSummariesMutationVariables = Exact<{
  parentDocumentId: Scalars['String']['input'];
  parentDocumentCollectionName: Scalars['String']['input'];
  summaryIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type reorderSummariesMutation = { __typename?: 'Mutation', reorderSummaries: boolean | null };

export type updateMultiDocumentSummaryFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateMultiDocumentDataInput;
}>;


export type updateMultiDocumentSummaryFormMutation = { __typename?: 'Mutation', updateMultiDocument: { __typename?: 'MultiDocumentOutput', data: (
      { __typename?: 'MultiDocument' }
      & MultiDocumentContentDisplay
    ) | null } | null };

export type createMultiDocumentSummaryFormMutationVariables = Exact<{
  data: CreateMultiDocumentDataInput;
}>;


export type createMultiDocumentSummaryFormMutation = { __typename?: 'Mutation', createMultiDocument: { __typename?: 'MultiDocumentOutput', data: (
      { __typename?: 'MultiDocument' }
      & MultiDocumentContentDisplay
    ) | null } | null };

export type multiRevisionTagCompareRevisionsQueryQueryVariables = Exact<{
  selector?: InputMaybe<RevisionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiRevisionTagCompareRevisionsQueryQuery = { __typename?: 'Query', revisions: { __typename?: 'MultiRevisionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Revision' }
      & RevisionHistoryEntry
    )> } | null };

export type TagContributorsListQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagContributorsListQuery = { __typename?: 'Query', tag: { __typename?: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagFullContributorsList
    ) | null } | null };

export type multiCommentTagDiscussionQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentTagDiscussionQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsList
    )> } | null };

export type multiCommentTagDiscussionButtonQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentTagDiscussionButtonQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsList
    )> } | null };

export type multiCommentTagDiscussionSectionQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentTagDiscussionSectionQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsList
    )> } | null };

export type multiRevisionTagEditsByUserQueryQueryVariables = Exact<{
  selector?: InputMaybe<RevisionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiRevisionTagEditsByUserQueryQuery = { __typename?: 'Query', revisions: { __typename?: 'MultiRevisionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Revision' }
      & RevisionTagFragment
    )> } | null };

export type getTagUpdatesQueryVariables = Exact<{
  before: Scalars['Date']['input'];
  after: Scalars['Date']['input'];
}>;


export type getTagUpdatesQuery = { __typename?: 'Query', TagUpdatesInTimeBlock: Array<{ __typename?: 'TagUpdates', revisionIds: Array<string>, commentCount: number, commentIds: Array<string>, lastRevisedAt: string | null, lastCommentedAt: string | null, added: number, removed: number, tag: (
      { __typename?: 'Tag' }
      & TagHistoryFragment
    ), users: Array<(
      { __typename?: 'User' }
      & UsersMinimumInfo
    )>, documentDeletions: Array<{ __typename?: 'DocumentDeletion', userId: string | null, documentId: string, netChange: DocumentDeletionNetChange, type: MultiDocumentType | null, createdAt: string, docFields: { __typename?: 'MultiDocument', _id: string, slug: string, tabTitle: string, tabSubtitle: string | null } | null }> }> };

export type updateTagFlagTagFlagEditAndNewFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateTagFlagDataInput;
}>;


export type updateTagFlagTagFlagEditAndNewFormMutation = { __typename?: 'Mutation', updateTagFlag: { __typename?: 'TagFlagOutput', data: (
      { __typename?: 'TagFlag' }
      & TagFlagFragment
    ) | null } | null };

export type createTagFlagTagFlagEditAndNewFormMutationVariables = Exact<{
  data: CreateTagFlagDataInput;
}>;


export type createTagFlagTagFlagEditAndNewFormMutation = { __typename?: 'Mutation', createTagFlag: { __typename?: 'TagFlagOutput', data: (
      { __typename?: 'TagFlag' }
      & TagFlagFragment
    ) | null } | null };

export type multiTagTagFlagItemQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagTagFlagItemQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Tag' }
      & TagWithFlagsFragment
    )> } | null };

export type TagFlagItemQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagFlagItemQuery = { __typename?: 'Query', tagFlag: { __typename?: 'SingleTagFlagOutput', result: (
      { __typename?: 'TagFlag' }
      & TagFlagFragment
    ) | null } | null };

export type updateTagTagFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateTagDataInput;
}>;


export type updateTagTagFormMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'TagOutput', data: (
      { __typename?: 'Tag' }
      & TagWithFlagsFragment
    ) | null } | null };

export type createTagTagFormMutationVariables = Exact<{
  data: CreateTagDataInput;
}>;


export type createTagTagFormMutation = { __typename?: 'Mutation', createTag: { __typename?: 'TagOutput', data: (
      { __typename?: 'Tag' }
      & TagWithFlagsFragment
    ) | null } | null };

export type multiChapterTagIntroSequenceQueryQueryVariables = Exact<{
  selector?: InputMaybe<ChapterSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiChapterTagIntroSequenceQueryQuery = { __typename?: 'Query', chapters: { __typename?: 'MultiChapterOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Chapter' }
      & ChaptersFragment
    )> } | null };

export type TagMergePageQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagMergePageQuery = { __typename?: 'Query', tag: { __typename?: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagFragment
    ) | null } | null };

export type mergeTagsMutationVariables = Exact<{
  sourceTagId: Scalars['String']['input'];
  targetTagId: Scalars['String']['input'];
  transferSubtags: Scalars['Boolean']['input'];
  redirectSource: Scalars['Boolean']['input'];
}>;


export type mergeTagsMutation = { __typename?: 'Mutation', mergeTags: boolean | null };

export type promoteLensToMainMutationVariables = Exact<{
  lensId: Scalars['String']['input'];
}>;


export type promoteLensToMainMutation = { __typename?: 'Mutation', promoteLensToMain: boolean | null };

export type multiPostTagPreviewQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostTagPreviewQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type TagSearchHitQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagSearchHitQuery = { __typename?: 'Query', tag: { __typename?: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagPreviewFragment
    ) | null } | null };

export type multiVoteTagVoteActivityQueryQueryVariables = Exact<{
  selector?: InputMaybe<VoteSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiVoteTagVoteActivityQueryQuery = { __typename?: 'Query', votes: { __typename?: 'MultiVoteOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Vote' }
      & TagVotingActivity
    )> } | null };

export type multiTagFlagTaggingDashboardQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagFlagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagFlagTaggingDashboardQueryQuery = { __typename?: 'Query', tagFlags: { __typename?: 'MultiTagFlagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'TagFlag' }
      & TagFlagFragment
    )> } | null };

export type multiTagTaggingDashboardQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagTaggingDashboardQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Tag' }
      & TagWithFlagsFragment
    )> } | null };

export type TaggingDashboardQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TaggingDashboardQuery = { __typename?: 'Query', tagFlag: { __typename?: 'SingleTagFlagOutput', result: (
      { __typename?: 'TagFlag' }
      & TagFlagEditFragment
    ) | null } | null };

export type multiTagRelTagsDetailsItemQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagRelSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagRelTagsDetailsItemQueryQuery = { __typename?: 'Query', tagRels: { __typename?: 'MultiTagRelOutput', totalCount: number | null, results: Array<(
      { __typename?: 'TagRel' }
      & TagRelFragment
    )> } | null };

export type TagsDetailsItemQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagsDetailsItemQuery = { __typename?: 'Query', tag: { __typename?: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagEditFragment
    ) | null } | null };

export type GetTagsByCoreTagIdQueryVariables = Exact<{
  coreTagId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetTagsByCoreTagIdQuery = { __typename?: 'Query', TagsByCoreTagId: { __typename?: 'TagWithTotalCount', totalCount: number, tags: Array<(
      { __typename?: 'Tag' }
      & ConceptItemFragment
    )> } };

export type updateMultiDocumentLensFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateMultiDocumentDataInput;
}>;


export type updateMultiDocumentLensFormMutation = { __typename?: 'Mutation', updateMultiDocument: { __typename?: 'MultiDocumentOutput', data: (
      { __typename?: 'MultiDocument' }
      & MultiDocumentEdit
    ) | null } | null };

export type createMultiDocumentLensFormMutationVariables = Exact<{
  data: CreateMultiDocumentDataInput;
}>;


export type createMultiDocumentLensFormMutation = { __typename?: 'Mutation', createMultiDocument: { __typename?: 'MultiDocumentOutput', data: (
      { __typename?: 'MultiDocument' }
      & MultiDocumentEdit
    ) | null } | null };

export type tagBySlugQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type tagBySlugQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & TagFragment
    )> } | null };

export type tagBasicInfoBySlugQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type tagBasicInfoBySlugQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & TagBasicInfo
    )> } | null };

export type allTagsPageBySlugQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type allTagsPageBySlugQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & AllTagsPageFragment
    )> } | null };

export type tagPageBySlugQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  contributorsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type tagPageBySlugQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & TagPageFragment
    )> } | null };

export type tagPageWithRevisionBySlugQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  contributorsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type tagPageWithRevisionBySlugQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & TagPageWithRevisionFragment
    )> } | null };

export type tagEditBySlugQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type tagEditBySlugQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & TagEditFragment
    )> } | null };

export type tagHistoryBySlugQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type tagHistoryBySlugQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & TagHistoryFragment
    )> } | null };

export type tagPageWithArbitalContentBySlugQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  contributorsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type tagPageWithArbitalContentBySlugQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & TagPageWithArbitalContentFragment
    )> } | null };

export type tagPageRevisionWithArbitalContentBySlugQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  contributorsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type tagPageRevisionWithArbitalContentBySlugQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & TagPageRevisionWithArbitalContentFragment
    )> } | null };

export type tagPageWithArbitalContentAndLensRevisionBySlugQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  contributorsLimit?: InputMaybe<Scalars['Int']['input']>;
  lensSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type tagPageWithArbitalContentAndLensRevisionBySlugQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & TagPageWithArbitalContentAndLensRevisionFragment
    )> } | null };

export type multiTagCoreTagsChecklistQueryQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiTagCoreTagsChecklistQueryQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Tag' }
      & TagFragment
    )> } | null };

export type getTagOrLensPreviewQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
}>;


export type getTagOrLensPreviewQuery = { __typename?: 'Query', TagPreview: { __typename?: 'TagPreviewWithSummaries', tag: (
      { __typename?: 'Tag' }
      & TagPreviewFragment
    ), lens: (
      { __typename?: 'MultiDocument' }
      & MultiDocumentContentDisplay
    ) | null, summaries: Array<(
      { __typename?: 'MultiDocument' }
      & MultiDocumentContentDisplay
    )> } | null };

export type getTagOrLensSectionPreviewQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
}>;


export type getTagOrLensSectionPreviewQuery = { __typename?: 'Query', TagPreview: { __typename?: 'TagPreviewWithSummaries', tag: (
      { __typename?: 'Tag' }
      & TagSectionPreviewFragment
    ), lens: (
      { __typename?: 'MultiDocument' }
      & MultiDocumentContentDisplay
    ) | null, summaries: Array<(
      { __typename?: 'MultiDocument' }
      & MultiDocumentContentDisplay
    )> } | null };

export type getTagPreviewQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type getTagPreviewQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & TagPreviewFragment
    )> } | null };

export type getTagSectionPreviewQueryVariables = Exact<{
  selector?: InputMaybe<TagSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
}>;


export type getTagSectionPreviewQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<(
      { __typename?: 'Tag' }
      & TagSectionPreviewFragment
    )> } | null };

export type SequencesPageTitleQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SequencesPageTitleQuery = { __typename?: 'Query', sequence: { __typename?: 'SingleSequenceOutput', result: (
      { __typename?: 'Sequence' }
      & SequencesPageTitleFragment
    ) | null } | null };

export type multiUserUserPageTitleQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserUserPageTitleQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & UsersMinimumInfo
    )> } | null };

export type SingleCommentForFeedbackQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type SingleCommentForFeedbackQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & UltraFeedComment
    ) | null } | null };

export type multiCommentUltraFeedPostDialogQueryQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiCommentUltraFeedPostDialogQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment' }
      & CommentsList
    )> } | null };

export type UltraFeedPostDialogQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UltraFeedPostDialogQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & UltraFeedPostFragment
    ) | null } | null };

export type UltraFeedTargetCommentQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UltraFeedTargetCommentQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentWithRepliesFragment
    ) | null } | null };

export type LocalPostQueryQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type LocalPostQueryQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & UltraFeedPostFragment
    ) | null } | null };

export type UserRecentPostsForCompactCardQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UserRecentPostsForCompactCardQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type UltraFeedThreadItemQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UltraFeedThreadItemQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsListWithVotes
    ) | null } | null };

export type createUltraFeedEventMutationVariables = Exact<{
  data: CreateUltraFeedEventDataInput;
}>;


export type createUltraFeedEventMutation = { __typename?: 'Mutation', createUltraFeedEvent: { __typename?: 'UltraFeedEventOutput', data: { __typename?: 'UltraFeedEvent', _id: string } | null } | null };

export type updateUltraFeedEventMutationVariables = Exact<{
  selector: Scalars['String']['input'];
  data: UpdateUltraFeedEventDataInput;
}>;


export type updateUltraFeedEventMutation = { __typename?: 'Mutation', updateUltraFeedEvent: { __typename?: 'UltraFeedEventOutput', data: { __typename?: 'UltraFeedEvent', _id: string } | null } | null };

export type connectCrossposterMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type connectCrossposterMutation = { __typename?: 'Mutation', connectCrossposter: string | null };

export type useEmailTokenMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type useEmailTokenMutation = { __typename?: 'Mutation', useEmailToken: any | null };

export type sendEventTriggeredDMMutationVariables = Exact<{
  eventType: Scalars['String']['input'];
}>;


export type sendEventTriggeredDMMutation = { __typename?: 'Mutation', sendEventTriggeredDM: boolean };

export type multiPostLWUserTooltipContentQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiPostLWUserTooltipContentQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type userTooltipProfileQueryQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type userTooltipProfileQueryQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersProfile
    ) | null } | null };

export type TopKarmaUsersQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TopKarmaUsersQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & UsersMinimumInfo
    )> } | null };

export type AirtableLeaderboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type AirtableLeaderboardsQuery = { __typename?: 'Query', AirtableLeaderboards: Array<{ __typename?: 'AirtableLeaderboardResult', name: string, leaderboardAmount: number | null }> };

export type getNetKarmaChangesForAuthorsOverPeriodQueryVariables = Exact<{
  days: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type getNetKarmaChangesForAuthorsOverPeriodQuery = { __typename?: 'Query', NetKarmaChangesForAuthorsOverPeriod: Array<{ __typename?: 'NetKarmaChangesForAuthorsOverPeriod', userId: string | null, netKarma: number | null }> };

export type loginMutationVariables = Exact<{
  username?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type loginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginReturnData', token: string | null } | null };

export type signupMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  subscribeToCurated?: InputMaybe<Scalars['Boolean']['input']>;
  reCaptchaToken?: InputMaybe<Scalars['String']['input']>;
  abTestKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type signupMutation = { __typename?: 'Mutation', signup: { __typename?: 'LoginReturnData', token: string | null } | null };

export type resetPasswordMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type resetPasswordMutation = { __typename?: 'Mutation', resetPassword: string | null };

export type usePasswordResetEmailTokenMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  args?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type usePasswordResetEmailTokenMutation = { __typename?: 'Mutation', useEmailToken: any | null };

export type multiSubscriptionSubscriptionsListQueryQueryVariables = Exact<{
  selector?: InputMaybe<SubscriptionSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiSubscriptionSubscriptionsListQueryQuery = { __typename?: 'Query', subscriptions: { __typename?: 'MultiSubscriptionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Subscription' }
      & SubscriptionState
    )> } | null };

export type UserContentFeedPostsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  sortedBy: Scalars['String']['input'];
}>;


export type UserContentFeedPostsQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsListWithVotes
    )> } | null };

export type UserContentFeedCommentsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  sortBy: Scalars['String']['input'];
}>;


export type UserContentFeedCommentsQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Comment', post: (
        { __typename?: 'Post' }
        & PostsListWithVotes
      ) | null, topLevelComment: (
        { __typename?: 'Comment' }
        & CommentsListWithTopLevelComment
      ) | null }
      & CommentsList
    )> } | null };

export type UserContentFeedWikiEditsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type UserContentFeedWikiEditsQuery = { __typename?: 'Query', revisions: { __typename?: 'MultiRevisionOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Revision' }
      & RevisionTagFragment
    )> } | null };

export type UserContentFeedThreadQueryVariables = Exact<{
  topLevelCommentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserContentFeedThreadQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<(
      { __typename?: 'Comment' }
      & UltraFeedComment
    )> } | null };

export type UsersNameWrapperQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersNameWrapperQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null };

export type multiUserUsersProfileQueryQueryVariables = Exact<{
  selector?: InputMaybe<UserSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type multiUserUsersProfileQueryQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', totalCount: number | null, results: Array<(
      { __typename?: 'User' }
      & UsersProfile
    )> } | null };

export type updateUserDeactivateAccountSectionMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserDeactivateAccountSectionMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersEdit
    ) | null } | null };

export type updateUserDeleteAccountSectionMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserDeleteAccountSectionMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersEdit
    ) | null } | null };

export type UsersSearchForMergeQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type UsersSearchForMergeQuery = { __typename?: 'Query', UsersSearchForMerge: Array<(
    { __typename?: 'User' }
    & UsersMergeSearchResult
  )> };

export type MergeAccountsMutationVariables = Exact<{
  sourceUserId: Scalars['String']['input'];
  targetUserId: Scalars['String']['input'];
  dryRun: Scalars['Boolean']['input'];
}>;


export type MergeAccountsMutation = { __typename?: 'Mutation', MergeAccounts: { __typename?: 'MergeAccountsResult', completed: boolean, success: boolean, failures: Array<{ __typename?: 'MergeAccountsFailure', stage: string, message: string, collectionName: string | null, documentId: string | null }> } };

export type SoftDeleteUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type SoftDeleteUserMutation = { __typename?: 'Mutation', SoftDeleteUser: boolean };

export type UserTopPostsForManagerQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserTopPostsForManagerQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & PostsList
    )> } | null };

export type UsersAccountTargetUserQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UsersAccountTargetUserQuery = { __typename?: 'Query', GetUserBySlug: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null };

export type UsersAccountManagementGetUserBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UsersAccountManagementGetUserBySlugQuery = { __typename?: 'Query', GetUserBySlug: (
    { __typename?: 'User' }
    & UsersEdit
  ) | null };

export type UsersEditFormGetUserBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UsersEditFormGetUserBySlugQuery = { __typename?: 'Query', GetUserBySlug: (
    { __typename?: 'User' }
    & UsersEdit
  ) | null };

export type updateUserAutoSavedSettingsMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserAutoSavedSettingsMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersEdit
    ) | null } | null };

export type KarmaChangeNotifierQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type KarmaChangeNotifierQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UserKarmaChanges
    ) | null } | null };

export type karmaChangesCheckedKarmaChangeNotifierMutationVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type karmaChangesCheckedKarmaChangeNotifierMutation = { __typename?: 'Mutation', karmaChangesChecked: boolean };

export type KarmaChangePostBodiesQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type KarmaChangePostBodiesQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<{ __typename?: 'Post', _id: string, contents: { __typename?: 'Revision', _id: string, htmlHighlight: string } | null }> } | null };

export type KarmaChangeCommentBodiesQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type KarmaChangeCommentBodiesQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<{ __typename?: 'Comment', _id: string, contents: { __typename?: 'Revision', _id: string, html: string | null } | null }> } | null };

export type SubscribedUserQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type SubscribedUserQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null };

export type SubscribedPostQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type SubscribedPostQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type SubscribedCommentQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type SubscribedCommentQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    ) | null } | null };

export type SubscribedLocalgroupQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type SubscribedLocalgroupQuery = { __typename?: 'Query', localgroup: { __typename?: 'SingleLocalgroupOutput', result: (
      { __typename?: 'Localgroup' }
      & localGroupsBase
    ) | null } | null };

export type SubscribedTagQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type SubscribedTagQuery = { __typename?: 'Query', tag: { __typename?: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagPreviewFragment
    ) | null } | null };

export type SubscribedSequenceQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type SubscribedSequenceQuery = { __typename?: 'Query', sequence: { __typename?: 'SingleSequenceOutput', result: (
      { __typename?: 'Sequence' }
      & SequencesPageTitleFragment
    ) | null } | null };

export type updateUserReactionsPaletteMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateUserDataInput;
}>;


export type updateUserReactionsPaletteMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', data: (
      { __typename?: 'User' }
      & UsersCurrent
    ) | null } | null };

export type performVoteCommentMutationVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type performVoteCommentMutation = { __typename?: 'Mutation', performVoteComment: { __typename?: 'VoteResultComment', showVotingPatternWarning: boolean, document: (
      { __typename?: 'Comment' }
      & WithVoteComment
    ) } | null };

export type performVotePostMutationVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type performVotePostMutation = { __typename?: 'Mutation', performVotePost: { __typename?: 'VoteResultPost', showVotingPatternWarning: boolean, document: (
      { __typename?: 'Post' }
      & WithVotePost
    ) } | null };

export type performVoteTagRelMutationVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type performVoteTagRelMutation = { __typename?: 'Mutation', performVoteTagRel: { __typename?: 'VoteResultTagRel', showVotingPatternWarning: boolean, document: (
      { __typename?: 'TagRel' }
      & WithVoteTagRel
    ) } | null };

export type performVoteRevisionMutationVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type performVoteRevisionMutation = { __typename?: 'Mutation', performVoteRevision: { __typename?: 'VoteResultRevision', showVotingPatternWarning: boolean, document: (
      { __typename?: 'Revision' }
      & WithVoteRevision
    ) } | null };

export type performVoteTagMutationVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type performVoteTagMutation = { __typename?: 'Mutation', performVoteTag: { __typename?: 'VoteResultTag', showVotingPatternWarning: boolean, document: (
      { __typename?: 'Tag' }
      & WithVoteTag
    ) } | null };

export type performVoteMultiDocumentMutationVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type performVoteMultiDocumentMutation = { __typename?: 'Mutation', performVoteMultiDocument: { __typename?: 'VoteResultMultiDocument', showVotingPatternWarning: boolean, document: (
      { __typename?: 'MultiDocument' }
      & WithVoteMultiDocument
    ) } | null };

export type performVoteMessageMutationVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<Scalars['String']['input']>;
  extendedVote?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type performVoteMessageMutation = { __typename?: 'Mutation', performVoteMessage: { __typename?: 'VoteResultMessage', showVotingPatternWarning: boolean, document: (
      { __typename?: 'Message' }
      & WithVoteMessage
    ) } | null };

export type emailstestsQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type emailstestsQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsRevision
    ) | null } | null };

export type updateCommentCommentsNewFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdateCommentDataInput;
}>;


export type updateCommentCommentsNewFormMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentOutput', data: (
      { __typename?: 'Comment' }
      & SuggestAlignmentComment
    ) | null } | null };

export type updatePostPostsEditFormMutationVariables = Exact<{
  selector: SelectorInput;
  data: UpdatePostDataInput;
}>;


export type updatePostPostsEditFormMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostOutput', data: (
      { __typename?: 'Post' }
      & SuggestAlignmentPost
    ) | null } | null };

export type AutomatedContentEvaluationsFragment = { __typename?: 'AutomatedContentEvaluation', _id: string, score: number | null, aiChoice: string | null, aiReasoning: string | null, aiCoT: string | null, pangramApiVersion: string | null, pangramScore: number | null, pangramFractionAi: number | null, pangramFractionAiAssisted: number | null, pangramFractionHuman: number | null, pangramMaxScore: number | null, pangramPrediction: string | null, sentenceScores: Array<{ __typename?: 'SentenceScore', sentence: string, score: number }> | null, pangramWindowScores: Array<{ __typename?: 'PangramWindowScore', text: string, score: number, startIndex: number, endIndex: number, label: string | null, confidence: string | null, wordCount: number | null }> | null };

export type BookmarksMinimumInfoFragment = { __typename?: 'Bookmark', _id: string, active: boolean };

export type BookmarksWithDocumentFragment = (
  { __typename?: 'Bookmark', post: (
    { __typename?: 'Post' }
    & PostsListWithVotes
  ) | null }
  & BookmarksMinimumInfoFragment
);

export type BookmarksFeedItemFragment = (
  { __typename?: 'Bookmark', collectionName: string, lastUpdated: string, post: (
    { __typename?: 'Post' }
    & PostsListWithVotes
  ) | null, comment: (
    { __typename?: 'Comment' }
    & UltraFeedComment
  ) | null }
  & BookmarksMinimumInfoFragment
);

export type BookPageFragment = { __typename?: 'Book', _id: string, createdAt: string, title: string | null, number: number | null, subtitle: string | null, tocTitle: string | null, sequenceIds: Array<string>, postIds: Array<string>, collectionId: string, displaySequencesAsGrid: boolean | null, hideProgressBar: boolean | null, showChapters: boolean | null, contents: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null, sequences: Array<(
    { __typename?: 'Sequence' }
    & SequencesPageWithChaptersFragment
  )>, posts: Array<(
    { __typename?: 'Post' }
    & PostsListWithVotes
  )> };

export type BookEdit = (
  { __typename?: 'Book', contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & BookPageFragment
);

export type ChaptersFragment = { __typename?: 'Chapter', _id: string, createdAt: string, title: string | null, subtitle: string | null, number: number | null, sequenceId: string | null, postIds: Array<string>, contents: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null, posts: Array<(
    { __typename?: 'Post' }
    & PostsListWithVotes
  )> };

export type SlimChapter = { __typename?: 'Chapter', _id: string, createdAt: string, title: string | null, subtitle: string | null, number: number | null, sequenceId: string | null, postIds: Array<string>, contents: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null, posts: Array<(
    { __typename?: 'Post' }
    & ChapterPostSlim
  )> };

export type ChaptersEdit = (
  { __typename?: 'Chapter', contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & ChaptersFragment
);

export type CkEditorUserSessionInfo = { __typename?: 'CkEditorUserSession', _id: string, userId: string | null, documentId: string | null, endedAt: string | null, endedBy: string | null };

export type ModeratorClientIDInfo = { __typename?: 'ClientId', _id: string, clientId: string | null, createdAt: string | null, firstSeenReferrer: string | null, firstSeenLandingPage: string | null, users: Array<(
    { __typename?: 'User' }
    & UsersMinimumInfo
  )> | null };

export type CollectionContinueReadingFragment = { __typename?: 'Collection', _id: string, title: string, slug: string, gridImageId: string | null };

export type CollectionsPageFragment = { __typename?: 'Collection', _id: string, createdAt: string, slug: string, userId: string, title: string, firstPageLink: string, gridImageId: string | null, hideStartReadingButton: boolean | null, noindex: boolean, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, contents: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null, books: Array<(
    { __typename?: 'Book' }
    & BookPageFragment
  )> };

export type CollectionsEditFragment = (
  { __typename?: 'Collection', contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & CollectionsPageFragment
);

export type CommentsList = { __typename?: 'Comment', _id: string, postId: string | null, tagId: string | null, relevantTagIds: Array<string>, tagCommentType: TagCommentType, parentCommentId: string | null, topLevelCommentId: string | null, descendentCount: number, title: string | null, postedAt: string, lastEditedAt: string | null, repliesBlockedUntil: string | null, userId: string, draft: boolean, deleted: boolean, deletedPublic: boolean, deletedByUserId: string | null, deletedReason: string | null, hideAuthor: boolean, authorIsUnreviewed: boolean, currentUserVote: string | null, currentUserExtendedVote: any | null, isBookmarked: boolean, baseScore: number | null, extendedScore: any | null, score: number, voteCount: number, af: boolean, afDate: string | null, moveToAlignmentUserId: string | null, afBaseScore: number | null, afExtendedScore: any | null, suggestForAlignmentUserIds: Array<string>, reviewForAlignmentUserId: string | null, needsReview: boolean | null, answer: boolean, parentAnswerId: string | null, retracted: boolean, postVersion: string | null, reviewedByUserId: string | null, shortform: boolean | null, shortformFrontpage: boolean, lastSubthreadActivity: string | null, moderatorHat: boolean, hideModeratorHat: boolean | null, nominatedForReview: string | null, reviewingForReview: string | null, promoted: boolean | null, directChildrenCount: number, votingSystem: string, isPinnedOnProfile: boolean, debateResponse: boolean | null, rejected: boolean, rejectedReason: string | null, originalDialogueId: string | null, tag: { __typename?: 'Tag', _id: string, slug: string } | null, relevantTags: Array<(
    { __typename?: 'Tag' }
    & TagPreviewFragment
  )>, contents: { __typename?: 'Revision', _id: string, html: string | null, plaintextMainText: string, wordCount: number } | null, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, promotedByUser: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null };

export type CommentsListWithTopLevelComment = (
  { __typename?: 'Comment', topLevelComment: (
    { __typename?: 'Comment' }
    & CommentsList
  ) | null }
  & CommentsList
);

export type UltraFeedComment = (
  { __typename?: 'Comment', post: (
    { __typename?: 'Post' }
    & PostsListWithVotes
  ) | null }
  & CommentsList
);

export type ShortformComments = (
  { __typename?: 'Comment', post: (
    { __typename?: 'Post' }
    & PostsMinimumInfo
  ) | null, relevantTags: Array<(
    { __typename?: 'Tag' }
    & TagPreviewFragment
  )> }
  & CommentsList
);

export type FrontpageShortformComments = (
  { __typename?: 'Comment', latestChildren: Array<{ __typename?: 'Comment', _id: string, postedAt: string, user: { __typename?: 'User', _id: string, displayName: string } | null }> }
  & ShortformComments
);

export type DraftComments = (
  { __typename?: 'Comment', post: (
    { __typename?: 'Post' }
    & PostsMinimumInfo
  ) | null, parentComment: { __typename?: 'Comment', _id: string, user: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null }
  & CommentsList
);

export type CommentWithRepliesFragment = (
  { __typename?: 'Comment', lastSubthreadActivity: string | null, latestChildren: Array<(
    { __typename?: 'Comment' }
    & CommentsList
  )>, tag: (
    { __typename?: 'Tag' }
    & TagBasicInfo
  ) | null, post: (
    { __typename?: 'Post' }
    & PostsBase
  ) | null }
  & CommentsList
);

export type CommentEdit = (
  { __typename?: 'Comment', relevantTagIds: Array<string>, contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & CommentsList
);

export type DeletedCommentsMetaData = { __typename?: 'Comment', _id: string, deleted: boolean, deletedDate: string | null, deletedReason: string | null, deletedPublic: boolean, deletedByUser: { __typename?: 'User', _id: string, displayName: string } | null };

export type CommentsListWithParentMetadata = (
  { __typename?: 'Comment', post: (
    { __typename?: 'Post', isRead: boolean | null }
    & PostsMinimumInfo
  ) | null, tag: (
    { __typename?: 'Tag' }
    & TagBasicInfo
  ) | null }
  & CommentsList
);

export type SunshineCommentsList = (
  { __typename?: 'Comment', automatedContentEvaluations: (
    { __typename?: 'AutomatedContentEvaluation' }
    & AutomatedContentEvaluationsFragment
  ) | null }
  & CommentsListWithParentMetadata
);

export type WithVoteComment = { __typename: 'Comment', _id: string, currentUserVote: string | null, currentUserExtendedVote: any | null, baseScore: number | null, extendedScore: any | null, score: number, afBaseScore: number | null, afExtendedScore: any | null, voteCount: number };

export type CommentsForAutocomplete = { __typename?: 'Comment', _id: string, postId: string | null, baseScore: number | null, extendedScore: any | null, createdAt: string | null, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, contents: { __typename?: 'Revision', markdown: string | null } | null, post: (
    { __typename?: 'Post' }
    & PostsForAutocomplete
  ) | null };

export type CommentsForAutocompleteWithParents = (
  { __typename?: 'Comment', parentComment: (
    { __typename?: 'Comment', parentComment: (
      { __typename?: 'Comment', parentComment: (
        { __typename?: 'Comment', parentComment: (
          { __typename?: 'Comment', parentComment: (
            { __typename?: 'Comment', parentComment: (
              { __typename?: 'Comment', parentComment: (
                { __typename?: 'Comment', parentComment: (
                  { __typename?: 'Comment', parentComment: (
                    { __typename?: 'Comment', parentComment: (
                      { __typename?: 'Comment' }
                      & CommentsForAutocomplete
                    ) | null }
                    & CommentsForAutocomplete
                  ) | null }
                  & CommentsForAutocomplete
                ) | null }
                & CommentsForAutocomplete
              ) | null }
              & CommentsForAutocomplete
            ) | null }
            & CommentsForAutocomplete
          ) | null }
          & CommentsForAutocomplete
        ) | null }
        & CommentsForAutocomplete
      ) | null }
      & CommentsForAutocomplete
    ) | null }
    & CommentsForAutocomplete
  ) | null }
  & CommentsForAutocomplete
);

export type SuggestAlignmentComment = (
  { __typename?: 'Comment', suggestForAlignmentUserIds: Array<string>, post: (
    { __typename?: 'Post' }
    & PostsMinimumInfo
  ) | null, suggestForAlignmentUsers: Array<{ __typename?: 'User', _id: string, displayName: string }> }
  & CommentsList
);

export type CommentsMarkdownFragment = { __typename?: 'Comment', _id: string, postId: string | null, parentCommentId: string | null, postedAt: string, baseScore: number | null, voteCount: number, votingSystem: string, extendedScore: any | null, user: { __typename?: 'User', _id: string, slug: string, displayName: string } | null, contents: { __typename?: 'Revision', agentMarkdown: string | null, plaintextMainText: string } | null };

export type ConversationsMinimumInfo = { __typename?: 'Conversation', _id: string, createdAt: string | null, latestActivity: string | null, title: string | null, participantIds: Array<string> | null, archivedByIds: Array<string>, messageCount: number, moderator: boolean | null };

export type ConversationsList = (
  { __typename?: 'Conversation', participants: Array<(
    { __typename?: 'User' }
    & UsersMinimumInfo
  )> | null, latestMessage: (
    { __typename?: 'Message' }
    & messageListFragment
  ) | null }
  & ConversationsMinimumInfo
);

export type ConversationsListWithReadStatus = (
  { __typename?: 'Conversation', hasUnreadMessages: boolean | null }
  & ConversationsList
);

export type CurationNoticesFragment = { __typename?: 'CurationNotice', _id: string, createdAt: string, userId: string, commentId: string | null, postId: string, deleted: boolean, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, comment: (
    { __typename?: 'Comment' }
    & CommentsList
  ) | null, post: (
    { __typename?: 'Post' }
    & PostsMinimumInfo
  ) | null, contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null };

export type ElicitQuestionFragment = { __typename?: 'ElicitQuestion', _id: string, title: string, notes: string | null, resolution: string | null, resolvesBy: string | null };

export type FieldChangeFragment = { __typename?: 'FieldChange', _id: string, createdAt: string, userId: string | null, changeGroup: string | null, documentId: string | null, fieldName: string | null, oldValue: any | null, newValue: any | null };

export type GoogleServiceAccountSessionAdminInfo = { __typename?: 'GoogleServiceAccountSession', _id: string, email: string | null, estimatedExpiry: string | null };

export type JargonTerms = { __typename?: 'JargonTerm', _id: string, postId: string, term: string, humansAndOrAIEdited: string | null, approved: boolean, deleted: boolean, altTerms: Array<string>, contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null };

export type JargonTermsPost = { __typename?: 'JargonTerm', _id: string, term: string, humansAndOrAIEdited: string | null, approved: boolean, deleted: boolean, altTerms: Array<string>, contents: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null };

export type LlmConversationsFragment = { __typename?: 'LlmConversation', _id: string, userId: string | null, title: string | null, createdAt: string, lastUpdatedAt: string | null, deleted: boolean | null };

export type LlmConversationsViewingPageFragment = (
  { __typename?: 'LlmConversation', totalCharacterCount: number | null, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null }
  & LlmConversationsFragment
);

export type LlmConversationsWithMessagesFragment = (
  { __typename?: 'LlmConversation', messages: Array<(
    { __typename?: 'LlmMessage' }
    & LlmMessagesFragment
  )> | null }
  & LlmConversationsFragment
);

export type LlmMessagesFragment = { __typename?: 'LlmMessage', _id: string, userId: string | null, conversationId: string | null, role: string | null, content: string | null, createdAt: string };

export type localGroupsBase = { __typename?: 'Localgroup', _id: string, createdAt: string, organizerIds: Array<string>, lastActivity: string, name: string, nameInAnotherLanguage: string | null, isOnline: boolean, location: string | null, googleLocation: any | null, mongoLocation: any | null, types: Array<string>, categories: Array<string> | null, contactInfo: string | null, facebookLink: string | null, facebookPageLink: string | null, meetupLink: string | null, slackLink: string | null, website: string | null, bannerImageId: string | null, inactive: boolean, deleted: boolean, organizers: Array<(
    { __typename?: 'User' }
    & UsersMinimumInfo
  )> };

export type localGroupsHomeFragment = (
  { __typename?: 'Localgroup', contents: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null }
  & localGroupsBase
);

export type localGroupsEdit = (
  { __typename?: 'Localgroup', contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & localGroupsBase
);

export type localGroupsIsOnline = { __typename?: 'Localgroup', _id: string, name: string, isOnline: boolean };

export type newEventFragment = { __typename?: 'LWEvent', _id: string, createdAt: string | null, userId: string | null, name: string | null, important: boolean | null, properties: any | null, intercom: boolean | null };

export type lastEventFragment = { __typename?: 'LWEvent', _id: string, createdAt: string | null, documentId: string | null, userId: string | null, name: string | null, important: boolean | null, properties: any | null, intercom: boolean | null };

export type emailHistoryFragment = { __typename?: 'LWEvent', _id: string, createdAt: string | null, userId: string | null, name: string | null, properties: any | null };

export type messageListFragment = { __typename?: 'Message', _id: string, createdAt: string | null, conversationId: string | null, voteCount: number, baseScore: number, score: number, extendedScore: any | null, currentUserVote: string | null, currentUserExtendedVote: any | null, user: (
    { __typename?: 'User', profileImageId: string | null }
    & UsersMinimumInfo
  ) | null, contents: { __typename?: 'Revision', html: string | null, plaintextMainText: string } | null };

export type WithVoteMessage = { __typename: 'Message', _id: string, score: number, baseScore: number, extendedScore: any | null, afBaseScore: number | null, voteCount: number, currentUserVote: string | null, currentUserExtendedVote: any | null };

export type ModerationTemplateFragment = { __typename?: 'ModerationTemplate', _id: string, name: string, collectionName: ModerationTemplateType, order: number, groupLabel: string | null, deleted: boolean, contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null };

export type ModeratorActionDisplay = { __typename?: 'ModeratorAction', _id: string, userId: string, type: ModeratorActionType, active: boolean, createdAt: string, endedAt: string | null, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null };

export type MultiDocumentMinimumInfo = { __typename?: 'MultiDocument', _id: string, parentDocumentId: string, collectionName: MultiDocumentCollectionName, fieldName: MultiDocumentFieldName, userId: string, slug: string, oldSlugs: Array<string>, title: string | null, tabTitle: string, tabSubtitle: string | null, preview: string | null, index: number, deleted: boolean, createdAt: string, legacyData: any | null, baseScore: number, extendedScore: any | null, score: number, afBaseScore: number | null, afExtendedScore: any | null, voteCount: number, currentUserVote: string | null, currentUserExtendedVote: any | null };

export type MultiDocumentContentDisplay = (
  { __typename?: 'MultiDocument', tableOfContents: any | null, textLastUpdatedAt: string | null, contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & MultiDocumentMinimumInfo
);

export type MultiDocumentEdit = (
  { __typename?: 'MultiDocument', textLastUpdatedAt: string | null, arbitalLinkedPages: (
    { __typename?: 'ArbitalLinkedPages' }
    & ArbitalLinkedPagesFragment
  ) | null, summaries: Array<(
    { __typename?: 'MultiDocument' }
    & MultiDocumentContentDisplay
  )> }
  & MultiDocumentContentDisplay
);

export type MultiDocumentParentDocument = (
  { __typename?: 'MultiDocument', parentTag: (
    { __typename?: 'Tag' }
    & TagHistoryFragment
  ) | null }
  & MultiDocumentEdit
);

export type MultiDocumentWithContributors = (
  { __typename?: 'MultiDocument', contributors: { __typename?: 'TagContributorsList', totalCount: number, contributors: Array<{ __typename?: 'TagContributor', currentAttributionCharCount: number | null, user: (
        { __typename?: 'User' }
        & UsersMinimumInfo
      ) | null }> } | null }
  & MultiDocumentEdit
);

export type MultiDocumentRevision = (
  { __typename?: 'MultiDocument', tableOfContents: any | null, contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & MultiDocumentMinimumInfo
);

export type MultiDocumentWithContributorsRevision = (
  { __typename?: 'MultiDocument', textLastUpdatedAt: string | null, contributors: { __typename?: 'TagContributorsList', totalCount: number, contributors: Array<{ __typename?: 'TagContributor', currentAttributionCharCount: number | null, contributionScore: number, user: (
        { __typename?: 'User' }
        & UsersMinimumInfo
      ) | null }> } | null, arbitalLinkedPages: (
    { __typename?: 'ArbitalLinkedPages' }
    & ArbitalLinkedPagesFragment
  ) | null }
  & MultiDocumentRevision
);

export type WithVoteMultiDocument = (
  { __typename?: 'MultiDocument' }
  & MultiDocumentMinimumInfo
);

export type NotificationsList = { __typename?: 'Notification', _id: string, documentId: string | null, documentType: string | null, deleted: boolean | null, userId: string | null, createdAt: string | null, link: string | null, message: string | null, type: string | null, viewed: boolean | null, extraData: any | null };

export type PetrovDayActionInfo = { __typename?: 'PetrovDayAction', _id: string, createdAt: string, userId: string | null, actionType: string, data: any | null };

export type PodcastEpisodeCreateFragment = { __typename?: 'PodcastEpisode', _id: string, schemaVersion: number, createdAt: string, legacyData: any | null, podcastId: string, title: string, episodeLink: string, externalEpisodeId: string };

export type PodcastEpisodeFull = { __typename?: 'PodcastEpisode', _id: string, podcastId: string, title: string, episodeLink: string, externalEpisodeId: string };

export type PodcastSelect = { __typename?: 'Podcast', _id: string, title: string };

export type PostsMinimumInfo = { __typename?: 'Post', _id: string, slug: string, title: string, draft: boolean | null, shortform: boolean, hideCommentKarma: boolean, af: boolean, userId: string | null, coauthorUserIds: Array<string>, rejected: boolean, collabEditorDialogue: boolean };

export type PostsTopItemInfo = (
  { __typename?: 'Post', isRead: boolean | null, user: { __typename?: 'User', _id: string, displayName: string } | null, reviewWinner: (
    { __typename?: 'ReviewWinner' }
    & ReviewWinnerTopPostsPage
  ) | null }
  & PostsMinimumInfo
);

export type PostsBase = (
  { __typename?: 'Post', url: string | null, postedAt: string, sticky: boolean, metaSticky: boolean, stickyPriority: number, status: number, frontpageDate: string | null, meta: boolean, deletedDraft: boolean, postCategory: PostCategory, tagRelevance: any | null, shareWithUsers: Array<string> | null, sharingSettings: any | null, linkSharingKey: string | null, contents_latest: string | null, commentCount: number, voteCount: number, baseScore: number, extendedScore: any | null, unlisted: boolean, score: number, lastVisitedAt: string | null, isFuture: boolean, isRead: boolean | null, lastCommentedAt: string, lastCommentPromotedAt: string | null, canonicalCollectionSlug: string | null, curatedDate: string | null, commentsLocked: boolean | null, commentsLockedToAccountsCreatedAfter: string | null, debate: boolean, question: boolean, hiddenRelatedQuestion: boolean, originalPostRelationSourceId: string | null, userId: string | null, location: string | null, googleLocation: any | null, onlineEvent: boolean, globalEvent: boolean, startTime: string | null, endTime: string | null, localStartTime: string | null, localEndTime: string | null, eventRegistrationLink: string | null, joinEventLink: string | null, facebookLink: string | null, meetupLink: string | null, website: string | null, contactInfo: string | null, isEvent: boolean, eventImageId: string | null, eventType: string | null, types: Array<string> | null, groupId: string | null, reviewedByUserId: string | null, suggestForCuratedUserIds: Array<string> | null, suggestForCuratedUsernames: string | null, reviewForCuratedUserId: string | null, authorIsUnreviewed: boolean, afDate: string | null, suggestForAlignmentUserIds: Array<string>, reviewForAlignmentUserId: string | null, afBaseScore: number | null, afExtendedScore: any | null, afCommentCount: number, afLastCommentedAt: string | null, afSticky: boolean, hideAuthor: boolean, moderationStyle: string | null, ignoreRateLimits: boolean | null, submitToFrontpage: boolean, shortform: boolean, onlyVisibleToLoggedIn: boolean, onlyVisibleToEstablishedAccounts: boolean, reviewCount: number, reviewVoteCount: number, positiveReviewVoteCount: number, manifoldReviewMarketId: string | null, annualReviewMarketProbability: number | null, annualReviewMarketIsResolved: boolean | null, annualReviewMarketYear: number | null, annualReviewMarketUrl: string | null, rsvpCounts: any, podcastEpisodeId: string | null, forceAllowType3Audio: boolean, nominationCount2019: number, reviewCount2019: number, votingSystem: string | null, disableRecommendation: boolean, group: { __typename?: 'Localgroup', _id: string, name: string, organizerIds: Array<string> } | null }
  & PostsMinimumInfo
);

export type PostsWithVotes = (
  { __typename?: 'Post', currentUserVote: string | null, currentUserExtendedVote: any | null }
  & PostsBase
);

export type PostPodcastEpisode = { __typename?: 'Post', podcastEpisode: { __typename?: 'PodcastEpisode', _id: string, title: string, episodeLink: string, externalEpisodeId: string, podcast: { __typename?: 'Podcast', _id: string, title: string, applePodcastLink: string | null, spotifyPodcastLink: string | null } } | null };

export type PostsListWithVotes = (
  { __typename?: 'Post', currentUserVote: string | null, currentUserExtendedVote: any | null }
  & PostsList
  & PostPodcastEpisode
);

export type PostsListWithVotesAndSequence = (
  { __typename?: 'Post', canonicalSequence: (
    { __typename?: 'Sequence' }
    & SequencesPageFragment
  ) | null }
  & PostsListWithVotes
);

export type UltraFeedPostFragment = (
  { __typename?: 'Post', autoFrontpage: string | null, votingSystem: string | null, contents: { __typename?: 'Revision', _id: string, html: string | null, htmlHighlight: string, wordCount: number, plaintextDescription: string, version: string } | null }
  & PostsDetails
  & PostsListWithVotes
);

export type PostsReviewVotingList = (
  { __typename?: 'Post', reviewVoteScoreAllKarma: number, reviewVotesAllKarma: Array<number>, reviewVoteScoreHighKarma: number, reviewVotesHighKarma: Array<number>, reviewVoteScoreAF: number, reviewVotesAF: Array<number>, currentUserReviewVote: { __typename?: 'ReviewVote', _id: string, qualitativeScore: number, quadraticScore: number } | null }
  & PostsListWithVotes
);

export type PostsModerationGuidelines = (
  { __typename?: 'Post', frontpageDate: string | null, moderationStyle: string | null, user: { __typename?: 'User', _id: string, displayName: string, moderationStyle: string | null } | null, moderationGuidelines: { __typename?: 'Revision', _id: string, html: string | null, originalContents: { __typename?: 'ContentType', type: string, data: any } } | null }
  & PostsMinimumInfo
);

export type PostsAuthors = { __typename?: 'Post', user: (
    { __typename?: 'User', profileImageId: string | null, moderationStyle: string | null, bannedUserIds: Array<string> | null, bannedPersonalUserIds: Array<string> | null, moderatorAssistance: boolean | null, groups: Array<string> | null, banned: string | null, allCommentingDisabled: boolean | null }
    & UsersMinimumInfo
  ) | null, coauthors: Array<(
    { __typename?: 'User' }
    & UsersMinimumInfo
  )> | null };

export type PostsListBase = (
  { __typename?: 'Post', readTimeMinutes: number, rejectedReason: string | null, feedId: string | null, totalDialogueResponseCount: number, unreadDebateResponseCount: number, dialogTooltipPreview: string | null, disableSidenotes: boolean, customHighlight: { __typename?: 'Revision', _id: string, html: string | null, plaintextDescription: string } | null, lastPromotedComment: { __typename?: 'Comment', _id: string, user: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null, bestAnswer: (
    { __typename?: 'Comment' }
    & CommentsList
  ) | null, tags: Array<(
    { __typename?: 'Tag' }
    & TagBasicInfo
  )>, socialPreviewData: { __typename?: 'SocialPreviewType', _id: string, imageUrl: string } }
  & PostsBase
  & PostsAuthors
);

export type PostsList = (
  { __typename?: 'Post', deletedDraft: boolean, isBookmarked: boolean, bannedUserIds: Array<string> | null, contents: { __typename?: 'Revision', _id: string, htmlHighlight: string, plaintextDescription: string, wordCount: number, version: string } | null, fmCrosspost: { __typename?: 'CrosspostOutput', isCrosspost: boolean, hostedHere: boolean | null, foreignPostId: string | null } | null }
  & PostsListBase
);

export type MarkdownPostsList = (
  { __typename?: 'Post', isBookmarked: boolean, contents: { __typename?: 'Revision', _id: string, agentMarkdownExcerpt: string | null } | null, fmCrosspost: { __typename?: 'CrosspostOutput', isCrosspost: boolean, hostedHere: boolean | null, foreignPostId: string | null } | null }
  & PostsListBase
);

export type SunshineCurationPostsList = (
  { __typename?: 'Post', curationNotices: Array<(
    { __typename?: 'CurationNotice' }
    & CurationNoticesFragment
  )> | null }
  & PostsList
);

export type SunshineCurationPostsListItem = { __typename?: 'Post', _id: string, title: string, postedAt: string, baseScore: number, suggestForCuratedUsernames: string | null, user: { __typename?: 'User', _id: string, displayName: string } | null, curationNotices: Array<{ __typename?: 'CurationNotice', _id: string, user: { __typename?: 'User', _id: string, displayName: string } | null }> | null };

export type PostsListTag = (
  { __typename?: 'Post', tagRel: (
    { __typename?: 'TagRel' }
    & WithVoteTagRel
  ) | null }
  & PostsList
);

export type PostsListTagWithVotes = (
  { __typename?: 'Post', tagRel: (
    { __typename?: 'TagRel' }
    & WithVoteTagRel
  ) | null }
  & PostsListWithVotes
);

export type PostsDetails = (
  { __typename?: 'Post', canonicalSource: string | null, noIndex: boolean, viewCount: number | null, tagRelevance: any | null, commentSortOrder: string | null, sideCommentVisibility: string | null, collectionTitle: string | null, canonicalPrevPostSlug: string | null, canonicalNextPostSlug: string | null, canonicalSequenceId: string | null, canonicalBookId: string | null, bannedUserIds: Array<string> | null, moderationStyle: string | null, currentUserVote: string | null, currentUserExtendedVote: any | null, isBookmarked: boolean, feedLink: string | null, rsvps: Array<any> | null, activateRSVPs: boolean | null, tags: Array<(
    { __typename?: 'Tag' }
    & TagPreviewFragment
  )>, socialPreviewData: { __typename?: 'SocialPreviewType', _id: string, text: string | null, imageUrl: string }, canonicalSequence: { __typename?: 'Sequence', _id: string, title: string } | null, canonicalBook: { __typename?: 'Book', _id: string, title: string | null } | null, canonicalCollection: { __typename?: 'Collection', _id: string, title: string } | null, feed: (
    { __typename?: 'RSSFeed' }
    & RSSFeedMinimumInfo
  ) | null, sourcePostRelations: Array<{ __typename?: 'PostRelation', _id: string, sourcePostId: string, order: number | null, sourcePost: (
      { __typename?: 'Post' }
      & PostsListWithVotes
    ) | null }>, targetPostRelations: Array<{ __typename?: 'PostRelation', _id: string, sourcePostId: string, targetPostId: string, order: number | null, targetPost: (
      { __typename?: 'Post' }
      & PostsListWithVotes
    ) | null }>, fmCrosspost: { __typename?: 'CrosspostOutput', isCrosspost: boolean, hostedHere: boolean | null, foreignPostId: string | null } | null }
  & PostsListBase
);

export type PostsExpandedHighlight = { __typename?: 'Post', _id: string, contents: { __typename?: 'Revision', _id: string, html: string | null, wordCount: number } | null };

export type PostsPlaintextDescription = { __typename?: 'Post', _id: string, contents: { __typename?: 'Revision', _id: string, plaintextDescription: string } | null };

export type PostsRevision = (
  { __typename?: 'Post', version: string | null, contents: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null, revisions: Array<(
    { __typename?: 'Revision' }
    & RevisionMetadata
  )> | null }
  & PostsDetails
);

export type PostsWithNavigationAndRevision = (
  { __typename?: 'Post', tableOfContentsRevision: any | null, customHighlight: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null, reviewWinner: (
    { __typename?: 'ReviewWinner' }
    & ReviewWinnerAll
  ) | null, glossary: Array<(
    { __typename?: 'JargonTerm' }
    & JargonTermsPost
  )> }
  & PostsRevision
  & PostSequenceNavigation
  & PostPodcastEpisode
);

export type PostsWithNavigation = (
  { __typename?: 'Post', tableOfContents: any | null, reviewWinner: (
    { __typename?: 'ReviewWinner' }
    & ReviewWinnerAll
  ) | null, glossary: Array<(
    { __typename?: 'JargonTerm' }
    & JargonTermsPost
  )> }
  & PostsPage
  & PostSequenceNavigation
  & PostPodcastEpisode
);

export type PostSequenceNavigation = { __typename?: 'Post', sequence: (
    { __typename?: 'Sequence' }
    & SequencesPageFragment
  ) | null, prevPost: (
    { __typename?: 'Post', sequence: { __typename?: 'Sequence', _id: string } | null }
    & PostsListWithVotes
  ) | null, nextPost: (
    { __typename?: 'Post', sequence: { __typename?: 'Sequence', _id: string } | null }
    & PostsListWithVotes
  ) | null };

export type PostsPage = (
  { __typename?: 'Post', version: string | null, sideComments: any | null, myEditorAccess: string, contents: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null }
  & PostsDetails
);

export type PostsEdit = (
  { __typename?: 'Post', sideComments: any | null, myEditorAccess: string, version: string | null, coauthorUserIds: Array<string>, readTimeMinutesOverride: number | null, hideFromRecentDiscussions: boolean, hideFromPopularComments: boolean | null, tableOfContents: any | null, subforumTagId: string | null, socialPreviewImageId: string | null, generateDraftJargon: boolean | null, fmCrosspost: { __typename?: 'CrosspostOutput', isCrosspost: boolean, hostedHere: boolean | null, foreignPostId: string | null } | null, moderationGuidelines: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null, customHighlight: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null, socialPreview: { __typename?: 'SocialPreviewOutput', imageId: string | null, text: string | null } | null, socialPreviewData: { __typename?: 'SocialPreviewType', _id: string, imageId: string | null, text: string | null }, user: (
    { __typename?: 'User', moderationStyle: string | null, bannedUserIds: Array<string> | null, moderatorAssistance: boolean | null }
    & UsersMinimumInfo
  ) | null, usersSharedWith: Array<(
    { __typename?: 'User' }
    & UsersMinimumInfo
  )> | null, coauthors: Array<(
    { __typename?: 'User' }
    & UsersMinimumInfo
  )> | null }
  & PostsDetails
);

export type PostsEditQueryFragment = (
  { __typename?: 'Post', contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & PostsEdit
);

export type PostsEditMutationFragment = (
  { __typename?: 'Post', contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & PostsEdit
);

export type PostsRevisionsList = { __typename?: 'Post', _id: string, revisions: Array<(
    { __typename?: 'Revision' }
    & RevisionMetadata
  )> | null };

export type PostsRecentDiscussion = (
  { __typename?: 'Post', recentComments: Array<(
    { __typename?: 'Comment' }
    & CommentsList
  )> | null }
  & PostsListWithVotes
);

export type ShortformRecentDiscussion = (
  { __typename?: 'Post', recentComments: Array<(
    { __typename?: 'Comment' }
    & CommentsListWithTopLevelComment
  )> | null }
  & PostsListWithVotes
);

export type UsersBannedFromPostsModerationLog = { __typename?: 'Post', title: string, slug: string, _id: string, bannedUserIds: Array<string> | null, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null };

export type SunshinePostsList = (
  { __typename?: 'Post', currentUserVote: string | null, currentUserExtendedVote: any | null, isBookmarked: boolean, rejectedReason: string | null, autoFrontpage: string | null, fmCrosspost: { __typename?: 'CrosspostOutput', isCrosspost: boolean, hostedHere: boolean | null, foreignPostId: string | null } | null, contents: { __typename?: 'Revision', _id: string, html: string | null, htmlHighlight: string, wordCount: number, version: string } | null, automatedContentEvaluations: (
    { __typename?: 'AutomatedContentEvaluation' }
    & AutomatedContentEvaluationsFragment
  ) | null, moderationGuidelines: { __typename?: 'Revision', _id: string, html: string | null } | null, user: (
    { __typename?: 'User', profileImageId: string | null, moderationStyle: string | null, bannedUserIds: Array<string> | null, moderatorAssistance: boolean | null, needsReview: boolean | null, biography: (
      { __typename?: 'Revision' }
      & RevisionDisplay
    ) | null, moderationGuidelines: { __typename?: 'Revision', _id: string, html: string | null } | null, moderatorActions: Array<(
      { __typename?: 'ModeratorAction' }
      & ModeratorActionDisplay
    )> | null }
    & UsersMinimumInfo
  ) | null, frontpageClassification: { __typename?: 'FrontpageClassification', isFrontpage: boolean, probability: number } | null, tagRels: Array<(
    { __typename?: 'TagRel' }
    & TagRelMinimumFragment
  )> }
  & PostsListBase
);

export type WithVotePost = { __typename: 'Post', _id: string, currentUserVote: string | null, currentUserExtendedVote: any | null, baseScore: number, extendedScore: any | null, score: number, afBaseScore: number | null, afExtendedScore: any | null, voteCount: number };

export type HighlightWithHash = { __typename?: 'Post', _id: string, contents: { __typename?: 'Revision', _id: string, htmlHighlightStartingAtHash: string } | null };

export type PostWithDialogueMessage = { __typename?: 'Post', _id: string, dialogueMessageContents: string | null };

export type PostsBestOfList = (
  { __typename?: 'Post', firstVideoAttribsForPreview: any | null, podcastEpisode: { __typename?: 'PodcastEpisode', _id: string, title: string, episodeLink: string, externalEpisodeId: string, podcast: { __typename?: 'Podcast', _id: string, title: string, applePodcastLink: string | null, spotifyPodcastLink: string | null } } | null, socialPreviewData: { __typename?: 'SocialPreviewType', _id: string, text: string | null, imageUrl: string } }
  & PostsListWithVotes
);

export type PostsRSSFeed = (
  { __typename?: 'Post', scoreExceeded2Date: string | null, scoreExceeded30Date: string | null, scoreExceeded45Date: string | null, scoreExceeded75Date: string | null, scoreExceeded125Date: string | null, scoreExceeded200Date: string | null, metaDate: string | null, contents: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null }
  & PostsDetails
);

export type PostsOriginalContents = { __typename?: 'Post', _id: string, contents: { __typename?: 'Revision', _id: string, originalContents: { __typename?: 'ContentType', type: string, data: any } } | null };

export type PostsHTML = { __typename?: 'Post', _id: string, contents: (
    { __typename?: 'Revision' }
    & RevisionHTML
  ) | null };

export type PostsForAutocomplete = { __typename?: 'Post', _id: string, title: string, userId: string | null, baseScore: number, extendedScore: any | null, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, contents: { __typename?: 'Revision', markdown: string | null } | null };

export type SuggestAlignmentPost = (
  { __typename?: 'Post', suggestForAlignmentUsers: Array<{ __typename?: 'User', _id: string, displayName: string }> }
  & PostsList
);

export type ChapterPostSlim = { __typename?: 'Post', _id: string, title: string, slug: string, isRead: boolean | null };

export type UnclaimedReportsList = { __typename?: 'Report', _id: string, userId: string, commentId: string | null, postId: string | null, closedAt: string | null, createdAt: string, claimedUserId: string | null, link: string, description: string | null, reportedAsSpam: boolean | null, markedAsSpam: boolean | null, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, comment: (
    { __typename?: 'Comment', post: (
      { __typename?: 'Post' }
      & PostsMinimumInfo
    ) | null, tag: (
      { __typename?: 'Tag' }
      & TagBasicInfo
    ) | null }
    & CommentsList
  ) | null, post: (
    { __typename?: 'Post' }
    & PostsList
  ) | null, reportedUser: (
    { __typename?: 'User' }
    & SunshineUsersList
  ) | null, claimedUser: { __typename?: 'User', _id: string, displayName: string, username: string | null, slug: string } | null };

export type reviewVoteFragment = { __typename?: 'ReviewVote', _id: string, createdAt: string, userId: string, postId: string, qualitativeScore: number, quadraticScore: number, comment: string | null, year: string, dummy: boolean, reactions: Array<string> | null };

export type reviewAdminDashboard = { __typename?: 'ReviewVote', _id: string, createdAt: string, userId: string, user: { __typename?: 'User', _id: string, displayName: string, karma: number } | null };

export type ReviewWinnerArtImages = { __typename?: 'ReviewWinnerArt', _id: string, createdAt: string, postId: string, splashArtImagePrompt: string, splashArtImageUrl: string, midjourneyJobId: string | null, midjourneyImageIndex: number | null, upscaledImageUrl: string | null, activeSplashArtCoordinates: (
    { __typename?: 'SplashArtCoordinate' }
    & SplashArtCoordinatesEdit
  ) | null };

export type ReviewWinnerAll = { __typename?: 'ReviewWinner', _id: string, category: string, curatedOrder: number | null, postId: string, reviewYear: number, reviewRanking: number, competitorCount: number | null, reviewWinnerArt: (
    { __typename?: 'ReviewWinnerArt' }
    & ReviewWinnerArtImages
  ) | null };

export type ReviewWinnerTopPostsPage = { __typename?: 'ReviewWinner', _id: string, category: string, curatedOrder: number | null, reviewYear: number, reviewRanking: number, reviewWinnerArt: { __typename?: 'ReviewWinnerArt', splashArtImageUrl: string, activeSplashArtCoordinates: (
      { __typename?: 'SplashArtCoordinate' }
      & SplashArtCoordinatesEdit
    ) | null } | null };

export type ReviewWinnerAnnouncement = { __typename?: 'ReviewWinner', _id: string, category: string, curatedOrder: number | null, reviewYear: number, reviewRanking: number, competitorCount: number | null, postId: string, post: { __typename?: 'Post', _id: string, title: string, slug: string } | null };

export type RevisionDisplay = { __typename?: 'Revision', _id: string, version: string, html: string | null, wordCount: number, htmlHighlight: string, plaintextDescription: string };

export type RevisionHTML = { __typename?: 'Revision', _id: string, html: string | null };

export type RevisionEdit = (
  { __typename?: 'Revision', updateType: string | null, editedAt: string, userId: string | null, commitMessage: string | null, markdown: string | null, ckEditorMarkup: string | null, originalContents: { __typename?: 'ContentType', type: string, data: any } }
  & RevisionDisplay
);

export type RevisionMetadata = { __typename?: 'Revision', _id: string, version: string, editedAt: string, commitMessage: string | null, userId: string | null, score: number, baseScore: number, extendedScore: any | null, voteCount: number, currentUserVote: string | null, currentUserExtendedVote: any | null };

export type RevisionMetadataWithChangeMetrics = (
  { __typename?: 'Revision', changeMetrics: any, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null }
  & RevisionMetadata
);

export type RevisionHistoryEntry = (
  { __typename?: 'Revision', documentId: string | null, collectionName: string | null, changeMetrics: any, legacyData: any | null, skipAttributions: boolean, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null }
  & RevisionMetadata
);

export type RevisionHistorySummaryEdit = (
  { __typename?: 'Revision', summary: (
    { __typename?: 'MultiDocument', parentTag: { __typename?: 'Tag', _id: string, name: string } | null, parentLens: { __typename?: 'MultiDocument', _id: string, title: string | null, tabTitle: string, tabSubtitle: string | null } | null }
    & MultiDocumentMinimumInfo
  ) | null }
  & RevisionHistoryEntry
);

export type RevisionTagFragment = (
  { __typename?: 'Revision', tag: (
    { __typename?: 'Tag' }
    & TagHistoryFragment
  ) | null, lens: (
    { __typename?: 'MultiDocument' }
    & MultiDocumentParentDocument
  ) | null }
  & RevisionHistoryEntry
);

export type RecentDiscussionRevisionTagFragment = (
  { __typename?: 'Revision', tag: (
    { __typename?: 'Tag' }
    & TagRecentDiscussion
  ) | null }
  & RevisionHistoryEntry
);

export type WithVoteRevision = { __typename: 'Revision', _id: string, currentUserVote: string | null, currentUserExtendedVote: any | null, baseScore: number, extendedScore: any | null, score: number, voteCount: number };

export type RSSFeedMinimumInfo = { __typename?: 'RSSFeed', _id: string, userId: string, createdAt: string, ownedByUser: boolean, displayFullContent: boolean, nickname: string, url: string, importAsDraft: boolean, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null };

export type newRSSFeedFragment = { __typename?: 'RSSFeed', _id: string, userId: string, createdAt: string, ownedByUser: boolean, displayFullContent: boolean, nickname: string, url: string, status: string | null, importAsDraft: boolean };

export type SequencesPageTitleFragment = { __typename?: 'Sequence', _id: string, title: string, canonicalCollectionSlug: string | null, canonicalCollection: { __typename?: 'Collection', _id: string, title: string } | null };

export type SequencesPageFragment = (
  { __typename?: 'Sequence', createdAt: string, userId: string, gridImageId: string | null, bannerImageId: string | null, canonicalCollectionSlug: string | null, draft: boolean, isDeleted: boolean, hidden: boolean, hideFromAuthorPage: boolean, noindex: boolean, curatedOrder: number | null, userProfileOrder: number | null, af: boolean, postsCount: number, readPostsCount: number, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, contents: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null }
  & SequencesPageTitleFragment
);

export type SequenceContinueReadingFragment = { __typename?: 'Sequence', _id: string, title: string, gridImageId: string | null, canonicalCollectionSlug: string | null };

export type SequencesPageWithChaptersFragment = (
  { __typename?: 'Sequence', chapters: Array<(
    { __typename?: 'Chapter' }
    & SlimChapter
  )> }
  & SequencesPageFragment
);

export type SequencesEdit = (
  { __typename?: 'Sequence', contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & SequencesPageFragment
);

export type SplashArtCoordinates = { __typename?: 'SplashArtCoordinate', _id: string, reviewWinnerArtId: string | null, leftXPct: number, leftYPct: number, leftHeightPct: number, leftWidthPct: number, leftFlipped: boolean, middleXPct: number, middleYPct: number, middleHeightPct: number, middleWidthPct: number, middleFlipped: boolean, rightXPct: number, rightYPct: number, rightHeightPct: number, rightWidthPct: number, rightFlipped: boolean };

export type SplashArtCoordinatesEdit = (
  { __typename?: 'SplashArtCoordinate', createdAt: string }
  & SplashArtCoordinates
);

export type SpotlightMinimumInfo = { __typename?: 'Spotlight', _id: string, documentId: string, documentType: SpotlightDocumentType, spotlightImageId: string | null, spotlightDarkImageId: string | null, spotlightSplashImageUrl: string | null, draft: boolean, deletedDraft: boolean, position: number, lastPromotedAt: string, customTitle: string | null, customSubtitle: string | null, subtitleUrl: string | null, headerTitle: string | null, headerTitleLeftColor: string | null, headerTitleRightColor: string | null, duration: number, showAuthor: boolean, imageFade: boolean, imageFadeColor: string | null };

export type SpotlightHeaderEventSubtitle = (
  { __typename?: 'Spotlight', post: { __typename?: 'Post', _id: string, slug: string } | null, sequence: { __typename?: 'Sequence', _id: string } | null, tag: { __typename?: 'Tag', _id: string, slug: string } | null }
  & SpotlightMinimumInfo
);

export type SpotlightDisplay = (
  { __typename?: 'Spotlight', post: { __typename?: 'Post', _id: string, slug: string, title: string, user: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null, reviews: Array<{ __typename?: 'Comment', _id: string }> | null } | null, sequence: { __typename?: 'Sequence', _id: string, title: string, user: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null, tag: { __typename?: 'Tag', _id: string, name: string, slug: string, user: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null, description: { __typename?: 'Revision', html: string | null } | null }
  & SpotlightMinimumInfo
);

export type SpotlightEditQueryFragment = (
  { __typename?: 'Spotlight', description: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & SpotlightMinimumInfo
);

export type SubscriptionState = { __typename?: 'Subscription', _id: string, userId: string | null, createdAt: string, state: string | null, documentId: string | null, collectionName: string | null, deleted: boolean | null, type: string | null };

export type MembersOfGroupFragment = { __typename?: 'Subscription', user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null };

export type TagFlagFragment = { __typename?: 'TagFlag', _id: string, createdAt: string, name: string, slug: string, order: number | null, deleted: boolean, contents: { __typename?: 'Revision', html: string | null, htmlHighlight: string, plaintextDescription: string } | null };

export type TagFlagEditFragment = (
  { __typename?: 'TagFlag', contents: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & TagFlagFragment
);

export type TagRelBasicInfo = { __typename?: 'TagRel', _id: string, score: number, baseScore: number, extendedScore: any | null, afBaseScore: number | null, voteCount: number, tagId: string, postId: string, autoApplied: boolean };

export type TagRelFragment = (
  { __typename?: 'TagRel', currentUserVote: string | null, currentUserExtendedVote: any | null, currentUserCanVote: boolean, tag: (
    { __typename?: 'Tag' }
    & TagPreviewFragment
  ) | null, post: (
    { __typename?: 'Post' }
    & PostsList
  ) | null }
  & TagRelBasicInfo
);

export type TagRelHistoryFragment = (
  { __typename?: 'TagRel', createdAt: string, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, post: (
    { __typename?: 'Post' }
    & PostsList
  ) | null }
  & TagRelBasicInfo
);

export type TagRelCreationFragment = (
  { __typename?: 'TagRel', currentUserVote: string | null, currentUserExtendedVote: any | null, tag: (
    { __typename?: 'Tag' }
    & TagPreviewFragment
  ) | null, post: (
    { __typename?: 'Post', tagRelevance: any | null, tagRel: (
      { __typename?: 'TagRel' }
      & WithVoteTagRel
    ) | null }
    & PostsList
  ) | null }
  & TagRelBasicInfo
);

export type TagRelMinimumFragment = (
  { __typename?: 'TagRel', currentUserVote: string | null, currentUserExtendedVote: any | null, currentUserCanVote: boolean, tag: (
    { __typename?: 'Tag' }
    & TagPreviewFragment
  ) | null }
  & TagRelBasicInfo
);

export type WithVoteTagRel = { __typename: 'TagRel', _id: string, score: number, baseScore: number, extendedScore: any | null, afBaseScore: number | null, voteCount: number, currentUserVote: string | null, currentUserExtendedVote: any | null };

export type TagBasicInfo = { __typename?: 'Tag', _id: string, userId: string | null, name: string, shortName: string | null, slug: string, core: boolean, postCount: number, adminOnly: boolean, canEditUserIds: Array<string> | null, suggestedAsFilter: boolean, needsReview: boolean, descriptionTruncationCount: number, createdAt: string, wikiOnly: boolean, deleted: boolean, isSubforum: boolean, noindex: boolean, isArbitalImport: boolean | null, isPlaceholderPage: boolean, baseScore: number, extendedScore: any | null, score: number, afBaseScore: number | null, afExtendedScore: any | null, voteCount: number, currentUserVote: string | null, currentUserExtendedVote: any | null };

export type TagDetailsFragment = (
  { __typename?: 'Tag', subtitle: string | null, oldSlugs: Array<string>, isRead: boolean | null, defaultOrder: number, reviewedByUserId: string | null, wikiGrade: number, subforumModeratorIds: Array<string>, bannerImageId: string | null, squareImageId: string | null, lesswrongWikiImportSlug: string | null, lesswrongWikiImportRevision: string | null, subforumModerators: Array<(
    { __typename?: 'User' }
    & UsersMinimumInfo
  )>, moderationGuidelines: { __typename?: 'Revision', _id: string, html: string | null } | null, sequence: (
    { __typename?: 'Sequence' }
    & SequencesPageFragment
  ) | null }
  & TagBasicInfo
);

export type TagFragment = (
  { __typename?: 'Tag', canVoteOnRels: Array<TagRelVoteGroup> | null, authorOnly: boolean, parentTag: (
    { __typename?: 'Tag' }
    & TagBasicInfo
  ) | null, subTags: Array<(
    { __typename?: 'Tag' }
    & TagBasicInfo
  )>, description: { __typename?: 'Revision', _id: string, html: string | null, htmlHighlight: string, plaintextDescription: string, version: string, editedAt: string } | null }
  & TagDetailsFragment
);

export type TagHistoryFragment = (
  { __typename?: 'Tag', textLastUpdatedAt: string | null, tableOfContents: any | null, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, lensesIncludingDeleted: Array<(
    { __typename?: 'MultiDocument' }
    & MultiDocumentContentDisplay
  )> }
  & TagFragment
);

export type TagCreationHistoryFragment = (
  { __typename?: 'Tag', user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, description: { __typename?: 'Revision', html: string | null } | null }
  & TagFragment
);

export type TagRevisionFragment = (
  { __typename?: 'Tag', isRead: boolean | null, parentTag: (
    { __typename?: 'Tag' }
    & TagBasicInfo
  ) | null, subTags: Array<(
    { __typename?: 'Tag' }
    & TagBasicInfo
  )>, description: { __typename?: 'Revision', _id: string, version: string, html: string | null, htmlHighlight: string, plaintextDescription: string, editedAt: string, user: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null }
  & TagDetailsFragment
);

export type TagPreviewFragment = (
  { __typename?: 'Tag', isRead: boolean | null, canVoteOnRels: Array<TagRelVoteGroup> | null, authorOnly: boolean, isArbitalImport: boolean | null, parentTag: (
    { __typename?: 'Tag' }
    & TagBasicInfo
  ) | null, subTags: Array<(
    { __typename?: 'Tag' }
    & TagBasicInfo
  )>, description: { __typename?: 'Revision', _id: string, htmlHighlight: string } | null }
  & TagBasicInfo
);

export type TagSectionPreviewFragment = (
  { __typename?: 'Tag', isRead: boolean | null, canVoteOnRels: Array<TagRelVoteGroup> | null, authorOnly: boolean, parentTag: (
    { __typename?: 'Tag' }
    & TagBasicInfo
  ) | null, subTags: Array<(
    { __typename?: 'Tag' }
    & TagBasicInfo
  )>, description: { __typename?: 'Revision', _id: string, htmlHighlightStartingAtHash: string } | null }
  & TagBasicInfo
);

export type TagWithFlagsFragment = (
  { __typename?: 'Tag', tagFlagsIds: Array<string>, tagFlags: Array<(
    { __typename?: 'TagFlag' }
    & TagFlagFragment
  )> }
  & TagFragment
);

export type TagWithFlagsAndRevisionFragment = (
  { __typename?: 'Tag', tagFlagsIds: Array<string>, tagFlags: Array<(
    { __typename?: 'TagFlag' }
    & TagFlagFragment
  )> }
  & TagRevisionFragment
);

export type ArbitalLinkedPagesFragment = { __typename?: 'ArbitalLinkedPages', faster: Array<{ __typename?: 'ArbitalLinkedPage', _id: string, name: string, slug: string }>, slower: Array<{ __typename?: 'ArbitalLinkedPage', _id: string, name: string, slug: string }>, moreTechnical: Array<{ __typename?: 'ArbitalLinkedPage', _id: string, name: string, slug: string }>, lessTechnical: Array<{ __typename?: 'ArbitalLinkedPage', _id: string, name: string, slug: string }>, requirements: Array<{ __typename?: 'ArbitalLinkedPage', _id: string, name: string, slug: string }>, teaches: Array<{ __typename?: 'ArbitalLinkedPage', _id: string, name: string, slug: string }>, parents: Array<{ __typename?: 'ArbitalLinkedPage', _id: string, name: string, slug: string }>, children: Array<{ __typename?: 'ArbitalLinkedPage', _id: string, name: string, slug: string }> };

export type TagPageArbitalContentFragment = { __typename?: 'Tag', lenses: Array<(
    { __typename?: 'MultiDocument' }
    & MultiDocumentWithContributors
  )>, arbitalLinkedPages: (
    { __typename?: 'ArbitalLinkedPages' }
    & ArbitalLinkedPagesFragment
  ) | null };

export type TagPageFragment = (
  { __typename?: 'Tag', tableOfContents: any | null, postsDefaultSortOrder: string | null, canVoteOnRels: Array<TagRelVoteGroup> | null, authorOnly: boolean, forceAllowType3Audio: boolean, textLastUpdatedAt: string | null, subforumIntroPost: (
    { __typename?: 'Post' }
    & PostsListWithVotes
  ) | null, subforumWelcomeText: { __typename?: 'Revision', _id: string, html: string | null } | null, contributors: { __typename?: 'TagContributorsList', totalCount: number, contributors: Array<{ __typename?: 'TagContributor', contributionScore: number, currentAttributionCharCount: number | null, numCommits: number, voteCount: number, user: (
        { __typename?: 'User' }
        & UsersMinimumInfo
      ) | null }> } }
  & TagWithFlagsFragment
);

export type TagPageWithArbitalContentFragment = (
  { __typename?: 'Tag' }
  & TagPageFragment
  & TagPageArbitalContentFragment
);

export type AllTagsPageFragment = (
  { __typename?: 'Tag', tableOfContents: any | null }
  & TagWithFlagsFragment
);

export type TagPageWithRevisionFragment = (
  { __typename?: 'Tag', tableOfContents: any | null, textLastUpdatedAt: string | null, postsDefaultSortOrder: string | null, canVoteOnRels: Array<TagRelVoteGroup> | null, authorOnly: boolean, forceAllowType3Audio: boolean, subforumIntroPost: (
    { __typename?: 'Post' }
    & PostsListWithVotes
  ) | null, subforumWelcomeText: { __typename?: 'Revision', _id: string, html: string | null } | null, contributors: { __typename?: 'TagContributorsList', totalCount: number, contributors: Array<{ __typename?: 'TagContributor', contributionScore: number, currentAttributionCharCount: number | null, numCommits: number, voteCount: number, user: (
        { __typename?: 'User' }
        & UsersMinimumInfo
      ) | null }> } }
  & TagWithFlagsAndRevisionFragment
);

export type TagPageRevisionWithArbitalContentFragment = (
  { __typename?: 'Tag' }
  & TagPageWithRevisionFragment
  & TagPageArbitalContentFragment
);

export type TagFullContributorsList = { __typename?: 'Tag', contributors: { __typename?: 'TagContributorsList', totalCount: number, contributors: Array<{ __typename?: 'TagContributor', contributionScore: number, currentAttributionCharCount: number | null, numCommits: number, voteCount: number, user: (
        { __typename?: 'User' }
        & UsersMinimumInfo
      ) | null }> } };

export type TagEditFragment = (
  { __typename?: 'Tag', isPostType: boolean, parentTagId: string | null, subforumIntroPostId: string | null, tagFlagsIds: Array<string>, postsDefaultSortOrder: string | null, introSequenceId: string | null, canVoteOnRels: Array<TagRelVoteGroup> | null, removalResistant: boolean, authorOnly: boolean, autoTagModel: string | null, autoTagPrompt: string | null, parentTag: (
    { __typename?: 'Tag' }
    & TagBasicInfo
  ) | null, description: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null, subforumWelcomeText: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null, moderationGuidelines: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & TagDetailsFragment
);

export type TagRecentDiscussion = (
  { __typename?: 'Tag', lastVisitedAt: string | null, recentComments: Array<(
    { __typename?: 'Comment' }
    & CommentsList
  )> }
  & TagFragment
);

export type SunshineTagFragment = (
  { __typename?: 'Tag', user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null }
  & TagFragment
);

export type ExplorePageTagFragment = (
  { __typename?: 'Tag', legacyData: any | null, contributors: { __typename?: 'TagContributorsList', totalCount: number, contributors: Array<{ __typename?: 'TagContributor', contributionScore: number, currentAttributionCharCount: number | null, numCommits: number, voteCount: number, user: (
        { __typename?: 'User' }
        & UsersMinimumInfo
      ) | null }> } }
  & TagFragment
);

export type ConceptItemFragment = { __typename?: 'Tag', _id: string, core: boolean, name: string, slug: string, oldSlugs: Array<string>, postCount: number, baseScore: number, wikiOnly: boolean, isArbitalImport: boolean | null, coreTagId: string | null, maxScore: number | null, description: { __typename?: 'Revision', _id: string, wordCount: number } | null, usersWhoLiked: Array<{ __typename?: 'UserLikingTag', userId: string, displayName: string }> };

export type TagPageWithArbitalContentAndLensRevisionFragment = (
  { __typename?: 'Tag', arbitalLinkedPages: (
    { __typename?: 'ArbitalLinkedPages' }
    & ArbitalLinkedPagesFragment
  ) | null, lenses: Array<(
    { __typename?: 'MultiDocument' }
    & MultiDocumentWithContributorsRevision
  )> }
  & TagPageFragment
);

export type WithVoteTag = (
  { __typename?: 'Tag' }
  & TagBasicInfo
);

export type TypoSuggestionsDefaultFragment = { __typename?: 'TypoSuggestion', _id: string, createdAt: string, documentId: string | null, collectionName: string | null, fieldName: string | null, voteId: string | null, authorId: string | null, quote: string | null, llmCanonicalQuote: string | null, proposedReplacement: string | null, narrowedQuote: string | null, narrowedReplacement: string | null, explanation: string | null, llmVerdict: string | null, status: string | null, resolvedByUserId: string | null, appliedRevisionId: string | null, resolvedAt: string | null, reactor: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null, author: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null };

export type UserMostValuablePostInfo = { __typename?: 'UserMostValuablePost', _id: string, userId: string | null, postId: string | null, deleted: boolean | null };

export type UserRateLimitMutationFragment = { __typename?: 'UserRateLimit', _id: string, schemaVersion: number, createdAt: string, legacyData: any | null, userId: string, type: UserRateLimitType, intervalUnit: UserRateLimitIntervalUnit, intervalLength: number, actionsPerInterval: number, endedAt: string };

export type UserRateLimitDisplay = { __typename?: 'UserRateLimit', _id: string, userId: string, type: UserRateLimitType, actionsPerInterval: number, intervalUnit: UserRateLimitIntervalUnit, intervalLength: number, createdAt: string, endedAt: string, user: (
    { __typename?: 'User' }
    & UsersMinimumInfo
  ) | null };

export type UsersMinimumInfo = { __typename?: 'User', _id: string, slug: string, createdAt: string, username: string | null, displayName: string, profileImageId: string | null, karma: number, afKarma: number, deleted: boolean, isAdmin: boolean, htmlBio: string, postCount: number, commentCount: number, sequenceCount: number, afPostCount: number, afCommentCount: number, tagRevisionCount: number, reviewedByUserId: string | null };

export type UsersProfile = (
  { __typename?: 'User', coauthoredPostCount: number, fullName: string | null, previousDisplayName: string | null, oldSlugs: Array<string>, groups: Array<string> | null, organizerOfGroupIds: Array<string>, website: string | null, linkedinProfileURL: string | null, facebookProfileURL: string | null, blueskyProfileURL: string | null, twitterProfileURL: string | null, githubProfileURL: string | null, afSequenceCount: number, afSequenceDraftCount: number, sequenceDraftCount: number, moderationStyle: string | null, bannedUserIds: Array<string> | null, location: string | null, googleLocation: any | null, mapLocation: any | null, mapLocationSet: boolean | null, mapMarkerText: string | null, htmlMapMarkerText: string | null, mongoLocation: any | null, shortformFeedId: string | null, petrovPressedButtonDate: string | null, petrovOptOut: boolean, sortDraftsBy: string | null, email: string | null, emails: Array<any> | null, banned: string | null, deleteContent: boolean | null, noindex: boolean, paymentEmail: string | null, paymentInfo: string | null, postingDisabled: boolean | null, allCommentingDisabled: boolean | null, commentingOnOtherUsersDisabled: boolean | null, conversationsDisabled: boolean | null, pinnedPostIds: Array<string>, hideProfileTopPosts: boolean, voteReceivedCount: number | null, biography: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null, moderationGuidelines: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null }
  & UsersMinimumInfo
);

export type UsersCurrent = (
  { __typename?: 'User', oldSlugs: Array<string>, groups: Array<string> | null, organizerOfGroupIds: Array<string>, moderationStyle: string | null, bannedUserIds: Array<string> | null, location: string | null, googleLocation: any | null, mapLocation: any | null, mapLocationSet: boolean | null, mapMarkerText: string | null, mongoLocation: any | null, shortformFeedId: string | null, sortDraftsBy: string | null, email: string | null, emails: Array<any> | null, banned: string | null, deleteContent: boolean | null, paymentEmail: string | null, paymentInfo: string | null, postingDisabled: boolean | null, allCommentingDisabled: boolean | null, commentingOnOtherUsersDisabled: boolean | null, conversationsDisabled: boolean | null, usernameUnset: boolean | null, taggingDashboardCollapsed: boolean | null, beta: boolean | null, acceptedTos: boolean | null, pageUrl: string | null, isReviewed: boolean | null, nullifyVotes: boolean | null, hideIntercom: boolean, hideNavigationSidebar: boolean | null, hideCommunitySection: boolean, hasContinueReading: boolean | null, currentFrontpageFilter: string | null, frontpageSelectedTab: string | null, frontpageFilterSettings: any | null, ultraFeedSettings: any | null, hideFrontpageFilterSettingsDesktop: boolean | null, allPostsTimeframe: string | null, allPostsSorting: string | null, allPostsFilter: string | null, allPostsShowLowKarma: boolean | null, allPostsIncludeEvents: boolean | null, allPostsOpenSettings: boolean | null, draftsListSorting: string | null, draftsListShowArchived: boolean | null, draftsListShowShared: boolean | null, lastNotificationsCheck: string | null, bannedPersonalUserIds: Array<string> | null, noKibitz: boolean | null, showHideKarmaOption: boolean | null, markDownPostEditor: boolean, hideElicitPredictions: boolean | null, hideAFNonMemberInitialWarning: boolean | null, commentSorting: string | null, htmlMapMarkerText: string | null, nearbyEventsNotifications: boolean, nearbyEventsNotificationsLocation: any | null, nearbyEventsNotificationsRadius: number | null, nearbyPeopleNotificationThreshold: number | null, hideFrontpageMap: boolean | null, emailSubscribedToCurated: boolean | null, unsubscribeFromAll: boolean | null, whenConfirmationEmailSent: string | null, hideSubscribePoke: boolean | null, hideMeetupsPoke: boolean | null, hideHomeRHS: boolean | null, noCollapseCommentsFrontpage: boolean, noCollapseCommentsPosts: boolean, noSingleLineComments: boolean, showCommunityInRecentDiscussion: boolean, karmaChangeNotifierSettings: any | null, karmaChangeLastOpened: string | null, viewUnreviewedComments: boolean | null, recommendationSettings: any | null, theme: any | null, hasAnyBookmarks: boolean | null, auto_subscribe_to_my_posts: boolean, auto_subscribe_to_my_comments: boolean, autoSubscribeAsOrganizer: boolean, noExpandUnreadCommentsReview: boolean, hideFrontpageBookAd: boolean | null, abTestKey: string | null, abTestOverrides: any | null, reactPaletteStyle: ReactPaletteStyle | null, petrovPressedButtonDate: string | null, petrovLaunchCodeDate: string | null, petrovOptOut: boolean, lastUsedTimezone: string | null, acknowledgedNewUserGuidelines: boolean | null, notificationSubforumUnread: any | null, notificationRepliesToMyComments: any | null, subforumPreferredLayout: SubforumPreferredLayout | null, hideFrontpageBook2020Ad: boolean | null, showDialoguesList: boolean | null, showMyDialogues: boolean | null, showMatches: boolean | null, showRecommendedPartners: boolean | null, hideActiveDialogueUsers: boolean | null, hideSunshineSidebar: boolean | null, postGlossariesPinned: boolean | null, generateJargonForDrafts: boolean | null, generateJargonForPublishedPosts: boolean | null, claudeLinkedAt: string | null, moderationGuidelines: (
    { __typename?: 'Revision' }
    & RevisionDisplay
  ) | null, expandedFrontpageSections: { __typename?: 'ExpandedFrontpageSectionsSettingsOutput', community: boolean | null, recommendations: boolean | null, quickTakes: boolean | null, quickTakesCommunity: boolean | null, popularComments: boolean | null } | null, hiddenPostsMetadata: Array<{ __typename?: 'PostMetadataOutput', postId: string }> | null }
  & UsersMinimumInfo
);

export type UsersCurrentCommentRateLimit = { __typename?: 'User', _id: string, rateLimitNextAbleToComment: any | null };

export type UsersCurrentPostRateLimit = { __typename?: 'User', _id: string, rateLimitNextAbleToPost: any | null };

export type UserKarmaChanges = { __typename?: 'User', _id: string, karmaChanges: { __typename?: 'KarmaChanges', totalChange: number, updateFrequency: string, startDate: string | null, endDate: string | null, nextBatchDate: string | null, posts: Array<{ __typename?: 'PostKarmaChange', _id: string, scoreChange: number, postId: string, title: string | null, slug: string, collectionName: string, addedReacts: Array<{ __typename?: 'ReactionChange', reactionType: string, userId: string | null, quote: string | null }> | null }>, comments: Array<{ __typename?: 'CommentKarmaChange', _id: string, scoreChange: number, commentId: string | null, description: string | null, postId: string | null, postTitle: string | null, postSlug: string | null, tagSlug: string | null, tagName: string | null, tagCommentType: TagCommentType | null, collectionName: string, addedReacts: Array<{ __typename?: 'ReactionChange', reactionType: string, userId: string | null, quote: string | null }> | null }>, tagRevisions: Array<{ __typename?: 'RevisionsKarmaChange', _id: string, scoreChange: number, tagId: string | null, tagSlug: string | null, tagName: string | null, collectionName: string, addedReacts: Array<{ __typename?: 'ReactionChange', reactionType: string, userId: string | null, quote: string | null }> | null }> } | null };

export type SunshineUsersList = (
  { __typename?: 'User', karma: number, htmlBio: string, website: string | null, createdAt: string, email: string | null, emails: Array<any> | null, commentCount: number, maxCommentCount: number, postCount: number, maxPostCount: number, shortformFeedId: string | null, voteCount: number | null, smallUpvoteCount: number | null, bigUpvoteCount: number | null, smallDownvoteCount: number | null, bigDownvoteCount: number | null, banned: string | null, reviewedByUserId: string | null, reviewedAt: string | null, signUpReCaptchaRating: number | null, mapLocation: any | null, mapMarkerText: string | null, htmlMapMarkerText: string | null, needsReview: boolean | null, sunshineNotes: string | null, sunshineFlagged: boolean | null, postingDisabled: boolean | null, allCommentingDisabled: boolean | null, commentingOnOtherUsersDisabled: boolean | null, conversationsDisabled: boolean | null, votingDisabled: boolean, snoozedUntilContentCount: number | null, nullifyVotes: boolean | null, deleteContent: boolean | null, reviewGroup: ReviewGroup | null, hasPendingComments: boolean | null, usersContactedBeforeReview: Array<string> | null, voteReceivedCount: number | null, smallUpvoteReceivedCount: number | null, bigUpvoteReceivedCount: number | null, smallDownvoteReceivedCount: number | null, bigDownvoteReceivedCount: number | null, recentKarmaInfo: any | null, lastNotificationsCheck: string | null, lastRemovedFromReviewQueueAt: string | null, rejectedContentCount: number | null, mailgunValidation: { __typename?: 'MailgunValidationResult', email: string | null, status: string | null, validatedAt: string | null, httpStatus: number | null, error: string | null, isValid: boolean | null, risk: string | null, reason: string | null, didYouMean: string | null, isDisposableAddress: boolean | null, isRoleAddress: boolean | null, sourceUserId: string | null } | null, moderatorActions: Array<(
    { __typename?: 'ModeratorAction' }
    & ModeratorActionDisplay
  )> | null, userRateLimits: Array<(
    { __typename?: 'UserRateLimit' }
    & UserRateLimitDisplay
  )> | null }
  & UsersMinimumInfo
);

export type UserAltAccountsFragment = (
  { __typename?: 'User', IPs: Array<string> | null, associatedClientIds: Array<{ __typename?: 'ClientId', clientId: string | null, firstSeenReferrer: string | null, firstSeenLandingPage: string | null, userIds: Array<string> | null }> | null }
  & SunshineUsersList
);

export type UserClientIdsInfo = { __typename?: 'User', _id: string, slug: string, altAccountsDetected: boolean | null, associatedClientIds: Array<{ __typename?: 'ClientId', clientId: string | null, firstSeenReferrer: string | null, firstSeenLandingPage: string | null, userIds: Array<string> | null }> | null };

export type UsersMapEntry = { __typename?: 'User', _id: string, displayName: string, username: string | null, fullName: string | null, slug: string, mapLocationSet: boolean | null, htmlMapMarkerText: string | null, mapLocationLatLng: { __typename?: 'LatLng', lat: number, lng: number } | null };

export type UsersEdit = (
  { __typename?: 'User', markDownPostEditor: boolean, hideElicitPredictions: boolean | null, hideAFNonMemberInitialWarning: boolean | null, hideIntercom: boolean, commentSorting: string | null, currentFrontpageFilter: string | null, noCollapseCommentsPosts: boolean, noCollapseCommentsFrontpage: boolean, noSingleLineComments: boolean, hideCommunitySection: boolean, showCommunityInRecentDiscussion: boolean, beta: boolean | null, theme: any | null, email: string | null, whenConfirmationEmailSent: string | null, emailSubscribedToCurated: boolean | null, unsubscribeFromAll: boolean | null, moderatorAssistance: boolean | null, collapseModerationGuidelines: boolean | null, bannedUserIds: Array<string> | null, bannedPersonalUserIds: Array<string> | null, noKibitz: boolean | null, showHideKarmaOption: boolean | null, nullifyVotes: boolean | null, deleteContent: boolean | null, banned: string | null, associatedOAuthServices: Array<string> | null, username: string | null, displayName: string, fullName: string | null, mongoLocation: any | null, googleLocation: any | null, location: string | null, mapLocation: any | null, hideFromPeopleDirectory: boolean, reviewedByUserId: string | null, reviewForAlignmentForumUserId: string | null, groups: Array<string> | null, afApplicationText: string | null, afSubmittedApplication: boolean | null, karmaChangeLastOpened: string | null, karmaChangeNotifierSettings: any | null, notificationShortformContent: any | null, notificationCommentsOnSubscribedPost: any | null, notificationRepliesToMyComments: any | null, notificationRepliesToSubscribedComments: any | null, notificationSubscribedUserPost: any | null, notificationSubscribedUserComment: any | null, notificationSubscribedTagPost: any | null, notificationSubscribedSequencePost: any | null, notificationPostsInGroups: any | null, notificationPrivateMessage: any | null, notificationSharedWithMe: any | null, notificationAlignmentSubmissionApproved: any | null, notificationEventInRadius: any | null, notificationRSVPs: any | null, notificationCommentsOnDraft: any | null, notificationPostsNominatedReview: any | null, notificationGroupAdministration: any | null, notificationSubforumUnread: any | null, notificationNewMention: any | null, notificationTypoSuggestions: any | null, notificationNewDialogueChecks: any | null, notificationYourTurnMatchForm: any | null, notificationDialogueMessages: any | null, notificationPublishedDialogueMessages: any | null, hideFrontpageMap: boolean | null, hideTaggingProgressBar: boolean | null, hideFrontpageBookAd: boolean | null, hideFrontpageBook2020Ad: boolean | null, deleted: boolean, permanentDeletionRequestedAt: string | null, twitterProfileURLAdmin: string | null, biography: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null, moderationGuidelines: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null }
  & UsersProfile
  & UsersCurrent
);

export type UsersWithReviewInfo = (
  { __typename?: 'User', reviewVoteCount: number | null, email: string | null }
  & UsersMinimumInfo
);

export type UsersProfileEdit = { __typename?: 'User', _id: string, slug: string, displayName: string, profileImageId: string | null, organizerOfGroupIds: Array<string>, programParticipation: Array<string> | null, mapLocation: any | null, website: string | null, linkedinProfileURL: string | null, facebookProfileURL: string | null, blueskyProfileURL: string | null, twitterProfileURL: string | null, githubProfileURL: string | null, biography: (
    { __typename?: 'Revision' }
    & RevisionEdit
  ) | null, organizerOfGroups: Array<(
    { __typename?: 'Localgroup' }
    & localGroupsBase
  )> };

export type UsersCrosspostInfo = { __typename?: 'User', _id: string, username: string | null, slug: string, fmCrosspostUserId: string | null };

export type SuggestAlignmentUser = (
  { __typename?: 'User', afKarma: number, afPostCount: number, afCommentCount: number, reviewForAlignmentForumUserId: string | null, groups: Array<string> | null, afApplicationText: string | null, afSubmittedApplication: boolean | null }
  & UsersMinimumInfo
);

export type UsersMergeSearchResult = (
  { __typename?: 'User', email: string | null, emails: Array<any> | null, associatedOAuthServices: Array<string> | null }
  & UsersMinimumInfo
);

export type TagRelVotes = { __typename?: 'Vote', _id: string, userId: string | null, voteType: VoteType, power: number | null, documentId: string, votedAt: string | null, isUnvote: boolean, tagRel: (
    { __typename?: 'TagRel' }
    & WithVoteTagRel
  ) | null };

export type TagVotingActivity = (
  { __typename?: 'Vote', tagRel: (
    { __typename?: 'TagRel' }
    & TagRelFragment
  ) | null }
  & TagRelVotes
);

export type UserVotes = { __typename?: 'Vote', _id: string, userId: string | null, voteType: VoteType, power: number | null, cancelled: boolean, documentId: string, votedAt: string | null, isUnvote: boolean, collectionName: string };

export type UserVotesWithDocument = (
  { __typename?: 'Vote', comment: (
    { __typename?: 'Comment' }
    & CommentsListWithParentMetadata
  ) | null, post: (
    { __typename?: 'Post' }
    & PostsListWithVotes
  ) | null }
  & UserVotes
);

export type getCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type getCurrentUserQuery = { __typename?: 'Query', currentUser: (
    { __typename?: 'User' }
    & UsersCurrent
  ) | null };

export type createLWEventwithNewEventsMutationVariables = Exact<{
  data: CreateLWEventDataInput;
}>;


export type createLWEventwithNewEventsMutation = { __typename?: 'Mutation', createLWEvent: { __typename?: 'LWEventOutput', data: (
      { __typename?: 'LWEvent' }
      & newEventFragment
    ) | null } | null };

export type Lightcone2024FundraiserStripeAmountsQueryVariables = Exact<{ [key: string]: never; }>;


export type Lightcone2024FundraiserStripeAmountsQuery = { __typename?: 'Query', Lightcone2024FundraiserStripeAmounts: Array<number> | null };

export type Lightcone2025FundraiserAirtableAmountsQueryVariables = Exact<{ [key: string]: never; }>;


export type Lightcone2025FundraiserAirtableAmountsQuery = { __typename?: 'Query', Lightcone2025FundraiserAirtableAmounts: number };

export type FeedPostFragment = { __typename?: 'FeedPost', _id: string, postMetaInfo: any | null, post: (
    { __typename?: 'Post' }
    & PostsListWithVotes
  ) };

export type FeedCommentThreadFragment = { __typename?: 'FeedCommentThread', _id: string, commentMetaInfos: any | null, postSources: Array<string> | null, postMetaInfo: any | null, post: (
    { __typename?: 'Post' }
    & PostsListWithVotes
  ) | null, comments: Array<(
    { __typename?: 'Comment' }
    & UltraFeedComment
  )> };

export type FeedSpotlightFragment = { __typename?: 'FeedSpotlightItem', _id: string, spotlight: (
    { __typename?: 'Spotlight' }
    & SpotlightDisplay
  ) | null, post: (
    { __typename?: 'Post' }
    & PostsListWithVotes
  ) | null, spotlightMetaInfo: { __typename?: 'FeedSpotlightMetaInfo', sources: Array<string>, servedEventId: string, rankingMetadata: any | null } | null };

export type FeedSubscriptionSuggestionsFragment = { __typename?: 'FeedSubscriptionSuggestions', _id: string, suggestedUsers: Array<(
    { __typename?: 'User' }
    & UsersMinimumInfo
  )> };

export type FeedMarkerFragment = { __typename?: 'FeedMarker', _id: string, markerType: string, timestamp: string };

export type multiPostsForAutocompleteQueryQueryVariables = Exact<{
  input?: InputMaybe<MultiPostInput>;
}>;


export type multiPostsForAutocompleteQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & PostsForAutocomplete
    )> } | null };

export type multiCommentsForAutocompleteQueryQueryVariables = Exact<{
  input?: InputMaybe<MultiCommentInput>;
}>;


export type multiCommentsForAutocompleteQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<(
      { __typename?: 'Comment' }
      & CommentsForAutocomplete
    )> } | null };

export type multiCommentsForAutocompleteWithParentsQueryQueryVariables = Exact<{
  input?: InputMaybe<MultiCommentInput>;
}>;


export type multiCommentsForAutocompleteWithParentsQueryQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<(
      { __typename?: 'Comment' }
      & CommentsForAutocompleteWithParents
    )> } | null };

export type EmailComment2QueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailComment2Query = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: (
      { __typename?: 'Comment' }
      & CommentsListWithParentMetadata
    ) | null } | null };

export type EmailComment1QueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailComment1Query = { __typename?: 'Query', tag: { __typename?: 'SingleTagOutput', result: (
      { __typename?: 'Tag' }
      & TagPreviewFragment
    ) | null } | null };

export type EmailCommentQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailCommentQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsList
    ) | null } | null };

export type EmailFooterRecommendationsQueryQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']['input']>;
  algorithm?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type EmailFooterRecommendationsQueryQuery = { __typename?: 'Query', Recommendations: Array<(
    { __typename?: 'Post' }
    & PostsListWithVotesAndSequence
  )> | null };

export type EmailUsernameByIDQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailUsernameByIDQuery = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null };

export type EventUpdatedEmailQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventUpdatedEmailQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsBase
    ) | null } | null };

export type NewDialogueMessagesEmail1QueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewDialogueMessagesEmail1Query = { __typename?: 'Query', user: { __typename?: 'SingleUserOutput', result: (
      { __typename?: 'User' }
      & UsersMinimumInfo
    ) | null } | null };

export type NewDialogueMessagesEmailQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewDialogueMessagesEmailQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsRevision
    ) | null } | null };

export type PostNominatedEmailQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostNominatedEmailQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsRevision
    ) | null } | null };

export type multiPostPostsEmailQueryQueryVariables = Exact<{
  selector?: InputMaybe<PostSelector>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  enableTotal?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type multiPostPostsEmailQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', totalCount: number | null, results: Array<(
      { __typename?: 'Post' }
      & PostsRevision
      & PostPodcastEpisode
    )> } | null };

export type PostMetadataQueryVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostMetadataQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: { __typename?: 'Post', _id: string, title: string, slug: string, isEvent: boolean, groupId: string | null, canonicalSource: string | null, coauthorUserIds: Array<string>, shortform: boolean, eventImageId: string | null, noIndex: boolean, rejected: boolean, baseScore: number, createdAt: string | null, socialPreviewData: { __typename?: 'SocialPreviewType', _id: string, imageUrl: string, text: string | null }, customHighlight: { __typename?: 'Revision', plaintextDescription: string } | null, contents: { __typename?: 'Revision', plaintextDescription: string } | null, user: { __typename?: 'User', _id: string, displayName: string } | null, coauthors: Array<{ __typename?: 'User', _id: string, displayName: string }> | null } | null } | null };

export type SequenceMetadataQueryVariables = Exact<{
  sequenceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SequenceMetadataQuery = { __typename?: 'Query', sequence: { __typename?: 'SingleSequenceOutput', result: { __typename?: 'Sequence', _id: string, title: string, bannerImageId: string | null, gridImageId: string | null, noindex: boolean, contents: { __typename?: 'Revision', plaintextDescription: string } | null } | null } | null };

export type CommentPermalinkMetadataQueryVariables = Exact<{
  commentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentPermalinkMetadataQuery = { __typename?: 'Query', comment: { __typename?: 'SingleCommentOutput', result: { __typename?: 'Comment', _id: string, postId: string | null, deleted: boolean, user: { __typename?: 'User', displayName: string } | null, contents: { __typename?: 'Revision', plaintextMainText: string } | null } | null } | null };

export type TagMetadataQueryVariables = Exact<{
  tagSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagMetadataQuery = { __typename?: 'Query', tags: { __typename?: 'MultiTagOutput', results: Array<{ __typename?: 'Tag', _id: string, name: string, slug: string, noindex: boolean, description: { __typename?: 'Revision', _id: string, plaintextDescription: string } | null }> } | null };

export type UserMetadataQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserMetadataQuery = { __typename?: 'Query', users: { __typename?: 'MultiUserOutput', results: Array<{ __typename?: 'User', _id: string, displayName: string, username: string | null, slug: string, profileImageId: string | null, postCount: number, commentCount: number, karma: number, noindex: boolean }> } | null };

export type singleDraftPostForLLMQueryQueryVariables = Exact<{
  input?: InputMaybe<SinglePostInput>;
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type singleDraftPostForLLMQueryQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsEditQueryFragment
    ) | null } | null };

export type singlePublishedPostForLLMQueryQueryVariables = Exact<{
  input?: InputMaybe<SinglePostInput>;
}>;


export type singlePublishedPostForLLMQueryQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: (
      { __typename?: 'Post' }
      & PostsPage
    ) | null } | null };

export type multiPostsForLLMQueryQueryVariables = Exact<{
  input?: InputMaybe<MultiPostInput>;
}>;


export type multiPostsForLLMQueryQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<(
      { __typename?: 'Post' }
      & PostsPage
    )> } | null };

export type GetReviewWinnersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReviewWinnersQuery = { __typename?: 'Query', GetAllReviewWinners: Array<(
    { __typename?: 'Post' }
    & PostsTopItemInfo
  )> };

export type postWithMarkdownForCoverImageQueryVariables = Exact<{
  input?: InputMaybe<SinglePostInput>;
}>;


export type postWithMarkdownForCoverImageQuery = { __typename?: 'Query', post: { __typename?: 'SinglePostOutput', result: { __typename?: 'Post', _id: string, title: string, contents: { __typename?: 'Revision', markdown: string | null } | null } | null } | null };

export type postsWithMarkdownForCoverImageQueryVariables = Exact<{
  input?: InputMaybe<MultiPostInput>;
}>;


export type postsWithMarkdownForCoverImageQuery = { __typename?: 'Query', posts: { __typename?: 'MultiPostOutput', results: Array<{ __typename?: 'Post', _id: string, title: string, contents: { __typename?: 'Revision', markdown: string | null } | null }> } | null };

export type CommentsForEmbeddingsQueryVariables = Exact<{
  selector?: InputMaybe<CommentSelector>;
}>;


export type CommentsForEmbeddingsQuery = { __typename?: 'Query', comments: { __typename?: 'MultiCommentOutput', results: Array<{ __typename?: 'Comment', _id: string, postedAt: string, contents: { __typename?: 'Revision', _id: string, html: string | null } | null, user: { __typename?: 'User', _id: string, displayName: string, username: string | null, fullName: string | null } | null, post: { __typename?: 'Post', _id: string, title: string } | null }> } | null };

export const PostsMinimumInfoDoc = _o1(_1,[_23]) as unknown as DocumentNode<PostsMinimumInfo, unknown>;
export const UserProfilePostDoc = _o1(_1,[_40,_23]) as unknown as DocumentNode<UserProfilePost, unknown>;
export const ProfileTopPostDoc = _o1(_1,[_44,_23]) as unknown as DocumentNode<ProfileTopPost, unknown>;
export const UsersMinimumInfoDoc = _o1(_1,[_61]) as unknown as DocumentNode<UsersMinimumInfo, unknown>;
export const SequenceSummaryFragmentDoc = _o1(_1,[_71,_61]) as unknown as DocumentNode<SequenceSummaryFragment, unknown>;
export const BookmarksMinimumInfoFragmentDoc = _o1(_1,[_75]) as unknown as DocumentNode<BookmarksMinimumInfoFragment, unknown>;
export const PostsBaseDoc = _o1(_1,[_127,_23]) as unknown as DocumentNode<PostsBase, unknown>;
export const PostsAuthorsDoc = _o1(_1,[_136,_61]) as unknown as DocumentNode<PostsAuthors, unknown>;
export const TagBasicInfoDoc = _o1(_1,[_146]) as unknown as DocumentNode<TagBasicInfo, unknown>;
export const TagPreviewFragmentDoc = _o1(_1,[_158,_146]) as unknown as DocumentNode<TagPreviewFragment, unknown>;
export const CommentsListDoc = _o1(_1,[_184,_146,_158,_61]) as unknown as DocumentNode<CommentsList, unknown>;
export const PostsListBaseDoc = _o1(_1,[_192,_23,_61,_146,_158,_127,_136,_184]) as unknown as DocumentNode<PostsListBase, unknown>;
export const PostsListDoc = _o1(_1,[_198,_23,_127,_61,_136,_146,_158,_184,_192]) as unknown as DocumentNode<PostsList, unknown>;
export const PostPodcastEpisodeDoc = _o1(_1,[_203]) as unknown as DocumentNode<PostPodcastEpisode, unknown>;
export const PostsListWithVotesDoc = _o1(_1,[_207,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203]) as unknown as DocumentNode<PostsListWithVotes, unknown>;
export const BookmarksWithDocumentFragmentDoc = _o1(_1,[_214,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_75,_207]) as unknown as DocumentNode<BookmarksWithDocumentFragment, unknown>;
export const UltraFeedCommentDoc = _o1(_1,[_217,_146,_158,_61,_23,_127,_136,_184,_192,_198,_203,_207]) as unknown as DocumentNode<UltraFeedComment, unknown>;
export const BookmarksFeedItemFragmentDoc = _o1(_1,[_223,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_75,_217]) as unknown as DocumentNode<BookmarksFeedItemFragment, unknown>;
export const RevisionDisplayDoc = _o1(_1,[_226]) as unknown as DocumentNode<RevisionDisplay, unknown>;
export const SequencesPageTitleFragmentDoc = _o1(_1,[_230]) as unknown as DocumentNode<SequencesPageTitleFragment, unknown>;
export const SequencesPageFragmentDoc = _o1(_1,[_239,_230,_61,_226]) as unknown as DocumentNode<SequencesPageFragment, unknown>;
export const ChapterPostSlimDoc = _o1(_1,[_241]) as unknown as DocumentNode<ChapterPostSlim, unknown>;
export const SlimChapterDoc = _o1(_1,[_251,_226,_241]) as unknown as DocumentNode<SlimChapter, unknown>;
export const SequencesPageWithChaptersFragmentDoc = _o1(_1,[_255,_230,_61,_226,_241,_239,_251]) as unknown as DocumentNode<SequencesPageWithChaptersFragment, unknown>;
export const BookPageFragmentDoc = _o1(_1,[_261,_230,_61,_226,_239,_241,_251,_23,_127,_136,_146,_158,_184,_192,_198,_203,_255,_207]) as unknown as DocumentNode<BookPageFragment, unknown>;
export const RevisionEditDoc = _o1(_1,[_270,_226]) as unknown as DocumentNode<RevisionEdit, unknown>;
export const BookEditDoc = _o1(_1,[_275,_226,_230,_61,_239,_241,_251,_255,_23,_127,_136,_146,_158,_184,_192,_198,_203,_207,_261,_270]) as unknown as DocumentNode<BookEdit, unknown>;
export const ChaptersFragmentDoc = _o1(_1,[_277,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_226,_207]) as unknown as DocumentNode<ChaptersFragment, unknown>;
export const ChaptersEditDoc = _o1(_1,[_280,_226,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_277,_270]) as unknown as DocumentNode<ChaptersEdit, unknown>;
export const CkEditorUserSessionInfoDoc = _o1(_1,[_o2(_2,_o3(_3,"CkEditorUserSessionInfo"),_o4(_5,_o3(_3,"CkEditorUserSession")),_o5(_7,[_10,_20,_282,_283,_o4(_8,_o3(_3,"endedBy"))]))]) as unknown as DocumentNode<CkEditorUserSessionInfo, unknown>;
export const ModeratorClientIDInfoDoc = _o1(_1,[_290,_61]) as unknown as DocumentNode<ModeratorClientIDInfo, unknown>;
export const CollectionContinueReadingFragmentDoc = _o1(_1,[_293]) as unknown as DocumentNode<CollectionContinueReadingFragment, unknown>;
export const CollectionsPageFragmentDoc = _o1(_1,[_298,_226,_230,_61,_239,_241,_251,_255,_23,_127,_136,_146,_158,_184,_192,_198,_203,_207,_261]) as unknown as DocumentNode<CollectionsPageFragment, unknown>;
export const CollectionsEditFragmentDoc = _o1(_1,[_301,_61,_226,_230,_239,_241,_251,_255,_23,_127,_136,_146,_158,_184,_192,_198,_203,_207,_261,_298,_270]) as unknown as DocumentNode<CollectionsEditFragment, unknown>;
export const ShortformCommentsDoc = _o1(_1,[_305,_146,_158,_61,_184,_23]) as unknown as DocumentNode<ShortformComments, unknown>;
export const FrontpageShortformCommentsDoc = _o1(_1,[_309,_146,_158,_61,_184,_23,_305]) as unknown as DocumentNode<FrontpageShortformComments, unknown>;
export const DraftCommentsDoc = _o1(_1,[_312,_146,_158,_61,_184,_23]) as unknown as DocumentNode<DraftComments, unknown>;
export const CommentWithRepliesFragmentDoc = _o1(_1,[_316,_146,_158,_61,_23,_184,_127]) as unknown as DocumentNode<CommentWithRepliesFragment, unknown>;
export const CommentEditDoc = _o1(_1,[_318,_146,_158,_61,_226,_184,_270]) as unknown as DocumentNode<CommentEdit, unknown>;
export const DeletedCommentsMetaDataDoc = _o1(_1,[_320]) as unknown as DocumentNode<DeletedCommentsMetaData, unknown>;
export const CommentsListWithParentMetadataDoc = _o1(_1,[_322,_146,_158,_61,_184,_23]) as unknown as DocumentNode<CommentsListWithParentMetadata, unknown>;
export const AutomatedContentEvaluationsFragmentDoc = _o1(_1,[_335]) as unknown as DocumentNode<AutomatedContentEvaluationsFragment, unknown>;
export const SunshineCommentsListDoc = _o1(_1,[_340,_146,_158,_61,_184,_23,_322,_335]) as unknown as DocumentNode<SunshineCommentsList, unknown>;
export const WithVoteCommentDoc = _o1(_1,[_344]) as unknown as DocumentNode<WithVoteComment, unknown>;
export const PostsForAutocompleteDoc = _o1(_1,[_347,_61]) as unknown as DocumentNode<PostsForAutocomplete, unknown>;
export const CommentsForAutocompleteDoc = _o1(_1,[_350,_61,_347]) as unknown as DocumentNode<CommentsForAutocomplete, unknown>;
export const CommentsForAutocompleteWithParentsDoc = _o1(_1,[_354,_61,_347,_350]) as unknown as DocumentNode<CommentsForAutocompleteWithParents, unknown>;
export const SuggestAlignmentCommentDoc = _o1(_1,[_357,_146,_158,_61,_184,_23]) as unknown as DocumentNode<SuggestAlignmentComment, unknown>;
export const CommentsMarkdownFragmentDoc = _o1(_1,[_361]) as unknown as DocumentNode<CommentsMarkdownFragment, unknown>;
export const ConversationsMinimumInfoDoc = _o1(_1,[_366]) as unknown as DocumentNode<ConversationsMinimumInfo, unknown>;
export const messageListFragmentDoc = _o1(_1,[_371,_61]) as unknown as DocumentNode<messageListFragment, unknown>;
export const ConversationsListDoc = _o1(_1,[_375,_61,_366,_371]) as unknown as DocumentNode<ConversationsList, unknown>;
export const ConversationsListWithReadStatusDoc = _o1(_1,[_378,_366,_61,_371,_375]) as unknown as DocumentNode<ConversationsListWithReadStatus, unknown>;
export const ElicitQuestionFragmentDoc = _o1(_1,[_383]) as unknown as DocumentNode<ElicitQuestionFragment, unknown>;
export const FieldChangeFragmentDoc = _o1(_1,[_387]) as unknown as DocumentNode<FieldChangeFragment, unknown>;
export const GoogleServiceAccountSessionAdminInfoDoc = _o1(_1,[_391]) as unknown as DocumentNode<GoogleServiceAccountSessionAdminInfo, unknown>;
export const JargonTermsDoc = _o1(_1,[_398,_226,_270]) as unknown as DocumentNode<JargonTerms, unknown>;
export const LlmConversationsFragmentDoc = _o1(_1,[_401]) as unknown as DocumentNode<LlmConversationsFragment, unknown>;
export const LlmConversationsViewingPageFragmentDoc = _o1(_1,[_404,_401,_61]) as unknown as DocumentNode<LlmConversationsViewingPageFragment, unknown>;
export const LlmMessagesFragmentDoc = _o1(_1,[_407]) as unknown as DocumentNode<LlmMessagesFragment, unknown>;
export const LlmConversationsWithMessagesFragmentDoc = _o1(_1,[_410,_401,_407]) as unknown as DocumentNode<LlmConversationsWithMessagesFragment, unknown>;
export const localGroupsBaseDoc = _o1(_1,[_415,_61]) as unknown as DocumentNode<localGroupsBase, unknown>;
export const localGroupsHomeFragmentDoc = _o1(_1,[_418,_61,_415,_226]) as unknown as DocumentNode<localGroupsHomeFragment, unknown>;
export const localGroupsEditDoc = _o1(_1,[_420,_61,_226,_415,_270]) as unknown as DocumentNode<localGroupsEdit, unknown>;
export const localGroupsIsOnlineDoc = _o1(_1,[_422]) as unknown as DocumentNode<localGroupsIsOnline, unknown>;
export const newEventFragmentDoc = _o1(_1,[_428]) as unknown as DocumentNode<newEventFragment, unknown>;
export const lastEventFragmentDoc = _o1(_1,[_430]) as unknown as DocumentNode<lastEventFragment, unknown>;
export const emailHistoryFragmentDoc = _o1(_1,[_432]) as unknown as DocumentNode<emailHistoryFragment, unknown>;
export const WithVoteMessageDoc = _o1(_1,[_435]) as unknown as DocumentNode<WithVoteMessage, unknown>;
export const ModerationTemplateFragmentDoc = _o1(_1,[_438,_226,_270]) as unknown as DocumentNode<ModerationTemplateFragment, unknown>;
export const MultiDocumentMinimumInfoDoc = _o1(_1,[_446]) as unknown as DocumentNode<MultiDocumentMinimumInfo, unknown>;
export const WithVoteMultiDocumentDoc = _o1(_1,[_450,_446]) as unknown as DocumentNode<WithVoteMultiDocument, unknown>;
export const NotificationsListDoc = _o1(_1,[_456]) as unknown as DocumentNode<NotificationsList, unknown>;
export const PetrovDayActionInfoDoc = _o1(_1,[_458]) as unknown as DocumentNode<PetrovDayActionInfo, unknown>;
export const PodcastEpisodeCreateFragmentDoc = _o1(_1,[_463]) as unknown as DocumentNode<PodcastEpisodeCreateFragment, unknown>;
export const PodcastEpisodeFullDoc = _o1(_1,[_465]) as unknown as DocumentNode<PodcastEpisodeFull, unknown>;
export const PodcastSelectDoc = _o1(_1,[_467]) as unknown as DocumentNode<PodcastSelect, unknown>;
export const SplashArtCoordinatesDoc = _o1(_1,[_471]) as unknown as DocumentNode<SplashArtCoordinates, unknown>;
export const SplashArtCoordinatesEditDoc = _o1(_1,[_474,_471]) as unknown as DocumentNode<SplashArtCoordinatesEdit, unknown>;
export const ReviewWinnerTopPostsPageDoc = _o1(_1,[_484,_471,_474]) as unknown as DocumentNode<ReviewWinnerTopPostsPage, unknown>;
export const PostsTopItemInfoDoc = _o1(_1,[_488,_471,_474,_23,_484]) as unknown as DocumentNode<PostsTopItemInfo, unknown>;
export const PostsWithVotesDoc = _o1(_1,[_o2(_2,_o3(_3,"PostsWithVotes"),_6,_o5(_7,[_186,_144,_145])),_23,_127]) as unknown as DocumentNode<PostsWithVotes, unknown>;
export const PostsListWithVotesAndSequenceDoc = _o1(_1,[_492,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_230,_226,_207,_239]) as unknown as DocumentNode<PostsListWithVotesAndSequence, unknown>;
export const RSSFeedMinimumInfoDoc = _o1(_1,[_499,_61]) as unknown as DocumentNode<RSSFeedMinimumInfo, unknown>;
export const PostsDetailsDoc = _o1(_1,[_506,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_499,_207]) as unknown as DocumentNode<PostsDetails, unknown>;
export const UltraFeedPostFragmentDoc = _o1(_1,[_510,_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506]) as unknown as DocumentNode<UltraFeedPostFragment, unknown>;
export const PostsReviewVotingListDoc = _o1(_1,[_516,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<PostsReviewVotingList, unknown>;
export const PostsModerationGuidelinesDoc = _o1(_1,[_519,_23]) as unknown as DocumentNode<PostsModerationGuidelines, unknown>;
export const MarkdownPostsListDoc = _o1(_1,[_521,_23,_127,_61,_136,_146,_158,_184,_192]) as unknown as DocumentNode<MarkdownPostsList, unknown>;
export const CurationNoticesFragmentDoc = _o1(_1,[_525,_146,_158,_61,_226,_184,_23,_270]) as unknown as DocumentNode<CurationNoticesFragment, unknown>;
export const SunshineCurationPostsListDoc = _o1(_1,[_529,_23,_127,_61,_136,_146,_158,_184,_192,_226,_270,_198,_525]) as unknown as DocumentNode<SunshineCurationPostsList, unknown>;
export const SunshineCurationPostsListItemDoc = _o1(_1,[_531]) as unknown as DocumentNode<SunshineCurationPostsListItem, unknown>;
export const WithVoteTagRelDoc = _o1(_1,[_534]) as unknown as DocumentNode<WithVoteTagRel, unknown>;
export const PostsListTagDoc = _o1(_1,[_o2(_2,_o3(_3,"PostsListTag"),_6,_o5(_7,[_205,_541])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_534]) as unknown as DocumentNode<PostsListTag, unknown>;
export const PostsListTagWithVotesDoc = _o1(_1,[_543,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_534]) as unknown as DocumentNode<PostsListTagWithVotes, unknown>;
export const PostsExpandedHighlightDoc = _o1(_1,[_545]) as unknown as DocumentNode<PostsExpandedHighlight, unknown>;
export const PostsPlaintextDescriptionDoc = _o1(_1,[_548]) as unknown as DocumentNode<PostsPlaintextDescription, unknown>;
export const RevisionMetadataDoc = _o1(_1,[_550]) as unknown as DocumentNode<RevisionMetadata, unknown>;
export const PostsRevisionDoc = _o1(_1,[_558,_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_550]) as unknown as DocumentNode<PostsRevision, unknown>;
export const PostSequenceNavigationDoc = _o1(_1,[_568,_230,_61,_226,_23,_127,_136,_146,_158,_184,_192,_198,_203,_239,_207]) as unknown as DocumentNode<PostSequenceNavigation, unknown>;
export const ReviewWinnerArtImagesDoc = _o1(_1,[_570,_471,_474]) as unknown as DocumentNode<ReviewWinnerArtImages, unknown>;
export const ReviewWinnerAllDoc = _o1(_1,[_574,_471,_474,_570]) as unknown as DocumentNode<ReviewWinnerAll, unknown>;
export const JargonTermsPostDoc = _o1(_1,[_576,_226]) as unknown as DocumentNode<JargonTermsPost, unknown>;
export const PostsWithNavigationAndRevisionDoc = _o1(_1,[_582,_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_550,_230,_239,_471,_474,_570,_558,_568,_574,_576]) as unknown as DocumentNode<PostsWithNavigationAndRevision, unknown>;
export const PostsPageDoc = _o1(_1,[_586,_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226]) as unknown as DocumentNode<PostsPage, unknown>;
export const PostsWithNavigationDoc = _o1(_1,[_591,_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_230,_239,_471,_474,_570,_586,_568,_574,_576]) as unknown as DocumentNode<PostsWithNavigation, unknown>;
export const PostsEditDoc = _o1(_1,[_595,_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_226,_506,_270]) as unknown as DocumentNode<PostsEdit, unknown>;
export const PostsEditQueryFragmentDoc = _o1(_1,[_599,_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595]) as unknown as DocumentNode<PostsEditQueryFragment, unknown>;
export const PostsEditMutationFragmentDoc = _o1(_1,[_601,_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595]) as unknown as DocumentNode<PostsEditMutationFragment, unknown>;
export const PostsRevisionsListDoc = _o1(_1,[_603,_550]) as unknown as DocumentNode<PostsRevisionsList, unknown>;
export const PostsRecentDiscussionDoc = _o1(_1,[_614,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<PostsRecentDiscussion, unknown>;
export const CommentsListWithTopLevelCommentDoc = _o1(_1,[_617,_146,_158,_61,_184]) as unknown as DocumentNode<CommentsListWithTopLevelComment, unknown>;
export const ShortformRecentDiscussionDoc = _o1(_1,[_620,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_617]) as unknown as DocumentNode<ShortformRecentDiscussion, unknown>;
export const UsersBannedFromPostsModerationLogDoc = _o1(_1,[_o2(_2,_o3(_3,"UsersBannedFromPostsModerationLog"),_6,_o5(_7,[_68,_14,_12,_10,_129])),_61]) as unknown as DocumentNode<UsersBannedFromPostsModerationLog, unknown>;
export const ModeratorActionDisplayDoc = _o1(_1,[_622,_61]) as unknown as DocumentNode<ModeratorActionDisplay, unknown>;
export const TagRelBasicInfoDoc = _o1(_1,[_624]) as unknown as DocumentNode<TagRelBasicInfo, unknown>;
export const TagRelMinimumFragmentDoc = _o1(_1,[_629,_146,_624,_158]) as unknown as DocumentNode<TagRelMinimumFragment, unknown>;
export const SunshinePostsListDoc = _o1(_1,[_639,_23,_127,_61,_136,_146,_158,_184,_624,_192,_335,_226,_622,_629]) as unknown as DocumentNode<SunshinePostsList, unknown>;
export const WithVotePostDoc = _o1(_1,[_641]) as unknown as DocumentNode<WithVotePost, unknown>;
export const HighlightWithHashDoc = _o1(_1,[_647]) as unknown as DocumentNode<HighlightWithHash, unknown>;
export const PostWithDialogueMessageDoc = _o1(_1,[_651]) as unknown as DocumentNode<PostWithDialogueMessage, unknown>;
export const PostsBestOfListDoc = _o1(_1,[_o2(_2,_o3(_3,"PostsBestOfList"),_6,_o5(_7,[_211,_202,_503,_o4(_8,_o3(_3,"firstVideoAttribsForPreview"))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<PostsBestOfList, unknown>;
export const PostsRSSFeedDoc = _o1(_1,[_o2(_2,_o3(_3,"PostsRSSFeed"),_6,_o5(_7,[_508,_235,_o4(_8,_o3(_3,"scoreExceeded2Date")),_o4(_8,_o3(_3,"scoreExceeded30Date")),_o4(_8,_o3(_3,"scoreExceeded45Date")),_o4(_8,_o3(_3,"scoreExceeded75Date")),_o4(_8,_o3(_3,"scoreExceeded125Date")),_o4(_8,_o3(_3,"scoreExceeded200Date")),_o4(_8,_o3(_3,"metaDate"))])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226]) as unknown as DocumentNode<PostsRSSFeed, unknown>;
export const PostsOriginalContentsDoc = _o1(_1,[_o2(_2,_o3(_3,"PostsOriginalContents"),_6,_o5(_7,[_10,_o6(_8,_36,_o5(_7,[_10,_268]))]))]) as unknown as DocumentNode<PostsOriginalContents, unknown>;
export const RevisionHTMLDoc = _o1(_1,[_653]) as unknown as DocumentNode<RevisionHTML, unknown>;
export const PostsHTMLDoc = _o1(_1,[_o2(_2,_o3(_3,"PostsHTML"),_6,_o5(_7,[_10,_o6(_8,_36,_o5(_7,[_o4(_25,_652)]))])),_653]) as unknown as DocumentNode<PostsHTML, unknown>;
export const SuggestAlignmentPostDoc = _o1(_1,[_655,_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<SuggestAlignmentPost, unknown>;
export const UserRateLimitDisplayDoc = _o1(_1,[_661,_61]) as unknown as DocumentNode<UserRateLimitDisplay, unknown>;
export const SunshineUsersListDoc = _o1(_1,[_681,_61,_622,_661]) as unknown as DocumentNode<SunshineUsersList, unknown>;
export const UnclaimedReportsListDoc = _o1(_1,[_688,_146,_158,_61,_23,_127,_136,_184,_192,_622,_661,_198,_681]) as unknown as DocumentNode<UnclaimedReportsList, unknown>;
export const reviewVoteFragmentDoc = _o1(_1,[_694]) as unknown as DocumentNode<reviewVoteFragment, unknown>;
export const reviewAdminDashboardDoc = _o1(_1,[_696]) as unknown as DocumentNode<reviewAdminDashboard, unknown>;
export const ReviewWinnerAnnouncementDoc = _o1(_1,[_698]) as unknown as DocumentNode<ReviewWinnerAnnouncement, unknown>;
export const RevisionMetadataWithChangeMetricsDoc = _o1(_1,[_701,_550,_61]) as unknown as DocumentNode<RevisionMetadataWithChangeMetrics, unknown>;
export const RevisionHistoryEntryDoc = _o1(_1,[_703,_550,_61]) as unknown as DocumentNode<RevisionHistoryEntry, unknown>;
export const RevisionHistorySummaryEditDoc = _o1(_1,[_706,_550,_61,_703,_446]) as unknown as DocumentNode<RevisionHistorySummaryEdit, unknown>;
export const TagDetailsFragmentDoc = _o1(_1,[_708,_230,_61,_226,_146,_239]) as unknown as DocumentNode<TagDetailsFragment, unknown>;
export const TagFragmentDoc = _o1(_1,[_711,_146,_61,_230,_226,_239,_708]) as unknown as DocumentNode<TagFragment, unknown>;
export const MultiDocumentContentDisplayDoc = _o1(_1,[_714,_226,_446,_270]) as unknown as DocumentNode<MultiDocumentContentDisplay, unknown>;
export const TagHistoryFragmentDoc = _o1(_1,[_719,_146,_61,_230,_226,_239,_708,_446,_270,_711,_714]) as unknown as DocumentNode<TagHistoryFragment, unknown>;
export const ArbitalLinkedPagesFragmentDoc = _o1(_1,[_722]) as unknown as DocumentNode<ArbitalLinkedPagesFragment, unknown>;
export const MultiDocumentEditDoc = _o1(_1,[_726,_446,_226,_270,_714,_722]) as unknown as DocumentNode<MultiDocumentEdit, unknown>;
export const MultiDocumentParentDocumentDoc = _o1(_1,[_730,_446,_226,_270,_714,_722,_146,_61,_230,_239,_708,_711,_726,_719]) as unknown as DocumentNode<MultiDocumentParentDocument, unknown>;
export const RevisionTagFragmentDoc = _o1(_1,[_735,_550,_61,_146,_230,_226,_239,_708,_711,_446,_270,_714,_722,_726,_719,_703,_730]) as unknown as DocumentNode<RevisionTagFragment, unknown>;
export const TagRecentDiscussionDoc = _o1(_1,[_739,_146,_61,_230,_226,_239,_708,_158,_711,_184]) as unknown as DocumentNode<TagRecentDiscussion, unknown>;
export const RecentDiscussionRevisionTagFragmentDoc = _o1(_1,[_742,_550,_61,_146,_230,_226,_239,_708,_711,_158,_184,_703,_739]) as unknown as DocumentNode<RecentDiscussionRevisionTagFragment, unknown>;
export const WithVoteRevisionDoc = _o1(_1,[_744]) as unknown as DocumentNode<WithVoteRevision, unknown>;
export const newRSSFeedFragmentDoc = _o1(_1,[_746]) as unknown as DocumentNode<newRSSFeedFragment, unknown>;
export const SequenceContinueReadingFragmentDoc = _o1(_1,[_748]) as unknown as DocumentNode<SequenceContinueReadingFragment, unknown>;
export const SequencesEditDoc = _o1(_1,[_750,_230,_61,_226,_239,_270]) as unknown as DocumentNode<SequencesEdit, unknown>;
export const SpotlightMinimumInfoDoc = _o1(_1,[_755]) as unknown as DocumentNode<SpotlightMinimumInfo, unknown>;
export const SpotlightHeaderEventSubtitleDoc = _o1(_1,[_o2(_2,_o3(_3,"SpotlightHeaderEventSubtitle"),_752,_o5(_7,[_756,_o6(_8,_210,_166),_o6(_8,_560,_566),_167])),_755]) as unknown as DocumentNode<SpotlightHeaderEventSubtitle, unknown>;
export const SpotlightEditQueryFragmentDoc = _o1(_1,[_759,_226,_755,_270]) as unknown as DocumentNode<SpotlightEditQueryFragment, unknown>;
export const SubscriptionStateDoc = _o1(_1,[_762]) as unknown as DocumentNode<SubscriptionState, unknown>;
export const MembersOfGroupFragmentDoc = _o1(_1,[_764,_61]) as unknown as DocumentNode<MembersOfGroupFragment, unknown>;
export const TagFlagFragmentDoc = _o1(_1,[_767]) as unknown as DocumentNode<TagFlagFragment, unknown>;
export const TagFlagEditFragmentDoc = _o1(_1,[_770,_226,_767,_270]) as unknown as DocumentNode<TagFlagEditFragment, unknown>;
export const TagRelHistoryFragmentDoc = _o1(_1,[_772,_23,_127,_61,_136,_146,_158,_184,_192,_624,_198]) as unknown as DocumentNode<TagRelHistoryFragment, unknown>;
export const TagRelCreationFragmentDoc = _o1(_1,[_774,_146,_23,_127,_61,_136,_158,_184,_192,_624,_198,_534]) as unknown as DocumentNode<TagRelCreationFragment, unknown>;
export const TagCreationHistoryFragmentDoc = _o1(_1,[_777,_146,_61,_230,_226,_239,_708,_711]) as unknown as DocumentNode<TagCreationHistoryFragment, unknown>;
export const TagSectionPreviewFragmentDoc = _o1(_1,[_779,_146]) as unknown as DocumentNode<TagSectionPreviewFragment, unknown>;
export const TagWithFlagsFragmentDoc = _o1(_1,[_785,_146,_61,_230,_226,_239,_708,_711,_767]) as unknown as DocumentNode<TagWithFlagsFragment, unknown>;
export const TagPageFragmentDoc = _o1(_1,[_801,_146,_61,_230,_226,_239,_708,_711,_767,_23,_127,_136,_158,_184,_192,_198,_203,_785,_207]) as unknown as DocumentNode<TagPageFragment, unknown>;
export const MultiDocumentWithContributorsDoc = _o1(_1,[_803,_446,_226,_270,_714,_722,_726,_61]) as unknown as DocumentNode<MultiDocumentWithContributors, unknown>;
export const TagPageArbitalContentFragmentDoc = _o1(_1,[_806,_446,_226,_270,_714,_722,_726,_61,_803]) as unknown as DocumentNode<TagPageArbitalContentFragment, unknown>;
export const TagPageWithArbitalContentFragmentDoc = _o1(_1,[_810,_146,_61,_230,_226,_239,_708,_711,_767,_785,_23,_127,_136,_158,_184,_192,_198,_203,_207,_446,_270,_714,_722,_726,_803,_801,_806]) as unknown as DocumentNode<TagPageWithArbitalContentFragment, unknown>;
export const AllTagsPageFragmentDoc = _o1(_1,[_812,_146,_61,_230,_226,_239,_708,_711,_767,_785]) as unknown as DocumentNode<AllTagsPageFragment, unknown>;
export const TagRevisionFragmentDoc = _o1(_1,[_814,_146,_61,_230,_226,_239,_708]) as unknown as DocumentNode<TagRevisionFragment, unknown>;
export const TagWithFlagsAndRevisionFragmentDoc = _o1(_1,[_816,_146,_61,_230,_226,_239,_708,_814,_767]) as unknown as DocumentNode<TagWithFlagsAndRevisionFragment, unknown>;
export const TagPageWithRevisionFragmentDoc = _o1(_1,[_819,_146,_61,_230,_226,_239,_708,_814,_767,_23,_127,_136,_158,_184,_192,_198,_203,_816,_207]) as unknown as DocumentNode<TagPageWithRevisionFragment, unknown>;
export const TagPageRevisionWithArbitalContentFragmentDoc = _o1(_1,[_822,_146,_61,_230,_226,_239,_708,_814,_767,_816,_23,_127,_136,_158,_184,_192,_198,_203,_207,_446,_270,_714,_722,_726,_803,_819,_806]) as unknown as DocumentNode<TagPageRevisionWithArbitalContentFragment, unknown>;
export const TagFullContributorsListDoc = _o1(_1,[_824,_61]) as unknown as DocumentNode<TagFullContributorsList, unknown>;
export const TagEditFragmentDoc = _o1(_1,[_826,_146,_61,_230,_226,_239,_708,_270]) as unknown as DocumentNode<TagEditFragment, unknown>;
export const SunshineTagFragmentDoc = _o1(_1,[_828,_146,_61,_230,_226,_239,_708,_711]) as unknown as DocumentNode<SunshineTagFragment, unknown>;
export const ExplorePageTagFragmentDoc = _o1(_1,[_830,_146,_61,_230,_226,_239,_708,_711]) as unknown as DocumentNode<ExplorePageTagFragment, unknown>;
export const ConceptItemFragmentDoc = _o1(_1,[_833]) as unknown as DocumentNode<ConceptItemFragment, unknown>;
export const MultiDocumentRevisionDoc = _o1(_1,[_835,_226,_446,_270]) as unknown as DocumentNode<MultiDocumentRevision, unknown>;
export const MultiDocumentWithContributorsRevisionDoc = _o1(_1,[_837,_446,_226,_270,_835,_61,_722]) as unknown as DocumentNode<MultiDocumentWithContributorsRevision, unknown>;
export const TagPageWithArbitalContentAndLensRevisionFragmentDoc = _o1(_1,[_841,_146,_61,_230,_226,_239,_708,_711,_767,_785,_23,_127,_136,_158,_184,_192,_198,_203,_207,_446,_270,_835,_722,_801,_837]) as unknown as DocumentNode<TagPageWithArbitalContentAndLensRevisionFragment, unknown>;
export const WithVoteTagDoc = _o1(_1,[_843,_146]) as unknown as DocumentNode<WithVoteTag, unknown>;
export const TypoSuggestionsDefaultFragmentDoc = _o1(_1,[_846,_61]) as unknown as DocumentNode<TypoSuggestionsDefaultFragment, unknown>;
export const UserMostValuablePostInfoDoc = _o1(_1,[_848]) as unknown as DocumentNode<UserMostValuablePostInfo, unknown>;
export const UserRateLimitMutationFragmentDoc = _o1(_1,[_850]) as unknown as DocumentNode<UserRateLimitMutationFragment, unknown>;
export const UsersCurrentCommentRateLimitDoc = _o1(_1,[_855]) as unknown as DocumentNode<UsersCurrentCommentRateLimit, unknown>;
export const UsersCurrentPostRateLimitDoc = _o1(_1,[_859]) as unknown as DocumentNode<UsersCurrentPostRateLimit, unknown>;
export const UserKarmaChangesDoc = _o1(_1,[_878]) as unknown as DocumentNode<UserKarmaChanges, unknown>;
export const UserAltAccountsFragmentDoc = _o1(_1,[_882,_61,_622,_661,_681]) as unknown as DocumentNode<UserAltAccountsFragment, unknown>;
export const UserClientIdsInfoDoc = _o1(_1,[_884]) as unknown as DocumentNode<UserClientIdsInfo, unknown>;
export const UsersMapEntryDoc = _o1(_1,[_892]) as unknown as DocumentNode<UsersMapEntry, unknown>;
export const UsersProfileDoc = _o1(_1,[_906,_61,_226]) as unknown as DocumentNode<UsersProfile, unknown>;
export const UsersCurrentDoc = _o1(_1,[_934,_61,_226]) as unknown as DocumentNode<UsersCurrent, unknown>;
export const UsersEditDoc = _o1(_1,[_943,_61,_226,_906,_934,_270]) as unknown as DocumentNode<UsersEdit, unknown>;
export const UsersWithReviewInfoDoc = _o1(_1,[_o2(_2,_o3(_3,"UsersWithReviewInfo"),_46,_o5(_7,[_66,_119,_390])),_61]) as unknown as DocumentNode<UsersWithReviewInfo, unknown>;
export const UsersProfileEditDoc = _o1(_1,[_o2(_2,_o3(_3,"UsersProfileEdit"),_46,_o5(_7,[_10,_12,_31,_50,_938,_894,_o6(_8,_o3(_3,"organizerOfGroups"),_944),_o4(_8,_o3(_3,"programParticipation")),_668,_102,_895,_896,_897,_898,_899])),_226,_61,_270,_415]) as unknown as DocumentNode<UsersProfileEdit, unknown>;
export const UsersCrosspostInfoDoc = _o1(_1,[_946]) as unknown as DocumentNode<UsersCrosspostInfo, unknown>;
export const SuggestAlignmentUserDoc = _o1(_1,[_948,_61]) as unknown as DocumentNode<SuggestAlignmentUser, unknown>;
export const UsersMergeSearchResultDoc = _o1(_1,[_950,_61]) as unknown as DocumentNode<UsersMergeSearchResult, unknown>;
export const TagRelVotesDoc = _o1(_1,[_958,_534]) as unknown as DocumentNode<TagRelVotes, unknown>;
export const TagRelFragmentDoc = _o1(_1,[_960,_146,_23,_127,_61,_136,_158,_184,_192,_624,_198]) as unknown as DocumentNode<TagRelFragment, unknown>;
export const TagVotingActivityDoc = _o1(_1,[_963,_534,_624,_146,_158,_23,_127,_61,_136,_184,_192,_198,_958,_960]) as unknown as DocumentNode<TagVotingActivity, unknown>;
export const UserVotesDoc = _o1(_1,[_965]) as unknown as DocumentNode<UserVotes, unknown>;
export const UserVotesWithDocumentDoc = _o1(_1,[_969,_146,_158,_61,_184,_23,_127,_136,_192,_198,_203,_965,_322,_207]) as unknown as DocumentNode<UserVotesWithDocument, unknown>;
export const FeedPostFragmentDoc = _o1(_1,[_972,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<FeedPostFragment, unknown>;
export const FeedCommentThreadFragmentDoc = _o1(_1,[_974,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_217]) as unknown as DocumentNode<FeedCommentThreadFragment, unknown>;
export const SpotlightDisplayDoc = _o1(_1,[_976,_755,_61]) as unknown as DocumentNode<SpotlightDisplay, unknown>;
export const FeedSpotlightFragmentDoc = _o1(_1,[_981,_755,_61,_23,_127,_136,_146,_158,_184,_192,_198,_203,_976,_207]) as unknown as DocumentNode<FeedSpotlightFragment, unknown>;
export const FeedSubscriptionSuggestionsFragmentDoc = _o1(_1,[_983,_61]) as unknown as DocumentNode<FeedSubscriptionSuggestionsFragment, unknown>;
export const FeedMarkerFragmentDoc = _o1(_1,[_985]) as unknown as DocumentNode<FeedMarkerFragment, unknown>;
export const RunPangramOnTextDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"RunPangramOnText"),[_o12(_988,_989,_992),_o12(_988,_994,_o4(_5,_o3(_3,"PangramModel")))],_o5(_7,[_o7(_8,_o3(_3,"runPangramOnText"),[_o8(_536,_329,_989),_o8(_536,_993,_994)],_o5(_7,[_o4(_8,_o3(_3,"analyzedText")),_324,_325,_326,_327,_o6(_8,_328,_o5(_7,[_330,_87,_331,_332]))]))]))]) as unknown as DocumentNode<RunPangramOnTextMutation, RunPangramOnTextMutationVariables>;
export const MarkdownCollectionByDocumentIdDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MarkdownCollectionByDocumentId"),_998,_o5(_7,[_o7(_8,_999,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_12,_14,_295,_1009,_o6(_8,_296,_o5(_7,[_10,_14,_245,_249,_258,_o6(_8,_259,_228)]))]))]))]))]) as unknown as DocumentNode<MarkdownCollectionByDocumentIdQuery, MarkdownCollectionByDocumentIdQueryVariables>;
export const MarkdownCollectionPostsByDocumentIdDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MarkdownCollectionPostsByDocumentId"),_998,_o5(_7,[_o7(_8,_999,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_o6(_8,_296,_o5(_7,[_10,_1010,_o6(_8,_259,_o5(_7,[_10,_o6(_8,_254,_o5(_7,[_10,_1010]))]))]))]))]))]))]) as unknown as DocumentNode<MarkdownCollectionPostsByDocumentIdQuery, MarkdownCollectionPostsByDocumentIdQueryVariables>;
export const MarkdownCommunityPageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MarkdownCommunityPage"),[_o12(_988,_1011,_1012),_o12(_988,_1013,_1012),_o12(_988,_1014,_1015),_o12(_988,_1016,_1015),_o12(_988,_1017,_1019)],_o5(_7,[_o15(_8,_o3(_3,"upcomingInPerson"),_250,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1020,_o14(_1001,[_1023,_o8(_1002,_96,_1022)]))])),_1024],_1027),_o15(_8,_1028,_250,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1028,_1029)])),_1024],_1027),_o16(_8,_o3(_3,"nearbyInPerson"),_250,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"nearbyEvents"),_o14(_1001,[_o8(_1002,_887,_1014),_o8(_1002,_889,_1016),_1023]))])),_o8(_536,_793,_1013)],[_o10("Directive",_o3(_3,"include"),[_o8(_536,_o3(_3,"if"),_1017)])],_1027)]))]) as unknown as DocumentNode<MarkdownCommunityPageQuery, MarkdownCommunityPageQueryVariables>;
export const MarkdownFrontPageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MarkdownFrontPage"),[_o12(_988,_1030,_1012),_o12(_988,_1031,_1012)],_o5(_7,[_o6(_8,_1032,_o5(_7,[_10,_753,_754,_1033,_o6(_8,_560,_228),_o6(_8,_165,_721)])),_o15(_8,_1034,_250,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1034,_1029)])),_1036],_1038),_o15(_8,_o3(_3,"recent"),_250,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"magic"),_1029)])),_o8(_536,_793,_1030)],_1038),_o15(_8,_o3(_3,"latest"),_250,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,_1039),_1029)])),_o8(_536,_793,_1031)],_1038)])),_23,_127,_61,_136,_146,_158,_184,_192,_521]) as unknown as DocumentNode<MarkdownFrontPageQuery, MarkdownFrontPageQueryVariables>;
export const PostMarkdownCommentByIdDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostMarkdownCommentById"),_1042,_o5(_7,[_o7(_8,_221,_1044,_o5(_7,[_o6(_8,_1008,_1045)]))])),_361]) as unknown as DocumentNode<PostMarkdownCommentByIdQuery, PostMarkdownCommentByIdQueryVariables>;
export const PostMarkdownCommentsPostDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostMarkdownCommentsPost"),_1048,_o5(_7,[_o7(_8,_210,_1049,_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_12,_14,_57]))]))]))]) as unknown as DocumentNode<PostMarkdownCommentsPostQuery, PostMarkdownCommentsPostQueryVariables>;
export const PostMarkdownCommentsTopDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostMarkdownCommentsTop"),_1052,_o5(_7,[_o7(_8,_871,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"postCommentsTop"),_1053)])),_1054],_1055)])),_361]) as unknown as DocumentNode<PostMarkdownCommentsTopQuery, PostMarkdownCommentsTopQueryVariables>;
export const PostMarkdownCommentsNewDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostMarkdownCommentsNew"),_1052,_o5(_7,[_o7(_8,_871,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"postCommentsNew"),_1053)])),_1054],_1055)])),_361]) as unknown as DocumentNode<PostMarkdownCommentsNewQuery, PostMarkdownCommentsNewQueryVariables>;
export const PostMarkdownCommentsOldDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostMarkdownCommentsOld"),_1052,_o5(_7,[_o7(_8,_871,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"postCommentsOld"),_1053)])),_1054],_1055)])),_361]) as unknown as DocumentNode<PostMarkdownCommentsOldQuery, PostMarkdownCommentsOldQueryVariables>;
export const MarkdownLatestPostsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MarkdownLatestPosts"),_1059,_o5(_7,[_o7(_8,_250,_1061,_1038)])),_23,_127,_61,_136,_146,_158,_184,_192,_521]) as unknown as DocumentNode<MarkdownLatestPostsQuery, MarkdownLatestPostsQueryVariables>;
export const MarkdownSequenceByIdDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MarkdownSequenceById"),[_1064,_o12(_988,_1065,_1012)],_o5(_7,[_o7(_8,_560,[_1066],_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_14,_47,_64,_1026,_1009]))])),_o7(_8,_254,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"SequenceChapters"),_o14(_1001,[_o8(_1002,_246,_1063)]))])),_o8(_536,_793,_1065)],_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_14,_245,_o6(_8,_250,_1037)]))]))])),_23,_127,_61,_136,_146,_158,_184,_192,_521]) as unknown as DocumentNode<MarkdownSequenceByIdQuery, MarkdownSequenceByIdQueryVariables>;
export const MarkdownTagBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MarkdownTagBySlug"),_1069,_o5(_7,[_o7(_8,_191,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1070,_1071)])),_1072],_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_123,_12,_244,_141,_o6(_8,_149,_721),_o6(_8,_152,_721),_o6(_8,_154,_o5(_7,[_10,_359]))]))]))]))]) as unknown as DocumentNode<MarkdownTagBySlugQuery, MarkdownTagBySlugQueryVariables>;
export const MarkdownTagPostsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MarkdownTagPosts"),[_1073,_1051],_o5(_7,[_o7(_8,_250,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_82,_o14(_1001,[_o8(_1002,_163,_538)]))])),_1054],_1038)])),_23,_127,_61,_136,_146,_158,_184,_192,_521]) as unknown as DocumentNode<MarkdownTagPostsQuery, MarkdownTagPostsQueryVariables>;
export const MarkdownUserProfileDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MarkdownUserProfile"),_1069,_o5(_7,[_o7(_8,_288,[_1074,_1072],_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_12,_31,_49,_o4(_8,_o3(_3,"bio")),_51,_52,_56,_57,_47]))]))]))]) as unknown as DocumentNode<MarkdownUserProfileQuery, MarkdownUserProfileQueryVariables>;
export const MarkdownUserProfilePostsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MarkdownUserProfilePosts"),[_1076,_o12(_988,_1077,_1012)],_o5(_7,[_o15(_8,_o3(_3,"topPosts"),_250,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1078,_o14(_1001,[_1079,_o8(_1002,_1080,_o9(_565,"top",false)),_1082]))])),_1036],_1038),_o15(_8,_o3(_3,"recentPosts"),_250,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1078,_o14(_1001,[_1079,_o8(_1002,_1080,_1083),_1082]))])),_o8(_536,_793,_1077)],_1038)])),_23,_127,_61,_136,_146,_158,_184,_192,_521]) as unknown as DocumentNode<MarkdownUserProfilePostsQuery, MarkdownUserProfilePostsQueryVariables>;
export const MarkdownUserProfileRecentCommentsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MarkdownUserProfileRecentComments"),[_1076,_1084],_o5(_7,[_o7(_8,_871,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1085,_o14(_1001,[_1079,_o8(_1002,_1086,_1083)]))])),_o8(_536,_793,_607)],_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_28,_27,_85,_172,_1026,_1033,_360]))]))]))]) as unknown as DocumentNode<MarkdownUserProfileRecentCommentsQuery, MarkdownUserProfileRecentCommentsQueryVariables>;
export const HocuspocusAuthQueryServerDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"HocuspocusAuthQueryServer"),_1090,_1096)]) as unknown as DocumentNode<HocuspocusAuthQueryServerQuery, HocuspocusAuthQueryServerQueryVariables>;
export const McpPostMetadataDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"McpPostMetadata"),_1048,_o5(_7,[_o7(_8,_210,_1049,_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_14,_15]))]))]))]) as unknown as DocumentNode<McpPostMetadataQuery, McpPostMetadataQueryVariables>;
export const LocalgroupMetadataDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"LocalgroupMetadata"),[_o12(_988,_1097,_991)],_o5(_7,[_o7(_8,_1098,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_9,_1097)]))],_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_123,_237,_39]))]))]))]) as unknown as DocumentNode<LocalgroupMetadataQuery, LocalgroupMetadataQueryVariables>;
export const multiModeratorCommentsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiModeratorCommentsQuery"),[_o12(_988,_1100,_1103)],_o5(_7,[_o7(_8,_871,[_1105],_o5(_7,[_1106]))])),_146,_158,_61,_184,_23,_305]) as unknown as DocumentNode<multiModeratorCommentsQueryQuery, multiModeratorCommentsQueryQueryVariables>;
export const ProfilePostDiamondDataQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProfilePostDiamondDataQuery"),_1109,_o5(_7,[_o7(_8,_o3(_3,"ProfileDiamondPosts"),_1111,_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_12,_1112,_51,_o4(_8,_o3(_3,"isReviewWinner")),_o4(_8,_o3(_3,"isCurated"))])),_796]))]))]) as unknown as DocumentNode<ProfilePostDiamondDataQueryQuery, ProfilePostDiamondDataQueryQueryVariables>;
export const ProfileCommentDiamondDataQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProfileCommentDiamondDataQuery"),_1109,_o5(_7,[_o7(_8,_o3(_3,"ProfileDiamondComments"),_1111,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_8,_1062),_1112,_51,_162])),_796]))]))]) as unknown as DocumentNode<ProfileCommentDiamondDataQueryQuery, ProfileCommentDiamondDataQueryQueryVariables>;
export const ProfileUserQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProfileUserQuery"),_1117,_1120),_61,_226,_906]) as unknown as DocumentNode<ProfileUserQueryQuery, ProfileUserQueryQueryVariables>;
export const ProfilePostsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProfilePostsQuery"),_1121,_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_24)])),_796]))])),_23,_40]) as unknown as DocumentNode<ProfilePostsQueryQuery, ProfilePostsQueryQueryVariables>;
export const ProfilePageCommentsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProfilePageCommentsQuery"),_1123,_1125),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<ProfilePageCommentsQueryQuery, ProfilePageCommentsQueryQueryVariables>;
export const ProfilePageQuickTakesTabDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProfilePageQuickTakesTab"),_1123,_1126),_146,_158,_61,_184,_23,_305,_309]) as unknown as DocumentNode<ProfilePageQuickTakesTabQuery, ProfilePageQuickTakesTabQueryVariables>;
export const ProfileSequencesQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProfileSequencesQuery"),_1127,_o5(_7,[_o7(_8,_259,_1118,_o5(_7,[_o6(_8,_1025,_1128),_796]))])),_748]) as unknown as DocumentNode<ProfileSequencesQueryQuery, ProfileSequencesQueryQueryVariables>;
export const ProfilePageWikiEditsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProfilePageWikiEditsQuery"),_1129,_1132),_550,_61,_703,_146,_230,_226,_239,_708,_711,_446,_270,_714,_719,_722,_726,_730,_735]) as unknown as DocumentNode<ProfilePageWikiEditsQueryQuery, ProfilePageWikiEditsQueryQueryVariables>;
export const ProfileTopPostsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProfileTopPostsQuery"),_1121,_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_41)])),_796]))])),_23,_44]) as unknown as DocumentNode<ProfileTopPostsQueryQuery, ProfileTopPostsQueryQueryVariables>;
export const AdminMetadataQueryDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"AdminMetadataQuery"),_o5(_7,[_o4(_8,_o3(_3,"AdminMetadata"))]))]) as unknown as DocumentNode<AdminMetadataQueryQuery, AdminMetadataQueryQueryVariables>;
export const SearchSynonymsDocument = _o1(_1,[_o17(_986,_995,_1133,_o5(_7,[_o4(_8,_1133)]))]) as unknown as DocumentNode<SearchSynonymsQuery, SearchSynonymsQueryVariables>;
export const UpdateSearchSynonymsDocument = _o1(_1,[_o11(_986,_987,_1134,[_o12(_988,_1136,_1103)],_o5(_7,[_o10(_8,_1134,[_o8(_536,_1135,_1136)])]))]) as unknown as DocumentNode<UpdateSearchSynonymsMutation, UpdateSearchSynonymsMutationVariables>;
export const updateCurationNoticeCurationNoticesFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCurationNoticeCurationNoticesForm"),_1140,_1144),_61,_146,_158,_184,_23,_226,_270,_525]) as unknown as DocumentNode<updateCurationNoticeCurationNoticesFormMutation, updateCurationNoticeCurationNoticesFormMutationVariables>;
export const createCurationNoticeCurationNoticesFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createCurationNoticeCurationNoticesForm"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateCurationNoticeDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createCurationNotice"),_1145,_1143)])),_61,_146,_158,_184,_23,_226,_270,_525]) as unknown as DocumentNode<createCurationNoticeCurationNoticesFormMutation, createCurationNoticeCurationNoticesFormMutationVariables>;
export const updatePostCurationNoticesItem1Document = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostCurationNoticesItem1"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostCurationNoticesItem1Mutation, updatePostCurationNoticesItem1MutationVariables>;
export const updateCurationNoticeCurationNoticesItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCurationNoticeCurationNoticesItem"),_1140,_1144),_61,_146,_158,_184,_23,_226,_270,_525]) as unknown as DocumentNode<updateCurationNoticeCurationNoticesItemMutation, updateCurationNoticeCurationNoticesItemMutationVariables>;
export const createCommentCurationNoticesItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createCommentCurationNoticesItem"),_1149,_1152),_146,_158,_61,_184]) as unknown as DocumentNode<createCommentCurationNoticesItemMutation, createCommentCurationNoticesItemMutationVariables>;
export const multiCurationNoticeCurationPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCurationNoticeCurationPageQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"CurationNoticeSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_527,_1118,_o5(_7,[_1153,_796]))])),_61,_146,_158,_184,_23,_226,_270,_525]) as unknown as DocumentNode<multiCurationNoticeCurationPageQueryQuery, multiCurationNoticeCurationPageQueryQueryVariables>;
export const AdminEmailPreviewAudienceDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"AdminEmailPreviewAudience"),[_o12(_988,_1154,_o13(_990,_o4(_5,_o3(_3,"AdminEmailPreviewAudienceInput"))))],_o5(_7,[_o7(_8,_o3(_3,"adminEmailPreviewAudience"),_1155,_o5(_7,[_796,_o6(_8,_o3(_3,"sample"),_o5(_7,[_20,_390]))]))]))]) as unknown as DocumentNode<AdminEmailPreviewAudienceQuery, AdminEmailPreviewAudienceQueryVariables>;
export const AdminSendTestEmailDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"AdminSendTestEmail"),[_o12(_988,_1154,_o13(_990,_o4(_5,_o3(_3,"AdminSendTestEmailInput"))))],_o5(_7,[_o7(_8,_o3(_3,"adminSendTestEmail"),_1155,_o5(_7,[_1156,_79,_390,_o4(_8,_o3(_3,"unsubscribeUrl"))]))]))]) as unknown as DocumentNode<AdminSendTestEmailMutation, AdminSendTestEmailMutationVariables>;
export const AdminSendBulkEmailDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"AdminSendBulkEmail"),[_o12(_988,_1154,_o13(_990,_o4(_5,_o3(_3,"AdminSendBulkEmailInput"))))],_o5(_7,[_o7(_8,_o3(_3,"adminSendBulkEmail"),_1155,_o5(_7,[_1156,_o4(_8,_o3(_3,"runId")),_o4(_8,_o3(_3,"processed")),_o4(_8,_o3(_3,"batches")),_o6(_8,_o3(_3,"errors"),_o5(_7,[_o4(_8,_o3(_3,"batch")),_79])),_o4(_8,_o3(_3,"lastAfterUserId"))]))]))]) as unknown as DocumentNode<AdminSendBulkEmailMutation, AdminSendBulkEmailMutationVariables>;
export const randomUserDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"randomUser"),[_o12(_988,_1158,_992)],_o5(_7,[_o7(_8,_o3(_3,"GetRandomUser"),[_o8(_536,_1157,_1158)],_67)])),_61]) as unknown as DocumentNode<randomUserQuery, randomUserQueryVariables>;
export const AdminHomePageDesignsDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"AdminHomePageDesigns"),_o5(_7,[_o6(_8,_o3(_3,"adminHomePageDesigns"),_o5(_7,[_10,_1160,_14,_174,_1162,_1164,_1165,_47,_1166,_o4(_8,_o3(_3,"modelName")),_524,_o4(_8,_o3(_3,"ownerDisplayName")),_o4(_8,_o3(_3,"ownerSlug"))]))]))]) as unknown as DocumentNode<AdminHomePageDesignsQuery, AdminHomePageDesignsQueryVariables>;
export const SetHomePageDesignVerifiedDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"SetHomePageDesignVerified"),[_o12(_988,_1168,_992),_o12(_988,_1169,_1018),_o12(_988,_1170,_1018)],_o5(_7,[_o7(_8,_o3(_3,"setHomePageDesignVerified"),[_o8(_536,_1167,_1168),_o8(_536,_1161,_1169),_o8(_536,_1163,_1170)],_o5(_7,[_10,_1162,_1164,_1165]))]))]) as unknown as DocumentNode<SetHomePageDesignVerifiedMutation, SetHomePageDesignVerifiedMutationVariables>;
export const UpdateCommentDeletedDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"UpdateCommentDeleted"),_1171,_o5(_7,[_o7(_8,_1172,_1142,_o5(_7,[_o6(_8,_266,_o5(_7,[_10,_54]))]))]))]) as unknown as DocumentNode<UpdateCommentDeletedMutation, UpdateCommentDeletedMutationVariables>;
export const MigrationsDashboardQueryDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"MigrationsDashboardQuery"),_o5(_7,[_o6(_8,_o3(_3,"MigrationsDashboard"),_o5(_7,[_o6(_8,_o3(_3,"migrations"),_o5(_7,[_123,_o4(_8,_o3(_3,"dateWritten")),_o6(_8,_o3(_3,"runs"),_o5(_7,[_123,_o4(_8,_o3(_3,"started")),_o4(_8,_o3(_3,"finished")),_o4(_8,_o3(_3,"succeeded"))])),_o4(_8,_o3(_3,"lastRun"))]))]))]))]) as unknown as DocumentNode<MigrationsDashboardQueryQuery, MigrationsDashboardQueryQueryVariables>;
export const multiCommentAFUnreviewedCommentCountQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentAFUnreviewedCommentCountQuery"),_1123,_1174),_146,_158,_61,_184,_23,_357]) as unknown as DocumentNode<multiCommentAFUnreviewedCommentCountQueryQuery, multiCommentAFUnreviewedCommentCountQueryQueryVariables>;
export const alignmentPostDocument = _o1(_1,[_o11(_986,_987,_1175,[_1176,_1177],_o5(_7,[_o7(_8,_1175,[_853,_612],_683)])),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<alignmentPostMutation, alignmentPostMutationVariables>;
export const multiUserAuthorAnalyticsPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserAuthorAnalyticsPageQuery"),_1117,_1179),_61]) as unknown as DocumentNode<multiUserAuthorAnalyticsPageQueryQuery, multiUserAuthorAnalyticsPageQueryQueryVariables>;
export const PostsAnalyticsPageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsAnalyticsPage"),_1180,_1183),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_586]) as unknown as DocumentNode<PostsAnalyticsPageQuery, PostsAnalyticsPageQueryVariables>;
export const multiBookmarkBookmarksFeedQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiBookmarkBookmarksFeedQuery"),_1184,_o5(_7,[_o7(_8,_1185,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_218)])),_796]))])),_75,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_217,_223]) as unknown as DocumentNode<multiBookmarkBookmarksFeedQueryQuery, multiBookmarkBookmarksFeedQueryQueryVariables>;
export const multiBookmarkBookmarksListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiBookmarkBookmarksListQuery"),_1184,_o5(_7,[_o7(_8,_1185,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_208)])),_796]))])),_75,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_214]) as unknown as DocumentNode<multiBookmarkBookmarksListQueryQuery, multiBookmarkBookmarksListQueryQueryVariables>;
export const getReadHistoryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getReadHistory"),_1190,_o5(_7,[_o7(_8,_o3(_3,"UserReadHistory"),_1192,_o5(_7,[_o6(_8,_250,_o5(_7,[_211,_88]))]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<getReadHistoryQuery, getReadHistoryQueryVariables>;
export const multiVoteVoteHistoryTabQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiVoteVoteHistoryTabQuery"),_1193,_o5(_7,[_o7(_8,_1194,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_966)])),_796]))])),_965,_146,_158,_61,_184,_23,_322,_127,_136,_192,_198,_203,_207,_969]) as unknown as DocumentNode<multiVoteVoteHistoryTabQueryQuery, multiVoteVoteHistoryTabQueryQueryVariables>;
export const updateUserBook2020FrontpageWidgetDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserBook2020FrontpageWidget"),_1195,_1198),_61,_226,_934]) as unknown as DocumentNode<updateUserBook2020FrontpageWidgetMutation, updateUserBook2020FrontpageWidgetMutationVariables>;
export const updateUserBookFrontpageWidgetDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserBookFrontpageWidget"),_1195,_1198),_61,_226,_934]) as unknown as DocumentNode<updateUserBookFrontpageWidgetMutation, updateUserBookFrontpageWidgetMutationVariables>;
export const CommentEmbeddingsSearchQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CommentEmbeddingsSearchQuery"),[_1201,_1204],_o5(_7,[_o7(_8,_o3(_3,"CommentEmbeddingSearch"),[_1205,_1206],_968)])),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<CommentEmbeddingsSearchQueryQuery, CommentEmbeddingsSearchQueryQueryVariables>;
export const CommentEmbeddingsSimilaritySearchQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CommentEmbeddingsSimilaritySearchQuery"),[_1041,_1204],_o5(_7,[_o7(_8,_o3(_3,"CommentEmbeddingSimilaritySearch"),[_1207,_1206],_968)])),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<CommentEmbeddingsSimilaritySearchQueryQuery, CommentEmbeddingsSimilaritySearchQueryQueryVariables>;
export const CommentByIdDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CommentById"),_1180,_1209),_146,_158,_61,_184]) as unknown as DocumentNode<CommentByIdQuery, CommentByIdQueryVariables>;
export const updateCommentCommentFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentCommentForm"),_1171,_1210),_146,_158,_61,_184]) as unknown as DocumentNode<updateCommentCommentFormMutation, updateCommentCommentFormMutationVariables>;
export const createCommentCommentFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createCommentCommentForm"),_1149,_1152),_146,_158,_61,_184]) as unknown as DocumentNode<createCommentCommentFormMutation, createCommentCommentFormMutationVariables>;
export const CommentPermalinkDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CommentPermalink"),_1180,_1213),_146,_158,_61,_184,_23,_127,_316]) as unknown as DocumentNode<CommentPermalinkQuery, CommentPermalinkQueryVariables>;
export const LinkedDraftCommentQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"LinkedDraftCommentQuery"),_998,_o5(_7,[_o7(_8,_221,_1215,_o5(_7,[_o6(_8,_1008,_1216)]))])),_146,_158,_61,_184,_23,_312]) as unknown as DocumentNode<LinkedDraftCommentQueryQuery, LinkedDraftCommentQueryQueryVariables>;
export const CommentEditDocument = _o1(_1,[_o11(_986,_995,_317,_1180,_o5(_7,[_o7(_8,_221,_1007,_o5(_7,[_o6(_8,_1008,_1217)]))])),_146,_158,_61,_184,_226,_270,_318]) as unknown as DocumentNode<CommentEditQuery, CommentEditQueryVariables>;
export const CommentDeletedMetadataDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CommentDeletedMetadata"),_1180,_o5(_7,[_o7(_8,_221,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_319)]))]))])),_320]) as unknown as DocumentNode<CommentDeletedMetadataQuery, CommentDeletedMetadataQueryVariables>;
export const CommentsNewFormDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CommentsNewForm"),[_1088,_1176],_o5(_7,[_o7(_8,_30,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_851)]))]))])),_855]) as unknown as DocumentNode<CommentsNewFormQuery, CommentsNewFormQueryVariables>;
export const multiLWEventLastVisitListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiLWEventLastVisitListQuery"),_1218,_o5(_7,[_o7(_8,_1219,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_429)])),_796]))])),_430]) as unknown as DocumentNode<multiLWEventLastVisitListQueryQuery, multiLWEventLastVisitListQueryQueryVariables>;
export const PostsModerationGuidelinesDocument = _o1(_1,[_o11(_986,_995,_517,_1180,_o5(_7,[_o15(_8,_517,_210,_1220,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_517)])),_342]))])),_23,_519]) as unknown as DocumentNode<PostsModerationGuidelinesQuery, PostsModerationGuidelinesQueryVariables>;
export const TagModerationGuidelinesDocument = _o1(_1,[_o11(_986,_995,_1221,_1180,_o5(_7,[_o15(_8,_1221,_165,_1220,_o5(_7,[_1223,_342]))])),_146,_61,_230,_226,_239,_708,_711]) as unknown as DocumentNode<TagModerationGuidelinesQuery, TagModerationGuidelinesQueryVariables>;
export const updatePostModerationGuidelinesEditFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostModerationGuidelinesEditForm"),_1146,_1224),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_586]) as unknown as DocumentNode<updatePostModerationGuidelinesEditFormMutation, updatePostModerationGuidelinesEditFormMutationVariables>;
export const updateTagModerationGuidelinesEditFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateTagModerationGuidelinesEditForm"),_1225,_1229),_146,_61,_230,_226,_239,_708,_711,_767,_785]) as unknown as DocumentNode<updateTagModerationGuidelinesEditFormMutation, updateTagModerationGuidelinesEditFormMutationVariables>;
export const PostsEditQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsEditQuery"),[_997,_1230],_o5(_7,[_o7(_8,_210,_1220,_1232)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595,_599]) as unknown as DocumentNode<PostsEditQueryQuery, PostsEditQueryQueryVariables>;
export const TagEditQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TagEditQuery"),_998,_o5(_7,[_o7(_8,_165,_1220,_1234)])),_146,_61,_230,_226,_239,_708,_270,_826]) as unknown as DocumentNode<TagEditQueryQuery, TagEditQueryQueryVariables>;
export const multiCommentModeratorCommentsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentModeratorCommentsQuery"),_1123,_1125),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<multiCommentModeratorCommentsQueryQuery, multiCommentModeratorCommentsQueryQueryVariables>;
export const NewUserGuidelinesDialogDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"NewUserGuidelinesDialog"),_1180,_1209),_146,_158,_61,_184]) as unknown as DocumentNode<NewUserGuidelinesDialogQuery, NewUserGuidelinesDialogQueryVariables>;
export const ParentCommentSingleDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ParentCommentSingle"),_1180,_1236),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<ParentCommentSingleQuery, ParentCommentSingleQueryVariables>;
export const PopularCommentsDocument = _o1(_1,[_o11(_986,_995,_1237,_1238,_o5(_7,[_o7(_8,_1237,_1239,_1240)])),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<PopularCommentsQuery, PopularCommentsQueryVariables>;
export const SideCommentSingleDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SideCommentSingle"),_1042,_o5(_7,[_o7(_8,_221,[_o8(_536,_1000,_o14(_1001,[_o8(_1002,_1003,_1043)]))],_1212)])),_146,_158,_61,_184,_23,_127,_316]) as unknown as DocumentNode<SideCommentSingleQuery, SideCommentSingleQueryVariables>;
export const multiCommentUserCommentsRepliesQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentUserCommentsRepliesQuery"),_1123,_1125),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<multiCommentUserCommentsRepliesQueryQuery, multiCommentUserCommentsRepliesQueryQueryVariables>;
export const multiUserUserCommentsRepliesQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserUserCommentsRepliesQuery"),_1117,_1120),_61,_226,_906]) as unknown as DocumentNode<multiUserUserCommentsRepliesQueryQuery, multiUserUserCommentsRepliesQueryQueryVariables>;
export const DraftCommentsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"DraftCommentsQuery"),_1123,_o5(_7,[_o7(_8,_871,_1118,_o5(_7,[_o6(_8,_1025,_1216),_796]))])),_146,_158,_61,_184,_23,_312]) as unknown as DocumentNode<DraftCommentsQueryQuery, DraftCommentsQueryQueryVariables>;
export const multiCommentRecentCommentsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentRecentCommentsQuery"),_1123,_1125),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<multiCommentRecentCommentsQueryQuery, multiCommentRecentCommentsQueryQueryVariables>;
export const multiCommentuseCommentQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentuseCommentQuery"),_1123,_1241),_146,_158,_61,_184]) as unknown as DocumentNode<multiCommentuseCommentQueryQuery, multiCommentuseCommentQueryQueryVariables>;
export const multiCommentCommentsListCondensedQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentCommentsListCondensedQuery"),_1123,_1242),_146,_158,_61,_184,_23,_305]) as unknown as DocumentNode<multiCommentCommentsListCondensedQueryQuery, multiCommentCommentsListCondensedQueryQueryVariables>;
export const MyHomePageDesignSummariesDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"MyHomePageDesignSummaries"),_o5(_7,[_o6(_8,_o3(_3,"myHomePageDesignSummaries"),_o5(_7,[_1160,_14,_47]))]))]) as unknown as DocumentNode<MyHomePageDesignSummariesQuery, MyHomePageDesignSummariesQueryVariables>;
export const HomePageDesignByPublicIdFullDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"HomePageDesignByPublicIdFull"),_1244,_o5(_7,[_o7(_8,_1245,_1246,_o5(_7,[_10,_1160,_174,_14,_1166,_o4(_8,_o3(_3,"conversationHistory"))]))]))]) as unknown as DocumentNode<HomePageDesignByPublicIdFullQuery, HomePageDesignByPublicIdFullQueryVariables>;
export const MarketplaceHomePageDesignsDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"MarketplaceHomePageDesigns"),_o5(_7,[_o6(_8,_o3(_3,"marketplaceHomePageDesigns"),_o5(_7,[_1160,_14,_174,_1162,_524,_o4(_8,_o3(_3,"commentBaseScore"))]))]))]) as unknown as DocumentNode<MarketplaceHomePageDesignsQuery, MarketplaceHomePageDesignsQueryVariables>;
export const PublishHomePageDesignDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"PublishHomePageDesign"),[_o12(_988,_1154,_o13(_990,_o4(_5,_o3(_3,"PublishHomePageDesignInput"))))],_o5(_7,[_o7(_8,_o3(_3,"publishHomePageDesign"),_1155,_o5(_7,[_o6(_8,_266,_o5(_7,[_10,_1160,_524]))]))]))]) as unknown as DocumentNode<PublishHomePageDesignMutation, PublishHomePageDesignMutationVariables>;
export const HomePageDesignByPublicIdDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"HomePageDesignByPublicId"),_1244,_o5(_7,[_o7(_8,_1245,_1246,_1247)]))]) as unknown as DocumentNode<HomePageDesignByPublicIdQuery, HomePageDesignByPublicIdQueryVariables>;
export const MyHomePageDesignsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MyHomePageDesigns"),_1238,_o5(_7,[_o7(_8,_o3(_3,"myHomePageDesigns"),_1239,_1247)]))]) as unknown as DocumentNode<MyHomePageDesignsQuery, MyHomePageDesignsQueryVariables>;
export const HomeDesignKarmaChangesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"HomeDesignKarmaChanges"),_1180,_o5(_7,[_o7(_8,_30,_1220,_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_o6(_8,_861,_o5(_7,[_862,_863,_865,_867,_868,_o6(_8,_250,_o5(_7,[_10,_869,_162,_14,_12,_220])),_o6(_8,_871,_o5(_7,[_10,_869,_524,_687,_162,_872,_873,_875,_876,_171,_220])),_o6(_8,_877,_o5(_7,[_10,_869,_164,_875,_876,_220]))]))]))]))]))]) as unknown as DocumentNode<HomeDesignKarmaChangesQuery, HomeDesignKarmaChangesQueryVariables>;
export const HomeDesignReadStatusesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"HomeDesignReadStatuses"),_1249,_o5(_7,[_o7(_8,_250,_1251,_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_90]))]))]))]) as unknown as DocumentNode<HomeDesignReadStatusesQuery, HomeDesignReadStatusesQueryVariables>;
export const HomeDesignPostVoteStatusesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"HomeDesignPostVoteStatuses"),_1249,_o5(_7,[_o7(_8,_250,_1251,_1252)]))]) as unknown as DocumentNode<HomeDesignPostVoteStatusesQuery, HomeDesignPostVoteStatusesQueryVariables>;
export const HomeDesignCommentVoteStatusesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"HomeDesignCommentVoteStatuses"),[_o12(_988,_1100,_1102)],_o5(_7,[_o7(_8,_871,[_1105,_1250],_1252)]))]) as unknown as DocumentNode<HomeDesignCommentVoteStatusesQuery, HomeDesignCommentVoteStatusesQueryVariables>;
export const HomeDesignPerformVotePostDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"HomeDesignPerformVotePost"),_1255,_o5(_7,[_o7(_8,_1256,_1258,_1262)])),_641]) as unknown as DocumentNode<HomeDesignPerformVotePostMutation, HomeDesignPerformVotePostMutationVariables>;
export const HomeDesignPerformVoteCommentDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"HomeDesignPerformVoteComment"),_1255,_o5(_7,[_o7(_8,_1263,_1258,_1264)])),_344]) as unknown as DocumentNode<HomeDesignPerformVoteCommentMutation, HomeDesignPerformVoteCommentMutationVariables>;
export const PostExcerptDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostExcerpt"),_1266,_1267),_647]) as unknown as DocumentNode<PostExcerptQuery, PostExcerptQueryVariables>;
export const AllTagsActivityFeedDocument = _o1(_1,[_o11(_986,_995,_1268,[_1051,_1272,_1275],_o5(_7,[_o7(_8,_1268,[_1054,_1276,_1277],_o5(_7,[_342,_1278,_1279,_o6(_8,_1025,_o5(_7,[_265,_o6(_8,_1280,_o5(_7,[_o4(_25,_775)])),_o6(_8,_1281,_1130),_o6(_8,_1282,_968)]))]))])),_146,_61,_230,_226,_239,_708,_711,_550,_703,_446,_270,_714,_719,_722,_726,_730,_158,_184,_23,_777,_735,_322]) as unknown as DocumentNode<AllTagsActivityFeedQuery, AllTagsActivityFeedQueryVariables>;
export const TagHistoryFeedDocument = _o1(_1,[_o11(_986,_995,_1283,[_1051,_1272,_1275,_1073,_o12(_988,_1285,_1286)],_o5(_7,[_o7(_8,_1283,[_1054,_1276,_1277,_539,_o8(_536,_1284,_1285)],_o5(_7,[_342,_1278,_1279,_o6(_8,_1025,_o5(_7,[_265,_o6(_8,_1280,_729),_o6(_8,_1281,_1287),_o6(_8,_o3(_3,"lensRevision"),_1287),_o6(_8,_o3(_3,"summaryRevision"),_o5(_7,[_o4(_25,_704)])),_o6(_8,_o3(_3,"tagApplied"),_o5(_7,[_o4(_25,_771)])),_o6(_8,_1282,_190),_o6(_8,_o3(_3,"wikiMetadataChanged"),_1288),_o6(_8,_o3(_3,"lensOrSummaryMetadataChanged"),_1288)]))]))])),_146,_61,_230,_226,_239,_708,_711,_446,_270,_714,_550,_703,_624,_23,_127,_136,_158,_184,_192,_198,_719,_706,_772,_387]) as unknown as DocumentNode<TagHistoryFeedQuery, TagHistoryFeedQueryVariables>;
export const RecentDiscussionFeedDocument = _o1(_1,[_o11(_986,_995,_1289,[_1051,_1272,_1275,_1177,_1084,_1290,_o12(_988,_738,_1012)],_o5(_7,[_o7(_8,_1289,[_1054,_1276,_1277,_612],_o5(_7,[_342,_1278,_1279,_o6(_8,_1025,_o5(_7,[_265,_o6(_8,_o3(_3,"postCommented"),_1291),_o6(_8,_o3(_3,"shortformCommented"),_o5(_7,[_o4(_25,_618)])),_o6(_8,_o3(_3,"tagDiscussed"),_741),_o6(_8,_o3(_3,"tagRevised"),_o5(_7,[_o4(_25,_740)]))]))]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_617,_230,_226,_239,_708,_711,_550,_703,_739,_614,_620,_742]) as unknown as DocumentNode<RecentDiscussionFeedQuery, RecentDiscussionFeedQueryVariables>;
export const UltraFeedDocument = _o1(_1,[_o11(_986,_995,_1292,[_1051,_1272,_1275,_o12(_988,_1294,_991),_1297],_o5(_7,[_o7(_8,_1292,[_1054,_1276,_1277,_o8(_536,_1293,_1294),_1298],_o5(_7,[_342,_1278,_1279,_o6(_8,_1025,_o5(_7,[_265,_1299,_1300,_o6(_8,_o3(_3,"feedSpotlight"),_o5(_7,[_o4(_25,_977)])),_1301,_1302]))]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_217,_755,_976,_974,_972,_981,_983,_985]) as unknown as DocumentNode<UltraFeedQuery, UltraFeedQueryVariables>;
export const UltraFeedSubscriptionsDocument = _o1(_1,[_o11(_986,_995,_1303,[_1051,_1272,_1275,_1297],_o5(_7,[_o7(_8,_1303,[_1054,_1276,_1277,_1298],_o5(_7,[_342,_1278,_1279,_o6(_8,_1025,_o5(_7,[_265,_1299,_1300,_1301,_1302]))]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_217,_974,_972,_983,_985]) as unknown as DocumentNode<UltraFeedSubscriptionsQuery, UltraFeedSubscriptionsQueryVariables>;
export const UserContentFeedDocument = _o1(_1,[_o11(_986,_995,_1304,[_1076,_1051,_1272,_1275,_1306,_o12(_988,_1187,_991)],_o5(_7,[_o7(_8,_1304,[_1110,_1054,_1276,_1277,_1307,_1191],_o5(_7,[_342,_1278,_1279,_o6(_8,_1025,_o5(_7,[_265,_o6(_8,_o3(_3,"userPost"),_212),_o6(_8,_o3(_3,"profileComment"),_216),_o6(_8,_o3(_3,"shortformComment"),_216),_o6(_8,_o3(_3,"wikiEdit"),_1130)]))]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_550,_703,_230,_226,_239,_708,_711,_446,_270,_714,_719,_722,_726,_730,_207,_735]) as unknown as DocumentNode<UserContentFeedQuery, UserContentFeedQueryVariables>;
export const ElicitBlockDataDocument = _o1(_1,[_o11(_986,_995,_1308,[_1311],_o5(_7,[_o7(_8,_1308,[_1312],_1314)])),_61]) as unknown as DocumentNode<ElicitBlockDataQuery, ElicitBlockDataQueryVariables>;
export const ElicitPredictionDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"ElicitPrediction"),[_1311,_o12(_988,_1315,_1012)],_o5(_7,[_o7(_8,_o3(_3,"MakeElicitPrediction"),[_1312,_o8(_536,_1313,_1315)],_1314)])),_61]) as unknown as DocumentNode<ElicitPredictionMutation, ElicitPredictionMutationVariables>;
export const IframeWidgetSrcdocQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"IframeWidgetSrcdocQuery"),[_o12(_988,_1316,_992)],_o5(_7,[_o7(_8,_o3(_3,"iframeWidgetSrcdoc"),[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_9,_1316)]))],_o5(_7,[_o6(_8,_1008,_631)]))]))]) as unknown as DocumentNode<IframeWidgetSrcdocQueryQuery, IframeWidgetSrcdocQueryQueryVariables>;
export const RecentlyActiveDialoguesDocument = _o1(_1,[_o11(_986,_995,_1317,_1238,_o5(_7,[_o7(_8,_1317,_1239,_1319)])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<RecentlyActiveDialoguesQuery, RecentlyActiveDialoguesQueryVariables>;
export const MyDialoguesDocument = _o1(_1,[_o11(_986,_995,_1320,_1238,_o5(_7,[_o7(_8,_1320,_1239,_1319)])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<MyDialoguesQuery, MyDialoguesQueryVariables>;
export const DialoguesPageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"DialoguesPage"),_1180,_1322),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<DialoguesPageQuery, DialoguesPageQueryVariables>;
export const updatePostBanUserFromPostDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostBanUserFromPostDropdownItem"),_1146,_1224),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_586]) as unknown as DocumentNode<updatePostBanUserFromPostDropdownItemMutation, updatePostBanUserFromPostDropdownItemMutationVariables>;
export const CommentActionsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CommentActions"),_1180,_1324),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506]) as unknown as DocumentNode<CommentActionsQuery, CommentActionsQueryVariables>;
export const lockThreadDocument = _o1(_1,[_o11(_986,_987,_1325,[_1041,_o12(_988,_1327,_991)],_o5(_7,[_o10(_8,_1325,[_1207,_o8(_536,_1326,_1327)])]))]) as unknown as DocumentNode<lockThreadMutation, lockThreadMutationVariables>;
export const unlockThreadDocument = _o1(_1,[_o11(_986,_987,_1328,_1042,_o5(_7,[_o10(_8,_1328,[_1207])]))]) as unknown as DocumentNode<unlockThreadMutation, unlockThreadMutationVariables>;
export const updateCommentMoveToAlignmentCommentDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentMoveToAlignmentCommentDropdownItem"),_1171,_1210),_146,_158,_61,_184]) as unknown as DocumentNode<updateCommentMoveToAlignmentCommentDropdownItemMutation, updateCommentMoveToAlignmentCommentDropdownItemMutationVariables>;
export const updateCommentMoveToAnswersDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentMoveToAnswersDropdownItem"),_1171,_1210),_146,_158,_61,_184]) as unknown as DocumentNode<updateCommentMoveToAnswersDropdownItemMutation, updateCommentMoveToAnswersDropdownItemMutationVariables>;
export const updateCommentPinToProfileDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentPinToProfileDropdownItem"),_1171,_1210),_146,_158,_61,_184]) as unknown as DocumentNode<updateCommentPinToProfileDropdownItemMutation, updateCommentPinToProfileDropdownItemMutationVariables>;
export const updateCommentRetractCommentDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentRetractCommentDropdownItem"),_1171,_1210),_146,_158,_61,_184]) as unknown as DocumentNode<updateCommentRetractCommentDropdownItemMutation, updateCommentRetractCommentDropdownItemMutationVariables>;
export const updateCommentShortformFrontpageDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentShortformFrontpageDropdownItem"),_1171,_1210),_146,_158,_61,_184]) as unknown as DocumentNode<updateCommentShortformFrontpageDropdownItemMutation, updateCommentShortformFrontpageDropdownItemMutationVariables>;
export const updateCommentSuggestAlignmentCommentDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentSuggestAlignmentCommentDropdownItem"),_1171,_1329),_146,_158,_61,_184,_23,_357]) as unknown as DocumentNode<updateCommentSuggestAlignmentCommentDropdownItemMutation, updateCommentSuggestAlignmentCommentDropdownItemMutationVariables>;
export const updateCommentToggleIsModeratorCommentDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentToggleIsModeratorCommentDropdownItem"),_1171,_1210),_146,_158,_61,_184]) as unknown as DocumentNode<updateCommentToggleIsModeratorCommentDropdownItemMutation, updateCommentToggleIsModeratorCommentDropdownItemMutationVariables>;
export const moderateCommentDocument = _o1(_1,[_o11(_986,_987,_1330,[_1331,_o12(_988,_1332,_1018),_o12(_988,_1333,_991),_o12(_988,_1334,_1018)],_o5(_7,[_o7(_8,_1330,[_1207,_o8(_536,_53,_1332),_o8(_536,_178,_1333),_o8(_536,_176,_1334)],_190)])),_146,_158,_61,_184]) as unknown as DocumentNode<moderateCommentMutation, moderateCommentMutationVariables>;
export const updateUserApproveNewUserDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserApproveNewUserDropdownItem"),_1195,_1198),_61,_226,_934]) as unknown as DocumentNode<updateUserApproveNewUserDropdownItemMutation, updateUserApproveNewUserDropdownItemMutationVariables>;
export const updatePostDeleteDraftDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostDeleteDraftDropdownItem"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostDeleteDraftDropdownItemMutation, updatePostDeleteDraftDropdownItemMutationVariables>;
export const updatePostExcludeFromRecommendationsDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostExcludeFromRecommendationsDropdownItem"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostExcludeFromRecommendationsDropdownItemMutation, updatePostExcludeFromRecommendationsDropdownItemMutationVariables>;
export const PostLLMScoreQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostLLMScoreQuery"),_1336,_o5(_7,[_o7(_8,_210,_1337,_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_1338,_339]))]))])),_335]) as unknown as DocumentNode<PostLLMScoreQueryQuery, PostLLMScoreQueryQueryVariables>;
export const llmPolicyViolationTemplateQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"llmPolicyViolationTemplateQuery"),[_o12(_988,_1056,_1137)],_o5(_7,[_o7(_8,_1339,_1340,_1342)])),_226,_270,_438]) as unknown as DocumentNode<llmPolicyViolationTemplateQueryQuery, llmPolicyViolationTemplateQueryQueryVariables>;
export const unlistLlmPostDocument = _o1(_1,[_o11(_986,_987,_1343,[_1335,_o12(_988,_1345,_992)],_o5(_7,[_o10(_8,_1343,[_853,_o8(_536,_1344,_1345)])]))]) as unknown as DocumentNode<unlistLlmPostMutation, unlistLlmPostMutationVariables>;
export const unapproveUserLlmPolicyViolationDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"unapproveUserLlmPolicyViolation"),_1195,_o5(_7,[_o7(_8,_1196,_1142,_o5(_7,[_o6(_8,_266,_67)]))])),_61]) as unknown as DocumentNode<unapproveUserLlmPolicyViolationMutation, unapproveUserLlmPolicyViolationMutationVariables>;
export const markAsReadOrUnreadDocument = _o1(_1,[_o11(_986,_987,_1346,[_1176,_o12(_988,_1347,_1018)],_o5(_7,[_o10(_8,_1346,[_853,_o8(_536,_89,_1347)])]))]) as unknown as DocumentNode<markAsReadOrUnreadMutation, markAsReadOrUnreadMutationVariables>;
export const updatePostMoveToDraftDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostMoveToDraftDropdownItem"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostMoveToDraftDropdownItemMutation, updatePostMoveToDraftDropdownItemMutationVariables>;
export const updatePostMoveToFrontpageDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostMoveToFrontpageDropdownItem"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostMoveToFrontpageDropdownItemMutation, updatePostMoveToFrontpageDropdownItemMutationVariables>;
export const updatePostResyncRssDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostResyncRssDropdownItem"),_1146,_1350),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595]) as unknown as DocumentNode<updatePostResyncRssDropdownItemMutation, updatePostResyncRssDropdownItemMutationVariables>;
export const getRssPostChangesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getRssPostChanges"),_1336,_o5(_7,[_o7(_8,_o3(_3,"RssPostChanges"),_854,_o5(_7,[_o4(_8,_o3(_3,"isChanged")),_o4(_8,_o3(_3,"newHtml")),_o4(_8,_o3(_3,"htmlDiff"))]))]))]) as unknown as DocumentNode<getRssPostChangesQuery, getRssPostChangesQueryVariables>;
export const updateUserShortformDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserShortformDropdownItem"),_1195,_1198),_61,_226,_934]) as unknown as DocumentNode<updateUserShortformDropdownItemMutation, updateUserShortformDropdownItemMutationVariables>;
export const updatePostSuggestAlignmentPostDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostSuggestAlignmentPostDropdownItem"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostSuggestAlignmentPostDropdownItemMutation, updatePostSuggestAlignmentPostDropdownItemMutationVariables>;
export const updatePostSuggestCuratedDropdownItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostSuggestCuratedDropdownItem"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostSuggestCuratedDropdownItemMutation, updatePostSuggestCuratedDropdownItemMutationVariables>;
export const setIsHiddenDocument = _o1(_1,[_o11(_986,_987,_1351,[_1335,_o12(_988,_1353,_1019)],_o5(_7,[_o7(_8,_1351,[_853,_o8(_536,_1352,_1353)],_1197)])),_61,_226,_934]) as unknown as DocumentNode<setIsHiddenMutation, setIsHiddenMutationVariables>;
export const multiPostCKPostEditorQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostCKPostEditorQuery"),_1121,_1354),_23]) as unknown as DocumentNode<multiPostCKPostEditorQueryQuery, multiPostCKPostEditorQueryQueryVariables>;
export const sendNewDialogueMessageNotificationDocument = _o1(_1,[_o11(_986,_987,_1355,[_1335,_o12(_988,_1357,_992)],_o5(_7,[_o10(_8,_1355,[_853,_o8(_536,_1356,_1357)])]))]) as unknown as DocumentNode<sendNewDialogueMessageNotificationMutation, sendNewDialogueMessageNotificationMutationVariables>;
export const updatePostEditTitleDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostEditTitle"),_1146,_o5(_7,[_o7(_8,_1147,_1142,_o5(_7,[_o6(_8,_266,_303)]))])),_23]) as unknown as DocumentNode<updatePostEditTitleMutation, updatePostEditTitleMutationVariables>;
export const multiRevisionPostVersionHistoryQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiRevisionPostVersionHistoryQuery"),_1129,_1358),_550,_61,_701]) as unknown as DocumentNode<multiRevisionPostVersionHistoryQueryQuery, multiRevisionPostVersionHistoryQueryQueryVariables>;
export const PostVersionHistoryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostVersionHistory"),_1180,_o5(_7,[_o7(_8,_1359,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_233,_556]))]))])),_226,_550]) as unknown as DocumentNode<PostVersionHistoryQuery, PostVersionHistoryQueryVariables>;
export const revertPostToRevisionDocument = _o1(_1,[_o11(_986,_987,_1360,[_1335,_o12(_988,_1362,_992)],_o5(_7,[_o7(_8,_1360,[_853,_o8(_536,_1361,_1362)],_1348)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595]) as unknown as DocumentNode<revertPostToRevisionMutation, revertPostToRevisionMutationVariables>;
export const PresenceListDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PresenceList"),_1180,_1364),_61]) as unknown as DocumentNode<PresenceListQuery, PresenceListQueryVariables>;
export const multiRevisionTagVersionHistoryQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiRevisionTagVersionHistoryQuery"),_1129,_1358),_550,_61,_701]) as unknown as DocumentNode<multiRevisionTagVersionHistoryQueryQuery, multiRevisionTagVersionHistoryQueryQueryVariables>;
export const TagVersionHistoryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TagVersionHistory"),_1180,_o5(_7,[_o7(_8,_1359,_1007,_o5(_7,[_o6(_8,_1008,_234)]))])),_226]) as unknown as DocumentNode<TagVersionHistoryQuery, TagVersionHistoryQueryVariables>;
export const revertToRevisionDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"revertToRevision"),[_1073,_o12(_988,_1366,_992),_1367],_o5(_7,[_o7(_8,_o3(_3,"revertTagToRevision"),[_539,_o8(_536,_1365,_1366)],_1368)])),_146,_61,_230,_226,_239,_708,_711,_767,_785,_23,_127,_136,_158,_184,_192,_198,_203,_207,_801]) as unknown as DocumentNode<revertToRevisionMutation, revertToRevisionMutationVariables>;
export const createElicitQuestionCreateClaimDialogDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createElicitQuestionCreateClaimDialog"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateElicitQuestionDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createElicitQuestion"),_1145,_o5(_7,[_o6(_8,_266,_o5(_7,[_o4(_25,_379)]))]))])),_383]) as unknown as DocumentNode<createElicitQuestionCreateClaimDialogMutation, createElicitQuestionCreateClaimDialogMutationVariables>;
export const LlmModelOptionsDocument = _o1(_1,[_o17(_986,_995,_1369,_o5(_7,[_o4(_8,_1369)]))]) as unknown as DocumentNode<LlmModelOptionsQuery, LlmModelOptionsQueryVariables>;
export const ConvertDocumentDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ConvertDocument"),[_o12(_988,_1370,_1286),_o12(_988,_1372,_991)],_o5(_7,[_o10(_8,_o3(_3,"convertDocument"),[_1373,_1374])]))]) as unknown as DocumentNode<ConvertDocumentQuery, ConvertDocumentQueryVariables>;
export const FMCrosspostControlDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"FMCrosspostControl"),_1180,_o5(_7,[_o7(_8,_30,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_945)]))]))])),_946]) as unknown as DocumentNode<FMCrosspostControlQuery, FMCrosspostControlQueryVariables>;
export const unlinkCrossposterDocument = _o1(_1,[_o17(_986,_987,_1375,_o5(_7,[_o4(_8,_1375)]))]) as unknown as DocumentNode<unlinkCrossposterMutation, unlinkCrossposterMutationVariables>;
export const ImageUploadDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ImageUpload"),_1180,_1364),_61]) as unknown as DocumentNode<ImageUploadQuery, ImageUploadQueryVariables>;
export const multiPodcastEpisodePodcastEpisodeInputQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPodcastEpisodePodcastEpisodeInputQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"PodcastEpisodeSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_o3(_3,"podcastEpisodes"),_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_464)])),_796]))])),_465]) as unknown as DocumentNode<multiPodcastEpisodePodcastEpisodeInputQueryQuery, multiPodcastEpisodePodcastEpisodeInputQueryQueryVariables>;
export const multiPodcastPodcastEpisodeInputQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPodcastPodcastEpisodeInputQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"PodcastSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_o3(_3,"podcasts"),_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_466)])),_796]))])),_467]) as unknown as DocumentNode<multiPodcastPodcastEpisodeInputQueryQuery, multiPodcastPodcastEpisodeInputQueryQueryVariables>;
export const createPodcastEpisodePodcastEpisodeInputDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createPodcastEpisodePodcastEpisodeInput"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreatePodcastEpisodeDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createPodcastEpisode"),_1145,_o5(_7,[_o6(_8,_266,_o5(_7,[_o4(_25,_459)]))]))])),_463]) as unknown as DocumentNode<createPodcastEpisodePodcastEpisodeInputMutation, createPodcastEpisodePodcastEpisodeInputMutationVariables>;
export const multiLocalgroupSelectLocalgroupQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiLocalgroupSelectLocalgroupQuery"),_1376,_o5(_7,[_o7(_8,_1377,_1118,_o5(_7,[_o6(_8,_1025,_944),_796]))])),_61,_415]) as unknown as DocumentNode<multiLocalgroupSelectLocalgroupQueryQuery, multiLocalgroupSelectLocalgroupQueryQueryVariables>;
export const SequencesListEditorItemDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SequencesListEditorItem"),_1180,_o5(_7,[_o7(_8,_560,_1007,_1378)])),_230,_61,_226,_239]) as unknown as DocumentNode<SequencesListEditorItemQuery, SequencesListEditorItemQueryVariables>;
export const SingleTagItemDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SingleTagItem"),_1180,_1379),_146]) as unknown as DocumentNode<SingleTagItemQuery, SingleTagItemQueryVariables>;
export const SingleUsersItemDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SingleUsersItem"),_1180,_1380),_61,_226,_906]) as unknown as DocumentNode<SingleUsersItemQuery, SingleUsersItemQueryVariables>;
export const TagSelectDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TagSelect"),_1180,_1379),_146]) as unknown as DocumentNode<TagSelectQuery, TagSelectQueryVariables>;
export const MultiPostAnalyticsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MultiPostAnalyticsQuery"),[_1381,_1383,_1306,_o12(_988,_1385,_1018),_1051],_o5(_7,[_o7(_8,_o3(_3,"MultiPostAnalytics"),[_1110,_1386,_1307,_o8(_536,_1384,_1385),_1054],_o5(_7,[_o6(_8,_250,_o5(_7,[_10,_14,_12,_28,_1387,_o4(_8,_o3(_3,"uniqueViews")),_1388,_o4(_8,_o3(_3,"meanReadingTime")),_51,_1389])),_796]))]))]) as unknown as DocumentNode<MultiPostAnalyticsQueryQuery, MultiPostAnalyticsQueryQueryVariables>;
export const AnalyticsSeriesQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"AnalyticsSeriesQuery"),[_1381,_1383,_1391,_1393],_o5(_7,[_o7(_8,_o3(_3,"AnalyticsSeries"),[_1110,_1386,_1394,_1395],_o5(_7,[_1112,_1387,_1388,_51,_1389]))]))]) as unknown as DocumentNode<AnalyticsSeriesQueryQuery, AnalyticsSeriesQueryQueryVariables>;
export const multiBookmarkuseBookmarkQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiBookmarkuseBookmarkQuery"),_1184,_o5(_7,[_o7(_8,_1185,_1118,_o5(_7,[_o6(_8,_1025,_1396),_796]))])),_75]) as unknown as DocumentNode<multiBookmarkuseBookmarkQueryQuery, multiBookmarkuseBookmarkQueryQueryVariables>;
export const SetIsBookmarkedMutationDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"SetIsBookmarkedMutation"),[_o12(_988,_1154,_o13(_990,_o4(_5,_o3(_3,"SetIsBookmarkedInput"))))],_o5(_7,[_o7(_8,_o3(_3,"setIsBookmarked"),_1155,_o5(_7,[_o6(_8,_266,_1396)]))])),_75]) as unknown as DocumentNode<SetIsBookmarkedMutationMutation, SetIsBookmarkedMutationMutationVariables>;
export const reviewVotesForPostAndUserDocument = _o1(_1,[_o11(_986,_995,_1397,[_1335,_1076],_o5(_7,[_o7(_8,_1398,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1397,_o14(_1001,[_1399,_1079]))])),_1072],_o5(_7,[_o6(_8,_1025,_515)]))]))]) as unknown as DocumentNode<reviewVotesForPostAndUserQuery, reviewVotesForPostAndUserQueryVariables>;
export const UserExpandFrontpageSectionDocument = _o1(_1,[_o11(_986,_987,_1400,[_o12(_988,_1402,_992),_o12(_988,_1404,_1019)],_o5(_7,[_o10(_8,_1400,[_o8(_536,_1401,_1402),_o8(_536,_1403,_1404)])]))]) as unknown as DocumentNode<UserExpandFrontpageSectionMutation, UserExpandFrontpageSectionMutationVariables>;
export const multiTagfilterSettingsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagfilterSettingsQuery"),_1406,_1408),_146]) as unknown as DocumentNode<multiTagfilterSettingsQueryQuery, multiTagfilterSettingsQueryQueryVariables>;
export const initiateConversationDocument = _o1(_1,[_o11(_986,_987,_1409,[_o12(_988,_1410,_1103),_1177,_o12(_988,_1411,_1018)],_o5(_7,[_o7(_8,_1409,[_o8(_536,_364,_1410),_612,_o8(_536,_365,_1411)],_1412)])),_366]) as unknown as DocumentNode<initiateConversationMutation, initiateConversationMutationVariables>;
export const markConversationReadDocument = _o1(_1,[_o11(_986,_987,_1413,_1416,_o5(_7,[_o10(_8,_1413,_1418)]))]) as unknown as DocumentNode<markConversationReadMutation, markConversationReadMutationVariables>;
export const multiCommentModerationSidebarQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentModerationSidebarQuery"),_1123,_o5(_7,[_o7(_8,_871,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_336)])),_796]))])),_146,_158,_61,_184,_23,_322,_335,_340]) as unknown as DocumentNode<multiCommentModerationSidebarQueryQuery, multiCommentModerationSidebarQueryQueryVariables>;
export const multiSubscriptionuseNotifyMeQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiSubscriptionuseNotifyMeQuery"),_1419,_1422),_762]) as unknown as DocumentNode<multiSubscriptionuseNotifyMeQueryQuery, multiSubscriptionuseNotifyMeQueryQueryVariables>;
export const createSubscriptionuseNotifyMeDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createSubscriptionuseNotifyMe"),_1423,_1424),_762]) as unknown as DocumentNode<createSubscriptionuseNotifyMeMutation, createSubscriptionuseNotifyMeMutationVariables>;
export const PostAnalyticsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostAnalyticsQuery"),_1336,_o5(_7,[_o7(_8,_o3(_3,"PostAnalytics"),_854,_o5(_7,[_o4(_8,_o3(_3,"allViews")),_1425,_o4(_8,_o3(_3,"uniqueClientViews10Sec")),_o4(_8,_o3(_3,"medianReadingTime")),_o4(_8,_o3(_3,"uniqueClientViews5Min")),_o6(_8,_o3(_3,"uniqueClientViewsSeries"),_o5(_7,[_1112,_1425]))]))]))]) as unknown as DocumentNode<PostAnalyticsQueryQuery, PostAnalyticsQueryQueryVariables>;
export const PostsPreviewTooltipSingleDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsPreviewTooltipSingle"),_1180,_1427),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<PostsPreviewTooltipSingleQuery, PostsPreviewTooltipSingleQueryVariables>;
export const multiPostusePublishedPostsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostusePublishedPostsQuery"),_1121,_1430),_23,_127,_61,_136,_146,_158,_184,_192,_335,_226,_622,_624,_629,_639]) as unknown as DocumentNode<multiPostusePublishedPostsQueryQuery, multiPostusePublishedPostsQueryQueryVariables>;
export const increasePostViewCountMutationDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"increasePostViewCountMutation"),_1431,_o5(_7,[_o10(_8,_o3(_3,"increasePostViewCount"),_854)]))]) as unknown as DocumentNode<increasePostViewCountMutationMutation, increasePostViewCountMutationMutationVariables>;
export const markPostCommentsReadDocument = _o1(_1,[_o11(_986,_987,_1432,_1336,_o5(_7,[_o10(_8,_1432,_854)]))]) as unknown as DocumentNode<markPostCommentsReadMutation, markPostCommentsReadMutationVariables>;
export const RefreshDbSettingsDocument = _o1(_1,[_o17(_986,_987,_1433,_o5(_7,[_o4(_8,_1433)]))]) as unknown as DocumentNode<RefreshDbSettingsMutation, RefreshDbSettingsMutationVariables>;
export const multiModerationTemplateRejectContentDialogQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiModerationTemplateRejectContentDialogQuery"),_1434,_1435),_226,_270,_438]) as unknown as DocumentNode<multiModerationTemplateRejectContentDialogQueryQuery, multiModerationTemplateRejectContentDialogQueryQueryVariables>;
export const rejectPostMutationDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"rejectPostMutation"),_1146,_o5(_7,[_o7(_8,_1147,_1142,_o5(_7,[_o6(_8,_266,_1428)]))])),_23,_127,_61,_136,_146,_158,_184,_192,_335,_226,_622,_624,_629,_639]) as unknown as DocumentNode<rejectPostMutationMutation, rejectPostMutationMutationVariables>;
export const rejectCommentMutationDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"rejectCommentMutation"),_1171,_1436),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<rejectCommentMutationMutation, rejectCommentMutationMutationVariables>;
export const multiMultiDocumentuseTagOrLensQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiMultiDocumentuseTagOrLensQuery"),_1437,_o5(_7,[_o7(_8,_1438,_1118,_o5(_7,[_o6(_8,_1025,_734),_796]))])),_446,_226,_270,_714,_722,_726,_146,_61,_230,_239,_708,_711,_719,_730]) as unknown as DocumentNode<multiMultiDocumentuseTagOrLensQueryQuery, multiMultiDocumentuseTagOrLensQueryQueryVariables>;
export const UnreadNotificationCountQueryDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"UnreadNotificationCountQuery"),_o5(_7,[_o6(_8,_o3(_3,"unreadNotificationCounts"),_o5(_7,[_o4(_8,_o3(_3,"unreadNotifications")),_o4(_8,_o3(_3,"unreadPrivateMessages")),_o4(_8,_o3(_3,"faviconBadgeNumber")),_o4(_8,_o3(_3,"checkedAt"))]))]))]) as unknown as DocumentNode<UnreadNotificationCountQueryQuery, UnreadNotificationCountQueryQueryVariables>;
export const updateUseruseUpdateCurrentUserDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUseruseUpdateCurrentUser"),_1195,_1198),_61,_226,_934]) as unknown as DocumentNode<updateUseruseUpdateCurrentUserMutation, updateUseruseUpdateCurrentUserMutationVariables>;
export const updateUseruseUpdateGlossaryPinnedStateDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUseruseUpdateGlossaryPinnedState"),_1195,_1198),_61,_226,_934]) as unknown as DocumentNode<updateUseruseUpdateGlossaryPinnedStateMutation, updateUseruseUpdateGlossaryPinnedStateMutationVariables>;
export const UserClientIdsInfoQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UserClientIdsInfoQuery"),[_1381],_o5(_7,[_o7(_8,_30,_1439,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_883)]))]))])),_884]) as unknown as DocumentNode<UserClientIdsInfoQueryQuery, UserClientIdsInfoQueryQueryVariables>;
export const multiJargonTermGlossaryEditFormQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiJargonTermGlossaryEditFormQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"JargonTermSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_1440,_1118,_o5(_7,[_o6(_8,_1025,_1441),_796]))])),_226,_270,_398]) as unknown as DocumentNode<multiJargonTermGlossaryEditFormQueryQuery, multiJargonTermGlossaryEditFormQueryQueryVariables>;
export const updateJargonTermGlossaryEditForm1Document = _o1(_1,[_o11(_986,_987,_o3(_3,"updateJargonTermGlossaryEditForm1"),_1442,_1444),_226,_270,_398]) as unknown as DocumentNode<updateJargonTermGlossaryEditForm1Mutation, updateJargonTermGlossaryEditForm1MutationVariables>;
export const updatePostGlossaryEditFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostGlossaryEditForm"),_1146,_1350),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595]) as unknown as DocumentNode<updatePostGlossaryEditFormMutation, updatePostGlossaryEditFormMutationVariables>;
export const getNewJargonTermsDocument = _o1(_1,[_o11(_986,_987,_1445,[_1335,_o12(_988,_1447,_991),_o12(_988,_1449,_991),_o12(_988,_1451,_991),_o12(_988,_1453,_991),_o12(_988,_1455,_991)],_o5(_7,[_o7(_8,_1445,[_853,_o8(_536,_1446,_1447),_o8(_536,_1448,_1449),_o8(_536,_1450,_1451),_o8(_536,_1452,_1453),_o8(_536,_1454,_1455)],_1441)])),_226,_270,_398]) as unknown as DocumentNode<getNewJargonTermsMutation, getNewJargonTermsMutationVariables>;
export const multiPostGlossaryEditorPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostGlossaryEditorPageQuery"),_1456,_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_o6(_8,_1025,_1231),_796]))])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595,_599]) as unknown as DocumentNode<multiPostGlossaryEditorPageQueryQuery, multiPostGlossaryEditorPageQueryQueryVariables>;
export const updateJargonTermJargonEditorRowDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateJargonTermJargonEditorRow"),_1442,_1444),_226,_270,_398]) as unknown as DocumentNode<updateJargonTermJargonEditorRowMutation, updateJargonTermJargonEditorRowMutationVariables>;
export const updateJargonTermJargonTermFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateJargonTermJargonTermForm"),_1442,_1444),_226,_270,_398]) as unknown as DocumentNode<updateJargonTermJargonTermFormMutation, updateJargonTermJargonTermFormMutationVariables>;
export const createJargonTermJargonTermFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createJargonTermJargonTermForm"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateJargonTermDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createJargonTerm"),_1145,_1443)])),_226,_270,_398]) as unknown as DocumentNode<createJargonTermJargonTermFormMutation, createJargonTermJargonTermFormMutationVariables>;
export const getPostsWithApprovedJargonDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getPostsWithApprovedJargon"),[_1108],_o5(_7,[_o7(_8,_o3(_3,"PostsWithApprovedJargon"),_1239,_o5(_7,[_o6(_8,_1025,_o5(_7,[_213,_o6(_8,_1440,_1441)]))]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_226,_270,_207,_398]) as unknown as DocumentNode<getPostsWithApprovedJargonQuery, getPostsWithApprovedJargonQueryVariables>;
export const multiCommentAutocompleteModelSettingsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentAutocompleteModelSettingsQuery"),_1123,_1241),_146,_158,_61,_184]) as unknown as DocumentNode<multiCommentAutocompleteModelSettingsQueryQuery, multiCommentAutocompleteModelSettingsQueryQueryVariables>;
export const multiPostAutocompleteModelSettingsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostAutocompleteModelSettingsQuery"),_1121,_1458),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<multiPostAutocompleteModelSettingsQueryQuery, multiPostAutocompleteModelSettingsQueryQueryVariables>;
export const multiLlmConversationLlmChatWrapperQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiLlmConversationLlmChatWrapperQuery"),_1459,_o5(_7,[_o7(_8,_1460,_1118,_o5(_7,[_o6(_8,_1025,_1461),_796]))])),_401]) as unknown as DocumentNode<multiLlmConversationLlmChatWrapperQueryQuery, multiLlmConversationLlmChatWrapperQueryQueryVariables>;
export const updateLlmConversationLlmChatWrapperDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateLlmConversationLlmChatWrapper"),[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateLlmConversationDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"updateLlmConversation"),_1142,_o5(_7,[_o6(_8,_266,_1461)]))])),_401]) as unknown as DocumentNode<updateLlmConversationLlmChatWrapperMutation, updateLlmConversationLlmChatWrapperMutationVariables>;
export const LlmChatWrapperDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"LlmChatWrapper"),_1180,_1462),_401,_407,_410]) as unknown as DocumentNode<LlmChatWrapperQuery, LlmChatWrapperQueryVariables>;
export const multiLlmConversationLlmConversationsViewingPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiLlmConversationLlmConversationsViewingPageQuery"),_1459,_o5(_7,[_o7(_8,_1460,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_402)])),_796]))])),_401,_61,_404]) as unknown as DocumentNode<multiLlmConversationLlmConversationsViewingPageQueryQuery, multiLlmConversationLlmConversationsViewingPageQueryQueryVariables>;
export const LlmConversationsViewingPageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"LlmConversationsViewingPage"),_1180,_1462),_401,_407,_410]) as unknown as DocumentNode<LlmConversationsViewingPageQuery, LlmConversationsViewingPageQueryVariables>;
export const updateUserLayoutDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserLayout"),_1195,_1198),_61,_226,_934]) as unknown as DocumentNode<updateUserLayoutMutation, updateUserLayoutMutationVariables>;
export const HocuspocusAuthQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"HocuspocusAuthQuery"),_1090,_1096)]) as unknown as DocumentNode<HocuspocusAuthQueryQuery, HocuspocusAuthQueryQueryVariables>;
export const GetReviewResultsTableDataDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"GetReviewResultsTableData"),[_1464],_o5(_7,[_o7(_8,_o3(_3,"ReviewResultsTableData"),[_1465],_o5(_7,[_692,_o6(_8,_1025,_o5(_7,[_o4(_8,_o3(_3,"rank")),_14,_o4(_8,_o3(_3,"postUrl")),_o4(_8,_o3(_3,"authorName")),_o4(_8,_o3(_3,"coauthorNames")),_o4(_8,_1194)]))]))]))]) as unknown as DocumentNode<GetReviewResultsTableDataQuery, GetReviewResultsTableDataQueryVariables>;
export const CrossSiteLinkPreviewWithImageDimensionsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CrossSiteLinkPreviewWithImageDimensionsQuery"),_1470,_o5(_7,[_o7(_8,_1471,[_1472,_1473,_o8(_536,_1474,_1022)],_o5(_7,[_14,_43,_1475,_1476,_174,_664,_79,_1477,_1478]))]))]) as unknown as DocumentNode<CrossSiteLinkPreviewWithImageDimensionsQueryQuery, CrossSiteLinkPreviewWithImageDimensionsQueryQueryVariables>;
export const CrossSiteLinkPreviewDebugQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CrossSiteLinkPreviewDebugQuery"),_1470,_o5(_7,[_o7(_8,_1471,[_1472,_1473,_o8(_536,_1474,_1081)],_o5(_7,[_14,_43,_1475,_1476,_174,_664,_79,_1477,_1478,_o4(_8,_o3(_3,"debugTitleSource")),_o4(_8,_o3(_3,"debugImageSource")),_o4(_8,_o3(_3,"debugHtmlSource"))]))]))]) as unknown as DocumentNode<CrossSiteLinkPreviewDebugQueryQuery, CrossSiteLinkPreviewDebugQueryQueryVariables>;
export const SequencePreviewDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SequencePreview"),_1481,_o5(_7,[_o7(_8,_560,_1482,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_62)]))]))])),_61,_71]) as unknown as DocumentNode<SequencePreviewQuery, SequencePreviewQueryVariables>;
export const PostLinkPreviewCommentDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostLinkPreviewComment"),_1481,_o5(_7,[_o7(_8,_221,_1482,_1208)])),_146,_158,_61,_184]) as unknown as DocumentNode<PostLinkPreviewCommentQuery, PostLinkPreviewCommentQueryVariables>;
export const PostLinkPreviewPostDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostLinkPreviewPost"),_1481,_o5(_7,[_o7(_8,_210,_1482,_1426)])),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<PostLinkPreviewPostQuery, PostLinkPreviewPostQueryVariables>;
export const ArbitalPageRequestDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ArbitalPageRequest"),[_o12(_988,_1483,_992)],_o5(_7,[_o7(_8,_o3(_3,"ArbitalPageData"),[_o8(_536,_o3(_3,"pageAlias"),_1483)],_o5(_7,[_14,_174]))]))]) as unknown as DocumentNode<ArbitalPageRequestQuery, ArbitalPageRequestQueryVariables>;
export const multiUserCommunityMapQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserCommunityMapQuery"),_1117,_o5(_7,[_o7(_8,_288,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_885)])),_796]))])),_892]) as unknown as DocumentNode<multiUserCommunityMapQueryQuery, multiUserCommunityMapQueryQueryVariables>;
export const multiLocalgroupCommunityMapQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiLocalgroupCommunityMapQuery"),_1376,_1485),_61,_415,_226,_418]) as unknown as DocumentNode<multiLocalgroupCommunityMapQueryQuery, multiLocalgroupCommunityMapQueryQueryVariables>;
export const multiPostCommunityMapQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostCommunityMapQuery"),_1121,_1487),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<multiPostCommunityMapQueryQuery, multiPostCommunityMapQueryQueryVariables>;
export const updateLocalgroupGroupFormDialogDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateLocalgroupGroupFormDialog"),[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateLocalgroupDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"updateLocalgroup"),_1142,_1488)])),_61,_415,_226,_418]) as unknown as DocumentNode<updateLocalgroupGroupFormDialogMutation, updateLocalgroupGroupFormDialogMutationVariables>;
export const createLocalgroupGroupFormDialogDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createLocalgroupGroupFormDialog"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateLocalgroupDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createLocalgroup"),_1145,_1488)])),_61,_415,_226,_418]) as unknown as DocumentNode<createLocalgroupGroupFormDialogMutation, createLocalgroupGroupFormDialogMutationVariables>;
export const GroupFormDialogDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"GroupFormDialog"),_1180,_o5(_7,[_o7(_8,_1098,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_419)]))]))])),_61,_415,_226,_270,_420]) as unknown as DocumentNode<GroupFormDialogQuery, GroupFormDialogQueryVariables>;
export const multiPostLocalGroupPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostLocalGroupPageQuery"),_1121,_1487),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<multiPostLocalGroupPageQueryQuery, multiPostLocalGroupPageQueryQueryVariables>;
export const LocalGroupPageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"LocalGroupPage"),_1180,_o5(_7,[_o7(_8,_1098,_1489,_1490)])),_61,_415,_226,_418]) as unknown as DocumentNode<LocalGroupPageQuery, LocalGroupPageQueryVariables>;
export const multiSubscriptionLocalGroupSubscribersQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiSubscriptionLocalGroupSubscribersQuery"),_1419,_o5(_7,[_o7(_8,_1420,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_763)])),_796]))])),_61,_764]) as unknown as DocumentNode<multiSubscriptionLocalGroupSubscribersQueryQuery, multiSubscriptionLocalGroupSubscribersQueryQueryVariables>;
export const multiLocalgroupLocalGroupsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiLocalgroupLocalGroupsListQuery"),_1376,_1485),_61,_415,_226,_418]) as unknown as DocumentNode<multiLocalgroupLocalGroupsListQueryQuery, multiLocalgroupLocalGroupsListQueryQueryVariables>;
export const SetPersonalMapLocationDialogDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SetPersonalMapLocationDialog"),_1180,_1492),_61,_226,_906,_934,_270,_943]) as unknown as DocumentNode<SetPersonalMapLocationDialogQuery, SetPersonalMapLocationDialogQueryVariables>;
export const multiPostTabNavigationEventsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostTabNavigationEventsListQuery"),_1121,_1487),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<multiPostTabNavigationEventsListQueryQuery, multiPostTabNavigationEventsListQueryQueryVariables>;
export const multiMessageConversationContentsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiMessageConversationContentsQuery"),_1493,_1494),_61,_371]) as unknown as DocumentNode<multiMessageConversationContentsQueryQuery, multiMessageConversationContentsQueryQueryVariables>;
export const updateConversationInboxNavigationDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateConversationInboxNavigation"),_1495,_1497),_366,_61,_371,_375]) as unknown as DocumentNode<updateConversationInboxNavigationMutation, updateConversationInboxNavigationMutationVariables>;
export const multiMessageConversationPreviewQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiMessageConversationPreviewQuery"),_1493,_1494),_61,_371]) as unknown as DocumentNode<multiMessageConversationPreviewQueryQuery, multiMessageConversationPreviewQueryQueryVariables>;
export const singleMessageConversationPreviewQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"singleMessageConversationPreviewQuery"),_1180,_o5(_7,[_o7(_8,_454,_1220,_o5(_7,[_o6(_8,_1008,_374)]))])),_61,_371]) as unknown as DocumentNode<singleMessageConversationPreviewQueryQuery, singleMessageConversationPreviewQueryQueryVariables>;
export const ConversationPreviewDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ConversationPreview"),_1180,_o5(_7,[_o7(_8,_1498,_1007,_o5(_7,[_o6(_8,_1008,_1496)]))])),_366,_61,_371,_375]) as unknown as DocumentNode<ConversationPreviewQuery, ConversationPreviewQueryVariables>;
export const updateConversationConversationTitleEditFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateConversationConversationTitleEditForm"),_1495,_1497),_366,_61,_371,_375]) as unknown as DocumentNode<updateConversationConversationTitleEditFormMutation, updateConversationConversationTitleEditFormMutationVariables>;
export const multiConversationFriendlyInboxQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiConversationFriendlyInboxQuery"),_1499,_o5(_7,[_o7(_8,_1500,_1118,_o5(_7,[_o6(_8,_1025,_1501),_796]))])),_366,_61,_371,_375,_378]) as unknown as DocumentNode<multiConversationFriendlyInboxQueryQuery, multiConversationFriendlyInboxQueryQueryVariables>;
export const FriendlyInboxDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"FriendlyInbox"),_1180,_o5(_7,[_o7(_8,_1498,_1007,_o5(_7,[_o6(_8,_1008,_1501)]))])),_366,_61,_371,_375,_378]) as unknown as DocumentNode<FriendlyInboxQuery, FriendlyInboxQueryVariables>;
export const MessageUserGetUserBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MessageUserGetUserBySlug"),_1069,_1505),_61]) as unknown as DocumentNode<MessageUserGetUserBySlugQuery, MessageUserGetUserBySlugQueryVariables>;
export const createMessageMessagesNewFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createMessageMessagesNewForm"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateMessageDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createMessage"),_1145,_o5(_7,[_o6(_8,_266,_374)]))])),_61,_371]) as unknown as DocumentNode<createMessageMessagesNewFormMutation, createMessageMessagesNewFormMutationVariables>;
export const MessagesNewFormDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MessagesNewForm"),_1180,_o5(_7,[_o7(_8,_1339,_1007,_1342)])),_226,_270,_438]) as unknown as DocumentNode<MessagesNewFormQuery, MessagesNewFormQueryVariables>;
export const updateModerationTemplateModerationTemplateFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateModerationTemplateModerationTemplateForm"),_1506,_1508),_226,_270,_438]) as unknown as DocumentNode<updateModerationTemplateModerationTemplateFormMutation, updateModerationTemplateModerationTemplateFormMutationVariables>;
export const createModerationTemplateModerationTemplateFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createModerationTemplateModerationTemplateForm"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateModerationTemplateDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createModerationTemplate"),_1145,_1507)])),_226,_270,_438]) as unknown as DocumentNode<createModerationTemplateModerationTemplateFormMutation, createModerationTemplateModerationTemplateFormMutationVariables>;
export const multiModerationTemplateModerationTemplatesPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiModerationTemplateModerationTemplatesPageQuery"),_1434,_1435),_226,_270,_438]) as unknown as DocumentNode<multiModerationTemplateModerationTemplatesPageQueryQuery, multiModerationTemplateModerationTemplatesPageQueryQueryVariables>;
export const CommentOnYourDraftNotificationHoverDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CommentOnYourDraftNotificationHover"),_1180,_o5(_7,[_o7(_8,_210,_1007,_o5(_7,[_o6(_8,_1008,_303)]))])),_23]) as unknown as DocumentNode<CommentOnYourDraftNotificationHoverQuery, CommentOnYourDraftNotificationHoverQueryVariables>;
export const EmailPreviewQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"EmailPreviewQuery"),[_o12(_988,_1510,_1382),_1176],_o5(_7,[_o7(_8,_o3(_3,"EmailPreview"),[_o8(_536,_1509,_1510),_853],_o5(_7,[_o4(_8,_o3(_3,"to")),_o4(_8,_o3(_3,"subject")),_174,_330]))]))]) as unknown as DocumentNode<EmailPreviewQueryQuery, EmailPreviewQueryQueryVariables>;
export const multiNotificationNotificationsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiNotificationNotificationsListQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"NotificationSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_o3(_3,"notifications"),_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_451)])),_796]))])),_456]) as unknown as DocumentNode<multiNotificationNotificationsListQueryQuery, multiNotificationNotificationsListQueryQueryVariables>;
export const NotificationsMenuButtonDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"NotificationsMenuButton"),_1180,_1511),_878]) as unknown as DocumentNode<NotificationsMenuButtonQuery, NotificationsMenuButtonQueryVariables>;
export const TagRelNotificationItemDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TagRelNotificationItem"),_1180,_1512),_624,_146,_158,_23,_127,_61,_136,_184,_192,_198,_960]) as unknown as DocumentNode<TagRelNotificationItemQuery, TagRelNotificationItemQueryVariables>;
export const TypoSuggestionHoverQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TypoSuggestionHoverQuery"),[_o12(_988,_1514,_991)],_o5(_7,[_o7(_8,_o3(_3,"typoSuggestion"),[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_9,_1514)]))],_o5(_7,[_o6(_8,_1008,_1515)]))])),_61,_846]) as unknown as DocumentNode<TypoSuggestionHoverQueryQuery, TypoSuggestionHoverQueryQueryVariables>;
export const acceptTypoSuggestionFromHoverDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"acceptTypoSuggestionFromHover"),[_1516,_o12(_988,_1518,_o13(_990,_o4(_5,_o3(_3,"TypoAcceptMode"))))],_o5(_7,[_o7(_8,_o3(_3,"acceptTypoSuggestion"),[_1519,_o8(_536,_1517,_1518)],_1515)])),_61,_846]) as unknown as DocumentNode<acceptTypoSuggestionFromHoverMutation, acceptTypoSuggestionFromHoverMutationVariables>;
export const rejectTypoSuggestionFromHoverDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"rejectTypoSuggestionFromHover"),[_1516],_o5(_7,[_o7(_8,_o3(_3,"rejectTypoSuggestion"),[_1519],_1515)])),_61,_846]) as unknown as DocumentNode<rejectTypoSuggestionFromHoverMutation, rejectTypoSuggestionFromHoverMutationVariables>;
export const multiUserAdminPaymentsPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserAdminPaymentsPageQuery"),_1117,_1120),_61,_226,_906]) as unknown as DocumentNode<multiUserAdminPaymentsPageQueryQuery, multiUserAdminPaymentsPageQueryQueryVariables>;
export const updateUserEditPaymentInfoPageDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserEditPaymentInfoPage"),_1195,_1520),_61,_226,_906,_934,_270,_943]) as unknown as DocumentNode<updateUserEditPaymentInfoPageMutation, updateUserEditPaymentInfoPageMutationVariables>;
export const AddToCalendarButtonDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"AddToCalendarButton"),_1180,_o5(_7,[_o7(_8,_210,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_546)]))]))])),_548]) as unknown as DocumentNode<AddToCalendarButtonQuery, AddToCalendarButtonQueryVariables>;
export const getClaudeAccessLinkDocument = _o1(_1,[_o17(_986,_987,_1521,_o5(_7,[_o4(_8,_1521)]))]) as unknown as DocumentNode<getClaudeAccessLinkMutation, getClaudeAccessLinkMutationVariables>;
export const multiPostCurrentOpenThreadPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostCurrentOpenThreadPageQuery"),_1121,_1354),_23]) as unknown as DocumentNode<multiPostCurrentOpenThreadPageQueryQuery, multiPostCurrentOpenThreadPageQueryQueryVariables>;
export const multiPostDraftsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostDraftsListQuery"),_1121,_1458),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<multiPostDraftsListQueryQuery, multiPostDraftsListQueryQueryVariables>;
export const updatePostDraftsListDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostDraftsList"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostDraftsListMutation, updatePostDraftsListMutationVariables>;
export const latestGoogleDocMetadataSidebarDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"latestGoogleDocMetadataSidebar"),_1336,_o5(_7,[_o10(_8,_o3(_3,"latestGoogleDocMetadata"),_854)]))]) as unknown as DocumentNode<latestGoogleDocMetadataSidebarQuery, latestGoogleDocMetadataSidebarQueryVariables>;
export const ImportGoogleDocSidebarDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"ImportGoogleDocSidebar"),[_o12(_988,_1523,_992),_1176],_o5(_7,[_o7(_8,_o3(_3,"ImportGoogleDoc"),[_o8(_536,_1522,_1523),_853],_315)])),_23,_127]) as unknown as DocumentNode<ImportGoogleDocSidebarMutation, ImportGoogleDocSidebarMutationVariables>;
export const ConvertDocumentEditorTypeDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"ConvertDocumentEditorType"),[_997,_o12(_988,_1087,_o13(_990,_o4(_5,_o3(_3,"ConvertibleCollectionName")))),_1525,_o12(_988,_1370,_o13(_990,_1286)),_o12(_988,_1372,_992)],_o5(_7,[_o10(_8,_o3(_3,"convertDocumentEditorType"),[_1092,_1091,_1526,_1373,_1374])]))]) as unknown as DocumentNode<ConvertDocumentEditorTypeMutation, ConvertDocumentEditorTypeMutationVariables>;
export const updatePostExternalPostImporterDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostExternalPostImporter"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostExternalPostImporterMutation, updatePostExternalPostImporterMutationVariables>;
export const createCommentExternalPostImporterDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createCommentExternalPostImporter"),_1149,_1152),_146,_158,_61,_184]) as unknown as DocumentNode<createCommentExternalPostImporterMutation, createCommentExternalPostImporterMutationVariables>;
export const importUrlAsDraftPostDocument = _o1(_1,[_o11(_986,_987,_1527,[_1467],_o5(_7,[_o7(_8,_1527,[_1472],_o5(_7,[_o4(_8,_o3(_3,"alreadyExists")),_o6(_8,_210,_o5(_7,[_10,_12,_14,_406,_78,_28,_47,_o4(_8,_o3(_3,"modifiedAt")),_20,_15,_21]))]))]))]) as unknown as DocumentNode<importUrlAsDraftPostMutation, importUrlAsDraftPostMutationVariables>;
export const FeedPostsHighlightDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"FeedPostsHighlight"),_1180,_1528),_545]) as unknown as DocumentNode<FeedPostsHighlightQuery, FeedPostsHighlightQueryVariables>;
export const multiPostLWPostsByVoteQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostLWPostsByVoteQuery"),_1121,_1458),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<multiPostLWPostsByVoteQueryQuery, multiPostLWPostsByVoteQueryQueryVariables>;
export const createPostNewDialogueDialogDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createPostNewDialogueDialog"),_1529,_1531),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595]) as unknown as DocumentNode<createPostNewDialogueDialogMutation, createPostNewDialogueDialogMutationVariables>;
export const multiPostPingbacksListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostPingbacksListQuery"),_1121,_1487),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<multiPostPingbacksListQueryQuery, multiPostPingbacksListQueryQueryVariables>;
export const updatePostPostFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostPostForm"),_1146,_o5(_7,[_o7(_8,_1147,_1142,_1533)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595,_601]) as unknown as DocumentNode<updatePostPostFormMutation, updatePostPostFormMutationVariables>;
export const createPostPostFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createPostPostForm"),_1529,_o5(_7,[_o7(_8,_1530,_1145,_1533)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595,_601]) as unknown as DocumentNode<createPostPostFormMutation, createPostPostFormMutationVariables>;
export const multiUserMostValuablePostPostMostValuableCheckboxQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserMostValuablePostPostMostValuableCheckboxQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"UserMostValuablePostSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_o3(_3,"userMostValuablePosts"),_1118,_o5(_7,[_o6(_8,_1025,_1534),_796]))])),_848]) as unknown as DocumentNode<multiUserMostValuablePostPostMostValuableCheckboxQueryQuery, multiUserMostValuablePostPostMostValuableCheckboxQueryQueryVariables>;
export const updateUserMostValuablePostPostMostValuableCheckboxDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserMostValuablePostPostMostValuableCheckbox"),[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateUserMostValuablePostDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"updateUserMostValuablePost"),_1142,_1535)])),_848]) as unknown as DocumentNode<updateUserMostValuablePostPostMostValuableCheckboxMutation, updateUserMostValuablePostPostMostValuableCheckboxMutationVariables>;
export const createUserMostValuablePostPostMostValuableCheckboxDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createUserMostValuablePostPostMostValuableCheckbox"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateUserMostValuablePostDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createUserMostValuablePost"),_1145,_1535)])),_848]) as unknown as DocumentNode<createUserMostValuablePostPostMostValuableCheckboxMutation, createUserMostValuablePostPostMostValuableCheckboxMutationVariables>;
export const multiPostPostsByVoteQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostPostsByVoteQuery"),_1121,_1458),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<multiPostPostsByVoteQueryQuery, multiPostPostsByVoteQueryQueryVariables>;
export const multiVotePostsByVoteWrapperQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiVotePostsByVoteWrapperQuery"),_1193,_o5(_7,[_o7(_8,_1194,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_967])),_796]))])),_965]) as unknown as DocumentNode<multiVotePostsByVoteWrapperQueryQuery, multiVotePostsByVoteWrapperQueryQueryVariables>;
export const multiRevisionPostsCompareRevisionsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiRevisionPostsCompareRevisionsQuery"),_1129,_1536),_550,_61,_703]) as unknown as DocumentNode<multiRevisionPostsCompareRevisionsQueryQuery, multiRevisionPostsCompareRevisionsQueryQueryVariables>;
export const PostsCompareRevisionsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsCompareRevisions"),_1538,_o5(_7,[_o7(_8,_210,_1007,_1539)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_586,_230,_239,_568,_471,_474,_570,_574,_576,_591]) as unknown as DocumentNode<PostsCompareRevisionsQuery, PostsCompareRevisionsQueryVariables>;
export const multiCommentPostsDialogItemNewCommentsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentPostsDialogItemNewCommentsListQuery"),_1123,_1241),_146,_158,_61,_184]) as unknown as DocumentNode<multiCommentPostsDialogItemNewCommentsListQueryQuery, multiCommentPostsDialogItemNewCommentsListQueryQueryVariables>;
export const PostsEditFormUserDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsEditFormUser"),[_1088,_o12(_988,_858,_1018)],_o5(_7,[_o7(_8,_30,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_856)]))]))])),_859]) as unknown as DocumentNode<PostsEditFormUserQuery, PostsEditFormUserQueryVariables>;
export const LinkSharingEditQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"LinkSharingEditQuery"),[_1335,_o12(_988,_1089,_992),_1230],_o5(_7,[_o7(_8,_o3(_3,"getLinkSharedPost"),[_853,_1093],_1231)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595,_599]) as unknown as DocumentNode<LinkSharingEditQueryQuery, LinkSharingEditQueryQueryVariables>;
export const PostsGroupDetailsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsGroupDetails"),_1180,_o5(_7,[_o7(_8,_1098,_1007,_1490)])),_61,_415,_226,_418]) as unknown as DocumentNode<PostsGroupDetailsQuery, PostsGroupDetailsQueryVariables>;
export const PostsHighlightDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsHighlight"),_1180,_1528),_545]) as unknown as DocumentNode<PostsHighlightQuery, PostsHighlightQueryVariables>;
export const multiCommentPostsItemNewCommentsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentPostsItemNewCommentsListQuery"),_1123,_1241),_146,_158,_61,_184]) as unknown as DocumentNode<multiCommentPostsItemNewCommentsListQueryQuery, multiCommentPostsItemNewCommentsListQueryQueryVariables>;
export const LatestDialogueMessagesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"LatestDialogueMessages"),[_o12(_988,_1541,_992),_o12(_988,_1542,_1107)],_o5(_7,[_o10(_8,_o3(_3,"latestDialogueMessages"),[_o8(_536,_1540,_1541),_o8(_536,_o3(_3,"numMessages"),_1542)])]))]) as unknown as DocumentNode<LatestDialogueMessagesQuery, LatestDialogueMessagesQueryVariables>;
export const PostsItemWrapperDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsItemWrapper"),_1180,_1427),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<PostsItemWrapperQuery, PostsItemWrapperQueryVariables>;
export const createPostPostsNewFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createPostPostsNewForm"),_1529,_1531),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595]) as unknown as DocumentNode<createPostPostsNewFormMutation, createPostPostsNewFormMutationVariables>;
export const PostsNewForm4Document = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsNewForm4"),_1180,_1492),_61,_226,_906,_934,_270,_943]) as unknown as DocumentNode<PostsNewForm4Query, PostsNewForm4QueryVariables>;
export const PostsNewForm3Document = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsNewForm3"),_1180,_o5(_7,[_o7(_8,_210,_1007,_o5(_7,[_o6(_8,_1008,_1532)]))])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595,_601]) as unknown as DocumentNode<PostsNewForm3Query, PostsNewForm3QueryVariables>;
export const PostsNewForm2Document = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsNewForm2"),_1180,_o5(_7,[_o7(_8,_1098,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_421)]))]))])),_422]) as unknown as DocumentNode<PostsNewForm2Query, PostsNewForm2QueryVariables>;
export const PostsNewForm1Document = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsNewForm1"),_1543,_1544),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595,_599]) as unknown as DocumentNode<PostsNewForm1Query, PostsNewForm1QueryVariables>;
export const PostsNewFormDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsNewForm"),_1180,_1183),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_586]) as unknown as DocumentNode<PostsNewFormQuery, PostsNewFormQueryVariables>;
export const multiReviewWinnerBestOfLessWrongAnnouncementQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiReviewWinnerBestOfLessWrongAnnouncementQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"ReviewWinnerSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_o3(_3,"reviewWinners"),_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_697)])),_796]))])),_698]) as unknown as DocumentNode<multiReviewWinnerBestOfLessWrongAnnouncementQueryQuery, multiReviewWinnerBestOfLessWrongAnnouncementQueryQueryVariables>;
export const createSplashArtCoordinateImageCropPreviewDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createSplashArtCoordinateImageCropPreview"),_1545,_o5(_7,[_o7(_8,_1546,_1145,_o5(_7,[_o6(_8,_266,_o5(_7,[_473]))]))])),_471]) as unknown as DocumentNode<createSplashArtCoordinateImageCropPreviewMutation, createSplashArtCoordinateImageCropPreviewMutationVariables>;
export const createSplashArtCoordinatePostWithArtGridDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createSplashArtCoordinatePostWithArtGrid"),_1545,_1547),_471,_474]) as unknown as DocumentNode<createSplashArtCoordinatePostWithArtGridMutation, createSplashArtCoordinatePostWithArtGridMutationVariables>;
export const upscaleReviewWinnerArtPostWithArtGridDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"upscaleReviewWinnerArtPostWithArtGrid"),_1549,_o5(_7,[_o7(_8,_o3(_3,"upscaleReviewWinnerArt"),_1550,_572)])),_471,_474,_570]) as unknown as DocumentNode<upscaleReviewWinnerArtPostWithArtGridMutation, upscaleReviewWinnerArtPostWithArtGridMutationVariables>;
export const multiCommentReviewPillContainerQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentReviewPillContainerQuery"),_1123,_1551),_146,_158,_61,_184,_23,_127,_316]) as unknown as DocumentNode<multiCommentReviewPillContainerQueryQuery, multiCommentReviewPillContainerQueryQueryVariables>;
export const flipSplashArtImageDocument = _o1(_1,[_o11(_986,_987,_1552,_1549,_o5(_7,[_o10(_8,_1552,_1550)]))]) as unknown as DocumentNode<flipSplashArtImageMutation, flipSplashArtImageMutationVariables>;
export const multiReviewWinnerArtSplashImageEditingOptionsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiReviewWinnerArtSplashImageEditingOptionsQuery"),_1553,_1554),_471,_474,_570]) as unknown as DocumentNode<multiReviewWinnerArtSplashImageEditingOptionsQueryQuery, multiReviewWinnerArtSplashImageEditingOptionsQueryQueryVariables>;
export const PostsPageWrapper1Document = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsPageWrapper1"),[_1088,_1537,_1230],_o5(_7,[_o7(_8,_210,_1489,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_577)]))]))])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_550,_558,_230,_239,_568,_471,_474,_570,_574,_576,_582]) as unknown as DocumentNode<PostsPageWrapper1Query, PostsPageWrapper1QueryVariables>;
export const PostsPageWrapperDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsPageWrapper"),_1538,_o5(_7,[_o7(_8,_210,_1489,_1539)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_586,_230,_239,_568,_471,_474,_570,_574,_576,_591]) as unknown as DocumentNode<PostsPageWrapperQuery, PostsPageWrapperQueryVariables>;
export const PostsRevisionsListDocument = _o1(_1,[_o11(_986,_995,_602,_1180,_o5(_7,[_o7(_8,_210,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_602)]))]))])),_550,_603]) as unknown as DocumentNode<PostsRevisionsListQuery, PostsRevisionsListQueryVariables>;
export const RegisterRSVPDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"RegisterRSVP"),[_1176,_1556,_1558,_o12(_988,_1560,_1018),_o12(_988,_1562,_991)],_o5(_7,[_o7(_8,_o3(_3,"RSVPToEvent"),[_853,_1563,_1564,_o8(_536,_1559,_1560),_o8(_536,_1561,_1562)],_1323)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506]) as unknown as DocumentNode<RegisterRSVPMutation, RegisterRSVPMutationVariables>;
export const CancelRSVPToEventDocument = _o1(_1,[_o11(_986,_987,_1565,[_1176,_1556,_1381],_o5(_7,[_o7(_8,_1565,[_853,_1563,_1110],_1323)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506]) as unknown as DocumentNode<CancelRSVPToEventMutation, CancelRSVPToEventMutationVariables>;
export const LWPostsPreviewTooltip1Document = _o1(_1,[_o11(_986,_995,_o3(_3,"LWPostsPreviewTooltip1"),[_1088,_o12(_988,_650,_991)],_o5(_7,[_o7(_8,_210,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_648)]))]))])),_651]) as unknown as DocumentNode<LWPostsPreviewTooltip1Query, LWPostsPreviewTooltip1QueryVariables>;
export const LWPostsPreviewTooltipDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"LWPostsPreviewTooltip"),_1266,_1267),_647]) as unknown as DocumentNode<LWPostsPreviewTooltipQuery, LWPostsPreviewTooltipQueryVariables>;
export const PostsPreviewTooltipSingle4Document = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsPreviewTooltipSingle4"),_1180,_1512),_624,_146,_158,_23,_127,_61,_136,_184,_192,_198,_960]) as unknown as DocumentNode<PostsPreviewTooltipSingle4Query, PostsPreviewTooltipSingle4QueryVariables>;
export const PostsPreviewTooltipSingle3Document = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsPreviewTooltipSingle3"),_1180,_1209),_146,_158,_61,_184]) as unknown as DocumentNode<PostsPreviewTooltipSingle3Query, PostsPreviewTooltipSingle3QueryVariables>;
export const multiPostPostsTimeBlockQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostPostsTimeBlockQuery"),_1121,_1458),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<multiPostPostsTimeBlockQueryQuery, multiPostPostsTimeBlockQueryQueryVariables>;
export const getRecombeeLatestPostsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getRecombeeLatestPosts"),_1566,_o5(_7,[_o7(_8,_o3(_3,"RecombeeLatestPosts"),_1567,_1568)])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<getRecombeeLatestPostsQuery, getRecombeeLatestPostsQueryVariables>;
export const getRecombeeHybridPostsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getRecombeeHybridPosts"),_1566,_o5(_7,[_o7(_8,_o3(_3,"RecombeeHybridPosts"),_1567,_1568)])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<getRecombeeHybridPostsQuery, getRecombeeHybridPostsQueryVariables>;
export const createCommentDialogueSubmitDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createCommentDialogueSubmit"),_1149,_o5(_7,[_o7(_8,_1150,_1145,_o5(_7,[_o6(_8,_266,_1217)]))])),_146,_158,_61,_184,_226,_270,_318]) as unknown as DocumentNode<createCommentDialogueSubmitMutation, createCommentDialogueSubmitMutationVariables>;
export const PostsEditFormPostDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsEditFormPost"),_1543,_1544),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595,_599]) as unknown as DocumentNode<PostsEditFormPostQuery, PostsEditFormPostQueryVariables>;
export const multiCommentPostsPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentPostsPageQuery"),_1123,_1241),_146,_158,_61,_184]) as unknown as DocumentNode<multiCommentPostsPageQueryQuery, multiCommentPostsPageQueryQueryVariables>;
export const postCommentsThreadQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"postCommentsThreadQuery"),_1123,_1241),_146,_158,_61,_184]) as unknown as DocumentNode<postCommentsThreadQueryQuery, postCommentsThreadQueryQueryVariables>;
export const multiPostusePostQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostusePostQuery"),_1121,_1487),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<multiPostusePostQueryQuery, multiPostusePostQueryQueryVariables>;
export const postsListWithVotesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"postsListWithVotes"),_1121,_1458),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<postsListWithVotesQuery, postsListWithVotesQueryVariables>;
export const postsListTagWithVotesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"postsListTagWithVotes"),[_1058,_1051,_1116,_1569],_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_542)])),_796]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_534,_543]) as unknown as DocumentNode<postsListTagWithVotesQuery, postsListTagWithVotesQueryVariables>;
export const multiCommentQuickTakesSectionQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentQuickTakesSectionQuery"),_1123,_1126),_146,_158,_61,_184,_23,_305,_309]) as unknown as DocumentNode<multiCommentQuickTakesSectionQueryQuery, multiCommentQuickTakesSectionQueryQueryVariables>;
export const multiPostRecentDiscussionThreadsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostRecentDiscussionThreadsListQuery"),[_1058,_1051,_1116,_1084,_1290,_1177],_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_o6(_8,_1025,_1291),_796]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_614]) as unknown as DocumentNode<multiPostRecentDiscussionThreadsListQueryQuery, multiPostRecentDiscussionThreadsListQueryQueryVariables>;
export const CuratedAndPopularThisWeekDocument = _o1(_1,[_o11(_986,_995,_1570,[_1051,_1177],_o5(_7,[_o7(_8,_1570,[_1054,_612],_1319)])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<CuratedAndPopularThisWeekQuery, CuratedAndPopularThisWeekQueryVariables>;
export const multiPostRecommendationsSamplePageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostRecommendationsSamplePageQuery"),_1121,_1458),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<multiPostRecommendationsSamplePageQueryQuery, multiPostRecommendationsSamplePageQueryQueryVariables>;
export const WelcomePostItemDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"WelcomePostItem"),_1180,_o5(_7,[_o7(_8,_210,[_o8(_536,_1000,_o14(_1001,[_1005,_o8(_1002,_1479,_1081)]))],_1321)])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<WelcomePostItemQuery, WelcomePostItemQueryVariables>;
export const observeRecommendationDocument = _o1(_1,[_o11(_986,_987,_1571,_1336,_o5(_7,[_o10(_8,_1571,_854)]))]) as unknown as DocumentNode<observeRecommendationMutation, observeRecommendationMutationVariables>;
export const clickRecommendationDocument = _o1(_1,[_o11(_986,_987,_1572,_1336,_o5(_7,[_o10(_8,_1572,_854)]))]) as unknown as DocumentNode<clickRecommendationMutation, clickRecommendationMutationVariables>;
export const ContinueReadingQueryDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"ContinueReadingQuery"),_o5(_7,[_o6(_8,_o3(_3,"ContinueReading"),_o5(_7,[_o6(_8,_560,_1128),_o6(_8,_999,_o5(_7,[_o4(_25,_291)])),_o6(_8,_567,_212),_o4(_8,_o3(_3,"numRead")),_o4(_8,_o3(_3,"numTotal")),_o4(_8,_o3(_3,"lastReadTime"))]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_748,_293,_207]) as unknown as DocumentNode<ContinueReadingQueryQuery, ContinueReadingQueryQueryVariables>;
export const dismissRecommendationDocument = _o1(_1,[_o11(_986,_987,_1573,_1431,_o5(_7,[_o10(_8,_1573,_854)]))]) as unknown as DocumentNode<dismissRecommendationMutation, dismissRecommendationMutationVariables>;
export const RecommendationsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"RecommendationsQuery"),_1578,_1579),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_230,_226,_239,_492]) as unknown as DocumentNode<RecommendationsQueryQuery, RecommendationsQueryQueryVariables>;
export const SaveResearchEnvironmentDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"SaveResearchEnvironment"),[_1415,_o12(_988,_1581,_1019)],_o5(_7,[_o7(_8,_o3(_3,"saveResearchEnvironment"),[_1417,_o8(_536,_1580,_1581)],_o5(_7,[_o6(_8,_266,_1582)]))]))]) as unknown as DocumentNode<SaveResearchEnvironmentMutation, SaveResearchEnvironmentMutationVariables>;
export const MintDevPreviewUrlDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"MintDevPreviewUrl"),_1416,_o5(_7,[_o7(_8,_o3(_3,"mintDevPreviewUrl"),_1418,_o5(_7,[_78]))]))]) as unknown as DocumentNode<MintDevPreviewUrlMutation, MintDevPreviewUrlMutationVariables>;
export const ResearchSandboxRunningDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ResearchSandboxRunning"),_1416,_o5(_7,[_o10(_8,_o3(_3,"researchSandboxRunning"),_1418)]))]) as unknown as DocumentNode<ResearchSandboxRunningQuery, ResearchSandboxRunningQueryVariables>;
export const ConversationChatViewInfoDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ConversationChatViewInfo"),_1416,_o5(_7,[_o7(_8,_1583,_1584,_1585)]))]) as unknown as DocumentNode<ConversationChatViewInfoQuery, ConversationChatViewInfoQueryVariables>;
export const ContinueResearchConversationFromChatViewDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"ContinueResearchConversationFromChatView"),_1592,_1594)]) as unknown as DocumentNode<ContinueResearchConversationFromChatViewMutation, ContinueResearchConversationFromChatViewMutationVariables>;
export const CancelResearchConversationFromChatViewDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"CancelResearchConversationFromChatView"),_1416,_1595)]) as unknown as DocumentNode<CancelResearchConversationFromChatViewMutation, CancelResearchConversationFromChatViewMutationVariables>;
export const ResearchDocumentQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ResearchDocumentQuery"),_998,_o5(_7,[_o7(_8,_o3(_3,"researchDocument"),_1215,_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_14,_o6(_8,_36,_o5(_7,[_174,_268]))]))]))]))]) as unknown as DocumentNode<ResearchDocumentQueryQuery, ResearchDocumentQueryQueryVariables>;
export const FireDocumentConversationDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"FireDocumentConversation"),[_1415,_1598,_1591,_1588,_o12(_988,_1600,_991),_o12(_988,_1602,_991)],_o5(_7,[_o7(_8,_o3(_3,"fireResearchConversation"),[_o8(_536,_1000,_o14(_1001,[_o8(_1002,_369,_1414),_1603,_o8(_1002,_1604,_o3("EnumValue",_1259)),_o8(_1002,_1589,_1590),_o8(_1002,_1586,_1587),_o8(_1002,_1599,_1600),_o8(_1002,_1601,_1602)]))],_1593)]))]) as unknown as DocumentNode<FireDocumentConversationMutation, FireDocumentConversationMutationVariables>;
export const ProjectCommentsDocumentsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProjectCommentsDocumentsQuery"),_1605,_o5(_7,[_o7(_8,_1606,_1610,_o5(_7,[_o6(_8,_1025,_228)]))]))]) as unknown as DocumentNode<ProjectCommentsDocumentsQueryQuery, ProjectCommentsDocumentsQueryQueryVariables>;
export const CreateResearchDocumentSidebarDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"CreateResearchDocumentSidebar"),[_1598,_1612],_o5(_7,[_o7(_8,_o3(_3,"createResearchDocument"),[_o8(_536,_266,_o14(_1001,[_1603,_1613]))],_o5(_7,[_o6(_8,_266,_1614)]))]))]) as unknown as DocumentNode<CreateResearchDocumentSidebarMutation, CreateResearchDocumentSidebarMutationVariables>;
export const RenameResearchDocumentSidebarDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"RenameResearchDocumentSidebar"),_1615,_o5(_7,[_o7(_8,_1616,_1617,_1618)]))]) as unknown as DocumentNode<RenameResearchDocumentSidebarMutation, RenameResearchDocumentSidebarMutationVariables>;
export const RenameResearchConversationSidebarDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"RenameResearchConversationSidebar"),_1615,_o5(_7,[_o7(_8,_1619,_1617,_1618)]))]) as unknown as DocumentNode<RenameResearchConversationSidebarMutation, RenameResearchConversationSidebarMutationVariables>;
export const SetResearchDocumentIconDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"SetResearchDocumentIcon"),_1622,_o5(_7,[_o7(_8,_1616,_1623,_1625)]))]) as unknown as DocumentNode<SetResearchDocumentIconMutation, SetResearchDocumentIconMutationVariables>;
export const SetResearchConversationIconDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"SetResearchConversationIcon"),_1622,_o5(_7,[_o7(_8,_1619,_1623,_1625)]))]) as unknown as DocumentNode<SetResearchConversationIconMutation, SetResearchConversationIconMutationVariables>;
export const ReorderResearchDocumentsDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"ReorderResearchDocuments"),[_1598,_o12(_988,_1627,_1103)],_o5(_7,[_o7(_8,_o3(_3,"reorderResearchDocuments"),[_1628,_o8(_536,_1626,_1627)],_1630)]))]) as unknown as DocumentNode<ReorderResearchDocumentsMutation, ReorderResearchDocumentsMutationVariables>;
export const RenameResearchEnvironmentSidebarDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"RenameResearchEnvironmentSidebar"),[_1064,_o12(_988,_1631,_992)],_o5(_7,[_o7(_8,_1632,[_1066,_o8(_536,_266,_o14(_1001,[_o8(_1002,_333,_1631)]))],_o5(_7,[_o6(_8,_266,_o5(_7,[_10,_334]))]))]))]) as unknown as DocumentNode<RenameResearchEnvironmentSidebarMutation, RenameResearchEnvironmentSidebarMutationVariables>;
export const ArchiveResearchDocumentDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"ArchiveResearchDocument"),_1635,_o5(_7,[_o7(_8,_1616,_1636,_1637)]))]) as unknown as DocumentNode<ArchiveResearchDocumentMutation, ArchiveResearchDocumentMutationVariables>;
export const ArchiveResearchConversationDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"ArchiveResearchConversation"),_1635,_o5(_7,[_o7(_8,_1619,_1636,_1637)]))]) as unknown as DocumentNode<ArchiveResearchConversationMutation, ArchiveResearchConversationMutationVariables>;
export const ArchiveResearchEnvironmentDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"ArchiveResearchEnvironment"),_1635,_o5(_7,[_o7(_8,_1632,_1636,_1637)]))]) as unknown as DocumentNode<ArchiveResearchEnvironmentMutation, ArchiveResearchEnvironmentMutationVariables>;
export const ResearchConversationSidebarStatusesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ResearchConversationSidebarStatuses"),_1605,_o5(_7,[_o7(_8,_o3(_3,"researchConversationSidebarStatuses"),_1638,_o5(_7,[_370,_o4(_8,_o3(_3,"turnActive")),_1639,_o4(_8,_o3(_3,"lastReadAt"))]))]))]) as unknown as DocumentNode<ResearchConversationSidebarStatusesQuery, ResearchConversationSidebarStatusesQueryVariables>;
export const ResearchProjectListQueryDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"ResearchProjectListQuery"),_o5(_7,[_o7(_8,_o3(_3,"researchProjects"),[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1104,_1029)])),_o8(_536,_793,_o3(_1035,"100"))],_o5(_7,[_o6(_8,_1025,_1640)]))]))]) as unknown as DocumentNode<ResearchProjectListQueryQuery, ResearchProjectListQueryQueryVariables>;
export const ResearchClaudeTokenStatusQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ResearchClaudeTokenStatusQuery"),_1641,_o5(_7,[_o7(_8,_30,_1439,_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_o4(_8,_o3(_3,"hasClaudeCodeOAuthToken"))]))]))]))]) as unknown as DocumentNode<ResearchClaudeTokenStatusQueryQuery, ResearchClaudeTokenStatusQueryQueryVariables>;
export const CreateResearchProjectDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"CreateResearchProject"),[_o12(_988,_1611,_992),_o12(_988,_1642,_991)],_o5(_7,[_o7(_8,_o3(_3,"createResearchProject"),[_o8(_536,_266,_o14(_1001,[_1613,_o8(_1002,_154,_1642)]))],_o5(_7,[_o6(_8,_266,_1640)]))]))]) as unknown as DocumentNode<CreateResearchProjectMutation, CreateResearchProjectMutationVariables>;
export const ResearchSetClaudeCodeOAuthTokenDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"ResearchSetClaudeCodeOAuthToken"),[_o12(_988,_1643,_992)],_o5(_7,[_o7(_8,_o3(_3,"setClaudeCodeOAuthToken"),_1645,_1630)]))]) as unknown as DocumentNode<ResearchSetClaudeCodeOAuthTokenMutation, ResearchSetClaudeCodeOAuthTokenMutationVariables>;
export const AnswerResearchConversationQuestionDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"AnswerResearchConversationQuestion"),[_1415,_o12(_988,_1647,_992),_o12(_988,_1649,_992)],_o5(_7,[_o7(_8,_o3(_3,"answerResearchConversationQuestion"),[_1417,_o8(_536,_1646,_1647),_o8(_536,_1648,_1649)],_o5(_7,[_1156,_o4(_8,_o3(_3,"expired"))]))]))]) as unknown as DocumentNode<AnswerResearchConversationQuestionMutation, AnswerResearchConversationQuestionMutationVariables>;
export const ResearchWorkspaceFirstDocumentDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ResearchWorkspaceFirstDocument"),_1605,_o5(_7,[_o7(_8,_1606,[_1608,_1072],_o5(_7,[_o6(_8,_1025,_566)]))]))]) as unknown as DocumentNode<ResearchWorkspaceFirstDocumentQuery, ResearchWorkspaceFirstDocumentQueryVariables>;
export const EnsureResearchScratchDocumentDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"EnsureResearchScratchDocument"),_1605,_o5(_7,[_o7(_8,_o3(_3,"ensureResearchScratchDocument"),_1638,_o5(_7,[_282]))]))]) as unknown as DocumentNode<EnsureResearchScratchDocumentMutation, EnsureResearchScratchDocumentMutationVariables>;
export const ResearchSandboxDirectoryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ResearchSandboxDirectory"),[_1415,_o12(_988,_1651,_991)],_o5(_7,[_o7(_8,_o3(_3,"researchSandboxDirectory"),_1652,_o5(_7,[_1653,_1654,_o6(_8,_o3(_3,"entries"),_o5(_7,[_123,_1655,_1656]))]))]))]) as unknown as DocumentNode<ResearchSandboxDirectoryQuery, ResearchSandboxDirectoryQueryVariables>;
export const ResearchSandboxFileDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ResearchSandboxFile"),[_1415,_o12(_988,_1651,_992)],_o5(_7,[_o7(_8,_o3(_3,"researchSandboxFile"),_1652,_o5(_7,[_1653,_1654,_406,_o4(_8,_o3(_3,"truncated")),_o4(_8,_o3(_3,"binary")),_1656]))]))]) as unknown as DocumentNode<ResearchSandboxFileQuery, ResearchSandboxFileQueryVariables>;
export const ResearchSandboxStatsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ResearchSandboxStats"),_1416,_o5(_7,[_o7(_8,_o3(_3,"researchSandboxStats"),_1418,_o5(_7,[_1654,_o4(_8,_o3(_3,"cpuPct")),_o4(_8,_o3(_3,"memUsed")),_o4(_8,_o3(_3,"memTotal")),_o4(_8,_o3(_3,"diskUsed")),_o4(_8,_o3(_3,"diskTotal")),_o4(_8,_o3(_3,"hibernatingSince"))]))]))]) as unknown as DocumentNode<ResearchSandboxStatsQuery, ResearchSandboxStatsQueryVariables>;
export const RestartResearchSandboxDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"RestartResearchSandbox"),_1416,_o5(_7,[_o7(_8,_o3(_3,"restartResearchSandbox"),_1418,_o5(_7,[_1654]))]))]) as unknown as DocumentNode<RestartResearchSandboxMutation, RestartResearchSandboxMutationVariables>;
export const ResearchConversationTranscriptDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ResearchConversationTranscript"),[_1415,_o12(_988,_1658,_1012),_1051],_o5(_7,[_o7(_8,_o3(_3,"researchConversationTranscript"),[_1417,_1659,_1054],_o5(_7,[_10,_370,_o4(_8,_o3(_3,"seq")),_o4(_8,_o3(_3,"claudeMessageUuid")),_1655,_o4(_8,_o3(_3,"payload")),_47]))]))]) as unknown as DocumentNode<ResearchConversationTranscriptQuery, ResearchConversationTranscriptQueryVariables>;
export const MarkResearchConversationReadDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"MarkResearchConversationRead"),_1416,_o5(_7,[_o7(_8,_o3(_3,"markResearchConversationRead"),_1418,_o5(_7,[_1156]))]))]) as unknown as DocumentNode<MarkResearchConversationReadMutation, MarkResearchConversationReadMutationVariables>;
export const ResearchConversationBlockInfoDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ResearchConversationBlockInfo"),_1416,_o5(_7,[_o7(_8,_1583,_1584,_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_14,_o4(_8,_o3(_3,"presentationHtml")),_o4(_8,_o3(_3,"userTurnCount"))]))]))]))]) as unknown as DocumentNode<ResearchConversationBlockInfoQuery, ResearchConversationBlockInfoQueryVariables>;
export const ContinueResearchConversationFromBlockDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"ContinueResearchConversationFromBlock"),_1592,_1594)]) as unknown as DocumentNode<ContinueResearchConversationFromBlockMutation, ContinueResearchConversationFromBlockMutationVariables>;
export const CancelResearchConversationFromBlockDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"CancelResearchConversationFromBlock"),_1416,_1595)]) as unknown as DocumentNode<CancelResearchConversationFromBlockMutation, CancelResearchConversationFromBlockMutationVariables>;
export const MentionTypeaheadProjectResourcesQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"MentionTypeaheadProjectResourcesQuery"),_1605,_o5(_7,[_o7(_8,_1606,_1610,_o5(_7,[_o6(_8,_1025,_1614)])),_o7(_8,_1660,_1610,_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_14,_1639]))]))]))]) as unknown as DocumentNode<MentionTypeaheadProjectResourcesQueryQuery, MentionTypeaheadProjectResourcesQueryQueryVariables>;
export const ProjectSidebarQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProjectSidebarQuery"),_1605,_o5(_7,[_o7(_8,_o3(_3,"researchProject"),[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_9,_1597)]))],_1585),_o7(_8,_1606,_1610,_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_14,_1624,_o4(_8,_o3(_3,"sortOrder")),_47]))])),_o15(_8,_o3(_3,"archivedDocuments"),_1606,_1661,_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_14,_1624,_47]))])),_o7(_8,_1660,_1610,_1662),_o15(_8,_o3(_3,"archivedConversations"),_1660,_1661,_1662)]))]) as unknown as DocumentNode<ProjectSidebarQueryQuery, ProjectSidebarQueryQueryVariables>;
export const ResearchEnvironmentsByProjectQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ResearchEnvironmentsByProjectQuery"),_1605,_o5(_7,[_o7(_8,_1663,_1610,_1664),_o15(_8,_o3(_3,"archivedEnvironments"),_1663,_1661,_1664)]))]) as unknown as DocumentNode<ResearchEnvironmentsByProjectQueryQuery, ResearchEnvironmentsByProjectQueryQueryVariables>;
export const multiReviewWinnerArtBestOfLessWrongAdminQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiReviewWinnerArtBestOfLessWrongAdminQuery"),_1553,_1554),_471,_474,_570]) as unknown as DocumentNode<multiReviewWinnerArtBestOfLessWrongAdminQueryQuery, multiReviewWinnerArtBestOfLessWrongAdminQueryQueryVariables>;
export const BestOfLessWrongAdminDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"BestOfLessWrongAdmin"),_1666),_23,_471,_474,_484,_488]) as unknown as DocumentNode<BestOfLessWrongAdminQuery, BestOfLessWrongAdminQueryVariables>;
export const FrontpageBestOfLWWidgetDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"FrontpageBestOfLWWidget"),_1180,_1322),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<FrontpageBestOfLWWidgetQuery, FrontpageBestOfLWWidgetQueryVariables>;
export const GenerateCoverImagesForPostDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"GenerateCoverImagesForPost"),[_1335,_o12(_988,_1668,_991)],_o5(_7,[_o7(_8,_o3(_3,"generateCoverImagesForPost"),[_853,_o8(_536,_1667,_1668)],_566)]))]) as unknown as DocumentNode<GenerateCoverImagesForPostMutation, GenerateCoverImagesForPostMutationVariables>;
export const multiCommentLatestReviewQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentLatestReviewQuery"),_1123,_1125),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<multiCommentLatestReviewQueryQuery, multiCommentLatestReviewQueryQueryVariables>;
export const PostNominatedNotificationDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostNominatedNotification"),_1180,_1427),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<PostNominatedNotificationQuery, PostNominatedNotificationQueryVariables>;
export const getPostsUserCommentedOnDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getPostsUserCommentedOn"),_1190,_o5(_7,[_o7(_8,_o3(_3,"PostsUserCommentedOn"),_1192,_o5(_7,[_260]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<getPostsUserCommentedOnQuery, getPostsUserCommentedOnQueryVariables>;
export const ReviewPredictionPostsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ReviewPredictionPosts"),[_1464,_1051],_o5(_7,[_o7(_8,_o3(_3,"reviewPredictionPosts"),[_1465,_1054],_o5(_7,[_211,_120,_121]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<ReviewPredictionPostsQuery, ReviewPredictionPostsQueryVariables>;
export const multiPostQuickReviewPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostQuickReviewPageQuery"),_1121,_1670),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_516]) as unknown as DocumentNode<multiPostQuickReviewPageQueryQuery, multiPostQuickReviewPageQueryQueryVariables>;
export const multiPostQuickReviewPage2022QueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostQuickReviewPage2022Query"),_1121,_1670),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_516]) as unknown as DocumentNode<multiPostQuickReviewPage2022QueryQuery, multiPostQuickReviewPage2022QueryQueryVariables>;
export const multiReviewVoteReviewAdminDashboardQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiReviewVoteReviewAdminDashboardQuery"),_1671,_o5(_7,[_o7(_8,_1398,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_695)])),_796]))])),_696]) as unknown as DocumentNode<multiReviewVoteReviewAdminDashboardQueryQuery, multiReviewVoteReviewAdminDashboardQueryQueryVariables>;
export const multiCommentReviewPostCommentsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentReviewPostCommentsQuery"),_1123,_1551),_146,_158,_61,_184,_23,_127,_316]) as unknown as DocumentNode<multiCommentReviewPostCommentsQueryQuery, multiCommentReviewPostCommentsQueryQueryVariables>;
export const multiCommentReviewProgressNominationsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentReviewProgressNominationsQuery"),_1123,_1125),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<multiCommentReviewProgressNominationsQueryQuery, multiCommentReviewProgressNominationsQueryQueryVariables>;
export const multiCommentReviewProgressReviewsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentReviewProgressReviewsQuery"),_1123,_1125),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<multiCommentReviewProgressReviewsQueryQuery, multiCommentReviewProgressReviewsQueryQueryVariables>;
export const multiReviewVoteReviewProgressVotingQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiReviewVoteReviewProgressVotingQuery"),_1671,_1672),_694]) as unknown as DocumentNode<multiReviewVoteReviewProgressVotingQueryQuery, multiReviewVoteReviewProgressVotingQueryQueryVariables>;
export const multiReviewVoteReviewVotingCanvasQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiReviewVoteReviewVotingCanvasQuery"),_1671,_1672),_694]) as unknown as DocumentNode<multiReviewVoteReviewVotingCanvasQueryQuery, multiReviewVoteReviewVotingCanvasQueryQueryVariables>;
export const GivingSeasonHeartsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"GivingSeasonHeartsQuery"),_1676,_o5(_7,[_o7(_8,_o3(_3,"GivingSeasonHearts"),_1678,_1682)]))]) as unknown as DocumentNode<GivingSeasonHeartsQueryQuery, GivingSeasonHeartsQueryQueryVariables>;
export const AddGivingSeasonHeartDocument = _o1(_1,[_o11(_986,_987,_1683,[_1675,_o12(_988,_1684,_1685),_o12(_988,_1686,_1685),_o12(_988,_1687,_1685)],_o5(_7,[_o7(_8,_1683,[_1677,_o8(_536,_1679,_1684),_o8(_536,_1680,_1686),_o8(_536,_1681,_1687)],_1682)]))]) as unknown as DocumentNode<AddGivingSeasonHeartMutation, AddGivingSeasonHeartMutationVariables>;
export const RemoveGivingSeasonHeartDocument = _o1(_1,[_o11(_986,_987,_1688,_1676,_o5(_7,[_o7(_8,_1688,_1678,_1682)]))]) as unknown as DocumentNode<RemoveGivingSeasonHeartMutation, RemoveGivingSeasonHeartMutationVariables>;
export const ReviewVotingExpandedPostDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ReviewVotingExpandedPost"),_1180,_1427),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<ReviewVotingExpandedPostQuery, ReviewVotingExpandedPostQueryVariables>;
export const multiPostReviewVotingPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostReviewVotingPageQuery"),_1121,_1670),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_516]) as unknown as DocumentNode<multiPostReviewVotingPageQueryQuery, multiPostReviewVotingPageQueryQueryVariables>;
export const submitReviewVoteDocument = _o1(_1,[_o11(_986,_987,_1689,[_1176,_o12(_988,_1690,_1012),_o12(_988,_1692,_1012),_o12(_988,_1694,_1012),_o12(_988,_1695,_991),_o12(_988,_1463,_991),_o12(_988,_1696,_1018)],_o5(_7,[_o7(_8,_1689,[_853,_o8(_536,_512,_1690),_o8(_536,_1691,_1692),_o8(_536,_221,_1695),_o8(_536,_1693,_1694),_1465,_o8(_536,_693,_1696)],_1669)])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_516]) as unknown as DocumentNode<submitReviewVoteMutation, submitReviewVoteMutationVariables>;
export const updateUserReviews2019Document = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserReviews2019"),_1195,_1198),_61,_226,_934]) as unknown as DocumentNode<updateUserReviews2019Mutation, updateUserReviews2019MutationVariables>;
export const multiCommentReviewsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentReviewsListQuery"),_1123,_1125),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<multiCommentReviewsListQueryQuery, multiCommentReviewsListQueryQueryVariables>;
export const RotatingReviewWinnerSpotlightDisplayDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"RotatingReviewWinnerSpotlightDisplay"),_1180,_o5(_7,[_o7(_8,_978,_1007,_1697)])),_755,_61,_976]) as unknown as DocumentNode<RotatingReviewWinnerSpotlightDisplayQuery, RotatingReviewWinnerSpotlightDisplayQueryVariables>;
export const RotatingReviewWinnerSpotlightDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"RotatingReviewWinnerSpotlight"),_o5(_7,[_o6(_8,_1665,_o5(_7,[_o6(_8,_486,_o5(_7,[_10,_477])),_o6(_8,_978,_566)]))]))]) as unknown as DocumentNode<RotatingReviewWinnerSpotlightQuery, RotatingReviewWinnerSpotlightQueryVariables>;
export const multiCommentSingleLineReviewsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentSingleLineReviewsListQuery"),_1123,_1125),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<multiCommentSingleLineReviewsListQueryQuery, multiCommentSingleLineReviewsListQueryQueryVariables>;
export const multiUserUserReviewsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserUserReviewsQuery"),_1117,_1120),_61,_226,_906]) as unknown as DocumentNode<multiUserUserReviewsQueryQuery, multiUserUserReviewsQueryQueryVariables>;
export const createSplashArtCoordinateCoordinateEditorDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createSplashArtCoordinateCoordinateEditor"),_1545,_1547),_471,_474]) as unknown as DocumentNode<createSplashArtCoordinateCoordinateEditorMutation, createSplashArtCoordinateCoordinateEditorMutationVariables>;
export const updateRevisionCompareRevisionsDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateRevisionCompareRevisions"),[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateRevisionDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"updateRevision"),_1142,_o5(_7,[_o6(_8,_266,_273)]))])),_226,_270]) as unknown as DocumentNode<updateRevisionCompareRevisionsMutation, updateRevisionCompareRevisionsMutationVariables>;
export const RevisionsDiffDocument = _o1(_1,[_o11(_986,_995,_1698,[_o12(_988,_1087,_992),_1525,_1064,_o12(_988,_1700,_991),_o12(_988,_1702,_992),_o12(_988,_1704,_1018)],_o5(_7,[_o10(_8,_1698,[_1091,_1526,_o8(_536,_1062,_1063),_o8(_536,_1699,_1700),_o8(_536,_1701,_1702),_o8(_536,_1703,_1704)])]))]) as unknown as DocumentNode<RevisionsDiffQuery, RevisionsDiffQueryVariables>;
export const multiRevisionPostsRevisionSelectQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiRevisionPostsRevisionSelectQuery"),_1129,_1358),_550,_61,_701]) as unknown as DocumentNode<multiRevisionPostsRevisionSelectQueryQuery, multiRevisionPostsRevisionSelectQueryQueryVariables>;
export const PostsRevisionSelectDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsRevisionSelect"),_1180,_1324),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506]) as unknown as DocumentNode<PostsRevisionSelectQuery, PostsRevisionSelectQueryVariables>;
export const multiRevisionTagPageRevisionSelectQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiRevisionTagPageRevisionSelectQuery"),_1129,_1536),_550,_61,_703]) as unknown as DocumentNode<multiRevisionTagPageRevisionSelectQueryQuery, multiRevisionTagPageRevisionSelectQueryQueryVariables>;
export const multiRSSFeedNewFeedButtonQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiRSSFeedNewFeedButtonQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"RSSFeedSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_o3(_3,"rSSFeeds"),_1118,_o5(_7,[_o6(_8,_1025,_504),_796]))])),_61,_499]) as unknown as DocumentNode<multiRSSFeedNewFeedButtonQueryQuery, multiRSSFeedNewFeedButtonQueryQueryVariables>;
export const createRSSFeedNewFeedButtonDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createRSSFeedNewFeedButton"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateRSSFeedDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createRSSFeed"),_1145,_o5(_7,[_o6(_8,_266,_o5(_7,[_o4(_25,_745)]))]))])),_746]) as unknown as DocumentNode<createRSSFeedNewFeedButtonMutation, createRSSFeedNewFeedButtonMutationVariables>;
export const HomepageCommunityMapDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"HomepageCommunityMap"),_1180,_1427),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<HomepageCommunityMapQuery, HomepageCommunityMapQueryVariables>;
export const launchPetrovMissileDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"launchPetrovMissile"),[_o12(_988,_1706,_991)],_o5(_7,[_o7(_8,_o3(_3,"PetrovDayLaunchMissile"),[_o8(_536,_1705,_1706)],_o5(_7,[_o4(_8,_1705)]))]))]) as unknown as DocumentNode<launchPetrovMissileMutation, launchPetrovMissileMutationVariables>;
export const petrovDayLaunchResolversDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"petrovDayLaunchResolvers"),_o5(_7,[_o6(_8,_o3(_3,"PetrovDayCheckIfIncoming"),_o5(_7,[_o4(_8,_o3(_3,"launched")),_47]))]))]) as unknown as DocumentNode<petrovDayLaunchResolversQuery, petrovDayLaunchResolversQueryVariables>;
export const meetupMonthQueryDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"meetupMonthQuery"),_o5(_7,[_o7(_8,_o3(_3,"HomepageCommunityEvents"),[_o8(_536,_793,_o3(_1035,"500"))],_o5(_7,[_o6(_8,_1020,_o5(_7,[_10,_888,_890,_107]))]))]))]) as unknown as DocumentNode<meetupMonthQueryQuery, meetupMonthQueryQueryVariables>;
export const multiPetrovDayActionOptIntoPetrovButtonQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPetrovDayActionOptIntoPetrovButtonQuery"),_1707,_1709),_458]) as unknown as DocumentNode<multiPetrovDayActionOptIntoPetrovButtonQueryQuery, multiPetrovDayActionOptIntoPetrovButtonQueryQueryVariables>;
export const createPetrovDayActionOptIntoPetrovButtonDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createPetrovDayActionOptIntoPetrovButton"),_1710,_1711),_458]) as unknown as DocumentNode<createPetrovDayActionOptIntoPetrovButtonMutation, createPetrovDayActionOptIntoPetrovButtonMutationVariables>;
export const multiPetrovDayActionPetrovAdminConsoleQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPetrovDayActionPetrovAdminConsoleQuery"),_1707,_1709),_458]) as unknown as DocumentNode<multiPetrovDayActionPetrovAdminConsoleQueryQuery, multiPetrovDayActionPetrovAdminConsoleQueryQueryVariables>;
export const multiPetrovDayActionPetrovGameWrapperQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPetrovDayActionPetrovGameWrapperQuery"),_1707,_1709),_458]) as unknown as DocumentNode<multiPetrovDayActionPetrovGameWrapperQueryQuery, multiPetrovDayActionPetrovGameWrapperQueryQueryVariables>;
export const petrov2024checkIfNukedDocument = _o1(_1,[_o17(_986,_995,_1712,_o5(_7,[_o4(_8,_1712)]))]) as unknown as DocumentNode<petrov2024checkIfNukedQuery, petrov2024checkIfNukedQueryVariables>;
export const multiPetrovDayActionPetrovLaunchConsoleQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPetrovDayActionPetrovLaunchConsoleQuery"),_1707,_1709),_458]) as unknown as DocumentNode<multiPetrovDayActionPetrovLaunchConsoleQueryQuery, multiPetrovDayActionPetrovLaunchConsoleQueryQueryVariables>;
export const createPetrovDayActionPetrovLaunchConsoleDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createPetrovDayActionPetrovLaunchConsole"),_1710,_1711),_458]) as unknown as DocumentNode<createPetrovDayActionPetrovLaunchConsoleMutation, createPetrovDayActionPetrovLaunchConsoleMutationVariables>;
export const multiPetrovDayActionPetrovWarningConsoleQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPetrovDayActionPetrovWarningConsoleQuery"),_1707,_1709),_458]) as unknown as DocumentNode<multiPetrovDayActionPetrovWarningConsoleQueryQuery, multiPetrovDayActionPetrovWarningConsoleQueryQueryVariables>;
export const createPetrovDayActionPetrovWarningConsoleDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createPetrovDayActionPetrovWarningConsole"),_1710,_1711),_458]) as unknown as DocumentNode<createPetrovDayActionPetrovWarningConsoleMutation, createPetrovDayActionPetrovWarningConsoleMutationVariables>;
export const petrovDay2024ResolversDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"petrovDay2024Resolvers"),_o5(_7,[_o6(_8,_o3(_3,"PetrovDay2024CheckNumberOfIncoming"),_o5(_7,[_o4(_8,_1574)]))]))]) as unknown as DocumentNode<petrovDay2024ResolversQuery, petrovDay2024ResolversQueryVariables>;
export const HomepageCommunityEventPostsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"HomepageCommunityEventPostsQuery"),_1714,_o5(_7,[_o7(_8,_o3(_3,"HomepageCommunityEventPosts"),_1715,_o5(_7,[_1716]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<HomepageCommunityEventPostsQueryQuery, HomepageCommunityEventPostsQueryQueryVariables>;
export const SequenceAddPostRecentPostsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SequenceAddPostRecentPosts"),[_o12(_988,_1717,_1057),_o12(_988,_1718,_1057)],_o5(_7,[_o15(_8,_o3(_3,"drafts"),_250,[_o8(_536,_1003,_1717),_o8(_536,_793,_o3(_1035,"5")),_1719],_1720),_o15(_8,_o3(_3,"published"),_250,[_o8(_536,_1003,_1718),_o8(_536,_793,_o3(_1035,"10")),_1719],_1720)])),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<SequenceAddPostRecentPostsQuery, SequenceAddPostRecentPostsQueryVariables>;
export const SequenceEditChaptersDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SequenceEditChapters"),[_1721,_1051],_o5(_7,[_o7(_8,_254,_1722,_o5(_7,[_o6(_8,_1025,_1723)]))])),_226,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_277,_270,_280]) as unknown as DocumentNode<SequenceEditChaptersQuery, SequenceEditChaptersQueryVariables>;
export const SequenceEditPostRowDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SequenceEditPostRow"),_1180,_o5(_7,[_o7(_8,_210,_1489,_1426)])),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<SequenceEditPostRowQuery, SequenceEditPostRowQueryVariables>;
export const updateSequenceSequenceEditorDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateSequenceSequenceEditor"),[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateSequenceDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"updateSequence"),_1142,_o5(_7,[_o6(_8,_266,_1724)]))])),_230,_61,_226,_239,_270,_750]) as unknown as DocumentNode<updateSequenceSequenceEditorMutation, updateSequenceSequenceEditorMutationVariables>;
export const updateChapterSequenceEditorDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateChapterSequenceEditor"),[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateChapterDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"updateChapter"),_1142,_1725)])),_226,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_277,_270,_280]) as unknown as DocumentNode<updateChapterSequenceEditorMutation, updateChapterSequenceEditorMutationVariables>;
export const createChapterSequenceEditorDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createChapterSequenceEditor"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateChapterDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createChapter"),_1145,_1725)])),_226,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_277,_270,_280]) as unknown as DocumentNode<createChapterSequenceEditorMutation, createChapterSequenceEditorMutationVariables>;
export const deleteChapterSequenceEditorDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"deleteChapterSequenceEditor"),[_o12(_988,_1727,_992)],_o5(_7,[_o10(_8,_o3(_3,"deleteChapter"),[_o8(_536,_1726,_1727)])]))]) as unknown as DocumentNode<deleteChapterSequenceEditorMutation, deleteChapterSequenceEditorMutationVariables>;
export const moveSequencePostSequenceEditorDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"moveSequencePostSequenceEditor"),[_1335,_o12(_988,_1729,_992),_o12(_988,_1731,_992),_o12(_988,_1733,_1107)],_o5(_7,[_o10(_8,_o3(_3,"moveSequencePost"),[_853,_o8(_536,_1728,_1729),_o8(_536,_1730,_1731),_o8(_536,_1732,_1733)])]))]) as unknown as DocumentNode<moveSequencePostSequenceEditorMutation, moveSequencePostSequenceEditorMutationVariables>;
export const updateBookBooksFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateBookBooksForm"),[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateBookDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"updateBook"),_1142,_1734)])),_226,_230,_61,_239,_241,_251,_255,_23,_127,_136,_146,_158,_184,_192,_198,_203,_207,_261]) as unknown as DocumentNode<updateBookBooksFormMutation, updateBookBooksFormMutationVariables>;
export const createBookBooksFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createBookBooksForm"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateBookDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createBook"),_1145,_1734)])),_226,_230,_61,_239,_241,_251,_255,_23,_127,_136,_146,_158,_184,_192,_198,_203,_207,_261]) as unknown as DocumentNode<createBookBooksFormMutation, createBookBooksFormMutationVariables>;
export const BooksItemDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"BooksItem"),_1180,_o5(_7,[_o7(_8,_o3(_3,"book"),_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_271)]))]))])),_226,_230,_61,_239,_241,_251,_255,_23,_127,_136,_146,_158,_184,_192,_198,_203,_207,_261,_270,_275]) as unknown as DocumentNode<BooksItemQuery, BooksItemQueryVariables>;
export const GetBookWordCountDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"GetBookWordCount"),[_o12(_988,_1736,_992)],_o5(_7,[_o10(_8,_o3(_3,"getBookWordCount"),[_o8(_536,_1735,_1736)])]))]) as unknown as DocumentNode<GetBookWordCountQuery, GetBookWordCountQueryVariables>;
export const multiChapterChaptersListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiChapterChaptersListQuery"),_1737,_1738),_226,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_277]) as unknown as DocumentNode<multiChapterChaptersListQueryQuery, multiChapterChaptersListQueryQueryVariables>;
export const updateCollectionCollectionsEditFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCollectionCollectionsEditForm"),[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateCollectionDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"updateCollection"),_1142,_o5(_7,[_o6(_8,_266,_1739)]))])),_61,_226,_230,_239,_241,_251,_255,_23,_127,_136,_146,_158,_184,_192,_198,_203,_207,_261,_298]) as unknown as DocumentNode<updateCollectionCollectionsEditFormMutation, updateCollectionCollectionsEditFormMutationVariables>;
export const CollectionsEditDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CollectionsEdit"),_1180,_o5(_7,[_o7(_8,_999,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_299)]))]))])),_61,_226,_230,_239,_241,_251,_255,_23,_127,_136,_146,_158,_184,_192,_198,_203,_207,_261,_298,_270,_301]) as unknown as DocumentNode<CollectionsEditQuery, CollectionsEditQueryVariables>;
export const GetSequenceStatsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"GetSequenceStats"),[_1740],_o5(_7,[_o7(_8,_o3(_3,"getSequenceStats"),_563,_o5(_7,[_o4(_8,_o3(_3,"totalWordCount")),_o4(_8,_o3(_3,"totalReadTime"))]))]))]) as unknown as DocumentNode<GetSequenceStatsQuery, GetSequenceStatsQueryVariables>;
export const multiSequenceSequencesGridWrapperQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiSequenceSequencesGridWrapperQuery"),_1127,_o5(_7,[_o7(_8,_259,_1118,_o5(_7,[_o6(_8,_1025,_491),_796]))])),_230,_61,_226,_239]) as unknown as DocumentNode<multiSequenceSequencesGridWrapperQueryQuery, multiSequenceSequencesGridWrapperQueryQueryVariables>;
export const createSequenceSequencesNewFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createSequenceSequencesNewForm"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateSequenceDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createSequence"),_1145,_1741)]))]) as unknown as DocumentNode<createSequenceSequencesNewFormMutation, createSequenceSequencesNewFormMutationVariables>;
export const SequencesPageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SequencesPage"),_1180,_o5(_7,[_o7(_8,_560,_1489,_1378)])),_230,_61,_226,_239]) as unknown as DocumentNode<SequencesPageQuery, SequencesPageQueryVariables>;
export const SequencesEditDocument = _o1(_1,[_o11(_986,_995,_749,_1180,_o5(_7,[_o7(_8,_560,_1489,_o5(_7,[_o6(_8,_1008,_1724)]))])),_230,_61,_226,_239,_270,_750]) as unknown as DocumentNode<SequencesEditQuery, SequencesEditQueryVariables>;
export const multiChapterSequencesSummaryQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiChapterSequencesSummaryQuery"),_1737,_1738),_226,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_277]) as unknown as DocumentNode<multiChapterSequencesSummaryQueryQuery, multiChapterSequencesSummaryQueryQueryVariables>;
export const GetAllReviewWinnersDocument = _o1(_1,[_o17(_986,_995,_1665,_1666),_23,_471,_474,_484,_488]) as unknown as DocumentNode<GetAllReviewWinnersQuery, GetAllReviewWinnersQueryVariables>;
export const GetReviewWinnerSpotlightsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"GetReviewWinnerSpotlights"),_1121,_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_186,_487,_980]))]))])),_23,_471,_474,_755,_61,_127,_484,_976]) as unknown as DocumentNode<GetReviewWinnerSpotlightsQuery, GetReviewWinnerSpotlightsQueryVariables>;
export const CollectionsPageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CollectionsPage"),_1180,_o5(_7,[_o7(_8,_999,_1007,_o5(_7,[_o6(_8,_1008,_1739)]))])),_61,_226,_230,_239,_241,_251,_255,_23,_127,_136,_146,_158,_184,_192,_198,_203,_207,_261,_298]) as unknown as DocumentNode<CollectionsPageQuery, CollectionsPageQueryVariables>;
export const PostsSequenceMetadataQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostsSequenceMetadataQuery"),[_o12(_988,_1056,_o13(_990,_1057))],_o5(_7,[_o7(_8,_250,_1340,_1720)])),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<PostsSequenceMetadataQueryQuery, PostsSequenceMetadataQueryQueryVariables>;
export const updateContinueReadingDocument = _o1(_1,[_o11(_986,_987,_1742,[_1740,_1335],_o5(_7,[_o10(_8,_1742,[_562,_853])]))]) as unknown as DocumentNode<updateContinueReadingMutation, updateContinueReadingMutationVariables>;
export const ProfileShortformDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ProfileShortform"),_1180,_1322),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<ProfileShortformQuery, ProfileShortformQueryVariables>;
export const multiCommentRepliesToCommentListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentRepliesToCommentListQuery"),_1123,_1241),_146,_158,_61,_184]) as unknown as DocumentNode<multiCommentRepliesToCommentListQueryQuery, multiCommentRepliesToCommentListQueryQueryVariables>;
export const multiCommentShortformThreadListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentShortformThreadListQuery"),_1123,_1551),_146,_158,_61,_184,_23,_127,_316]) as unknown as DocumentNode<multiCommentShortformThreadListQueryQuery, multiCommentShortformThreadListQueryQueryVariables>;
export const multiCommentShortformTimeBlockQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentShortformTimeBlockQuery"),_1123,_1242),_146,_158,_61,_184,_23,_305]) as unknown as DocumentNode<multiCommentShortformTimeBlockQueryQuery, multiCommentShortformTimeBlockQueryQueryVariables>;
export const DisplaySpotlightQueryDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"DisplaySpotlightQuery"),_o5(_7,[_o6(_8,_1032,_979)])),_755,_61,_976]) as unknown as DocumentNode<DisplaySpotlightQueryQuery, DisplaySpotlightQueryQueryVariables>;
export const DisplaySpotlightByIdQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"DisplaySpotlightByIdQuery"),_1745,_o5(_7,[_o7(_8,_978,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_9,_1744)]))],_1697)])),_755,_61,_976]) as unknown as DocumentNode<DisplaySpotlightByIdQueryQuery, DisplaySpotlightByIdQueryQueryVariables>;
export const updateSpotlightSpotlightFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateSpotlightSpotlightForm"),_1746,_o5(_7,[_o7(_8,_1747,_1142,_1749)])),_755,_226,_270,_759]) as unknown as DocumentNode<updateSpotlightSpotlightFormMutation, updateSpotlightSpotlightFormMutationVariables>;
export const createSpotlightSpotlightFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createSpotlightSpotlightForm"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateSpotlightDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createSpotlight"),_1145,_1749)])),_755,_226,_270,_759]) as unknown as DocumentNode<createSpotlightSpotlightFormMutation, createSpotlightSpotlightFormMutationVariables>;
export const multiSpotlightSpotlightHistoryQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiSpotlightSpotlightHistoryQuery"),_1750,_1751),_755,_61,_976]) as unknown as DocumentNode<multiSpotlightSpotlightHistoryQueryQuery, multiSpotlightSpotlightHistoryQueryQueryVariables>;
export const updateSpotlightSpotlightItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateSpotlightSpotlightItem"),_1746,_o5(_7,[_o7(_8,_1747,_1142,_o5(_7,[_o6(_8,_266,_979)]))])),_755,_61,_976]) as unknown as DocumentNode<updateSpotlightSpotlightItemMutation, updateSpotlightSpotlightItemMutationVariables>;
export const SpotlightItemDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SpotlightItem"),_1180,_o5(_7,[_o7(_8,_978,_1007,_o5(_7,[_o6(_8,_1008,_1748)]))])),_755,_226,_270,_759]) as unknown as DocumentNode<SpotlightItemQuery, SpotlightItemQueryVariables>;
export const SpotlightStartOrContinueReadingQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SpotlightStartOrContinueReadingQuery"),_1745,_o5(_7,[_o7(_8,_978,[_o8(_536,_1000,_o14(_1001,[_o8(_1002,_1003,_o14(_1001,[_o8(_1002,_281,_1744)]))]))],_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_o6(_8,_o3(_3,"sequenceChapters"),_o5(_7,[_10,_1716]))]))]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<SpotlightStartOrContinueReadingQueryQuery, SpotlightStartOrContinueReadingQueryQueryVariables>;
export const multiSpotlightSpotlightsPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiSpotlightSpotlightsPageQuery"),_1750,_1751),_755,_61,_976]) as unknown as DocumentNode<multiSpotlightSpotlightsPageQueryQuery, multiSpotlightSpotlightsPageQueryQueryVariables>;
export const publishAndDeDuplicateSpotlightDocument = _o1(_1,[_o11(_986,_987,_1752,_1745,_o5(_7,[_o7(_8,_1752,[_o8(_536,_1743,_1744)],_979)])),_755,_61,_976]) as unknown as DocumentNode<publishAndDeDuplicateSpotlightMutation, publishAndDeDuplicateSpotlightMutationVariables>;
export const multiSubscriptionFollowUserSearchQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiSubscriptionFollowUserSearchQuery"),_1419,_1422),_762]) as unknown as DocumentNode<multiSubscriptionFollowUserSearchQueryQuery, multiSubscriptionFollowUserSearchQueryQueryVariables>;
export const UserFollowingCountDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UserFollowingCount"),_1419,_o5(_7,[_o7(_8,_1420,_1118,_o5(_7,[_796]))]))]) as unknown as DocumentNode<UserFollowingCountQuery, UserFollowingCountQueryVariables>;
export const SuggestedFeedSubscriptionUsersDocument = _o1(_1,[_o11(_986,_995,_1753,_1238,_o5(_7,[_o7(_8,_1753,_1239,_o5(_7,[_1178]))])),_61]) as unknown as DocumentNode<SuggestedFeedSubscriptionUsersQuery, SuggestedFeedSubscriptionUsersQueryVariables>;
export const updateCommentAFSuggestCommentsItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentAFSuggestCommentsItem"),_1171,_1329),_146,_158,_61,_184,_23,_357]) as unknown as DocumentNode<updateCommentAFSuggestCommentsItemMutation, updateCommentAFSuggestCommentsItemMutationVariables>;
export const multiCommentAFSuggestCommentsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentAFSuggestCommentsListQuery"),_1123,_1174),_146,_158,_61,_184,_23,_357]) as unknown as DocumentNode<multiCommentAFSuggestCommentsListQueryQuery, multiCommentAFSuggestCommentsListQueryQueryVariables>;
export const updatePostAFSuggestPostsItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostAFSuggestPostsItem"),_1146,_1755),_23,_127,_61,_136,_146,_158,_184,_192,_198,_655]) as unknown as DocumentNode<updatePostAFSuggestPostsItemMutation, updatePostAFSuggestPostsItemMutationVariables>;
export const multiPostAFSuggestPostsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostAFSuggestPostsListQuery"),_1121,_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_o6(_8,_1025,_1754),_796]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_655]) as unknown as DocumentNode<multiPostAFSuggestPostsListQueryQuery, multiPostAFSuggestPostsListQueryQueryVariables>;
export const updateUserAFSuggestUsersItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserAFSuggestUsersItem"),_1195,_1756),_61,_622,_661,_681]) as unknown as DocumentNode<updateUserAFSuggestUsersItemMutation, updateUserAFSuggestUsersItemMutationVariables>;
export const multiUserAFSuggestUsersListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserAFSuggestUsersListQuery"),_1117,_o5(_7,[_o7(_8,_288,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_947)])),_796]))])),_61,_948]) as unknown as DocumentNode<multiUserAFSuggestUsersListQueryQuery, multiUserAFSuggestUsersListQueryQueryVariables>;
export const AllReactedCommentsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"AllReactedComments"),_1238,_o5(_7,[_o7(_8,_o3(_3,"CommentsWithReacts"),_1239,_1240)])),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<AllReactedCommentsQuery, AllReactedCommentsQueryVariables>;
export const multiLWEventEmailHistoryQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiLWEventEmailHistoryQuery"),_1218,_o5(_7,[_o7(_8,_1219,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_431)])),_796]))])),_432]) as unknown as DocumentNode<multiLWEventEmailHistoryQueryQuery, multiLWEventEmailHistoryQueryQueryVariables>;
export const multiModerationTemplateGroupedTemplateListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiModerationTemplateGroupedTemplateListQuery"),_1434,_1435),_226,_270,_438]) as unknown as DocumentNode<multiModerationTemplateGroupedTemplateListQueryQuery, multiModerationTemplateGroupedTemplateListQueryQueryVariables>;
export const updateModerationTemplateGroupedTemplateListDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateModerationTemplateGroupedTemplateList"),_1506,_1508),_226,_270,_438]) as unknown as DocumentNode<updateModerationTemplateGroupedTemplateListMutation, updateModerationTemplateGroupedTemplateListMutationVariables>;
export const RunLlmCheckForDocumentDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"RunLlmCheckForDocument"),_1758,_o5(_7,[_o7(_8,_o3(_3,"runLlmCheckForDocument"),_1759,_338)])),_335]) as unknown as DocumentNode<RunLlmCheckForDocumentMutation, RunLlmCheckForDocumentMutationVariables>;
export const multiClientIdModerationAltAccountsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiClientIdModerationAltAccountsQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"ClientIdSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_o3(_3,"clientIds"),_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_284)])),_796]))])),_61,_290]) as unknown as DocumentNode<multiClientIdModerationAltAccountsQueryQuery, multiClientIdModerationAltAccountsQueryQueryVariables>;
export const multiUserModerationAltAccountsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserModerationAltAccountsQuery"),_1117,_o5(_7,[_o7(_8,_288,_1118,_o5(_7,[_o6(_8,_1025,_1760),_796]))])),_61,_622,_661,_681,_882]) as unknown as DocumentNode<multiUserModerationAltAccountsQueryQuery, multiUserModerationAltAccountsQueryQueryVariables>;
export const ModerationAltAccountsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ModerationAltAccounts"),_1180,_o5(_7,[_o7(_8,_30,_1007,_o5(_7,[_o6(_8,_1008,_1760)]))])),_61,_622,_661,_681,_882]) as unknown as DocumentNode<ModerationAltAccountsQuery, ModerationAltAccountsQueryVariables>;
export const ModeratorIPAddressInfoDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ModeratorIPAddressInfo"),[_o12(_988,_1762,_992)],_o5(_7,[_o7(_8,_o3(_3,"moderatorViewIPAddress"),[_o8(_536,_1761,_1762)],_o5(_7,[_o4(_8,_o3(_3,"ip")),_880]))]))]) as unknown as DocumentNode<ModeratorIPAddressInfoQuery, ModeratorIPAddressInfoQueryVariables>;
export const updateUserModeratorActionsDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserModeratorActions"),_1195,_1756),_61,_622,_661,_681]) as unknown as DocumentNode<updateUserModeratorActionsMutation, updateUserModeratorActionsMutationVariables>;
export const createModeratorActionDocument = _o1(_1,[_o11(_986,_987,_1763,_1764,_1766),_61,_622]) as unknown as DocumentNode<createModeratorActionMutation, createModeratorActionMutationVariables>;
export const multiConversationModeratorMessageCountQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiConversationModeratorMessageCountQuery"),_1499,_o5(_7,[_o7(_8,_1500,_1118,_o5(_7,[_o6(_8,_1025,_1412),_796]))])),_366]) as unknown as DocumentNode<multiConversationModeratorMessageCountQueryQuery, multiConversationModeratorMessageCountQueryQueryVariables>;
export const multiUserAltAccountInfoQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserAltAccountInfoQuery"),_1117,_1768),_61,_622,_661,_681]) as unknown as DocumentNode<multiUserAltAccountInfoQueryQuery, multiUserAltAccountInfoQueryQueryVariables>;
export const updateModeratorActionModeratorActionItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateModeratorActionModeratorActionItem"),_1769,_1771),_61,_622]) as unknown as DocumentNode<updateModeratorActionModeratorActionItemMutation, updateModeratorActionModeratorActionItemMutationVariables>;
export const NewCommentModerationWarningDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"NewCommentModerationWarning"),_1180,_1209),_146,_158,_61,_184]) as unknown as DocumentNode<NewCommentModerationWarningQuery, NewCommentModerationWarningQueryVariables>;
export const createModeratorActionNewModeratorActionDialogDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createModeratorActionNewModeratorActionDialog"),_1764,_1766),_61,_622]) as unknown as DocumentNode<createModeratorActionNewModeratorActionDialogMutation, createModeratorActionNewModeratorActionDialogMutationVariables>;
export const NewPostModerationWarningDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"NewPostModerationWarning"),_1180,_1209),_146,_158,_61,_184]) as unknown as DocumentNode<NewPostModerationWarningQuery, NewPostModerationWarningQueryVariables>;
export const createReportReportFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createReportReportForm"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateReportDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createReport"),_1145,_1773)])),_61,_146,_158,_184,_23,_127,_136,_192,_198,_622,_661,_681,_688]) as unknown as DocumentNode<createReportReportFormMutation, createReportReportFormMutationVariables>;
export const updatePostSunshineCuratedSuggestionsItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostSunshineCuratedSuggestionsItem"),_1146,_o5(_7,[_o7(_8,_1147,_1142,_o5(_7,[_o6(_8,_266,_1774)]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_226,_270,_525,_529]) as unknown as DocumentNode<updatePostSunshineCuratedSuggestionsItemMutation, updatePostSunshineCuratedSuggestionsItemMutationVariables>;
export const multiPostsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostsListQuery"),_1121,_1487),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<multiPostsListQueryQuery, multiPostsListQueryQueryVariables>;
export const multiSunshineCurationPostsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiSunshineCurationPostsListQuery"),_1121,_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_o6(_8,_1025,_1774),_796]))])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_226,_270,_525,_529]) as unknown as DocumentNode<multiSunshineCurationPostsListQueryQuery, multiSunshineCurationPostsListQueryQueryVariables>;
export const multiGoogleServiceAccountSessionSunshineGoogleServiceAccountQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiGoogleServiceAccountSessionSunshineGoogleServiceAccountQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"GoogleServiceAccountSessionSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_o3(_3,"googleServiceAccountSessions"),_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_388)])),_796]))])),_391]) as unknown as DocumentNode<multiGoogleServiceAccountSessionSunshineGoogleServiceAccountQueryQuery, multiGoogleServiceAccountSessionSunshineGoogleServiceAccountQueryQueryVariables>;
export const updateCommentSunshineNewCommentsItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentSunshineNewCommentsItem"),_1171,_1436),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<updateCommentSunshineNewCommentsItemMutation, updateCommentSunshineNewCommentsItemMutationVariables>;
export const multiCommentSunshineNewCommentsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentSunshineNewCommentsListQuery"),_1775,_o5(_7,[_o7(_8,_871,_1061,_1240)])),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<multiCommentSunshineNewCommentsListQueryQuery, multiCommentSunshineNewCommentsListQueryQueryVariables>;
export const updatePostSunshineNewPostsItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostSunshineNewPostsItem"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostSunshineNewPostsItemMutation, updatePostSunshineNewPostsItemMutationVariables>;
export const createModeratorActionSunshineNewPostsItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createModeratorActionSunshineNewPostsItem"),_1764,_1776)]) as unknown as DocumentNode<createModeratorActionSunshineNewPostsItemMutation, createModeratorActionSunshineNewPostsItemMutationVariables>;
export const multiPostSunshineNewPostsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostSunshineNewPostsListQuery"),_1121,_1430),_23,_127,_61,_136,_146,_158,_184,_192,_335,_226,_622,_624,_629,_639]) as unknown as DocumentNode<multiPostSunshineNewPostsListQueryQuery, multiPostSunshineNewPostsListQueryQueryVariables>;
export const multiTagRelSunshineNewTagsItemQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagRelSunshineNewTagsItemQuery"),_1777,_1778),_624,_146,_158,_23,_127,_61,_136,_184,_192,_198,_960]) as unknown as DocumentNode<multiTagRelSunshineNewTagsItemQueryQuery, multiTagRelSunshineNewTagsItemQueryQueryVariables>;
export const updateTagSunshineNewTagsItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateTagSunshineNewTagsItem"),_1225,_o5(_7,[_o7(_8,_1226,_1142,_o5(_7,[_o6(_8,_266,_1779)]))])),_146,_61,_230,_226,_239,_708,_711,_828]) as unknown as DocumentNode<updateTagSunshineNewTagsItemMutation, updateTagSunshineNewTagsItemMutationVariables>;
export const multiTagSunshineNewTagsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagSunshineNewTagsListQuery"),_1406,_1780),_146,_61,_230,_226,_239,_708,_711,_828]) as unknown as DocumentNode<multiTagSunshineNewTagsListQueryQuery, multiTagSunshineNewTagsListQueryQueryVariables>;
export const multiCommentSunshineNewUsersInfoQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentSunshineNewUsersInfoQuery"),_1123,_1125),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<multiCommentSunshineNewUsersInfoQueryQuery, multiCommentSunshineNewUsersInfoQueryQueryVariables>;
export const multiUserSunshineNewUsersListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserSunshineNewUsersListQuery"),_1117,_1768),_61,_622,_661,_681]) as unknown as DocumentNode<multiUserSunshineNewUsersListQueryQuery, multiUserSunshineNewUsersListQueryQueryVariables>;
export const SunshineNewUsersProfileInfoDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SunshineNewUsersProfileInfo"),_1180,_o5(_7,[_o7(_8,_30,_1007,_1781)])),_61,_622,_661,_681]) as unknown as DocumentNode<SunshineNewUsersProfileInfoQuery, SunshineNewUsersProfileInfoQueryVariables>;
export const multiReportSunshineReportedContentListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiReportSunshineReportedContentListQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"ReportSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_o3(_3,"reports"),_1118,_o5(_7,[_o6(_8,_1025,_1772),_796]))])),_61,_146,_158,_184,_23,_127,_136,_192,_198,_622,_661,_681,_688]) as unknown as DocumentNode<multiReportSunshineReportedContentListQueryQuery, multiReportSunshineReportedContentListQueryQueryVariables>;
export const updatePostSunshineReportedItem1Document = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostSunshineReportedItem1"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostSunshineReportedItem1Mutation, updatePostSunshineReportedItem1MutationVariables>;
export const updateCommentSunshineReportedItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentSunshineReportedItem"),_1171,_1436),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<updateCommentSunshineReportedItemMutation, updateCommentSunshineReportedItemMutationVariables>;
export const updateReportSunshineReportedContentListDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateReportSunshineReportedContentList"),[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateReportDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"updateReport"),_1142,_1773)])),_61,_146,_158,_184,_23,_127,_136,_192,_198,_622,_661,_681,_688]) as unknown as DocumentNode<updateReportSunshineReportedContentListMutation, updateReportSunshineReportedContentListMutationVariables>;
export const multiModerationTemplateSunshineSendMessageWithDefaultsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiModerationTemplateSunshineSendMessageWithDefaultsQuery"),_1434,_1435),_226,_270,_438]) as unknown as DocumentNode<multiModerationTemplateSunshineSendMessageWithDefaultsQueryQuery, multiModerationTemplateSunshineSendMessageWithDefaultsQueryQueryVariables>;
export const multiConversationSunshineUserMessagesQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiConversationSunshineUserMessagesQuery"),_1499,_o5(_7,[_o7(_8,_1500,_1118,_o5(_7,[_o6(_8,_1025,_1496),_796]))])),_366,_61,_371,_375]) as unknown as DocumentNode<multiConversationSunshineUserMessagesQueryQuery, multiConversationSunshineUserMessagesQueryQueryVariables>;
export const multiUserRateLimitUserRateLimitItemQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserRateLimitUserRateLimitItemQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"UserRateLimitSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_679,_1118,_o5(_7,[_o6(_8,_1025,_680),_796]))])),_61,_661]) as unknown as DocumentNode<multiUserRateLimitUserRateLimitItemQueryQuery, multiUserRateLimitUserRateLimitItemQueryQueryVariables>;
export const updateUserRateLimitUserRateLimitItem1Document = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserRateLimitUserRateLimitItem1"),_1782,_o5(_7,[_o7(_8,_1783,_1142,_1784)])),_850]) as unknown as DocumentNode<updateUserRateLimitUserRateLimitItem1Mutation, updateUserRateLimitUserRateLimitItem1MutationVariables>;
export const updateUserRateLimitUserRateLimitItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserRateLimitUserRateLimitItem"),_1782,_o5(_7,[_o7(_8,_1783,_1142,_1785)])),_61,_661]) as unknown as DocumentNode<updateUserRateLimitUserRateLimitItemMutation, updateUserRateLimitUserRateLimitItemMutationVariables>;
export const createUserRateLimitUserRateLimitItem1Document = _o1(_1,[_o11(_986,_987,_o3(_3,"createUserRateLimitUserRateLimitItem1"),_1786,_o5(_7,[_o7(_8,_1787,_1145,_1784)])),_850]) as unknown as DocumentNode<createUserRateLimitUserRateLimitItem1Mutation, createUserRateLimitUserRateLimitItem1MutationVariables>;
export const createUserRateLimitUserRateLimitItemDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createUserRateLimitUserRateLimitItem"),_1786,_o5(_7,[_o7(_8,_1787,_1145,_1785)])),_61,_661]) as unknown as DocumentNode<createUserRateLimitUserRateLimitItemMutation, createUserRateLimitUserRateLimitItemMutationVariables>;
export const CurationPostViewQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CurationPostViewQuery"),_1336,_o5(_7,[_o7(_8,_527,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"curationNoticesPostView"),_o14(_1001,[_1399]))]))],_o5(_7,[_1153]))])),_61,_146,_158,_184,_23,_226,_270,_525]) as unknown as DocumentNode<CurationPostViewQueryQuery, CurationPostViewQueryQueryVariables>;
export const ModerationInboxDataQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"ModerationInboxDataQuery"),[_o12(_988,_1788,_1113),_o12(_988,_1789,_1057),_o12(_988,_1790,_1057),_o12(_988,_1791,_1012),_o12(_988,_1792,_1012),_o12(_988,_1793,_1012),_o12(_988,_1794,_1012)],_o5(_7,[_o7(_8,_288,[_1795,_o8(_536,_793,_1791)],_o5(_7,[_1767])),_o15(_8,_o3(_3,"reviewQueueUsers"),_288,[_1795,_o8(_536,_793,_1792)],_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_676]))])),_o7(_8,_250,[_o8(_536,_1003,_1789),_1796,_1797],_1429),_o15(_8,_o3(_3,"classifiedPosts"),_250,[_o8(_536,_1003,_1790),_1796,_1797],_1429),_o7(_8,_o3(_3,"CurationCandidatePosts"),[_o8(_536,_793,_1794)],_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_530)]))])),_o6(_8,_o3(_3,"LastCuratedDate"),_o5(_7,[_o4(_8,_o3(_3,"lastCuratedDate"))]))])),_61,_622,_661,_23,_127,_136,_146,_158,_184,_192,_335,_226,_624,_629,_681,_639,_531]) as unknown as DocumentNode<ModerationInboxDataQueryQuery, ModerationInboxDataQueryQueryVariables>;
export const singleUserSupermodQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"singleUserSupermodQuery"),_1180,_o5(_7,[_o7(_8,_30,_1220,_1781)])),_61,_622,_661,_681]) as unknown as DocumentNode<singleUserSupermodQueryQuery, singleUserSupermodQueryQueryVariables>;
export const addOrUpvoteTagModeratorCoreTagsChecklistDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"addOrUpvoteTagModeratorCoreTagsChecklist"),_1798,_1801),_624,_146,_158,_629]) as unknown as DocumentNode<addOrUpvoteTagModeratorCoreTagsChecklistMutation, addOrUpvoteTagModeratorCoreTagsChecklistMutationVariables>;
export const performVoteTagRelModeratorCoreTagsChecklistDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"performVoteTagRelModeratorCoreTagsChecklist"),_1804,_o5(_7,[_o7(_8,_1805,_1806,_o5(_7,[_1807]))])),_534]) as unknown as DocumentNode<performVoteTagRelModeratorCoreTagsChecklistMutation, performVoteTagRelModeratorCoreTagsChecklistMutationVariables>;
export const updateUserModeratorNotesDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserModeratorNotes"),_1195,_1756),_61,_622,_661,_681]) as unknown as DocumentNode<updateUserModeratorNotesMutation, updateUserModeratorNotesMutationVariables>;
export const multiModerationTemplateRestrictAndNotifyModalQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiModerationTemplateRestrictAndNotifyModalQuery"),_1434,_1435),_226,_270,_438]) as unknown as DocumentNode<multiModerationTemplateRestrictAndNotifyModalQueryQuery, multiModerationTemplateRestrictAndNotifyModalQueryQueryVariables>;
export const rejectContentAndRemoveFromQueueRestrictAndNotifyDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"rejectContentAndRemoveFromQueueRestrictAndNotify"),[_1076,_997,_1757,_1809,_o12(_988,_1811,_991)],_o5(_7,[_o10(_8,_1812,[_1110,_1092,_1091,_1813,_o8(_536,_1810,_1811)])]))]) as unknown as DocumentNode<rejectContentAndRemoveFromQueueRestrictAndNotifyMutation, rejectContentAndRemoveFromQueueRestrictAndNotifyMutationVariables>;
export const updateModeratorActionSupermodDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateModeratorActionSupermod"),_1769,_1771),_61,_622]) as unknown as DocumentNode<updateModeratorActionSupermodMutation, updateModeratorActionSupermodMutationVariables>;
export const updateUserModerationKeyboardDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserModerationKeyboard"),_1195,_1756),_61,_622,_661,_681]) as unknown as DocumentNode<updateUserModerationKeyboardMutation, updateUserModerationKeyboardMutationVariables>;
export const rejectContentAndRemoveFromQueueModerationKeyboardDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"rejectContentAndRemoveFromQueueModerationKeyboard"),[_1076,_997,_1757,_1809],_o5(_7,[_o10(_8,_1812,[_1110,_1092,_1091,_1813])]))]) as unknown as DocumentNode<rejectContentAndRemoveFromQueueModerationKeyboardMutation, rejectContentAndRemoveFromQueueModerationKeyboardMutationVariables>;
export const approveCurrentContentOnlyModerationKeyboardDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"approveCurrentContentOnlyModerationKeyboard"),_1641,_o5(_7,[_o10(_8,_o3(_3,"approveUserCurrentContentOnly"),_1814)]))]) as unknown as DocumentNode<approveCurrentContentOnlyModerationKeyboardMutation, approveCurrentContentOnlyModerationKeyboardMutationVariables>;
export const updatePostPostReviewActionsDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostPostReviewActions"),_1146,_1148),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<updatePostPostReviewActionsMutation, updatePostPostReviewActionsMutationVariables>;
export const createModeratorActionPostReviewActionsDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createModeratorActionPostReviewActions"),_1764,_1776)]) as unknown as DocumentNode<createModeratorActionPostReviewActionsMutation, createModeratorActionPostReviewActionsMutationVariables>;
export const RerunLlmCheckHookDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"RerunLlmCheckHook"),_1758,_o5(_7,[_o7(_8,_o3(_3,"rerunLlmCheck"),_1759,_338)])),_335]) as unknown as DocumentNode<RerunLlmCheckHookMutation, RerunLlmCheckHookMutationVariables>;
export const updateUserContentPermissionsDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserContentPermissions"),_1195,_1756),_61,_622,_661,_681]) as unknown as DocumentNode<updateUserContentPermissionsMutation, updateUserContentPermissionsMutationVariables>;
export const createModeratorActionContentPermissionsDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createModeratorActionContentPermissions"),_1764,_o5(_7,[_o7(_8,_1763,_1145,_1815)]))]) as unknown as DocumentNode<createModeratorActionContentPermissionsMutation, createModeratorActionContentPermissionsMutationVariables>;
export const updateModeratorActionContentPermissionsDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateModeratorActionContentPermissions"),_1769,_o5(_7,[_o7(_8,_1770,_1142,_1815)]))]) as unknown as DocumentNode<updateModeratorActionContentPermissionsMutation, updateModeratorActionContentPermissionsMutationVariables>;
export const addPostsToTagDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"addPostsToTag"),_1798,_o5(_7,[_o7(_8,_1799,_1800,_o5(_7,[_o4(_25,_773)]))])),_624,_146,_158,_23,_127,_61,_136,_184,_192,_198,_534,_774]) as unknown as DocumentNode<addPostsToTagMutation, addPostsToTagMutationVariables>;
export const AllPostsPageTagRevisionItemDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"AllPostsPageTagRevisionItem"),_1180,_o5(_7,[_o7(_8,_1359,_1007,_o5(_7,[_o6(_8,_1008,_1287)]))])),_550,_61,_703]) as unknown as DocumentNode<AllPostsPageTagRevisionItemQuery, AllPostsPageTagRevisionItemQueryVariables>;
export const multiTagAllTagsAlphabeticalQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagAllTagsAlphabeticalQuery"),_1406,_o5(_7,[_o7(_8,_191,_1118,_o5(_7,[_1816,_796]))])),_146,_158]) as unknown as DocumentNode<multiTagAllTagsAlphabeticalQueryQuery, multiTagAllTagsAlphabeticalQueryQueryVariables>;
export const AllWikiTagsPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"AllWikiTagsPageQuery"),[_o12(_988,_1818,_1103)],_o5(_7,[_o7(_8,_191,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"tagsBySlugs"),_o14(_1001,[_o8(_1002,_1817,_1818)]))]))],_o5(_7,[_o6(_8,_1025,_1819)]))])),_833]) as unknown as DocumentNode<AllWikiTagsPageQueryQuery, AllWikiTagsPageQueryQueryVariables>;
export const multiTagArbitalExplorePageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagArbitalExplorePageQuery"),[_1405,_1051,_1116,_1367],_o5(_7,[_o7(_8,_191,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_829)])),_796]))])),_146,_61,_230,_226,_239,_708,_711,_830]) as unknown as DocumentNode<multiTagArbitalExplorePageQueryQuery, multiTagArbitalExplorePageQueryQueryVariables>;
export const multiTagCoreTagsSectionQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagCoreTagsSectionQuery"),_1406,_o5(_7,[_o7(_8,_191,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_710])),_796]))])),_146,_61,_230,_226,_239,_708]) as unknown as DocumentNode<multiTagCoreTagsSectionQueryQuery, multiTagCoreTagsSectionQueryQueryVariables>;
export const FilterModeDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"FilterMode"),_1180,_1821),_146,_158]) as unknown as DocumentNode<FilterModeQuery, FilterModeQueryVariables>;
export const multiTagRelFooterTagListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagRelFooterTagListQuery"),_1777,_o5(_7,[_o7(_8,_637,_1118,_o5(_7,[_o6(_8,_1025,_638),_796]))])),_624,_146,_158,_629]) as unknown as DocumentNode<multiTagRelFooterTagListQueryQuery, multiTagRelFooterTagListQueryQueryVariables>;
export const addOrUpvoteTagDocument = _o1(_1,[_o11(_986,_987,_1799,_1798,_1801),_624,_146,_158,_629]) as unknown as DocumentNode<addOrUpvoteTagMutation, addOrUpvoteTagMutationVariables>;
export const multiTagLWTagPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagLWTagPageQuery"),_1406,_1822),_146,_61,_230,_226,_239,_708,_711,_767,_785]) as unknown as DocumentNode<multiTagLWTagPageQueryQuery, multiTagLWTagPageQueryQueryVariables>;
export const LWTagPageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"LWTagPage"),_1180,_1823),_146,_61,_230,_226,_239,_708,_270,_826]) as unknown as DocumentNode<LWTagPageQuery, LWTagPageQueryVariables>;
export const updateTagNewTagPageDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateTagNewTagPage"),_1225,_o5(_7,[_o7(_8,_1226,_1142,_o5(_7,[_o6(_8,_266,_1233)]))])),_146,_61,_230,_226,_239,_708,_270,_826]) as unknown as DocumentNode<updateTagNewTagPageMutation, updateTagNewTagPageMutationVariables>;
export const multiTagNewTagsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagNewTagsListQuery"),_1406,_1780),_146,_61,_230,_226,_239,_708,_711,_828]) as unknown as DocumentNode<multiTagNewTagsListQueryQuery, multiTagNewTagsListQueryQueryVariables>;
export const getRandomTagDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"getRandomTag"),_o5(_7,[_o6(_8,_o3(_3,"RandomTag"),_o5(_7,[_12]))]))]) as unknown as DocumentNode<getRandomTagQuery, getRandomTagQueryVariables>;
export const multiMultiDocumentRedlinkTagPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiMultiDocumentRedlinkTagPageQuery"),_1437,_o5(_7,[_o7(_8,_1438,_1118,_o5(_7,[_o6(_8,_1025,_449),_796]))])),_446]) as unknown as DocumentNode<multiMultiDocumentRedlinkTagPageQueryQuery, multiMultiDocumentRedlinkTagPageQueryQueryVariables>;
export const multiTagRedlinkTagPageQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagRedlinkTagPageQuery"),_1406,_1408),_146]) as unknown as DocumentNode<multiTagRedlinkTagPageQueryQuery, multiTagRedlinkTagPageQueryQueryVariables>;
export const multiSubscriptionSubscribeButtonQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiSubscriptionSubscribeButtonQuery"),_1419,_1422),_762]) as unknown as DocumentNode<multiSubscriptionSubscribeButtonQueryQuery, multiSubscriptionSubscribeButtonQueryQueryVariables>;
export const createSubscriptionSubscribeButtonDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createSubscriptionSubscribeButton"),_1423,_1424),_762]) as unknown as DocumentNode<createSubscriptionSubscribeButtonMutation, createSubscriptionSubscribeButtonMutationVariables>;
export const multiMultiDocumentSummariesEditFormQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiMultiDocumentSummariesEditFormQuery"),_1437,_o5(_7,[_o7(_8,_1438,_1118,_o5(_7,[_o6(_8,_1025,_718),_796]))])),_446,_226,_270,_714]) as unknown as DocumentNode<multiMultiDocumentSummariesEditFormQueryQuery, multiMultiDocumentSummariesEditFormQueryQueryVariables>;
export const reorderSummariesDocument = _o1(_1,[_o11(_986,_987,_1824,[_o12(_988,_1825,_992),_o12(_988,_1827,_992),_o12(_988,_1829,_1103)],_o5(_7,[_o10(_8,_1824,[_o8(_536,_441,_1825),_o8(_536,_1826,_1827),_o8(_536,_1828,_1829)])]))]) as unknown as DocumentNode<reorderSummariesMutation, reorderSummariesMutationVariables>;
export const updateMultiDocumentSummaryFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateMultiDocumentSummaryForm"),_1830,_o5(_7,[_o7(_8,_1831,_1142,_1832)])),_446,_226,_270,_714]) as unknown as DocumentNode<updateMultiDocumentSummaryFormMutation, updateMultiDocumentSummaryFormMutationVariables>;
export const createMultiDocumentSummaryFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createMultiDocumentSummaryForm"),_1833,_o5(_7,[_o7(_8,_1834,_1145,_1832)])),_446,_226,_270,_714]) as unknown as DocumentNode<createMultiDocumentSummaryFormMutation, createMultiDocumentSummaryFormMutationVariables>;
export const multiRevisionTagCompareRevisionsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiRevisionTagCompareRevisionsQuery"),_1129,_1536),_550,_61,_703]) as unknown as DocumentNode<multiRevisionTagCompareRevisionsQueryQuery, multiRevisionTagCompareRevisionsQueryQueryVariables>;
export const TagContributorsListDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TagContributorsList"),_1180,_o5(_7,[_o7(_8,_165,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_823)]))]))])),_61,_824]) as unknown as DocumentNode<TagContributorsListQuery, TagContributorsListQueryVariables>;
export const multiCommentTagDiscussionQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentTagDiscussionQuery"),_1123,_1241),_146,_158,_61,_184]) as unknown as DocumentNode<multiCommentTagDiscussionQueryQuery, multiCommentTagDiscussionQueryQueryVariables>;
export const multiCommentTagDiscussionButtonQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentTagDiscussionButtonQuery"),_1123,_1241),_146,_158,_61,_184]) as unknown as DocumentNode<multiCommentTagDiscussionButtonQueryQuery, multiCommentTagDiscussionButtonQueryQueryVariables>;
export const multiCommentTagDiscussionSectionQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentTagDiscussionSectionQuery"),_1123,_1241),_146,_158,_61,_184]) as unknown as DocumentNode<multiCommentTagDiscussionSectionQueryQuery, multiCommentTagDiscussionSectionQueryQueryVariables>;
export const multiRevisionTagEditsByUserQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiRevisionTagEditsByUserQuery"),_1129,_1132),_550,_61,_703,_146,_230,_226,_239,_708,_711,_446,_270,_714,_719,_722,_726,_730,_735]) as unknown as DocumentNode<multiRevisionTagEditsByUserQueryQuery, multiRevisionTagEditsByUserQueryQueryVariables>;
export const getTagUpdatesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getTagUpdates"),[_o12(_988,_1658,_1835),_o12(_988,_1837,_1835)],_o5(_7,[_o7(_8,_o3(_3,"TagUpdatesInTimeBlock"),[_1659,_o8(_536,_1836,_1837)],_o5(_7,[_732,_o4(_8,_o3(_3,"revisionIds")),_57,_o4(_8,_1099),_o4(_8,_o3(_3,"lastRevisedAt")),_91,_o4(_8,_o3(_3,"added")),_o4(_8,_o3(_3,"removed")),_289,_o6(_8,_o3(_3,"documentDeletions"),_o5(_7,[_20,_282,_o4(_8,_o3(_3,"netChange")),_265,_o6(_8,_o3(_3,"docFields"),_o5(_7,[_10,_12,_443,_444])),_47]))]))])),_146,_61,_230,_226,_239,_708,_711,_446,_270,_714,_719]) as unknown as DocumentNode<getTagUpdatesQuery, getTagUpdatesQueryVariables>;
export const updateTagFlagTagFlagEditAndNewFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateTagFlagTagFlagEditAndNewForm"),[_1138,_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateTagFlagDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"updateTagFlag"),_1142,_1838)])),_767]) as unknown as DocumentNode<updateTagFlagTagFlagEditAndNewFormMutation, updateTagFlagTagFlagEditAndNewFormMutationVariables>;
export const createTagFlagTagFlagEditAndNewFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createTagFlagTagFlagEditAndNewForm"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateTagFlagDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createTagFlag"),_1145,_1838)])),_767]) as unknown as DocumentNode<createTagFlagTagFlagEditAndNewFormMutation, createTagFlagTagFlagEditAndNewFormMutationVariables>;
export const multiTagTagFlagItemQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagTagFlagItemQuery"),_1406,_1822),_146,_61,_230,_226,_239,_708,_711,_767,_785]) as unknown as DocumentNode<multiTagTagFlagItemQueryQuery, multiTagTagFlagItemQueryQueryVariables>;
export const TagFlagItemDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TagFlagItem"),_1180,_o5(_7,[_o7(_8,_1839,_1007,_o5(_7,[_o6(_8,_1008,_783)]))])),_767]) as unknown as DocumentNode<TagFlagItemQuery, TagFlagItemQueryVariables>;
export const updateTagTagFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateTagTagForm"),_1225,_1229),_146,_61,_230,_226,_239,_708,_711,_767,_785]) as unknown as DocumentNode<updateTagTagFormMutation, updateTagTagFormMutationVariables>;
export const createTagTagFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createTagTagForm"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateTagDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createTag"),_1145,_1228)])),_146,_61,_230,_226,_239,_708,_711,_767,_785]) as unknown as DocumentNode<createTagTagFormMutation, createTagTagFormMutationVariables>;
export const multiChapterTagIntroSequenceQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiChapterTagIntroSequenceQuery"),_1737,_1738),_226,_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_277]) as unknown as DocumentNode<multiChapterTagIntroSequenceQueryQuery, multiChapterTagIntroSequenceQueryQueryVariables>;
export const TagMergePageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TagMergePage"),_1180,_o5(_7,[_o7(_8,_165,_1007,_o5(_7,[_1223]))])),_146,_61,_230,_226,_239,_708,_711]) as unknown as DocumentNode<TagMergePageQuery, TagMergePageQueryVariables>;
export const mergeTagsDocument = _o1(_1,[_o11(_986,_987,_1840,[_o12(_988,_1842,_992),_o12(_988,_1844,_992),_o12(_988,_1846,_1019),_o12(_988,_1848,_1019)],_o5(_7,[_o10(_8,_1840,[_o8(_536,_1841,_1842),_o8(_536,_1843,_1844),_o8(_536,_1845,_1846),_o8(_536,_1847,_1848)])]))]) as unknown as DocumentNode<mergeTagsMutation, mergeTagsMutationVariables>;
export const promoteLensToMainDocument = _o1(_1,[_o11(_986,_987,_1849,[_o12(_988,_1851,_992)],_o5(_7,[_o10(_8,_1849,[_o8(_536,_1850,_1851)])]))]) as unknown as DocumentNode<promoteLensToMainMutation, promoteLensToMainMutationVariables>;
export const multiPostTagPreviewQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostTagPreviewQuery"),_1121,_1487),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<multiPostTagPreviewQueryQuery, multiPostTagPreviewQueryQueryVariables>;
export const TagSearchHitDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TagSearchHit"),_1180,_1821),_146,_158]) as unknown as DocumentNode<TagSearchHitQuery, TagSearchHitQueryVariables>;
export const multiVoteTagVoteActivityQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiVoteTagVoteActivityQuery"),_1193,_o5(_7,[_o7(_8,_1194,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_961)])),_796]))])),_534,_958,_624,_146,_158,_23,_127,_61,_136,_184,_192,_198,_960,_963]) as unknown as DocumentNode<multiVoteTagVoteActivityQueryQuery, multiVoteTagVoteActivityQueryQueryVariables>;
export const multiTagFlagTaggingDashboardQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagFlagTaggingDashboardQuery"),[_o12(_988,_1056,_o4(_5,_o3(_3,"TagFlagSelector"))),_1051,_1116],_o5(_7,[_o7(_8,_782,_1118,_o5(_7,[_o6(_8,_1025,_783),_796]))])),_767]) as unknown as DocumentNode<multiTagFlagTaggingDashboardQueryQuery, multiTagFlagTaggingDashboardQueryQueryVariables>;
export const multiTagTaggingDashboardQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagTaggingDashboardQuery"),_1406,_1822),_146,_61,_230,_226,_239,_708,_711,_767,_785]) as unknown as DocumentNode<multiTagTaggingDashboardQueryQuery, multiTagTaggingDashboardQueryQueryVariables>;
export const TaggingDashboardDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TaggingDashboard"),_1180,_o5(_7,[_o7(_8,_1839,_1007,_o5(_7,[_o6(_8,_1008,_o5(_7,[_o4(_25,_768)]))]))])),_767,_226,_270,_770]) as unknown as DocumentNode<TaggingDashboardQuery, TaggingDashboardQueryVariables>;
export const multiTagRelTagsDetailsItemQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagRelTagsDetailsItemQuery"),_1777,_1778),_624,_146,_158,_23,_127,_61,_136,_184,_192,_198,_960]) as unknown as DocumentNode<multiTagRelTagsDetailsItemQueryQuery, multiTagRelTagsDetailsItemQueryQueryVariables>;
export const TagsDetailsItemDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TagsDetailsItem"),_1180,_1823),_146,_61,_230,_226,_239,_708,_270,_826]) as unknown as DocumentNode<TagsDetailsItemQuery, TagsDetailsItemQueryVariables>;
export const GetTagsByCoreTagIdDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"GetTagsByCoreTagId"),[_o12(_988,_1852,_991),_1051,_o12(_988,_1854,_1382)],_o5(_7,[_o7(_8,_o3(_3,"TagsByCoreTagId"),[_o8(_536,_832,_1852),_1054,_o8(_536,_1853,_1854)],_o5(_7,[_o6(_8,_191,_1819),_796]))])),_833]) as unknown as DocumentNode<GetTagsByCoreTagIdQuery, GetTagsByCoreTagIdQueryVariables>;
export const updateMultiDocumentLensFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateMultiDocumentLensForm"),_1830,_o5(_7,[_o7(_8,_1831,_1142,_1855)])),_446,_226,_270,_714,_722,_726]) as unknown as DocumentNode<updateMultiDocumentLensFormMutation, updateMultiDocumentLensFormMutationVariables>;
export const createMultiDocumentLensFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createMultiDocumentLensForm"),_1833,_o5(_7,[_o7(_8,_1834,_1145,_1855)])),_446,_226,_270,_714,_722,_726]) as unknown as DocumentNode<createMultiDocumentLensFormMutation, createMultiDocumentLensFormMutationVariables>;
export const tagBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"tagFragmentBySlug"),_1856,_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_1857]))])),_146,_61,_230,_226,_239,_708,_711]) as unknown as DocumentNode<tagBySlugQuery, tagBySlugQueryVariables>;
export const tagBasicInfoBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"tagBasicInfoBySlug"),_1856,_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_1407]))])),_146]) as unknown as DocumentNode<tagBasicInfoBySlugQuery, tagBasicInfoBySlugQueryVariables>;
export const allTagsPageBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"allTagsPageFragmentBySlug"),_1856,_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_811)]))]))])),_146,_61,_230,_226,_239,_708,_711,_767,_785,_812]) as unknown as DocumentNode<allTagsPageBySlugQuery, allTagsPageBySlugQueryVariables>;
export const tagPageBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"tagPageFragmentBySlug"),_1858,_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_o6(_8,_1025,_1368)]))])),_146,_61,_230,_226,_239,_708,_711,_767,_785,_23,_127,_136,_158,_184,_192,_198,_203,_207,_801]) as unknown as DocumentNode<tagPageBySlugQuery, tagPageBySlugQueryVariables>;
export const tagPageWithRevisionBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"tagPageWithRevisionFragmentBySlug"),_1859,_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_o6(_8,_1025,_o5(_7,[_821]))]))])),_146,_61,_230,_226,_239,_708,_814,_767,_816,_23,_127,_136,_158,_184,_192,_198,_203,_207,_819]) as unknown as DocumentNode<tagPageWithRevisionBySlugQuery, tagPageWithRevisionBySlugQueryVariables>;
export const tagEditBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"tagEditFragmentBySlug"),_1856,_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_o6(_8,_1025,_1233)]))])),_146,_61,_230,_226,_239,_708,_270,_826]) as unknown as DocumentNode<tagEditBySlugQuery, tagEditBySlugQueryVariables>;
export const tagHistoryBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"tagHistoryFragmentBySlug"),_1856,_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_o6(_8,_1025,_729)]))])),_146,_61,_230,_226,_239,_708,_711,_446,_270,_714,_719]) as unknown as DocumentNode<tagHistoryBySlugQuery, tagHistoryBySlugQueryVariables>;
export const tagPageWithArbitalContentBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"tagPageWithArbitalContentFragmentBySlug"),_1858,_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_807)]))]))])),_146,_61,_230,_226,_239,_708,_711,_767,_785,_23,_127,_136,_158,_184,_192,_198,_203,_207,_801,_446,_270,_714,_722,_726,_803,_806,_810]) as unknown as DocumentNode<tagPageWithArbitalContentBySlugQuery, tagPageWithArbitalContentBySlugQueryVariables>;
export const tagPageRevisionWithArbitalContentBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"tagPageRevisionWithArbitalContentFragmentBySlug"),_1859,_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_820)]))]))])),_146,_61,_230,_226,_239,_708,_814,_767,_816,_23,_127,_136,_158,_184,_192,_198,_203,_207,_819,_446,_270,_714,_722,_726,_803,_806,_822]) as unknown as DocumentNode<tagPageRevisionWithArbitalContentBySlugQuery, tagPageRevisionWithArbitalContentBySlugQueryVariables>;
export const tagPageWithArbitalContentAndLensRevisionBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"tagPageWithArbitalContentAndLensRevisionFragmentBySlug"),[_1405,_1051,_1230,_1367,_o12(_988,_840,_991)],_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_838)]))]))])),_146,_61,_230,_226,_239,_708,_711,_767,_785,_23,_127,_136,_158,_184,_192,_198,_203,_207,_801,_722,_446,_270,_835,_837,_841]) as unknown as DocumentNode<tagPageWithArbitalContentAndLensRevisionBySlugQuery, tagPageWithArbitalContentAndLensRevisionBySlugQueryVariables>;
export const multiTagCoreTagsChecklistQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiTagCoreTagsChecklistQuery"),_1406,_o5(_7,[_o7(_8,_191,_1118,_o5(_7,[_1857,_796]))])),_146,_61,_230,_226,_239,_708,_711]) as unknown as DocumentNode<multiTagCoreTagsChecklistQueryQuery, multiTagCoreTagsChecklistQueryQueryVariables>;
export const getTagOrLensPreviewDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getTagOrLensPreview"),_1860,_o5(_7,[_o7(_8,_1861,_1862,_o5(_7,[_627,_1863,_725]))])),_146,_446,_226,_270,_158,_714]) as unknown as DocumentNode<getTagOrLensPreviewQuery, getTagOrLensPreviewQueryVariables>;
export const getTagOrLensSectionPreviewDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getTagOrLensSectionPreview"),_1860,_o5(_7,[_o7(_8,_1861,_1862,_o5(_7,[_o6(_8,_165,_1864),_1863,_725]))])),_146,_446,_226,_270,_779,_714]) as unknown as DocumentNode<getTagOrLensSectionPreviewQuery, getTagOrLensSectionPreviewQueryVariables>;
export const getTagPreviewDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getTagPreview"),_1856,_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_1816]))])),_146,_158]) as unknown as DocumentNode<getTagPreviewQuery, getTagPreviewQueryVariables>;
export const getTagSectionPreviewDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getTagSectionPreview"),[_1405,_1051,_1265],_o5(_7,[_o7(_8,_191,_1061,_o5(_7,[_o6(_8,_1025,_1864)]))])),_146,_779]) as unknown as DocumentNode<getTagSectionPreviewQuery, getTagSectionPreviewQueryVariables>;
export const SequencesPageTitleDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SequencesPageTitle"),_1180,_o5(_7,[_o7(_8,_560,_1489,_1865)])),_230]) as unknown as DocumentNode<SequencesPageTitleQuery, SequencesPageTitleQueryVariables>;
export const multiUserUserPageTitleQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserUserPageTitleQuery"),_1117,_1179),_61]) as unknown as DocumentNode<multiUserUserPageTitleQueryQuery, multiUserUserPageTitleQueryQueryVariables>;
export const SingleCommentForFeedbackDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SingleCommentForFeedback"),_998,_o5(_7,[_o7(_8,_221,_1866,_o5(_7,[_o6(_8,_1008,_222)]))])),_146,_158,_61,_184,_23,_127,_136,_192,_198,_203,_207,_217]) as unknown as DocumentNode<SingleCommentForFeedbackQuery, SingleCommentForFeedbackQueryVariables>;
export const multiCommentUltraFeedPostDialogQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentUltraFeedPostDialogQuery"),_1123,_1241),_146,_158,_61,_184]) as unknown as DocumentNode<multiCommentUltraFeedPostDialogQueryQuery, multiCommentUltraFeedPostDialogQueryQueryVariables>;
export const UltraFeedPostDialogDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UltraFeedPostDialog"),_1180,_o5(_7,[_o7(_8,_210,_1007,_1867)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_510]) as unknown as DocumentNode<UltraFeedPostDialogQuery, UltraFeedPostDialogQueryVariables>;
export const UltraFeedTargetCommentDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UltraFeedTargetComment"),_1180,_1213),_146,_158,_61,_184,_23,_127,_316]) as unknown as DocumentNode<UltraFeedTargetCommentQuery, UltraFeedTargetCommentQueryVariables>;
export const LocalPostQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"LocalPostQuery"),_998,_o5(_7,[_o7(_8,_210,_1215,_1867)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_510]) as unknown as DocumentNode<LocalPostQueryQuery, LocalPostQueryQueryVariables>;
export const UserRecentPostsForCompactCardDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UserRecentPostsForCompactCard"),_1121,_o5(_7,[_o7(_8,_250,_1118,_1720)])),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<UserRecentPostsForCompactCardQuery, UserRecentPostsForCompactCardQueryVariables>;
export const UltraFeedThreadItemDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UltraFeedThreadItem"),_1180,_o5(_7,[_o7(_8,_210,_1215,_1321)])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<UltraFeedThreadItemQuery, UltraFeedThreadItemQueryVariables>;
export const createUltraFeedEventDocument = _o1(_1,[_o11(_986,_987,_1868,[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateUltraFeedEventDataInput"))))],_o5(_7,[_o7(_8,_1868,_1145,_1741)]))]) as unknown as DocumentNode<createUltraFeedEventMutation, createUltraFeedEventMutationVariables>;
export const updateUltraFeedEventDocument = _o1(_1,[_o11(_986,_987,_1869,[_o12(_988,_1056,_992),_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"UpdateUltraFeedEventDataInput"))))],_o5(_7,[_o7(_8,_1869,_1142,_1741)]))]) as unknown as DocumentNode<updateUltraFeedEventMutation, updateUltraFeedEventMutationVariables>;
export const connectCrossposterDocument = _o1(_1,[_o11(_986,_987,_1870,_1872,_o5(_7,[_o10(_8,_1870,_1645)]))]) as unknown as DocumentNode<connectCrossposterMutation, connectCrossposterMutationVariables>;
export const useEmailTokenDocument = _o1(_1,[_o11(_986,_987,_1873,_1872,_o5(_7,[_o10(_8,_1873,_1645)]))]) as unknown as DocumentNode<useEmailTokenMutation, useEmailTokenMutationVariables>;
export const sendEventTriggeredDMDocument = _o1(_1,[_o11(_986,_987,_1874,_1714,_o5(_7,[_o10(_8,_1874,_1715)]))]) as unknown as DocumentNode<sendEventTriggeredDMMutation, sendEventTriggeredDMMutationVariables>;
export const multiPostLWUserTooltipContentQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostLWUserTooltipContentQuery"),_1121,_1487),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<multiPostLWUserTooltipContentQueryQuery, multiPostLWUserTooltipContentQueryQueryVariables>;
export const userTooltipProfileQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"userTooltipProfileQuery"),_1180,_1380),_61,_226,_906]) as unknown as DocumentNode<userTooltipProfileQueryQuery, userTooltipProfileQueryQueryVariables>;
export const TopKarmaUsersDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TopKarmaUsers"),_1117,_1179),_61]) as unknown as DocumentNode<TopKarmaUsersQuery, TopKarmaUsersQueryVariables>;
export const AirtableLeaderboardsDocument = _o1(_1,[_o17(_986,_995,_1875,_o5(_7,[_o6(_8,_1875,_o5(_7,[_123,_o4(_8,_o3(_3,"leaderboardAmount"))]))]))]) as unknown as DocumentNode<AirtableLeaderboardsQuery, AirtableLeaderboardsQueryVariables>;
export const getNetKarmaChangesForAuthorsOverPeriodDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"getNetKarmaChangesForAuthorsOverPeriod"),[_o12(_988,_1877,_1107),_1108],_o5(_7,[_o7(_8,_o3(_3,"NetKarmaChangesForAuthorsOverPeriod"),[_o8(_536,_1876,_1877),_1054],_o5(_7,[_20,_o4(_8,_o3(_3,"netKarma"))]))]))]) as unknown as DocumentNode<getNetKarmaChangesForAuthorsOverPeriodQuery, getNetKarmaChangesForAuthorsOverPeriodQueryVariables>;
export const loginDocument = _o1(_1,[_o11(_986,_987,_1878,[_1880,_1883],_o5(_7,[_o7(_8,_1878,[_1884,_1885],_1095)]))]) as unknown as DocumentNode<loginMutation, loginMutationVariables>;
export const signupDocument = _o1(_1,[_o11(_986,_987,_1886,[_1558,_1880,_1883,_o12(_988,_1888,_1018),_o12(_988,_1890,_991),_o12(_988,_1891,_991)],_o5(_7,[_o7(_8,_1886,[_1564,_1884,_1885,_o8(_536,_1887,_1888),_o8(_536,_1889,_1890),_o8(_536,_930,_1891)],_1095)]))]) as unknown as DocumentNode<signupMutation, signupMutationVariables>;
export const resetPasswordDocument = _o1(_1,[_o11(_986,_987,_1892,[_1558],_o5(_7,[_o10(_8,_1892,[_1564])]))]) as unknown as DocumentNode<resetPasswordMutation, resetPasswordMutationVariables>;
export const usePasswordResetEmailTokenDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"usePasswordResetEmailToken"),[_1871,_o12(_988,_1894,_1286)],_o5(_7,[_o10(_8,_1873,[_1644,_o8(_536,_1893,_1894)])]))]) as unknown as DocumentNode<usePasswordResetEmailTokenMutation, usePasswordResetEmailTokenMutationVariables>;
export const multiSubscriptionSubscriptionsListQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiSubscriptionSubscriptionsListQuery"),_1419,_1422),_762]) as unknown as DocumentNode<multiSubscriptionSubscriptionsListQueryQuery, multiSubscriptionSubscriptionsListQueryQueryVariables>;
export const UserContentFeedPostsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UserContentFeedPosts"),[_1076,_1108,_o12(_988,_1895,_992)],_o5(_7,[_o7(_8,_250,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1078,_o14(_1001,[_1079,_o8(_1002,_1080,_1895),_o8(_1002,_111,_o18("NullValue"))]))])),_1054,_1797],_1457)])),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207]) as unknown as DocumentNode<UserContentFeedPostsQuery, UserContentFeedPostsQueryVariables>;
export const UserContentFeedCommentsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UserContentFeedComments"),[_1076,_1108,_o12(_988,_1305,_992)],_o5(_7,[_o7(_8,_871,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1085,_o14(_1001,[_1079,_o8(_1002,_1086,_1305)]))])),_1054,_1797],_o5(_7,[_o6(_8,_1025,_o5(_7,[_189,_213,_o6(_8,_616,_619)])),_796]))])),_146,_158,_61,_23,_127,_136,_184,_192,_198,_203,_207,_617]) as unknown as DocumentNode<UserContentFeedCommentsQuery, UserContentFeedCommentsQueryVariables>;
export const UserContentFeedWikiEditsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UserContentFeedWikiEdits"),_1109,_o5(_7,[_o7(_8,_555,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"revisionsByUser"),_o14(_1001,[_1079]))])),_1054,_1797],_1131)])),_550,_61,_703,_146,_230,_226,_239,_708,_711,_446,_270,_714,_719,_722,_726,_730,_735]) as unknown as DocumentNode<UserContentFeedWikiEditsQuery, UserContentFeedWikiEditsQueryVariables>;
export const UserContentFeedThreadDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UserContentFeedThread"),[_o12(_988,_1896,_992),_1051],_o5(_7,[_o7(_8,_871,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_o3(_3,"repliesToCommentThreadIncludingRoot"),_o14(_1001,[_o8(_1002,_173,_1896)]))])),_1054],_o5(_7,[_o6(_8,_1025,_222)]))])),_146,_158,_61,_184,_23,_127,_136,_192,_198,_203,_207,_217]) as unknown as DocumentNode<UserContentFeedThreadQuery, UserContentFeedThreadQueryVariables>;
export const UsersNameWrapperDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UsersNameWrapper"),_1180,_1364),_61]) as unknown as DocumentNode<UsersNameWrapperQuery, UsersNameWrapperQueryVariables>;
export const multiUserUsersProfileQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiUserUsersProfileQuery"),_1117,_1120),_61,_226,_906]) as unknown as DocumentNode<multiUserUsersProfileQueryQuery, multiUserUsersProfileQueryQueryVariables>;
export const updateUserDeactivateAccountSectionDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserDeactivateAccountSection"),_1195,_1520),_61,_226,_906,_934,_270,_943]) as unknown as DocumentNode<updateUserDeactivateAccountSectionMutation, updateUserDeactivateAccountSectionMutationVariables>;
export const updateUserDeleteAccountSectionDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserDeleteAccountSection"),_1195,_1520),_61,_226,_906,_934,_270,_943]) as unknown as DocumentNode<updateUserDeleteAccountSectionMutation, updateUserDeleteAccountSectionMutationVariables>;
export const UsersSearchForMergeDocument = _o1(_1,[_o11(_986,_995,_1897,[_1201],_o5(_7,[_o7(_8,_1897,[_1205],_o5(_7,[_o4(_25,_949)]))])),_61,_950]) as unknown as DocumentNode<UsersSearchForMergeQuery, UsersSearchForMergeQueryVariables>;
export const MergeAccountsDocument = _o1(_1,[_o11(_986,_987,_1898,[_o12(_988,_1899,_992),_o12(_988,_1901,_992),_o12(_988,_1903,_1019)],_o5(_7,[_o7(_8,_1898,[_o8(_536,_665,_1899),_o8(_536,_1900,_1901),_o8(_536,_1902,_1903)],_o5(_7,[_o4(_8,_o3(_3,"completed")),_1629,_o6(_8,_o3(_3,"failures"),_o5(_7,[_o4(_8,_o3(_3,"stage")),_455,_220,_282]))]))]))]) as unknown as DocumentNode<MergeAccountsMutation, MergeAccountsMutationVariables>;
export const SoftDeleteUserDocument = _o1(_1,[_o11(_986,_987,_1904,_1641,_o5(_7,[_o10(_8,_1904,_1814)]))]) as unknown as DocumentNode<SoftDeleteUserMutation, SoftDeleteUserMutationVariables>;
export const UserTopPostsForManagerDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UserTopPostsForManager"),_1059,_o5(_7,[_o7(_8,_250,_1061,_1720)])),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<UserTopPostsForManagerQuery, UserTopPostsForManagerQueryVariables>;
export const UsersAccountTargetUserDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UsersAccountTargetUser"),_1069,_1505),_61]) as unknown as DocumentNode<UsersAccountTargetUserQuery, UsersAccountTargetUserQueryVariables>;
export const UsersAccountManagementGetUserBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UsersAccountManagementGetUserBySlug"),_1069,_1905),_61,_226,_906,_934,_270,_943]) as unknown as DocumentNode<UsersAccountManagementGetUserBySlugQuery, UsersAccountManagementGetUserBySlugQueryVariables>;
export const UsersEditFormGetUserBySlugDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UsersEditFormGetUserBySlug"),_1069,_1905),_61,_226,_906,_934,_270,_943]) as unknown as DocumentNode<UsersEditFormGetUserBySlugQuery, UsersEditFormGetUserBySlugQueryVariables>;
export const updateUserAutoSavedSettingsDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserAutoSavedSettings"),_1195,_1520),_61,_226,_906,_934,_270,_943]) as unknown as DocumentNode<updateUserAutoSavedSettingsMutation, updateUserAutoSavedSettingsMutationVariables>;
export const KarmaChangeNotifierDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"KarmaChangeNotifier"),_1180,_1511),_878]) as unknown as DocumentNode<KarmaChangeNotifierQuery, KarmaChangeNotifierQueryVariables>;
export const karmaChangesCheckedKarmaChangeNotifierDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"karmaChangesCheckedKarmaChangeNotifier"),[_1391,_1393],_o5(_7,[_o10(_8,_o3(_3,"karmaChangesChecked"),[_1394,_1395])]))]) as unknown as DocumentNode<karmaChangesCheckedKarmaChangeNotifierMutation, karmaChangesCheckedKarmaChangeNotifierMutationVariables>;
export const KarmaChangePostBodiesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"KarmaChangePostBodies"),_1059,_o5(_7,[_o7(_8,_250,_1722,_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_o6(_8,_36,_155)]))]))]))]) as unknown as DocumentNode<KarmaChangePostBodiesQuery, KarmaChangePostBodiesQueryVariables>;
export const KarmaChangeCommentBodiesDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"KarmaChangeCommentBodies"),_1775,_o5(_7,[_o7(_8,_871,_1722,_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_1338]))]))]))]) as unknown as DocumentNode<KarmaChangeCommentBodiesQuery, KarmaChangeCommentBodiesQueryVariables>;
export const SubscribedUserDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SubscribedUser"),_998,_o5(_7,[_o7(_8,_30,_1866,_1363)])),_61]) as unknown as DocumentNode<SubscribedUserQuery, SubscribedUserQueryVariables>;
export const SubscribedPostDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SubscribedPost"),_998,_o5(_7,[_o7(_8,_210,_1866,_1426)])),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<SubscribedPostQuery, SubscribedPostQueryVariables>;
export const SubscribedCommentDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SubscribedComment"),_998,_o5(_7,[_o7(_8,_221,_1866,_1235)])),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<SubscribedCommentQuery, SubscribedCommentQueryVariables>;
export const SubscribedLocalgroupDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SubscribedLocalgroup"),_998,_o5(_7,[_o7(_8,_1098,_1866,_o5(_7,[_o6(_8,_1008,_944)]))])),_61,_415]) as unknown as DocumentNode<SubscribedLocalgroupQuery, SubscribedLocalgroupQueryVariables>;
export const SubscribedTagDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SubscribedTag"),_998,_o5(_7,[_o7(_8,_165,_1866,_1820)])),_146,_158]) as unknown as DocumentNode<SubscribedTagQuery, SubscribedTagQueryVariables>;
export const SubscribedSequenceDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SubscribedSequence"),_998,_o5(_7,[_o7(_8,_560,_1866,_1865)])),_230]) as unknown as DocumentNode<SubscribedSequenceQuery, SubscribedSequenceQueryVariables>;
export const updateUserReactionsPaletteDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateUserReactionsPalette"),_1195,_1198),_61,_226,_934]) as unknown as DocumentNode<updateUserReactionsPaletteMutation, updateUserReactionsPaletteMutationVariables>;
export const performVoteCommentDocument = _o1(_1,[_o11(_986,_987,_1263,_1804,_o5(_7,[_o7(_8,_1263,_1806,_1264)])),_344]) as unknown as DocumentNode<performVoteCommentMutation, performVoteCommentMutationVariables>;
export const performVotePostDocument = _o1(_1,[_o11(_986,_987,_1256,_1804,_o5(_7,[_o7(_8,_1256,_1806,_1262)])),_641]) as unknown as DocumentNode<performVotePostMutation, performVotePostMutationVariables>;
export const performVoteTagRelDocument = _o1(_1,[_o11(_986,_987,_1805,_1804,_o5(_7,[_o7(_8,_1805,_1806,_o5(_7,[_1807,_1261]))])),_534]) as unknown as DocumentNode<performVoteTagRelMutation, performVoteTagRelMutationVariables>;
export const performVoteRevisionDocument = _o1(_1,[_o11(_986,_987,_1906,_1804,_o5(_7,[_o7(_8,_1906,_1806,_o5(_7,[_o6(_8,_1260,_o5(_7,[_o4(_25,_743)])),_1261]))])),_744]) as unknown as DocumentNode<performVoteRevisionMutation, performVoteRevisionMutationVariables>;
export const performVoteTagDocument = _o1(_1,[_o11(_986,_987,_1907,_1804,_o5(_7,[_o7(_8,_1907,_1806,_o5(_7,[_o6(_8,_1260,_o5(_7,[_o4(_25,_842)])),_1261]))])),_146,_843]) as unknown as DocumentNode<performVoteTagMutation, performVoteTagMutationVariables>;
export const performVoteMultiDocumentDocument = _o1(_1,[_o11(_986,_987,_1908,_1804,_o5(_7,[_o7(_8,_1908,_1806,_o5(_7,[_o6(_8,_1260,_o5(_7,[_o4(_25,_447)])),_1261]))])),_446,_450]) as unknown as DocumentNode<performVoteMultiDocumentMutation, performVoteMultiDocumentMutationVariables>;
export const performVoteMessageDocument = _o1(_1,[_o11(_986,_987,_1909,_1804,_o5(_7,[_o7(_8,_1909,_1806,_o5(_7,[_o6(_8,_1260,_o5(_7,[_o4(_25,_433)])),_1261]))])),_435]) as unknown as DocumentNode<performVoteMessageMutation, performVoteMessageMutationVariables>;
export const emailstestsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"emailstests"),_1543,_1910),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_550,_558]) as unknown as DocumentNode<emailstestsQuery, emailstestsQueryVariables>;
export const updateCommentCommentsNewFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updateCommentCommentsNewForm"),_1171,_1329),_146,_158,_61,_184,_23,_357]) as unknown as DocumentNode<updateCommentCommentsNewFormMutation, updateCommentCommentsNewFormMutationVariables>;
export const updatePostPostsEditFormDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"updatePostPostsEditForm"),_1146,_1755),_23,_127,_61,_136,_146,_158,_184,_192,_198,_655]) as unknown as DocumentNode<updatePostPostsEditFormMutation, updatePostPostsEditFormMutationVariables>;
export const getCurrentUserDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"getCurrentUser"),_o5(_7,[_o6(_8,_o3(_3,"currentUser"),_1197)])),_61,_226,_934]) as unknown as DocumentNode<getCurrentUserQuery, getCurrentUserQueryVariables>;
export const createLWEventwithNewEventsDocument = _o1(_1,[_o11(_986,_987,_o3(_3,"createLWEventwithNewEvents"),[_o12(_988,_1139,_o13(_990,_o4(_5,_o3(_3,"CreateLWEventDataInput"))))],_o5(_7,[_o7(_8,_o3(_3,"createLWEvent"),_1145,_o5(_7,[_o6(_8,_266,_o5(_7,[_o4(_25,_423)]))]))])),_428]) as unknown as DocumentNode<createLWEventwithNewEventsMutation, createLWEventwithNewEventsMutationVariables>;
export const Lightcone2024FundraiserStripeAmountsDocument = _o1(_1,[_o17(_986,_995,_1911,_o5(_7,[_o4(_8,_1911)]))]) as unknown as DocumentNode<Lightcone2024FundraiserStripeAmountsQuery, Lightcone2024FundraiserStripeAmountsQueryVariables>;
export const Lightcone2025FundraiserAirtableAmountsDocument = _o1(_1,[_o17(_986,_995,_1912,_o5(_7,[_o4(_8,_1912)]))]) as unknown as DocumentNode<Lightcone2025FundraiserAirtableAmountsQuery, Lightcone2025FundraiserAirtableAmountsQueryVariables>;
export const multiPostsForAutocompleteQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostsForAutocompleteQuery"),_1913,_o5(_7,[_o7(_8,_250,_1155,_o5(_7,[_o6(_8,_1025,_349)]))])),_61,_347]) as unknown as DocumentNode<multiPostsForAutocompleteQueryQuery, multiPostsForAutocompleteQueryQueryVariables>;
export const multiCommentsForAutocompleteQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentsForAutocompleteQuery"),_1914,_o5(_7,[_o7(_8,_871,_1155,_o5(_7,[_o6(_8,_1025,_353)]))])),_61,_347,_350]) as unknown as DocumentNode<multiCommentsForAutocompleteQueryQuery, multiCommentsForAutocompleteQueryQueryVariables>;
export const multiCommentsForAutocompleteWithParentsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiCommentsForAutocompleteWithParentsQuery"),_1914,_o5(_7,[_o7(_8,_871,_1155,_o5(_7,[_o6(_8,_1025,_o5(_7,[_o4(_25,_351)]))]))])),_61,_347,_350,_354]) as unknown as DocumentNode<multiCommentsForAutocompleteWithParentsQueryQuery, multiCommentsForAutocompleteWithParentsQueryQueryVariables>;
export const EmailComment2Document = _o1(_1,[_o11(_986,_995,_o3(_3,"EmailComment2"),_1180,_1236),_146,_158,_61,_184,_23,_322]) as unknown as DocumentNode<EmailComment2Query, EmailComment2QueryVariables>;
export const EmailComment1Document = _o1(_1,[_o11(_986,_995,_o3(_3,"EmailComment1"),_1180,_1821),_146,_158]) as unknown as DocumentNode<EmailComment1Query, EmailComment1QueryVariables>;
export const EmailCommentDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"EmailComment"),_1180,_1427),_23,_127,_61,_136,_146,_158,_184,_192,_198]) as unknown as DocumentNode<EmailCommentQuery, EmailCommentQueryVariables>;
export const EmailFooterRecommendationsQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"EmailFooterRecommendationsQuery"),_1578,_1579),_23,_127,_61,_136,_146,_158,_184,_192,_198,_203,_207,_230,_226,_239,_492]) as unknown as DocumentNode<EmailFooterRecommendationsQueryQuery, EmailFooterRecommendationsQueryQueryVariables>;
export const EmailUsernameByIDDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"EmailUsernameByID"),_1180,_1364),_61]) as unknown as DocumentNode<EmailUsernameByIDQuery, EmailUsernameByIDQueryVariables>;
export const EventUpdatedEmailDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"EventUpdatedEmail"),_1180,_o5(_7,[_o7(_8,_210,_1007,_o5(_7,[_o6(_8,_1008,_315)]))])),_23,_127]) as unknown as DocumentNode<EventUpdatedEmailQuery, EventUpdatedEmailQueryVariables>;
export const NewDialogueMessagesEmail1Document = _o1(_1,[_o11(_986,_995,_o3(_3,"NewDialogueMessagesEmail1"),_1180,_1364),_61]) as unknown as DocumentNode<NewDialogueMessagesEmail1Query, NewDialogueMessagesEmail1QueryVariables>;
export const NewDialogueMessagesEmailDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"NewDialogueMessagesEmail"),_1543,_1910),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_550,_558]) as unknown as DocumentNode<NewDialogueMessagesEmailQuery, NewDialogueMessagesEmailQueryVariables>;
export const PostNominatedEmailDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostNominatedEmail"),_1543,_1910),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_550,_558]) as unknown as DocumentNode<PostNominatedEmailQuery, PostNominatedEmailQueryVariables>;
export const multiPostPostsEmailQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostPostsEmailQuery"),_1456,_o5(_7,[_o7(_8,_250,_1118,_o5(_7,[_o6(_8,_1025,_o5(_7,[_578,_206])),_796]))])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_550,_558]) as unknown as DocumentNode<multiPostPostsEmailQueryQuery, multiPostPostsEmailQueryQueryVariables>;
export const PostMetadataDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"PostMetadata"),_1431,_o5(_7,[_o7(_8,_210,_1337,_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_14,_12,_104,_109,_501,_o6(_8,_42,_o5(_7,[_10,_43,_330])),_o6(_8,_187,_38),_39,_33,_35,_21,_16,_105,_502,_22,_27,_47]))]))]))]) as unknown as DocumentNode<PostMetadataQuery, PostMetadataQueryVariables>;
export const SequenceMetadataDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"SequenceMetadata"),[_1537],_o5(_7,[_o7(_8,_560,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_9,_561)]))],_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_14,_237,_236,_142,_39]))]))]))]) as unknown as DocumentNode<SequenceMetadataQuery, SequenceMetadataQueryVariables>;
export const CommentPermalinkMetadataDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CommentPermalinkMetadata"),[_1331],_o5(_7,[_o7(_8,_221,_1044,_o5(_7,[_o6(_8,_1008,_o5(_7,[_10,_162,_o6(_8,_30,_o5(_7,[_31])),_o6(_8,_36,_o5(_7,[_175])),_54]))]))]))]) as unknown as DocumentNode<CommentPermalinkMetadataQuery, CommentPermalinkMetadataQueryVariables>;
export const TagMetadataDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"TagMetadata"),[_o12(_988,_1915,_991)],_o5(_7,[_o7(_8,_191,[_o8(_536,_1003,_o14(_1001,[_o8(_1002,_1070,_o14(_1001,[_o8(_1002,_11,_1915)]))]))],_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_123,_12,_142,_o6(_8,_154,_547)]))]))]))]) as unknown as DocumentNode<TagMetadataQuery, TagMetadataQueryVariables>;
export const UserMetadataDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"UserMetadata"),[_o12(_988,_1067,_991)],_o5(_7,[_o7(_8,_288,[_1074],_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_31,_49,_12,_50,_56,_57,_51,_142]))]))]))]) as unknown as DocumentNode<UserMetadataQuery, UserMetadataQueryVariables>;
export const singleDraftPostForLLMQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"singleDraftPostForLLMQuery"),[_1916,_1230],_o5(_7,[_o7(_8,_210,_1155,_1232)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_270,_595,_599]) as unknown as DocumentNode<singleDraftPostForLLMQueryQuery, singleDraftPostForLLMQueryQueryVariables>;
export const singlePublishedPostForLLMQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"singlePublishedPostForLLMQuery"),_1917,_o5(_7,[_o7(_8,_210,_1155,_1182)])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_586]) as unknown as DocumentNode<singlePublishedPostForLLMQueryQuery, singlePublishedPostForLLMQueryQueryVariables>;
export const multiPostsForLLMQueryDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"multiPostsForLLMQuery"),_1913,_o5(_7,[_o7(_8,_250,_1155,_o5(_7,[_o6(_8,_1025,_1181)]))])),_23,_127,_61,_136,_146,_158,_184,_192,_499,_198,_203,_207,_506,_226,_586]) as unknown as DocumentNode<multiPostsForLLMQueryQuery, multiPostsForLLMQueryQueryVariables>;
export const GetReviewWinnersDocument = _o1(_1,[_o17(_986,_995,_o3(_3,"GetReviewWinners"),_1666),_23,_471,_474,_484,_488]) as unknown as DocumentNode<GetReviewWinnersQuery, GetReviewWinnersQueryVariables>;
export const postWithMarkdownForCoverImageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"postWithMarkdownForCoverImage"),_1917,_o5(_7,[_o7(_8,_210,_1155,_o5(_7,[_o6(_8,_1008,_1918)]))]))]) as unknown as DocumentNode<postWithMarkdownForCoverImageQuery, postWithMarkdownForCoverImageQueryVariables>;
export const postsWithMarkdownForCoverImageDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"postsWithMarkdownForCoverImage"),_1913,_o5(_7,[_o7(_8,_250,_1155,_o5(_7,[_o6(_8,_1025,_1918)]))]))]) as unknown as DocumentNode<postsWithMarkdownForCoverImageQuery, postsWithMarkdownForCoverImageQueryVariables>;
export const CommentsForEmbeddingsDocument = _o1(_1,[_o11(_986,_995,_o3(_3,"CommentsForEmbeddings"),[_1122],_o5(_7,[_o7(_8,_871,_1340,_o5(_7,[_o6(_8,_1025,_o5(_7,[_10,_28,_1338,_o6(_8,_30,_o5(_7,[_10,_31,_49,_886])),_o6(_8,_210,_228)]))]))]))]) as unknown as DocumentNode<CommentsForEmbeddingsQuery, CommentsForEmbeddingsQueryVariables>;